// Companies data extracted from App.jsx
function importAllImages(r) { return r.keys().map(r); }

const Companies = [
    {
      name: "BHO Chimney Sweep",
      nameUrl: "BHO-Chimney-Sweep",
      imgLogo: require(`../Images/bhochimneysweep.png`),
      favicon: require(`../Images/BHO_Chimney_Sweep_Favicon.png`),
      images: importAllImages(require.context('../Images', false, /\.(png|jpe?g|svg|webp)$/)).filter(img => img.includes('bho-') || img.includes('bhochimneysweep')),
      rating: 5,
      verified: true,
      services: ["Chimney Sweep", "Chimney Repair", "Chimney Inspection"],
      specialties: ["Chimney Cleaning", "Chimney Repair", "Fireplace Cleaning"],
      aboutus: "BHO Chimney Sweep is a family-owned business with over 50 years of experience in providing professional chimney services. We are dedicated to ensuring the safety and efficiency of your home’s chimney system.",
      // Websites and Phones
      website: "https://www.bhochimneysweep.com/local/",
      website_Chimney: "https://www.bhochimneysweep.com/local/chimney/",
      website_AirDuct: "https://www.bhochimneysweep.com/local/airduct/",
      website_Dryer: "https://www.bhochimneysweep.com/local/airduct/",
      websiteBook: "https://www.bhochimneysweep.com/book/",
      phone: "866-501-1614",
      phoneHandyBy: "866-784-0890",
      email: "info@bhochimneysweep.com",
      highlights: [
        "50 years of experience",
        "Family-owned and operated",
        "Certified and insured technicians",
        "Same-day service available",
      ],
      questions: {
        title: "",
        rows: [

          {
            title: "Why choose BHO Chimney Sweep?",
            content: "With 50 years of expertise, we provide professional, reliable chimney services, ensuring safety and efficiency in every home."
          },
          {
            title: "What is BHO stands for?",
            content: "BHO stands for Bob and Henry Oliver, the founders who built the company with a focus on quality chimney services, reflecting decades of trusted service to homes."
          },
          {
            title: "What services do you offer?",
            content: "We offer chimney cleaning, inspection, repairs, maintenance, creosote removal, waterproofing, and more for optimal performance."
          },
          {
            title: "How much is chimney inspection?",
            content: "Our chimney inspection costs $69. It includes a comprehensive check to identify potential issues."
          },
          {
            title: "Can you clean and repair together?",
            content: "Yes, we offer same-day cleaning and repair services during your appointment if needed."
          },
          {
            title: "How do I book an appointment?",
            content: `Call us <a href='tel:866-501-1614'>866-501-1614</a> or fill out the <a href='/boo'}>online form</a> to schedule your visit.`
          },

        ]
      },
      // Reviews
      Chimney_Review: "BHO Chimney Sweep was fantastic. They inspected and cleaned our chimney thoroughly. The technician explained everything clearly and even fixed a minor crack in the crown. Now our fireplace works perfectly, and we feel much safer using it. Highly recommend their professional service!",
      AirDuct_Review: "BHO Chimney Sweep Cleaning did an amazing job. The technician arrived on time, was polite, and explained the whole process. He cleaned our air ducts thoroughly and improved our indoor air quality immediately. We can already feel the difference. Highly professional and trustworthy team!",
      Dryer_Review: "I’m so glad I called BHO for my dryer vent cleaning. The technician was prompt, friendly, and very thorough. He cleared a huge lint buildup and showed me the before-and-after. My dryer works faster now, and I feel safer knowing there’s no fire risk.",
      reviews: [
        {
          "review": "I cannot say enough good things about BHO Chimney Sweep. We hadn't had our chimney looked at in nearly eight years and honestly expected the worst. Yuval showed up right on time, laid down drop cloths everywhere so nothing got dirty, and walked me through the whole inspection with photos on his tablet. There was a fair amount of creosote buildup and a small gap in the flue liner he pointed out, and he explained my options without any pressure to upsell. The cleaning was thorough and the area was spotless when he left. We've already booked an annual visit. Professional, honest, and genuinely kind people.",
          "name": "Marcus D.",
          "date": "2024-11-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked a dryer vent cleaning after noticing our clothes were taking two full cycles to dry. The tech found a massive lint clog about ten feet into the duct and cleared it out completely. He showed me the before-and-after photos — honestly a little scary how much was packed in there. The dryer runs like new now and I feel a lot safer about fire risk. Quick, clean, and reasonably priced.",
          "name": "Priya N.",
          "date": "2025-01-23",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Fast, friendly air duct cleaning. Arrived on time, finished in about an hour, and our house already smells fresher. Would absolutely use BHO again.",
          "name": "Greg H.",
          "date": "2024-09-08",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "We had water leaking into our firebox every time it rained, and three other companies either ignored us or quoted a full rebuild. BHO came out, did a proper inspection, and found the chimney crown had cracked and the cap was rusted through. They took photos from the roof so I could see the damage myself and gave me a written estimate on the spot. The repair took half a day — they resealed the crown, installed a new stainless cap, and waterproofed the masonry. It's been through two heavy storms since without a single drop inside. The crew was respectful, cleaned up after themselves, and the price was fair. Relieved to finally have this fixed by people who know what they're doing.",
          "name": "Eleanor V.",
          "date": "2025-02-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Yuval came out to clean our fireplace and prep it for gas logs. He was knowledgeable, efficient, and clearly takes pride in his work. He answered every question I threw at him and never made me feel rushed. The fireplace looks brand new and I'm finally confident it's safe to use this winter. Scheduling with Maureen in the office was easy too. Great experience start to finish.",
          "name": "Tom R.",
          "date": "2023-12-04",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "My wife has bad allergies and our vents hadn't been cleaned since we bought the house. The BHO team pulled an unbelievable amount of dust, pet hair, and debris out of the system — I watched the whole thing. They were careful with our furniture, wore shoe covers, and sealed each vent as they went so nothing blew around the house. Within a day my wife noticed she wasn't sneezing every morning, and the air just feels cleaner. The technician also spotted a loose connection near the furnace and tightened it at no charge. Honest, thorough, and genuinely helpful.",
          "name": "Sandra L.",
          "date": "2024-10-29",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Same-day dryer vent cleaning, no fuss. The technician was polite and quick. Lint buildup gone, dryer's faster, and I have peace of mind.",
          "name": "Jamal W.",
          "date": "2025-03-11",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Solid work overall. The inspection was detailed and the technician clearly knew chimneys inside and out — he found a cracked damper I had no idea about. The only reason for four stars is that the appointment window was wide and they showed up toward the very end of it, so I lost most of my morning waiting. Once they arrived, though, the work was excellent and the price was fair. A quick courtesy call when running late would've made it five stars.",
          "name": "Becky F.",
          "date": "2024-08-19",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Professional from the first phone call. The office staff was warm and got me scheduled within a few days. The technician was tidy, friendly, and explained what he was doing as he went. He cleaned our chimney and gave honest advice on maintenance with zero upselling. Refreshing to deal with people you can actually trust.",
          "name": "Antonio C.",
          "date": "2025-04-02",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We were selling our home and needed a chimney inspection for the buyers on short notice. I called BHO on a Monday and they had someone out by Wednesday. The technician was thorough, documented everything with photos, and provided a clean written report the same day that satisfied our inspector with no issues. He even took a few minutes to show the new owners how to care for the fireplace. That kind of above-and-beyond service is rare, and it made an already hectic time so much easier. If you need a chimney company that's responsive, detailed, and honest, this is the one.",
          "name": "Diane M.",
          "date": "2025-05-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our wood stove was burning through logs way faster than it should, and Yuval figured out why in about ten minutes. Heavy creosote glaze had built up inside the insert and the flue liner was partially blocked. He cleaned everything thoroughly, showed me before and after photos on his phone, and gave me practical tips on burning seasoned hardwood only. The stove draws like a dream now and the house actually gets warm. Fifty years in business shows in the workmanship.",
          "name": "Marcus T.",
          "date": "2025-11-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Admittedly I was a skeptic after a previous outfit charged me $400 and barely touched the creosote buildup. Joey showed up, laid down drop cloths everywhere, and actually scraped the flue clean while I watched. He even handed me before and after photos. Completely changed my opinion on chimney companies.",
          "name": "Marcus T.",
          "date": "2025-01-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "At 78, I worry about getting taken advantage of, but Patrick never once made me feel rushed or talked down to. He walked me through every step of the chimney sweep, showed me the creosote buildup on a little camera before and after, and explained why the flue liner was still in good shape. Such a polite young man. Laid drop cloths over my good carpet and cleaned up so well you'd never know he was here.",
          "name": "Eleanor M.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "After that wild June storm tore through, I was nervous about my chimney crown cracking. Andre came out, climbed up, and gave the crown, cap, and flashing a thorough once-over. Turned out the flashing had lifted on one corner. He resealed it and showed me before/after photos so I knew exactly what was done. Honest, careful work.",
          "name": "Marcus T.",
          "date": "2024-07-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After reading too many news stories about dryer fires I finally booked a cleaning, and I'm so glad I did. The amount of lint they pulled out of our vent run was honestly alarming, a whole bag of it from a duct that snakes across the basement ceiling. Marco showed me before and after photos and explained how a clogged vent was making my dryer run twice as long. Clothes dry in one cycle now and I sleep a lot better.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Maureen in the office made the whole thing painless. She found me a slot two days out, texted a reminder the night before, and called when the tech was 20 minutes away. Diego swept the flue, scraped the creosote, and left the hearth spotless. Wonderful communication start to finish.",
          "name": "Marisol T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Hector swept our flue and cleared a thick creosote buildup in under an hour. Tidy, fast, and the drop cloths kept everything spotless. Couldn't ask for more.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We closed on our brand-new build in July and the ducts had that fresh-construction dust everywhere. The tech pulled out drywall grit, sawdust, and a few stray screws from the return vents. Showed me before and after photos of every run. Place smells clean now and the registers actually push more air. Worth doing right after move-in.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Finished a full kitchen remodel and the whole house had a fine layer of drywall dust that kept resettling no matter how much we wiped. Sergei came out, ran his brushes through every duct run, and pulled out an unbelievable amount of sanding dust and sawdust scraps. He showed us before and after photos of the supply trunk and it was night and day. Air smells clean again and the dusting has finally stopped.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "What sold me was the price they quoted on the phone was the exact price I paid at the end. No mystery fees, no sudden add-ons. Mikhail swept the flue, showed me the creosote buildup before and after, and told me straight up the liner had years left. Refreshing to deal with a company that doesn't try to scare you into repairs.",
          "name": "Gregory M.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Closed on our first house in March and the previous owners had three dogs, so the whole place smelled like a kennel through the vents. BHO sent Carlos out and he cleaned every single duct run plus the return vents. He showed us the before/after photos and there was so much dander and hair packed in there. The air feels completely different now, no more musty pet smell when the AC kicks on.",
          "name": "Marcus T.",
          "date": "2026-03-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our dryer was taking three full cycles to get a load of towels dry, and the back of the unit got alarmingly hot. Raj found the duct run packed solid with lint where it bends behind the wall. After the cleaning, everything dries in one cycle now. He showed me the before/after photos and they were genuinely shocking.",
          "name": "Daniela R.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We closed on our first house in October and the previous owners left a wood stove but zero instructions. Devin walked me through how the damper works, how to tell when creosote is building up, and what a clean burn actually looks like. He swept the flue and left a written report with photos. As brand new homeowners we felt totally taken care of.",
          "name": "Marcus T.",
          "date": "2024-11-12",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Honestly went in expecting some bait-and-switch on the $69 inspection but that was the actual price, no upsell pressure. Tech showed me a few photos of light creosote buildup and said it could wait another season. Refreshing to deal with people who don't invent problems.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Going on year six with BHO and they have never let me down. Tyler cleaned out a heavy creosote buildup this fall and walked me through the flue liner condition with photos before he left. Same honest crew every time, shoe covers on, drop cloths down. There is real comfort in not having to vet a new company every season.",
          "name": "Marcus T.",
          "date": "2024-11-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We hadn't used our fireplace in close to four years and were nervous about lighting it again, so I scheduled an inspection through Maureen who walked me through the whole process on the phone. Omar arrived right on time, laid down drop cloths across the entire hearth and put on shoe covers before stepping inside. He found a heavy creosote buildup in the flue and a hairline crack in the chimney crown, then showed me everything on his camera so I wasn't just taking his word for it. After the sweep he sealed the crown and installed a new stainless cap to keep critters out. The written report he emailed that evening listed every finding with before and after photos. Honest, thorough, and never once tried to upsell me on work I didn't need.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Been getting our chimney swept by these folks every fall for almost a decade now, and they never disappoint. Nikolai showed up right on time, laid down drop cloths before he even touched the firebox, and had the creosote buildup cleared out in under an hour. Left the hearth cleaner than he found it. Same dependable service year after year.",
          "name": "Gregory T.",
          "date": "2025-10-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My next-door neighbor raved about these folks after they relined her chimney, so I figured I'd give them a shot. Eli showed up right on time, laid down drop cloths before he touched anything, and swept years of creosote out of our flue. House smells like a fireplace again instead of a campfire. Couldn't be happier.",
          "name": "Daniel R.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Switched our wood-burning firebox over to gas logs this spring and BHO handled the prep beautifully. Victor swept out years of creosote, scrubbed the smoke shelf, and confirmed the flue liner was sound before the gas guys ever showed up. Sent me a written report with before/after photos the same afternoon. Could not have asked for a smoother start to the conversion.",
          "name": "Marcus D.",
          "date": "2026-03-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our dryer was taking three cycles to dry a load of towels, so we finally booked a vent cleaning. Ramon pulled out an absolutely shocking amount of packed lint from the duct run and then swapped out the old flimsy plastic flap on the outside for a new metal vent hood with a built-in pest guard. Birds had actually been nesting in the old one. Drying time is back to a single cycle now, and he showed me before/after photos of the whole run.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Got our fireplace ready just in time for the holidays. Luis swept the flue, cleared a thick band of creosote, and laid down drop cloths so not a speck of soot touched our carpet. House finally feels cozy again with stockings hung and a real fire going.",
          "name": "Marisol P.",
          "date": "2024-12-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Kevin showed up right on time and got straight to work on our flue. He spotted a cracked liner I never would have noticed, walked me through it with before and after photos, and laid down drop cloths before touching anything. No mess left behind. Genuinely knowledgeable guy who clearly takes pride in the craft.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We kept hearing scratching above the firebox and sure enough a family of squirrels had moved into our flue. Jordan came out, safely cleared them, vacuumed all the debris off the smoke shelf, and installed a new stainless cap with a screen so nothing can get back in. Clean, professional, and he even showed me before and after photos. Couldn't ask for better.",
          "name": "Marcus T.",
          "date": "2025-03-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Called at 8am with a chimney emergency before a cold snap and they had Dmitri at my door by 11. No three-day wait, no runaround. He swept the flue, knocked out a heavy creosote buildup, and was packed up before noon. That kind of speed is rare.",
          "name": "Marcus T.",
          "date": "2025-01-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "As a property manager overseeing 22 units across three buildings, scheduling lint removal used to be a nightmare until I found BHO. They coordinated with Maureen to hit every laundry room in one afternoon, cleared lint traps and the full duct runs on each machine, and left a written report per unit for my files. Tenants barely noticed they were there. This is now an annual line item on my maintenance calendar.",
          "name": "Marcus T.",
          "date": "2025-09-12",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our laundry room is on the second floor and the duct snakes up through an interior wall before exiting at the roofline, so most companies wanted nothing to do with it. Felix showed up with a rotary brush kit long enough to reach the full run and pulled out an embarrassing amount of compacted lint near the roof termination. He even climbed up to clear the vent hood cap, which a bird had partially nested in. Dryer cycle time dropped from almost two hours to about forty minutes. Genuinely impressed.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our 1920s brick colonial had a chimney that was visibly crumbling above the roofline. Sam climbed up, took before photos, and walked me through exactly which courses of brick had spalled and needed replacing. He rebuilt the top three courses, repointed the rest, and the mortar color match is so close you'd never know. Clean work, no debris left behind, and they put drop cloths everywhere inside near the firebox.",
          "name": "Eleanor M.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Scheduled both the air ducts and the dryer vent in a single visit and it saved us so much hassle. Yuval walked through every return vent before he started, laid down drop cloths, and showed me the before/after photos when he finished. The amount of dust pulled out of the main duct run was honestly shocking. House air feels noticeably cleaner now.",
          "name": "Marisol G.",
          "date": "2025-03-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "After two rainy seasons of brown stains creeping down our living room wall, BHO finally got to the root of it. Joey showed me photos of a hairline-cracked crown and a chimney cap that had rusted clean through at the base. They rebuilt the crown, dropped in a new stainless cap, and sealed the brick with a breathable waterproofing membrane. Three storms since and the wall is bone dry. Couldn't be happier with how thorough they were.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What stood out most was how careful Patrick was with our white living room rug. Shoe covers went on before he even stepped inside, and he laid down drop cloths from the front door all the way to the fireplace. After the sweep there wasn't a speck of creosote anywhere. You'd never know someone had been working in here.",
          "name": "Marisol T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We were under contract on a 1920s colonial and our agent insisted on a chimney inspection before closing. Andre showed up on time, ran a camera up the flue, and walked me through every photo of the cracked liner. The written report he emailed that afternoon was detailed enough that we negotiated a credit with the sellers. Couldn't have asked for a smoother experience during a stressful escrow.",
          "name": "Marcus T.",
          "date": "2025-03-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After my son's asthma flared up every winter, our allergist suggested checking the ductwork. BHO ran a camera through every return vent and showed me the dust mat lining the supply runs. They cleaned the whole system, sealed the registers while working, and laid drop cloths in each room. Two weeks later his nighttime coughing is noticeably down. The written report even logged before/after particulate readings.",
          "name": "Priya R.",
          "date": "2025-11-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "We kept getting a smoky smell drifting into the living room every time the wind picked up. Marco came out, ran a smoke test, and figured out our damper wasn't seating properly and the cap was missing. He swapped in a stainless cap and adjusted the damper the same visit. No more odor, and the draft is night and day better.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We kept smelling something stale every time the AC kicked on. Diego pulled the return vents, showed us a layer of dust and what looked like the start of mildew, then ran a full negative-air cleaning and fogged the system with a sanitizer. The musty smell was gone by that evening. Honest work, fair price.",
          "name": "Marisol T.",
          "date": "2025-08-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "My youngest has asthma and the dust in our place was making things worse every winter. The crew showed up in shoe covers, sealed off each room, and ran the camera through the supply trunk before and after. Showed me clumps of pet hair and gray dust they pulled from the return vents. Air feels noticeably cleaner and the kids aren't waking up congested.",
          "name": "Priya R.",
          "date": "2025-11-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Scheduled a cleaning for our fireplace insert and Hector arrived right on time with shoe covers and drop cloths ready. He pulled the insert, swept the connector pipe, and checked the stainless liner for gaps. Walked me through how to read the difference between fluffy soot and dangerous glazed creosote. Very educational visit.",
          "name": "Priya N.",
          "date": "2024-10-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Two other companies told me my chimney crown was fine, then BHO came out and showed me the cracks with their camera. No pressure, just facts and a written report. They sealed it properly and waterproofed the whole thing. Wish I'd called them first.",
          "name": "Priya N.",
          "date": "2024-11-03",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "My husband passed two years ago and he always handled the fireplace, so I was nervous calling anyone. Sergei was so kind and patient with all my questions. He took time to explain the damper and showed me how to open and close it myself. Honest folks.",
          "name": "Dorothy K.",
          "date": "2024-10-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We lost a couple shingles in a hailstorm and wanted to be sure the chimney didn't take damage too. Mikhail inspected the crown and stainless cap, found a hairline crack in the crown wash, and sealed it that same visit. Clear written report afterward. Reassuring to deal with people who don't try to sell you the moon.",
          "name": "Priya N.",
          "date": "2025-03-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Peace of mind is exactly what I got. Our dryer had been overheating and shutting off mid-cycle, which I learned is a classic warning sign of a blocked vent. Carlos snaked the entire duct run, cleared a thick mat of lint near the exterior vent hood, and checked the flap was opening freely again. Clean, fast, and he wore shoe covers the whole time.",
          "name": "Priya K.",
          "date": "2026-03-22",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Scheduling could not have been smoother. Maureen answered on the first ring, walked me through the $69 inspection, and emailed a confirmation with the arrival window all spelled out. Raj showed up right at the start of it, inspected the flue liner and damper, and sent a written report with before/after photos that same afternoon. Genuinely impressed with how organized this office runs.",
          "name": "Devon R.",
          "date": "2026-02-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quick and painless inspection for $69. Devin showed me before and after photos of the smoke shelf. Honest, no upsell. Will use again next season.",
          "name": "Priya R.",
          "date": "2024-09-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "First time servicing the dryer vent in our new construction. Builder left a long duct run to the exterior wall and it already had a kink. Tyler straightened it, cleaned the lint trap housing, and confirmed good airflow at the vent hood outside. Dryer cycle is noticeably faster now.",
          "name": "Priya N.",
          "date": "2024-11-02",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "After our basement build-out we couldn't get rid of the chalky drywall film on furniture. The crew laid drop cloths everywhere, cleaned all the return vents and supplies, and bagged up a shocking pile of construction debris. Coughing at night has stopped completely. Maureen scheduled us within the same week.",
          "name": "Priya R.",
          "date": "2026-03-02",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Honest folks. The $69 inspection was worth every penny and there was zero pressure to buy anything extra. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Tamara K.",
          "date": "2024-09-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We bought a home where the prior owner was clearly a heavy smoker. You could smell stale cigarettes every time the furnace ran. Omar came out, pulled the return vents, and showed me the yellow film coated inside the duct work. After a full cleaning the smoke smell is basically gone. Took about three hours and they laid drop cloths everywhere.",
          "name": "Priya N.",
          "date": "2026-04-02",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Clothes used to come out damp after a full cycle and I kept blaming the machine. Turns out the vent hood outside was almost completely blocked. Nikolai cleared the whole run and the lint trap area, and now a single cycle does the job. Quick, clean, professional.",
          "name": "Marcus T.",
          "date": "2024-11-22",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "First fireplace we've ever owned and I had no clue where to start. Eli was patient, showed me the smoke shelf and explained why an annual sweep matters before we light our first fire. Honest and not pushy at all.",
          "name": "Priya N.",
          "date": "2025-01-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Sixty-nine bucks for a full chimney inspection? Figured there was a catch. There wasn't. Victor was on time, laid down a drop cloth, and gave me a written report. Money well spent.",
          "name": "Renata K.",
          "date": "2024-09-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We've had BHO out four years running for the annual sweep and inspection. This year Ramon replaced our cracked chimney crown and the work has held beautifully through a wet spring. Maureen always squeezes us in before the holidays, and the written report she emails afterward is thorough and easy to understand.",
          "name": "Priya K.",
          "date": "2025-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After buying an older home with a wood stove, I had no idea what condition the chimney was in, so I called BHO based on a neighbor's recommendation. Luis came out and spent nearly two hours doing a full inspection, checking the flue liner, the damper, and the smoke shelf with a camera. He discovered the previous owners had never had it cleaned and there was a glazed creosote layer that needed special attention. He explained the difference between the cleaning levels and why mine required more work, then quoted a fair price before doing anything. The sweep was meticulous, no soot anywhere in the living room, and he double checked the cap on his way out. A family business that clearly takes pride in doing things the right way.",
          "name": "Priya R.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Annual sweep done and dusted. Kevin was thorough with the creosote removal and showed me before/after photos of the flue. Quick, tidy, no upsell. We'll keep calling them every season.",
          "name": "Renata M.",
          "date": "2024-11-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Found out about BHO at a block party when three different people on my street said they'd used them. Jordan came out, ran the camera up the flue liner, and showed me a crack I never would have known about. No pressure to fix it that day. Honest crew.",
          "name": "Priya M.",
          "date": "2025-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Needed a level-2 inspection before installing a gas insert and Dmitri was thorough to a fault, in the best way. He ran the camera up the full flue, checked the damper and crown, and flagged a hairline gap that needed sealing before the insert went in. Clear explanation, no upsell.",
          "name": "Priya R.",
          "date": "2025-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Felix cleaned out years of lint buildup and installed a louvered exterior hood with a rodent screen. He laid drop cloths the whole way and left zero mess. Clothes dry faster already.",
          "name": "Priya N.",
          "date": "2026-03-02",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We wanted a warm hearth for Christmas morning and BHO delivered. The technician inspected the damper, replaced a rusted stainless cap, and showed me before/after photos of the smoke shelf. First fire of the season was clean and drew beautifully. Whole family gathered around it on the 25th.",
          "name": "Declan R.",
          "date": "2025-12-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Sam was fantastic. Removed a heavy buildup of creosote that two other companies told me wasn't worth dealing with. He explained exactly why our chimney was drawing poorly, replaced the stainless cap, and even swept up the hearth afterward. Courteous, patient with all my questions, and clearly an expert.",
          "name": "Priya N.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Birds had built a massive nest in our chimney and twigs were falling down into the fireplace. Yuval pulled out an unbelievable amount of nesting material, swept the flue clean, and capped it with a stainless steel cap and screen. Quick, tidy, no mess left behind.",
          "name": "Priya N.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Same-day service that actually meant same day. Phoned in the morning, technician arrived that afternoon within the window Maureen quoted me. Quick inspection, swept the firebox and smoke shelf, handed me a written report on the way out. Couldn't ask for a smoother turnaround.",
          "name": "Priya R.",
          "date": "2024-11-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Manage a fourplex and the dryers were taking two cycles to dry anything. Joey came out, ran the brush through every vent run to the roof, and showed me the clogged lint he pulled from each. Tenants are thrilled and my fire-risk worry is gone. Booked them again for next year already.",
          "name": "Priya R.",
          "date": "2024-11-03",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Long run from a tight crawlspace to the side of the house. Patrick crawled the whole length, found a crushed section of flex duct, and replaced it with rigid metal. Lint trap area was spotless when he left. Drop cloths down the whole time too.",
          "name": "Priya N.",
          "date": "2026-03-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Tuckpointing on a 90-year-old chimney done right. The old mortar was sandy and falling out by hand. Andre raked it back to a proper depth and tooled the new joints to match the original. Looks period-correct.",
          "name": "Desmond R.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Knocked out our dryer vent and air ducts on the same morning. Marco found a bird's nest packed into the vent hood outside that we never knew was there. Dryer runs in one cycle now instead of three.",
          "name": "Devon R.",
          "date": "2024-11-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Water had been seeping in around our flashing for years. Diego traced it to a crumbling crown and a missing cap that previous owners never replaced. He patched the crown, installed a stainless cap, and applied a clear masonry sealant. Detailed written report with before/after photos. Dry ever since.",
          "name": "Priya R.",
          "date": "2026-03-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Hector vacuumed the smoke shelf and brushed the flue, then wiped down the hearth tiles until they shone. He moved the side table away from the firebox himself so nothing got bumped. Spotless cleanup, friendly the whole time.",
          "name": "Derek P.",
          "date": "2024-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Needed a pre-purchase inspection on short notice and Maureen got me on the schedule within two days. The $69 inspection felt like a steal given the thoroughness. Sergei documented a deteriorating chimney crown with before photos and a clear written summary. Used it as leverage to ask for repairs.",
          "name": "Priya N.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Measurable difference is the only way I can describe it. My air-quality monitor sat around 45 PM2.5 before; after Mikhail cleaned all the duct runs it reads under 12. He explained the negative-air machine and showed me the collection bag. Worth every penny for a household with two kids and a dog.",
          "name": "Marcus T.",
          "date": "2026-02-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Persistent downdrafts had us frustrated all winter. The tech explained the flue was undersized relative to the firebox and recommended a top-mount damper. Honest assessment, written report with photos, and the fix actually worked. House finally smells clean.",
          "name": "Priya R.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Musty basement odor turned out to be coming from the supply ducts. Crew tagged each register, ran the brush through every duct run, and sprayed an antimicrobial fog before sealing back up. House smells neutral now instead of like a damp closet.",
          "name": "Devon R.",
          "date": "2024-11-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Constant sneezing in the mornings finally pushed me to book an air duct cleaning. Carlos explained the whole process, vacuumed every supply and return run, and showed me before/after photos of the trunk line. The amount of dust they removed was honestly gross but explains a lot. House smells fresher already.",
          "name": "Marcus T.",
          "date": "2026-03-09",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Raj came out to service our old cast-iron wood stove that we hadn't touched in two seasons. There was a serious creosote layer in the chimney and he removed it all without making a single mess in the living room. What impressed me most was the efficiency advice afterward, he explained how loading the stove front to back and keeping the air control open longer at startup would cut creosote buildup dramatically. We followed it this winter and the glass stays clean now. Genuinely knowledgeable crew.",
          "name": "Eleanor V.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Honestly didn't expect much, since the last sweep we hired left soot all over our hearth and tracked it through the living room. Devin wore shoe covers, used drop cloths, and you'd never know anyone had been here except the fireplace was spotless. Glazed creosote gone, damper working again. Color me impressed.",
          "name": "Eleanor V.",
          "date": "2025-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Being in my eighties I appreciate people who slow down and explain things properly. The technician inspected the chimney crown and stainless cap, then sat at my kitchen table going over the written report line by line so I understood every charge. No pressure, no upselling. Wore shoe covers without me even asking. This is how service used to be.",
          "name": "Harold P.",
          "date": "2025-02-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Storm knocked our chimney cap clean off. Maureen got me scheduled fast and Tyler installed a new stainless cap, checked the flashing for leaks, and made sure the crown was solid. No more rain coming down the flue. Very pleased.",
          "name": "Devon R.",
          "date": "2025-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wish I'd done this years ago. The lint trap only catches part of the lint, and the rest had been packing into our vent for who knows how long. They pulled out enough to fill a grocery bag. Fire risk gone, and the dryer is noticeably more efficient.",
          "name": "Devon R.",
          "date": "2024-08-05",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "What stood out was the communication. Maureen confirmed twice, once by text and once by email, and even followed up after to make sure I was happy. The inspection covered the chimney crown and stainless cap, and Omar explained everything in plain English. So easy to deal with.",
          "name": "Aileen P.",
          "date": "2024-09-23",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Stainless cap installed same day after they spotted ours was rusted through. Nikolai explained everything plainly. Professional and friendly the whole time.",
          "name": "Devon K.",
          "date": "2025-03-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our home was finished in February. Even though it was new, the supply and return ducts were full of construction debris, insulation bits, and that gypsum powder you get from sanding. Eli walked the whole system, vacuumed every run, and left a written report. Drop cloths down the whole time, shoe covers on. Couldn't ask for more from a first service.",
          "name": "Devon R.",
          "date": "2026-03-21",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Contractor left, dust stayed. Victor and his partner spent close to four hours pulling sawdust and drywall grit out of every duct run in our two-story. Wore shoe covers, protected the floors, and walked me through a written report at the end. Worth every penny after a messy renovation.",
          "name": "Devin K.",
          "date": "2024-11-21",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "After two other companies tried to upsell me a full liner replacement, BHO came out, ran the camera, and said the flue was perfectly fine. Just needed a sweep and a new stainless cap. They could have easily lied and charged me thousands. Ramon was upfront about everything and the final bill matched the estimate to the dollar.",
          "name": "Devon P.",
          "date": "2026-02-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Such a relief. Moved into a place last fall, two cats lived here before us and the dust was insane. The crew vacuumed out every duct run and replaced the filter, plus wore shoe covers the whole time so they didn't track anything on our new floors. Allergies have settled down a lot.",
          "name": "Devon R.",
          "date": "2025-11-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Noticed the dryer overheating and shutting off mid-cycle, which scared me given all the fire warnings you hear. Luis came out, pulled an unbelievable amount of lint from the duct, and explained how the buildup was restricting airflow. He laid drop cloths in the laundry room and wore shoe covers the whole time. Drying time is back to normal and the overheating stopped completely.",
          "name": "Priya N.",
          "date": "2026-03-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Bought a 1920s home with an original brick chimney and was nervous about using the fireplace. The tech inspected the flue liner, found some minor cracks, and explained our options without scaring us into anything. Booked the inspection through Maureen and the whole thing was simple. Glad we called before our first winter.",
          "name": "Eleanor W.",
          "date": "2024-09-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "As a retiree on a fixed income I'm careful with every dollar, so the $69 inspection special is what got me in the door. What kept my business was the honesty. The technician checked the flue liner and damper, told me the stainless cap was still solid, and didn't try to sell me a thing I didn't need. He even pointed out a small gap near the crown and said it was cosmetic, not urgent. You don't find that kind of straight talk much anymore. Five stars and I'll be calling them yearly.",
          "name": "Devon A.",
          "date": "2026-02-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Loyal customer since 2019. Kevin handled our creosote removal and damper adjustment this time around. He remembered our drafty firebox from last visit and tweaked it without me even asking. That kind of memory is why I keep calling the same family business.",
          "name": "Eleanor R.",
          "date": "2023-09-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our chimney had a persistent smell every time it rained and we couldn't figure out why. The technician who came, Jordan, diagnosed it almost immediately as creosote absorbing moisture combined with a missing chimney cap that was letting water pour straight down the flue. He performed a thorough sweep, removed the creosote, and recommended waterproofing the masonry to stop the brick from soaking up rain. I appreciated that he photographed the crown and the deteriorating mortar joints so I could see exactly what he was talking about. The written report arrived the next morning with a clear breakdown of recommended versus urgent work. Scheduling the follow up for the cap and waterproofing was easy through the office. Everything was handled professionally and the smell is completely gone now.",
          "name": "Devon K.",
          "date": "2026-03-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We've used BHO for our yearly chimney cleaning since we bought the house in 2016. This year there was a thick glaze of creosote near the top of the flue and the tech took his time scraping it all down. Shoe covers on, drop cloths spread, and a clear explanation of what he found. Reliable family business that treats your home with respect.",
          "name": "Desmond K.",
          "date": "2025-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "A coworker who lives two towns over swears by this company, and now I see why. The technician walked me through the whole inspection, pointed out some loose mortar on the chimney crown, and emailed a written report with photos that same afternoon. Professional from the first phone call with Maureen to the cleanup.",
          "name": "Marcus T.",
          "date": "2024-09-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Family-owned outfit that clearly knows their craft. Dmitri came out, laid drop cloths everywhere, cleaned decades of soot from the firebox and removed glazed creosote so the gas-log set would sit clean. Walked me through the whole level-2 report afterward. Professional and tidy.",
          "name": "Eleanor V.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We'd had a squirrel get into the dryer exhaust last winter, which is what prompted this call. The tech cleaned the entire vent line and capped the exterior with a sturdy pest guard hood that swings open with airflow but stays shut otherwise. He explained that the old cap had no flap at all, basically an open invitation for critters. Quick, professional, and the new hood looks much cleaner against the siding.",
          "name": "Devon R.",
          "date": "2024-11-20",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Cozy is the only word for our living room now. Felix removed years of creosote buildup and explained how the flue liner had a small gap that he sealed. Maureen scheduled us right before Thanksgiving so we could host without worrying about smoke. Wonderful service top to bottom.",
          "name": "Tamara W.",
          "date": "2023-11-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Sam went above and beyond during our inspection. He climbed up, photographed the chimney crown, and showed me a hairline crack on a tablet before recommending the least expensive fix. No pressure, no upsell. Hard to find that kind of honesty these days.",
          "name": "Eleanor B.",
          "date": "2026-02-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a noisy spring with chirping coming down the chimney, we finally called BHO. The tech found an abandoned bird nest packed in the flue, removed it completely, and fitted a new stainless cap with a screen mesh. He laid drop cloths everywhere and wore shoe covers so our floors stayed spotless. Honest pricing and a written report explaining everything. Family-owned and it really shows in how they treat your home.",
          "name": "Devon R.",
          "date": "2025-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Punctual to the minute. They gave me a two-hour window and Yuval rolled up right at the start of it. Laid down drop cloths, checked the damper and flue liner, cleaned everything, and was respectful of my time throughout. Will use again.",
          "name": "Devon K.",
          "date": "2025-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Owning a small apartment block means dryer fires keep me up at night. BHO sent a crew that cleared all eight vent hoods, vacuumed the duct runs, and even fixed a crushed transition hose I didn't know about. Drop cloths down in every unit, shoe covers on, and a tidy invoice broken out per address. Professional from the first call to the last.",
          "name": "Devon W.",
          "date": "2026-02-18",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We have one of those second-floor stacked laundry closets where the vent travels something like 25 feet before reaching the exterior wall. Joey measured airflow before and after with a meter and showed me the numbers, which jumped noticeably once he cleared the backed-up lint. He explained why long runs like ours need cleaning more often. Wore shoe covers without me asking. Easy to recommend to neighbors with the same setup.",
          "name": "Devon R.",
          "date": "2024-09-22",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We bought a historic farmhouse and the inspector flagged the chimney. BHO came out, did the $69 inspection first, then gave us an honest assessment. Only the upper section needed a partial rebuild, not the whole stack like another company wanted to charge for. Saved us thousands. Patrick was professional and explained the spalling brick issue in plain language.",
          "name": "Priya K.",
          "date": "2025-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wonderful experience from the first phone call with Maureen all the way through. We bundled the air-duct cleaning with the dryer-vent service because we'd just bought the place and had no idea when either was last done. The technician brought a camera so I could actually see the gunk inside the duct run, then again afterward so I could see it gone. Wore shoe covers the whole time too, which my wife appreciated.",
          "name": "Priya S.",
          "date": "2025-09-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Honestly thought I'd need the whole chimney rebuilt, but the crew was straight with me. The real culprit was a cracked crown letting water pool into the brick joints. They ground out and repointed the worst mortar, recapped the crown, fitted a new rust-proof cap, and waterproofed the exterior. Drop cloths everywhere, shoe covers on, and they hauled away every scrap of debris. Half the price I'd braced for.",
          "name": "Donovan K.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "My biggest worry was soot getting on the cream sofa right next to the fireplace. The technician draped it with a sheet before doing anything else, then ran a HEPA vacuum after removing the creosote buildup. Floors looked cleaner when he left than when he arrived. Maureen had warned me they were tidy and she was right.",
          "name": "Annika V.",
          "date": "2026-02-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Selling our house and the buyer's lender wanted documentation on the fireplace and flue. Andre came out, put down drop cloths, inspected the smoke shelf and damper, and gave us a written report we could hand directly to the title company. Professional from start to finish.",
          "name": "Eleanor V.",
          "date": "2025-08-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We moved into a 1970s house and the musty smell from the vents drove me crazy. The crew pulled out genuinely alarming amounts of debris from the return vents and treated the system. Smell gone, and my chronic morning congestion eased within days. Maureen in the office was patient about rescheduling around my work calls. Professional from start to finish.",
          "name": "Daniela K.",
          "date": "2025-08-21",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Smoke would roll back into the room when we lit a fire. Marco diagnosed a heavy creosote buildup choking the flue plus a warped throat damper. He cleaned the whole system, freed up the damper, and showed me before/after photos. Draft is strong now and the burnt smell is gone.",
          "name": "Eleanor W.",
          "date": "2026-02-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a small roof leak we worried about mold getting into the ductwork. Diego brought a camera, scoped the trunk lines, and let me watch the screen the whole time. He cleaned everything and applied an EPA-registered sanitizing treatment. Got a written report with before/after photos too. Real peace of mind.",
          "name": "Aisha B.",
          "date": "2026-02-19",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "We moved into an older home and within a week everyone was congested and sneezing. Hector came out, inspected the ductwork, and found the previous owners had never had it cleaned. He pulled drywall dust and construction debris out of the return vents. My seasonal allergies have genuinely calmed down since. Worth every penny.",
          "name": "Eleanor V.",
          "date": "2025-02-21",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Quick, clean, and honest. Sergei inspected the flue liner on our pellet insert, cleaned the buildup, and confirmed the cap was still in good shape. No upselling, just straight answers. The whole thing came in at a fair price.",
          "name": "Devon R.",
          "date": "2024-03-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Was burned by a national franchise that quoted me a new flue liner I didn't need. BHO inspected, ran the camera, and said the liner was perfectly sound. They saved me thousands and only charged the $69 inspection. That kind of honesty earns a customer for life.",
          "name": "Desmond R.",
          "date": "2024-09-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wonderful experience for an old gal who doesn't trust easily. Mikhail arrived right on time, explained the creosote removal in plain English, and never made me feel foolish for asking him to repeat things. Fair price too.",
          "name": "Mildred T.",
          "date": "2024-03-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Following a nasty windstorm in spring, water started seeping near our fireplace. The technician traced it to failed flashing where the chimney meets the roofline. He re-flashed and applied waterproofing, then walked me through the whole repair with photos. Fifty years in business shows in the workmanship. The crown also got a fresh coat of sealant while he was up there.",
          "name": "Allison K.",
          "date": "2024-04-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Scheduling was simple, Maureen got me in within the week. The tech ran a brush the full length of the vent and showed me the dense lint buildup he removed from the duct elbow behind the machine. He explained how that buildup is one of the leading causes of laundry-room fires. Reassuring to know it's handled now, and the written summary they emailed was a nice touch.",
          "name": "Allison M.",
          "date": "2026-01-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Rare to find a company where the front desk is this dialed in. Maureen remembered my name on the second call, fit me into a cancellation slot, and reminded me to keep the cat away from the smoke shelf area. The tech laid drop cloths everywhere and wore shoe covers. Smooth, professional, and friendly the entire way.",
          "name": "Bernard K.",
          "date": "2025-04-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Fireplace cleaning done right. Shoe covers on, drop cloths down, zero soot left behind. Maureen made booking effortless. Such a relief working with real pros.",
          "name": "Ana L.",
          "date": "2026-02-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "New townhome, never had the dryer vent looked at. Turns out the builder ran it up through the second floor with a couple tight bends. They cleaned it out, found a fair bit of leftover lint already, and showed me the airflow improvement at the exterior vent. Quick and tidy visit.",
          "name": "Anneliese K.",
          "date": "2025-06-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We had new flooring and trim installed and the HVAC was blowing sawdust out of the vents for weeks. BHO came in with a negative-air machine and scrubbed the system top to bottom. They cleaned the return vents that the builder never touched. House finally feels livable again, no more gritty film on the counters.",
          "name": "Eleanor M.",
          "date": "2023-08-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Pricing was laid out clearly before any work started. Maureen emailed me a written breakdown so I knew exactly what the sweep and inspection would run. The technician arrived in shoe covers, laid drop cloths, and removed a surprising amount of creosote without ever pushing waterproofing or repairs I didn't need. Fair and straightforward from start to finish.",
          "name": "Allison R.",
          "date": "2025-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Honestly didn't think air ducts could hold that much gunk until I saw what came out of ours. New house, previous family had a big golden retriever, and the supply vents were lined with fur. Maureen got us scheduled within the week. The tech walked the whole system, showed me before and after shots on his tablet, and gave us a written report at the end. Money well spent for peace of mind.",
          "name": "Aisha K.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Fantastic experience start to finish. Maureen got me scheduled within a couple days when I called about my dryer running hot and needing two cycles per load. The tech vacuumed out the entire vent run and cleaned where it exits through the roof. One cycle now and the dryer stays cool to the touch.",
          "name": "Glenn A.",
          "date": "2025-01-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "As a brand new wood-stove owner I genuinely didn't know a chimney needed cleaning until a neighbor mentioned it. Carlos came out, removed a surprising amount of creosote, and showed me before and after photos so I understood why it mattered. He also pointed out our cap was missing and quoted a stainless one. No pressure, just good information. The shoe covers and drop cloths kept everything spotless. For someone learning all this for the first time, it was exactly the kind of help I needed.",
          "name": "Devon R.",
          "date": "2025-02-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Compared three places. The other two wanted over a hundred just to look. BHO did the inspection for $69 and the sweep itself came in way under what I'd budgeted. Raj was thorough with the creosote removal and showed me before/after photos. Great value for a tight wallet.",
          "name": "Priya S.",
          "date": "2025-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Five winters of fireplace cleanings and a stainless cap install along the way. The technicians are consistent and tidy, always laying drop cloths from the door to the hearth. My only small note is the arrival window ran a bit wide this last time, but the work itself was excellent as always.",
          "name": "Devon A.",
          "date": "2025-10-08",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "From the first phone call with Maureen to the final walkthrough, this was an exceptional experience. We have a tall masonry chimney on a two story colonial and several other companies wouldn't even quote it. BHO sent two technicians who set up drop cloths and shoe covers, ran a camera the full length of the flue, and identified spalling brick near the crown that needed repair before winter. They handled the chimney sweep, the creosote removal, and a small masonry repair all in one visit. What stood out was how they cleaned up afterward, you would never have known anyone had been working in our living room. The fifty plus years of experience really shows in the way they explain problems without any pressure. We've already booked our annual inspection for next fall.",
          "name": "Annette W.",
          "date": "2025-06-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Like clockwork every autumn. The technician swept the flue, cleared a season's worth of creosote, and gave the damper a quick check while he was up there. Honest and fast.",
          "name": "Priya N.",
          "date": "2024-10-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Neighbor recommendation that paid off. Quick, clean, thorough creosote removal and a fresh stainless cap installed. Shoe covers on at the door. In and out in about 90 minutes.",
          "name": "Helena V.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We're converting to a gas insert and the realtor wanted documentation. The $69 inspection turned into a full level-2 with the camera scope. Devin found the old clay liner was cracked, gave me an honest repair quote, and cleaned out the creosote buildup while he was up there. Trustworthy people.",
          "name": "Devon K.",
          "date": "2026-01-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Phenomenal service start to finish. Maureen got us scheduled within two days, and the technician arrived right on time. He vacuumed out the lint trap housing, brushed the full duct run from the laundry room to the exterior wall, and replaced our cracked plastic vent cover with a new metal hood that has a screen to keep mice out. He also pointed out that our flexible foil transition hose was a fire hazard and replaced it with rigid pipe. Honest, thorough, and reasonably priced.",
          "name": "Aisha K.",
          "date": "2025-06-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Five decades of experience really shows. Tyler arrived with shoe covers on, swept the chimney, checked the crown for cracks, and handed me a written report by the time he left. We lit our first holiday fire that evening and the room smelled like woodsmoke and pine, exactly the comfort we wanted.",
          "name": "Greg H.",
          "date": "2025-11-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We've used this family-owned business twice now and request Omar every time. On the recent visit he cleaned the smoke shelf, checked the damper operation, and noticed our cap was loose from a windstorm. Fixed it on the spot. Shoe covers, drop cloths, the whole deal. The man is a true professional and a pleasure to have in the home.",
          "name": "Devon R.",
          "date": "2025-01-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Squirrels in the chimney are no joke. Nikolai arrived, assessed the situation, humanely removed the critters, cleared the leaves and acorns that had piled on the smoke shelf, and installed a sturdy stainless cap with a screen. He explained how animals get in and how the new cap prevents it. Reasonable price and very respectful of our property.",
          "name": "Anastasia K.",
          "date": "2024-06-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What impressed me most was how fast they responded after I left a voicemail on a Sunday. Maureen called back first thing Monday and slotted me in the same day. The chimney crown had some hairline cracks she flagged, the stainless cap got reseated, and the whole visit ran on schedule. Professional from the first ring of the phone to the final handshake. For a busy household where I can't afford to sit around waiting all day, this kind of reliability is worth its weight in gold.",
          "name": "Angela M.",
          "date": "2026-02-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Coordinated cleaning for a 12-unit rental I oversee. The technician was efficient, knocked out every lint trap and vent run, and the dry times improved immediately according to my tenants. One unit's exterior vent flap was broken and they flagged it with a photo so I could get it replaced. Solid, reliable work.",
          "name": "Aisha K.",
          "date": "2024-06-21",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Roof termination on a two-story colonial, which I knew would be a pain. Eli brought a ladder tall enough, cleared the cap, and ran his brush down from the top while a coworker monitored at the dryer. Lint that came out was packed solid at the elbow. Clothes actually dry now.",
          "name": "Sandra L.",
          "date": "2023-06-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Freeze-thaw had wrecked the face brick on our chimney. Several bricks were flaking apart. The crew replaced the damaged units, repointed, and applied a breathable waterproofing afterward so it won't happen again. They explained why sealing it the wrong way traps moisture. Really knew their masonry.",
          "name": "Travis B.",
          "date": "2024-06-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dryer was taking forever to dry a load and I finally called. Glad I added the air ducts to the same appointment. Lint trap area and the full vent run were completely clogged with built-up lint, a genuine fire hazard according to Victor. Fixed and tested before he left.",
          "name": "Hassan B.",
          "date": "2024-06-17",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our chimney cap had basically disintegrated into orange flakes on the roof. BHO came out, measured for a custom stainless cap, and while up there they spotted a crown crack we'd never have caught. Both fixed in one visit. Friendly, tidy, and the waterproofing they applied has held up through a wet spring.",
          "name": "Annika S.",
          "date": "2023-04-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Drop cloths covered the entire hearth area and a runner protected the hallway hardwood. The chimney crown had some cracking they flagged in a written report, but the sweep itself was immaculate. Not a smudge left behind.",
          "name": "Curtis M.",
          "date": "2023-09-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "As a real-estate agent I refer BHO to all my clients for pre-sale inspections. They never miss the appointment, the reports are formatted clearly, and the photos of the liner and cap are always included. My buyers feel confident knowing exactly what they're getting into. A reliable partner for closings.",
          "name": "Devon R.",
          "date": "2024-06-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booking the air-duct cleaning was the single best thing I did for my allergies this year. Ramon brushed and vacuumed every supply run, cleaned the blower compartment, and photographed the before/after so I could actually see the difference. My sinus headaches have basically disappeared. He wore shoe covers the entire visit too.",
          "name": "Theo M.",
          "date": "2026-01-27",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Stale smoke odor in the summer months turned out to be a negative pressure issue combined with a chimney that needed a cap. Luis walked me through the whole thing, no upselling. Quick, clean, and the smell finally cleared up after years of dealing with it.",
          "name": "Devon K.",
          "date": "2025-07-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Solid job on our air ducts. Shoe covers on, drop cloths down, and they sanitized the whole system to knock out a musty smell in the spare bedroom. Took about three hours. Smell hasn't come back.",
          "name": "Grant M.",
          "date": "2025-04-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Dust on the shelves no matter how often I wipe. Kevin walked the whole system, showed me the gunk built up in the main duct run, and cleaned each vent thoroughly with drop cloths down throughout. Less dusting now and my partner's nighttime cough has eased up. Very professional team.",
          "name": "Devon K.",
          "date": "2024-08-17",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "After we bought a house with an existing fireplace insert, I wanted a thorough check before lighting it. The technician removed the insert, swept the chimney, and discovered the liner wasn't properly connected at the top, which would have leaked smoke into the room. He documented it all in a written report with photos. They scheduled the liner fix for the following week and it's been perfect since. Really glad I called before just striking a match.",
          "name": "Carmen L.",
          "date": "2025-09-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My husband insisted all chimney sweeps are the same after a bad experience years ago. Jordan proved him wrong. Thorough cleaning, explained the smoke shelf situation in plain English, and pointed out a loose stainless cap that the other guys never mentioned. Even my skeptical husband shook his hand on the way out.",
          "name": "Renata C.",
          "date": "2025-10-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After 51 years in this house I finally had the chimney properly looked at. The gentleman who came was gentle and respectful, took his time scoping the flue, and patiently answered every single question my wife and I threw at him. He showed us photos of the smoke shelf and where some old soot had gathered. We never felt hurried. Maureen in the office was equally lovely when I booked, and she called the morning of to confirm. Hard to find this kind of care anymore.",
          "name": "Walter G.",
          "date": "2025-09-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Big thunderstorm rolled through and I noticed our cap looked crooked from the yard. Called the office and they sent someone within two days. He straightened and secured the stainless cap, inspected the crown for cracks, and confirmed the flashing was watertight. Quick, professional, fairly priced.",
          "name": "Hector V.",
          "date": "2025-11-04",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our laundry is on the second floor so the vent has a long, awkward run down to the side of the house. Dmitri took his time clearing every section and even pulled a small bird's nest out near the exterior vent hood, which explained the lint that kept blowing back. Drop cloths down, no mess left behind. Genuinely felt safer the moment he was done.",
          "name": "Tomas G.",
          "date": "2025-06-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Easy to book, easy to reschedule when my work shifted. Maureen handled the change without a fuss and resent the reminder for the new date. Creosote buildup was heavier than expected and they showed me photos before and after. Appreciated the clear updates throughout.",
          "name": "Tamsin O.",
          "date": "2023-10-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dryer vent was completely packed with lint. They cleared the whole duct run and showed me the pile. My dryer runs cooler already. Great work.",
          "name": "Tobias M.",
          "date": "2024-12-07",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Moved into a newly built house and wanted the air ducts done before turning the HVAC on for the summer. Felix found sawdust and a surprising amount of fine drywall dust packed into the return vents. He brushed and vacuumed each duct run and sealed the access points back up. Air quality difference was immediate, especially for my allergies.",
          "name": "Oluwaseun B.",
          "date": "2024-08-19",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Post-construction duct cleaning done right. The amount of drywall dust they extracted from the main trunk line was genuinely alarming. Tech was tidy, explained the process, and showed me camera footage of the cleaned duct interiors. Highly recommend for anyone coming off a remodel.",
          "name": "Tomas G.",
          "date": "2026-01-17",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Reasonable price, no nonsense. They cleaned the firebox and smoke shelf, checked the damper, and handed me a clear report. Done.",
          "name": "Marcus T.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Sam handled our duct cleaning after we bought a smoker's house. The nicotine smell had soaked into everything. He explained the process, sealed off rooms, and ran his equipment through every return and supply. The difference the first night was night and day. Very professional and tidy.",
          "name": "Stefan L.",
          "date": "2025-07-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Two cycles to dry a single load, every single time. That was my reality until BHO came out. The technician disconnected the vent, ran a brush through the long duct run that goes up two stories, and pulled out years of compacted lint. He also pointed out my flexible foil hose was crushed and recommended a rigid replacement. Drying is now one cycle and noticeably faster. Worth every penny.",
          "name": "Sofia K.",
          "date": "2024-06-17",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "New to homeownership and new to fireplaces. The $69 inspection was a no-brainer and the technician treated my dumb questions like they were normal. Learned what a damper is, learned to check for nesting birds, and learned my chimney crown had a small crack to keep an eye on. Really appreciated the education.",
          "name": "Hana K.",
          "date": "2025-03-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Skeptical bargain hunter here. The $69 price felt too good but it was legit. Quick, clean, professional. Shoe covers on, no mess left behind.",
          "name": "Hollis B.",
          "date": "2024-03-11",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "After three years with BHO I can't imagine using anyone else for the chimney. The crown sealing they did two seasons back is still solid, and this year's creosote removal was quick and spotless. Maureen's scheduling makes the whole thing painless.",
          "name": "Constance W.",
          "date": "2024-03-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Reached out in early fall to get ahead of the heating season and was glad I did. The inspection was the advertised sixty nine dollar rate, which I confirmed when I booked, and there were no surprise charges added later. Yuval checked the damper, found it was rusted partly shut, and freed it up while he was there. He swept the flue, removed a moderate creosote layer, and pointed out that the stainless cap was slightly loose but didn't try to sell me a new one, he just tightened it. The before and after photos he showed on his tablet made it easy to understand what he'd done. My only minor note is the arrival window was fairly wide, but he called ahead to narrow it down, which I appreciated.",
          "name": "Hassan M.",
          "date": "2023-10-17",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Our family has relied on this company for the annual sweep for years. The smoke shelf and flue were caked with creosote after a long burning season, and they cleared every bit of it. Maureen handled the booking over the phone and even called to confirm the morning of. Clean work, fair price, and they always leave a written report of what they checked. Wouldn't trust anyone else with our fireplace.",
          "name": "Hollis B.",
          "date": "2025-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We bought our house last spring and the previous owners left a sticky note that just said 'call BHO for the chimney.' Best advice they could have given us. Joey did a full sweep, checked the damper, and explained how the smoke shelf collects debris. Genuinely educational, and he never tried to upsell us on anything we didn't need. Will be using them every year now.",
          "name": "Theodore K.",
          "date": "2024-12-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Prompt, polite, and meticulous. Patrick prepped our chimney for a gas-log conversion by sweeping the flue and clearing the smoke shelf of debris. Shoe covers on, drop cloths down, not a speck of soot left behind. The written report he emailed was detailed enough that our installer signed off immediately.",
          "name": "Sofia M.",
          "date": "2025-06-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Solid work cleaning our long second-floor duct run and putting in a new exterior hood with a built-in guard. The bird nesting problem we'd been fighting every spring should finally be solved. Friendly tech who walked me through what he found.",
          "name": "Gregory P.",
          "date": "2023-04-17",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Ready for sweater weather and fireside nights. Quick, tidy creosote removal and a damper adjustment so the fire stops smoking back into the room. The $69 inspection was honest and they didn't upsell me on anything.",
          "name": "Priya N.",
          "date": "2024-10-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Andre handled our dryer-vent cleaning and was meticulous. He pulled an alarming amount of lint from the duct run behind the wall, cleared the lint trap housing, and showed me the airflow improvement with a meter reading. Our dryer cycles are noticeably shorter now. Friendly, tidy, and quick.",
          "name": "Sofia K.",
          "date": "2025-08-07",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Found out the hard way that our old cap had blown off and birds moved right in. The technician cleared a tightly packed nest from the flue, swept down any loose creosote while he was at it, and put on a new stainless steel cap with screen. Professional all the way.",
          "name": "Hassan B.",
          "date": "2023-04-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Needed an inspection before closing on my house and the timeline was tight. They squeezed me in within 24 hours, did the $69 inspection, took before and after photos of the flue, and emailed the report before the end of the day. Saved my closing date.",
          "name": "Reuben S.",
          "date": "2024-06-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We run a portfolio of rental townhomes and BHO has become our go-to for dryer-vent maintenance. Marco walked each property, cleaned every duct run to the wall cap, and gave me before/after photos for the owners' records. Billing was straightforward, one invoice per property. Could not ask for more.",
          "name": "Grant M.",
          "date": "2025-04-07",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our duct run is unusually long because the dryer sits in a converted closet far from any outside wall. The technician was thorough and clearly knew how to handle the multiple bends. He showed me the lint he removed and photographed the clean run afterward. The only small note is the arrival window was fairly wide, four hours, so I lost most of a morning waiting, but the work itself was excellent.",
          "name": "Kenji A.",
          "date": "2025-02-17",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Maureen in the office was wonderful scheduling around our work hours. The masonry crew rebuilt the crumbling crown and repointed about half the chimney on our 1930s bungalow. They sent a written report with before/after photos. Fair price for the amount of work. The new crown has a proper drip edge now instead of the flat cracked one we had.",
          "name": "Sofia D.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Both services in one trip, exactly what I wanted. The duct cleaning was thorough and they showed me a written report at the end listing each vent they hit. Only minor thing was the arrival window they gave me was pretty wide, a full four hours, so I lost most of the morning waiting around. Once the tech showed up though, everything was excellent and professional.",
          "name": "Caroline W.",
          "date": "2025-01-29",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Persistent damp smell in the firebox every time it rained turned out to be water tracking down a fractured crown. The technician sealed the crown, swapped out the corroded cap for stainless, and treated the masonry with a vapor-permeable waterproofer so the brick can still breathe. No more musty odor. Solid, honest work from a family-run outfit.",
          "name": "Reginald P.",
          "date": "2025-06-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Plastic sheeting went over the return vents and they put down protective film on the stairs before hauling equipment up. Every register cover was wiped clean and reinstalted exactly where it was. The dust I expected to find on the furniture simply wasn't there. Very respectful of the house.",
          "name": "Priya R.",
          "date": "2025-06-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Bought a foreclosure that hadn't had a fire in years. Diego's camera inspection found heavy creosote buildup and a missing stainless cap. The written report broke down what was urgent versus cosmetic, which helped me budget for the move. Honest assessment, no upselling.",
          "name": "Tabitha K.",
          "date": "2026-02-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Honestly skeptical that duct cleaning would do anything, but my wife has COPD and her pulmonologist recommended it. The technician documented dust levels going in and coming out, and the difference in the bagged debris was undeniable. Her oxygen readings have been steadier and she's using her rescue inhaler less. Glad we did it.",
          "name": "Russell A.",
          "date": "2025-04-18",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "After a remodel made our house tighter, we started getting downdrafts and that telltale smoke smell. These folks identified the make-up air problem right away and cracked the damper situation that was making it worse. Maureen in the office was patient scheduling around my work hours. Genuinely impressed with how thorough they were.",
          "name": "Hannah B.",
          "date": "2024-09-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our newborn's room always smelled a little off and I was paranoid about mold. Maureen scheduled us fast and the technician was incredibly thorough, cleaning all the return vents and supply runs, then fogging with a sanitizer he said was safe for kids and pets. He explained everything in plain English without trying to upsell me on a single thing. Genuinely kind people and the odor is completely gone.",
          "name": "Priya N.",
          "date": "2026-01-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "As someone with chronic allergies, I was skeptical air duct cleaning would actually help. It did. The technician went vent by vent, vacuumed the returns, and sanitized the supply lines. Showed me a written report with photos of what came out. Two months in and I'm using my antihistamines far less.",
          "name": "Hana S.",
          "date": "2026-01-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Maureen made booking simple and the technician who came for our wood stove cleaning was thorough. Cleared a thick creosote ring from the connector pipe and explained why our wood was the issue, too wet. Only small note is the arrival window was four hours wide so I burned half a morning waiting. Still a solid job and the stove runs hotter now.",
          "name": "Tobias K.",
          "date": "2024-12-11",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Different league entirely. A so-called specialist we used last winter rushed through in fifteen minutes and missed obvious creosote. Maureen scheduled us promptly, the tech did a real inspection, and the masonry repair on our chimney looks seamless against the original brick. 50 years of experience clearly shows.",
          "name": "Tobias H.",
          "date": "2024-06-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What a relief to deal with people who treat seniors with dignity. The young man laid down drop cloths, removed his shoes, and walked me slowly through the whole inspection. He found the chimney cap was rusting and explained my options without any pressure to decide on the spot. I'll be calling them again.",
          "name": "Frances B.",
          "date": "2024-06-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Heavy rains last fall left a water stain on the ceiling beside the chimney. Hector did a full storm-damage check, found the crown had spider cracks letting moisture in, and recommended a crown rebuild plus fresh flashing seal. He didn't pressure me at all, just laid out the options. The written report was detailed and easy to understand. They wore shoe covers in the house too, which my wife appreciated.",
          "name": "Sandra M.",
          "date": "2023-11-28",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Highly recommend for anyone who hasn't had this done. I had no idea how much lint can accumulate until they showed me the pile. The dryer was getting hot to the touch and taking three cycles to dry towels. Now it's one cycle and the machine stays cool. Worth every penny for the safety alone.",
          "name": "Rachel D.",
          "date": "2023-04-12",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Phoned 866-501-1614 expecting voicemail and got a real person, Maureen, who was lovely. She booked me, texted the night-before reminder, and gave me an accurate arrival time so I wasn't stuck waiting all day. Sergei cleaned the firebox and checked the damper. Communication this good is honestly the reason I'll call them again.",
          "name": "Greggory H.",
          "date": "2026-01-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Damper was stuck for years. Mikhail freed it in minutes and tested the draft. Fast, knowledgeable, and respectful of our home. Highly recommend.",
          "name": "Sofia G.",
          "date": "2025-06-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Builder handed us the keys in December and the dryer was venting poorly from day one. The tech discovered the flexible transition hose was crushed behind the unit and the lint trap area still had packing material in it. Cleared everything, reattached properly, and tested the vent hood flap outside. Runs perfectly now.",
          "name": "Tamara V.",
          "date": "2026-01-27",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Whole-home renovation meant sawdust and joint compound dust in places I didn't know existed. Carlos mapped out every supply and return before he started, sealed off the registers, and ran the brush system through. The change in air quality was immediate. My allergies eased up within a couple days. Genuinely impressed by how methodical the work was.",
          "name": "Sasha V.",
          "date": "2025-04-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "You don't find many companies this transparent anymore. Raj walked me through the chimney crown condition with photos and gave me an honest estimate for a small repair, then said it could wait a season if money was tight. Never once felt pressured. The sweep itself was thorough and the quote held firm. This is how a 50-plus-year family business should operate.",
          "name": "Priya N.",
          "date": "2025-08-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "First-time homeowners here and the inspection report flagged the air ducts as filthy, prior owners had pets. BHO came out and confirmed it, then did a thorough cleaning of the entire system. They showed us photos of all the pet hair and dust they pulled. The whole crew was respectful and laid down drop cloths. We breathe a lot easier knowing it's done right.",
          "name": "Carmen V.",
          "date": "2026-02-11",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Reliable and honest. My dryer had started overheating to the point I'd smell something warm in the laundry room. They cleared the lint from the trap housing and the full duct, showed me the pile they removed, and gave me a written report. Drying back to one cycle.",
          "name": "Terrence B.",
          "date": "2025-12-03",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Moved into our place last spring with a fireplace that hadn't been touched in years. Devin swept it, cleared a heavy creosote layer, and patiently answered every first-timer question I threw at him about seasoning firewood and airflow. Left a tidy written report. We feel confident lighting our first fire now.",
          "name": "Trevor B.",
          "date": "2024-04-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We're a young family pinching pennies on the first house and a full chimney workup felt like a luxury we couldn't afford. Maureen in the office walked me through the $69 inspection over the phone and it ended up being all we needed this year. The tech cleaned the smoke shelf, checked the damper operation, and gave us a clear written report so we know what to plan for. No scare tactics, just facts. For the price it was an absolute steal.",
          "name": "Tobias M.",
          "date": "2025-12-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Been calling this crew for the better part of five years now. Tyler did the sweep and a full flue liner inspection, then showed me the before and after photos on his tablet. No upsell, just straight facts on what needed doing. Renewing my trust every single visit.",
          "name": "Rashid M.",
          "date": "2026-02-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Living in a house built in the 1920s means the chimney is original masonry and I worried it might need major work. The technician spent a long time inspecting the flue liner with a camera and showed me where the old terracotta tiles had small cracks. Rather than pushing an expensive reline immediately, he explained which cracks were cosmetic and which needed monitoring, then performed a careful sweep and creosote removal. He laid drop cloths from the front door all the way to the hearth so nothing got tracked through. The written report he sent included photos of every flue section labeled by height. I felt like I was given real information to make a decision rather than a sales pitch. Genuinely refreshing to deal with a company that's this transparent.",
          "name": "Carla J.",
          "date": "2025-12-04",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Third year in a row with these guys for the routine cleaning. Creosote was heavier than usual this time and the tech flagged it, recommended we burn drier wood, then knocked it all out without making a mess. Professional and to the point.",
          "name": "Carmen O.",
          "date": "2024-09-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My sister-in-law passed along their number after they fixed her leaky chimney. Booked the $69 inspection and it turned into a great experience. The waterproofing they recommended has held up through two heavy storms with zero water in the firebox. Knowledgeable people.",
          "name": "Gabriela S.",
          "date": "2025-03-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Old gas line under the firebox needed the chimney cleaned and inspected before the insert install. Omar did a proper level-2 with the video camera, removed creosote glazing, and replaced a rusted stainless cap that was letting water in. Maureen in the office made scheduling painless.",
          "name": "Tobias W.",
          "date": "2024-04-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After noticing our laundry room felt humid, we suspected a clogged vent. The technician confirmed it, cleared a dense lint blockage near the exterior elbow, and installed a new vent hood with a flap and pest screen since the old one had rusted open. He showed me the lint he pulled out, it filled most of a grocery bag. Great attention to detail and he wore shoe covers inside the whole time.",
          "name": "Tamara W.",
          "date": "2026-01-29",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Hosting the in-laws for the holidays meant the fireplace had to work, and it does. Nikolai cleaned out a heavy creosote layer, swapped the cracked cap for a new stainless one, and pointed out where the masonry crown needed a touch of repair. Booked that follow-up too. Now the den glows every evening and the kids roast marshmallows. Couldn't be happier with how warm and inviting it feels.",
          "name": "Bernadette C.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Cannot say enough good things about Eli. He arrived for the $69 inspection, found our flue was perfectly fine, and refused to invent problems just to make a sale. Took time to teach me how to read my own damper and creosote buildup. That kind of integrity earns lifelong customers.",
          "name": "Hassan A.",
          "date": "2024-03-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Excellent experience start to finish. Maureen in the office got us scheduled within a couple of days and the technician removed a substantial bird nest from our chimney flue, cleaned out all the debris, and installed a new stainless cap with a screen to keep wildlife out for good. He took before and after photos and walked me through the written report. The whole thing was done in under two hours and the area was left cleaner than when he arrived. Truly impressed with this family-owned outfit.",
          "name": "Lillian or D.",
          "date": "2026-02-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Prompt and efficient. Texted to confirm the appointment, showed up on time, wore shoe covers inside, and finished the creosote removal faster than I expected. No complaints about the responsiveness at all.",
          "name": "Hana W.",
          "date": "2025-03-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a near-miss with an overheating dryer in one of my rentals, I had every unit serviced. The crew was thorough, cleared lint from all the vent runs, and explained why the longer duct runs on the upper floors clog faster. Peace of mind for a landlord is worth a lot.",
          "name": "Lena F.",
          "date": "2023-08-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Second floor laundry venting through the attic and out a gable. Maureen booked us quickly and Victor handled the attic crawl like it was nothing, clearing two tight elbows that were almost fully blocked. Airflow at the exterior vent hood is strong again. Professional from start to finish.",
          "name": "Olivia M.",
          "date": "2026-05-03",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Spalling was so bad on the south face you could crumble the brick with your fingers. BHO did a partial rebuild of the worst section and tuckpointed the rest. Mortar match is excellent. Highly recommend for older homes.",
          "name": "Malik J.",
          "date": "2024-02-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Outstanding. Combined our air-duct and dryer-vent cleaning and the difference in airflow from the registers is night and day. Ramon was meticulous, taped off the returns, and vacuumed up every speck. You can tell this is a family business that actually cares about the work.",
          "name": "Tobias M.",
          "date": "2025-12-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Maureen got me on the schedule within a couple days when I described the water stains spreading across my ceiling. Luis found the chimney crown had spalled badly and the cap was gone entirely, so rain was pouring straight down the flue. New crown, new stainless cap, full waterproofing. He walked me through every photo before and after. Genuinely impressed.",
          "name": "Lucia M.",
          "date": "2026-01-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Kevin showed up, slipped on shoe covers at the threshold, and got to work. He took before and after photos of the flue liner and pointed out the creosote glaze he removed. What impressed me was the cleanup, he swept around the firebox and then wiped the mantel, leaving zero residue. Genuinely the cleanest service visit we've had.",
          "name": "Tobias L.",
          "date": "2024-12-05",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our closing was three weeks out and the home inspector flagged the chimney as needing a specialist. Maureen coordinated everything and Jordan delivered a comprehensive written report with photos of the cracked crown and worn flue liner. The whole process was painless and the documentation satisfied our underwriter.",
          "name": "Hassan M.",
          "date": "2025-01-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Clean air matters more to me since I started working from home. BHO cleaned the full duct system, replaced my filter with a higher-MERV one they recommended, and walked me through how often to swap it. Dust on my desk surfaces has dropped dramatically. The technician was thorough and tidy.",
          "name": "Imani W.",
          "date": "2024-10-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Damper was rusted shut and the chimney hadn't been swept in a decade. Smoke spilled into the den every time. Dmitri cleared the creosote, got the damper moving smoothly again, and sealed up a gap in the smoke shelf area. Drop cloths and shoe covers the whole time. Couldn't be happier.",
          "name": "Reginald F.",
          "date": "2025-03-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Bought an older home that smelled musty no matter how much we cleaned. Felix found the ducts were packed with construction dust and some mildew near a vent close to the bathroom. Full clean plus a sanitizing fog, and honestly it transformed how the place smells. Worth every dollar.",
          "name": "Tobias K.",
          "date": "2025-09-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked them after my doctor suggested indoor air might be aggravating my asthma. Sam and his helper were thorough, laid drop cloths everywhere, and cleaned every duct run plus the return vents. They even pointed out a loose section of duct and resealed it. Breathing easier and the house holds way less dust.",
          "name": "Theodore M.",
          "date": "2025-06-12",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Fantastic experience with this family-owned outfit. They cleaned our fireplace insert, swept the liner, removed glazed creosote near the smoke shelf, and capped off with a tidy vacuum of the hearth. The tech spent extra time teaching my husband how to build a top-down fire for cleaner, hotter burns. We've noticed way less smoke spillage already. Worth every penny.",
          "name": "Annika S.",
          "date": "2025-02-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Skeptical is putting it mildly. After a contractor botched our waterproofing and the chimney still leaked, I assumed everyone cut corners. BHO did it right, sealed the crown, treated the brick, and a year later not a single drop inside. The written report even noted areas to watch.",
          "name": "Aaliyah B.",
          "date": "2025-04-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "I'm 84 and a bit hard of hearing, but Yuval made sure to face me when he talked and spoke clearly so I caught every word. He cleaned out the creosote, checked the damper, and even helped me carry in firewood that was sitting by the door. The kind of thoughtful service my late mother would have appreciated.",
          "name": "Raymond L.",
          "date": "2026-01-27",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Wind ripped the cap off during a derecho. Joey replaced it with a sturdier stainless model and checked the crown and flashing for storm damage. Honest assessment, no upselling. Solid company.",
          "name": "Errol B.",
          "date": "2024-08-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Fire safety was my whole reason for calling. The technician measured airflow at the vent hood before and after, and the difference was dramatic once he cleared the packed lint from the duct. Professional and thorough. Could have used a slightly tighter arrival window but he texted ahead, so no real complaint.",
          "name": "Brandon W.",
          "date": "2025-09-08",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "From the first call you can tell the office is well run. Maureen explained the inspection pricing up front, no surprises, and sent a calendar invite plus a reminder. The written report on the flue liner was detailed and easy to follow. Pleasant experience all around.",
          "name": "Priya N.",
          "date": "2024-12-05",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Air duct cleaning made a huge difference in dust. Crew pulled debris from every return vent and bagged it all. Polite and efficient throughout.",
          "name": "Reginald B.",
          "date": "2024-04-12",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "First duct cleaning on our new house. The system looked clean to me but the camera showed plenty of leftover construction dust in the longer runs. Crew was professional and walked me through the report. Took a little longer than quoted but the result was solid.",
          "name": "Grant W.",
          "date": "2023-05-12",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Had the ducts cleaned after gutting our bathroom and laundry area. Crew pulled out drywall chunks and a layer of fine sanding dust that had settled in the duct runs. They were thorough and respectful of the house, drop cloths down the whole time.",
          "name": "Reggie P.",
          "date": "2024-06-12",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Quote over the phone matched the invoice exactly. Patrick removed heavy creosote, inspected the flue liner, and pointed out a hairline crack in the crown without trying to sell me an immediate fix. Said keep an eye on it. Appreciated the candor and the fair price.",
          "name": "Helena V.",
          "date": "2026-04-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Bought a fixer-upper and the previous owners smoked indoors for years. The vent hood and ducts were caked. Andre and his partner spent the afternoon scrubbing out the runs and the smell improvement was immediate. Highly recommend for anyone moving into an older home that needs a fresh start.",
          "name": "Tobias W.",
          "date": "2025-05-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "After moving into an older home, I realized the dryer vent had probably never been cleaned. Loads took forever and the unit got hot enough to worry me. Marco traced the whole run, found a bird's nest near the exterior vent hood, and cleared everything out. Now my clothes dry in a single cycle and the machine runs cool. Couldn't be happier with the care he took.",
          "name": "Renata M.",
          "date": "2026-01-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our realtor recommended getting the chimney looked at after we bought the house, and I'm so glad we did. The crew laid drop cloths everywhere, swept the flue, and walked me through reading the report line by line since I'd never owned a fireplace before. They explained creosote stages in plain English. Family-owned and it shows in how they treat you.",
          "name": "Sofia M.",
          "date": "2025-10-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Affordable and honest, a rare combo. The $69 inspection turned up only minor creosote so the technician swept it on the spot and didn't pad the bill. Family-owned outfit and it shows in how they treat you.",
          "name": "Anjali V.",
          "date": "2024-06-29",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Long-time customer here. The annual inspection and sweep always comes with a detailed written report, which I appreciate for our records. Diego spotted a hairline crack in the smoke shelf early enough that the repair stayed minor and affordable. Reliable people, year after year.",
          "name": "Brigitte L.",
          "date": "2023-06-27",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "We had a chimney fire scare last winter, a loud popping followed by a strong burning smell, and BHO got us on the schedule within two days. Hector arrived and immediately did a safety inspection, confirming there had been a small flue fire that left damage to the liner. He explained everything calmly, showed me the scorched section on camera, and walked through the repair options. The creosote that had built up was the third degree glazed type, which he removed completely. He also installed a new stainless cap and recommended cutting back the oak we'd been burning unseasoned. The whole time he kept the area protected with drop cloths and cleaned up thoroughly. I genuinely think their thoroughness prevented a far worse outcome down the line. Cannot thank this family run team enough.",
          "name": "Tobias E.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Yearly maintenance sweep went smoothly. Sergei arrived, put on his shoe covers, and got straight to clearing the creosote from the liner. He pointed out a hairline issue on the chimney crown but didn't pressure us to fix it on the spot. Appreciate that kind of honesty from a company we've used for ages.",
          "name": "Vincent A.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Word travels fast in our cul-de-sac, and BHO was the name everyone kept dropping. The tech laid drop cloths across the entire hearth area and cleaned up so well I couldn't tell anyone had been there. Flue is spotless. Solid work.",
          "name": "Owen B.",
          "date": "2024-06-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Honestly impressed. Before our gas-log set went in, Mikhail swept the entire flue, vacuumed the firebox, and ran a level-2 camera inspection because we'd had a chimney fire years ago. He documented everything in a tidy report and explained why a new liner would make the conversion safer long term. No pressure, just facts.",
          "name": "Greta H.",
          "date": "2025-09-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Carlos was fantastic. He snaked the brush through the entire duct, cleared the lint, then replaced our broken exterior vent with a new hood that has a louvered pest guard. No more wasps building nests in there. He even resealed around the wall penetration with fresh caulk.",
          "name": "Hassan M.",
          "date": "2024-07-03",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Snowy December, crackling fire, hot cocoa. That's the scene now thanks to a thorough sweep. They protected the floors with drop cloths and showed me the return on a clean flue with photos. Highly recommend for getting the hearth holiday-ready.",
          "name": "Omar F.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Raj is the reason I keep calling this company. Last week he tackled a stubborn creosote glaze in our 1920s chimney, swapped out a rusted cap for a new stainless one, and waterproofed the masonry while he was up there. He texted me photos of every step. Maureen scheduled it all painlessly. Top-notch from start to finish.",
          "name": "Camille D.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We had a raccoon situation in the flue that turned into months of debris buildup. Devin got everything out, scrubbed the smoke shelf clean, and topped the chimney with a stainless cap and screen. He was patient with all my questions about damper function too. Solid work.",
          "name": "Reginald M.",
          "date": "2025-07-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dryer wasn't drying and I was worried about a fire hazard, so I appreciated that they fit me in the same afternoon. Tech cleared a surprisingly long lint clog from the vent run, cleaned the lint trap housing, and showed me the airflow improvement before he left. Quick, no fuss, on time.",
          "name": "Terrence O.",
          "date": "2025-07-11",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Six-unit building, six dryers, all cleaned in a single visit. Tyler was meticulous, vacuumed each lint trap housing and ran the brush the full length of every duct. He noted one vent that exited too close to a window and recommended a fix. Tenants reported faster drying within a day.",
          "name": "Tobias N.",
          "date": "2026-05-09",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Tight crawlspace under the house with a duct run that doglegs around a support beam. Omar didn't complain once, suited up, and worked through it methodically. He found the flapper on the exterior vent hood was stuck shut from years of lint buildup and freed it. Showed me a before-and-after photo of the duct interior on his phone. Reasonable price for a job nobody else wanted to touch.",
          "name": "Trevor B.",
          "date": "2024-12-11",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Restored the original brick on our 1908 Victorian's chimney without making it look new or fake. That mattered to us. Nikolai found matching reclaimed brick for the few units that had to be swapped, repointed with a lime-based mortar appropriate for the age, and waterproofed. The attention to historic detail was beyond what I expected from a chimney company.",
          "name": "Constance W.",
          "date": "2025-07-29",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Maureen got us on the schedule fast and the tech handled the dryer vent and ducts back to back. Pulled a wad of lint out of the vent hood the size of a softball. No more burning smell when we run the dryer.",
          "name": "Renata F.",
          "date": "2024-02-26",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Cracked crown was funneling water into the brick and freeze-thaw was wrecking the mortar. The team repointed the deteriorated joints, recast the crown with an overhang drip edge, and sealed everything. Clean, professional, and they explained why waterproofing matters up here.",
          "name": "Tobias W.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Careful is the word I'd use. The crew padded the corner of our antique armoire that sits near the chimney and used drop cloths under all the gear. Damper was serviced and the whole hearth wiped down. Polished work, polished cleanup.",
          "name": "Helena K.",
          "date": "2026-04-27",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Pre-purchase inspection on a 1940s bungalow. The technician was punctual, wore shoe covers, and explained the difference between surface staining and actual structural concerns on the masonry. Written report came the next morning. Gave us real peace of mind before we signed.",
          "name": "Renata S.",
          "date": "2023-09-12",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Following a kitchen renovation our whole house smelled like sawdust for months no matter how much I vacuumed. Turns out the construction dust had settled deep in the return vents. The team did a complete air-duct cleaning, sealed each register during the process, and the air feels genuinely crisp now. My particle counter confirmed it.",
          "name": "Gabriel O.",
          "date": "2025-09-30",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Our fireplace draft was so weak that smoke just hung in the room. The technician ran a quick test and found the flue liner had partially collapsed near the top. He explained options clearly and the repair fixed both the draft and the lingering smell. Fair price for the work.",
          "name": "Sofia M.",
          "date": "2026-01-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Quick and clean. Cleared a damp smell out of our HVAC system and sanitized the duct runs. Drop cloths everywhere, friendly tech, in and out without drama.",
          "name": "Lena F.",
          "date": "2024-06-17",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Our golden retriever sheds constantly and the dander was triggering my daughter's asthma. The crew showed up on time, ran a powerful vacuum through every supply and return, and the before/after photos were eye-opening. So much pet hair came out of the ducts. She's been sleeping through the night since.",
          "name": "Camille B.",
          "date": "2024-12-03",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Booked the $69 inspection for our wood-burning stove and it turned into a great learning session. Eli checked the stainless liner, measured creosote thickness, and showed me the spot where buildup was worst right above the stove collar. He cleaned it that same visit. Appreciated that he didn't try to sell me a whole new liner when a cleaning was all I needed.",
          "name": "Reginald M.",
          "date": "2024-08-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Pleasantly surprised. The previous company left my fireplace looking worse than before. These folks were careful, professional, and the creosote removal was genuinely thorough. Damper moves freely now.",
          "name": "Garrett W.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Gentle, trustworthy, and so very patient with an old man who likes to understand things. The technician spent extra time showing me the flue liner condition on his camera and explaining why no repair was needed yet. Honest people don't sell you what you don't need.",
          "name": "Stanley R.",
          "date": "2024-12-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Reached out after a hailstorm because a neighbor's chimney crown had cracked and I wanted ours checked. The tech inspected the crown, cap, and flashing top to bottom, took before/after photos, and gave us a clean bill of health except for a tiny flashing gap he sealed on the spot. Genuinely appreciated the thoroughness and the clear explanation.",
          "name": "Tasha L.",
          "date": "2025-05-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "My insurance agent actually recommended a vent cleaning after a neighbor's house caught fire from their dryer. Glad I listened. The crew pulled a shocking amount of lint from a duct run I couldn't even reach myself. They photographed the buildup and the cleared duct so I had proof for my own peace of mind. Polite, on time, and careful with my floors.",
          "name": "Yolanda S.",
          "date": "2024-12-03",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Maureen coordinated my air duct cleaning around a tricky work schedule and never once made me feel like a hassle. Reminder text came right on time, the crew mapped every return vent and supply run, and she followed up the next day to confirm I was satisfied. Office staff like this keep customers loyal.",
          "name": "Sullivan W.",
          "date": "2025-08-16",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Flue liner inspection turned up a small crack I never knew about. Honest written report, no pressure to fix immediately. Trustworthy family-owned outfit.",
          "name": "Hana W.",
          "date": "2025-08-16",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Brand-new construction, and we wanted a clean slate before the baby arrives. Victor and his partner laid drop cloths through every hallway, put on shoe covers, and pulled an honest amount of builder debris out of the return vents and supply ducts. The before and after photos sold me completely. Professional, careful, and they answered all my questions about maintenance going forward.",
          "name": "Henrietta M.",
          "date": "2025-11-30",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Our builder swore the ducts were fine after the addition went in. They were not. BHO showed me handfuls of sawdust and drywall powder coming out of the return vents. Ramon was professional, quick, and left the place cleaner than he found it. The musty construction smell is gone.",
          "name": "Hana W.",
          "date": "2026-05-08",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Solid experience overall. The pricing was fair and clearly explained up front, and the technician was honest that my chimney didn't need much. My only small gripe is the arrival window was pretty wide, from 8 to noon, and he showed up close to 11:45. Once he was here though, fast and tidy work, no upsell attempts at all.",
          "name": "Bradley S.",
          "date": "2024-06-29",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Just wanted air I could actually trust before moving the kids in. The home had a cat and the ducts proved it. BHO scheduled fast, the technician was thorough, cleaned all the return vents and supply runs, and left a written report. Couldn't be happier.",
          "name": "Renata G.",
          "date": "2024-08-19",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Wonderful family-owned outfit. Called because drying took two-plus cycles and the dryer felt hot. They came out, cleaned the entire duct, and even cleaned up the lint dust that drifted onto the floor. Professional and friendly.",
          "name": "Owen D.",
          "date": "2024-03-26",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Honestly had no idea chimneys needed regular maintenance until we became homeowners. Luis was great about teaching rather than just selling. He showed me the smoke shelf, explained why the cap matters for keeping rain and critters out, and didn't try to upsell anything we didn't need.",
          "name": "Quincy L.",
          "date": "2025-04-27",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Pleasantly surprised top to bottom. I budgeted a few hundred dollars expecting the worst, and walked away spending a fraction of that. Kevin inspected the flue liner, found the creosote was minimal, and gave me a realistic timeline for the next cleaning. He laid drop cloths everywhere and you'd never know anyone had been in the living room. The $69 fee was exactly what they quoted with zero surprises at the end. For folks watching their spending, this is the place.",
          "name": "Camille D.",
          "date": "2026-04-09",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We started with BHO for the chimney and now have them do our air ducts too. This visit they cleaned all the return vents and supply runs, and the dust difference in the house was noticeable within a day. Same dependable family operation we've trusted for years.",
          "name": "Quentin D.",
          "date": "2025-04-30",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "After moving into a house with a gas insert, I wanted everything checked before using it. The technician inspected the venting, the cap, and the surrounding masonry, then ran the camera to confirm there were no blockages or animal nests in the flue. He found an old bird's nest near the smoke shelf and cleared it out carefully, showing me the debris in a bucket afterward. The sweep was clean and he wore shoe covers the entire time. The written report was detailed and arrived later that day. The only small hiccup was that the initial callback to confirm my appointment took a day longer than expected, but once Maureen reached me everything ran smoothly. Solid, knowledgeable service and I'd use them again without hesitation.",
          "name": "Lorraine B.",
          "date": "2026-01-27",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Quick, clean, dependable. Annual creosote removal handled in no time and the firebox looked spotless after. Same crew we've trusted for years.",
          "name": "Aaliyah F.",
          "date": "2023-11-17",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "An old college friend who's now a contractor told me these were the only chimney people he trusts. After my appointment I understand the loyalty. Jordan found heavy creosote buildup, removed all of it, and showed me before and after photos so I could actually see the difference. He also flagged that my chimney crown will need attention in a couple years but said there was no rush. That kind of honesty earns repeat business.",
          "name": "Rosalind F.",
          "date": "2025-08-19",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Quick and clean fireplace cleaning ahead of our gas insert. Dmitri was in and out in under two hours, left the hearth spotless, and the level-2 report came through that evening. Solid work.",
          "name": "Andre L.",
          "date": "2023-11-27",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Booked a dryer vent cleaning and ended up upgrading the exterior hood too. The original cover was a brittle plastic louver that had stopped closing, so mice had a path right in. The tech installed a galvanized hood with a stainless screen guard and brushed the full run clean. Drying is noticeably quicker. Took a touch longer than I expected but the result was worth it.",
          "name": "Lindsey B.",
          "date": "2025-11-11",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "After two years of not using our fireplace we wanted it safe for Christmas. The tech did a full inspection, removed glazed creosote, and replaced a missing chimney cap that birds had been getting into. Written report was detailed and easy to understand. The first fire on Christmas Eve was the coziest night we've had in this house. Maureen in the office was a delight to deal with too.",
          "name": "Lucinda T.",
          "date": "2023-12-20",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Polite and skilled, Felix made quick work of our fireplace cleaning. He laid out drop cloths, brushed the firebox, and pointed out where the smoke shelf had collected debris. My only minor note is the arrival window was a bit wide, four hours, but he called ahead so I wasn't stuck waiting blindly. Solid work overall.",
          "name": "Grant W.",
          "date": "2024-06-11",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Chimney was making strange noises all summer. Turned out to be birds nesting deep in the flue. The crew removed the nest, vacuumed out the leftover twigs and droppings, and installed a new stainless steel cap with a screen mesh. Drop cloths down, shoe covers on, very clean operation. Fair price and friendly service. Will use them again.",
          "name": "Carmela V.",
          "date": "2024-11-12",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Booked online late at night and got a confirmation call from Maureen by 8:30 the next morning. They had availability that very day. Sam arrived inside the window, swept the chimney, removed a thick creosote layer, and left the hearth spotless. Fifty years in business clearly teaches you how to run a tight schedule.",
          "name": "Lillian D.",
          "date": "2026-04-02",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Maureen made scheduling for my rental duplex effortless, working around both tenants' availability. The tech cleaned both dryer vents, showed me the surprising amount of lint pulled from the runs, and left everything spotless with shoe covers and drop cloths. Honest pricing and no upsell. Exactly what a busy landlord needs.",
          "name": "Renata C.",
          "date": "2024-02-27",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Roof-vented dryer on a tall house. Yuval was up on the steep pitch safely harnessed and pulled a thick mat of lint right out of the cap. Quick, clean, and our drying time is cut in half.",
          "name": "Aisha K.",
          "date": "2025-08-19",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Solid tuckpointing job. The joints were washed out and birds were nesting in the gaps. They cleaned it all out, repointed, and installed a stainless cap so nothing gets back in. Took two days for the masonry to cure properly.",
          "name": "Reuben A.",
          "date": "2023-10-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Decided to do air ducts and the dryer vent together since the crew was already coming out. Smart move. Joey explained how the long duct run behind our laundry room had a kink restricting airflow and reworked it. He laid drop cloths everywhere and left the place spotless. Genuinely impressed with how careful and tidy the whole job was.",
          "name": "Gregory A.",
          "date": "2025-07-11",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "We'd called three companies about a leaking chimney and BHO was the only one who climbed up to actually look instead of guessing. Turned out the crown had a half-inch crack and the old galvanized cap had rusted out, so water was getting in two ways. They rebuilt the crown, installed a lifetime stainless cap, and applied masonry waterproofing. The written report had photos of every step. No leaks through the whole rainy season.",
          "name": "Esperanza V.",
          "date": "2025-08-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Fifty years in business shows. They protected the floor from the door to the fireplace, vacuumed every bit of soot from the smoke shelf, and even buffed the brass fireplace tools that had gotten dusty. The stainless cap got installed without a single mark left on the roof flashing visible from below. Spotless top to bottom.",
          "name": "Rashid A.",
          "date": "2023-04-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Scheduling a real-estate inspection through this company was straightforward. Patrick arrived, scoped the flue with a camera, checked the damper operation, and noted everything in a tidy written report. My only minor note is the arrival window they gave me was fairly wide, so I sat around a bit. Still very happy with the result and would use them again.",
          "name": "Conor B.",
          "date": "2024-04-25",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Quick note of thanks. Andre cleaned our air ducts and the dryer vent in one visit. The lint trap area had a serious buildup and the duct runs were dustier than I expected. House feels fresher and the dryer runs cooler. Efficient and respectful of the home.",
          "name": "Selena B.",
          "date": "2026-03-12",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Wind-driven downdrafts were pushing cold air and old smoke smell down the chimney. Marco installed a wind-directional cap and adjusted the damper seal. Problem solved in one visit. He even vacuumed up the little bit of soot that fell during the work.",
          "name": "Theo G.",
          "date": "2025-10-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We'd been chasing a mildew odor for months. The crew did a proper negative-air vacuum on every duct, scrubbed the return vents, and applied an antimicrobial treatment. They showed me before/after photos so I could actually see the difference. The arrival window was pretty wide, almost four hours, but once they showed up the work itself was excellent and the smell is gone.",
          "name": "Russell D.",
          "date": "2025-03-11",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Persistent dusty smell whenever the heat kicked on. Diego diagnosed it as buildup in the ductwork, cleaned the entire system, and replaced our clogged filter. Walked me through a written report at the end. The musty smell is gone and my morning sinus issues have improved a lot.",
          "name": "Rashid A.",
          "date": "2025-09-25",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Our insert had been smoking back into the room and I assumed we needed a costly repair. Turns out it was just a heavily glazed flue. The technician removed the creosote, checked the damper operation, and explained that burning unseasoned pine was the culprit. Switched to seasoned oak per his advice and the difference is night and day. Clean, courteous, and the drop cloths kept everything spotless.",
          "name": "Bianca F.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "I'll never use anyone else. We'd had two cheap dryer-vent cleanings that clearly missed half the lint, because the dryer was still overheating. BHO ran a brush through the entire duct run, cleared a bird's nest near the vent hood, and the dryer works like new. Worth every penny over the bargain outfits.",
          "name": "Sofia K.",
          "date": "2024-08-05",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "My daughter found these folks for me and I'm so grateful. At my age I get anxious about strangers in the house, but Hector put me right at ease. He explained the whole sweeping process beforehand, showed me the before and after photos of the chimney, and tidied up every speck of soot. Maureen even followed up a few days later to make sure I was happy. Genuinely caring family business.",
          "name": "Gloria W.",
          "date": "2025-04-16",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Post-storm inspection turned up more than I expected. The flashing on the back side had pulled away and water was getting behind the brick. They re-flashed, waterproofed the masonry, and sealed the crown. The crew laid drop cloths everywhere and cleaned up spotless. The arrival window was a bit wide, four hours, but the tech called ahead when he was thirty minutes out, so it worked out fine in the end.",
          "name": "Gregory P.",
          "date": "2024-10-07",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "The flexible foil duct behind our dryer had collapsed and was choked with lint, a combination the tech said is a real fire hazard. He replaced that section with proper rigid duct and cleared the whole run to the exterior hood. Clothes dry faster and I no longer worry every time we run a load overnight.",
          "name": "Eli N.",
          "date": "2026-04-17",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Booking was a breeze. Maureen gave me a clear two-hour window instead of a vague all-day one, which I appreciated. She texted a reminder and the tech arrived on time, swept the chimney, and removed a surprising amount of creosote. Very communicative little family business.",
          "name": "Henrietta B.",
          "date": "2024-03-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Creosote removal was thorough and quick. Sergei was friendly and walked me through the buildup levels. Fireplace feels brand new. Five stars easy.",
          "name": "Caleb D.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "New home, first-ever dryer vent service. The work itself was great, they cleaned the duct run and lint trap and verified airflow at the hood. Only small thing was the arrival window was pretty wide, about four hours, so I lost most of my morning. Still, friendly tech and good results.",
          "name": "Cedric L.",
          "date": "2024-03-04",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Renovation dust was everywhere after our kitchen remodel, coating every vent in the house. The BHO crew cleaned out all the supply and return ducts, and the technician was courteous, explained what he found, and left everything spotless. The air felt noticeably fresher within a day.",
          "name": "Oscar L.",
          "date": "2023-03-22",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Wonderful from the first call. Maureen gave me an exact figure for the dryer-vent cleaning and there were no surprises. The tech cleared a startling amount of lint from the duct run and showed me the clogged lint trap area. My dryer runs cooler now and the price was completely fair.",
          "name": "Sofia L.",
          "date": "2025-10-11",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "We purchased a townhome where the seller had two large dogs. The HVAC tech we used said the air ducts were the worst part, so we called BHO. Mikhail came out, was upfront about pricing, and got to work pulling fur and dust out of every vent. He even pointed out a loose duct connection in the basement and explained how to get it sealed. Three hours later the place smelled clean for the first time. Great experience start to finish.",
          "name": "Hassan M.",
          "date": "2026-01-27",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "My utility bill had crept up and I finally connected it to the dryer needing multiple cycles. Carlos came out, snaked a brush through the duct run, and removed a frankly disgusting amount of lint near the wall transition. He explained that the blockage was forcing the dryer to overheat and work harder. Drying is now a single cycle and the laundry room isn't a sauna anymore.",
          "name": "Lakshmi V.",
          "date": "2025-07-11",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "First-time fireplace owner here. Scheduling with Maureen was easy and the tech showed up within the window. He inspected everything, swept out the creosote, and recommended a stainless cap since ours had rusted through. Quick, clean, informative.",
          "name": "Bianca F.",
          "date": "2024-12-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Cheapest inspection I could find and somehow the most thorough. Got a written report, photos of the chimney crown, and a clear yes-or-no on whether I needed repairs. I didn't. Saved me a bundle.",
          "name": "Reginald P.",
          "date": "2025-08-16",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Six years of sweeps and one masonry repair with this company. The work has always been first rate, and the stainless cap they put on really cut down our downdraft. There was a small callback delay scheduling this year's visit, but Maureen made up for it once we connected. Still a yearly fixture for us.",
          "name": "Anneliese F.",
          "date": "2024-07-15",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Three different companies had told me my chimney was fine, but I kept getting smoke drifting back into the room. BHO was the first to actually diagnose the problem. Raj examined the smoke shelf and damper, then used the camera to find that a partial creosote blockage higher up was restricting the draft. He swept the entire flue, removed the buildup, and explained how the height of the chimney relative to the roofline was affecting the draw. The difference on the very next fire was night and day, no smoke at all. He protected the hearth with drop cloths and left the area spotless. The written report documented the airflow issue with photos so I understood it completely. Real expertise and patience, exactly what fifty years in the trade should look like.",
          "name": "Felix N.",
          "date": "2025-08-11",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Scheduling our every-fall chimney sweep with Maureen is always painless. The technician this year spent extra time on the flue liner because we'd burned a lot over the winter, and the amount of creosote he pulled out was eye-opening. He bagged everything, vacuumed the hearth, and walked me through a written report before leaving. Consistent quality season after season.",
          "name": "Marcus D.",
          "date": "2025-02-28",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Got their name from a neighbor over the fence. Friendly, fair, fast. Damper was sticking and the tech freed it up and cleaned the whole flue without making a mess. Highly recommend.",
          "name": "Curtis A.",
          "date": "2024-02-27",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We bought a 1920s home with a coal-converted fireplace and wanted gas logs. BHO sent Devin for a full level-2 inspection. He scoped the flue, found heavy creosote and a deteriorating crown, and gave a phased plan so we could budget. Cleaning was thorough and the before/after photos showed the difference. Genuinely appreciated the honesty about what needed doing before any gas appliance went near it.",
          "name": "Camille B.",
          "date": "2026-02-17",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Excellent experience. The lint trap area and the duct were packed, and the tech showed me a clump the size of a softball that came out of the line. He also installed a new pest-proof exterior hood after we mentioned a chipmunk had gotten in. Tidy, courteous, and clearly knew the work.",
          "name": "Quentin D.",
          "date": "2023-09-25",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Warm home, happy family. Tyler swept the chimney and cleared the smoke shelf of debris before our holiday party. He was in and out in under an hour and left zero mess. The fire roared all night while everyone sipped mulled wine.",
          "name": "Trevor S.",
          "date": "2025-12-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Omar treated our air-duct cleaning like it was his own home. Covered the return vents, ran the brushes through every duct run, and showed me the before and after photos of the gunk he pulled out. The house smells fresher and my allergies have calmed down. Courteous and thorough.",
          "name": "Naomi F.",
          "date": "2025-04-19",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Quick and painless. Found a bird nest, removed it, swept the flue, capped it with stainless and a screen. Done in 90 minutes. Nikolai was great.",
          "name": "Otis F.",
          "date": "2023-08-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "On time, every time. This is my second year using them and both visits started exactly when promised. Quick sweep, damper checked, flue inspected, done in under an hour. Reliability like this keeps me coming back.",
          "name": "Caleb F.",
          "date": "2025-10-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Manage student housing where the dryers run nonstop. BHO cleared the lint from all ten units and the buildup was alarming. They documented each duct run with photos and gave me a written report I could share with the property owner. Will absolutely have them back next semester.",
          "name": "Hugo B.",
          "date": "2025-01-19",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "The run from our upstairs laundry to the roof is long and has a couple of 90-degree bends that trap lint. Technician came prepared with the right length of rod and brush. He was friendly and explained that our setup really should be serviced annually. Took longer than the estimate but he stayed until the airflow tested right. Happy with the result.",
          "name": "Gregory P.",
          "date": "2023-10-05",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Arrival window was a bit wide, they said morning and showed up around 1pm, but once they were here the work was excellent. Repointed the entire chimney on our 1925 four-square and replaced about a dozen spalled bricks near the top. Honest about what could wait and what couldn't. Just wish the scheduling had been tighter.",
          "name": "Harriet L.",
          "date": "2025-04-11",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Very pleased. Air ducts and dryer vent done in the same appointment, which made coordinating around work way easier. The before/after photos of the return vents sealed it for me, that was a lot of debris. Friendly and on time.",
          "name": "Aisha K.",
          "date": "2026-02-18",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Good repair work on a cracked crown and rusted cap that had been leaking into our attic. Only knock is the arrival window was pretty wide and I waited most of the morning. Once they showed, though, the crown patch and new stainless cap were done quickly and the waterproofing sealed up the leak. Fair price.",
          "name": "Harold B.",
          "date": "2023-10-28",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "The lint trap and full duct run got cleaned out, and not one fuzz ball landed on my laundry room floor. They taped plastic around the connection point so nothing scattered. Wiped the top of the dryer afterward too. Tidy and thorough.",
          "name": "Camille D.",
          "date": "2025-08-02",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Family-owned outfit that clearly knows chimneys. We needed a pre-sale report to disclose to potential buyers and Eli went above and beyond, photographing the crown, cap, and smoke chamber. The report read like something an engineer would produce. Buyers had zero questions after seeing it.",
          "name": "Lillian A.",
          "date": "2025-10-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My newborn's nursery is right above the furnace, so indoor air quality became a real priority. BHO did a meticulous job on every duct run, used a camera so I could see the dust before and after, and didn't track a speck of dirt in. Maureen even followed up a week later to ask how the air felt. That kind of care is rare.",
          "name": "Nadia F.",
          "date": "2025-12-05",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Honestly thought we'd have to live with the smoke smell forever. Turns out a cracked smoke shelf and a poorly sealing damper were the culprits. The crew did a full inspection, gave me a written report, and handled the masonry patch and damper fix. No more odor when the AC kicks on.",
          "name": "Camille D.",
          "date": "2024-06-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Allergies were brutal and the house had a perpetual musty edge to it. Victor cleaned all the supply and return runs, replaced the filter, and fogged the system with a sanitizer. Within a day the air felt fresher and my sneezing dropped off noticeably. Professional from start to finish.",
          "name": "Camille O.",
          "date": "2026-03-28",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Excellent service from start to finish. Maureen scheduled us quickly and the technician arrived right on time. He cleaned every vent in the house, vacuumed the return runs, and showed me how much dust had collected. My husband's allergy flare-ups have noticeably decreased. We'll have them back annually.",
          "name": "Bridget O.",
          "date": "2026-04-08",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Reliable and professional. Ramon cleaned the wood stove, inspected the liner top to bottom, and gave us a written report. House stays warmer now.",
          "name": "Hugo P.",
          "date": "2023-11-26",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Came in skeptical because a previous air-duct company sprayed some chemical, called it a day, and charged a fortune. BHO actually cleaned every return vent and supply, showed me the debris they pulled out, and the difference in air quality was noticeable within a week. Real work, not theater.",
          "name": "Nikolai P.",
          "date": "2025-07-19",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Respectful and unhurried, exactly what an 80-year-old widow needs. The technician went over the inspection report at my dining table and pointed out the creosote glazing in terms I could follow. Only small thing, the arrival window was four hours wide and I'd have liked it narrower, but he phoned ahead which helped. Very pleased overall.",
          "name": "Vivian S.",
          "date": "2024-08-22",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Snow and ice this winter did a number on our chimney. Luis came out, found the crown had freeze-thaw cracking and the cap was rusted through after years of weather. Replaced the cap with stainless, patched the crown, and confirmed the flashing was sound. He explained how the storm accelerated the damage. Patient and knowledgeable.",
          "name": "Bianca F.",
          "date": "2026-02-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Booked this after smelling a faint burning odor every time the dryer ran. Turns out lint had built up right at the vent flap. Kevin cleared it, tested the airflow, and confirmed the flap opens and closes properly now. The smell is gone and so is my anxiety about it.",
          "name": "Grace H.",
          "date": "2023-09-27",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Solid service and friendly office. The only small thing was the arrival window felt a touch wide at first, but Maureen narrowed it down with a morning call and a reminder text, so it worked out fine. Jordan inspected the chimney crown and cap and walked me through the report. Would use again.",
          "name": "Octavio M.",
          "date": "2023-06-29",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Waterproofing the chimney crown stopped our leak instantly. Dmitri explained the sealant and the warranty. Clean, professional, on time. Couldn't be happier.",
          "name": "Mireille F.",
          "date": "2024-07-25",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Just finished building and brought BHO in for the first duct cleaning. So much drywall dust and sawdust came out of the supply runs it was honestly shocking for a new home. Tech was thorough, sanitized after, and gave me a written report with photos. Highly recommend getting this done before you really start living in the place.",
          "name": "Yuki S.",
          "date": "2026-05-02",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Finished a long kitchen and dining room remodel and the dust just would not settle. The technician cleaned every duct run, replaced our filthy filter, and used a powerful vacuum on the return vents. Showed before and after photos that honestly sold me on the whole thing. The drywall haze is finally gone from the windowsills.",
          "name": "Brigitte N.",
          "date": "2025-11-03",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Fair pricing and total honesty. They cleaned the air ducts and return vents, showed me before and after photos, and never tried to tack on services I didn't ask for. The quoted number was the final number.",
          "name": "Nathan W.",
          "date": "2024-04-15",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Pet odor in the vents was the main reason we called. New-to-us house, previous owners had a couple of cats. The crew was efficient, used shoe covers, and showed us the before/after photos. Smells fresh now.",
          "name": "Lena B.",
          "date": "2025-10-05",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Dryer was tripping its overheat sensor and clothes stayed damp. The technician was thorough, cleared the lint trap cavity and the entire vent line out to the roof cap, and verified airflow before he left. One cycle dries everything now. Genuinely relieved this is fixed.",
          "name": "Curtis H.",
          "date": "2026-04-22",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "We just bought a cabin-style home with a big wood-burning stove and were completely clueless about upkeep. Felix spent extra time explaining the difference between the flue liner and the chimney itself, how often we should sweep based on how much we burn, and what warning signs to watch for. He removed years of buildup and the stove drafts so much better now. The before and after photos really drove home why this matters. Top-notch for first-timers like us.",
          "name": "Aaron D.",
          "date": "2025-11-18",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Money's tight this year so the $69 special was the only reason I booked. Glad I did. Technician was respectful, wore shoe covers, and explained the creosote levels in plain English instead of trying to upsell me into a chimney rebuild.",
          "name": "Sofia L.",
          "date": "2024-11-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Three homes, same chimney company. Whenever we move, BHO is the first call. Sam handled this round's creosote removal and replaced a worn damper that was sticking. Fast, clean, and they actually answer the phone. Fifty years in business shows in how they treat people.",
          "name": "Tobias N.",
          "date": "2026-05-10",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our annual sweep turned into something more involved when the technician noticed water staining on the firebox brick. He traced it to a cracked chimney crown and deteriorating mortar at the top, then climbed up to photograph the damage so I could see it from the ground. Instead of pressuring me, he laid out a plan to handle the sweep and creosote removal now and schedule the masonry repair and waterproofing for a dry stretch of weather. Maureen coordinated the return visit and kept me posted on timing. The repair crew rebuilt the crown and sealed the brick, and the staining hasn't returned since. Throughout both visits they used drop cloths and shoe covers and cleaned every speck of soot. A genuinely trustworthy operation that earned a long term customer.",
          "name": "Yolanda S.",
          "date": "2024-04-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Routine sweep, no surprises, exactly how we like it. The flue was cleared of creosote and the stainless cap got a once-over too. Friendly tech, careful with the drop cloths.",
          "name": "Sofia R.",
          "date": "2024-12-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Recommended by a friend from church who'd had her air ducts done. Decided to try the same service and I'm thrilled. The crew cleaned every return vent in the house and showed me the dust they pulled out of the main duct run. My allergies have actually calmed down since. Maureen made scheduling painless too.",
          "name": "Imani W.",
          "date": "2025-05-06",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Reliable family business. Scheduled a chimney sweep and level-2 inspection prior to a gas-insert conversion. The technician removed years of creosote, checked the damper operation, and confirmed the flue liner was suitable. Clean, courteous, on time.",
          "name": "Rashid F.",
          "date": "2024-12-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We bought an older home and had no idea when the dryer vent was last cleaned. Yuval came out, cleared a frighteningly compacted lint blockage from the run, and discovered the exterior vent flap was missing entirely. He installed a proper metal hood with a built-in animal guard and a working damper flap. He took photos throughout and emailed me a written summary of everything he did. The dryer runs cooler and faster now, and I feel a lot better about the fire risk being gone.",
          "name": "Nora F.",
          "date": "2026-04-19",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Nothing says holidays like a clean, safe fire. Joey checked the flue liner, knocked out the creosote, and waterproofed the exterior masonry that had been soaking up snow melt. He explained everything in plain terms and the report came with before/after photos. Our living room finally feels like the cozy retreat I always pictured for winter evenings.",
          "name": "Yolanda B.",
          "date": "2024-11-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "What stood out was how Patrick explained everything in plain language. He inspected the flue liner, identified some spalling brick on the crown, and gave me a written report with photos and a realistic timeline. No scare tactics. He even put on shoe covers without being asked. Genuinely the best chimney experience I've had.",
          "name": "Theodore M.",
          "date": "2026-03-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Last winter we noticed smoke wasn't drafting right and discovered a huge accumulation of leaves and an old nest blocking the flue. BHO sent someone out fast. He cleared the entire blockage, removed all the debris from the smoke shelf, swept the liner, and installed a new stainless cap with a screen. The written report he left even noted a small crack in the crown to keep an eye on. Honest, thorough, and reasonably priced. Highly recommend this company for anyone with critter problems.",
          "name": "Imani W.",
          "date": "2025-12-01",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Responsive and respectful of my schedule. I work from home and they kept their two-hour arrival window tight so I wasn't stuck waiting all day. The technician swept the flue, cleared creosote, and pointed out a worn damper seal with photos. Honest and fast.",
          "name": "Sofia B.",
          "date": "2024-09-08",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our HOA hired BHO to service the dryer vents in the shared laundry building. The team cleared every vent hood and duct run, vacuumed the lint traps, and finished ahead of schedule. Clean, courteous, and the per-unit reporting made it easy to bill back. Genuinely impressed.",
          "name": "Simone D.",
          "date": "2024-09-30",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Complicated run that goes up from the basement, across the first-floor ceiling, and out the back. Andre traced the whole thing, identified where the lint was collecting at a transition, and cleared it completely. He laid down drop cloths in the basement and vacuumed up after. Strong airflow at the vent hood now and the dryer no longer overheats mid-cycle.",
          "name": "Bianca F.",
          "date": "2026-01-27",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Marco and his helper rebuilt the upper portion of our chimney that had separated from years of water damage. They shored it up, tore down the loose courses, and rebuilt with new brick and crown. Showed me photos of the rusted, broken old liner inside too and recommended a reline, which we'll do next year. No pressure. Drop cloths down the whole time, swept up every speck.",
          "name": "Gregory N.",
          "date": "2024-09-26",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We'd lived here three years and never cleaned the ducts or the dryer vent, so we had both done at once. The technician was upfront that the duct work would take a while and he was right, but he never rushed. Walked the whole house checking each return vent, photographed the worst spots, and went over a written report with me afterward. Shoe covers, drop cloths, the works. Couldn't ask for more.",
          "name": "Lawrence D.",
          "date": "2025-05-30",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Brown water marks on the chimney breast inside the house had me worried about mold. Diego identified a cracked crown and a cap that had blown off in a windstorm. He recapped, repaired the crown, and waterproofed the exterior brick. Tidy with drop cloths inside and a written report afterward. Wall's drying out nicely now.",
          "name": "Nadine F.",
          "date": "2026-04-25",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Shoe covers, drop cloths, the works. Hector treated the place like a museum. He moved our coffee table aside, set out a runner across the rug, and after removing the creosote he vacuumed and wiped until the hearth gleamed. No dust cloud, no mess. Couldn't ask for more.",
          "name": "Bjorn S.",
          "date": "2024-07-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Quick, professional pre-purchase inspection. Found minor creosote and a slightly loose cap, both documented in the written report. Reasonable price and fast turnaround on the paperwork. Helped us close on time.",
          "name": "Omar F.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Severe dust allergies run in my family, so I track our indoor PM readings obsessively. After the full system cleaning the baseline dropped by more than half and has stayed there. The technician explained that the blower wheel was caked and that was a big contributor. Detailed written report came by email the next day.",
          "name": "Vincent H.",
          "date": "2024-07-22",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Quick and effective. Smoky backdraft every windy night, fixed with a new stainless cap and a damper adjustment. Sergei was on time and tidy. Highly recommend.",
          "name": "Owen S.",
          "date": "2025-12-29",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Detected a moldy smell after our humidifier overflowed into the return. They scoped the ducts with a camera, cleaned the affected runs, and sanitized everything. Detailed written report afterward. Reassuring to have it documented.",
          "name": "Hassan E.",
          "date": "2024-09-08",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Newborn at home and we wanted clean air. Mikhail was patient, wore shoe covers, sealed the registers, and ran his equipment through every duct run. The amount of dust pulled out of the returns was alarming for a house this new. Peace of mind for our family and the air feels lighter.",
          "name": "Lorenzo P.",
          "date": "2025-03-19",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Couldn't be happier with the service on our fireplace insert. The crew pulled the unit, swept the chimney, and found the stainless liner had a minor gap at the connection that was hurting our draft. They fixed the seal and the efficiency improvement is obvious, the stove holds heat much longer between loads. Carlos took time to explain how to manage the air intake for a cleaner burn and less creosote. This kind of expertise is exactly what you hope for from a company that's been doing it for half a century.",
          "name": "Yolanda C.",
          "date": "2026-03-15",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Friends warned me chimney sweeps would upsell endlessly. Raj did the opposite, told me my system was in great shape, swept it, and left. No scare tactics about the flue liner, no invented repairs. Refreshing after the company I used before who tried to sell me a whole rebuild.",
          "name": "Imani F.",
          "date": "2024-12-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Couldn't ask for kinder treatment. Devin took his time with my dryer vent, showed me how clogged the lint trap and duct run had gotten, and explained why that was a fire hazard for an old house like mine. He didn't rush a single thing and made sure I understood before he left.",
          "name": "Doris H.",
          "date": "2025-06-30",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Quick storm-damage check after a tree limb came down near the chimney. Cap was dented, crown was fine. Tyler swapped the cap and double-checked the flashing. In and out, very tidy.",
          "name": "Owen D.",
          "date": "2025-07-14",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Outstanding service from start to finish. We have a 30-foot vent run that goes up through the wall and out the roof, and the tech had the right equipment to handle all of it. The lint he extracted from the upper section was packed solid, the kind of thing that starts house fires. Showed me the before and after photos and walked me through keeping it clean between visits.",
          "name": "Nathaniel B.",
          "date": "2025-02-11",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Maureen is the reason this gets five stars from me. She answered every question patiently, sent reminders by both text and email, and rebooked me when a storm rolled in without any drama. The crew laid drop cloths, swept the flue, and emailed photos. Communication was genuinely top-notch.",
          "name": "Delphine A.",
          "date": "2026-03-20",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Lint trap and full vent run cleared in 40 minutes. Tech was tidy and showed me the airflow improvement. Solid dryer service at a fair price.",
          "name": "Omar S.",
          "date": "2025-10-02",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "New construction dryer vent done right. Omar found that the builder had left the exterior vent hood flap stuck and the duct run had construction dust inside. He cleaned it all and made sure the flap moved freely. Dryer times dropped noticeably. Easy scheduling with Maureen too.",
          "name": "Rashida F.",
          "date": "2025-02-16",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "After three months of contractors sanding drywall in our place, the air was unbreathable. BHO did a complete duct cleaning, supplies and returns, and even cleaned the blower compartment where sawdust had collected. The written report listed everything they did. My wife stopped sneezing the very next morning. Couldn't ask for a better outcome.",
          "name": "Cyrus A.",
          "date": "2024-09-27",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Couldn't be happier with how upfront this company is. I expected the usual bait-and-switch where the cheap inspection turns into a four-figure repair pitch. Instead Nikolai ran the camera through the flue, said everything looked healthy, swept out the creosote, and charged me the estimate I was given. No pressure, no scare tactics, just honest work from people who clearly take pride in their reputation.",
          "name": "Carmen D.",
          "date": "2026-01-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After buying our place we noticed a constant doggy smell whenever the heat ran. Turns out the prior owners had three of them. BHO did a complete air-duct cleaning, vacuumed out every supply and return, and changed the filter. The technician was friendly and answered all my questions about how often we should redo it. The written report was a nice touch and the price was fair.",
          "name": "Gregory P.",
          "date": "2024-12-03",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Scheduling was easy and the price was fair. My main complaint, if you can call it that, was the four-hour arrival window which made planning my day tricky. Once Eli arrived he was excellent though, cleared the lint-packed duct run that was making the dryer overheat, and got us back to one-cycle drying. Still very satisfied overall.",
          "name": "Annika S.",
          "date": "2024-09-05",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Inherited a fireplace with our new house and frankly didn't trust it. The inspection put my mind at ease. Tech checked the damper, the liner, and the crown, then sat with me to go over the written report. Patient with all my rookie questions.",
          "name": "Lucia G.",
          "date": "2023-11-29",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Was bracing for an expensive lecture about everything wrong with my chimney. Instead Victor did the $69 inspection, said the liner and cap looked great for the age of the house, and only recommended a basic sweep. Honest people, fair prices.",
          "name": "Garrett W.",
          "date": "2023-12-04",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Coming up on our fifth annual visit. The fireplace cleaning was meticulous and Ramon pointed out some glazed creosote we hadn't noticed building near the top of the flue. He removed it carefully and explained how to burn drier wood to slow it down. Genuinely helpful every time.",
          "name": "Geneva P.",
          "date": "2023-11-29",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Scheduling was simple and the office confirmed my sixty nine dollar inspection price upfront. The technician arrived prepared, spread drop cloths across the living room floor, and got to work on a full camera inspection of the flue. He pointed out a thin creosote layer and a stainless cap that had started to corrode at the base. We discussed replacing the cap and he gave me a fair quote without any pressure to decide on the spot. The sweep itself was quick and remarkably clean. He emailed a thorough written report with labeled photos that same evening. The only small thing was that the visit ran about thirty minutes past the window, though he texted to let me know he was running behind. Professional, honest, and clearly experienced.",
          "name": "Reginald A.",
          "date": "2026-02-15",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "My wife and I have had our chimney cleaned here every single year for over a decade. Luis is usually the one who comes out, and he's meticulous, brushing the entire flue, removing the creosote, and checking the damper operates freely. He even noticed our smoke shelf needed a better clearing this year and took care of it without charging extra. The kind of small family company that earns loyalty by doing right by you every visit.",
          "name": "Eleanor W.",
          "date": "2025-10-27",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Heard about them from the guy who mows my lawn, of all people. He'd used them for a dryer vent cleaning. Mine was packed solid with lint, a real fire hazard apparently. Kevin cleared the whole run from the lint trap to the exterior vent hood and my dryer dries a load in one cycle now instead of three. Wish I'd called sooner.",
          "name": "Frederick N.",
          "date": "2024-10-30",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Arrival window was a bit wide, they told me 8 to noon and showed at 11:45, but once Jordan arrived the work was excellent. Full creosote removal, smoke shelf cleaned, and a level-2 camera inspection ahead of our gas-log install. The written report was thorough. Just wish the window were tighter.",
          "name": "Helena T.",
          "date": "2025-04-22",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Good thorough cleaning of our duct run plus a new exterior hood with a pest screen, which we needed after a bird nest blocked the old one. The arrival window was pretty wide, almost four hours, so I had to rearrange my morning. But once the tech showed up he was efficient and the work was clean. Dryer performance improved right away.",
          "name": "Eli S.",
          "date": "2024-02-14",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Just wanted a working fireplace for Thanksgiving and got exactly that. Fast sweep, honest inspection, new stainless cap. The room is so cozy now we use it every night.",
          "name": "Ravi M.",
          "date": "2025-11-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Friendly service from Dmitri, who swept the chimney and removed a season's worth of creosote in under an hour. He showed me the camera footage of the liner and confirmed the cap was in good shape. Quick, clean, and reasonably priced.",
          "name": "Aria S.",
          "date": "2024-11-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Birds had been getting into our chimney for two seasons and finally we'd had enough. The technician removed the nesting material, cleaned the flue, and put on a stainless cap with screen. Professional and friendly. The arrival window was a bit wide and I had to wait most of the morning, but once he showed up the work itself was excellent and well worth it.",
          "name": "Gregorio S.",
          "date": "2024-03-28",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "My air ducts hadn't been touched in years and the allergies were getting bad. Called Friday, they came Monday morning right on schedule. Cleaned every return vent and the supply runs, showed me the before and after photos of the dust they pulled out. Honestly shocked by how much came out. The crew worked clean, laid down drop cloths in the hallway, and finished within the estimated time. Booking was painless thanks to Maureen who walked me through the whole process. A genuinely fast and well-run outfit.",
          "name": "Nathaniel G.",
          "date": "2025-12-01",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Good service for my triplex dryer vents. The cleaning itself was thorough and the lint they pulled out was impressive. Only small gripe was the arrival window was a bit wide and I waited longer than I'd hoped, but the tech apologized and did excellent work once on site.",
          "name": "Caleb O.",
          "date": "2023-11-22",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Crawlspace duct run, maybe 30 feet with several joints. Felix crawled it end to end and resealed two loose connections that were leaking lint into the crawlspace. Spotless work and a fair quote up front.",
          "name": "Hassan D.",
          "date": "2024-04-18",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Our 1890s rowhouse shares a party wall and the chimney masonry was deteriorating. BHO was careful and methodical, repointing the deteriorated joints and rebuilding the cap. They coordinated with our neighbor since it's a shared structure. Really thoughtful crew.",
          "name": "Imani T.",
          "date": "2025-11-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Quick and painless. Sam did the dryer vent and air ducts in one visit, cleared a serious lint clog from the vent run, and was out within a couple hours. Dryer is back to drying in a single cycle.",
          "name": "Bianca T.",
          "date": "2024-09-04",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Fifty-plus years in business shows. The guy who came out diagnosed our leak in about ten minutes: spalled crown plus a missing cap. Rebuilt the crown, fitted stainless, sealed the masonry, gone in a few hours. No mess left behind.",
          "name": "Curtis O.",
          "date": "2024-05-09",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "I have light gray carpet and was nervous. They covered a wide path with drop cloths and put booties over their boots. After the chimney sweep and inspection, the technician ran a vacuum over the carpet edge just in case. Honestly cleaner than before he came in.",
          "name": "Lorraine F.",
          "date": "2026-01-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We almost skipped the chimney inspection during our home purchase and I'm so glad we didn't. Yuval discovered a cracked flue liner that wasn't visible from the ground. The written report with camera footage gave us the ammunition to renegotiate before closing. Saved us thousands down the road. Genuinely grateful for the thoroughness and the clear, jargon-free explanation he gave my husband and me.",
          "name": "Genevieve W.",
          "date": "2025-05-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Five stars for both the work and the education. Joey didn't just clean the ducts, he showed me which return vents were leaking unfiltered attic air and recommended a sealing fix. My allergy symptoms eased almost immediately and the house holds temperature better. Genuinely health-focused service, not a sales pitch.",
          "name": "Lorena P.",
          "date": "2026-04-08",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "We'd been blaming the wood for the smoke that kept coming back into the family room. Patrick showed me it was actually creosote glazing in the flue plus a damper that only opened halfway. He removed the buildup, freed the damper, and the difference was immediate. Fires draw clean now and the house doesn't reek the next morning.",
          "name": "Nadia P.",
          "date": "2026-04-02",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Honestly impressed. The technician walked the whole system before touching anything, pointed out where moisture had let some mildew set in near a duct run in the crawlspace, and laid out exactly what the sanitizing fog would and wouldn't do. No pressure, no scare tactics. Cleaned it all, treated it, and the musty smell that had bugged us for over a year is finally gone. These folks know what they're doing.",
          "name": "Brigitte S.",
          "date": "2025-12-02",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "My allergies were out of control and I suspected the ducts. The team confirmed it. Heavy dust and dander throughout the supply lines. They cleaned everything methodically, vacuumed each return vent, and gave me before/after photos. A small note: the arrival window was pretty wide, but once they arrived the work was first rate.",
          "name": "Annika W.",
          "date": "2024-05-22",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Solid cleaning of our wood stove flue. The technician removed a fair amount of creosote and pointed out that our chimney crown had a hairline crack to watch. Slight ding is that the callback to confirm my appointment came a day late, but once they were here the work was excellent and the stove burns noticeably cleaner.",
          "name": "Frederick W.",
          "date": "2024-05-02",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "We compared three quotes. The first two felt like used-car sales pitches. BHO was straightforward, did a proper $69 inspection, and only recommended the creosote removal we genuinely needed. Andre was patient with all my questions about the chimney crown. Easy choice in the end.",
          "name": "Lorenzo D.",
          "date": "2023-10-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Marvelous people. As someone who'll be 80 this fall, I value patience above all, and the young man delivered. He scoped the chimney, found minor masonry cracking near the crown, and carefully explained whether it needed attention now or could wait. No scare tactics. He laid drop cloths and wore shoe covers the whole time. The written estimate was clear and itemized, and he never once made me feel like a bother for asking him to slow down and repeat himself.",
          "name": "Clifford N.",
          "date": "2025-10-11",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "We had a microburst tear through the neighborhood and I was certain our chimney was compromised. Maureen scheduled an inspection right away. The technician examined the crown, the stainless cap, and every inch of flashing, then handed me a written report showing everything checked out except a small crown chip he sealed. Honest folks who could have invented problems but didn't. That kind of integrity earns repeat business.",
          "name": "Renata C.",
          "date": "2024-06-03",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "A family-owned outfit that clearly takes pride in the work. They cleaned out a vent that hadn't been touched in over a decade, and the amount of lint was genuinely scary. Marco explained the fire risk without any pressure or upselling, just facts. Dryer runs cooler and quicker now.",
          "name": "Sofia L.",
          "date": "2024-05-20",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Scheduling my dryer vent cleaning took about three minutes. Maureen confirmed the address, texted a reminder, and the tech cleared a packed lint trap and the full duct run out to the exterior vent hood. Office follow-up call afterward was a nice touch. Easy, friendly, and well organized.",
          "name": "Roosevelt C.",
          "date": "2025-10-08",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Sweep and inspection done with zero mess. Drop cloths everywhere, shoe covers on. Diego is a true craftsman. This crew earns repeat business.",
          "name": "Bethany A.",
          "date": "2024-02-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Got the air ducts cleaned in our newly built home about a month after closing. There was fine construction powder coating the inside of nearly every register. Hector vacuumed each run, brushed the trunk lines, and showed me the camera footage. The house smells fresher and the HVAC isn't kicking that dust around anymore.",
          "name": "Bjorn H.",
          "date": "2024-10-21",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "We did a big garage-to-living-space conversion and the duct system was packed with construction dust. Sergei arrived on time, laid down drop cloths, and worked through every vent methodically. The amount of sawdust he pulled out filled most of a contractor bag. Clean air again, and the dusting marathon is over.",
          "name": "Lila F.",
          "date": "2026-02-14",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Trustworthy and reasonably priced. Got a clear quote, the work matched it, and the report on the damper and smoke shelf was easy to understand.",
          "name": "Isaiah B.",
          "date": "2023-11-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Moved into a home that reeked of old cigarette smoke. You could see the residue around the supply vents. Mikhail and the team cleaned the entire duct system and the difference was huge by that evening. They protected the floors with drop cloths and cleaned up after themselves. Very satisfied with this family-owned outfit.",
          "name": "Nadia F.",
          "date": "2025-08-26",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Three cycles for a load of jeans was the last straw. Carlos pulled apart the vent, found the run nearly choked with lint, and cleaned it all the way to the exterior vent hood. He showed me photos before and after. Now everything dries in one go and the dryer cabinet no longer gets uncomfortably hot. Top-notch service.",
          "name": "Demetrius F.",
          "date": "2025-02-28",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "As a new wood-stove owner I appreciated how much they taught me. Raj explained creosote removal, why glazed creosote is dangerous, and how to burn cleaner going forward. Swept everything, left no mess thanks to the drop cloths. Reasonable price too.",
          "name": "Nathaniel O.",
          "date": "2025-05-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "What a value. For sixty-nine dollars I got a proper inspection, photos, and a written summary I could actually understand. The damper was sticking and they oiled it without charging extra. I expected nickel-and-diming and got the opposite.",
          "name": "Esperanza R.",
          "date": "2025-03-27",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Have used BHO for the chimney for years, so when our dryer started running hot I called them for the vent. They cleared a packed lint trap line and a clogged duct run behind the wall. House feels safer now. Loyalty earned across multiple services.",
          "name": "Hollis B.",
          "date": "2025-08-21",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "We inherited my grandmother's house and the chimney hadn't been touched in over a decade. I was honestly afraid of what they'd find. The technician was incredibly patient, explaining each step as he inspected the flue liner, damper, and crown. There was significant creosote buildup along with some loose mortar joints near the top. He prioritized the cleaning for safety, did a complete creosote removal, then walked me through which repairs were urgent versus which could wait. The before and after photos in the written report were eye opening. What I valued most was that he never made me feel rushed or talked down to, even when I asked a lot of basic questions. Booking the follow up masonry work through Maureen was painless. This family company turned a stressful situation into a manageable one.",
          "name": "Imani O.",
          "date": "2023-03-21",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Standard annual cleaning. Creosote removed, hearth left tidy, in and out within the hour. Solid value for a service we count on every season.",
          "name": "Theo L.",
          "date": "2024-03-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "A neighbor two doors down couldn't stop talking about how clean BHO left her fireplace, so I booked. The technician was meticulous, brushing out creosote and vacuuming the firebox until it looked new. Drop cloths everywhere, shoe covers on. This is a family-owned outfit and it shows in how much they care.",
          "name": "Lucia D.",
          "date": "2025-07-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Prepping for a gas insert and these folks made it easy. Devin laid drop cloths, swept the flue, scrubbed the firebox, and ran the camera up to document the liner condition. Report had clear photos. The hearth looked brand new when he left.",
          "name": "Quentin S.",
          "date": "2024-07-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Couldn't be happier. The technician removed an enormous amount of lint, replaced the crushed foil transition hose with rigid duct, and installed a new exterior vent hood with a rodent guard. He explained everything in plain terms and left the laundry area spotless.",
          "name": "Carmen V.",
          "date": "2025-03-28",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Prepping for a houseful of grandkids over Christmas break, I needed the chimney sorted. The technician removed a surprising amount of creosote, adjusted the damper, and showed me the clean flue afterward. Slight ding is the arrival window was four hours wide and I sat around most of the morning waiting. Once they showed up though, the work was excellent and the den is wonderfully warm now.",
          "name": "Constance D.",
          "date": "2024-12-05",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Outstanding job by Tyler on a tricky masonry repair. The chimney crown had cracked and water was seeping into the firebox. He rebuilt the crown, sealed it, and waterproofed the exterior, walking me through each phase. Three weeks later and it's bone dry through two storms. He clearly knows his trade and respects your property, drop cloths everywhere.",
          "name": "Lena V.",
          "date": "2025-10-28",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What a relief. A squirrel had nested in our flue and the smell was getting bad. Omar removed everything humanely, sanitized and cleared the debris, swept the chimney, and installed a new stainless steel cap with a screen so it can't happen again. He explained the whole process clearly and the price was exactly what was quoted. No surprises.",
          "name": "Beatriz O.",
          "date": "2025-05-16",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Quick turnaround when I needed it most. A guest was coming for the holidays and I wanted the fireplace usable. They had same-day availability, swept it clean, removed the creosote, and confirmed the cap and crown were solid. Showed up right on time too.",
          "name": "Imani P.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Property manager here. Across the 16 units I oversee, BHO cleaned every dryer vent run, replaced two flimsy vinyl transition hoses with rigid metal, and gave me a tidy report per unit. Tenants stopped complaining about damp clothes. The crew treated each apartment respectfully with drop cloths down.",
          "name": "Yolanda P.",
          "date": "2026-03-14",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Stacked washer-dryer in a second-floor hall closet, venting up and out the roof. I assumed it was a lost cause because the run is so long and tight, but Nikolai got his brush all the way to the termination and pulled out years of packed lint. He capped the run with a new pest-resistant vent hood at my request. The difference in drying time is night and day. Truly knowledgeable about tough configurations.",
          "name": "Rosalind W.",
          "date": "2025-06-09",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "The brick veneer around our firebox opening had cracked and a few pieces were loose. Eli reset the masonry, repointed the firebrick joints inside the firebox with refractory mortar, and explained the difference between regular mortar and the high-heat stuff. Clean, knowledgeable, and they wore shoe covers in the house the entire visit.",
          "name": "Lars E.",
          "date": "2024-12-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Booking both services for the same day was the right call. Victor arrived right on time, covered the floors, and methodically cleaned every supply and return vent in the house. He even noticed our dryer vent hood flap was stuck open and replaced it so critters can't get in. The written report he handed over was detailed and easy to understand. Real pros, fifty years of doing this clearly shows.",
          "name": "Emeka O.",
          "date": "2025-10-19",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Every heavy rain we'd get a drip near the flue and it was driving us crazy. BHO found the crown was cracked all the way through and the cap was rusted so badly the mesh had fallen out. They poured a new crown with a proper overhang, set a stainless cap, and applied a clear waterproofing treatment to the brick. Methodical and respectful of our home, shoe covers and all.",
          "name": "Yelena Z.",
          "date": "2025-02-22",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "The arrival window was a bit wide, but once Ramon got here he was meticulous. Drop cloths down, shoe covers on, furniture nudged clear of the firebox. He removed the creosote and left the hearth spotless. A small heads-up call would've helped, otherwise excellent.",
          "name": "Devin O.",
          "date": "2023-12-28",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Listing agent recommended I get ahead of any chimney issues before putting our place on the market. The crew inspected the masonry, checked the crown for cracks, and verified the damper sealed properly. The written report became part of our disclosure packet. Smart move that made the sale go smoother.",
          "name": "Theo G.",
          "date": "2024-08-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We adopted two cats and the dander was overwhelming the air. A friend recommended BHO. They cleaned all the supply and return runs, the dust and hair pulled out filled most of a bag, and they treated the system with an antimicrobial after asking my permission. Breathing is noticeably easier. Shoe covers and drop cloths the whole time.",
          "name": "Desmond C.",
          "date": "2025-06-17",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "The arrival window was on the wide side, roughly four hours, which made my morning tricky. That said, once the tech showed up he was excellent. Diagnosed a downdraft caused by a missing chimney cap and a loose damper, fixed both, and the smoke smell is gone. Would still use them again.",
          "name": "Bradley H.",
          "date": "2024-08-12",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Stale, closed-up smell in our rental was driving the tenants crazy. Luis and a helper cleaned every register, vacuumed the trunk line, and applied an antimicrobial sanitizer. Tenants say the place smells fresh now. Booking through Maureen was painless.",
          "name": "Conor W.",
          "date": "2026-04-15",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Wiping dust off furniture daily got old fast. Kevin inspected the system, found years of buildup in the main trunk, and cleaned every vent with care. Drop cloths down the whole time. The reduction in airborne dust is real and my eyes aren't itchy in the mornings anymore.",
          "name": "Soren H.",
          "date": "2025-10-07",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Excellent visit. They cleaned the insert, checked the liner for creosote glaze, and gave me a rundown on burning efficiency that actually made sense. No mess thanks to the shoe covers and drop cloths. Booking through Maureen was painless.",
          "name": "Simone A.",
          "date": "2025-04-21",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "My neighbor's sweep left her with a cracked damper and no explanation, so I was nervous. BHO was the opposite. Careful drop cloths, shoe covers, a real camera inspection, and a clear written report. They earned my trust and my neighbor switched to them after seeing the work.",
          "name": "Beatrice O.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Such gentle souls. My wife and I are both in our late seventies and we worry about being oversold. Jordan looked over the chimney, showed us the stainless cap was still solid, and told us honestly the sweep could wait another season. Who tells you that? Trustworthy.",
          "name": "Bernard A.",
          "date": "2024-05-07",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Rain was finding its way in after a brutal storm season. Dmitri diagnosed lifted flashing and a worn crown, did the repairs, and applied waterproofing to the masonry. He showed me before/after photos that made the difference obvious. The leak is gone. Fair price for quality work.",
          "name": "Julian S.",
          "date": "2025-01-26",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Good honest work and a fair price. The lint they pulled from our duct could have filled a pillow, and the dryer dries in half the time now. Only small thing was a callback delay when I had a follow-up question, took a couple days to hear back. The cleaning itself was excellent and I feel a lot safer.",
          "name": "Damon F.",
          "date": "2026-05-09",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "The communication here is what sets them apart. Maureen called to confirm, texted the night before, and the tech phoned when he was on the way. Inspection of the flue and damper was thorough and the written report came through by email the same day. Couldn't ask for a smoother experience.",
          "name": "Yasmin E.",
          "date": "2024-07-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Stellar service from start to finish. Maureen booked us fast and Felix cleared a stubborn creosote glaze from the flue. Spotless cleanup. Genuinely impressed.",
          "name": "Grant H.",
          "date": "2025-05-11",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We were the first owners of this house and never trusted that the ducts were clean from the build. Glad we called. The team found plenty of debris in the return vents and a stray chunk of foam insulation in one supply line. Drop cloths everywhere, very respectful of the new floors. Written report came by email same day.",
          "name": "Carmela D.",
          "date": "2023-09-08",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Solid job cleaning the ducts after our remodel left drywall dust in every register. The work itself was great and they got out a ton of sanding grit. Only gripe is the arrival window was pretty wide, a four-hour block, so I lost most of a morning waiting. Still glad I called.",
          "name": "Grant D.",
          "date": "2025-07-19",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Refreshingly honest outfit. Sam inspected the chimney, found the stainless cap was loose, and told me he could secure it for a small fee rather than pushing a full replacement. The whole visit, sweep included, came in under what I'd budgeted. He laid drop cloths everywhere and left no mess. The transparency is what earns repeat business, and I'll be calling them every year.",
          "name": "Yolanda F.",
          "date": "2025-05-30",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Quick and painless. Previous owner had a dog, our daughter has allergies, so cleaning the ducts was a no-brainer before we settled in. Tech was on time, knocked out every vent, showed me the photos. Air smells clean.",
          "name": "Oscar D.",
          "date": "2024-06-14",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Quick and effective. Dryer was overheating and shutting down, clothes never fully drying. They cleared the duct and lint trap area, and now it runs cool and dries in one cycle.",
          "name": "Bianca L.",
          "date": "2024-12-14",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Bought our first home in the fall and the fireplace was a total mystery to me. The technician was kind and thorough, walked me through the smoke shelf and damper, and showed photos of the flue before and after the sweep. My only small note is the arrival window was pretty wide and I ended up waiting a couple hours, but the actual service was excellent and educational. Would use again now that we know to do this every year.",
          "name": "Renata S.",
          "date": "2024-10-16",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Good honest work at a price that didn't make me wince. The $69 inspection covered the flue, crown, and cap, and the tech swept out the firebox while he was here. No pressure, no nonsense.",
          "name": "Nikolai F.",
          "date": "2024-07-18",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Reliable as the seasons. Four winters running, BHO sweeps our chimney, checks the flue liner, and leaves the hearth cleaner than they found it. Yuval is courteous and the $69 inspection price has stayed honest. A rare company that earns repeat business the right way.",
          "name": "Soledad V.",
          "date": "2024-02-06",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Having heated with wood for fifteen years, I know a thorough sweep when I see one, and Joey delivered. He arrived on time, set up drop cloths and a vacuum at the hearth, and ran the brush through methodically rather than rushing. The creosote he pulled out was substantial and he showed me the difference between the powdery first degree and the glazed buildup near the cap. He inspected the stainless liner with a camera and confirmed it was still in great shape. We talked about wood seasoning and stack temperature for a good ten minutes, real practical advice from someone who clearly knows the trade. The written report confirmed everything visually. No upsell, no nonsense, just a clean flue and good information. I've already recommended them to two neighbors who burn wood.",
          "name": "Garrett P.",
          "date": "2025-10-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Another year, another spotless sweep. Patrick cleared the creosote, inspected the flue, and showed me before/after photos so I could see the difference. Easy to schedule, no nonsense.",
          "name": "Bianca G.",
          "date": "2025-01-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "My uncle has used these folks for years and finally convinced me. Worth it. Thorough inspection, written report, and a clear explanation of the flue liner condition. No surprises on the bill.",
          "name": "Anthony G.",
          "date": "2024-04-03",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Five decades of experience really shows. Andre handled our pre-conversion cleaning and level-2 inspection, removing glazed creosote that a previous company had apparently missed. He pointed out a cracked flue tile on the camera feed and walked me through repair options before we put gas logs in. Felt like dealing with true professionals, not a sales pitch.",
          "name": "Naomi C.",
          "date": "2025-12-29",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Reached out after our clothes kept coming out damp. Marco identified a heavily clogged duct and a failed exterior flap that animals had been using. He cleaned the whole run, then mounted a new louvered hood with a screen guard and sealed it properly. He was upfront about the cost before starting any work. Very satisfied with how quiet and fast the dryer is now.",
          "name": "Bryce L.",
          "date": "2023-06-30",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Our hearth is the heart of the home this season. Diego did a meticulous sweep, replaced the cap, and pointed out a hairline crack in the crown he sealed on the spot. The whole crew was friendly and the place smelled wonderful with the first fire going. Felt like a holiday card.",
          "name": "Felipe A.",
          "date": "2025-12-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Hector came out for a routine sweep and ended up catching a damper that wasn't sealing, which was driving up our heating bill. He adjusted it and cleaned the smoke shelf, then gave me a written report. Professional and personable. I'll be requesting him next year.",
          "name": "Omar J.",
          "date": "2024-02-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Top-notch from the first phone call. Maureen was warm and helpful scheduling, and the tech who came out cleared a packed bird nest from the flue, vacuumed the smoke shelf, and capped the chimney with a stainless cap and integrated screen. He showed me before and after photos so I could see the difference. Genuinely good people and great craftsmanship.",
          "name": "Frederick A.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Fast, friendly, on the dot. Sergei texted when he was fifteen minutes out, arrived within the window, and had the chimney swept and inspected before I finished my coffee. Written report in hand. Smooth experience.",
          "name": "Owen H.",
          "date": "2025-05-20",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Landlord of a four-unit Victorian with tricky long duct runs to the roof. The tech assessed each one, brushed and vacuumed the full length, and cleared a bird's nest from one rooftop vent hood. Showed me before/after photos and explained the airflow improvement. Booked the whole building for annual service.",
          "name": "Felix A.",
          "date": "2024-12-05",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Long roof run on our townhouse. The tech was careful on the ladder and cleared the cap and the upper section of duct where lint had compacted. Wore shoe covers inside. Took a little coordinating between the roof and the dryer but they handled it well.",
          "name": "Tobias E.",
          "date": "2023-03-14",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Fifty years in business shows. The mason on our crew clearly had decades of experience pointing old brick. Our chimney is from 1915 and the soft historic brick needs gentle handling, not aggressive grinding. He hand-raked the joints to protect the brick faces. Beautiful result.",
          "name": "Yolanda F.",
          "date": "2025-01-30",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Solid service overall. Had the dryer vent and ducts cleaned together. The lint they removed from the trap housing and the run was alarming. One small note, the callback to confirm my appointment came a day later than promised, but the actual work was great and the tech was friendly.",
          "name": "Sondra P.",
          "date": "2024-12-12",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Spotted rust streaks running down my white siding and figured the chimney cap was failing. Mikhail confirmed it, plus a crown crack I had no idea about. He replaced the cap with stainless steel, patched and sealed the crown, and waterproofed the whole stack. Streaks are gone and the brick beads water like new now.",
          "name": "Garrett L.",
          "date": "2023-07-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Such a clean job. They sheeted the mantel decor, protected the wood floor with a runner, and brushed the flue without any soot escaping into the room. The smoke shelf was vacuumed clean and the glass doors wiped. Carlos even dusted the firebox surround before packing up.",
          "name": "Naomi W.",
          "date": "2025-03-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Booking the pre-sale inspection was easy and Maureen was lovely on the phone. The technician was thorough with the flue camera and pointed out where the previous owner had patched the crown. Report was emailed promptly. One small thing, the callback after I had a follow-up question took a couple days, but the info was worth the wait.",
          "name": "Saanvi D.",
          "date": "2023-11-27",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Phenomenal results for anyone with respiratory issues. My teenage daughter's exercise-induced asthma was worse indoors than out, which baffled us. The before/after photos of our duct runs explained why. Post-cleaning her peak-flow numbers improved and she sleeps through the night now. The crew was punctual, gloved, and careful.",
          "name": "Beatrice N.",
          "date": "2024-12-19",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Smoke smell every time the furnace ran. The team explained how stack effect was pulling fireplace odors through the house and traced it to a damper that wouldn't fully close. They sealed it properly and added a top-sealing damper. Very knowledgeable, walked me through everything.",
          "name": "Imani L.",
          "date": "2025-05-27",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Five stars for the musty-odor cleanup. They sanitized all the ducts and even the return vents I didn't know got that dirty. Fresh-smelling house now.",
          "name": "Yolanda P.",
          "date": "2024-02-26",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "This family-owned outfit took great care of us. After years of unexplained congestion, the duct cleaning revealed mold-flecked dust in the return vents. They cleaned and sanitized thoroughly and recommended a better filter. My chronic sinus pressure has eased considerably. Genuinely grateful for the difference it made.",
          "name": "Yolanda F.",
          "date": "2024-09-14",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "We have a freestanding wood stove that hadn't been serviced since we moved in. Raj arrived, laid down drop cloths, and got to work removing a startling amount of creosote from the single-wall connector and the liner above. He showed me photos before and after and they were genuinely shocking. His advice on splitting and drying wood for at least a year before burning has already cut down on the buildup we see on the glass. Couldn't recommend a more thorough team.",
          "name": "Nadia E.",
          "date": "2024-09-12",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Didn't believe the reviews until I saw it myself. The last outfit barely cleaned and left glazed creosote behind. This crew got it all, photographed the smoke shelf before and after, and explained everything. Genuinely the most thorough chimney service I've had in twenty years of owning this house.",
          "name": "Quentin L.",
          "date": "2024-04-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "After my fall last year my family insisted I stop climbing ladders, so I had these folks check the chimney. The technician was so patient explaining the creosote removal and showed me everything on a screen so I didn't have to go outside. Wore shoe covers, cleaned up beautifully. A genuine comfort.",
          "name": "Lorraine F.",
          "date": "2025-12-18",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Concerned after the spring storms, I booked a check on the crown and cap. The tech was thorough, even pointed out where the flashing sealant was beginning to age though not yet failing. He resealed it preventively and explained why it mattered. Appreciated the long view rather than just a quick patch.",
          "name": "Meredith A.",
          "date": "2024-05-21",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Our dryer kept tripping the thermal cutoff and a repair guy told us the vent was probably blocked. He was right. The tech here cleared a thick wall of lint deep in the duct run and the machine has worked flawlessly since. Quick, clean, and the safety angle alone made it worth it.",
          "name": "Imani C.",
          "date": "2024-10-14",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Pleasantly surprised by how organized the office is for a 50-plus year family operation. Maureen booked me quickly, sent a clear reminder, and even noted my gate code so the tech wasn't stuck outside. Creosote removal and a quick cap check, all explained clearly. Great communication.",
          "name": "Constantine F.",
          "date": "2023-04-05",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Smoke shelf was loaded with debris. They cleaned it out and snapped before and after photos. Quick, friendly, and honest pricing. Will call again.",
          "name": "Liana P.",
          "date": "2026-03-27",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Fresh build, dryer vent had never been touched. The tech cleared leftover lint and a bit of construction dust from the duct run, then confirmed strong airflow at the exterior hood. Fast, clean, and he wore shoe covers the whole time on our new flooring.",
          "name": "Tobias E.",
          "date": "2026-04-11",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Air duct cleaning after our second-floor renovation. They got the sawdust and drywall film out and the air feels fresher. One small thing, the callback to confirm my appointment came a day later than promised, but Maureen apologized and the techs more than made up for it with careful, thorough work and drop cloths everywhere.",
          "name": "Yasmin O.",
          "date": "2023-12-05",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Estimate was clear and the price was very fair compared to two other quotes I got. They removed creosote, checked the flue liner, and gave me a written report. Slight callback delay when I phoned with a follow-up question, took a day to hear back, but Maureen was apologetic and helpful once we connected. Honest company, no upselling whatsoever.",
          "name": "Trevor A.",
          "date": "2024-10-07",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Cannot say enough good things. We bought a house from a long-time smoker and the air felt heavy from day one. BHO sent out a thorough technician who walked the whole system first, sealed the vents, and ran the cleaning through every duct run. He showed us the filthy before photos and the spotless after shots. Maureen in the office was lovely to deal with on scheduling too. The stale smoke smell that lingered for weeks is finally gone and the whole family noticed it the same night.",
          "name": "Yolanda C.",
          "date": "2026-04-21",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Impressed by how methodical the technician was. We'd been running loads two or three times because the dryer just couldn't push the moisture out. He measured airflow before and after, brushed the long duct run that travels through the garage, and removed a thick mat of lint at the elbow joint. Drying time dropped dramatically, single cycle now, and the dryer stays cool. He left the area cleaner than he found it.",
          "name": "Heath W.",
          "date": "2025-10-30",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Never owned a fireplace before this house. Devin came out, cleared the creosote, and gave me a mini lesson on airflow and seasoned wood. Felt like talking to a knowledgeable friend rather than a salesperson.",
          "name": "Kwame A.",
          "date": "2025-02-02",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "I'll admit I chase deals, and the $69 chimney inspection caught my eye. Turned out to be one of the better decisions I've made for the house. The technician spent real time up there, checked the stainless cap and crown, and showed me before/after photos of the creosote he removed. He could've invented a problem to upsell me and didn't. Maureen also followed up to make sure I was happy. As a budget-conscious homeowner I felt genuinely respected, not squeezed.",
          "name": "Wendell O.",
          "date": "2026-01-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Customer for about five years and still happy overall. The sweep and inspection were thorough, and Tyler did a nice job resetting the cap that storms had loosened. Honest feedback: the morning arrival window was fairly wide and I waited a while, but the quality of work keeps me coming back.",
          "name": "Walter E.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Our dryer had been taking two or three cycles to dry a single load and the laundry room would get uncomfortably hot, so I figured the vent was clogged. The BHO technician confirmed it immediately, the duct run from our laundry room to the exterior wall was packed with lint, especially at a bend behind the wall. He pulled out an alarming amount of lint, cleaned the lint trap housing, and checked the exterior vent hood which had a flap stuck shut. He showed me everything he removed in a bag and explained how a blocked vent is a real fire hazard. After the cleaning, the dryer finished a full load in one normal cycle. He laid down a cloth to protect the floor and left the area cleaner than he found it. Wish I'd called them a year ago.",
          "name": "Sofia L.",
          "date": "2024-11-05",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "We get the chimney done every fall before the first fire, and BHO has been our go-to for as long as I can remember. The tech laid drop cloths from the door to the fireplace, swept the full length of the flue, and removed a stubborn band of creosote near the crown. He left a written report and answered all my questions about waterproofing for next time. Couldn't be happier.",
          "name": "Nathaniel P.",
          "date": "2025-11-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "When we moved in, the woman across the street insisted we call BHO before lighting a single fire. Glad we listened. Omar ran a camera up the chimney, found a bird's nest and a ton of creosote, and cleared it all out. He capped the flue with a new stainless cap to keep critters from coming back. The whole visit felt honest and unhurried, and Maureen had followed up the day before to confirm. These are good, dependable people who clearly take pride in their work.",
          "name": "Naomi H.",
          "date": "2025-10-21",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Booked an inspection because we're going from wood to a gas insert. Nikolai did a complete level-2 scope, found the smoke chamber was caked with creosote, and cleaned it down to clean masonry. The stainless cap got cleared of nesting debris too. Email report arrived within hours. Excellent.",
          "name": "Bertrand O.",
          "date": "2026-04-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Maureen scheduled us promptly and the tech arrived as planned. He brushed out the entire duct run, vacuumed the lint trap cavity, and installed a new exterior hood with a built-in pest guard because the old one was wide open. Drying time dropped noticeably. Professional and respectful of the house.",
          "name": "Yolanda C.",
          "date": "2026-05-06",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Cozy nights are back. They cleaned out the firebox, removed creosote, and laid drop cloths everywhere. Got it done a week before the holidays so we could decorate the mantel and enjoy a roaring fire. Reasonable price too.",
          "name": "Hailey K.",
          "date": "2024-12-13",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Really appreciated Eli's attention to detail on the dryer-vent cleaning. He found a partial blockage halfway through the duct run that the previous company missed, cleared it out, and reattached the vent hood properly. The lint trap area is spotless now. He also wore shoe covers indoors. Could not ask for more.",
          "name": "Brigitte L.",
          "date": "2025-06-23",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Debris and an old nest were clogging our flue and causing draft problems. Victor cleared it all out, swept the liner thoroughly, removed the creosote that had built up behind the blockage, and installed a stainless cap with a screen. Clean, courteous, and prompt.",
          "name": "Soledad J.",
          "date": "2023-10-11",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Appreciated how quickly they returned my call and got me on the books for the next day. The only small thing was the arrival window was four hours wide, which is a bit long when you're trying to plan around it. That said, the tech did call ahead, swept the flue thoroughly, cleared the creosote, and the work itself was excellent. Would still use them again.",
          "name": "Gabriela V.",
          "date": "2024-03-12",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Coordinating dryer cleaning across my rental portfolio used to take weeks of phone tag. Maureen scheduled five properties in one week and the crew hit every lint trap and duct run on time. Faster dry cycles reported by tenants. Reasonable rates for multi-unit work too.",
          "name": "Brigitte L.",
          "date": "2025-07-26",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "From the second-floor laundry the duct runs a long way through interior walls before terminating on the roof. Ramon cleaned the entire length, then showed me a photo proving the run was clear. He noted a slightly crushed elbow and gave honest advice rather than upselling. Dryer is far more efficient now.",
          "name": "Felicity O.",
          "date": "2026-04-21",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Partial rebuild above the flashing line on a chimney that had been leaking for years. Water had eaten through the mortar. They tore down to solid masonry, rebuilt, recrowned, and reflashed where it tied into the roof. Written report and a warranty on the work. Worth every penny.",
          "name": "Octavio S.",
          "date": "2023-05-12",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Luis handled our combined air-duct and dryer-vent appointment and I can't say enough good things. He showed me camera footage of the duct run before and after, pointed out where dust had been collecting on the smoke shelf side of the system, and made sure every vent register was reseated properly. Polite, thorough, clean. The house smells fresher already.",
          "name": "Florence U.",
          "date": "2025-04-08",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Quick, knowledgeable, and honest about what actually needed doing. Our leak came from a cracked crown, not the roof like the roofer claimed. The crew sealed the crown, added a new stainless cap, and applied masonry waterproofing. Before-and-after photos confirmed the fix. Very glad I called.",
          "name": "Imani C.",
          "date": "2026-05-12",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Protective coverings went over the furniture nearest each return vent. The crew laid corner guards on the doorways while moving the vacuum hoses. Every register was cleaned and the area mopped where they'd set equipment. No dust on the shelves afterward, which surprised me given how dirty the ducts were.",
          "name": "Esteban G.",
          "date": "2024-05-16",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Relocating across the country and buying sight-unseen, so a trustworthy inspection mattered. Kevin did a video walkthrough of the chimney for me, then sent a detailed written report covering the liner condition, creosote levels, and the stainless cap. Felt like I had eyes on the property even from 2,000 miles away. Exceptional communication throughout.",
          "name": "Roland P.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Air felt stale and heavy every time the heat kicked on. Jordan ran a thorough cleaning of the whole duct system and the negative-air bag told the story by itself. Within a couple days the staleness was gone and my morning headaches with it. Reasonable price and no upsell.",
          "name": "Omar J.",
          "date": "2025-10-11",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Downdraft was so bad it would blow out candles near the hearth. Dmitri assessed the flue and found it was too short for the roofline. He extended it and adjusted the damper. Clean work, drop cloths down, and a clear written report afterward.",
          "name": "Gustavo R.",
          "date": "2024-11-21",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We noticed a damp, basement-y smell circulating through the vents and were worried about mold spores. The team did a complete duct cleaning with negative air, then fogged the system with an EPA-registered sanitizer. They covered floors with drop cloths and wore shoe covers the whole time. Took maybe two and a half hours, and the difference in air quality was immediate. Very respectful of our home.",
          "name": "Mateo G.",
          "date": "2025-07-19",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Quick, clean, effective. Technician vacuumed every supply and return, showed me the dust on camera, and was out in a couple hours. My asthma has been much calmer since. Glad I finally did this.",
          "name": "Curtis N.",
          "date": "2026-02-11",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Prompt and professional fireplace insert cleaning. The tech swept the flue, removed creosote, and verified the cap and liner were in good condition. Gave honest efficiency tips without pushing extra services.",
          "name": "Gerald H.",
          "date": "2023-06-18",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Switched from a big-name company that ghosted me twice. The arrival window here was a touch wide, roughly four hours, but the tech called ahead and the cleaning itself was excellent. Stainless cap inspected, flue swept properly. Minor scheduling note aside, far better than who I used before.",
          "name": "Yasmin A.",
          "date": "2025-05-30",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Honest and gentle service from start to finish. Maureen booked me in and explained the $69 inspection clearly over the phone, no surprises. The technician who came was patient with this 82-year-old, walking me through the damper, the flue, and the smoke shelf at my own pace. Refreshing.",
          "name": "Edith C.",
          "date": "2024-02-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Family-owned outfit that clearly knows chimneys. After a windstorm bent our cap, Felix replaced it and gave the crown and flashing a complete inspection. Friendly, on time, and the written report was detailed. Will call them again.",
          "name": "Theo G.",
          "date": "2023-09-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "I run a small in-law unit so the dryer gets heavy use, which meant heavy lint buildup. The technician brushed and vacuumed the entire run, cleared the exterior vent hood of a packed lint cap, and showed me the airflow improvement on his meter. Reassuring service that I'll be repeating annually now that I see how much accumulates.",
          "name": "Vincent P.",
          "date": "2023-12-08",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Maureen makes scheduling effortless. She offered me three time slots, sent a reminder text, and called when Sam was fifteen minutes out. He swept the chimney, cleared the smoke shelf, and showed me before and after photos of the creosote. The office stayed in touch the whole time.",
          "name": "Lucinda V.",
          "date": "2026-05-12",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Arrival window was a bit wide, but once Yuval showed up he was excellent. Cleared the creosote fast and left no mess. Good crew overall.",
          "name": "Desmond V.",
          "date": "2024-10-18",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "First service on the air ducts in our new construction. A lot of sawdust and drywall grit had settled into the runs during the build. The cleaning was thorough and the report was detailed. There was a small scheduling hiccup where they had to push my appointment a day, but they called ahead and were apologetic, so no real complaints.",
          "name": "Lakshmi P.",
          "date": "2025-07-23",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Newly built addition tied into our existing system and the whole house was coated in fine construction dust. Joey ran a camera through first, showed me the sawdust packed in the supply runs, then cleaned it all out. Floors were protected the entire time, shoe covers on. Best money I spent on the whole project.",
          "name": "Felix B.",
          "date": "2024-04-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Straight shooters. The phone quote for the air-duct cleaning held, and the technician explained why he wasn't recommending the sanitizing add-on for my situation. Saved me money by telling me what I didn't need. Return vents look spotless.",
          "name": "Bianca H.",
          "date": "2025-07-13",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Solid work overall. We bought a place where the owners had a cat, and the ducts needed it badly. The cleaning itself was great and the tech was knowledgeable. Only small gripe is the arrival window they gave me was pretty wide, four hours, so I burned half a morning waiting. Once he showed up though, the work was excellent and the vents came out spotless.",
          "name": "Bradley H.",
          "date": "2025-03-12",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Honestly relieved I called when I did. The dryer was getting so hot the top panel was warm to the touch and loads took two cycles. Maureen booked me fast, and the tech cleared out an enormous amount of lint from the vent run. Now it dries in one cycle and the overheating is gone entirely. Peace of mind is worth a lot.",
          "name": "Yolanda P.",
          "date": "2026-02-11",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "We had no idea where to even begin with our new fireplace, so I'm grateful the team made it so approachable. They explained that the creosote buildup we had was a fire risk and showed me exactly what they removed. Talked us through the chimney crown and recommended waterproofing down the line, but didn't push it. With 50+ years of experience they clearly know what they're doing, and they passed a lot of that knowledge on to two clueless new owners. Booked a follow-up already.",
          "name": "Imani C.",
          "date": "2025-12-01",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Fair price, no drama. The inspection was the advertised $69 and the sweep was reasonable too. Liner checked out fine.",
          "name": "Beatriz N.",
          "date": "2024-02-21",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We've leaned on this family business for three years now. The waterproofing they applied to our brick chimney has kept the moisture out beautifully, and this year's creosote removal was quick and clean. Maureen even called to confirm the day before, which I always appreciate.",
          "name": "Marisol G.",
          "date": "2023-04-18",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Preparing to sell our house, I needed a chimney inspection for the buyer's peace of mind. Patrick was meticulous, documenting the flue liner, the crown, the cap, and the firebox with a camera so I'd have a complete record. He found minor creosote and a small gap in the mortar at the crown, neither urgent, and noted them clearly in the written report. He didn't try to pressure me into repairs before the sale, just gave me honest documentation I could share with the buyers. Everything was protected with drop cloths and he wore shoe covers throughout. The report was professional enough that our realtor commented on how thorough it was. Maureen even followed up to make sure I'd received the emailed copy. Exactly the kind of clean, no drama service you want during a stressful move.",
          "name": "Nathaniel D.",
          "date": "2026-04-18",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Reliable as ever for the yearly clean. Creosote was building up faster than I expected and the technician explained why, then cleared it all and double-checked the damper. Appreciated the straight talk.",
          "name": "Imani C.",
          "date": "2024-10-05",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Referred by a buddy at work who'd just had his chimney swept. The arrival window was a bit wide, almost four hours, but the tech called when he was twenty minutes out which helped. Once here, he did excellent work clearing creosote and checking the damper. Just be ready to keep your morning open.",
          "name": "Sebastian P.",
          "date": "2024-08-12",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Good experience overall. There was a callback delay after I left a voicemail, took about two days to hear back, but Maureen apologized and got me on the schedule fast. The cleaning and level-2 inspection before our gas-log conversion were done right, creosote gone and crown checked.",
          "name": "Imani P.",
          "date": "2025-02-11",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Top-notch from the first phone call. We'd seen lint blowing out and birds poking around our old open vent. Andre cleared the duct of a thick lint mat, replaced the worn cover with a new metal vent hood featuring a spring-loaded flap and pest screen, and tested the airflow afterward to confirm it was strong. He even cleaned up the bit of lint that fell outside. Couldn't ask for more.",
          "name": "Trevor A.",
          "date": "2024-09-09",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Reliable, clean, and exactly what we needed before our holiday open house. Marco inspected the chimney crown, swept thoroughly, and gave a written report noting everything was in good shape after creosote removal. Shoe covers on, drop cloths down, no mess at all. We lit the fire that night and the whole house felt instantly warmer and more festive. This family-owned outfit clearly takes pride in their work.",
          "name": "Gretchen V.",
          "date": "2023-12-01",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Diego deserves a raise. Showed up, diagnosed why our fireplace was smoking back into the room, cleaned the flue, and adjusted the damper, all while keeping the area immaculate with drop cloths. He stayed an extra fifteen minutes just to make sure the draft was pulling correctly before he left.",
          "name": "Yolanda P.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Heard rustling in the chimney and assumed the worst. Sure enough, birds. The technician removed a sprawling nest, cleaned the flue, and put on a new stainless steel cap with screen mesh. Tidy work and a fair price. He even pointed out our damper was a little stiff and showed me how to free it up.",
          "name": "Thaddeus L.",
          "date": "2025-09-27",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Same-day dryer vent cleaning saved my laundry routine. Phoned mid-morning after the dryer started overheating, and they had someone out by early afternoon. Cleared the lint trap and the full duct run to the exterior vent hood. Airflow is night and day. Fast and professional.",
          "name": "Dmitri L.",
          "date": "2025-08-04",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Run a six-plex and one of the dryers was constantly tripping its thermal cutoff. BHO traced it to a packed vent run, cleared it, and did the other five while they were there. The amount of lint was honestly scary. Professional, documented everything, fairly priced.",
          "name": "Idris Q.",
          "date": "2023-05-18",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Our crawlspace duct is awkward and long, so I appreciated that they sent someone willing to deal with it. Hector did solid work and the airflow improved a lot. One small thing, there was a callback delay getting the appointment confirmed after I first called, took a couple days to hear back from the office. Once scheduled though, the service itself was great and the crawlspace was left clean.",
          "name": "Nikolai S.",
          "date": "2024-07-26",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Callback took a couple days longer than I'd hoped to get on the schedule, but the tuckpointing they did on our older home's chimney was top-notch. New mortar matches the 1940s original nicely and the spalled corner bricks were replaced cleanly. Polite crew, fair quote.",
          "name": "Bernadette H.",
          "date": "2024-08-03",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Got the dryer vent and the air ducts done in a single morning visit. Reasonable, efficient, and tidy. The tech vacuumed the lint trap cavity I didn't even know existed and showed me how clogged the vent hood had been.",
          "name": "Niko V.",
          "date": "2024-04-21",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Decent crown repair and a new chimney cap to stop the water that had been getting into our masonry. The work itself was solid and the waterproofing held. My only gripe is they had to reschedule once and the callback to confirm took a couple days. Still, the leak's fixed and the price was reasonable.",
          "name": "Sven A.",
          "date": "2024-08-01",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "From the booties at the door to the drop cloth covering half the living room, these folks clearly respect your home. The chimney crown got resealed and the firebox vacuumed of every flake of creosote. They wiped down the hearth stone afterward and folded their cloths neatly. Immaculate.",
          "name": "Frieda N.",
          "date": "2026-05-20",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Solid pre-purchase chimney inspection. Sergei checked the smoke shelf, the damper, and ran the camera up the full flue. Written report was clear about what needed attention versus what was fine. Helped our negotiations.",
          "name": "Imani C.",
          "date": "2024-10-11",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Trustworthy and meticulous. We host my elderly mother who is on oxygen, so clean indoor air is not negotiable. The technician took particulate readings before and after, cleaned every register and return vent, and provided a written report we could share with her care team. The numbers improved measurably. Highly recommend for sensitive households.",
          "name": "Charlotte E.",
          "date": "2026-01-15",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Called about a smoky odor that got worse in humid weather. The diagnosis was creosote absorbing moisture plus a damper stuck partly open letting outside air mix in. Thorough creosote removal and a damper repair later, the smell is finally gone. Mikhail was professional and explained the science behind it.",
          "name": "Whitney A.",
          "date": "2025-08-16",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Mold remediation company told us the ducts needed cleaning and sanitizing after a water issue. BHO came out, scoped the runs, cleaned thoroughly, and applied an antimicrobial fog. Provided a written report I could hand to my insurance. Smooth experience.",
          "name": "Delphine A.",
          "date": "2024-12-14",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "After renovating, fine drywall dust was everywhere and my throat was constantly scratchy. Carlos brought professional equipment, cleaned each duct run, and pulled out a shocking amount of construction debris from the returns. He laid drop cloths and left no mess. My breathing improved within days. Truly appreciated the thoroughness.",
          "name": "Imani G.",
          "date": "2025-07-29",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Really impressed by how much the technician knew about wood-stove efficiency. After cleaning the liner and clearing the creosote near the smoke shelf, he sat down and explained how our damper setting was choking the fire and creating more buildup. Adjusting it per his guidance has made the stove burn hotter on less wood. The written report was detailed and easy to understand. A genuinely helpful, no-pressure visit from start to finish.",
          "name": "Lucinda B.",
          "date": "2025-10-28",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Expected the usual runaround. Instead I got an honest assessment that my chimney just needed a basic sweep, not the expensive masonry work another company had insisted on. They cleaned it, checked the crown, and that was that. Honesty like this is rare.",
          "name": "Theodore M.",
          "date": "2024-02-13",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Kindness goes a long way at my age. The young gentleman swept the chimney, removed years of creosote, and patiently showed me before and after pictures so I could see the difference. He never made me feel hurried even though I asked the same question twice. Lovely manners and honest pricing.",
          "name": "Arthur D.",
          "date": "2025-03-25",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Storm season left me worried about leaks, so I scheduled the $69 inspection. The technician climbed up, examined the crown, stainless cap, and flashing carefully, and showed me photos of each. Found minor crown weathering and recommended a sealant, no hard sell. Everything documented. Couldn't ask for more transparency for the price.",
          "name": "Carmen O.",
          "date": "2025-10-11",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Cannot say enough good things. The fear of a lint fire had been nagging at me for months. They arrived right on schedule, laid down drop cloths, pulled the dryer out, and cleared an astonishing amount of lint from both the machine cavity and the long duct run. Everything was vacuumed up before they left and the written report confirmed the vent was clear. Sleeping easy now.",
          "name": "Hannah V.",
          "date": "2025-07-26",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Quick, friendly, and on time. Maureen handled the booking and reminders, and the tech finished the flue inspection faster than I expected. Written report landed in my inbox before he'd even pulled out of the driveway.",
          "name": "Thaddeus J.",
          "date": "2025-02-21",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Air ducts and return vents cleaned thoroughly. The team bagged every bit of debris and wore shoe covers. House air feels fresher. Money well spent.",
          "name": "Yelena C.",
          "date": "2025-01-30",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Builder finished the place in spring and we wanted the dryer vent checked before heavy use. Smart move. There was packing debris in the lint trap housing and the long duct run had a sag holding lint. Raj fixed the run, cleaned it, and tested the vent hood. Dryer is far more efficient now.",
          "name": "Quentin A.",
          "date": "2024-06-15",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Came off a full basement finish with drywall everywhere. The crew sealed each register, ran the negative-air system, and scrubbed the return vents that were caked with joint-compound dust. They were friendly and explained each step. The persistent chalky smell finally cleared out after they left.",
          "name": "Noor H.",
          "date": "2026-04-22",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Half a century in business and it shows in how they treat customers. Devin gave me an honest estimate, swept the chimney, and removed a thick layer of creosote near the smoke shelf. When I asked about waterproofing he said my masonry was in good shape and didn't need it yet. No pressure to spend more. The bill was exactly what we discussed. Genuinely appreciate dealing with people who value honesty over a quick sale.",
          "name": "Ronald E.",
          "date": "2026-03-05",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "The dander in this house was no joke. Two dogs lived here before us and my husband's asthma flared up the first week. BHO came out, cleaned all the return vents and supply runs, and replaced the filter. The crew was polite, wore shoe covers, and gave us a written report. His breathing has improved noticeably since.",
          "name": "Simone A.",
          "date": "2024-10-08",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Solid work. My dryer needed two cycles and ran hot. Technician cleaned the full duct run and the lint trap slot, showed me the buildup he removed, and confirmed proper airflow at the vent hood. Dries in one cycle now. Only minor thing was a slightly late arrival, but he called ahead to let me know.",
          "name": "Rashid E.",
          "date": "2025-05-08",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Closed on the house in January and the wood stove came with it. Tyler inspected the liner, swept the flue, and patiently explained how to read the moisture content of our firewood. Genuinely helpful for someone starting from zero.",
          "name": "Felix H.",
          "date": "2025-01-27",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Solid value overall and I'd use them again. The $69 inspection was honest and the creosote removal was thorough. Only small gripe is the arrival window was pretty wide, four hours, so I lost most of a morning waiting. Once Omar showed up though he was quick, tidy, and worth it.",
          "name": "Beatriz N.",
          "date": "2024-02-21",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Repeat customer and proud of it. Nikolai has done our last four sweeps and knows our old farmhouse flue like the back of his hand. This time he replaced the stainless cap and cleared a stubborn creosote glaze. Shoe covers, drop cloths, a real written report. Nothing sloppy with these folks.",
          "name": "Frederick O.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Booked a sweep and inspection after noticing soot marks above the fireplace opening. The technician was knowledgeable and explained that the marks were from a smoke shelf that needed cleaning along with a creosote layer in the flue. He handled both, ran a camera to confirm the liner was intact, and showed me before and after photos. He used drop cloths and was careful with our white carpet. My one constructive note is that the arrival window spanned four hours and I had to rearrange my afternoon, though he did call when he was about twenty minutes out. The work itself was excellent and the written report was detailed. For the quality of the actual service I'd happily book again, just hoping for a tighter time window next time.",
          "name": "Beatrice H.",
          "date": "2023-07-29",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Good service overall for our annual sweep. The arrival window they gave me was a bit wide, a full four hours, so I ended up waiting around most of the morning. That said, once the tech arrived he was excellent, cleared the creosote quickly, was careful with shoe covers, and left everything clean. Would still book again, just hoping for a tighter window next year.",
          "name": "Dale H.",
          "date": "2025-09-09",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Our babysitter's parents recommended BHO and I'm passing the favor forward with this review. Clean, professional sweep, and the tech pointed out spalling brick near the chimney crown with photos to back it up. Honest assessment, no scare tactics.",
          "name": "Vanessa C.",
          "date": "2025-02-18",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Thorough from start to finish. Before installing gas logs, Eli ran a level-2 video inspection, removed creosote from the flue and smoke shelf, and tested the damper. He emailed a written report with annotated photos. The whole crew respects your home, shoe covers and drop cloths throughout. Couldn't be happier with the prep work.",
          "name": "Walter G.",
          "date": "2024-10-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wonderful job clearing our second-story dryer run, which the previous owners clearly never touched. The tech showed me before and after photos and replaced the missing exterior flap with a proper hood that includes a critter guard. He was patient with all my questions and never made me feel rushed.",
          "name": "Felicia O.",
          "date": "2025-08-21",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "First real cold snap of the season and our fireplace is ready. Victor cleared the flue, checked the damper, and the fire drew perfectly that evening. Snug as can be now.",
          "name": "Desmond L.",
          "date": "2025-11-26",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Booked the $69 inspection and got Ramon, who was punctual and incredibly thorough. He photographed the chimney crown, checked the stainless cap, and noted minor creosote that didn't yet need a full sweep. Honest assessment instead of pushing services I didn't need. Refreshing.",
          "name": "Caleb H.",
          "date": "2024-07-30",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Squirrels had completely taken over the top of our chimney and dragged in tons of debris. BHO came out, cleared the flue, vacuumed everything off the smoke shelf, and installed a stainless cap with a screen to seal them out permanently. The technician was respectful, used drop cloths and shoe covers, and left no mess. Couldn't be happier with how it turned out.",
          "name": "Yolanda E.",
          "date": "2024-08-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Reached out for an inspection and they responded within the hour. Squeezed me in next day, ran the $69 inspection, scoped the flue liner, and emailed photos plus a written report by evening. Punctual and thorough start to finish. The technician even called when he was on his way so I wasn't guessing about timing. For a service that often involves waiting around, this was refreshingly efficient and respectful of my afternoon.",
          "name": "Yasmin C.",
          "date": "2026-01-27",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Manage a small apartment building and fire safety is my top concern. The crew cleaned all the dryer vents, vacuumed each lint trap cavity, and pointed out which exterior vent hoods needed new flaps. Written report for every unit. Tenants noticed faster drying right away.",
          "name": "Nadia V.",
          "date": "2024-04-11",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Second-story laundry venting through a long attic run out to a roof cap. Luis navigated the attic, cleared a heavily blocked section near the termination, and checked the exterior flapper was opening freely. He laid a drop cloth around the dryer and left zero mess. The before-and-after airflow difference was obvious immediately. Great with complicated layouts.",
          "name": "Carmen V.",
          "date": "2025-10-02",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Old chimney, soft brick, lots of efflorescence and spalling. Kevin diagnosed it as a moisture problem from a failed crown rather than just surface damage. Fixed the root cause first by rebuilding the crown, then repointed and waterproofed. Glad someone finally addressed why it kept happening instead of just patching.",
          "name": "Dominic V.",
          "date": "2025-10-21",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "After a friend recommended them we had both our air ducts and dryer vent serviced at once. The technician was patient with all my questions, explained why the return vents collect the most debris, and gave me a written report at the end. Drop cloths down the whole time. Airflow through the vents is dramatically better now and the laundry room finally doesn't feel like a sauna when the dryer runs.",
          "name": "Dolores H.",
          "date": "2025-08-15",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Years of water damage had left our chimney crown crumbling and the cap a rusted mess. Jordan took the time to show me exactly where rain was entering before doing anything. He rebuilt the crown with a drip edge, installed a heavy-gauge stainless cap, repointed a few bad joints, and waterproofed the brick. Written report with photos. Worth every penny and then some.",
          "name": "Beatrice N.",
          "date": "2025-09-18",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Tidy operation from start to finish. A runner protected the entry tile, shoe covers stayed on indoors, and the antique side chair near the fireplace got moved gently out of the way. Flue swept, damper checked, hearth left spotless.",
          "name": "Quentin B.",
          "date": "2023-06-23",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "After 50-plus years in business you can tell these folks have seen everything. Our pre-sale inspection turned up an old terra-cotta liner with hairline cracks. The technician documented it honestly without scaring us, and the written report gave the buyers confidence to proceed. Refreshing to deal with people who care about their reputation more than a quick buck.",
          "name": "Frederick J.",
          "date": "2025-07-08",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Persistent dry cough that vanished after this service. I'd tried everything else. BHO cleaned the ducts, found the blower compartment thick with dust, and explained how it was recirculating through the whole house. Two days later the cough was gone. Tidy work, drop cloths everywhere, and a clear report.",
          "name": "Felix Q.",
          "date": "2024-05-29",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Three different companies told us to just burn drier wood. These guys actually found the real problem: a deteriorated flue liner and a damper that no longer sealed, letting downdrafts carry smoke smell into the den. They relined the affected section and replaced the damper assembly. The written report had photos of everything before and after. First winter in years without that constant smoky smell. Worth every penny.",
          "name": "Desmond C.",
          "date": "2026-03-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Persistent musty smell, especially upstairs. Dmitri traced it to dust and a bit of mildew in the supply ducts feeding the bedrooms. Cleaned everything, sanitized, replaced our filter, and the air smells clean again. Friendly and fair.",
          "name": "Imani L.",
          "date": "2025-10-27",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Dust accumulation in our home was relentless and my partner's allergies were miserable. The crew arrived in shoe covers, sealed off vents, and ran their vacuum system through the entire ductwork. Before/after photos showed thick gray buildup gone. Much less dusting now and the sneezing has dropped off noticeably. Solid, honest work.",
          "name": "Garrett L.",
          "date": "2024-03-06",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Our pellet stove insert needed a deep clean and Felix handled it expertly. Cleared the venting, inspected the liner, and checked the cap for blockages. He explained how ash buildup was reducing our heat output and showed me the maintenance points to keep an eye on between professional cleanings. Tidy work, friendly attitude, and a fair price for the level of care.",
          "name": "Omar D.",
          "date": "2024-02-27",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "After a discount dryer-vent service left my laundry room dustier than before, I almost gave up. BHO was a revelation, they cleaned the full duct run, the lint trap area, and showed me the bag of buildup. Drying time cut in half. Should have called the family-owned guys from the start.",
          "name": "Greta S.",
          "date": "2025-09-04",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "I rarely write reviews but this deserves one. Living alone at 86, I'm cautious about who I let in, and Sam earned my trust immediately. He explained the inspection step by step, showed me the worn chimney crown on his camera, and gave me a written report I could share with my son. He even helped me move a heavy chair back into place afterward. The whole time he was patient, respectful, and never once condescending. This is a company that clearly trains its people to care about older customers.",
          "name": "Beatrice O.",
          "date": "2025-07-02",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Following the hailstorm that hit us in May, our crown had visible damage. Yuval rebuilt the crown wash, checked that the flashing was watertight, and resealed where needed. He laid drop cloths inside near the fireplace and cleaned up completely. The work was meticulous and he answered every question I threw at him. Knowing the company has been around fifty-plus years gave me real confidence in the repair lasting.",
          "name": "Nathaniel W.",
          "date": "2024-05-21",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Straightforward and professional. Lint had built up so badly that the exterior flap couldn't even close, leaving the run open to the elements. The tech cleared it all, replaced the damaged vent hood cover, and tested the airflow. Dryer is faster and I'm not worried about a fire starting overnight anymore.",
          "name": "Oscar M.",
          "date": "2024-02-29",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Calling the office was a pleasure. Maureen explained exactly what the air duct cleaning included, sent a confirmation and a reminder, and the crew cleaned every return vent and supply run carefully. They wore shoe covers the whole time. Communication was clear and the follow-up call sealed it for me.",
          "name": "Magnolia S.",
          "date": "2024-11-02",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Inspection for $69 was a steal. Detailed written report and clear photos of the flue liner. No upsell, just facts. Honest family business.",
          "name": "Brandon J.",
          "date": "2024-06-05",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Our newly built home looked spotless but the ducts told a different story. Joey pulled out handfuls of construction dust and a few drywall screws from the return vents. Every run got brushed and vacuumed, drop cloths down, shoe covers on. He explained everything clearly and the written report was easy to follow. Genuinely impressed for a first cleaning.",
          "name": "Sienna G.",
          "date": "2023-02-19",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Our contractor's idea of cleanup was a broom, so the ducts were full of sawdust and drywall scraps. BHO did a deep clean of every duct run and the blower. Patrick was great about showing before and after photos. House air quality went from gritty to fresh in one visit.",
          "name": "Damian S.",
          "date": "2025-02-26",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Fair and friendly. Clear pricing, no surprises, thorough fireplace cleaning. Will use again. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Megan O.",
          "date": "2024-02-21",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Fresh start for our new home. Sellers smoked for decades and the vents told the story. Andre was meticulous, showed before/after photos, and the smoke smell lifted right away. Couldn't ask for more.",
          "name": "Emilio R.",
          "date": "2025-12-15",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Excellent service for a problem I'd ignored too long. Clothes were coming out warm and damp, taking two and even three cycles. The technician disconnected everything, ran his brush through the duct, and pulled out compacted lint that had restricted airflow for who knows how long. He wore shoe covers and laid down a drop cloth. Drying is back to a single cycle and the dryer no longer overheats. Truly grateful.",
          "name": "Cassandra J.",
          "date": "2024-08-19",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "First fireplace, first winter, lots of nerves. The $69 inspection was worth every penny. Tech found the previous owner had let creosote build up badly and walked me through the whole cleaning. He also showed me the missing stainless cap and explained why it lets water and animals in. Booking through Maureen was painless and the report was clear. I feel like I actually understand my chimney now.",
          "name": "Gabriela V.",
          "date": "2024-02-14",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "On a teacher's salary I watch every expense, so $69 for a thorough chimney inspection sealed the deal. The technician was patient, walked me through the written report line by line, and pointed out that my flue liner had years of life left. No upsell, no fear-mongering. Just a clean job and an honest assessment. Couldn't ask for better value.",
          "name": "Quentin H.",
          "date": "2025-10-02",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Year after year, BHO keeps our fireplace safe and clean. The inspection turned up a small gap in the chimney crown that Marco sealed on the spot. They never push services we don't need, which is exactly why we keep renewing each fall.",
          "name": "Imani C.",
          "date": "2024-09-26",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "After a windstorm knocked our chimney cap loose, I called and Maureen got a technician out quickly. He climbed up, inspected the damage, and confirmed the stainless cap was bent beyond repair and that some debris had fallen into the flue. He removed the debris, did a sweep and creosote removal while he was up there, and installed a new cap that fit properly. He showed me photos from the roof since I couldn't see it myself, and pointed out that the crown was in good shape otherwise. The written report covered everything. The price for the new cap was reasonable and quoted before he started. Only small thing is I had to call twice to get the initial quote confirmed, but the actual work was top notch and quick. Genuinely happy with the result.",
          "name": "Quincy F.",
          "date": "2025-02-22",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Faithful customers for years and they keep earning it. Diego swept the flue, pulled out the creosote, and gave the stainless cap a quick inspection. Friendly, fast, and respectful of the house.",
          "name": "Yolanda S.",
          "date": "2024-11-28",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "A guy in my fishing club gave me their number after I complained about smoke backing into the living room. Turned out my smoke shelf was caked in years of debris. The tech cleaned it thoroughly and the draft is perfect now. Fires light easy and the room stays clear. Couldn't ask for more.",
          "name": "Walter J.",
          "date": "2024-11-26",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Clean job, fair price. The $69 inspection got upgraded to a level-2 when they realized we were converting to a gas insert, and even then the cost was reasonable. Creosote removed, flue liner verified, done. Hector was friendly and explained everything.",
          "name": "Lucinda A.",
          "date": "2023-08-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Reliable, careful work. After a mouse got into the duct through the broken exterior vent, the technician cleared the line, removed the nesting debris, and installed a new hood with a stainless pest screen. He also pointed out a section of the run that had sagged and recommended a strap, which he added. Minor callback delay on confirming the appointment, but the work itself was excellent.",
          "name": "Omar J.",
          "date": "2023-11-04",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "We always do Christmas Eve by the fire and this year almost didn't happen because the chimney was overdue. BHO squeezed us in, removed heavy creosote, replaced the stainless cap, and confirmed the liner was sound. The tech was so respectful of our home, drop cloths everywhere. That first fire with the tree lit was pure magic. Thank you for saving our tradition.",
          "name": "Annika O.",
          "date": "2024-12-23",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Maureen was lovely setting up the appointment, and Sergei did a beautiful job on the air-duct cleaning. He sealed off the return vents, brushed each run, and produced before and after photos that honestly surprised me, the dust was unreal. House feels lighter now. One small thing, the callback to confirm came a day later than promised, but the work itself was excellent.",
          "name": "Imani C.",
          "date": "2025-03-12",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Great job removing a bird nest and capping our chimney. Stainless cap with screen looks clean and professional. Mikhail was efficient and friendly.",
          "name": "Cornelius H.",
          "date": "2023-06-23",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Solid and dependable. They arrived right on time, swept the chimney, checked the smoke shelf and damper, and were out within the hour. Quick scheduling over the phone with Maureen too. No surprises.",
          "name": "Brandon E.",
          "date": "2024-07-23",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "BHO handled the dryer-vent cleaning for all 18 units I manage and it was the smoothest vendor experience I've had. Crew arrived on schedule, cleared every duct run, swapped a damaged transition hose, and left each laundry closet cleaner than they found it. Itemized billing per unit made my life easy.",
          "name": "Oscar H.",
          "date": "2025-11-08",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Roof termination, two stories up, long run from the upstairs laundry. Carlos brought the right gear and cleared it top to bottom. No more burning smell when the dryer runs.",
          "name": "Desmond H.",
          "date": "2023-08-11",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Repointed the chimney and rebuilt a leaning section on our 1912 craftsman. The crew was respectful of the original masonry character. They matched the joint profile and mortar tone. Maureen followed up after to make sure we were happy.",
          "name": "Tabitha O.",
          "date": "2024-03-28",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Excellent work bundling the two services. Raj cleared a heavy lint blockage from the dryer vent run, then moved on to the ducts without missing a beat. Professional and respectful of the house.",
          "name": "Rashida C.",
          "date": "2026-01-07",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Rusted cap and a hairline crown crack were the source of a slow leak into the chase. They swapped the cap for stainless, sealed the crown, and treated the masonry. Clean work, clear explanation of the waterproofing process, and no upsell on stuff I didn't need.",
          "name": "Desmond H.",
          "date": "2023-02-26",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "They had to push my appointment by a few days due to a scheduling mix-up, which was mildly annoying. That said, the actual visit was flawless on the cleanliness front, shoe covers, drop cloths over the rug, and a vacuumed smoke shelf with zero soot left behind. Maureen was apologetic and kind about the reschedule.",
          "name": "Indira C.",
          "date": "2025-10-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Needed inspection paperwork for our mortgage on a rural property with a wood stove insert. Devin scoped everything, verified the liner clearance, and noted creosote buildup in the written report. Fairly priced and turned around fast enough to keep our closing date intact.",
          "name": "Whitney L.",
          "date": "2024-02-29",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Mold sensitivity made the basement air rough on me. The team inspected the duct runs with a camera, cleaned them, and pointed out a return vent near the crawlspace pulling in damp air that needed sealing. They didn't overstate anything. My symptoms have calmed and the air smells clean instead of earthy.",
          "name": "Renata G.",
          "date": "2025-07-08",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Smoke kept spilling out of the firebox on startup. Tyler explained the cold chimney needed priming but the bigger issue was a creosote-clogged flue restricting the draft. Full sweep, damper cleaned and lubricated, and a quick lesson on lighting a top-down fire. Smells fresh now.",
          "name": "Lorena V.",
          "date": "2024-05-09",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Good service overall. They cleaned and sanitized our ducts to deal with a musty odor and it worked. Only knock is the first callback took a couple days, but once Maureen got us on the schedule the tech was great and very thorough with the return vents.",
          "name": "Sven H.",
          "date": "2025-01-30",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "My son's pediatrician mentioned indoor allergens could be behind his constant congestion, so we had the ducts cleaned. Omar was kind and detailed, cleaning every return vent and showing us the dust and pet dander he removed. He provided a written report. A few weeks later, his nighttime cough is basically gone.",
          "name": "Felicity D.",
          "date": "2025-12-18",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Good service overall. They cleaned the wood stove and inspected the flue liner, finding moderate creosote. My only minor gripe is it took two calls before I got the appointment locked in. Once Nikolai showed up, though, the job was clean and thorough and his burning tips were spot on.",
          "name": "Heather J.",
          "date": "2024-07-09",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Won me over completely. A previous company quoted a full liner replacement; BHO inspected with the camera and proved it wasn't needed, just a thorough creosote removal. Eli was honest, careful, and tidy. The before and after photos sealed it. This is how chimney service should be done.",
          "name": "Hassan J.",
          "date": "2024-10-27",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Pleasant young man came to clean the dryer vent. He showed me how much lint had built up in the duct run and explained in simple terms why it mattered. Patient and tidy. Slightly late arriving but he called to let me know, so no real complaint.",
          "name": "Norman J.",
          "date": "2024-09-14",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Wind-driven rain had me convinced the flashing failed. Victor checked it all, found the cap had shifted in the storm but the flashing was intact. Re-secured the stainless cap and sealed the crown for good measure. Quick and honest.",
          "name": "Imani H.",
          "date": "2025-12-08",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Reliable and thorough. After a dryer fire scare on the local news I booked a cleaning, and the lint they removed from our duct run justified the decision instantly. The tech was friendly and explained everything. The only minor hiccup was a scheduling mix-up on the first appointment, but they made it right quickly and the work was top-notch.",
          "name": "Tessa J.",
          "date": "2025-12-19",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Good work and very kind office staff. There was a small hiccup when a callback I was promised came a day late, but once Maureen got hold of me she apologized and squeezed me in the very next morning. The tech removed heavy creosote and checked the stainless cap. Still a positive experience overall.",
          "name": "Emiliano Q.",
          "date": "2023-09-08",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "New stainless cap and a quick crown patch sorted our draft issues. Ramon was efficient and friendly. Job done right the first time. Recommend them.",
          "name": "Noor E.",
          "date": "2025-09-22",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "New house, never serviced dryer vent. The duct run went straight up through the wall and already had lint catching at a bend the builder created. Cleaned it out, checked the exterior vent hood flap, and confirmed airflow. Tidy work and the dryer dries a full load in one cycle now.",
          "name": "Maxwell O.",
          "date": "2025-10-09",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "After a top-to-bottom renovation, the dust in our vents was out of control. The technician was meticulous, cleaning supplies, returns, and the main trunk while keeping the work area spotless with drop cloths. He documented everything in a written report. We can finally breathe without that construction film coating everything.",
          "name": "Camila Z.",
          "date": "2023-06-30",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Booked an inspection expecting to be talked into expensive repairs. Luis was completely upfront, said the chimney crown and flue were fine, and only recommended a routine sweep. The $69 inspection plus the cleaning came to a fair total with no hidden fees. He even pointed out where I could save by scheduling in the off-season next time. Honest advice you can actually trust.",
          "name": "Felicia G.",
          "date": "2025-12-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "We just bought our first house and the previous family had pets, so the ducts were full of fur. BHO got us in quickly, the technician was thorough and respectful of our new floors with drop cloths and shoe covers, and the photos he showed afterward were eye-opening. Air quality feels much better now and our cat-allergic guest didn't even sneeze. Great value for the work.",
          "name": "Whitney J.",
          "date": "2026-05-09",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Dryer overheating fixed. Took multiple cycles before, now just one. The duct run was full of lint and the crew cleared it fast. Friendly and tidy.",
          "name": "Nikolai O.",
          "date": "2024-04-12",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Moved in last summer and decided to get the chimney checked before using it. Kevin was fantastic, explained the flue liner condition, swept out the creosote, and gave me a realistic maintenance schedule. As a total beginner I never felt talked down to.",
          "name": "Owen P.",
          "date": "2024-08-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Surprised in the best way. The flat $69 inspection fee held all the way through checkout, drop cloths protected the carpet, and the smoke shelf got cleaned out without an added charge. For a family on a budget this was a relief.",
          "name": "Lacey G.",
          "date": "2024-10-25",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Long-standing chimney clients who finally booked the air duct cleaning. They photographed the return vents before and after, and the difference in buildup was eye-opening. Same careful, family-run crew we've trusted for the fireplace going on five years now.",
          "name": "Lars H.",
          "date": "2026-03-28",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Persistent dust no matter how often we cleaned finally pushed us to have the air ducts done, and BHO was thorough beyond what I expected. The technician inspected all the supply and return vents, then showed me a camera feed of just how much dust and debris had collected inside the duct runs over the years. He cleaned each run systematically, sealed the access points afterward, and even sanitized the return vents which had visible buildup. He laid drop cloths near every register and wore shoe covers throughout the house. The amount of debris collected was honestly shocking and explained why we'd been dusting constantly. The air felt noticeably fresher within a day and the written summary listed every vent serviced. Polite, careful, and clearly experienced. We've already scheduled the dryer vent for next month.",
          "name": "Delia V.",
          "date": "2024-06-14",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Annual creosote removal and sweep completed without a hitch. Tech was punctual and tidy, used drop cloths throughout, and gave me a written report afterward. We've never had a bad experience in all the years we've used them.",
          "name": "Rafael V.",
          "date": "2025-03-15",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "My neighbor's glowing review was spot on. Quick scheduling, fair pricing, and the technician wore shoe covers and rolled out drop cloths without being asked. Creosote gone, cap inspected, done. Will call again next season.",
          "name": "Esperanza L.",
          "date": "2025-06-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "We had no idea what shape our chimney was in before the gas conversion. Jordan scoped it top to bottom, showed me the camera footage of heavy creosote and a worn damper, and cleaned it all out. He was patient with my questions and never made me feel rushed. The level-2 report was the most detailed document I've gotten from any contractor.",
          "name": "Felix N.",
          "date": "2025-07-26",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "What a relief to finally have this done right. Lint had built up so badly that the dryer was overheating and shutting off. The tech cleaned the full duct run, vacuumed the trap housing, and swapped our cracked plastic exterior cover for a sturdy aluminum vent hood with a built-in pest guard. He walked me around outside to show the new hood and how the flap seals. Drying is back to normal and the house feels less stuffy.",
          "name": "Renata H.",
          "date": "2026-02-17",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Solid work getting the hearth ready for the holidays. The $69 inspection turned up a creosote layer that needed clearing and they handled it same visit. Only small note is the callback to confirm my appointment came a day later than promised, but the actual service was great and the living room is cozy and warm now.",
          "name": "Bryce E.",
          "date": "2025-12-04",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Reliable as ever, Dmitri swept our chimney and removed a thick creosote layer that had built up over two winters. He explained the difference between the glaze stages and why annual cleaning matters. Tidy, knowledgeable, and never made me feel rushed. This is a family business that clearly trains its people well.",
          "name": "Frederick O.",
          "date": "2024-10-17",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "After a storm knocked our old cap loose, birds moved in within weeks. The team removed the nest, swept the flue, cleaned out the firebox and smoke shelf, and installed a heavy-duty stainless steel cap with a screen. They explained why the previous cap failed and how this one is built to last. Fair $69 inspection rolled into the job and a detailed written report at the end. Very satisfied.",
          "name": "Magdalena P.",
          "date": "2025-02-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Couldn't believe they had same-day availability during the busy fall season. Felix came out, swept the flue, removed a heavy creosote glaze, and reseated the stainless cap that had loosened. Right on time, clean work, fair price. A family-owned crew that clearly values being responsive to customers.",
          "name": "Vanessa N.",
          "date": "2025-11-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Had every dryer vent in my eight-unit building cleaned before the heating season. The technician was knowledgeable, cleared substantial lint from the runs, and explained how clogged vents shorten dryer lifespan. Thorough work and a clear report. Will rebook annually.",
          "name": "Camille S.",
          "date": "2024-08-03",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "This family-owned outfit was the only one that didn't flinch when I described our setup, a duct that crosses a long crawlspace and turns twice before exiting. Sam crawled in, cleared the whole run, and replaced a section of damaged flex with rigid pipe so it won't sag and collect lint again. He explained everything in plain language and the price was exactly what Maureen quoted on the phone. Clothes dry in one cycle now.",
          "name": "Lillian J.",
          "date": "2026-02-13",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "After a rough winter, several bricks on our 100-year-old chimney had popped their faces clean off from freeze-thaw spalling. BHO replaced the damaged brick, deep-repointed the surrounding joints, sealed it with a vapor-permeable waterproofer, and capped it with a stainless cap to keep rain out of the flue. They took photos from the roof so I could see the finished work without climbing up. Thorough and tidy.",
          "name": "Ferdinand Q.",
          "date": "2025-05-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Maureen scheduled our air-duct and dryer-vent cleaning together and it went smoothly. The duct run had years of buildup and the photos proved it. Friendly tech, fair price, clean finish.",
          "name": "Quentin L.",
          "date": "2024-08-19",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Water staining on the ceiling near the fireplace had us puzzled. Yuval climbed up and found the crown had separated from the flue tile and the cap was missing entirely. He recast the crown, fitted a new stainless cap, and applied a breathable waterproofer to the exterior. Detailed photos throughout. The whole job was tidy and the leak is completely gone.",
          "name": "Ophelia G.",
          "date": "2026-02-07",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "You can tell a family-owned outfit cares about little things. The technician laid drop cloths the moment he came in, slipped booties over his boots, and kept a vacuum running while brushing the flue so creosote never reached the air. Wiped the mantel and hearth clean, and even straightened the rug he'd folded back. Faultless.",
          "name": "Wendell H.",
          "date": "2024-09-04",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Pre-purchase inspection done right. The tech laid drop cloths, used the camera, and explained why the missing chimney cap had let water into the smoke chamber. Got a written report with before photos the same day. Used it to ask the seller for a cap and waterproofing credit.",
          "name": "Dimitri Z.",
          "date": "2025-11-16",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Solid, honest indoor-air help. After wildfire smoke season our whole system needed a reset. Joey cleaned every duct run and replaced the filter, and my air monitor dropped from the 30s back into single digits. He wore shoe covers and cleaned up completely. The kind of family-owned outfit you want to keep on speed dial.",
          "name": "Aaron V.",
          "date": "2024-09-14",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Family-owned and it shows in how they treat you. Our downdraft problem turned out to be a combination of an oversized flue and a missing cap. The crew installed a properly sized cap and tightened the damper. No more smoke smell drifting upstairs. Maureen followed up to make sure we were happy.",
          "name": "Anton K.",
          "date": "2025-09-13",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Whole house smelled like a damp towel whenever the furnace ran. The crew was fantastic, going duct by duct with a brush and vacuum, then fogging the system with a sanitizer that left a faint clean scent for a day before fading to just neutral. They showed me before/after photos of the worst runs and explained how to keep moisture out going forward. Such a relief to breathe clean air again.",
          "name": "Renata V.",
          "date": "2026-05-06",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Reliable and professional. They cleaned all the supply runs and return vents, swapped our dirty filter, and explained how often to maintain the system. The dust on our blinds has dramatically decreased and my hay fever symptoms inside the house are much better. Reasonable price too.",
          "name": "Nikolai Z.",
          "date": "2024-11-02",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Top-notch from the first phone call. Maureen got us scheduled fast and the technician who serviced our fireplace insert was meticulous. He removed the unit, swept the chimney, checked the stainless liner, and pointed out where creosote was glazing near the top. Beyond the cleaning, the efficiency coaching was the real value, he taught us to burn hotter, shorter fires rather than long smoldering ones. Our wood lasts longer and the flue stays cleaner. This family-owned business clearly takes pride in the work.",
          "name": "Theodore G.",
          "date": "2025-12-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Skeptic no more. The last air-duct outfit left my returns just as grimy as before. BHO pulled genuine debris from every vent, even the hard-to-reach ones, and the musty smell finally disappeared. Maureen made scheduling painless. A clear step above the company I'd wasted money on.",
          "name": "Camila E.",
          "date": "2025-11-18",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Treated this old fellow like family. Patrick took the time to explain creosote and why my flue needed a good sweep after years of neglect. He showed me before and after photos and answered every question with a smile. Fair, honest, and gentle.",
          "name": "Herbert E.",
          "date": "2025-05-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Booked a follow-up after a severe weather warning weekend. The technician inspected the chimney crown, the cap, and the flashing thoroughly and gave us a clean report with photos. The only small thing was a callback delay, it took a couple days to hear back when I had a follow-up question, but the in-person work itself was excellent and the leak worry is gone.",
          "name": "Roland E.",
          "date": "2024-03-09",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "First-rate from the phone call to the finish. Maureen explained exactly what the cleaning involved and the tech backed it up. He pulled a dense rope of lint out of the duct elbow and showed me how restricted the airflow had been. The dryer no longer runs hot and I have genuine peace of mind about the fire risk.",
          "name": "Reginald A.",
          "date": "2024-07-03",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "I deal with a lot of contractors and this office runs better than most. Maureen confirmed by phone, texted a reminder, and gave me a tight arrival window. Andre inspected the flue liner, scraped the creosote, and laid drop cloths so nothing got dirty. The follow-up call to check my satisfaction was such a thoughtful touch.",
          "name": "Winifred L.",
          "date": "2026-04-18",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Dryer vent cleaning was fast and the lint pile was alarming. Glad we called. Tech was courteous and showed the clear duct run after. Great job.",
          "name": "Felix O.",
          "date": "2026-04-14",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Closed on our brand-new home in the fall and booked the first duct cleaning right away. Marco found a layer of fine construction dust throughout the supply runs and some insulation fragments near the return vents. He sanitized afterward and provided before and after photos. The whole place feels less dusty and the air smells clean.",
          "name": "Ingrid C.",
          "date": "2024-12-12",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Drywall dust from our remodel had infiltrated the ductwork and kept blowing back into the rooms. They cleaned all the return vents and ran brushes through the supply runs. Tidy, professional, and the air noticeably improved. Glad I didn't try to DIY this one.",
          "name": "Iggy R.",
          "date": "2024-10-08",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "No-pressure, no-gimmick service. They quoted the dryer-vent cleaning honestly, pulled out clumps of lint from the full duct run, and the price never budged. The tech showed me photos of the cleared vent hood. Fast, fair, and trustworthy.",
          "name": "Desmond C.",
          "date": "2024-08-26",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Good service but one hiccup worth mentioning. The cleaning of the ducts in our newly purchased home, prior owner smoked, was genuinely excellent and the smell is gone. The only thing is I had to call back twice to confirm my appointment because the first callback never came. Maureen sorted it out and was apologetic. The actual technician was fantastic and very thorough on every vent run.",
          "name": "Damon E.",
          "date": "2024-04-25",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "We have a long vent run that exits through the roof, and it had gotten so clogged the dryer would overheat and clothes took forever. The technician brought the right equipment for the height, cleared the entire line plus the cap, and gave me a written report noting the airflow improvement. Single cycle drying now and the unit runs noticeably cooler. Great attention to detail.",
          "name": "Imani G.",
          "date": "2025-11-27",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "New homeowner, new fireplace, zero experience. The crew was respectful with shoe covers and drop cloths, and the tech took time to point out the smoke shelf and damper so I'd know the parts. Cleaned a heavy creosote layer and left a written report. Small thing, but the office had to call me back twice to confirm the appointment which was a tiny bit of a hassle. Service itself was great and I learned a lot.",
          "name": "Camille J.",
          "date": "2025-06-21",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Decent value and friendly folks. The $69 inspection was legit and the report was clear. Took two calls to actually get scheduled, the first callback never came, but Maureen sorted it out the second time and the service itself was great. Creosote was light, no repairs needed.",
          "name": "Ibrahim D.",
          "date": "2023-09-13",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Four seasons of dependable service. Diego swept the chimney, cleared the smoke shelf, and double-checked the damper operation before leaving. He laid drop cloths over the whole living room floor. Consistency like this is hard to find these days, and it keeps me loyal.",
          "name": "Yolanda S.",
          "date": "2023-08-11",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "My wife is sensitive to smoke and our fireplace had always let a little drift into the room, so we finally called to get it sorted. The technician did a full inspection, found the damper wasn't seating properly and there was creosote restricting the upper flue. He swept it thoroughly, removed the buildup, and adjusted the damper so it sealed correctly. Then he ran the camera to show me the clean liner end to end. He spent extra time explaining how to build a top down fire to reduce smoke at startup, advice that's genuinely worked since. Drop cloths covered the whole hearth area and cleanup was spotless. The written report with photos arrived that evening. For a family owned shop they treated our home like it was their own. Couldn't be happier with how it turned out.",
          "name": "Oscar B.",
          "date": "2026-05-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Every fall we get our chimney swept here and this year was no different. The flue had a heavier creosote layer than usual and the technician took his time, brushing it thoroughly and vacuuming up after. He showed me photos of the clean flue and confirmed the damper was sealing properly. Maureen was lovely on the phone setting it all up. Dependable folks who clearly take pride in their work.",
          "name": "Genevieve A.",
          "date": "2025-10-02",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Found these folks through a recommendation in our neighborhood group chat. Half the street has apparently used them. Hector did our air duct cleaning, hitting every return vent and the long duct run to the upstairs bedrooms. He showed me the filthy before photos and the spotless after. Air feels noticeably fresher and there's way less dust settling on the furniture. Friendly, efficient, and respectful of the house.",
          "name": "Dominic E.",
          "date": "2024-07-22",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Spotless work prepping the firebox for our gas-log set. Drop cloths down, creosote swept out, smoke shelf cleared, and a level-2 inspection to confirm everything was safe. In and out professionally. Will use again.",
          "name": "Yolanda E.",
          "date": "2024-03-06",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Sergei did an outstanding job. The duct was about half blocked with lint, and the exterior vent had no screen so insects kept getting in. He cleaned the entire run, installed a new vent hood with a pest guard, and resealed the wall opening. Quick, neat, and friendly.",
          "name": "Damian K.",
          "date": "2024-04-26",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Toasty and ready for company. The technician swept the chimney, cleaned the smoke shelf, and showed me before/after photos of the flue. We've been enjoying fires every evening since. Lovely way to spend the cold months.",
          "name": "Selena G.",
          "date": "2024-11-15",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Mikhail is a craftsman. He repointed some crumbling mortar, installed a new stainless cap, and waterproofed the entire chimney stack. Sent me a detailed written report with photos of the smoke shelf and flue liner. The work has held up flawlessly through a brutal winter. Worth every penny.",
          "name": "Anneliese G.",
          "date": "2025-12-19",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Wildlife had turned our chimney into an apartment complex. Carlos handled it all, removing the nests and debris, sweeping the liner, and capping the top with a stainless cap and screen. He was thorough and clearly knows his trade after years of doing this. Reasonable and reliable.",
          "name": "Edmund C.",
          "date": "2024-04-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Prompt response to my request and an easy booking. Tech showed within the window, used shoe covers, swept and inspected the chimney, and left a written report. Minor note: I got a callback a day later than promised initially, but once they reached me everything moved fast and the service was great.",
          "name": "Hector A.",
          "date": "2023-11-16",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "As a landlord I appreciate vendors who show up and just handle it. The BHO crew cleaned both dryer vents in my duplex, vacuumed the lint traps, and photographed the buildup they removed from the duct runs. No mess left behind thanks to drop cloths. Easy to recommend for rental owners.",
          "name": "Theo J.",
          "date": "2026-01-27",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Long second-floor run terminating at the roof. The technician measured airflow first, did the cleaning, then measured again to prove the improvement. Lint pulled from the upper elbow was alarming. Tidy, courteous, and clearly experienced with these harder jobs.",
          "name": "Omar G.",
          "date": "2024-11-08",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Honest mason. Our chimney on a 1935 tudor looked rough but he said only the top two feet needed a rebuild and the rest just needed repointing. Could have upsold a full teardown. Did the partial rebuild and tuckpointing for a fair price. Mortar match is great.",
          "name": "Geneva P.",
          "date": "2024-10-16",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Couldn't be happier. We combined the dryer-vent service with a full air-duct cleaning. Raj spent extra time on the long vent run that snakes through our crawlspace, where most of the lint had collected, and the dryer is performing like new. He wore shoe covers, kept drop cloths down, and left zero mess. The before/after photos were a nice touch and confirmed the money was well spent.",
          "name": "Yolanda M.",
          "date": "2025-11-26",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Cracked crown, corroded cap, and saturated brick from years of neglect. The team tackled all of it in one go, repointing the worst mortar joints and finishing with a quality masonry waterproofing. They laid drop cloths from the door to the hearth. Professional from start to finish.",
          "name": "Trevor M.",
          "date": "2024-11-15",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Careful with the furniture, careful with the floors, careful with everything. They covered the sofa and bookshelf with sheets, ran a runner across the hardwood, and removed a thick creosote glaze without a trace of mess. The before and after photos in the written report were a nice touch.",
          "name": "Yara M.",
          "date": "2026-03-19",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Bought our first home and didn't know the first thing about chimneys. Devin treated us with patience, showed the flue liner condition on his tablet, and the written report was easy to follow. Made us feel like informed buyers instead of overwhelmed ones.",
          "name": "Adaeze O.",
          "date": "2023-06-04",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Constant sneezing in the mornings finally has an explanation. The duct cleaning pulled out years of fine dust the previous owners left behind. The technician showed me the before/after photos of the supply runs and they were night and day. My antihistamine use is way down. Very pleased.",
          "name": "Sofia L.",
          "date": "2026-05-02",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Great experience start to finish. Smoky smell traced to a leaky damper and soot on the smoke shelf. Cleaned, sealed, fixed. Strong draft now and zero odor.",
          "name": "Felicity O.",
          "date": "2026-05-01",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Family business that clearly takes pride in the work. After a musty smell appeared near our return vents, Tyler cleaned the entire system and applied an antimicrobial sanitizer. Tidy, on time, honest pricing.",
          "name": "Otis J.",
          "date": "2024-04-09",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Honestly didn't expect such a big difference. We'd been battling dust and my wife's asthma for years. The technician went room by room, vacuumed each vent, and the gunk that came out of the main duct run was incredible. House feels fresher and she's needing her inhaler far less. Highly recommend.",
          "name": "Quincy E.",
          "date": "2026-05-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Wood stove cleaning done right. Cleared the creosote, verified the liner integrity, and left the hearth spotless. Quick and easy.",
          "name": "Priscilla Q.",
          "date": "2023-03-22",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Reluctant to hire another sweep after the disaster last year, soot everywhere and a half-done job. This time the crew laid drop cloths, wore shoe covers, swept the flue completely, and the fireplace was immaculate. They also caught a hairline crack in the crown the other company missed entirely.",
          "name": "Reginald U.",
          "date": "2024-07-14",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "What a thoughtful crew. My eyesight isn't what it was, so the technician described everything aloud as he inspected the chimney, then printed the report in larger text for me when I asked. He pointed out the damaged damper and walked through the repair options without any pressure. Maureen was equally patient when I called to schedule. Truly a comfort to deal with people who slow down for us older folks.",
          "name": "Marjorie V.",
          "date": "2026-02-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Our chimney took a beating in the ice storm and I figured the crown was cracked. Omar confirmed it, did a clean crown repair, replaced the storm-damaged stainless cap, and verified the flashing seal. He explained freeze-thaw damage in a way I actually understood. Top-notch service from start to finish.",
          "name": "Felicia Q.",
          "date": "2026-03-27",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "We bought an older home and had no idea when the dryer vent was last cleaned. The answer, judging by the lint, was never. The technician cleared the full run from the laundry room to the side wall hood and pointed out where the duct had a sag collecting debris. Clothes dry beautifully now and the laundry room doesn't feel like a sauna.",
          "name": "Lucia E.",
          "date": "2026-02-14",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Everything about the scheduling was smooth. Maureen booked the $69 inspection, sent a reminder the day before, and the tech arrived right inside the window. He went over the chimney crown, cap, and damper and left a clear written report. Easy to recommend for the communication alone.",
          "name": "Cyrus D.",
          "date": "2024-05-27",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Callback to confirm took a day longer than expected, but the actual sweep was excellent. Nikolai cleared the flue and tidied up completely. Pleased overall.",
          "name": "Wanda Z.",
          "date": "2024-03-08",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Spotless new build, dusty ducts. Simple as that. The crew vacuumed every supply and return run, pulled out leftover sawdust, and gave me a written report. Floors protected the whole time. First duct service done and I feel good about the air we're breathing.",
          "name": "Damian U.",
          "date": "2026-02-28",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "We sanded and painted half the house during our renovation and the ducts paid the price. Eli pulled out so much fine drywall powder and sawdust that I was embarrassed. He covered the floors, wore shoe covers, and gave me a clear written report at the end. The air feels brand new. A genuinely family-owned outfit that takes pride in the work.",
          "name": "Selene Q.",
          "date": "2026-05-15",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Genuinely impressed by the transparency here. Maureen explained every line of the estimate before scheduling, and Victor stuck to it exactly. He removed the creosote, inspected the liner with a camera, and showed me the footage on his tablet. When I asked whether I should replace the cap he said mine was still solid and didn't need it. That kind of honesty is rare. Spotless work, fair price, zero upselling.",
          "name": "Larissa J.",
          "date": "2026-05-18",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Bought a home with serious pet odor in the vents, three cats apparently. The team cleaned every duct, vacuumed the returns, and the place smells brand new. Professional and on time.",
          "name": "Ingrid S.",
          "date": "2025-06-21",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Could not get a load dry in under two cycles and the dryer was hot enough to make me nervous. Ramon arrived on time, traced the duct run, and discovered the exterior vent hood flap was stuck and packed with lint. He cleaned the whole line and freed the flap. Everything dries in one cycle now and the machine stays cool. Polite and knowledgeable throughout.",
          "name": "Ferdinand C.",
          "date": "2026-05-02",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Our first house came with a beautiful old fireplace we were afraid to use. Luis inspected the crown and liner, cleared the creosote, and explained everything in terms a beginner could follow. Reassuring and professional.",
          "name": "Theo M.",
          "date": "2023-12-11",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Reasonably priced and genuinely useful. They inspected the chimney crown and cap, found the creosote was minor, and swept it for less than I expected. A family business that treats you like a neighbor.",
          "name": "Talia E.",
          "date": "2025-05-19",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Been a customer since 2020 and the masonry repair they did on our crumbling mortar joints two years ago still looks great. This year's sweep and flue liner inspection came with the usual detailed report. Minor scheduling hiccup early on, but Maureen sorted it quickly. Trustworthy crew.",
          "name": "Nathaniel Q.",
          "date": "2025-06-17",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Ours is a prefab fireplace and I'd struggled to find a company willing to service it properly. BHO not only took the job but the technician clearly knew these systems well. He inspected the metal flue, the cap, and the firebox panels, checking for any cracks or gaps that could be a hazard. There was a moderate creosote layer he removed carefully without damaging the panels, and he replaced the spark arrestor screen on the cap that had rusted through. He documented it all with photos in a written report and explained the lifespan I should expect from the unit. Shoe covers and drop cloths the whole time. He answered every question patiently and never pushed extra services. Finding someone who handles prefabs this competently was a relief, and I'll be calling them every year now.",
          "name": "Tamara G.",
          "date": "2023-12-08",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Mostly great as always for our yearly sweep. The only hiccup was a callback delay, I left a message to reschedule and didn't hear back for two days. Once we connected though, the service itself was top notch. Tech cleared the creosote, checked the flue liner, and left no mess at all. Minor scheduling bump aside, still a company I trust.",
          "name": "Quentin B.",
          "date": "2024-04-22",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Trusted my neighbor's word and booked the inspection. The tech was matter-of-fact and clear, walked the flue with a camera and gave me a written report. Reasonable. No complaints.",
          "name": "Beatrix O.",
          "date": "2023-11-04",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "After a minor scheduling mix-up where my appointment got moved a day, BHO more than made up for it. Kevin did a meticulous chimney sweep and level-2 inspection before our gas insert went in, removing creosote and checking the flue liner. The written report was excellent and the office was apologetic about the date change.",
          "name": "Desmond U.",
          "date": "2025-10-15",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Really impressed with this family-owned outfit. They cleaned our long basement duct run thoroughly, pulling out compacted lint, then replaced the exterior flapper that birds had wedged open with a new hood and pest screen. The tech wore shoe covers and laid a drop cloth by the dryer. Honest pricing and great communication throughout.",
          "name": "Saanvi G.",
          "date": "2025-05-13",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Hosting the whole extended family for the holidays and the fireplace needed to be perfect. Jordan did a full sweep, removed glazed creosote, sealed a small crown crack, and added waterproofing before the snow set in. He walked me through the written report line by line. The den is the coziest it's ever been and everyone gathers there after dinner. Genuinely impressed with 50 years of know-how at work.",
          "name": "Mathias U.",
          "date": "2025-12-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quick and courteous, Dmitri cleaned our fireplace and chimney in one visit. He noticed the cap had bent in a storm and replaced it without an upcharge surprise. Drop cloths down, shoe covers on, area cleaner than when he arrived.",
          "name": "Ravi B.",
          "date": "2024-05-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Birds nesting in the flue had us worried about a fire hazard. The technician cleared the nest, removed all the dry twigs and leaves that could ignite, swept out the creosote, and installed a stainless cap with a screen. He took the time to explain everything and showed me photos. The callback after I left a voicemail took an extra day, but the actual service was excellent and worth the small wait.",
          "name": "Rosalind G.",
          "date": "2025-10-22",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Reliable from the first call. I needed creosote removed before lighting my first fire of the season and they fit me in the next morning, dead on time. Felix was efficient, courteous, and showed me the buildup he cleared. Quick and clean.",
          "name": "Renata J.",
          "date": "2024-10-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Our condo association needed all the in-unit dryer vents serviced and BHO managed the whole project. They coordinated access with each owner, cleared every duct run and vent hood, and delivered a single consolidated report. Tenants and owners alike noticed shorter dry times. Outstanding multi-unit service.",
          "name": "Vivian E.",
          "date": "2023-09-07",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Tight crawlspace, long run, the kind of job that takes patience. Sam worked at it steadily and cleared a stubborn blockage near a bend. He was polite and laid down protection at the dryer. It did run a bit past the estimated time, but he made sure the airflow tested strong before packing up. No complaints about the quality.",
          "name": "Yvonne C.",
          "date": "2025-04-30",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Tuckpointed our historic district home's chimney to code with the township's mortar requirements. They knew exactly what was needed for a designated historic property, used lime mortar, and provided documentation. Yuval handled the whole thing smoothly. Highly recommend if you own an older home.",
          "name": "Anselm C.",
          "date": "2025-08-07",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Top-notch. Air ducts and dryer vent in one appointment with Joey, who clearly knows his trade. He showed me the debris from each return vent and a written summary afterward. Very satisfied.",
          "name": "Cormac B.",
          "date": "2025-02-09",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "After a windstorm tore our chimney cap off, rain started leaking down the flue within a week. BHO came out fast, installed a custom stainless cap, and while up there caught a crack in the crown that needed sealing too. They waterproofed the surrounding brick as a precaution. Honest crew, fair pricing, and a written report I could file with insurance.",
          "name": "Rosalind E.",
          "date": "2025-04-03",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Lint was packed solid in the run and they cleared it all without scattering a bit. Plastic was taped around the vent opening, and they swept the floor and wiped the machine top afterward. Clean, quick, and respectful of my tight laundry nook.",
          "name": "Otis J.",
          "date": "2023-08-15",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Coordinated a pre-sale chimney inspection with Maureen and it slotted in nicely before our open house. Crew checked the crown, the cap, and the masonry joints, flagging only minor tuckpointing in the written report. Buyers appreciated the transparency and it helped the deal move quickly.",
          "name": "Bjorn H.",
          "date": "2024-09-19",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Dryer vent was the focus but the air-quality angle sold me. Lint had packed the run almost solid, which the technician said was both a fire risk and a humidity problem feeding mold. After cleaning, the laundry room no longer feels swampy and the musty smell upstairs cleared. He showed me the cleared lint trap and full duct. Reassuring work.",
          "name": "Hugo D.",
          "date": "2025-03-26",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Took two calls to get scheduled because the first callback slipped through the cracks, but once Maureen sorted it out everything was smooth. The tech found our downdraft was from a damper that had rusted into a half-open position. He replaced it and the smoke smell that had bothered us for months disappeared. Solid work despite the rocky start.",
          "name": "Rashid N.",
          "date": "2024-07-04",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Pretty happy with the duct cleaning and sanitizing. Got rid of a moldy smell that had been hanging around the hallway vent. Tech was polite and put down drop cloths. Arrival window was a bit wide but the actual visit went well.",
          "name": "Naomi C.",
          "date": "2023-11-18",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Scheduling took a couple of callbacks to nail down, which was slightly frustrating, but the actual cleaning was excellent. The tech cleaned every supply and return vent, showed before/after photos, and was very respectful of the house. My allergy sniffles have eased and there's noticeably less dust settling.",
          "name": "Tabitha J.",
          "date": "2023-10-19",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Called about poor draft on our insert and the technician diagnosed it as creosote buildup combined with a damper that wasn't fully opening. He cleaned the liner, freed up the damper, and explained how to maintain a cleaner burn going forward. The before and after photos made the buildup crystal clear. Stove drafts beautifully now and we're using noticeably less wood.",
          "name": "Malcolm R.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "I compared them against the company my landlord used and it's night and day. BHO actually explained the creosote risk, swept it all out, and tested the damper. The written report was detailed enough that even my insurance was satisfied. Professional from the first call with Maureen.",
          "name": "Annika G.",
          "date": "2023-12-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Trustworthy and unhurried. At 79 I appreciate that the young man explained the whole chimney sweep before he started and showed me the creosote on the brush afterward. No mess left behind thanks to the drop cloths. He even reminded me to keep the damper closed when not in use. Considerate.",
          "name": "Ralph S.",
          "date": "2024-11-26",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Limb fell during a storm and clipped the chimney. Patrick checked the cap, crown, and flashing same week. Minor cap dent, easy fix. Professional and reasonable.",
          "name": "Damian Y.",
          "date": "2025-04-02",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Heavy lint, gone in an hour. The tech was efficient, wore shoe covers, and left the laundry room cleaner than he found it. Showed me the before and after photos of the duct. No more worrying about a fire.",
          "name": "Garrett O.",
          "date": "2023-06-18",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Friendly from the first hello. Maureen walked me through the process, texted a reminder, and called ahead before the tech arrived. The sweep cleared a lot of creosote and the firebox looked brand new. Only minor note is the window was a bit wide, but the heads-up call fixed that.",
          "name": "Felicity U.",
          "date": "2025-06-30",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Fireplace and damper cleaned beautifully. Drop cloths protected the carpet and not a speck of soot escaped. Andre is meticulous. Highly recommend this team.",
          "name": "Theo N.",
          "date": "2025-07-19",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "New construction dryer vent, first time serviced. The cleaning was good and they got the construction lint and dust out of the duct run, then verified the vent hood worked. My one note is that I had to call back twice to confirm the appointment because the first callback never came. Once the tech arrived though, he was polite and did solid work.",
          "name": "Fatima Z.",
          "date": "2025-04-26",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Kitchen gut job left sanding dust drifting out of every vent. The crew showed up, protected the floors, and cleaned each duct run and return. The before and after photos of the supply trunk were eye-opening. Air quality bounced right back.",
          "name": "Bennett U.",
          "date": "2024-02-11",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Reasonable, honest, and clean. The sweep was thorough and the written report on the damper was clear and easy to follow.",
          "name": "Quentin R.",
          "date": "2023-09-14",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "When we moved in, the cigarette smell was overwhelming the moment the AC turned on. The previous owner had smoked indoors for years. Marco came out and did a complete air-duct cleaning, showing me how the residue had built up inside the runs. He was honest about what cleaning could and couldn't fix and didn't oversell anything. By the next morning the difference was dramatic. Appreciated the written report and the fair pricing.",
          "name": "Felicia U.",
          "date": "2024-11-19",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Booked an appointment after the dryer started shutting off from overheating. Diego cleaned out the lint trap housing and the duct run, explaining how the restriction was causing the heat to build. Now it dries in one pass and stays cool. Smooth, professional visit.",
          "name": "Mei Z.",
          "date": "2025-03-21",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Just became homeowners and the wood stove intimidated me. Hector changed that. He walked me through lighting a proper fire, explained why creosote forms and how the cap and liner protect the system, and swept everything spotless. Even showed before and after photos on his phone. The kind of patient teaching every nervous first-timer hopes for. We'll be annual customers for sure.",
          "name": "Anaya R.",
          "date": "2025-09-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Best sixty-nine dollars I've spent on the house all year. The technician didn't just glance up the flue, he ran a camera, showed me the liner condition, and explained creosote buildup in a way that made sense. No upsell at all. He recommended I wait a year on the sweep since buildup was light. That kind of honesty earns repeat customers.",
          "name": "Maxwell C.",
          "date": "2026-03-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Five straight years and counting. There's a real peace of mind in knowing the same honest people are inspecting your flue every fall. Sergei handled the creosote removal and pointed out our cap needed replacing soon, no pressure. Will keep calling 866-501-1614 every season.",
          "name": "Octavia M.",
          "date": "2024-05-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "We'd let our annual sweep slide for two years and it showed. The technician pulled out a heavy creosote load and explained the increased fire risk that comes with skipping cleanings. He inspected the flue liner and crown with a camera, finding a small crack in the crown he photographed for the report. He laid drop cloths across the room and used a HEPA vacuum so there was no dust cloud at all. The sweep was excellent and the report thorough. My only constructive note is that there was a scheduling mix up where my first appointment got bumped a day due to a crew running long elsewhere, but Maureen apologized and got me in quickly after. The actual work and the technician's expertise were first rate, so I'd still recommend them to anyone.",
          "name": "Emerson C.",
          "date": "2025-04-26",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Spotless work on the annual cleaning. Creosote gone, firebox vacuumed, damper checked. Quick and courteous. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Tabitha E.",
          "date": "2023-12-09",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "After a neighbor mentioned how BHO saved her from a chimney fire risk, I scheduled right away. Mikhail arrived, swept out an alarming amount of creosote, and explained exactly why annual cleaning matters for the type of wood we burn. He also checked the damper and the cap while he was up there. The level of detail and the obvious experience, fifty-plus years apparently, gave me real peace of mind heading into winter.",
          "name": "Quentin R.",
          "date": "2025-09-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Just a great local company. Carlos cleaned out our chimney and did the level-2 camera inspection ahead of converting to gas logs. He removed a surprising amount of creosote and showed me before/after photos. Crown and cap both checked. Easy to recommend.",
          "name": "Gwendolyn I.",
          "date": "2026-05-12",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Smooth appointment. The technician brushed out the duct, cleared a lint blockage near the exterior elbow, and installed a new vent hood with a built-in animal guard after we'd had a squirrel nesting issue. Airflow is much stronger now and the new hood looks great on the wall.",
          "name": "Wesley R.",
          "date": "2023-02-22",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Warm fires and zero worry this winter. Quick creosote removal, damper checked, new cap installed. The room finally feels like the holiday haven I wanted.",
          "name": "Daniela R.",
          "date": "2024-12-10",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "From the first phone call with Maureen to Raj finishing the inspection, the whole experience was smooth. Raj scoped the flue with a camera, showed me a small crack in the liner on his screen, and gave me options without pressure. He waited to answer every question I had about creosote removal. Genuinely kind and patient man.",
          "name": "Saoirse M.",
          "date": "2026-04-21",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Phenomenal service. We discovered a nest blocking our chimney right before the cold season and they squeezed us in fast. The tech removed the obstruction, cleaned the flue and smoke shelf, and fitted a new stainless steel cap with a screen mesh. Everything was explained, the price was fair, and the work was spotless. This family-owned company earned a customer for life.",
          "name": "Demetrius Q.",
          "date": "2026-01-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Air duct cleaning done right and done fast. Scheduled it Tuesday for Thursday, crew arrived exactly when they said, cleaned all the return vents and supply runs, and laid drop cloths so nothing got dusty. They wrapped up ahead of the estimated finish time. Easy, punctual, professional.",
          "name": "Quentin M.",
          "date": "2025-02-26",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Manage a rental fourplex with vents running through the attic. The tech navigated the long runs, cleared packed lint, and showed me the haul. Faster drying immediately. Knocked off half a star only because one unit had to be rescheduled, but they communicated well about it.",
          "name": "Rashid U.",
          "date": "2025-03-22",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Our upstairs dryer vents out the roof through a fairly long duct. Devin handled the rooftop work and cleared the cap, which was matted with lint. He explained that long roof runs trap moisture and lint more easily and suggested an annual cleaning. Solid, honest service and a clean dryer area afterward.",
          "name": "Bartholomew K.",
          "date": "2023-05-19",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Crumbling mortar and a cracked crown on our 1928 colonial. The team chipped out the bad mortar, repointed, and poured a new crown with an overhang. They draped drop cloths over the shrubs so falling debris wouldn't damage the landscaping. Small thing but it showed they cared.",
          "name": "Rosalind U.",
          "date": "2023-09-01",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "We needed both done and they made it a single visit, which I appreciated since my schedule is tight. The technician pulled an honestly disgusting amount of lint from the dryer vent hood and run. He also flagged that one of our air-duct return vents was barely pulling air. Good honest work and reasonably priced.",
          "name": "Imani W.",
          "date": "2024-10-30",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Could not find the source of a recurring leak until BHO pinpointed a cracked crown letting water seep into the masonry. They patched the crown, replaced the rusty cap with stainless, and sealed the whole stack with waterproofing. Three months and several storms later, totally dry. Great communication from Maureen on scheduling too.",
          "name": "Kwame B.",
          "date": "2023-12-09",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Spotless is the only way to describe it. Drop cloths covered a wide area, shoe covers went on at the door, and the hearth tiles were wiped to a shine after the sweep. They flagged a worn flue liner in the report but the cleanup itself was perfect.",
          "name": "Salma E.",
          "date": "2025-01-27",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Our real-estate attorney suggested a chimney specialist after the general inspector noted possible flue damage. Tyler confirmed a cracked liner with the camera, measured the creosote, and produced a written report detailed enough to satisfy both parties' lawyers. Worth every penny for the documentation alone.",
          "name": "Marisol E.",
          "date": "2025-04-12",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "My pulmonologist literally asked if I'd had my ducts cleaned recently, so I called BHO. They documented particulate readings, cleaned the whole system, and the numbers dropped sharply. Breathing at night is easier and the air doesn't feel as dry and dusty. Maureen made scheduling painless and the crew was respectful of our home.",
          "name": "Adaeze U.",
          "date": "2024-11-08",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Persistent campfire smell in the living room even when we hadn't used the fireplace in weeks. The technician ran a smoke pencil test and found air was reversing down a flue with a degraded damper seal and no cap. New cap, top-sealing damper, and a thorough creosote removal solved it completely. Detailed written report and honest pricing. These are the people you want.",
          "name": "Beatrix Y.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Couldn't figure out where the musty odor was coming from until the technician scoped our ducts and found mildew growing near a supply run that sat below a leaky window. He cleaned it, treated it with sanitizing fog, and gave me tips to keep it dry. Thorough and patient with all my questions. Air smells genuinely fresh now and I'd trust them again in a heartbeat.",
          "name": "Ezra Q.",
          "date": "2025-06-13",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Great experience overall. Omar cleaned the entire duct system, vacuumed the returns, and pointed out where dust had been recirculating. He wore shoe covers and put drop cloths down everywhere. My morning congestion is gone and I'm not sneezing the moment the AC turns on. Would use again.",
          "name": "Adaeze U.",
          "date": "2025-08-22",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Very pleased. Nikolai came out for our annual wood stove service, swept the flue liner, and removed a season's worth of creosote. He flagged that our stainless cap was starting to corrode and recommended replacing it within a year, but never pressured us. His advice on top-down fire starting has genuinely reduced our smoke and creosote. Honest, knowledgeable, and respectful of our home with the shoe covers and drop cloths.",
          "name": "Delphine O.",
          "date": "2024-11-05",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Three stars to the last guys, five to BHO. Where the previous sweep left glaze on the flue walls, Eli got it spotless and showed me the difference on camera. He spotted a worn stainless cap and gave me an honest, no-pressure quote to replace it. Couldn't be happier.",
          "name": "Damon W.",
          "date": "2025-06-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Gentle hands and a patient manner. Victor scoped my flue liner, found it sound, and told me honestly I didn't need any repairs yet. He explained the stainless cap and why it protects against critters. As an 81-year-old I felt respected and never rushed. Will use again without hesitation.",
          "name": "Phyllis G.",
          "date": "2025-08-13",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "After two back-to-back storms this spring, water marks appeared on the chimney breast inside. The technician traced it to a failed flashing joint, re-flashed it, waterproofed the surrounding brick, and resealed the crown. Before/after photos showed exactly what was done. The interior staining stopped immediately. These folks take pride in their work and it shows in every detail. Maureen in the office was also a pleasure to coordinate with.",
          "name": "Vanessa I.",
          "date": "2025-04-02",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Peace of mind was the whole point and I got it. Ramon explained that the soft, fluffy lint packed in our vent is exactly what fuels dryer fires, then cleared every inch of the run. He tested the dryer afterward to confirm strong airflow at the exterior hood. Friendly, knowledgeable, and respectful of our home.",
          "name": "Naomi T.",
          "date": "2025-04-22",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Maureen got me on the calendar fast for a dryer vent that was barely venting. She sent a reminder, confirmed the morning of, and the tech cleared the lint trap and the entire duct run. My dryer times dropped noticeably. The office communication was clear and reassuring throughout.",
          "name": "Ignatius P.",
          "date": "2023-12-19",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Fifty years of experience really shows. Quick creosote removal, honest inspection, and a clear written report. Maureen was a pleasure to schedule with.",
          "name": "Imani Q.",
          "date": "2024-11-26",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Wanted the air ducts cleaned in our newly finished home before winter. The amount of drywall dust and construction grit that came out of the return vents was eye-opening for a place that looked brand new. Luis brushed each run, vacuumed thoroughly, and walked me through the camera footage. The forced air heat feels cleaner now.",
          "name": "Reginald T.",
          "date": "2023-11-17",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Following our home addition, construction dust kept recirculating no matter how often we changed the filter. BHO did a complete system clean, including the blower compartment packed with sawdust. They were punctual and careful, and Maureen made scheduling painless. The lingering drywall smell is gone and the house finally feels finished.",
          "name": "Anaya C.",
          "date": "2025-12-19",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "What a relief to find an honest chimney company. The price quoted was the price I paid, period. Kevin swept everything, removed years of creosote, and was candid that I should re-line eventually but that it wasn't urgent. He gave me a fair ballpark for when I'm ready, with no pressure to commit. The before and after photos really showed the difference.",
          "name": "Adriana M.",
          "date": "2025-02-08",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Pets, pets, and more pets in this house before us. The dog hair in the ducts was unbelievable. BHO sent a great tech who cleaned the whole system and showed us before/after photos. Allergies way down already.",
          "name": "Roland Q.",
          "date": "2025-02-28",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Years of running everything twice finally pushed me to call. The technician was great, pulled a shocking wad of lint from where the duct bends behind the dryer, and cleaned all the way to the vent hood outside. He showed before and after photos and the difference was night and day. One cycle dries a full load now, and the dryer doesn't get hot anymore. Money well spent for the safety alone.",
          "name": "Gunnar T.",
          "date": "2024-10-09",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Bought the house in spring and finally got around to the chimney before fall. Tech swept the flue, cleared creosote, and explained the damper and smoke shelf. Honest about what we did and didn't need. Great intro to fireplace ownership.",
          "name": "Brandon E.",
          "date": "2025-03-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Affordable, punctual, clean. Jordan handled the $69 inspection and the creosote removal in one visit. Shoe covers, drop cloths, the works. No surprise fees.",
          "name": "Yolanda I.",
          "date": "2024-05-07",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Loyal for several years now. The fireplace cleaning was thorough and they protected the carpet with covers throughout. Dmitri was great. One small thing: a callback I left took a day to be returned, though once reached they were as helpful as ever. Still worth it.",
          "name": "Bartholomew J.",
          "date": "2023-12-14",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Our laundry is on the second floor and the dryer vent runs a long way through the wall to the roof, which had never been cleaned in the eight years we'd lived here. The technician traced the entire duct run, identified two tight bends where lint had compacted, and cleared the whole line with a rotary brush. He cleaned out the lint trap housing and checked the exterior vent hood on the roof, replacing a damaged flap. The volume of lint he removed filled most of a trash bag and he showed me all of it. He explained that a long run like ours should be cleaned annually given the fire risk. Floors were protected and the work area left clean. Dryer performance improved immediately. Knowledgeable and thorough, and the written summary documented everything clearly.",
          "name": "Wanda K.",
          "date": "2024-08-19",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "We've trusted this family-owned outfit with our every-year sweep for a long time now. Felix arrived on schedule, laid down drop cloths, and cleared a thick season of creosote from the flue. He flagged that our chimney crown might need attention down the road but wasn't pushy about it. Honest, careful, and consistent. That's why we keep coming back.",
          "name": "Lorenzo M.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "My mother's bridge partner recommended them and that's about as trustworthy a source as you get. Lovely experience. Tech cleaned the fireplace, swept the flue, and left zero soot behind thanks to the drop cloths. Polite and quick.",
          "name": "Adeline M.",
          "date": "2024-03-15",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "We wanted gas logs and a clean bill of health on the chimney first. Sam's level-2 inspection was incredibly detailed, scoping the full flue and noting a small gap near the smoke chamber. He cleaned the creosote, recommended a sealant before the gas appliance, and sent a written report the same day. Knowledgeable and honest throughout.",
          "name": "Hugo Z.",
          "date": "2024-06-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Outstanding service. We called about poor drying performance and the tech found a severely clogged duct plus a broken exterior flap. He cleaned the whole run, replaced the transition hose, and mounted a new louvered hood with a pest screen to keep the chipmunks out for good. He tested the airflow before leaving and showed me the difference. Genuinely appreciated his thoroughness.",
          "name": "Imani B.",
          "date": "2026-05-25",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Maureen booked us right before the holiday rush and the technician was punctual and tidy. He swept the flue, cleared creosote, and noted the crown looked good in the report. We had a small scheduling mix-up at first where the original slot got moved, but they sorted it quickly and apologized. The fireplace works beautifully now and our evenings are so much cozier.",
          "name": "Walter J.",
          "date": "2025-11-19",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "My elderly mother needed her chimney swept and Yuval treated her with such respect. He explained everything slowly, showed her the before and after photos, and made sure she understood the damper operation before leaving. The kindness meant as much as the spotless work. Thank you.",
          "name": "Dominic A.",
          "date": "2025-07-02",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Quiet, careful, and quick. Cleared a bird nest, swept the flue, installed a stainless cap with screen. Maureen made scheduling easy and the tech was a pro.",
          "name": "Vivienne Z.",
          "date": "2024-02-26",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "After a chimney fire scare I was anxious to get someone out immediately, and they did not disappoint. Maureen took my call, understood the urgency, and dispatched a technician the same day. He inspected the flue liner for damage, did a full creosote removal, checked the chimney crown and cap, and walked me through everything with before and after photos. The speed and the calm professionalism made a stressful situation manageable. Arrived within the promised window and never made me feel rushed despite the quick turnaround. Genuinely grateful for how fast they moved.",
          "name": "Adaeze U.",
          "date": "2026-03-14",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Twelve units, twelve dryers, one very impressed property manager. The crew worked through the building methodically, cleaning each lint trap and full duct run, and left written reports I filed away for the owner. Shoe covers and drop cloths in every apartment. Tenants thanked me for the upgrade.",
          "name": "Daphne I.",
          "date": "2024-10-16",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Complicated run from a second-floor closet across the ceiling and down to a side wall. Joey mapped it, found the lint had built up at the long horizontal stretch, and cleared the entire path. He vacuumed the lint trap housing too. Drying time noticeably faster and the dryer stays cooler.",
          "name": "Ingrid P.",
          "date": "2026-05-18",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Big partial rebuild on a tall double-flue chimney from the 1900s. About a third of it had to come down and go back up. The crew scaffolded safely, matched the brick bond pattern exactly, rebuilt both flue divisions, and put a custom multi-flue stainless cap on top. Three days of careful work and they cleaned the yard each evening. The before and after photos are night and day. Couldn't be happier with how it turned out.",
          "name": "Cornelius B.",
          "date": "2024-07-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Pleasant experience all around. Combined the air-duct and dryer-vent cleaning so we only had to take one afternoon off. Patrick laid out drop cloths, brought a vacuum that could practically suck the paint off the walls, and walked each duct run with a camera. The before/after photos showed just how much dust had built up over the years. He went vent by vent, never cut corners, and explained everything as he went. Will absolutely call them again.",
          "name": "Sebastián R.",
          "date": "2025-06-24",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Noticed efflorescence and damp patches on the chimney brick inside our bedroom. Andre explained how a cracked crown and failed cap were letting moisture migrate through the masonry. He rebuilt the crown, set a stainless cap, and applied a vapor-permeable waterproofing sealer. The brick is finally drying out. Thorough and considerate of our home.",
          "name": "Felicity D.",
          "date": "2026-05-20",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Marco protected our new oak floors with a long runner and put booties on without being asked. He vacuumed every speck of creosote from the smoke shelf, wiped down the firebox, and moved the ottoman back into place exactly where it had been. The room was cleaner when he finished than when he started.",
          "name": "Reginald T.",
          "date": "2024-02-14",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Professional and prompt for our pre-purchase inspection. The written report covered the damper, smoke shelf, and crown condition with photos. Reasonably priced too.",
          "name": "Garrett U.",
          "date": "2024-07-23",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Clean ducts, clean conscience. We have a chronically ill family member so I research everything. BHO's process was exactly what the EPA literature describes, complete with negative-air containment and source removal. The before/after camera footage of the return vents was eye-opening. Symptoms have measurably improved and the report was detailed and honest.",
          "name": "Stellan K.",
          "date": "2025-02-20",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Weak draft and smoke rollback during lighting. Diego found the throat damper was undersized and partially blocked by debris. Cleared it, adjusted the firebox airflow, and recommended a small grate change. Worked perfectly. Tidy and respectful of the house.",
          "name": "Cyrus E.",
          "date": "2024-10-17",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Sanitizing fog completely killed the musty smell in our finished basement. The crew cleaned every duct run and return, covered the floors, and were done in a couple hours. Clean, professional, no mess left behind.",
          "name": "Tahlia M.",
          "date": "2026-04-30",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Two cats and a dusty old house meant my allergies never let up. The crew ran their vacuum through every duct run, cleaned all the return vents, and the amount of dander they pulled out was unreal. Itchy eyes and sneezing have dropped way off. Best home decision I've made in a while.",
          "name": "Sebastian C.",
          "date": "2024-06-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "The crew cleaned our fireplace insert and gave the flue liner a careful inspection. Found some glazed creosote that needed a chemical treatment, which they explained clearly before doing anything. Efficiency advice on wood moisture content was helpful. Decent value.",
          "name": "Stanley I.",
          "date": "2025-06-14",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Genuinely thought all these companies were the same until BHO came out. The other place rushed and missed the smoke shelf entirely. Hector took his time, cleaned everything, and the masonry repair on our firebox is flawless. Fifty years of know-how is not just a slogan with them.",
          "name": "Valentina I.",
          "date": "2024-03-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After my stroke I can't always follow fast talkers, but the technician here spoke slowly and kindly, repeating the parts about the smoke shelf and creosote until I understood. He laid drop cloths over everything and wore shoe covers. The written report was thorough. My wife and I are both grateful for such considerate, gentle service at our age.",
          "name": "Eugene T.",
          "date": "2024-04-30",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Concerned the high winds had loosened our cap, I called and got a prompt appointment. Sergei re-secured the stainless cap, inspected the crown for cracks, and confirmed the flashing was sealed tight. He wore shoe covers and left no mess. Reassuring, professional visit.",
          "name": "Lucas Z.",
          "date": "2024-11-19",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "The actual cleaning was excellent and they got a frightening amount of lint out of our long duct run. My only honest feedback is the arrival window was pretty wide and I waited most of the morning. Once the tech showed up he was great, thorough, and explained the fire risk clearly. Dryer works much better and I'd still use them.",
          "name": "Cody R.",
          "date": "2024-11-30",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Talking to Maureen feels like talking to a friend who happens to be incredibly organized. She booked me, reminded me twice, and made sure I knew the exact arrival time. Mikhail inspected the flue and damper, removed the creosote, and sent photos. The whole office clearly cares about doing right by people.",
          "name": "Saoirse G.",
          "date": "2024-08-04",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Crown waterproofing handled in one visit and the leak is gone. Carlos explained the sealant and gave a fair price. Clean, prompt, professional. Thrilled.",
          "name": "Lars U.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Built our dream home and the ducts were never cleaned after construction. So glad we did this. There was packed sawdust in a couple supply runs and dust coating every register. The technician was meticulous, kept shoe covers on, and emailed a written report with photos. Scheduling with Maureen was a breeze and the price was fair.",
          "name": "Noelani K.",
          "date": "2024-05-30",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Post-reno duct cleaning that actually delivered. Whole house had a drywall haze and the vents were blowing grit. Raj scrubbed every supply and return, vacuumed the trunk line, and showed me the debris he removed. Floors stayed clean under the drop cloths. My family's coughing stopped almost overnight. Phenomenal service.",
          "name": "Quentin J.",
          "date": "2023-10-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Pricing transparency is their strong suit. Got a written estimate, the air-duct cleaning matched it exactly, and they cleaned all the return vents without trying to sell me extras. Tech was punctual and professional.",
          "name": "Wesley T.",
          "date": "2024-11-22",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "We closed on a place where the seller clearly smoked and had a cat. Double trouble in the air ducts. Devin was professional from start to finish, sealed off the supply and return vents, ran his machine through each run, and replaced the filter. He laid drop cloths and wore shoe covers, which I appreciated since we'd just refinished the floors. The smell that hung in the air for weeks is finally gone, and the written report gives us a baseline for next time. Worth every penny.",
          "name": "Tanya O.",
          "date": "2026-02-11",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Good experience overall. Dryer ran hot and clothes took two cycles. They cleared the vent run and trap area and it works great now, one cycle. The only small hiccup was that my first call wasn't returned until the next day, but once connected they were very accommodating.",
          "name": "Valeria H.",
          "date": "2025-06-25",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "We are brand new to having a fireplace and had a ton of questions. The technician answered all of them, from how often to sweep to what seasoned wood looks like. He removed a thick creosote layer, showed me the chimney crown, and left a detailed written report. Scheduling with Maureen was smooth. As first-time owners we couldn't have asked for a better introduction to keeping our chimney safe and clean. Truly appreciated the patience and the no-pressure approach throughout.",
          "name": "Yusra T.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Watching my budget closely after a layoff, so I appreciated that the $69 inspection was exactly that and not a foot in the door for a sales pitch. The tech checked the damper, the cap, and the liner, gave me a written report, and told me straight that everything was in good shape. Honest value when I needed it most.",
          "name": "Cordelia J.",
          "date": "2025-07-11",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Our family has used BHO for the chimney for six years and they never disappoint. This visit covered the sweep, a damper check, and waterproofing the crown ahead of monsoon season. Tyler explained everything clearly and emailed the written report that afternoon.",
          "name": "Delphine A.",
          "date": "2026-04-22",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Bought a fixer upper with a fireplace that hadn't been used in who knows how long, and I wanted a professional opinion before lighting anything. The technician did a comprehensive inspection, running the camera the full length of the flue liner and examining the damper, smoke shelf, and crown. He found an old animal nest, significant creosote, and a missing chimney cap, all of which he documented with photos. He cleared the nest, performed a full creosote removal and sweep, and quoted a fair price for a new stainless cap. What impressed me was how he prioritized the findings into must do now versus monitor later. The written report was the most detailed I've ever seen, with each flue section labeled. Drop cloths and shoe covers throughout. I now feel completely confident using the fireplace this winter.",
          "name": "Julius M.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Yearly maintenance done right. The tech swept the flue, removed all the creosote, and even gave the smoke shelf a good clearing. In and out, clean and professional.",
          "name": "Saoirse D.",
          "date": "2024-09-16",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Picked them because three neighbors on our street use them every fall. Dryer vent was completely clogged with lint and the tech cleared the entire run out to the vent hood on the side of the house. He showed me the wad of lint he pulled, honestly scary how much there was. Clothes dry fast now.",
          "name": "Hassan B.",
          "date": "2025-04-25",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Maureen got us scheduled within the week. Technician swept the flue, removed creosote from the firebox and smoke shelf, and performed a level-2 inspection before our gas-insert install. Tidy, courteous, and the report was clear. Minor note: the quote over the phone was a touch lower than the final, though they explained the difference reasonably.",
          "name": "Priscilla J.",
          "date": "2025-03-28",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "From scheduling with Maureen to the finished job, everything was easy. Omar cleared a massive lint clog from our duct run, vacuumed the lint trap cavity, and installed a new metal exterior hood with a built-in pest guard since the old one had rusted open and let bugs in. He explained the fire risk of the buildup very clearly. Dryer is running cool and fast again. Five stars.",
          "name": "Cole F.",
          "date": "2024-12-08",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Holiday-ready in one visit. Nikolai removed the creosote, replaced the stainless cap, and checked the flue liner top to bottom. First fire of the season was clean and drew like a dream. Cozy nights ahead.",
          "name": "Imani C.",
          "date": "2024-12-16",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Eli handled a difficult dryer-vent job where the run went up two floors. He cleared a serious lint blockage, cleaned the trap, and resealed the vent hood. The arrival was about forty minutes past the window, which he apologized for, but the quality of work more than made up for it. Knowledgeable and friendly throughout.",
          "name": "Tatiana R.",
          "date": "2024-08-26",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "We'd been hearing flapping in the chimney for weeks. Victor came out, found a large nest wedged in the flue, removed it carefully, vacuumed the debris off the smoke shelf, and installed a new stainless cap with a screen. He was meticulous about laying drop cloths and even cleaned a bit of soot off the hearth that wasn't really his job. Honest pricing, no upsells. Exactly the kind of service you hope for.",
          "name": "Bartholomew U.",
          "date": "2025-06-08",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Punctual and painless. Got a same-day slot, the tech arrived on time, swept the firebox, and cleared the damper of debris. In and out without disrupting my whole day. Exactly what I wanted.",
          "name": "Logan K.",
          "date": "2025-06-13",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Decent dryer-vent cleaning for my three rental units. The actual work was good and they cleared a lot of lint from the runs. My only constructive note is that it took two callbacks to get my final invoice sorted out. Once corrected, the pricing was fair and the cleaning was solid.",
          "name": "Emmett G.",
          "date": "2026-04-30",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Roof-terminated dryer vent on a steep two-story. Ramon was harnessed and methodical, brushing from the cap down while watching the lint clear at the dryer end. He showed me a thick clump that had nearly sealed the pipe. Strong airflow restored and the burning smell is gone. Knew exactly how to deal with the long vertical run.",
          "name": "Quentin A.",
          "date": "2024-02-28",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Spalled brick on the chimney of our 1940s cape. Luis replaced the failing units, repointed, and explained that the original mortar was too hard a mix for the soft brick, which caused the spalling. Used a softer compatible mortar this time. Learned something and got quality work.",
          "name": "Delphine R.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Good service, just one hiccup. The first appointment got bumped due to a scheduling mix-up, but Maureen called to apologize and squeezed us in two days later for both the ducts and the dryer vent. Once here, the tech was fantastic and cleared a thick lint clog from the run.",
          "name": "Tova E.",
          "date": "2024-03-13",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Solid masonry waterproofing and crown repair on a chimney that had been leaking into the firebox. The new stainless cap looks sharp. Only small thing was the initial estimate visit and the actual repair were a week apart, a touch longer than I hoped. But the work was clean and the leak stopped cold.",
          "name": "Algernon S.",
          "date": "2024-03-21",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "It took a callback to confirm my slot, which was a minor hiccup. The visit itself, though, was beautifully clean. Kevin covered the rug and the side table, swept the flue with no dust escaping, and left the hearth spotless. Friendly and careful throughout.",
          "name": "Greta P.",
          "date": "2026-05-02",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Putting an inherited property on the market meant a lot of unknowns, including a fireplace nobody had used in decades. The technician inspected the flue, found a bird's nest and creosote, and laid it all out in a written report we could share with prospective buyers. Their honesty and the clear documentation made disclosing the chimney's condition simple. The whole crew was courteous and respectful of an old family home.",
          "name": "Cordelia M.",
          "date": "2026-03-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Air felt fresher within hours. Jordan cleaned all the duct runs and the blower, and explained which filter would best capture allergens. My eyes stopped feeling gritty in the mornings. He was on time, courteous, and left no trace behind. Good value for the peace of mind.",
          "name": "Janelle S.",
          "date": "2026-03-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Every time the dryer or kitchen fan ran, smoke smell came down the chimney. Dmitri explained the depressurization issue and showed me the damper wasn't sealing at all. He installed a top-mount damper with a cable control and the odor is completely gone. Appreciated how patiently he answered my questions.",
          "name": "Mireille J.",
          "date": "2026-01-28",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "After a sewer backup we were terrified about lingering odors and mold in the ductwork. Felix reassured us, scoped the entire system, cleaned the affected runs, and applied a heavy antimicrobial treatment. Provided a detailed written report with photos. The smell that had us gagging for a week is completely gone. Cannot thank this team enough for getting us scheduled so quickly.",
          "name": "Wesley B.",
          "date": "2024-08-21",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Clean, courteous, effective. Vacuumed the supply lines and returns, showed me photos, done in no time. My asthma's been quieter ever since.",
          "name": "Renata I.",
          "date": "2026-03-27",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "After three years of neglecting our wood stove, I finally called and I'm so glad I did. The technician was almost apologetic about how much creosote he pulled out, but he handled it with total professionalism. He inspected the liner end to end, checked the cap, and laid out a maintenance schedule. The efficiency tips, especially about loading the firebox properly and using a moisture meter on the wood, have transformed how the stove performs. Warmer house, cleaner glass, less wood used. Outstanding work.",
          "name": "Genevieve U.",
          "date": "2025-08-23",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Cautious after a chimney company overcharged us and underdelivered, we got BHO for a second opinion. They were honest about what actually needed doing, did a careful sweep, and the price was fair. Slight callback delay when I had a follow-up question, but otherwise far superior to the first company.",
          "name": "Bartholomew K.",
          "date": "2025-08-12",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Lovely from the first phone call. Maureen explained things clearly and the young man who came was a true gentleman, patiently walking me through the dryer vent cleaning and showing me the lint that had collected in the trap and the vent hood. He never made me feel rushed even though I'm slow these days. Honest, gentle, dependable.",
          "name": "Irene P.",
          "date": "2025-01-09",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Storm-damage follow-up done right. The crew assessed the crown, cap, and flashing, found the crown sealant had eroded after years of weather, and applied a fresh waterproof coat. Detailed written report. No pressure, just facts.",
          "name": "Yolanda B.",
          "date": "2023-06-12",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "A genuinely reassuring experience. Our dryer had started taking forever and the cabinet got hot, both red flags for a clogged vent. The technician disassembled the machine, cleared the internal lint near the heating element, then ran his brush the full length of the duct to the roof vent. The pile of lint was sobering. Everything was photographed, cleaned up, and the dryer now runs cool and quick.",
          "name": "Beatrice W.",
          "date": "2025-08-15",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Reaching a real human on 866-501-1614 was refreshing. Maureen explained the inspection, set the appointment, and sent a reminder text I actually appreciated. The tech wore shoe covers, swept the chimney, and reviewed the written report with me. Smooth communication from booking to finish.",
          "name": "Barrington H.",
          "date": "2026-05-25",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Return vents and the whole duct system cleaned out. So much less dust now. The crew was respectful and bagged everything neatly. Excellent value.",
          "name": "Carmen I.",
          "date": "2026-05-08",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "First dryer vent service on a house we just built. Tech found leftover packing foam in the lint trap area and construction dust lining the duct run. Cleared it all, confirmed strong airflow at the exterior hood, and was in and out cleanly. Dryer is running great now.",
          "name": "Vincent A.",
          "date": "2026-05-18",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "They did a thorough job clearing sawdust and drywall dust from our ducts after the remodel. Honest work and friendly techs. Only minor note, there was a small scheduling hiccup where my first slot got bumped, but they got me in two days later and the cleaning itself was excellent, return vents and all.",
          "name": "Maya E.",
          "date": "2024-08-03",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Very fair pricing and no pressure at all. The technician inspected the flue, swept out the creosote, and gave me an honest assessment that my chimney was in great shape. The one small thing was a scheduling mix-up, my first appointment got bumped a day due to an overbooking, but Maureen handled it gracefully and threw in a small discount for the trouble. Honest people who own their mistakes.",
          "name": "Camille B.",
          "date": "2025-09-19",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Reliable and friendly. New house, old dog smell in the vents. The crew cleaned everything out, showed me photos, and the air smells fresh. Scheduling with Maureen was easy too.",
          "name": "Conrad I.",
          "date": "2024-07-30",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Prompt, courteous, and effective. The dryer had been overheating and needing multiple cycles for months. The tech cleaned the entire duct, removed a dense plug of lint at the wall transition, and tested airflow afterward. Dries in one cycle and runs cool now.",
          "name": "Desmond A.",
          "date": "2026-04-15",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "First time owning a wood-burning fireplace and I was anxious about doing it wrong. Sam made it easy, explaining the flue liner, the creosote stages, and how to build a fire that burns cleaner. No mess at all.",
          "name": "Colin W.",
          "date": "2025-04-11",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Great bang for the buck. Inspection was $69 flat, the sweep was reasonable, and the duct work they quoted was fair too. No pressure to bundle anything.",
          "name": "Felipe Z.",
          "date": "2024-08-28",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Three years of annual sweeps, same excellent result each time. The technicians clear the creosote, inspect the flue liner, and leave no mess behind. I've recommended them to half my street already. A genuinely trustworthy outfit with decades behind them.",
          "name": "Cyrus T.",
          "date": "2024-10-30",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Scheduled the sixty nine dollar inspection mostly out of caution since we'd just had a baby and wanted to make sure everything was safe. Yuval was patient and friendly, explaining that a fireplace with poor draft can pull combustion byproducts back into the home. He inspected the flue, found a light creosote layer and a damper that was sticking, then swept the flue and lubricated the damper so it operated smoothly. He confirmed the stainless cap was in good condition. Everything was documented with before and after photos in the written report. He was careful with drop cloths and shoe covers since we have a crawling baby. The only minor thing was the report took until the next afternoon to arrive, slightly later than promised, but it was worth the wait for how thorough it was. Reassuring service overall.",
          "name": "Renata P.",
          "date": "2023-05-16",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Our go-to for the annual chimney cleaning year after year. This visit the creosote buildup was significant after a cold winter, and the technician handled it thoroughly, brushing the full flue and vacuuming every speck. He left a written report and offered a tip about better airflow to slow buildup. Maureen's scheduling is always smooth. Great value and great people.",
          "name": "Augustus K.",
          "date": "2025-02-11",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Neighbor said call BHO, so I did. The callback after my voicemail took a day longer than I expected, but once connected Maureen was great and got me on the schedule fast. The technician was thorough with the sweep and creosote removal, and the firebox was left spotless. A minor hiccup at the start, but the actual service was excellent.",
          "name": "Coraline T.",
          "date": "2024-05-19",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Decades of know-how on display. Joey prepped our chimney for a gas-log conversion, removing glazed creosote and verifying the clay liner with a camera. He explained the level-2 process plainly and left a written report. The hearth was cleaner than before he started.",
          "name": "Mateo R.",
          "date": "2024-01-23",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "The cleaning itself was thorough and the new exterior vent hood with a pest guard works well, no more wasps finding their way in. My only gripe is that the first appointment got bumped a day due to a scheduling mix-up, and I wasn't called until the morning of. That said, the tech who came out was apologetic and did genuinely careful work on the duct run, so I'd still use them again.",
          "name": "Adaeze U.",
          "date": "2025-10-30",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "We bought an old house with a long-neglected fireplace and wanted it safe for our first Christmas here. The crew inspected everything, cleared decades of creosote, replaced a damaged damper, and waterproofed the masonry. The written report gave me real peace of mind. Now the living room is the warmest, coziest spot in the house and we can't stop using it. So glad we called this family business.",
          "name": "Sören K.",
          "date": "2023-12-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Impressed start to finish. Patrick inspected our chimney, found the crown was deteriorating, and scheduled the masonry repair himself. He coated the crown, sealed it, and waterproofed the brick. Every step documented with photos. He even swept the patio where a little debris had fallen. That extra care is rare.",
          "name": "Helga S.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Squirrels had chewed their way in and filled the flue with acorns and leaves. The crew cleared it all, swept the liner clean, and capped the chimney with a stainless steel cap and screen. Professional and friendly throughout. Fair price too.",
          "name": " Feliciana X.",
          "date": "2023-12-07",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Fast response on a weekday morning. They had availability the same afternoon and the technician honored the window without making me wait. Swept the chimney, inspected the flue, and handed me a clear written report. Smooth and efficient operation.",
          "name": "Tabitha S.",
          "date": "2024-04-19",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "BHO cleaned the dryer vents across my five-unit building and the difference was night and day. The tech cleared each duct run, vacuumed the lint trap housings, and flagged one crushed vent line for replacement. Tenants stopped running double cycles. Professional and respectful of every occupied apartment.",
          "name": "Sofia Z.",
          "date": "2024-01-09",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Second-floor laundry, long run, roof termination. Andre cleaned it thoroughly, replaced a missing screen on the vent hood, and left the area cleaner than he found it. Efficient and friendly.",
          "name": "Mariela T.",
          "date": "2025-09-15",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Minor scheduling hiccup where the first appointment got bumped a day due to weather, which is understandable for masonry work since it can't be done in the rain. The repointing and crown rebuild on our older home came out beautifully. Crew was apologetic and the work speaks for itself.",
          "name": "Thaddeus G.",
          "date": "2024-05-18",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Both jobs handled in one efficient visit. The duct cleaning freshened up the whole house and the dryer vent was packed solid with lint. Tech was courteous and tidy.",
          "name": "Bryce N.",
          "date": "2026-03-02",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Our 1920s chimney had a crown that was basically gone and a cap so rusted it crumbled when touched. Marco treated it like his own home, taking time to repoint old joints, recast the crown with a proper overhang, install a stainless cap, and waterproof the historic brick without changing its look. Before-and-after photos were a nice touch. Genuinely skilled craftsmen.",
          "name": "Marisol T.",
          "date": "2025-07-26",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Respectful of the home in every way. Shoe covers at the threshold, drop cloths over the hardwood, and a sheet draped over the nearby armchair. The stainless cap got installed and the creosote brushed out cleanly. Not a smudge anywhere when they left.",
          "name": "Malik D.",
          "date": "2023-11-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Got the $69 pre-sale inspection and it more than paid for itself. Diego spotted a deteriorating chimney crown and a loose stainless cap, both photographed in the written report. We addressed them before listing and avoided last-minute buyer demands.",
          "name": "Yusuf B.",
          "date": "2024-05-17",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Arrival window was wide, roughly four hours, which made the morning tricky, and I'll mention that honestly. But once the technician arrived the work was excellent. He cleaned every register and return vent, showed me the dusty before photos, and the air quality improvement is real. My allergy meds have gone from daily to occasional. Still glad we used them.",
          "name": "Travis B.",
          "date": "2024-08-05",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Smoke smell upstairs was driving us nuts. Inspection revealed creosote buildup and a smoke shelf full of debris plus a damper that wouldn't close fully. Full cleaning and a damper repair fixed it. Before and after photos in the report were a nice touch.",
          "name": "Garrett U.",
          "date": "2025-06-08",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Musty smell in the nursery had me anxious. They cleaned and sanitized the supply ducts feeding that room and the rest of the house, using a treatment safe around little ones. Smell gone, air feels lighter.",
          "name": "Soraya D.",
          "date": "2025-11-25",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "We have a multi-generational household and several of us suffer from allergies. Hector took the time to clean every vent in our large home, sealed registers properly, and provided a detailed written report with before/after photos. The dust reduction is remarkable and Grandma's breathing has improved. A family business that clearly cares about families.",
          "name": "Magnus O.",
          "date": "2025-04-15",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Friendly and efficient. Swept the insert flue, checked the liner, removed creosote, and shared a few good tips on burning seasoned wood. In and out without any fuss.",
          "name": "Rashid Y.",
          "date": "2024-04-16",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Color me converted. Our old sweep never mentioned the creosote was approaching dangerous levels. BHO caught it, removed it thoroughly, and walked us through fireplace safety. The before and after photos were eye-opening. Glad we finally found a company that takes this seriously.",
          "name": "Ophelia R.",
          "date": "2024-05-16",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Good honest people who treat the elderly with real respect. The technician took his time inspecting the chimney crown and masonry, explained where small cracks were forming, and gave me a fair written estimate. He didn't push me to decide anything that day. There was a short delay getting the follow-up call about scheduling the repair, but it came and all was well.",
          "name": "Leonard B.",
          "date": "2024-07-21",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Rough hailstorm prompted me to have the chimney looked at. Sergei was meticulous, examining the crown, the stainless cap, and the flashing inch by inch. He found a small crown crack and a slightly lifted flashing corner, repaired both, and walked me through photos of each. The whole experience felt honest and unhurried. For a family business with decades behind them, the modern documentation and care impressed me.",
          "name": "Curtis A.",
          "date": "2025-08-16",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Knowledgeable crew that clearly knows the fire risks. They found lint packed all the way to the exterior vent hood and a partially crushed section of duct restricting flow. Both fixed in one visit. The dryer is dramatically faster and I no longer dread running a load before bed.",
          "name": "Felix D.",
          "date": "2023-03-10",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Nice people and easy to schedule. The first reminder text didn't come through, a small glitch, but Maureen called personally to confirm so it didn't matter. The sweep cleared the creosote and checked the cap and crown. Friendly office and clear communication once we connected.",
          "name": "Marguerite Z.",
          "date": "2025-01-15",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Sweep was great and the flue is spotless. Scheduling hit a minor hiccup and got moved a day, but they called ahead. Mikhail more than made up for it.",
          "name": "Pablo Y.",
          "date": "2024-08-21",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Moved into our new construction home over the holidays and the HVAC kept stirring up dust. Carlos came out, opened the supply and return runs, and found exactly what you'd expect after a build: drywall powder, sawdust, and grit everywhere. He cleaned and sanitized it all, laid drop cloths, and showed me the difference on camera. Air feels noticeably cleaner now and the sneezing stopped.",
          "name": "Beatriz S.",
          "date": "2025-01-09",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Construction left our duct system full of fine dust that kept settling on the new furniture. Raj ran the negative-air machine, brushed every run, and cleaned the return vents that were gray with drywall powder. Professional and clean from start to finish. Worth it after a big renovation.",
          "name": "Theo K.",
          "date": "2025-05-28",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Knowledgeable and honest. Quoted fairly, swept thoroughly, checked the stainless cap and crown, and never once pushed unnecessary repairs. The invoice matched the estimate down to the cent.",
          "name": "Hector V.",
          "date": "2024-03-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Our newly bought home had a faint smoke smell that got stronger with the heater on. Previous owner was a smoker. The technician from BHO inspected the duct runs, found nicotine residue, and cleaned the entire system thoroughly. He also pointed out our return vents were undersized, just a helpful note, no pressure. The smell is gone and the written report was detailed. Solid family-owned business.",
          "name": "Beatrix M.",
          "date": "2025-04-17",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "What a difference. We were running the dryer two and three times per load and the laundry room would get hot and humid. Devin showed up, cleaned the lint trap slot, then ran a powered brush through the long duct run, capturing all the debris so nothing spread. Single cycle now, dryer stays cool, and the room doesn't steam up anymore. Family-owned and it shows in how they treat your home.",
          "name": "Tabitha R.",
          "date": "2025-08-13",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "As new owners of a 1940s home with the original chimney, we wanted a pro to look at it before lighting anything. The inspection covered the liner, crown, and damper, and the tech patiently explained why the missing cap needed replacing. Found a small amount of nesting debris too. Educational and thorough for two people who'd never dealt with this before.",
          "name": "Mireille D.",
          "date": "2023-10-04",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Genuinely impressed for the price point. After putting off a chimney check for two winters because I assumed it'd cost a fortune, the $69 inspection finally got me to pull the trigger. Tyler was professional, laid drop cloths through the hall, and showed me before/after photos of the creosote he cleared from the flue. He flagged a tiny crack in the crown but said it was nothing to lose sleep over yet. No upsell, just facts. For anyone counting dollars, this is the honest, affordable option.",
          "name": "Saoirse U.",
          "date": "2026-05-12",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "We've trusted BHO with the chimney for years, so the dryer vent was an easy call. They cleared a long duct run that was choked with lint and showed me the pile they pulled out. Dryer cycles are faster now. Same reliable people, different service.",
          "name": "Magdalena R.",
          "date": "2025-02-25",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "After a bad experience with a chain company that did a rushed five minute sweep, I switched to BHO and the contrast was striking. The technician spent a full ninety minutes on the job, inspecting the flue liner, crown, and cap with a camera before touching anything. He found the previous company had missed a substantial glazed creosote deposit near the smoke chamber, which he removed properly using the right tools. He showed me the difference on his screen, then documented everything in a written report with photos. Drop cloths protected the hearth and surrounding floor the entire time. He took the time to explain how to avoid that buildup by burning seasoned hardwood. This is what a real chimney service looks like, and I'm relieved to have found a family run company that does it right the first time.",
          "name": "Cedric T.",
          "date": "2025-09-03",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Routine sweep handled efficiently. There was a small scheduling mix-up where they had me down for the afternoon instead of the morning, but they sorted it out quickly and the tech still came the same day. Once here, he cleared the creosote, checked the damper, and tidied up nicely. Polite crew, just a little disorganized on the booking side this once.",
          "name": "Marisol T.",
          "date": "2024-05-30",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "A friend down the road handed me a BHO magnet off her fridge and told me to call. So glad I did. Omar inspected the chimney top to bottom, found a deteriorating flue liner, and explained my options clearly without any pressure. He took photos of everything and emailed a written report within the hour. The waterproofing add-on was reasonably priced and the whole crew treated my home like their own. Genuinely impressed by the care.",
          "name": "Marguerite S.",
          "date": "2025-12-28",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Outstanding service prepping for our gas insert. Nikolai ran a thorough level-2 inspection, scoped the flue with the camera, removed heavy creosote, and replaced a damaged stainless cap that was a nesting site for birds. He laid drop cloths over the whole living room and left zero mess. The report had clear photos of every issue. Communication from Maureen was excellent too, confirming the appointment twice.",
          "name": "Annika L.",
          "date": "2025-08-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Knew our vent needed attention when the laundry room started smelling musty. The tech cleared the duct of dense lint, replaced the flattened foil hose with rigid pipe, and installed a new exterior hood with a critter screen. Fast and friendly.",
          "name": "Vince M.",
          "date": "2024-06-15",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Cozy season unlocked. Fast, friendly sweep with drop cloths down and shoe covers on. Creosote gone, damper smooth, fire crackling by dinnertime. Perfect timing before the holidays.",
          "name": "Renata B.",
          "date": "2025-11-23",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Eli cleaned the flue and removed creosote efficiently, and his manner was warm and professional. He pointed out that our stainless cap was still in great shape, saving me from an unnecessary replacement. Honest people doing honest work.",
          "name": "Marcel D.",
          "date": "2024-04-03",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Outstanding work. A bird nest had blocked our flue completely and we couldn't use the fireplace. Victor removed the nest, cleaned out all the debris and droppings, swept the chimney, and installed a stainless cap with a screen mesh so it stays critter-free. He showed me before and after photos and left a clear written report. The whole crew respects your home, shoe covers and all. Genuinely good experience.",
          "name": "Ignatius D.",
          "date": "2024-10-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Speedy and trustworthy. My dryer vent was clogged and posing a hazard, so the same-day appointment was a relief. Tech cleared the whole duct run, cleaned the lint trap, and tested the airflow at the vent hood before leaving. On time and quick.",
          "name": "Felipe R.",
          "date": "2025-04-08",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Owning rentals means staying ahead of fire hazards, and clogged dryer vents top that list. The crew serviced all six of my units in a day, cleared the runs back to the wall caps, and gave me photos of the lint removed. Couldn't be happier with the documentation.",
          "name": "Bennett K.",
          "date": "2023-12-13",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our crawlspace duct run is long and genuinely hard to access, so I was glad they took the job at all. The cleaning itself was good and the airflow improved. My only constructive note is that the original scheduling had a hiccup and the first appointment got bumped to the following week, which was a minor inconvenience. The technician who eventually came was thorough and cleared the lint near the exterior vent hood. Polite and professional once on site.",
          "name": "Cyrus B.",
          "date": "2023-12-22",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Repointed and rebuilt the deteriorated shoulder of our 1918 chimney where it steps in. That spot always holds water and was the worst. They sloped the new masonry properly to shed rain and waterproofed it. Solid, lasting fix.",
          "name": "Marguerite K.",
          "date": "2025-06-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Ramon came out for a combined dryer-vent and air-duct appointment and was a pleasure to deal with. He found that our dryer's lint trap area hadn't been reached in years and the vent run was the real culprit behind our long dry times. After clearing it, he tested a load to confirm. Took photos before and after so I could see the difference. Honest, hardworking, and clearly experienced.",
          "name": "Genevieve A.",
          "date": "2025-09-08",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Leak above the fireplace turned out to be a cracked crown, not the roof. They sealed the crown, replaced a rusted cap with stainless, and waterproofed the brick. Quick, clean, and they explained everything. Drip's gone.",
          "name": "Bartholomew R.",
          "date": "2024-06-18",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "The way they protected the furniture impressed me most. Plastic sheeting over the sofa, film on the carpet runways, and corner guards on every doorway as the hoses came through. All the return vents were cleaned and reinstalled, and the floors vacuumed where they worked. Not a particle of dust left on any surface.",
          "name": "Florence A.",
          "date": "2025-07-21",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Smooth experience getting a chimney report for our home sale. The inspector was thorough, courteous, and the written summary was professional. Scheduling took one extra call to nail down a time that worked, a minor hiccup, but the actual visit and report were great. Would recommend to anyone in escrow.",
          "name": "Annika T.",
          "date": "2023-04-18",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Frequent migraines that I now suspect were partly air-quality driven. After BHO cleaned the ducts and replaced our old filter, the dust load in the house dropped noticeably and my headache frequency followed. The technician documented everything with a written report. Calm, knowledgeable, and not pushy at all. Grateful we found them.",
          "name": "Camille Y.",
          "date": "2025-05-13",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Downdrafts in our two-story were sending a sour smoky smell through the vents. Luis diagnosed negative pressure and a chimney cap that had blown off in a storm. He installed a new stainless cap, cleaned the flue, and got the damper sealing tight. Wind howls outside now and not a whiff of smoke inside. Genuinely grateful for the careful diagnosis instead of a guess.",
          "name": "Selena Q.",
          "date": "2024-04-22",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Decent experience. The duct cleaning and sanitizing took care of a faint moldy odor near the upstairs returns. Tech was friendly. Scheduling had a small hiccup where the first appointment got bumped a day, but Maureen called to apologize and the follow-up visit was solid.",
          "name": "Bjorn A.",
          "date": "2024-03-15",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "After moving into a rental that hadn't seen duct cleaning in ages, my asthma flared up badly. Kevin came out, inspected the system, and cleaned out years of dust and debris from the supply and return runs. He was honest and didn't upsell. My symptoms calmed within a week. Truly thankful.",
          "name": "Delphine K.",
          "date": "2024-02-09",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Jordan serviced our wood-burning insert and was meticulous about the whole process. He removed the unit, cleaned the connector and liner, and checked the smoke shelf for hidden creosote. What set this visit apart was the time he spent on efficiency, walking me through how a hotter fire produces less creosote and burns more completely. The written report included photos of every section he inspected. A genuinely thorough and educational experience.",
          "name": "Cordelia X.",
          "date": "2025-03-07",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Best decision after firing the last outfit. They'd left my chimney leaking despite charging for waterproofing. BHO redid it properly, sealed the crown, and treated the masonry. Bone dry through the whole rainy season since. The contrast with the previous company is almost embarrassing.",
          "name": "Xavier C.",
          "date": "2025-10-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Patient as a saint. I asked the young man to explain the creosote removal three times and he did so cheerfully each time. He showed me before and after photos of the flue and never made this 83-year-old feel like a nuisance. Trustworthy folks.",
          "name": "Glenda M.",
          "date": "2025-10-29",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Worried sick after a tornado warning night, I had them out to check everything. The tech inspected the crown, cap, and flashing and found only minor wear, which he sealed. The scheduling had a small hiccup where my first slot got bumped, but they apologized and squeezed me in the next morning. The actual inspection and the written report were thorough and put my mind at ease.",
          "name": "Priscilla M.",
          "date": "2024-02-08",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Such a relief to have this done. My grandmother's house had a dryer fire years ago, so I've always been paranoid about lint. The tech here cleared a vent that was easily half-blocked, showed me the buildup, and reassured me the run was completely clear afterward. Kind, careful, and thorough. The fifty-plus years of experience really shows in how confidently they work.",
          "name": "Sienna K.",
          "date": "2026-05-01",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Maureen deserves a raise. She juggled my reschedule, kept me posted by text, and made the whole booking feel effortless. Dmitri arrived on time, laid drop cloths, swept the flue, and walked me through the report before leaving. Communication was the standout, and the work was excellent too.",
          "name": "Leopold N.",
          "date": "2024-02-28",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Stainless cap secured and creosote cleared in one tidy visit. Felix wore shoe covers and left zero mess. Fast, friendly, fairly priced. Couldn't be happier.",
          "name": "Greta X.",
          "date": "2025-04-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "New home, never had the dryer vent done. The duct run from the laundry to the exterior wall was long and had a couple builder-created bends collecting lint already. Sam cleaned it thoroughly and checked the vent hood flap. Solid work, though the visit ran a bit later in the window than I'd hoped. Dryer performs much better now.",
          "name": "Hamza I.",
          "date": "2024-09-03",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Our flooring and trim install threw sawdust everywhere, including deep in the ducts. The technician was thorough, cleaned all the supply and return vents, and left a written report. Took a couple hours but the air noticeably improved. No more gritty film on the counters.",
          "name": "Rosalind P.",
          "date": "2026-03-30",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "After getting wildly different quotes from three companies, BHO stood out for being the most reasonable and the most honest. Yuval explained that the high quote I'd received elsewhere was for repairs I didn't actually need. He swept the chimney, cleared the creosote, inspected the liner, and showed me a clean written report. The price was fair and there was absolutely no attempt to upsell. I trust them completely.",
          "name": "Priscilla K.",
          "date": "2026-04-22",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Decent experience with a minor scheduling bump. We bought a house with two dogs' worth of fur in the ducts. The cleaning was thorough and the tech was great, showed the before/after shots and all. They did have to push my appointment back a day at the last minute, which threw off my plans a bit, but they called ahead and were apologetic. End result was a much fresher-smelling home.",
          "name": "Sullivan K.",
          "date": "2023-11-14",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Dryer overheating and damp clothes brought me here. Technician cleared the duct and vent hood quickly, showed me the lint pile, and now one cycle does it. Fast and clean.",
          "name": "Esteban M.",
          "date": "2024-02-20",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Picked up the keys to our first home and the fireplace came with a lot of unknowns. Joey cleared the creosote, walked me through the damper, and recommended a stainless cap. Quick, friendly, and a great learning experience.",
          "name": "Sterling B.",
          "date": "2025-07-15",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Came for the cheap inspection, stayed for the honesty. They could've told me I needed a whole new liner and I wouldn't have known better, but the technician said it was fine and just swept the creosote out. Fair people.",
          "name": "Damon Q.",
          "date": "2023-04-26",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Annual customer for four years. The $69 inspection is fair and the sweep is always thorough. Patrick flagged some early creosote glazing and handled it before it became a problem. The before and after photos he shared made the value obvious. Easy people to keep coming back to.",
          "name": "Ignatius W.",
          "date": "2023-03-07",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Our older brick chimney had visible white staining on the exterior and a contractor friend suggested it might be a moisture problem. The BHO technician confirmed it was efflorescence from water penetrating the porous brick, then inspected the crown and found hairline cracks letting water in. He recommended a sweep and creosote removal first, followed by crown repair and waterproofing of the masonry. He walked me through photos of each issue and gave a clear quote with no pressure. Maureen scheduled the follow up repair visit promptly. The crew sealed the crown, applied a breathable waterproofing treatment, and the staining has stopped spreading. Both visits were tidy, with drop cloths and careful cleanup. I appreciated that they tackled the root cause rather than just cleaning and leaving. Excellent, knowledgeable work from start to finish.",
          "name": "Adaora N.",
          "date": "2024-02-27",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Always a pleasure. Andre cleared the creosote from our flue, gave the cap a look, and left the hearth immaculate. Years of dependable service and counting.",
          "name": "Felix O.",
          "date": "2025-12-18",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Came recommended by the family that sold us our home. The tech swept the chimney, removed heavy creosote, and pointed out that the stainless cap was rusting and due for replacement. No hard sell, just facts and photos. Appreciated the straight talk.",
          "name": "Reginald F.",
          "date": "2024-01-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Solid all around. Booked a level-2 inspection before our gas-log conversion and Marco delivered. Creosote removed, damper checked, flue liner confirmed sound, written report emailed. No complaints.",
          "name": "Cornelius B.",
          "date": "2023-05-04",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Appreciated how careful the technician was with our hardwood floors, drop cloths down the whole way. He cleaned the entire duct run, removed a startling amount of packed lint, and put in a new exterior vent hood with a pest guard after we'd had a bird nest two springs in a row. The new hood seals tight. Took a bit to get on the schedule but worth the wait.",
          "name": "Sloane P.",
          "date": "2023-08-11",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Wanted the hearth glowing for our holiday gatherings and it's exactly that. The technician did a thorough chimney sweep, removed creosote, and showed me photos of the clean flue and smoke shelf. He was patient with all my questions about wood types and draft. The whole family now crowds the fireplace every evening with hot drinks. Comfortable, safe, and warm. Could not ask for more this time of year.",
          "name": "Caleb W.",
          "date": "2024-12-01",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "After a chimney fire scare, we called in a panic and Maureen squeezed us in fast. Diego arrived, assessed the creosote damage, scoped the liner, and gave us a clear written report on what was safe and what needed attention. He calmed our nerves and never oversold. The peace of mind alone was worth it, and the firebox was left immaculate.",
          "name": "Beatrix W.",
          "date": "2025-02-27",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Two robins had built a nest right at the top of our flue. BHO removed it gently, cleared the twigs that had fallen onto the smoke shelf, and installed a stainless steel cap with a screen. The technician was kind and explained how the screen keeps birds out without blocking airflow. Quick and reasonably priced.",
          "name": "Henrietta B.",
          "date": "2025-08-19",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Excellent responsiveness overall. They got me scheduled quickly and the tech did a great sweep and inspection of the flue and crown. One small hiccup: there was a scheduling mix-up and my first window got bumped, but Maureen called to apologize and rebooked me same day. The recovery was handled well and the actual work was top notch.",
          "name": "Cordelia W.",
          "date": "2023-09-05",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Property manager overseeing two small apartment buildings. Maureen scheduled both in one trip and the crew cleaned every dryer vent and lint trap efficiently. The buildup they pulled from the longer duct runs was eye-opening. Reports filed per unit. A genuinely reliable vendor for multi-unit work.",
          "name": "Margot Y.",
          "date": "2025-06-04",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Great service! I highly recommend.",
          "name": "Taylor S.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Very nice and courteous.",
          "name": "Derrick N.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Top notch. I highly recommend them. Very professional and nice! Arrived on time, which is always appreciated.",
          "name": "Kayla W.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Very happy with their work. Showed up on time and were not phased by a 2-story house with a tile roof. Price seemed reasonable to inspect my chimney, diagnose the reason it was leaking when raining, and recommend a new cap. The follow-up was great.",
          "name": "Hannah Y.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "I called BHO Chimney Sweep to clean my fireplace and found the company and the technician Yuval to be timely, knowledgeable and extremely efficient. I would highly recommend them and will use them in the future.",
          "name": "Brittany R.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "BHO Chimney Sweep staff was super friendly, attentive and professional. From Maureen in scheduling to Yuval in fireplace repair and inspection. Yuval was efficient and professional while completing the work required. We still are awaiting further updates.",
          "name": "Bryan B.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "The appointment was scheduled professionally and Joey arrived at the scheduled time. He did an inspection and the necessary work to prepare my fireplace for gas logs. I am now confident that the fireplace is safe. He was thorough in his work.",
          "name": "Manuel M.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Yuval was amazing! So friendly, and informative. He saved me a ton of money, over my other estimates. The work was quick and professional. You\u2019re in good hands with these guys.",
          "name": "Shelia B.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "The company was very responsive in scheduling my initial appointment and then the subsequent work following the inspection and appointment. My technician Joey was as knowledgeable as they come and extremely thorough. I am going to recommend them.",
          "name": "Erin D.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Just one of the best experiences I've ever had with a company coming to my house. They were professional, friendly, clear and concise about what they needed to do, and very efficient in getting it done. I cannot recommend these guys enough.",
          "name": "Hannah G.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Great customer service, answered all our questions. Would recommend 100%.",
          "name": "Katherine B.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "These guys are the best. Fixed my gas chimney, cleaned it, showed me how to use it, and gave me safety tips. I fully recommend them! On time, fast and professional. Just hire them already!",
          "name": "Nathaniel L.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "I was able to schedule an inspection next day. The tech (Jeff) was on time, professional, and informative. I received a complete and separate report by email for each of the six chimneys before he left the property. Great experience.",
          "name": "Victoria C.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We needed some work on the fireplace and a cap. They were prompt, professional, and showed us video of the interior with some other clear issues like gaps and cracks. The estimate was good and they got all the work done that day. It was a great experience.",
          "name": "Rachael B.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Excellent job by Joseph! He really knows and likes what he does! My fireplace and flame looks better! Loving the automatic starter he installed.",
          "name": "Danielle B.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Joey was professional, knowledgeable and did a great job! Thorough inspection and was very clear on what we needed to do to prepare our chimney for use. They cleaned, repaired, and painted our fireplace and we are ready to go!",
          "name": "Deborah K.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Eli and his partner showed up early, explained everything and did a great job. I would definitely use BHO Chimney Sweep again.",
          "name": "Christopher R.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Very friendly, good customer service.",
          "name": "Gail V.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "BHO Chimney Sweep was with us every step of the way getting our fireplace and chimney inspected, cleaned, restored, and fully remodeled. It looks amazing now and is the centerpiece of our living room. Would definitely recommend!",
          "name": "Jerry A.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our dryer vent hadn\u2019t been cleaned in 16 years. Joey did an amazing job cleaning both the inside and outside vents. It has made a tremendous difference in the efficiency of our dryer. He was very professional and knowledgeable. Would recommend.",
          "name": "Brent S.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Not bad... clean and professional.",
          "name": "John V.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Your technician, Joey, completed the job for my fireplace issues. He inspected the primary complaint that I was having with the fireplace. He then cleaned the area before patching up the necessary areas that notably needed mending. He placed a new cap and made sure everything was safe.",
          "name": "Chris H.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Joel has excellent work ethics and is polite and a pleasant young person.",
          "name": "Anthony M.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "I had my chimney cleaned and it was inspected before they came. Charged a hundred dollars just to give me an estimate is crazy. The young guy was very nice though, and just to knock a few bricks off my fireplace can cost me anywhere from a few hundred to more. Still, the service was good.",
          "name": "Mary K.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Jeff and team were professional, fast, and did excellent work.",
          "name": "Dawn N.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "My experience with BHO Chimney Sweep went well. The repair process was clearly communicated to me and their pricing was good. I had a few follow ups needed here and there but overall good. I would recommend BHO Chimney Sweep and use them again.",
          "name": "Brandon L.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Very professional and explained it all so a knucklehead like me could understand. Worked quick and left it cleaner than it was before. Highly recommended.",
          "name": "Laurie G.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "On time, inspected and showed reports and video.",
          "name": "Michael M.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Eli was friendly, personable and took the time to educate and explain everything about my fireplace with an emphasis on safety. He walked me through the whole inspection process and went over in detail what needed to be done and how his team would handle it.",
          "name": "Connie O.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Tony with BHO Chimney Sweep takes his job very seriously. He treats his customer with the utmost respect and does whatever is necessary to ensure their happiness. Very happy with the service provided.",
          "name": "Kimberly F.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Eli came out the same day I called and performed a thorough inspection of our chimney and then did the repair work that day too! The BHO Chimney Sweep team was honest, efficient, and really friendly. A pleasure to work with, I\u2019d definitely recommend!",
          "name": "Brian B.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "We did not use this service. They came to the house on time. They had good communication. However their quote was way over what we expected to pay. We ended up using a different company.",
          "name": "Kaitlyn A.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Eli did a great job cleaning and doing all repairs. The fireplace looks and works great.",
          "name": "Aaron I.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "I called because my fireplace gas valve was stuck and I could not turn on; I thought the flue was blocked by a safety device installed by another service provider, but that wasn\u2019t the case, the tech Josh was able to open the valve. However, the service was prompt and professional.",
          "name": "Melody L.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Juan Molina was very professional and extremely helpful.",
          "name": "Kristine B.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Justin was extremely knowledgeable and did a great job of servicing our HVAC and compressor. He installed an air scrubber and serviced our thermostat. All with a smile and even vacuumed his workspace.",
          "name": "Ryan J.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Christian Flores was very knowledgeable. Took his time to explain how all the components of my A/C work and where my system was failing. We discussed the age of my unit and the pros and cons of trying to replace components or doing a full replacement.",
          "name": "Mary S.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Worked with Jonathan Ortiz who arrived early and was very friendly. He made it easy for me to understand what went wrong with our AC units and offered suggestions for repair.",
          "name": "Jacob B.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Alberto at BHO Chimney Sweep Heating, AC really took care of us. We had neglected our central air until it finally quit. Alberto took the time to explain step by step what the problems were. He was very detailed and did a great job with the repairs.",
          "name": "Timothy P.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Filemon was extremely professional from the time he arrived until the time he left. Very thorough and careful installation.",
          "name": "Stacey N.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Kevin arrived during the scheduled appointment time, diagnosed the problem accurately and quickly while providing options to resolve the problem. His care, concern and professionalism were appreciated. A job well done.",
          "name": "Sara H.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Both Justins that came to repair our unit were on time, very polite and explained what needed to be done in order for our unit to function. They took their time and were very thorough. Greatly appreciated. We are still deciding on the next steps.",
          "name": "Chelsea T.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Hamachi\u2019s Acosta and Allen Urquidez did a great job and now I have great air flow on \u201cfan\u201d function. I could not do it on my own.",
          "name": "Theresa G.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "I was referred to BHO Chimney Sweep from a friend who has utilized them for decades. There is something so comforting about working with true experts that know how to install a machine and how to ensure that it runs properly for years to come.",
          "name": "Daniel B.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Very good service call. Very thorough!",
          "name": "Elizabeth W.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Kevin was extremely polite and professional and explained everything he worked on and inspected and was very thorough in his work. We are very happy with his service and promptness.",
          "name": "Julie K.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Ivan Diaz was fantastic! Professional, courteous and knowledgeable. He advised me of everything he would check for both of our house systems. After reviewing, cleaning condensers and changing filters, he also tactfully suggested a few improvements.",
          "name": "Judy S.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Great inspection/maintenance service today from Alex and Alberto. They were very thorough in both their inspection and wonderful in explaining what they found and had a picture for everything. Very personable too. I believe you can't go wrong with them.",
          "name": "Christopher G.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "He explained so politely we were satisfied with his maintenance and we hope he will come back for next maintenance.",
          "name": "Melissa M.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Great experience. I was notified of an estimated arrival time so I could plan. When the tech came, he listened to my concerns and didn\u2019t try to diminish my concerns or upsell because I\u2019m a woman. He took his time and triple checked everything.",
          "name": "Marcus T.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Matthew was great! Subscribed so I\u2019ll be seeing him again.",
          "name": "Mandy I.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Jonathan from BHO Chimney Sweep was very professional and skilled. He kept me informed throughout the servicing of my AC unit and discussed what was needed to keep it running in optimal condition.",
          "name": "Michael M.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Giovanny was extremely professional and thorough. I felt like I received exceptional service from him and am continuing to work with BHO Chimney Sweep to replace my AC unit.",
          "name": "Dennis R.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Replacing my HVAC through BHO Chimney Sweep, I am very satisfied with my experience. From making an appointment to finishing the work, the process was systemized and thorough. Actual work was clean and timely. Thank you very much!",
          "name": "Melissa N.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "The service rep was very thorough and explained what he was going to do. We were very pleased with his thoroughness to clear out some clogged areas to help with our breathing problems.",
          "name": "Lori W.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Juan was very detail oriented and took the time to explain things to me in a technical way that was easy to understand.",
          "name": "Cheyenne D.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Today, Alberto M. from BHO Chimney Sweep came to provide annual maintenance to our HVAC system. His service was outstanding, he provided a super thorough explanation of all the work he did, and any potential recommendations for additional improvements.",
          "name": "Benjamin J.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "BHO Chimney Sweep arrived right on time and got our chimney inspected and cleaned within an hour. The technician showed me video footage of the flue before and after — incredible difference. Will definitely use them every year.",
          "name": "Olivia P.",
          "date": "2024-01-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked BHO for a dryer vent cleaning after our laundry started taking forever to dry. The tech pulled out so much lint it was scary. Dryer works like new now. Quick, clean, professional.",
          "name": "Lucas T.",
          "date": "2024-02-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Outstanding service from BHO Chimney Sweep. They came out for an inspection, found a hidden crack in the firebox, and fixed it the same day. Fair pricing and zero pressure.",
          "name": "Madison F.",
          "date": "2024-03-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Had BHO out for an air duct cleaning before we moved into our new home. The team was thorough, courteous, and finished ahead of schedule. The air smells noticeably fresher.",
          "name": "Mason K.",
          "date": "2024-04-02",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "BHO Chimney Sweep handled a chimney cap replacement on our 3-story home with ease. Safe, fast, and beautifully done. The new cap looks great and the price was very reasonable.",
          "name": "Chloe R.",
          "date": "2024-04-25",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Maureen in scheduling was so helpful when our fireplace stopped drawing properly. The technician arrived next day, diagnosed a damper issue, and had it working again in 30 minutes. Excellent.",
          "name": "Logan S.",
          "date": "2024-05-14",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "I have a very old chimney that other companies wouldn't touch. BHO came out, assessed it carefully, and provided a sensible repair plan. Three days later it was rebuilt to code and looks beautiful.",
          "name": "Grace B.",
          "date": "2024-06-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Yuval came back for our annual maintenance and once again did a fantastic job. Knowledgeable, thorough, and respectful of our home. BHO has earned a customer for life.",
          "name": "Caleb M.",
          "date": "2024-07-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our air ducts had not been cleaned in over a decade. BHO Chimney Sweep did a deep clean with industrial equipment and the dust difference around the house is incredible. My allergies are noticeably better.",
          "name": "Maya H.",
          "date": "2024-08-13",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Joey from BHO was punctual, professional, and explained every step of the chimney sweep. He even pointed out a loose flashing that could have caused leaks and fixed it on the spot. Five stars.",
          "name": "Owen W.",
          "date": "2024-09-05",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "BHO Chimney Sweep replaced our deteriorated chimney crown. The work was permitted, inspected, and warrantied. The new crown is rock solid and we have peace of mind for years to come.",
          "name": "Aiden Q.",
          "date": "2024-10-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quick same-day service from BHO when we had a sudden chimney smoke issue. The technician identified a blocked flue and cleared it within an hour. Saved our evening fire night.",
          "name": "Sophia L.",
          "date": "2024-11-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dryer vent cleaning by BHO was top notch. Technician used a brush snake the full length of the duct and pulled out a startling amount of lint. Dryer runs much more efficiently now.",
          "name": "Ethan G.",
          "date": "2024-12-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "BHO Chimney Sweep installed gas logs in our fireplace and the result is gorgeous. The installer took time to ensure the flame looked natural and the venting was perfect. Highly recommend.",
          "name": "Isabella O.",
          "date": "2025-01-19",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Had BHO out for a full air duct and dryer vent combo service. The team was efficient, friendly, and the air quality improvement was noticeable within hours. Bundled pricing was a great value.",
          "name": "Noah Z.",
          "date": "2025-03-04",
          "service": "Air Duct Service",
          "rating": 5
        },
      ],
    },
    {
      name: "Master Air Duct",
      nameUrl: "Master-Air-Duct",
      imgLogo: require(`../Images/masterairduct.png`),
      favicon: require(`../Images/Master_Air_Duct_Favicon.png`),
      images: importAllImages(require.context('../Images', false, /\.(png|jpe?g|svg|webp)$/)).filter(img => img.includes('master-') || img.includes('masterairduct')),
      rating: 5,
      verified: true,
      services: ["Air Duct Cleaning", "Air Duct Repair", "Air Duct Inspection", "Chimney Cleaning", "Chimney Inspection", "Chimney Repair", "Dryer Vent Cleaning", "Dryer Vent Repair", "Dryer Vent"],
      specialties: ["Air Duct Sealing", "Air Duct Sanitizing", "Air Duct Maintenance"],
      aboutus: "For over 20 years, Master Air Duct has been a trusted name in indoor air quality and home safety solutions. Our experienced team specializes in comprehensive Air Duct Cleaning, Air Duct Repair, and Air Duct Inspections, ensuring your HVAC system runs efficiently and your indoor air stays clean. In addition to our air duct expertise, we offer professional Chimney Cleaning, Chimney Inspections, and Chimney Repairs to keep your fireplace and chimney system safe, functional, and up to code. We also provide thorough Dryer Vent Cleaning, Dryer Vent Repairs, and Dryer Vent Inspections, helping prevent fire hazards and improve appliance performance. At Master Air Duct, we’re committed to top-tier service, transparent pricing, and long-lasting results. Whether you're maintaining your system or addressing an urgent issue, we bring two decades of hands-on experience and customer-first values to every job.",
      // Websites and Phones
      website: "https://www.masterairducts.com/",
      website_Chimney: "https://www.masterairducts.com/chimney/",
      website_AirDuct: "https://www.masterairducts.com/airduct/",
      website_Dryer: "https://www.masterairducts.com/airduct/",
      websiteBook: "https://www.masterairducts.com/book/",
      phone: "866-605-4089",
      phoneHandyBy: "866-890-7189",
      email: "info@masterairducts.com",
      highlights: [
        "20 years of experience",
        "Family-owned and operated",
        "Certified and insured technicians",
        "Same-day service available",
      ],
      questions: {
        title: "",
        rows: [
          {
            title: "Why choose Master Air Duct?",
            content: "With over 20 years of experience, we deliver expert air duct, chimney, and dryer vent services that improve air quality, safety, and system efficiency."
          },
          {
            title: "What services do you offer?",
            content: "We provide air duct cleaning, repair, and inspections; chimney cleaning, inspections, and repairs; and dryer vent cleaning, repair, and inspections."
          },
          {
            title: "How often should air ducts be cleaned?",
            content: "We recommend air duct cleaning every 3 to 5 years, or sooner if you notice dust buildup, allergies, or reduced HVAC efficiency."
          },
          {
            title: "Do you offer same-day repairs?",
            content: "Yes, we can perform most repairs on the same day as your inspection or cleaning appointment, depending on the issue."
          },
          {
            title: "Is dryer vent cleaning important?",
            content: "Absolutely. Regular dryer vent cleaning reduces fire risk, improves dryer performance, and extends the life of your appliance."
          },
          {
            title: "How do I schedule an appointment?",
            content: `Call us at <a href='tel:866-605-4089'>866-605-4089</a> or fill out the <a href='/book'>online form</a> to schedule your service today.`
          }
        ]

      },
      // Reviews
      Chimney_Review: "Master Air Duct’s chimney team was amazing. They inspected, cleaned, and made minor repairs all in one visit. The technician was knowledgeable and courteous. Our fireplace works perfectly now, and we feel secure using it. I’ll definitely use them again for yearly maintenance.",
      AirDuct_Review: "Master Air Duct did a great job cleaning our air ducts. The tech was on time, explained the process, and worked efficiently. The difference in air quality was immediate. Very professional and respectful of our home. I highly recommend their services to anyone.",
      Dryer_Review: "I hired Master Air Duct for dryer vent cleaning and couldn’t be happier. The technician removed a dangerous amount of lint and explained everything clearly. My dryer runs better now, and I feel safer. Excellent, honest service from start to finish. Highly recommended!",
      reviews: [
        {
          "review": "Found a disconnected duct run in the crawlspace that was dumping conditioned air under the house. Andre resealed every joint with mastic and reconnected the detached supply line in about two hours. Cold rooms upstairs are finally comfortable.",
          "name": "Brenda K.",
          "date": "2025-08-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our old plastic vent hood out back had basically rotted off and birds were nesting in the duct. Marco cleared a shocking amount of packed lint, then installed a stainless steel hood with a built-in pest guard so nothing can climb back in. Dryer runs cooler and clothes finish in one cycle now. Clean, professional, fair price.",
          "name": "Brenda K.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We've been calling Master for our air ducts every couple of years since we bought this house, and they've never let us down. This time Diego and his partner laid down drop cloths before touching anything, cleaned every supply and return vent, and showed us before/after photos of the main trunk line. The dust buildup was honestly shocking. Same crew quality we've come to expect after nearly a decade with them.",
          "name": "Deborah K.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our towels were taking three full cycles to dry and I figured the dryer was dying. Turns out the vent line was packed with lint all the way to the exterior hood. Hector cleared it out, showed me the pile he pulled, and now everything dries in one cycle. Wish I'd called sooner.",
          "name": "Brianna T.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "After a heavy storm we noticed water stains on the ceiling near the fireplace. Sergei came out, climbed up, and showed me the crown was cracked all the way across. He sealed it and applied a waterproofing coat to the brick. No leaks since, even through the spring rains.",
          "name": "Brenda M.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My son's asthma flared up every fall, and I suspected the ducts since we'd never had them cleaned. Mikhail pulled out genuinely gross mats of dust from the return vents and showed me before/after photos. Two weeks in and his nighttime coughing is way down. The drop cloths and shoe covers were a nice touch too.",
          "name": "Priya R.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "What stood out most was how careful the crew was with our floors. Drop cloths went down from the front door all the way to the furnace before any equipment came in. Carlos even wiped down the return vent covers before reinstalling them. You honestly couldn't tell they had been here except the air smelled fresher.",
          "name": "Priya M.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "After a six-week kitchen remodel, every supply vent in the house was coated in a fine gray drywall film. Raj and his crew pulled the registers, ran a rotary brush through the trunk lines, and vacuumed out the return ducts. The amount of sawdust they showed me in the collection bag was honestly disgusting. They laid drop cloths everywhere and wore shoe covers. House finally smells clean again.",
          "name": "Marisol T.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Woke up to a dryer that wouldn't heat the morning before guests arrived. Called the office and they had Devin at my door within four hours. He cleared a packed lint trap and a vent run stuffed almost solid, and the dryer was drying again same day. Lifesaver.",
          "name": "Brianna T.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Pulled the dryer out to chase a sock and found a wall of lint packed behind the vent hood that honestly scared me. Tyler came the same afternoon, ran a rotary brush the full run to the roof cap, and showed me the bag of debris he pulled out. Sleeping a lot better now.",
          "name": "Renata K.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our living room kept filling with smoke every time we lit a fire. Omar inspected the flue and found a heavy creosote buildup choking the draft. After a thorough cleaning the difference was night and day. Smoke goes straight up now.",
          "name": "Patricia M.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our dryer kept shutting off mid-cycle and the clothes came out scorching. Nikolai found the vent line packed solid with lint behind the wall. After he cleared it the dryer ran cool and finished in one cycle. No more overheating.",
          "name": "Priya R.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Wanted the ducts cleaned before turning on the AC for the season and these guys delivered. Eli pulled out a shocking amount of dust from the return vents and showed me before and after photos. House smells fresher already.",
          "name": "Priya N.",
          "date": "2025-05-12",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Musty smell in our basement bedroom finally gone after the air duct cleaning. The tech showed me before and after photos of the supply ducts and there was honestly a shocking amount of gunk. He also sanitized everything with a fog treatment. Air smells fresh now.",
          "name": "Brenda K.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "We were closing on our 1920s bungalow and the inspector flagged the chimney as a concern. The tech showed up with a camera, scoped the flue liner, and found cracks I never would have caught. The written report had photos and a clear breakdown of what needed fixing versus what was cosmetic. Helped us negotiate $1,800 off the sale price.",
          "name": "Priya N.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Just closed on a house where the previous owners had three cats, and the smell hitting the vents whenever the AC kicked on was awful. Victor pulled out clumps of fur and dander from the return ducts that honestly made me a little sick to see. He showed me before/after photos and the supply ducts looked brand new after. Air actually smells clean now.",
          "name": "Brianna T.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our master bedroom was always stuffy no matter how high we cranked the AC. Turns out both return vents were packed with years of dust and pet hair, basically choking the system. Ramon pulled the grilles off, showed me the buildup, and ran the cleaning unit through every supply and return. Airflow afterward was night and day. He left shoe covers on the whole time and the written report explained exactly what he found.",
          "name": "Priya M.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our upstairs bedrooms never got cool no matter how low we set the thermostat. Luis pulled apart the supply ducts and showed me a clog of dust and pet hair that was choking the airflow. After the cleaning the vents actually push air now, and our July electric bill dropped about thirty dollars compared to last year. Wish we'd done this sooner.",
          "name": "Renata K.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Kevin handled our air duct cleaning and was incredibly thorough. He showed me the before and after photos of the supply ducts and you could actually see the dust buildup that came out. Polite, on time, and laid down drop cloths everywhere. Couldn't ask for more.",
          "name": "Brianna T.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Manage four rental units across town and the dryer vents had not been touched in years. Jordan ran a camera up each line and pulled out a shocking amount of compacted lint near the wall hood. Tenants are already saying clothes dry faster. Got a written report for my files too.",
          "name": "Brian K.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Booked our yearly chimney sweep and the tech laid down drop cloths before touching anything. He showed me the creosote buildup on the smoke shelf and explained why glaze needs a stronger treatment than the flaky stuff. Cleaned the flue, checked the damper, and left zero soot on the carpet. Solid annual service.",
          "name": "Renata K.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Scheduling was the easiest part of the whole process. The office offered me a same-day slot, sent a text reminder the night before, and another when the tech was 20 minutes out. They cleaned all our supply ducts and return vents and left a written report. No guessing about arrival windows.",
          "name": "Priya M.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "With a newborn at home, we wanted the air as clean as possible before bringing her back from the hospital. Dmitri showed up in shoe covers, laid drop cloths through the hallway, and cleaned every supply duct and return vent. The amount of dust pulled out was honestly shocking. He showed us before and after photos and walked my wife through the whole process. Breathing easier already.",
          "name": "Priya N.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Wanted our gas logs ready before the cold snap and the tech checked the pilot assembly, cleaned the burner ports, and made sure the damper clamp was in place. Quick, clean, no mess.",
          "name": "Brenda M.",
          "date": "2025-10-14",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Wanted our gas fireplace looked at before the cold set in. Felix took apart the logs, cleaned the burner ports that were clogged with dust, and checked the pilot assembly. Flame looks even and blue again instead of that lazy yellow it had last winter. Drop cloth down the whole time too.",
          "name": "Brianna T.",
          "date": "2025-09-18",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Quoted me a flat rate over the phone and that's exactly what I paid, down to the dollar. No surprise add-ons for the extra return vents like I half expected. Sam showed me before and after photos of the supply ducts and explained what he found without trying to sell me anything I didn't need.",
          "name": "Priya N.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Two long-haired shepherds shed nonstop, and our return vents were caked with fur. Tony pulled out clumps of pet hair you wouldn't believe and showed me before/after photos of every supply duct. House smells fresh now.",
          "name": "Brenda T.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our laundry room sits on the ground floor but the vent climbs three stories and exits through the roof, so the lint had nowhere to go. Pavel brought a rotary brush kit long enough to reach the rooftop termination and cleared a genuine fistful of compacted lint near the elbow. Dry times dropped from two cycles to one. He showed me before and after photos and explained the rooftop cap needed a new bird guard.",
          "name": "Renata P.",
          "date": "2025-09-18",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Our utility bills had crept up for no obvious reason. Turns out a return duct had pulled loose at the plenum. Marcus sealed the leaks with mastic and metal tape, then reattached the run and strapped it properly. Showed me before and after photos of the seams. Honest, transparent pricing with no upsell pressure.",
          "name": "Theodore M.",
          "date": "2025-11-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Same-day appointment after I noticed the dryer taking forever. Tech vacuumed the full run from the lint trap to the wall and swapped out the flimsy louvered exterior cap for a new vent hood with a metal pest screen. Showed me before-and-after photos of the lint cleared. Honest work.",
          "name": "Devon R.",
          "date": "2026-03-22",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Third house, same company. Andre remembered we'd had the dryer vent done a few years back and asked how it was holding up before getting into the duct cleaning. Sealed a small gap in the return plenum and gave us a written report with photos.",
          "name": "Roland P.",
          "date": "2026-03-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Laundry never finished in one go anymore, so I booked a vent cleaning. The tech found a crushed section behind the wall plus a clogged lint trap housing. He cleaned the whole run and even replaced the flimsy plastic transition hose with rigid metal. Big difference already.",
          "name": "Desmond R.",
          "date": "2025-11-02",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Rusted-out cap was letting water straight into the flue. Marco swapped it for a stainless steel one and pointed out where the crown had hairline cracks. Solid work, fair price.",
          "name": "Curtis D.",
          "date": "2024-11-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Sneezing fits in the morning are basically gone since the supply ducts got cleaned. Diego was thorough and explained everything in plain English.",
          "name": "Garrett M.",
          "date": "2024-03-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Shoe covers on the second they walked in, and they laid runners over the hallway rug. Spotless cleanup after pulling debris out of the supply ducts.",
          "name": "Devon R.",
          "date": "2026-03-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Drywall dust was getting pulled through the system and settling on everything within a day of dusting. The tech cleaned all the return vents and supply ducts and left a written report with before and after photos. Big difference.",
          "name": "Derek P.",
          "date": "2026-03-02",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Same-day air duct cleaning when our HVAC was blowing dust everywhere. Hector showed up right in the window the office quoted, laid drop cloths through the hallway, and cleaned every supply and return vent. No mess left behind.",
          "name": "Desmond R.",
          "date": "2024-11-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Clothes were taking two cycles to dry and that was my first clue. Tech cleared a clogged lint trap housing and a crushed section of vent line, then verified airflow at the exterior flap. Fast and tidy.",
          "name": "Wendell P.",
          "date": "2024-11-03",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Smoke smell lingered in the house for weeks even when nothing was burning. The tech traced it to a cracked flue liner pulling odors back into the room. He explained the issue clearly with photos and gave us a written repair plan. Honest crew.",
          "name": "Gerald T.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Noticed the laundry room smelling hot and the dryer tripping its thermal cutoff. The tech pulled out a huge wad of compacted lint from the vent hood and the duct run. He showed me the before and after photos so I could see the difference. Dries in 40 minutes now instead of three rounds.",
          "name": "Anthony G.",
          "date": "2024-11-22",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Solid pre-summer tune-up on our duct system. The tech laid drop cloths and wore shoe covers the whole time, and the supply ducts came out spotless.",
          "name": "Trevor B.",
          "date": "2024-04-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Sergei found a small patch of mold near one of the return vents during the inspection and explained exactly how the sanitizing process would handle it. He laid down drop cloths everywhere and wore shoe covers the whole time. House smells noticeably cleaner.",
          "name": "Theodore R.",
          "date": "2026-03-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Quick and honest. Needed a chimney inspection before listing our house and Mikhail had the written report emailed to us the same afternoon. No upselling, just facts about the crown and damper condition.",
          "name": "Theodore B.",
          "date": "2024-11-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Moved into a place where you could tell someone smoked indoors for years. That stale cigarette smell was baked into everything, especially when the furnace ran. The crew cleaned every supply and return vent, used drop cloths so nothing got dirty, and gave me a written report. Big difference within a day.",
          "name": "Marcus D.",
          "date": "2025-03-21",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Weak airflow from every register turned out to be a clogged return choking the blower. Crew cleared it same day and showed before/after photos. Big difference.",
          "name": "Darnell W.",
          "date": "2024-11-02",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Solid work on the return vents and main trunk line. Airflow noticeably stronger and the HVAC isn't running as long to hit temperature.",
          "name": "Trevor M.",
          "date": "2024-11-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Carlos cleaned every return vent in our two-story house and never once rushed. He wore shoe covers without being asked and explained how the negative-pressure machine pulls debris from the supply ducts. Genuinely courteous guy who clearly knows his trade.",
          "name": "Devon R.",
          "date": "2024-11-02",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Tenant complained the dryer took three cycles to dry a load. Tech cleared the vent run, replaced a crushed section of flex duct behind the unit, and showed me before and after photos. Fast and clean.",
          "name": "Priya N.",
          "date": "2026-03-02",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Annual sweep done right. Raj swept the flue and pointed out a thin crack in the crown that I never would have spotted.",
          "name": "Gordon T.",
          "date": "2024-10-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked a dryer vent cleaning over the phone in about four minutes. They confirmed by email and reminded me the morning of. Devin pulled a shocking amount of lint from the vent line and cleaned out the lint trap housing too. Communication was clear start to finish.",
          "name": "Trevor K.",
          "date": "2025-03-22",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our two-year-old has had a constant runny nose since we moved in. Tyler cleaned the ducts and found a return vent absolutely caked with construction dust from the previous owners. Clear pricing up front, no surprises. Kid's congestion is noticeably better.",
          "name": "Marcus T.",
          "date": "2025-03-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Omar came out to inspect our gas-log fireplace and found a hairline crack in one of the ceramic logs that we never would have noticed. He explained why it mattered for safe burning, repositioned the logs to match the manufacturer layout, and tested the flame pattern. Left a written report with everything documented.",
          "name": "Theodore K.",
          "date": "2024-11-22",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Solid prep job before the season. The tech swept out the firebox, scraped creosote buildup off the smoke shelf, and showed me where the damper wasn't seating right. Left a written report with photos.",
          "name": "Desmond R.",
          "date": "2025-10-02",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Honest pricing. The lint trap and full vent run cleaned for the price they quoted, no tacked-on fees. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Trevor B.",
          "date": "2024-11-02",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Three cats and a decade of dander built up in our system. Nikolai laid down drop cloths and put on shoe covers before touching anything, then ran the brush and vacuum through every register. Sneezing has dropped off completely.",
          "name": "Quentin M.",
          "date": "2024-11-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Long horizontal run through the attic, maybe 30 feet, and it was choked. Tech vacuumed it section by section and reattached two joints that had pulled apart.",
          "name": "Desmond K.",
          "date": "2025-11-04",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "A flex duct in the attic had completely detached from the boot over the dining room. Eli clamped it back, sealed the collar, and checked the rest of the supply runs for leaks while he was up there. Quick, tidy, and the airflow difference is night and day.",
          "name": "Priya S.",
          "date": "2024-06-21",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Squirrels had been getting into the dryer vent on the side of the house and it was driving me crazy. Victor did a thorough cleaning of the duct, then capped the exterior with a sturdy hood and a pest guard so critters can't push their way in. Laid a drop cloth by the laundry room and wore shoe covers the whole time. No more scratching sounds in the wall.",
          "name": "Yvonne M.",
          "date": "2024-11-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Loyal customer going on seven years now. Started with a chimney inspection, then dryer vent, and air ducts have become our regular every-other-year thing. Ramon came out this round, wore shoe covers without being asked, and pointed out a loose connection on one supply duct that he tightened up. Transparent pricing every single time, never a surprise on the invoice.",
          "name": "Yvonne M.",
          "date": "2024-11-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Clothes coming out damp after a full cycle was driving me crazy. Luis ran a brush the length of the vent and vacuumed out an unreal amount of lint near the exterior vent hood. He also pointed out that the flap wasn't closing properly and adjusted it. Dries normally now and the laundry room isn't as humid.",
          "name": "Aisha M.",
          "date": "2024-07-21",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "What impressed me most was the written report with before-and-after photos. The crown had a deep crack and the old galvanized cap was rusted through. Kevin rebuilt the crown with a proper overhang and installed a new stainless cap. He also brushed on a clear waterproof sealant over the masonry. He explained that brick acts like a sponge and the sealer lets it breathe while keeping rain out. Three months later, bone dry.",
          "name": "Yolanda P.",
          "date": "2026-02-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Allergy season used to mean a box of tissues on every table. After the crew cleaned our system, the pollen-and-dust haze you could see in the sunlight is gone. They sealed a loose return that had been pulling attic dust straight into the house. Honestly didn't expect such a difference from one visit.",
          "name": "Yolanda T.",
          "date": "2026-02-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Genuinely impressed by the tidiness. Jordan taped plastic over the openings he wasn't actively working on so dust wouldn't drift into the rooms, and he vacuumed every grille after reinstalling it. The collected debris went straight into a sealed bag that he hauled out to the truck. After he left I ran a white cloth along the baseboards near the vents and it came up clean.",
          "name": "Annalise K.",
          "date": "2024-11-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "We finished a full basement buildout and the contractor's plastic sheeting didn't keep the sawdust out of the HVAC. Dmitri walked the whole system with me before starting, sealed off the registers he wasn't working on, and used a negative-air machine on the main trunk. He found a chunk of drywall debris lodged near the damper that was choking airflow to the back bedrooms. Pricing was exactly what the office quoted, no surprises. Same-day slot too.",
          "name": "Anneke V.",
          "date": "2025-11-20",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Punctuality is rare these days, so I want to give credit where it's due. My dryer vent was so clogged the machine kept overheating and shutting off, and with a newborn at home I could not wait days for laundry. The scheduler squeezed me in for that afternoon. Felix arrived ten minutes early, vacuumed out a shocking amount of lint, checked the vent hood flap outside, and tested airflow before leaving. Clothes dry in one cycle now. Genuinely saved my week.",
          "name": "Priya N.",
          "date": "2025-03-22",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "My neighbor's house had a dryer fire last winter, so I finally booked an inspection. Sam showed me before-and-after photos and the amount of compacted lint near the vent hood was genuinely alarming. He cleaned the entire duct, replaced the flimsy plastic transition hose with rigid metal, and tested the airflow before leaving. Transparent pricing, no upsell pressure. This is exactly the peace of mind I was after.",
          "name": "Aisha M.",
          "date": "2025-03-22",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Poor draft fixed in one visit. Tony adjusted the damper and cleared a bird's nest from the flue. No more backdraft.",
          "name": "Nadia K.",
          "date": "2026-02-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dryer was running way too hot to the touch. Pavel cleaned the entire vent path and replaced the crushed flexible hose behind the machine with a rigid line. Honest pricing, no upsell. Clothes finally come out dry the first time.",
          "name": "Yolanda M.",
          "date": "2026-03-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our AC was struggling to keep up last summer so we got ahead of it this year. Marcus inspected every supply and return register, cleaned the blower compartment, and gave us a written report. The airflow difference is night and day, and the upstairs bedrooms finally cool down evenly. Twenty-plus years in the business really shows in how thorough they were.",
          "name": "Danielle K.",
          "date": "2026-04-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked these folks because of a damp, moldy odor every time the AC kicked on. Turned out our ducts were full of dust and there was moisture buildup near the coil. They cleaned the whole system and applied an antimicrobial fog. Worth every penny.",
          "name": "Priya N.",
          "date": "2025-06-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Buying a foreclosure can be nerve-wracking. The crew came out, ran a Level 2 inspection, and documented heavy creosote buildup plus a missing stainless cap. Everything was photographed and explained in the report so my lender and I knew exactly what we were dealing with before signing.",
          "name": "Yolanda C.",
          "date": "2025-03-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We bought our first home in February and the prior family had a dog and clearly smoked. Andre arrived same day, put on shoe covers, and got to work on the ductwork. The amount of dust and pet hair he vacuumed out of the trunk lines was unreal. He was patient explaining what causes the lingering odor and how cleaning the returns helps. Transparent pricing, no surprises on the invoice. The musty smell that greeted us every morning is finally gone and the whole second floor feels fresher.",
          "name": "Priya K.",
          "date": "2025-11-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "After 20 years in this house we'd never had the ducts touched. The return vent in the hallway was so impacted it was barely pulling air. Marco explained how a clogged return strains the whole system and showed me the mat of debris he pulled out. The system now circulates properly and the upstairs rooms finally hold temperature. Transparent pricing, no surprises, and he laid drop cloths everywhere. Genuinely impressed with this family business.",
          "name": "Eleanor T.",
          "date": "2025-03-21",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Diego and his partner laid drop cloths through the whole hallway and wore shoe covers without being asked. They cleaned every supply and return register, then showed me before-and-after photos of the debris that came out of the ducts. The difference in airflow at the back of the house is dramatic now, and the system reaches the set temperature way faster than it used to.",
          "name": "Imani B.",
          "date": "2026-03-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Quick shout-out to Hector who did our ductwork. Sharp, fast, and respectful of the house. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Priya S.",
          "date": "2025-03-21",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "As a small-time landlord I appreciated the transparent pricing up front. They serviced the dryer vent at my duplex, cleaned the lint trap housing, and confirmed the exterior vent flap was actually opening. Sergei even put down drop cloths so the laundry area stayed spotless. No surprise charges at the end, which is rare in my experience with contractors.",
          "name": "Gloria M.",
          "date": "2025-06-21",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We've used Master Air Duct for the chimney three years running now. Each time the creosote report comes with before and after photos so I can actually see the difference. This visit the flue liner was inspected with a camera and they confirmed no Stage 3 glaze, just normal seasonal soot. Mikhail was thorough and wore shoe covers the whole time. Transparent pricing, no upsell, exactly what I want from a yearly maintenance visit.",
          "name": "Priya N.",
          "date": "2026-02-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What stood out was how organized the office is. The scheduler walked me through the pricing up front, no surprises, then sent a calendar invite with a two-hour window instead of the usual all-day waiting game. A reminder text came the evening before. The crew laid down drop cloths and showed me before and after photos of the return vents. Whole experience felt buttoned up.",
          "name": "Annette R.",
          "date": "2024-11-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Expecting our first baby in July and figured the ducts had never been touched in this 1990s house. The technician confirmed it, the supply ducts were lined with years of buildup. He used a rotating brush and vacuum system, sealed each vent after, and gave us a written report. Felt great knowing the nursery air would be clean.",
          "name": "Hannah R.",
          "date": "2026-04-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our gas fireplace smelled funny when we turned it on after summer. Carlos checked the gas line connections, cleaned out the dust around the burner, and confirmed there were no leaks with his detector. Smell was just accumulated dust burning off. Reassuring to have a certified guy confirm it was safe.",
          "name": "Priya N.",
          "date": "2025-09-30",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "First winter in this house and I had no idea when the fireplace was last serviced. Raj came out, ran a full inspection, and found a cracked refractory panel in the firebox that he flagged in the written report. He cleaned everything, vacuumed the ash, and explained how to safely build a fire. Felt confident lighting it for the first time after that. Honest pricing and no upsell pressure at all.",
          "name": "Yolanda P.",
          "date": "2024-10-14",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "What sold me was how upfront the office was about cost. They walked me through the per-vent breakdown before booking, and when Devin arrived he confirmed the same number. He laid drop cloths everywhere and cleaned all twelve supply ducts plus the returns. Final invoice matched the estimate to the penny. No upsell on sanitizing or anything extra, which I appreciated since the last company tried to double the bill mid-job.",
          "name": "Lucia M.",
          "date": "2026-03-21",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Pet hair everywhere in the ducts after fifteen years. Tyler was thorough. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Yolanda P.",
          "date": "2025-03-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "We live in a townhome where the dryer duct runs up and out the roof. Omar climbed up safely, removed the rooftop vent hood, and ran his brush down from the top while a second tech worked from the dryer end. They met in the middle and pulled out years of lint. He also resealed the flashing around the cap before he left.",
          "name": "Aurelia M.",
          "date": "2024-07-22",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Whistling sound from the vents turned out to be a leaky joint near the air handler. The tech sealed it and reconnected a section that had separated. Drop cloths down the whole time. Problem solved.",
          "name": "Curtis W.",
          "date": "2025-02-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked a dryer-vent cleaning and ended up replacing the exterior hood too. The old flap was stuck open and letting cold air pour in all winter. New stainless hood with a pest screen seals tight now. Quick, clean, no upsell pressure.",
          "name": "Theo P.",
          "date": "2025-01-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Been using them for years and the consistency is what keeps me. The crew vacuumed all the return vents, swept the supply lines, and showed me the before and after on the camera. House smells fresh.",
          "name": "Priya S.",
          "date": "2025-06-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Two and sometimes three cycles to dry a single load. The technician measured the airflow before and after, which I appreciated, and showed me how restricted the line was. After cleaning the duct run and the vent hood the readings jumped. Honest pricing too, no upsell.",
          "name": "Garrett P.",
          "date": "2026-03-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Had a slow drip showing up on the firebox after rain. Turned out the flashing where the chimney meets the shingles had pulled away. Nikolai resealed the flashing and recapped the flue. Drop cloths everywhere inside, very tidy.",
          "name": "Theo R.",
          "date": "2025-04-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Eli showed up same day after I called about constant sneezing. He vacuumed every supply duct and the main trunk line, then handed me a written report. My eyes stopped watering within a few days.",
          "name": "Trevor B.",
          "date": "2024-11-05",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked same-day and the tech showed up with a stack of drop cloths and a contained negative-air machine. He sealed the trunk line before brushing the supply ducts so nothing escaped into the basement. Cleanup was thorough, swept the floor and even put the furniture back exactly where it had been.",
          "name": "Tobias W.",
          "date": "2025-01-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Post-renovation cleaning of all twelve supply ducts. Victor was thorough, vacuumed each return grille, and bagged the construction dust so I could see what came out. Fair price, certified and insured.",
          "name": "Quincy B.",
          "date": "2024-07-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Furnace kicked on for the season and the whole house smelled musty. One phone call and the crew was out by early afternoon the same day, which I did not expect. They cleaned the supply ducts and returns, showed me before-and-after photos of the trunk line, and wore shoe covers the entire time. Honest pricing matched what the office told me on the phone.",
          "name": "Gregory M.",
          "date": "2024-02-17",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Scheduling was painless and the office gave me a two-hour window they actually hit. Ramon snaked the whole vent run, vacuumed out the lint trap cavity, and pointed out where the old flex hose had been kinked behind the machine. Burning smell on hot cycles is completely gone now.",
          "name": "Gregory T.",
          "date": "2026-01-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We assumed our fireplace was just old and smoky, but Luis showed us the real problem was a missing stainless cap letting downdrafts push smoke inside. He installed a new cap, swept the flue, and the draft improved immediately. Shoe covers and drop cloths the whole time. Couldn't be happier with how clean they left everything.",
          "name": "Brandon R.",
          "date": "2025-01-30",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Same-day appointment which I appreciated since the dryer kept clicking off after ten minutes. Turned out the exterior vent flap was glued shut with lint and the run was almost fully blocked. Kevin vacuumed it from both ends and tested the airflow with a meter before leaving. Cool, fast, and quiet now.",
          "name": "Brandon T.",
          "date": "2025-06-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Scheduled a cleaning in spring to prep for the heat. Jordan found a disconnected duct in the crawlspace that was dumping cold air under the house and reattached it on the spot. No upcharge games, just the transparent price they quoted on the phone.",
          "name": "Omar F.",
          "date": "2025-03-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Fresh air at last. The crew sanitized all twelve supply ducts and showed me the camera footage afterward. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Gregory M.",
          "date": "2024-11-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "My realtor recommended getting the chimney looked at before we put the house on the market. Dmitri was thorough, checked the flashing and the firebox, and gave us a written report the same week. The pricing was exactly what the office quoted, no surprises.",
          "name": "Curtis M.",
          "date": "2024-07-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Previous owner smoked cigars. Need I say more. Felix and the crew tackled the supply ducts and the smell that came through every register. Honest pricing and they finished faster than quoted.",
          "name": "Gregory M.",
          "date": "2024-07-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Noticed one room never got cool air. Sam found the return vent completely blocked with construction dust from a remodel years ago. He cleaned all the supply ducts and the return, then balanced the airflow. Quoted me upfront and stuck to it. House feels fresher already.",
          "name": "Brandon K.",
          "date": "2026-02-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Furnace was working overtime all winter. After they vacuumed out the ductwork the heat circulates evenly and my gas bill came down two months in a row. Transparent quote, no upsell.",
          "name": "Gregory T.",
          "date": "2025-01-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Tony arrived right on schedule and spent a good two hours on our system. He found a disconnected supply duct in the crawlspace that was dumping conditioned air into nowhere, sealed it up, and showed me the written report afterward. Skilled and patient with all my questions. The whole crew was respectful and cleaned up every speck.",
          "name": "Margaret O.",
          "date": "2024-07-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked same-day service for a rental between tenants. Pavel showed up with shoe covers, vacuumed the full vent line to the roof termination, and pointed out where a bird had started nesting at the cap. Glad I caught it before the next tenant moved in.",
          "name": "Trevor S.",
          "date": "2024-11-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Scheduled a creosote removal after a smoky winter. The technician found a heavy layer coating the upper flue and used a rotary brush to knock it loose. He bagged everything and vacuumed the firebox spotless. Walked me through how to season firewood properly so it doesn't build up so fast next year.",
          "name": "Desmond R.",
          "date": "2025-01-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Reminders kept me on track. Got a confirmation when I booked, a heads up the day before, and a call when Marcus was on the way. He cleared a clogged vent hood and showed me where the duct had been crushed behind the dryer. Easy to deal with.",
          "name": "Desmond O.",
          "date": "2026-01-17",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Three kids under six and someone always seems to be sneezing. Andre and the crew were patient working around the chaos, covered their shoes without being asked, and showed me a flashlight view inside a return that was full of pet hair and dust. The whole house smells fresher and the kids slept through the night for once.",
          "name": "Olivia B.",
          "date": "2024-11-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Prompt and professional. The technician laid down drop cloths, inspected the thermocouple and thermopile, and adjusted the flame height so it wasn't sooting up the glass. Now it lights on the first try every time.",
          "name": "Doug R.",
          "date": "2024-12-08",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Booked a cleaning ahead of the first cold snap. Tech laid drop cloths from the door to the hearth, brushed the flue, and removed a surprising amount of creosote. Clean burn the same night.",
          "name": "Trevor M.",
          "date": "2025-11-05",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "After a contractor scared me into thinking I needed a whole new duct system, these folks were a relief. Marco inspected the vent hood, found a bird's nest blocking the line, cleared it, and charged exactly what the scheduler quoted. He didn't invent problems. Twenty years in business shows in how straight they are with people.",
          "name": "Gerald T.",
          "date": "2025-01-18",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our golden retriever's fur had basically lined the inside of the supply ducts. Diego showed me the camera footage before he started and again after, and the difference was night and day. He vacuumed each return vent and wiped down the registers too. The dust on the furniture has noticeably decreased since the cleaning, which tells me a lot of that was circulating through the system.",
          "name": "Theo R.",
          "date": "2025-12-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "My condo's dryer vent is one of the longest runs in the building, almost 40 feet to the roofline. The crew used a camera to confirm the blockage location before touching anything. Found a mash of lint right at the second bend. Cleared it, then reran the camera to prove it was clean. Solid, no-nonsense work.",
          "name": "Tobias R.",
          "date": "2026-02-11",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Excellent work sealing our leaky ductwork. Hector mapped every gap with a smoke pencil, then mastic-sealed the supply trunk and reconnected a run that had fallen off the register boot in the hallway. He explained everything in plain terms and left a written report. House holds temperature so much better now and the dusty smell is gone.",
          "name": "Naomi F.",
          "date": "2026-03-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "After 12 years in this house we'd never had the dryer vent cleaned, and it showed. Sergei pulled out a massive lint clog near the elbow and measured airflow before and after with a meter to prove the improvement. He also installed a new exterior vent hood with a pest guard because mice had chewed the old screen. Whole job took about an hour and the laundry area was spotless when he left. Genuinely impressed with the attention to detail.",
          "name": "Naomi F.",
          "date": "2026-05-02",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "After years of having Master do our air ducts, we finally had them tackle the dryer vent that runs all the way up to the roof. Mikhail cleared a serious lint clog near the vent hood and the dryer cycles are noticeably shorter now. Same honest crew we've trusted across every service. They've earned the repeat business.",
          "name": "Gregory T.",
          "date": "2024-02-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Same-day service when I called about my dryer running forever. Carlos was here within a few hours, put down a drop cloth, and got to work. He snaked the long vent that runs up to the roof and pulled out years of lint. Said it was honestly a fire risk. Clothes dry on one cycle again.",
          "name": "Priya N.",
          "date": "2025-02-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our chimney crown was spalling and chunks of mortar were ending up in the yard. The technician ground it out, recast a new crown, and waterproofed the whole stack. He showed me the rusted cap he replaced too. Honest about what needed doing now versus what could wait, which I appreciated.",
          "name": "Marisol G.",
          "date": "2025-12-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dust was triggering my daughter's asthma so badly we were considering moving. The technician found the return vents packed with debris from a long-ago renovation. He bagged it all and laid drop cloths everywhere. The air smells cleaner and she's using her inhaler far less now.",
          "name": "Annika S.",
          "date": "2025-06-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Spotless from start to finish. Raj covered our cream sofa with a sheet before working on the nearby return, wore shoe covers the whole time, and left zero mess.",
          "name": "Rosalind H.",
          "date": "2025-06-11",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our addition created a constant haze of fine drywall powder that the furnace just kept recirculating. Devin showed up on time, taped drop cloths over the hardwood, and ran his brush and vacuum through every branch line. He explained that sanding dust is especially fine and clings to the duct walls, which is why a regular filter change wasn't cutting it. The thermostat reads cleaner air now and there's noticeably less dust resettling. Worth every dollar.",
          "name": "Priya S.",
          "date": "2026-01-17",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Dryer was taking three cycles to dry a single load. Phoned in the morning, Tyler was here by noon. Pulled a thick mat of lint from the vent and reattached the transition hose properly. Quick, on time, and now one cycle does it.",
          "name": "Yvonne C.",
          "date": "2025-12-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Lint everywhere behind the dryer when I moved the unit. The crew was quick, professional, and laid down a drop cloth so my laundry room stayed clean. Vent runs clear to the roof now.",
          "name": "Priya N.",
          "date": "2024-06-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "That faint campfire smell in our den had been bugging me all winter. Turns out negative pressure in the house was reversing the flue. The technician explained how to crack a window for makeup air and cleaned out the creosote that was making it worse. Smart guy, very patient with my questions.",
          "name": "Lorraine V.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After 20 minutes our dryer would overheat and stop. Omar traced the problem to a lint clog deep in the vent where it elbows up to the roof. He cleared it, cleaned the lint trap housing, and put down a drop cloth so my floor stayed clean. Great experience.",
          "name": "Lena K.",
          "date": "2024-07-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Dust everywhere when the AC kicked on, so I finally booked a full duct cleaning. Nikolai ran the brush and vacuum through all the trunk lines and even cleaned the return grilles. Allergies have been way better this June.",
          "name": "Renee S.",
          "date": "2026-05-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "We'd been worried about mold for months after a roof leak. Eli came out same day, inspected every return and supply line with a camera, and gave us a written report confirming no active mold growth, just dust. He still recommended a sanitizing treatment to clear the lingering musty smell and it worked beautifully. Honest people who didn't upsell us on stuff we didn't need.",
          "name": "Yolanda P.",
          "date": "2026-01-17",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "As a first-time homebuyer I had no idea what to look for. The technician walked me through the whole flue liner situation on the camera screen and then sent a detailed written report with before photos. Worth every penny for the peace of mind during escrow.",
          "name": "Aisha R.",
          "date": "2026-02-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "New construction it was not. The house we bought had a heavy pet odor that I assumed would fade once we cleaned the carpets, but it kept coming back through the vents. Victor inspected the ductwork and found years of dander coating the inside. He cleaned everything down to the air handler and even sanitized the return drops. The difference the next morning was night and day. Worth every dollar.",
          "name": "Yasmin R.",
          "date": "2026-02-17",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Restricted airflow throughout the downstairs had us baffled. The tech traced it to two clogged return vents that hadn't been cleaned since the house was built. Watching the vacuum pull out that gray buildup was honestly gross but satisfying. He measured airflow before and after so I could see the improvement. Polite, on time, and the quote matched the final bill exactly.",
          "name": "Sofia R.",
          "date": "2024-06-09",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Booked a same-day appointment after our AC seemed weaker every summer. Ramon measured the airflow at a couple of registers before starting, ran the brush and vacuum through all the supply ducts, then measured again so I could see the improvement. The number jumped noticeably. House cools faster now and the compressor isn't cycling constantly, which should help the power bill.",
          "name": "Yelena P.",
          "date": "2024-06-27",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Hats off to Luis. He vacuumed out years of construction dust from our return vents and even reset the registers I'd been struggling with. Friendly and professional the whole time.",
          "name": "Caleb M.",
          "date": "2025-12-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Solid work on my rental property dryer vent. The line ran a long way through the basement ceiling and they cleared every foot of it. Reasonable rate.",
          "name": "Yolanda R.",
          "date": "2025-01-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Quick and tidy annual sweep. Kevin protected the hearth with a drop cloth and finished in under an hour. Damper works smoothly now.",
          "name": "Aileen B.",
          "date": "2024-03-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quick and painless to set up. The office had a slot two days out and texted twice with reminders so I never forgot. Jordan arrived with shoe covers on and went through every supply duct in the house.",
          "name": "Lorraine T.",
          "date": "2025-06-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked same-day after our pediatrician suggested cleaner indoor air for our asthmatic toddler. Dmitri was thorough, vacuumed each supply duct and even cleaned the blower compartment. Reasonable price for the peace of mind.",
          "name": "Daniel K.",
          "date": "2025-01-17",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Scheduling was painless and they had someone out the same afternoon. Felix did a full safety check on the gas logs, tested carbon monoxide levels near the unit, and cleaned the glass front. He even showed me where the shutoff valve was since I had no idea. Honest pricing, no upsell.",
          "name": "Lakeisha T.",
          "date": "2026-01-17",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Wonderful experience getting our wood-burning fireplace ready for fall. Sam was punctual, wore shoe covers, and worked methodically. He cleaned the firebox, checked the damper operation, and pointed out that the chimney cap screen was partially blocked with debris. He cleared it and tightened the stainless cap while he was up there. The office had texted me a reminder the day before, which I appreciated. Whole thing took about ninety minutes and the area was spotless when he left.",
          "name": "Priya K.",
          "date": "2025-09-29",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Fair and transparent from the first call. The quote covered everything, including the written report I got at the end. Tony wore shoe covers, never once mentioned an add-on, and the price never moved.",
          "name": "Amara O.",
          "date": "2024-06-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Allergies got bad once we adopted two dogs. Pavel inspected the whole system, found dander buildup near the blower, and cleaned every branch. Transparent pricing, no surprises.",
          "name": "Priya N.",
          "date": "2024-07-19",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Clothes were taking forever to dry and the dryer felt hot to the touch. Marcus diagnosed a long roof-exit duct packed with lint and a partially crushed section in the wall. He cleaned the whole length, replaced the crushed segment, and put a new louvered cap on the roof termination. Honest pricing, quoted before he started, no surprises at the end.",
          "name": "Priya N.",
          "date": "2025-03-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Reconnected a detached duct behind a soffit that two other companies missed. Andre found it within twenty minutes, sealed the connection, and tested airflow at each vent before leaving. Fair price and same-day service.",
          "name": "Gerald P.",
          "date": "2024-10-12",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Lint was blowing back out around the wall flap, so I called. The technician cleaned the run and put on a new vent hood with a louvered pest guard. Explained why the old one failed. Reasonable pricing and on time.",
          "name": "Curtis B.",
          "date": "2023-07-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Fifth or sixth time we've had this company out across air ducts and chimney. Marco handled the duct cleaning, set up drop cloths in the hallway, and flagged that one return vent register was bent and letting dust bypass the filter. Fixed it on the spot. Twenty-plus years in business and it shows in how smooth the whole visit runs.",
          "name": "Lucinda R.",
          "date": "2025-12-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Noticed loads needed an extra spin every time. Quick and thorough vent cleaning fixed it. The lint trap area was the main culprit.",
          "name": "Tobias K.",
          "date": "2024-11-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Water was coming in around the damper and rusting it. Diego diagnosed a cracked crown plus a failed cap. He replaced the cap with stainless, patched the crown, and sealed everything. Same-day service which I did not expect. Damper works smoothly now and no more moisture.",
          "name": "Gerald K.",
          "date": "2024-06-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Pollen season is brutal for me. Booked these folks after a neighbor's recommendation. Hector cleaned the whole system and pointed out where dust was getting pulled in around a poorly sealed register. Less sneezing already.",
          "name": "Desmond W.",
          "date": "2023-07-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Was worried about dust everywhere since we'd just repainted. The crew rolled out drop cloths along the entire path and used a HEPA vacuum at every register. When they pulled years of buildup from the supply ducts it all went into a sealed container rather than billowing around the house. They wiped the vent covers down before screwing them back in, and gave me a quick before-and-after photo set on a tablet. Cleaner when they left than when they arrived.",
          "name": "Quentin F.",
          "date": "2024-07-19",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Whole-house duct cleaning after we gutted two bathrooms. The crew got out an unbelievable amount of sawdust and grout dust. Drop cloths down, shoe covers on, registers all reinstalled cleanly. Office quoted a transparent flat rate.",
          "name": "Tobias R.",
          "date": "2025-04-29",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our home inspection flagged the air ducts the day before closing and we panicked. This family-owned outfit took the call and got Sergei out that same afternoon. He inspected everything, cleaned the system, and handed us a written report we could give the buyer. On time and absolutely clutch under pressure.",
          "name": "Tobias W.",
          "date": "2024-07-29",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Decided to get this done after reading how many house fires start at the dryer. Mikhail measured the vent length, found a 15-foot run with two elbows packed solid with lint, and cleaned it from both ends. He also resealed the exterior vent hood that was hanging loose. Walked me through the whole thing and gave me a written report. Worth every dollar for the safety alone.",
          "name": "Donovan R.",
          "date": "2025-07-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Carlos diagnosed a sluggish draft as a partially collapsed flue liner. He gave us transparent pricing on the relining before doing any work, no surprises. Fire pulls beautifully now and the smoke smell is completely gone.",
          "name": "Travis O.",
          "date": "2025-03-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "The repair guy explained that a blocked vent was choking the airflow and making the heating element cycle on and off, which is why the dryer felt scalding. He snaked out the whole line and the temperature dropped to normal immediately. Very clear about what he was doing the entire time.",
          "name": "Curtis D.",
          "date": "2025-12-03",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Wonderful experience from start to finish. The scheduler got me a same-day slot, and the crew arrived with a truck-mounted vacuum that pulled construction debris out of the supply ducts left over from our renovation. They sealed a couple of leaky joints, sanitized the system, and the cool air actually reaches the back rooms now. Pricing was exactly what they said, no surprises.",
          "name": "Gustavo M.",
          "date": "2024-05-29",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Old house, old ducts, persistent musty odor. Raj and the crew spent nearly four hours pulling out decades of debris and then fogged the entire system with a sanitizer. They even cleaned the blower compartment where most of the smell was coming from. The difference in air quality is night and day. My allergies have calmed down too.",
          "name": "Nathaniel B.",
          "date": "2025-04-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Sellers said the chimney was fine. Inspection said otherwise. Devin found a cracked crown and spalling brick, all documented in a clean PDF report. That paperwork saved us from a money pit.",
          "name": "Grant W.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Bought a foreclosure where someone clearly chain-smoked. Tyler showed up with a camera scope and walked me through how thick the residue was inside the supply lines before he started. Two techs worked the whole system, laid drop cloths over the hardwood, and gave me before and after pictures. The nicotine smell that hit us every time the AC ran is basically gone now.",
          "name": "Derek O.",
          "date": "2025-06-04",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Same-day service when our system seemed to barely push air. Return grille was caked. Cleaned it out fast and the difference was immediate.",
          "name": "Aaron F.",
          "date": "2023-08-15",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Twenty-plus years in business shows. The crew knew exactly where the airflow restrictions would be and cleaned the trunk line and every branch. AC keeps up in the afternoon heat now.",
          "name": "Curtis D.",
          "date": "2025-07-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Omar was the technician who cleaned our ducts and I can't say enough good things. He brought a camera into the supply lines so I could see the dust and pet dander before he started, then again after. The difference was night and day. Courteous, knowledgeable, and he answered every dumb question I threw at him without making me feel rushed.",
          "name": "Yolanda F.",
          "date": "2024-04-19",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "We own a triplex and the insurance company wanted documentation that the dryer vents were maintained. Nikolai handled all three units in one visit, gave me itemized written reports per unit, and explained how the rigid metal transition duct is safer than the foil flex the previous owner installed. Switched two of them out on the spot.",
          "name": "Daniel O.",
          "date": "2025-10-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Phoned the office about a strong campfire smell coming from the fireplace and they had a crew out same day. Turns out the creosote had reached a glazed stage near the top of the flue. Eli explained the risk of a chimney fire calmly without scaring us into anything, then did a full sweep and re-inspected. He also checked the stainless cap and found a bird's nest tucked behind it. Everything cleared and documented in a written report. Very professional from start to finish.",
          "name": "Lorraine V.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Rescheduling is usually a headache but not here. I had to move my appointment twice because of work and the scheduler handled it cheerfully both times, resending a new reminder each time. When the day came they cleaned the ducts and replaced two crushed return vent covers. Clear communication throughout, and the written report explained everything they found.",
          "name": "Hassan B.",
          "date": "2024-07-19",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Moved into an older home with a four-month-old and the dust was relentless. Victor explained how the return vents pull air through the whole system and showed me the gunk he removed. He was gentle and quiet so he wouldn't wake the baby during her nap. Photos before and after made it obvious the cleaning was worth every dollar. Truly a family-owned outfit that gets families.",
          "name": "Sofia M.",
          "date": "2025-06-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Pleased with the gas-log tune-up. Ramon replaced the worn pilot orifice, vacuumed the firebox, and verified the embers were placed correctly so they glow without blocking the burner. Flame looks natural again.",
          "name": "Walter B.",
          "date": "2025-02-11",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Needed the fireplace ready before the holidays. Quick, thorough, and the tech bagged the ash and creosote so nothing got tracked on the carpet. Damper moves freely now.",
          "name": "Caleb W.",
          "date": "2024-11-21",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Refreshing to deal with a company that just does what it says. The price quoted included clearing the full vent run and reattaching the loose section behind the dryer. Luis showed me the lint he pulled out, snapped a couple before and after photos, and the final total was identical to the estimate. Zero pressure to buy a maintenance plan or any of that.",
          "name": "Bryce H.",
          "date": "2025-12-05",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Same-day appointment after I noticed fur blowing out of the supply vents whenever the AC kicked on. Kevin arrived with the full rig, sealed off each register, and pulled years of accumulated pet hair out of the trunk line. He even cleaned the return grilles by hand. Honest crew, family-owned, and the air quality is genuinely better.",
          "name": "Walter K.",
          "date": "2026-02-17",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Rooftop dryer vent on a two-story house. Jordan got up there, pulled the cap, and brushed the entire run from above. Laid drop cloths around the dryer so no lint got on the floor.",
          "name": "Garrett L.",
          "date": "2023-08-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "This family-owned outfit fixed a problem I'd lived with for years. A supply duct under the master bedroom had separated at the collar. Dmitri sealed all the visible leaks with mastic, reattached the run, and added straps so it won't sag again. He wore shoe covers and cleaned up every scrap. The room finally gets warm in winter.",
          "name": "Marisol D.",
          "date": "2025-12-07",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Wonderful experience start to finish. Felix cleaned years of compacted lint out of our dryer duct and pointed out where a section of flex hose had been crushed behind the machine. He straightened that out and capped the exterior with a new stainless hood that has a fine pest mesh to keep wasps from building nests in it. He even reset the dryer back into place perfectly level. Clothes dry faster and the laundry room finally smells fresh.",
          "name": "Aisha L.",
          "date": "2025-11-27",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Long-time customer here. We rotate between duct cleaning and the occasional dryer vent check, and the office always remembers our history. Sam cleaned the supply ducts and reseated a damper that had been rattling for months. Written report emailed before he even left the driveway.",
          "name": "Hassan B.",
          "date": "2026-01-17",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "After moving into an older home the dryer would run two cycles and clothes were still warm and damp. Tony inspected the entire vent path, found a bird nest blocking the exterior hood, and cleared it along with packed lint deeper in the line. He installed a new vent cap with a guard. Drying time is half what it was.",
          "name": "Lena V.",
          "date": "2026-01-17",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Noticed efflorescence, that white chalky stuff, all over the exterior brick. Pavel explained it meant water was getting in through the crown. He waterproofed the masonry and recrowned the top. The transparent quote matched the final bill to the dollar. Really thorough, walked me through every photo.",
          "name": "Priya N.",
          "date": "2026-05-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "As someone with chronic allergies, I notice every speck of dust. The crew was meticulous, covering furniture before they touched a single vent. They showed me the before/after photos of the supply ducts and the difference was shocking. Breathing easier and waking up without a stuffy nose for the first time in years.",
          "name": "Camila O.",
          "date": "2025-12-02",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Marcus and his partner were meticulous. Plastic sheeting over the doorways, shoe covers, drop cloths under every vent they opened. The amount of dust that came out of the return ducts was alarming but none of it ended up on my floors. Swept and vacuumed before they left.",
          "name": "Imani S.",
          "date": "2026-02-04",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Following our open-concept remodel, the air felt gritty no matter how often I dusted. Andre and Andre arrived together, mapped out the supply and return runs, and used a rotary system on the main trunk lines. They opened a couple of access panels and pulled out drywall chunks the framers had let fall in. Detailed written report at the end with photos of each vent. The whole family-owned vibe came through, very respectful of our space.",
          "name": "Gretchen M.",
          "date": "2024-11-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Smelled hot lint and shut the dryer off immediately. The office understood the safety concern and dispatched Marco the same day. He cleared the duct, cleaned behind the machine, and explained the burn risk a clogged vent creates. Fast and reassuring.",
          "name": "Marisol D.",
          "date": "2025-05-11",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Family-owned outfit that actually treats your home like it matters. Diego showed up in shoe covers, pulled an honestly disturbing amount of lint out of the duct, and explained why the rooftop termination was the choke point. Same-day service too.",
          "name": "Coraline B.",
          "date": "2025-11-26",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Every gust of wind sent smoke back down our chimney. Hector found the crown was cracked and rain had been seeping in, plus the cap was rusted out. New cap and a sealed crown later, the draft is rock solid. Thorough and tidy.",
          "name": "Cynthia A.",
          "date": "2024-06-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Dryer shutting down constantly. Sergei showed up with shoe covers, found the booster fan upstream was packed with lint, and cleaned the full duct. Works perfectly now.",
          "name": "Sofia B.",
          "date": "2026-01-17",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Quick, clean, professional. Mikhail cleaned out the return ducts before summer and the musty smell that hit every time the AC turned on is gone.",
          "name": "Whitney A.",
          "date": "2025-04-14",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Stale, locker-room smell in the hallway whenever the heat ran. The technician traced it to buildup in the main trunk line and a clogged return. Cleaned and sanitized the same afternoon. No more odor.",
          "name": "Camille W.",
          "date": "2024-08-19",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Reliable family-owned outfit. We scheduled a pre-sale chimney inspection and the office got us in within two days. The written report covered the damper, the cap, and creosote levels, and the technician put down drop cloths so there was zero mess in our living room. Buyers were satisfied and the deal went through smoothly.",
          "name": "Lillian F.",
          "date": "2024-09-27",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "So glad I called. Our new home had a previous owner with several large dogs, and the dander was triggering my daughter's allergies constantly. Carlos was thorough with every return vent and supply register, vacuumed the trunk line, and explained the whole process in plain terms. He even pointed out a loose duct connection and sealed it. My daughter has barely sneezed since. Certified, insured, and genuinely kind people.",
          "name": "Latoya B.",
          "date": "2025-12-19",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "With two cats the return vents had become a fur magnet and our airflow had dropped to almost nothing. Raj removed every grille, brushed and vacuumed the returns, then ran his system through the supply lines. He showed me the filter we'd been neglecting too. The HVAC finally breathes and the dust on the furniture has noticeably dropped. Certified, insured, and respectful of the house with shoe covers throughout.",
          "name": "Mei L.",
          "date": "2025-11-27",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Moved into a 90s house and the ducts had clearly never been cleaned. Devin found a collapsed flex run feeding the master bedroom that was killing the airflow, repaired it, and cleaned the rest of the system. The room finally holds temperature and the thermostat doesn't fight itself anymore. First full month our energy bill was down about eighteen percent. Honest, careful work and a written report at the end.",
          "name": "Priya N.",
          "date": "2026-05-11",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Tyler did a fantastic job on the air ducts. He noticed our filter was the wrong size and recommended the right MERV rating. Tidy work, drop cloths down, gone in under ninety minutes.",
          "name": "Nathan K.",
          "date": "2025-06-27",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Property manager here. Scheduling was painless, the office worked around my tenants' availability for two separate apartments. Omar cleared a vent that was so packed the exterior flap wouldn't even budge. Lint everywhere came out into the vacuum bag, not the unit. Tenant texted me later that the laundry room finally stopped smelling hot. Will use them for the rest of my portfolio.",
          "name": "Megan T.",
          "date": "2026-04-11",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Our annual chimney maintenance with this family-owned outfit has been consistent for years. Nikolai swept the flue, checked the firebox mortar joints, and noted the crown could use a sealant before next winter. No pressure, just an honest written report and fair pricing.",
          "name": "Curtis A.",
          "date": "2024-12-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Loved how communicative the office was. After I booked the dryer vent cleaning I got an email confirmation, a text reminder the day before, and a courtesy call when Eli was running about ten minutes behind. He cleared the lint buildup and tested the airflow at the vent hood. Honest folks.",
          "name": "Bianca S.",
          "date": "2025-12-03",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "My husband and I are first-time parents and a bit paranoid about air quality. Victor walked us through every step, from sealing the registers to running the negative-air machine. He pointed out a disconnected duct in the basement that was dumping dusty crawlspace air into the house. Fixed it on the spot. The written report was detailed and the price matched the quote exactly.",
          "name": "Grace L.",
          "date": "2024-08-19",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "After moving into a house with a gas fireplace we'd never used, we wanted a pro to confirm it was safe before lighting it. Ramon inspected the venting, checked the firebox for cracks, tested the igniter, and gave us a clear rundown of how to operate it. Patient and thorough with all our beginner questions.",
          "name": "Yvonne S.",
          "date": "2025-11-05",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Realized mid-winter we'd never had the fireplace serviced. Luis squeezed us in same day, swept the flue liner, scraped down the smoke chamber, and replaced a worn gasket on the glass door of our insert. He took before and after photos so I could actually see the difference. Reasonable price and he explained everything in plain terms.",
          "name": "Renata G.",
          "date": "2026-01-09",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "No games with the pricing. They told me the cost for all the supply and return ducts and stuck to it even when the job ran longer than expected. Kevin was thorough and put drop cloths down so nothing got dirty.",
          "name": "Sofia R.",
          "date": "2023-08-22",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Long-haired cat had us dusting daily. Jordan ran negative-air through every duct and the difference in airflow alone is worth it. Vents are spotless.",
          "name": "Daniela F.",
          "date": "2025-06-30",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Booked a cleaning for our extra-long dryer duct that snakes through the ceiling and exits on the roof. Dmitri showed up same day, wore shoe covers, and treated the place like his own. He explained that long runs need more frequent cleaning and showed me how much lint had built up at each elbow. The dryer runs noticeably cooler now and a single cycle actually dries the towels.",
          "name": "Selene V.",
          "date": "2025-12-09",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Half our heat was escaping into the basement through gaps at the duct seams. Felix walked me through each leak with a flashlight, sealed them with mastic, and reconnected a run that had popped off the trunk line. Tidy, professional, and the upstairs bedrooms warmed right up.",
          "name": "Wendell T.",
          "date": "2024-03-15",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Dryer was overheating and shutting off mid-cycle. Sam found the exterior hood completely blocked with lint and a dead bird. Cleaned the whole vent, then mounted a new hood with a proper pest guard. Showed me the debris in a bucket so I'd know it was real. Problem solved the same afternoon.",
          "name": "Garrett W.",
          "date": "2024-04-11",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Reliable family business we keep coming back to. The technician sanitized the return vents and showed before/after photos. Quick, clean, no upsell.",
          "name": "Tamara W.",
          "date": "2024-07-26",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Booked these folks after my energy bill crept up and laundry took forever. Tony explained the longer the dryer runs the more I pay, then cleaned the full vent run and checked the lint trap housing. He sent before and after photos by text. Worth every penny.",
          "name": "Marcus D.",
          "date": "2024-04-05",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Cracked crown repaired and a new rust-resistant cap put on. Pavel was quick and clean, laid drop cloths from the front door to the hearth. No leaks the following winter.",
          "name": "Sawyer B.",
          "date": "2023-08-27",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Constant morning congestion finally pushed me to get the ducts done. Marcus was on time and walked me through the dust buildup in the return vents. A week later the sneezing is noticeably better and my allergy meds aren't running out as fast.",
          "name": "Brandon K.",
          "date": "2024-08-12",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Clean operation all around. They laid runners down the stairs, bagged the debris from the supply lines, and wiped fingerprints off the registers afterward. No trace of the visit.",
          "name": "Garrett P.",
          "date": "2023-08-25",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Sawdust from our flooring install was everywhere in the ducts. Andre cleaned every return and supply, replaced the filter, and showed me the before and after. Quick, professional, fairly priced.",
          "name": "Lamar W.",
          "date": "2026-05-11",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Allergies were brutal and I suspected the ductwork. Booked a morning slot and the tech actually arrived early. Marco cleaned all the return vents and supply runs, used a camera to show me the buildup, and the difference in air quality was noticeable by that evening. Twenty-plus years of experience really shows in how efficiently he worked.",
          "name": "Aaron P.",
          "date": "2024-09-06",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Noticed the laundry room felt humid and hot every time I ran a load. Turned out the vent was nearly blocked. Diego cleared it, checked the lint trap, and confirmed strong airflow at the outside flapper. Quick and reasonable.",
          "name": "Tobias L.",
          "date": "2023-10-12",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Booked a same-day inspection because the smoke smell got unbearable. Hector arrived with a camera and showed me creosote glaze coating the upper flue. Cleaned it out and explained why seasoned wood matters. House smells normal again.",
          "name": "Desmond P.",
          "date": "2025-10-26",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "My dryer started shutting off and throwing a heat error. This family-owned crew came out and discovered the vent run going up two stories was caked with lint. Sergei used a rotary brush and a vacuum to clear it and gave me a written report afterward. The whole thing was reasonably priced and the dryer hasn't overheated since. Honestly relieved it wasn't the machine itself.",
          "name": "Gerald W.",
          "date": "2024-09-05",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Got the ducts done ahead of the first heat wave and I'm glad I did. The technician showed me the camera footage of the inside of the ducts before and after, and the difference was honestly gross to see but satisfying. He also pointed out our furnace filter was the wrong size and restricting airflow. AC runs quieter and the electric bill dropped noticeably.",
          "name": "Ibrahim D.",
          "date": "2026-05-20",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Transparent pricing was a big deal for me, and they delivered. Quoted me a flat rate over the phone for a full duct cleaning and mold sanitizing, no surprises at the end. Mikhail walked me through every vent he cleaned and the antimicrobial spray he used. The musty basement smell is completely gone.",
          "name": "Desmond F.",
          "date": "2026-02-11",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Needed documentation for the home sale and these folks delivered. Carlos scoped the entire flue, noted the liner was in good shape, and the report came with timestamped photos. Professional from start to finish.",
          "name": "Desmond A.",
          "date": "2025-06-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "House smelled like an ashtray the day we got the keys. The technician cleaned all the ductwork and returns, and the stale smoke smell finally lifted. Quick, clean, and the price matched the quote exactly.",
          "name": "Steven A.",
          "date": "2024-04-11",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Our energy bills had crept up and rooms felt stuffy. Raj diagnosed it as severely clogged returns restricting the blower. He cleaned the whole system, returns included, and gave me a written report with photos. Bill matched the estimate. Bills should drop now.",
          "name": "Greg P.",
          "date": "2024-02-28",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Weak airflow from half my vents. Tech cleaned the returns and supply lines and replaced a crushed section of duct. Big improvement in circulation.",
          "name": "Brandon L.",
          "date": "2023-08-15",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Impressed by Devin from start to finish. He sanitized all the supply ducts after cleaning and the musty smell we'd lived with for years is finally gone. Very polite young man, explained the whole process, and showed me the debris bag at the end. Family-owned outfit that clearly trains its people well.",
          "name": "Sophia A.",
          "date": "2024-10-15",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Quick turnaround on a rental unit dryer vent that hadn't been serviced in ages. Tyler found the duct disconnected behind the wall, reattached it properly, and sealed the joint. Honest about what was needed.",
          "name": "Foster L.",
          "date": "2024-07-25",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Creosote removal was needed badly after we'd skipped a couple of seasons. The buildup was thick and shiny in spots. Omar used the rotary system and showed me a handful of the glazed flakes he pulled out. Flue is clean and drafting properly again, and he reattached the loose cap screws while he was up there.",
          "name": "Beatrix S.",
          "date": "2025-10-27",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Family run business that actually picks up the phone. Set my duct cleaning in one call, got a reminder the night before. Tech checked the damper and cleaned all the returns.",
          "name": "Gerald W.",
          "date": "2023-10-12",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Wanted the ducts done before bringing our preemie home from the NICU. Same-day appointment, certified tech, and a fair price. Nikolai cleaned every vent and showed me before/after photos. Highly recommend for any parent.",
          "name": "Aisha D.",
          "date": "2025-11-29",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Excellent service from a genuinely family-owned outfit. The tech cleaned the burner ports with a fine brush, checked the gas pressure at the valve, and confirmed the flue was clear for the gas logs. He also pointed out our CO detector batteries were dead and waited while I swapped them.",
          "name": "Curtis A.",
          "date": "2024-10-19",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Got the gas fireplace tuned up before sweater weather. Eli cleaned the glass, vacuumed years of dust off the logs, and adjusted the air mixture so the flame stopped sooting up the glass. Big improvement.",
          "name": "Otis H.",
          "date": "2025-10-19",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Got three estimates and these guys were the only ones who didn't change the number when the tech showed up. Victor cleaned every vent in the house, replaced one cracked register cover at no charge, and handed me a written report. Exactly what was quoted, no hidden charges, no upsell on duct sealing I didn't ask about.",
          "name": "Desmond K.",
          "date": "2026-01-29",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "We have four pets and the ductwork showed it. Ramon pulled out matted hair from the return plenum and shared a written report with photos at the end. Professional and tidy.",
          "name": "Gregory A.",
          "date": "2024-04-11",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Our dryer vent travels the entire length of the basement and then up to a rooftop cap. Luis used a powerful vacuum on one end and a spinning brush from the roof. He found a bird nest jammed near the exterior hood, which explained the poor airflow. Replaced the cap with a proper screened one.",
          "name": "Bennett C.",
          "date": "2024-10-03",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Prompt and thorough. A flex run had detached over the kitchen and was blowing into the attic insulation. Kevin reseated the collar, sealed it, and checked the surrounding joints. Airflow at that vent went from nothing to strong.",
          "name": "Lacey B.",
          "date": "2025-05-22",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "The scheduler got me in next morning. Jordan was friendly and explained everything as he worked, vacuuming the duct and brushing the lint trap housing. Our cheap plastic exterior vent had cracked and let in a wasp colony last summer, so he replaced it with a metal vent hood and integrated pest guard. Tidy, fast, and the written report listed exactly what he did.",
          "name": "Priya S.",
          "date": "2026-01-15",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "We've leaned on Master for air ducts for the better part of a decade, so when the chimney needed attention we didn't shop around. Dmitri inspected the flue liner, scraped down a heavy creosote layer, and recommended a new stainless cap to keep critters out. He walked us through every line item before starting. That kind of trust is exactly why we stay loyal.",
          "name": "Vincent A.",
          "date": "2025-04-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "My jeans needed three cycles, no exaggeration. The crew came out same day, used shoe covers, and traced the vent from the back of the dryer through the wall. They removed a solid clog and tightened a loose connection that was leaking lint into the laundry room. Everything dries on the first cycle now and the room feels cooler.",
          "name": "Yvonne S.",
          "date": "2025-06-23",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "We bought an older home and the inspection flagged the chimney. Felix came out and found a badly cracked crown and a cap that was basically rust. He recast the crown, installed a stainless cap, and applied waterproof sealer to the entire chimney. Detailed written report with photos that I forwarded to our insurance. Great experience start to finish.",
          "name": "Ingrid F.",
          "date": "2025-07-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Worth every penny for an asthma household. Sam and the crew cleaned each supply and return, replaced our clogged filter, and left a written report with photos. The air in the bedrooms feels lighter and my wheezing at night has calmed down considerably.",
          "name": "Naomi F.",
          "date": "2026-04-19",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Could not believe how clean they kept everything. Tony put down drop cloths in the hallway and a separate mat by the front door for his tools. He vacuumed each return vent before removing the cover so loose dust wouldn't fall. The negative-air machine caught everything else. When the job wrapped he ran a dust mop over the whole main floor even though it didn't need it. Total respect for our home.",
          "name": "Lucia B.",
          "date": "2025-11-17",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "We had a contractor finish our attic conversion and the drywall sanding left a film on every vent in the house. Pavel came out, sealed off the registers, and ran a negative-air vacuum through the system. He pointed out where joint-compound dust had built up near the blower. Took about three hours and the difference in air quality was immediate. No more sneezing fits in the morning.",
          "name": "Yuki H.",
          "date": "2023-08-22",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Dryer quit the day of a family reunion with a mountain of towels to wash. Same-day appointment, Marcus arrived right on schedule, found the vent completely blocked at the elbow, and had it flowing in under an hour. Punctual and professional.",
          "name": "Latoya B.",
          "date": "2025-10-19",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "After 12 years in this house I'd never had the dryer vent cleaned, which I now know is a real fire hazard. Andre arrived on time, used a long rotary brush to break up the lint mat in the duct, and vacuumed everything as he went. He found a dead bird nest near the exterior vent too. Showed me photos of the buildup before and the clean run after. Genuinely impressed by how thorough he was.",
          "name": "Marguerite S.",
          "date": "2026-02-04",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Persistent draft problems solved. Marco measured the flue and found it was undersized for our new insert, causing smoke to spill. He recommended the right fix and the difference is huge.",
          "name": "Bianca L.",
          "date": "2026-01-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Diego diagnosed our overheating dryer in minutes. The vent hood outside was completely matted and the duct behind the wall was restricted. He cleaned both, checked the airflow, and the dryer stopped cutting out. Friendly and tidy work.",
          "name": "Naomi F.",
          "date": "2025-04-11",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Family-owned and it feels like it. Hector treated our place with care, vacuuming each vent and wiping down the registers. The system breathes so much easier now that summer is here.",
          "name": "Caroline P.",
          "date": "2024-06-11",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "After a small flood in the crawlspace we panicked about mold getting into the ductwork. These guys came out fast, inspected with a scope, and reassured us. They cleaned everything and applied a sanitizing treatment to be safe. The written report gave us real peace of mind.",
          "name": "Aisha T.",
          "date": "2025-11-26",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Our buyer's inspector wanted a specialist to verify the chimney. Sergei came out, did a full inspection, confirmed the flue liner was intact and the crown only needed minor sealing. The written report was so detailed it satisfied both the buyer and their agent immediately. Honestly relieved it was this painless.",
          "name": "Margaret O.",
          "date": "2024-04-11",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "We recently purchased a home where the prior owners had cats in every room. Even after a deep clean the air felt thick with dander whenever the system ran. Mikhail came out, scoped the ducts, and showed me on his screen just how much buildup was in the supply lines. He spent nearly four hours cleaning the entire system, wore shoe covers the whole time, and left a detailed written report. The air quality improvement is honestly remarkable, no more itchy eyes in the morning.",
          "name": "Caroline W.",
          "date": "2026-01-23",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Couldn't figure out why the AC ran constantly while barely cooling. Carlos pulled the main return grille and it was nearly sealed shut with dust and lint. After he cleared both returns and the supply ducts, the airflow at every register doubled, no exaggeration. He explained everything in plain language and the price was exactly what the office quoted. This is how a family-owned company should operate.",
          "name": "Tamara J.",
          "date": "2025-06-30",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "What stood out was how methodical Raj was. He sealed off each register, ran the negative-air vacuum, and walked me through the dust load on every line. Our two-story finally heats evenly upstairs and down, and the furnace short-cycling stopped. Bill came down enough that the cleaning basically pays for itself over a winter.",
          "name": "Sofia R.",
          "date": "2025-11-29",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Devin tackled our return vents and you could tell he took pride in the work. Thorough and friendly. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Garrett P.",
          "date": "2025-08-09",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Owning rentals means fire safety is always on my mind. Tyler did a thorough dryer-vent cleaning at my single-family rental, brushed the entire run, and tested airflow at the vent hood afterward. He noted the screen on the exterior cap was trapping lint and swapped it for a louvered cover. Professional and certified, exactly what a landlord wants on file.",
          "name": "Sandra V.",
          "date": "2025-12-03",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Friendly tech, spotless work. Annual sweep, damper checked, and a clear photo report emailed within the hour. Fair price, friendly crew, and a job done right the first time — no complaints at all.",
          "name": "Hugh M.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "From the first phone call the scheduler was friendly and gave me transparent pricing with no upsell pressure. They texted me a reminder the evening before and again the morning of with the technician's name. Omar showed up on time, cleaned the dryer vent thoroughly, and explained why the lint trap area needed attention. Wonderful coordination from the office staff.",
          "name": "Yolanda P.",
          "date": "2025-02-26",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Newborn plus a dog equals a lot of allergens floating around. Nikolai arrived right on time, put down drop cloths, and cleaned all the supply and return ducts. He found mold starting near one register and flagged it with a written recommendation. Appreciated that he didn't pressure us into anything extra.",
          "name": "Benjamin F.",
          "date": "2024-05-12",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Gas logs wouldn't stay lit and Eli diagnosed a dirty thermocouple within minutes. Cleaned it, tested the pilot flame, and everything works again. Fair price for a quick fix.",
          "name": "Nadia F.",
          "date": "2025-12-03",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "This family-owned outfit did a fantastic job prepping our fireplace for the season. The tech inspected the firebox, swept the flue, and noticed the damper was rusted partly open, which explained our high heating bills last year. He freed it up and showed me how to confirm it closes fully. Left a detailed written report. The kind of service that earns repeat customers.",
          "name": "Felicia D.",
          "date": "2024-09-27",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "The vent had not been cleaned in years and I braced for an inflated bill. Victor cleared a huge wad of lint from the trap and the exterior flap, tested airflow, and charged the quoted rate. Honest work.",
          "name": "Natalie F.",
          "date": "2024-09-17",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Moved into a home where the previous owners had big dogs, and the supply ducts were lined with old fur and dander. Ramon did a meticulous job, scrubbing each run and vacuuming the registers individually. He pointed out a loose section of duct while he was in there and reconnected it at no extra charge. The whole house breathes cleaner now and my partner's allergy symptoms have eased up considerably.",
          "name": "Marisol V.",
          "date": "2025-10-25",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "What a difference. The vent run from our laundry closet is long and turns twice before exiting the roof. Luis measured airflow before and after, cleaned the whole run, and the reading more than doubled. He left a written report with the airflow numbers and photos of the lint he removed.",
          "name": "Ingrid S.",
          "date": "2026-01-17",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Noticed one bedroom never cooled down no matter what. Kevin traced it to a supply duct that had come apart at a junction in the attic. He reconnected the two sections, sealed the seam with mastic tape, and verified the airflow with a meter. Clear pricing quoted upfront, no surprises on the invoice.",
          "name": "Quentin R.",
          "date": "2026-01-26",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Quick visit to clean a clogged dryer vent. Jordan also installed a new exterior hood with a pest screen since the old flapper had broken off. Airflow is night and day. Appreciated the heads up about checking it yearly.",
          "name": "Lamar D.",
          "date": "2025-06-23",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Repeat customer for sure. The crew arrived same-day after a cancellation freed up, cleaned all the supply and return ducts, and Dmitri pointed out where insulation had collapsed onto a duct run in the attic. Helpful as always.",
          "name": "Felicia D.",
          "date": "2024-09-02",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Dryer was taking multiple runs to finish a load. Felix cleaned the vent and the exterior hood flap, which was stuck wide open. Fast, polite, fair price.",
          "name": "Theo B.",
          "date": "2023-08-12",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Leak around the chimney during the rainy season was driving me nuts. Sam traced it to deteriorated flashing and a hairline crack in the crown. He sealed both and added a waterproof coating. Problem solved, and he never tried to upsell me on anything extra.",
          "name": "Damon W.",
          "date": "2024-09-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Pet dander and dust were a nightmare for my allergies. Tony cleaned the entire duct system and sanitized it. Sneezing dropped off within days.",
          "name": "Otis L.",
          "date": "2024-05-27",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Tidy crew, careful work. Shoe covers, drop cloths under the furnace, and they sealed each duct opening with tape between sections. The supply ducts had a lot of buildup but the cleanup was flawless.",
          "name": "Nathaniel C.",
          "date": "2024-03-12",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Renovated the entire first floor and the HVAC was full of construction debris. Pavel and the crew laid down protective sheeting, brushed out the supply ducts, and cleaned all the return vents. They found and removed a wad of sawdust packed against the damper. Honest, upfront pricing from the office and certified techs. Genuinely happy with the result.",
          "name": "Brett D.",
          "date": "2025-12-09",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Moved into an older place and the previous owners clearly never cleaned the ducts. I called expecting a week-long wait and instead got a slot that very afternoon. Marcus showed up within the quoted window, taped off the supply vents, and ran his equipment through the whole system. He even found a disconnected return that was pulling in attic dust and reattached it. Walked me through everything with photos. Honest, prompt, and thorough.",
          "name": "Nathaniel K.",
          "date": "2026-01-27",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Saw a documentary on dryer fires and panicked a little. Andre came out, inspected the full run, and pulled out matted lint the size of a football. Replaced my crushed foil hose with rigid pipe. Sleep easier now.",
          "name": "Felipe A.",
          "date": "2024-09-17",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "After years of putting up with a smoky fireplace, we finally called. Marco pulled out an enormous amount of creosote and discovered the damper was warped and not opening fully. He freed it up and now the draft roars to life the second we light a match. Wish we'd done this sooner. Fair price too.",
          "name": "Quentin H.",
          "date": "2024-08-05",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Was about to buy a new dryer because it kept running hot and quitting. The technician convinced me to let him inspect the vent first. Good thing, it was packed solid for about six feet. Cleared it and the machine works like new. Saved me hundreds.",
          "name": "Eduardo P.",
          "date": "2023-11-28",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Pre-season duct cleaning was money well spent. The crew was on time, friendly, and explained how the buildup in the supply lines was making the AC work harder than it needed to. After they cleaned everything the airflow at every register improved noticeably. Got a written report with photos for our records too.",
          "name": "Nathaniel R.",
          "date": "2025-05-02",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Twenty-plus years in business shows. Diego knew exactly where musty odors hide and went straight for the return plenum. Cleaned, sanitized, sealed a small gap. Fresh air in every room now.",
          "name": "Roland H.",
          "date": "2024-05-12",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Transparent pricing and fast turnaround. Got the inspection report before our closing date with no drama. The tech even pointed out the rusted damper that the seller eventually replaced.",
          "name": "Bryce T.",
          "date": "2025-08-29",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Pet smell in our new place was overwhelming. Hector and his partner cleaned the return ducts and supply vents, used drop cloths everywhere, and the odor that lingered around the registers is gone. Same-day booking made it easy.",
          "name": "Nathaniel F.",
          "date": "2025-05-27",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Bedroom vents were hardly blowing. Sergei found a clogged return strangling the system, cleaned it, and airflow returned. Quick and tidy with drop cloths down.",
          "name": "Victor H.",
          "date": "2023-11-19",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Quick, clean, professional. Cleared a heavy dust buildup in the main return that was strangling the airflow. System breathes much better.",
          "name": "Nathaniel O.",
          "date": "2024-02-09",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Mikhail cleaned the entire duct system in our older home and was a true professional. He pointed out a small leak in one of the supply runs and taped it temporarily, then noted it in the written report so we could schedule a proper repair. Wore shoe covers, never tracked anything in, and left the place spotless. Hard to find this level of care.",
          "name": "Renata V.",
          "date": "2024-02-23",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Tenant in my condo unit kept resetting the thermal fuse on the dryer. Turned out the vent was almost fully blocked. Carlos cleared it, vacuumed the lint trap cavity, and the dryer has worked fine since. Appreciated the clear explanation.",
          "name": "Wesley B.",
          "date": "2025-03-27",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Reached out for our regular yearly sweep and Raj arrived right on schedule. He spread drop cloths from the door to the hearth, swept the entire flue, and inspected the liner with a camera. Found minor creosote, nothing alarming, and pointed out where the flashing around the chimney base was starting to lift. Gave me a written estimate to address it later but never pushed. Clean, courteous, and exactly the kind of maintenance I count on every fall.",
          "name": "Yolanda P.",
          "date": "2025-09-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Appreciated the proactive reminders. They booked me for same day, sent a confirmation text, then a follow up when the crew was loading up to head over. The supply ducts and return vents all got cleaned and they handed me a written report before leaving.",
          "name": "Conrad H.",
          "date": "2024-04-05",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Our six-month-old kept waking up congested and we suspected the vents. Devin confirmed the supply ducts were thick with dust and pet dander. He used shoe covers, was careful around the nursery, and the difference in air quality was immediate. Transparent pricing, no upsell.",
          "name": "Carmen V.",
          "date": "2025-02-26",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Booked a pre-season safety check on our gas-log set and could not be happier. Tyler arrived in shoe covers, spread a drop cloth, and methodically went through the pilot assembly, the oxygen depletion sensor, and the glass gasket seal. He found the logs had drifted out of position and reset them to spec, then ran the unit for fifteen minutes to confirm a steady blue-to-yellow flame with no soot. Detailed report emailed same day.",
          "name": "Gregory P.",
          "date": "2026-02-20",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Straightforward cleaning before the cold. Tech removed creosote from the flue, vacuumed the firebox, and checked the cap. No surprises on the bill, exactly what the office quoted.",
          "name": "Gordon L.",
          "date": "2025-11-12",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Pricing was clear before anyone set foot in my house. The scheduler explained the cost per system and there were two HVAC systems, so I got the breakdown for each. Omar cleaned all the returns and supply runs, showed me the dust he vacuumed out, and the invoice matched exactly. He mentioned my filter could use upgrading but never pushed it as a sale.",
          "name": "Wesley A.",
          "date": "2025-04-11",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Shedding season turned our vents into fur traps. Nikolai cleaned every supply and return, then sanitized. Quick and respectful of the house.",
          "name": "Nathaniel B.",
          "date": "2024-09-05",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Three-story walkup, dryer vent goes straight up to the roof. Tech handled the height safely and cleared the lint without tracking anything inside. Quick and tidy.",
          "name": "Cormac D.",
          "date": "2024-04-19",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Eli did a fantastic job sealing leaky ducts in our 1980s ranch. Several joints in the main trunk had gaps, and a branch run had detached entirely near the laundry. He sealed everything, reconnected the loose run, and showed me before-and-after photos. Took his time and explained the whole process. The constant dust on our shelves has noticeably dropped.",
          "name": "Eleanor C.",
          "date": "2025-09-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "I'd noticed our clothes were coming out damp and the dryer felt hot to the touch, which freaked me out after reading about lint fires. Victor came out, cleaned the entire vent line through the basement, and showed me a frightening amount of lint packed near the exterior wall. He capped it with a new stainless vent hood and pest guard so birds stop nesting in there each spring. Calm, knowledgeable, and very fair on price. Will use them again.",
          "name": "Felicia N.",
          "date": "2024-09-03",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "After using this company for the dryer vent two summers in a row, we trusted them with a full duct cleaning. Ramon covered the floors with drop cloths, ran the brush through every line, and gave a fair written estimate for sealing two leaky joints we can schedule later. No pressure, just facts. We'll keep calling them.",
          "name": "Bartholomew N.",
          "date": "2025-08-19",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "We were running everything twice and the laundry room got really hot. Luis pulled the dryer out, vacuumed behind it, and ran a rotary brush through the entire vent line up to the roof termination. He showed me the bag of lint he collected and gave me a written report. Now a single cycle dries the load completely. Couldn't be happier.",
          "name": "Camila F.",
          "date": "2026-04-29",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Rust streaks were running down the white siding from the chimney cap. Kevin replaced the corroded cap with a stainless steel multi-flue cap and sealed the crown where it had cracked. Explained how a proper drip edge keeps water off the brick. Streaks are gone and it looks brand new.",
          "name": "Renata C.",
          "date": "2026-01-18",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We moved into an older home and the dust was relentless, setting off my husband's asthma. Jordan found the ducts hadn't been touched in decades. He cleaned the trunk line, every register, and the return grilles, then showed me the disgusting before photos. The sneezing and tight chest he'd had every evening have eased up a lot.",
          "name": "Lindsey H.",
          "date": "2025-03-15",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Dmitri and the crew protected the whole route with drop cloths and corner guards on the walls. They emptied the collected debris into a sealed bin and hauled it off. The bathroom we let them use for water was wiped down spotless before they left. Floors looked vacuumed, vents gleaming.",
          "name": "Yasmin D.",
          "date": "2026-05-02",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Drywall dust kept coating my furniture after our remodel. Felix cleaned all the return grilles and trunk lines and left a tidy written report. Polite and efficient.",
          "name": "Oksana L.",
          "date": "2024-02-14",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Lint was visibly backing up at the outside vent hood and I was worried about a fire. The office took it seriously and sent Sam the same day. He cleared the run, replaced a crushed section of duct, and verified the flap opened freely. Peace of mind, fast.",
          "name": "Camille F.",
          "date": "2024-04-30",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "The exterior vent flap wasn't opening anymore and lint was leaking around the dryer. Tony diagnosed a blocked duct, cleared it completely, and replaced the broken vent hood with a proper louvered cap that has a pest guard. Drying time cut in half. Polite, on time, and the price matched the quote exactly.",
          "name": "Hannah V.",
          "date": "2025-05-09",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Smoke kept rolling out of the firebox into the living room. The tech identified a blockage of leaves and debris near the top of the flue. After clearing it and sweeping the creosote, the draft was instantly better. Left a written report with photos.",
          "name": "Felicia D.",
          "date": "2025-05-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Laundry took three cycles and the dryer kept overheating to a stop. Pavel found the transition duct kinked and full of lint. He swapped it for a smooth aluminum elbow, cleared the long vent run, and tested the exhaust temperature before and after. Now one cycle does it and the back of the dryer no longer feels like an oven.",
          "name": "Tasha L.",
          "date": "2025-08-23",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Booked these folks because the AC smelled stale every time it ran. Marcus cleaned the evaporator coil area access and all the ductwork, swapped our clogged filter, and now the air is fresh and cold.",
          "name": "Larissa V.",
          "date": "2026-03-27",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Honestly skeptical at first, but the moldy smell in our guest room had become embarrassing. The crew showed up on time, taped off the registers, and ran their vacuum system through the whole house. The before and after photos of the supply ducts were eye-opening. They finished with an antimicrobial fog that killed the odor completely. Same-day service and a fair price. Couldn't ask for more.",
          "name": "Vanessa O.",
          "date": "2026-04-28",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "We almost skipped the chimney inspection to save money but I'm so glad we didn't. Andre found a hidden gap in the flue liner where flue gases could leak into the wall cavity. He explained everything, took photos, and the written report was something we could hand straight to our attorney. That kind of thoroughness during a home purchase is priceless.",
          "name": "Nadia K.",
          "date": "2026-01-17",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "After buying a home from heavy smokers, the recirculated air made the whole place feel stuffy and sour. Marco explained that the residue clings inside the metal ducts and only a full cleaning would help. He was meticulous, cleaned every register, and showed me the filthy filter and the gunk pulled from the trunk line. Fair, upfront pricing and a family-run operation that clearly takes pride in the work. The house finally smells like ours.",
          "name": "Angela P.",
          "date": "2024-10-15",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Scheduling was easy and the office got someone out the same afternoon. Diego showed me how clogged our return vents were, which explained the constant stuffiness and dust. He cleaned every return and supply duct, vacuumed thoroughly, and took before/after photos. The home feels noticeably fresher and the airflow is strong again. Fair, transparent pricing too.",
          "name": "Nadia S.",
          "date": "2026-01-08",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "After years of allergy complaints we finally had the ducts done. Hector showed up on time, taped plastic over the supply registers, and ran a powerful vacuum through the whole system. The amount of debris he pulled out of the return was honestly embarrassing. Airflow at the far bedrooms is finally strong, the AC reaches temperature faster, and our May electric bill came in lower than last year. Couldn't be happier with the results.",
          "name": "Camille A.",
          "date": "2025-04-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Sergei showed up same day after I called about a dusty new place. He scrubbed out every register and ran the brush deep into the supply ducts. Polite, efficient, and walked me through the before and after photos. Couldn't be happier.",
          "name": "Aaron L.",
          "date": "2025-05-16",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Reliable crew for landlords. They cleaned the dryer vents at two of my rentals back to back, both running long routes to the roof, and left the laundry closets cleaner than they found them.",
          "name": "Aisha D.",
          "date": "2024-09-16",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Routine creosote cleaning that turned into a useful inspection. Mikhail swept the flue then showed me on the camera feed that the liner had a small gap. He documented it in the report so I could decide on repairs next season. Appreciated the honesty.",
          "name": "Theo G.",
          "date": "2024-08-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Scheduling online was simple and the office followed up within an hour to confirm a window. A reminder text landed the day before so I could plan around it. Carlos and the crew arrived with drop cloths, cleaned every supply duct, and pointed out a loose section near the plenum. The clarity of communication is what I'll remember most.",
          "name": "Simone D.",
          "date": "2025-08-11",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Brought a baby home in February and the heating ducts smelled musty whenever the furnace kicked on. Raj inspected the whole system, cleaned each return vent, and showed me a clogged section near the air handler. The musty smell is completely gone now and the nursery feels fresh.",
          "name": "Theodore W.",
          "date": "2024-02-09",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Reliable and tidy. Cleaned the dust off the logs and burner, inspected the gas connection for leaks, and tested the wall switch ignition. In and out in under an hour.",
          "name": "Simone D.",
          "date": "2024-09-27",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Our fireplace had been smoking back into the living room all winter. Devin diagnosed it as a creosote-clogged flue plus a damper that wasn't opening all the way. He cleaned the liner top to bottom, freed the damper, and the very next fire drew perfectly with no smoke spillage. He also laid drop cloths over the whole hearth area and cleaned up so well you'd never know he'd been there. Genuinely impressed with how knowledgeable he was about draft issues.",
          "name": "Naomi B.",
          "date": "2026-02-03",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Booked same day and the price held. Tyler cleaned the vent hood and the full line out to the wall cap. What he quoted is what I paid, plain and simple.",
          "name": "Imani C.",
          "date": "2024-02-14",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "After 20 years and three generations of dogs, the ducts were overdue. Omar brought a camera, showed me the dander and hair coating the inside, and got it all out. The supply registers that used to puff dust are clean now.",
          "name": "Constance H.",
          "date": "2025-01-28",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "After 20 years in our house we finally had the rooftop dryer vent serviced. Nikolai found the duct run was nearly 45 feet with a long attic section that had sagged and trapped lint in a low spot. He supported the sag with a strap, cleaned every foot, and replaced the rusted rooftop cap. He even showed me the moisture stain that the trapped lint had been causing on the ceiling.",
          "name": "Yolanda B.",
          "date": "2025-06-25",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Leaky return duct was pulling attic air into the system. Eli sealed the seams and reattached a section at the plenum that had worked loose. Honest assessment, no pushy add-ons.",
          "name": "Frank H.",
          "date": "2024-08-04",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Solid job cleaning the dryer duct and swapping the corroded exterior vent for a new hood with a pest guard. Victor was on time and wrapped up quicker than expected. No mess left behind.",
          "name": "Roland T.",
          "date": "2023-11-29",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Going on year nine with Master and they're still my first call. This time the supply ducts were full of construction dust from a remodel, and Ramon cleaned them top to bottom, replaced the filter, and snapped before/after photos. The whole house feels less stuffy already.",
          "name": "Noelle C.",
          "date": "2026-05-09",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Took two cycles to dry sheets so I called about a vent cleaning. Luis arrived on time, found the transition hose kinked behind the dryer, and replaced it with rigid duct. He also cleared the lint trap slot and the outside vent. Clear, transparent pricing up front.",
          "name": "Nathaniel W.",
          "date": "2024-09-18",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Crown was crumbling and letting rain into the flue liner. Kevin rebuilt it and waterproofed the stack. Showed me the cracked clay liner tiles in his photos. Fair pricing and he was upfront that the liner should be watched going forward.",
          "name": "Hollis T.",
          "date": "2025-03-22",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Allergy-driven sinus headaches were a weekly thing. The technician cleaned the supply ducts and explained how dust recirculates through the system. Headaches are way less frequent now and the house doesn't smell musty.",
          "name": "Ravi P.",
          "date": "2023-11-29",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Old house, lots of dust, and I braced for a mess. Instead the technician taped plastic over each register, ran the negative-air unit, and brushed the supply ducts with everything contained. Drop cloths under every work area, shoe covers at the door. He swept and wiped the registers, then showed me the bagged debris before carrying it out. Immaculate.",
          "name": "Bertrand O.",
          "date": "2025-04-28",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Three months of construction dust had built up in our ductwork during a master-suite addition. Jordan was meticulous, removing each register, vacuuming the supply ducts, and using a brush on the flexible runs. He showed me a photo of the inside of a return that was caked with fine sawdust, then the same vent spotless afterward. Wore shoe covers the whole time and cleaned up so well you'd never know they were here. Same-day appointment, which I did not expect.",
          "name": "Desmond F.",
          "date": "2026-04-18",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Right on time, no games. Our ducts hadn't been touched in years and the tech got us scheduled same-day after a cancellation. Cleaned every register, bagged the debris, and the place smells fresh. Transparent flat rate too.",
          "name": "Quentin S.",
          "date": "2025-07-02",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Quick same-day appointment, fair price, clean work. Dmitri cleared the lint clog and tested airflow before and after. No more burning smell.",
          "name": "Bartholomew C.",
          "date": "2024-02-21",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Felix figured out our poor draft was due to a chimney that was too short relative to the roofline. Wind was creating a downdraft. He installed a tall cap and the smoke smell vanished. Knowledgeable and professional.",
          "name": "Roland S.",
          "date": "2024-11-28",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Clothes were coming out hot and damp at the same time, weird combo. The tech said it was a classic blocked vent causing the dryer to overheat and shut down on its safety. He cleared the duct, cleaned the lint trap slot, and showed me the pile he pulled out. Problem solved in under an hour.",
          "name": "Marcus V.",
          "date": "2024-05-14",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Outstanding service before the summer rush. Sam arrived right on schedule, protected the floors with drop cloths, and methodically cleaned every supply and return duct in our two-story home. He showed me a handful of dust bunnies the size of softballs that came out of the trunk line. The AC cools faster now and the thermostat isn't running constantly. Worth every penny and the price matched the quote.",
          "name": "Eleanor J.",
          "date": "2024-04-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Damp smell from the vents after we bought the house. Tony inspected and found mildew in the return ducts, cleaned it all out, and sanitized. Quick and professional.",
          "name": "Quentin S.",
          "date": "2025-01-29",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Selling my late father's home and wanted everything above board. The crew inspected the chimney, found old creosote and a deteriorating cap, and gave me a written report I shared with prospective buyers. Upfront and respectful the whole time.",
          "name": "Eugene P.",
          "date": "2024-10-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Our newly bought ranch had a strong dog odor coming through every vent. Pavel arrived right on time, laid down drop cloths, and cleaned the supply and return ducts thoroughly. He also vacuumed out the air handler where a lot of hair had collected. Pleasant guy, explained everything, and the smell is finally fading.",
          "name": "Roberto C.",
          "date": "2025-08-09",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Returns in our older home were so clogged the furnace was working overtime. Marcus cleared them out and the airflow improvement was instant. Honest pricing and a clear written report. Will use again.",
          "name": "Curtis B.",
          "date": "2024-09-12",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Pricing was exactly what they quoted on the phone. Andre cleaned all the supply ducts and the blower compartment, and the airflow improvement was obvious the same evening. HVAC runs shorter cycles now.",
          "name": "Desmond W.",
          "date": "2024-09-21",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Marco was our tech and he was outstanding. He spent extra time on the master bedroom return vent because the airflow was weak, found a clog of drywall dust, and cleared it completely. The bedroom finally cools down at night. Respectful, on time, and explained the transparent pricing upfront so there were zero surprises on the bill.",
          "name": "Jasmine C.",
          "date": "2024-12-11",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Manage a fourplex and one tenant's dryer kept shutting off mid-cycle. Diego traced it to a kinked flex line behind the machine plus heavy lint buildup at the wall penetration. Replaced the transition duct with semi-rigid, cleared the full run, and showed me the camera footage. The unit dries normally now and I have photos for my maintenance records.",
          "name": "Curtis H.",
          "date": "2026-01-22",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "After a damp fall the fireplace was smoking back into the room. The crew diagnosed a creosote-clogged flue and a stuck damper. They cleaned out the buildup, freed the damper, and verified a strong draft with a smoke test before leaving. Hearth was cleaner than when they arrived. Reasonable price for a same-day visit.",
          "name": "Marisol C.",
          "date": "2025-03-07",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "The office made booking effortless. One short call, a clear quote, and a text reminder the day before my dryer vent cleaning. Hector found the vent hood flap stuck open and fixed it while clearing the lint line. Smooth from scheduling to finish.",
          "name": "Rashid A.",
          "date": "2026-03-09",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Scheduling was painless, the office worked around our toddler's nap schedule. Sergei and his partner cleaned every duct, sanitized the registers, and laid drop cloths everywhere. They were respectful and quick.",
          "name": "Naomi P.",
          "date": "2025-07-21",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "We host a lot in winter so getting the gas fireplace inspected each fall is a must. Mikhail checked the venting clearance, cleaned the burner, verified there were no gas leaks, and tested CO output near the hearth. He flagged a slightly loose log support and tightened it. Always professional and explains everything in plain language.",
          "name": "Roberto L.",
          "date": "2025-10-29",
          "service": "Fireplaces Service",
          "rating": 4.1
        },
        {
          "review": "Pre-season cleaning on our masonry fireplace. Carlos swept the flue, scraped the smoke shelf, and recommended a new spark screen since ours had rusted through. No pressure, just an honest heads up. Tidy work.",
          "name": "Wesley A.",
          "date": "2025-10-08",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Appreciated how transparent the whole thing was. They emailed me a quote with the line items spelled out, and when Raj finished cleaning the ducts the total was the same. He found a disconnected supply duct in the crawlspace and reconnected it without charging extra, just folded it into the original price. That kind of honesty is rare.",
          "name": "Roland P.",
          "date": "2025-07-30",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Husky owner here, so you can imagine the fur situation. Devin was upfront about pricing before he started, laid drop cloths through the hallway, and worked register by register. He pulled enough hair from the return ducts to fill a bag. Airflow improved immediately and the place doesn't smell like dog anymore.",
          "name": "Felicia D.",
          "date": "2026-03-12",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Family-owned outfit that clearly knows long duct runs. Our vent exits the roof and the lint had built up at the top elbow. Tyler brushed it from the roof side and vacuumed from the laundry side, then tested airflow. Dry times are way down.",
          "name": "Theo W.",
          "date": "2023-11-28",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Came out the same day I called. A duct in the crawlspace had detached and was lying on the dirt. Omar reconnected it to the boot, sealed the joint, and strapped the run up off the ground so it wouldn't slip again. Reasonable price for solid work.",
          "name": "Tamara V.",
          "date": "2025-04-11",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Mice were getting into the laundry room through the dryer vent opening, and I was at my wit's end. Nikolai sealed the gap, cleaned out the lint that had built up over years, and installed a heavy-duty exterior hood with a stainless pest guard that actually clicks shut. He laid down drop cloths and vacuumed up afterward. Worth every penny for the peace of mind alone.",
          "name": "Sasha V.",
          "date": "2026-04-18",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Years of air-duct visits made the dryer vent cleaning an easy call. Eli pulled a frightening amount of lint from the line behind the laundry room, checked the vent hood flap outside, and tested airflow before packing up. Consistent quality across every service they've done for us.",
          "name": "Ignacio F.",
          "date": "2024-04-15",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Family-owned and it shows in how they treat you. After our dryer started needing a second and third cycle, the technician came out and discovered the vent run was nearly 30 feet with two tight elbows full of lint. He cleaned all of it and recommended a shorter route. Dries fast now and he never once tried to upsell me.",
          "name": "Sofia G.",
          "date": "2025-03-26",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Family-owned outfit that actually cares. Victor found a cracked crown plus a rusted cap that had practically disintegrated. He recast the crown with an overhang, fitted a new stainless cap, and brushed waterproof sealant over the masonry. Twenty years of experience really showed in how methodical he was.",
          "name": "Aubrey L.",
          "date": "2024-02-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Transparent pricing, no upsell pressure, and the dust they removed from the return vents filled two bags. My morning sneezing routine has practically disappeared. Ramon was friendly and careful with shoe covers throughout.",
          "name": "Sasha M.",
          "date": "2026-01-21",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Shoe covers every time they came in and out, no exceptions. Drop cloths protected the new hardwood while they cleaned the return ducts. Spotless finish.",
          "name": "Selena V.",
          "date": "2024-09-06",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Post-remodel cleaning of our entire duct system. Luis explained that the drywall sanding had pushed gypsum dust deep into the supply lines. He used a negative-air machine and brushed every branch. Air feels noticeably fresher and the filter isn't clogging in a week anymore.",
          "name": "Carla N.",
          "date": "2025-06-27",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Hosting Thanksgiving and the dryer died mid-load with a houseful of guests coming. The scheduler heard the panic in my voice and got Kevin out within hours. He pulled an absurd amount of lint from the vent line, cleaned the trap housing, and even checked the thermostat to rule out a heating element issue. Dryer purring again before dinner prep started. This is what same-day service should be.",
          "name": "Rosalind H.",
          "date": "2024-11-22",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "My dryer kept throwing a thermal cutoff error and a repair guy said the vent was probably blocked. He was right. Jordan traced the run through the attic, found a spot where lint had packed solid against an elbow, and cleared the whole thing. He also showed me how the rooftop cap had been collecting buildup for years. Honest, knowledgeable, and explained everything in plain language without trying to sell me extras.",
          "name": "Vivienne D.",
          "date": "2025-08-13",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Quick, clean, effective. Dmitri swept the flue, cleared the creosote, and reseated the damper. Smoke draws right up now. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Tessa W.",
          "date": "2026-03-22",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Quick and thorough. Felix cleared the lint clog that was tripping our dryer's thermal fuse. No more mid-cycle shutdowns and the laundry room is cooler too.",
          "name": "Heather O.",
          "date": "2026-02-09",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Reasonable price, no pressure. The tech cleaned the ducts and noticed our condenser line area needed attention, then pointed me to an HVAC contact. Appreciated the honesty before summer.",
          "name": "Quentin H.",
          "date": "2025-06-19",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Family-owned and it shows in how they treat your home. Sam put down drop cloths, wore shoe covers, and explained the mold sanitizing fog before he started. Our basement no longer smells like a damp cellar. The lingering odor that bothered us for two years is finally gone after one visit.",
          "name": "Lorraine D.",
          "date": "2024-10-04",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Same-day appointment which was a lifesaver since our closing was in a week. Tony inspected the chimney top to bottom, documented the firebox cracks, and emailed the report by evening. Clear, fair, and no pressure to buy repairs from them.",
          "name": "Sofia G.",
          "date": "2025-05-02",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Previous owners smoked for two decades according to the neighbors. You could smell it through every register. The crew did a complete duct cleaning, sanitized the returns, and gave me before/after photos that were genuinely shocking. Worth it.",
          "name": "Melissa H.",
          "date": "2024-02-28",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "For months I assumed our undersized AC just couldn't keep up. Pavel took one look at the return vents and pointed out they were almost completely choked with dust, pet dander, and a forgotten filter. He cleaned both returns and all the supply runs, then showed me the airflow reading climb on his meter. Suddenly every room cools evenly. He covered his shoes, laid drop cloths, and explained the whole process patiently. Money well spent.",
          "name": "Rosalind A.",
          "date": "2025-04-17",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Couldn't figure out why one side of the house was always stuffy. Marcus found the airflow was being choked by years of buildup in the branch ducts. He cleaned everything thoroughly, vacuumed the registers, and the change was immediate. The stuffy rooms are comfortable now and the system isn't laboring the way it was.",
          "name": "Lucia F.",
          "date": "2026-01-07",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Andre handled the duct cleaning and was a pleasure. Laid drop cloths, wore covers, walked the report with me at the end.",
          "name": "Thomas E.",
          "date": "2025-02-04",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Needed dryer vents done before new tenants moved in. Marco arrived on time, laid drop cloths, and cleared a surprising amount of lint from the long horizontal run. Reasonable price for a landlord on a budget.",
          "name": "Nadia P.",
          "date": "2025-05-09",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Annual sweep, done. Diego was in and out cleanly, vacuumed the firebox, and confirmed the cap was secure. No mess, no fuss.",
          "name": "Eamon D.",
          "date": "2024-05-28",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Easy to reach and easy to schedule. The reminder text the night before saved me, I'd completely forgotten. The tech cleaned all our return vents and supply ducts, then emailed the written report. Good communication.",
          "name": "Margot E.",
          "date": "2024-09-23",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "After our second baby arrived, the constant dust on every surface drove me crazy. Hector spent over three hours cleaning supply ducts, return vents, and the blower. He explained how a clean system reduces the dust we breathe and showed me genuinely disgusting before photos. The price was exactly what they quoted over the phone, and he even reattached a loose register cover for free. Such a relief knowing the kids are breathing cleaner air.",
          "name": "Isabella G.",
          "date": "2026-01-15",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Sergei did a great job prepping our gas logs for the season. He vacuumed the firebox, cleaned the glass panel, checked the pilot light color, and adjusted the air shutter so the flame burns clean. Showed me before and after photos of the burner. Very transparent operation.",
          "name": "Eleanor W.",
          "date": "2024-12-15",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Scheduled a fireplace cleaning the week before our first fire of the season. Mikhail arrived right on time, put down drop cloths, and got to work. He cleaned out a thick layer of creosote, vacuumed the firebox down to bare brick, and inspected the refractory panels for cracks. Everything checked out. He even wiped down the glass doors and showed me the before and after photos on his tablet. The price matched the quote exactly. Couldn't ask for better.",
          "name": "Constance J.",
          "date": "2024-12-04",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Straightforward and fair. The quote included clearing the lint trap and the long vent run that goes through the attic. Carlos was in and out in under an hour and the price never budged. No attempt to sell me anything extra.",
          "name": "Yvette D.",
          "date": "2026-05-08",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Booked because our two shedding labs had us replacing filters monthly. Raj cleaned the trunk lines and every branch, vacuumed the return grilles, and explained how the dander was recirculating. Filters last way longer now.",
          "name": "Spencer O.",
          "date": "2024-12-14",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "My new place has the dryer in a center closet, so the duct has to run a long way before reaching the rooftop vent. Devin arrived on time, laid down a drop cloth, and snaked his rotary tool the full distance. He pulled out a startling amount of lint near the second bend where it had been packing in. Took before and after photos and explained that the long run means I should schedule yearly. Genuinely helpful and not pushy at all.",
          "name": "Marisol G.",
          "date": "2025-08-07",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Outstanding. Our two-story had a hot upstairs and freezing downstairs. Tyler found three leaky joints and one fully detached supply run feeding the bonus room. He sealed each gap with mastic, reconnected the run, and balanced the airflow. The written report he left documented every fix with photos. Comfort throughout the house is dramatically better and the system isn't running constantly anymore.",
          "name": "Desmond L.",
          "date": "2026-02-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Family-owned outfit that clearly cares about the work. Omar cleaned a long, twisty dryer run that two other companies wouldn't touch, then fitted a new vent hood with a built-in pest guard on the exterior brick. Patient with all my questions and the price matched the quote exactly.",
          "name": "Marcus H.",
          "date": "2025-02-07",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Loyal for years and never disappointed. Nikolai cleaned the return vents, sealed a small gap in the trunk line, and left the place spotless. Transparent pricing as always.",
          "name": "Octavia L.",
          "date": "2025-02-27",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Clothes stayed damp after one cycle for months. Eli cleaned the whole vent and the hood. Simple, fast, and the lint pile was shocking.",
          "name": "Ravi C.",
          "date": "2024-02-14",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Persistent musty smell and damp brick near the fireplace. Victor diagnosed water intrusion through a cracked crown. He sealed the crown, replaced the rusty cap, and waterproofed the chimney exterior. The musty smell vanished within a week. Couldn't be happier with how professional the whole crew was.",
          "name": "Quentin S.",
          "date": "2025-10-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Family-owned and it shows in how they treat your home. Ramon and his partner laid down drop cloths, cleaned every supply and return duct, and double-checked the system afterward. My daughter's pollen allergies have calmed dramatically and the visible dust on surfaces has dropped off.",
          "name": "Wendell A.",
          "date": "2024-09-08",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Appreciated how respectful Luis was of the house. He laid down a runner from the entry to the basement, covered the workbench area with plastic, and contained all the dust from the supply ducts in a sealed system. Afterward he vacuumed around each vent and even wiped down the thermostat he'd brushed against. Left it cleaner than he found it.",
          "name": "Owen T.",
          "date": "2023-12-15",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Following a big garage-to-office conversion, sawdust had infiltrated the return ducts. Kevin arrived on time, put down drop cloths, and ran a thorough cleaning of all vents. Transparent pricing, no upsell. He showed me the debris bag at the end.",
          "name": "Hiro K.",
          "date": "2024-09-05",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Construction dust from a remodel had loaded our ducts and the contractor's crew never cleaned them. One morning call and Jordan arrived that afternoon, exactly when promised. He scrubbed the supply ducts, cleaned the returns, and laid drop cloths so nothing tracked onto the new floors. Sneezing stopped within a day.",
          "name": "Bennett A.",
          "date": "2025-02-08",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Pulled out a clump of lint from behind the machine that made my stomach drop. Dmitri came the next morning, ran the brush the full length to the side wall vent, and showed me the bag of debris. Reassuring to finally have it done right.",
          "name": "Theodore W.",
          "date": "2024-12-30",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "We'd been smelling smoke even with the fireplace cold, which freaked me out. Felix came out same day and traced it to creosote odor trapped in a flue with no cap, allowing rain to react with the buildup. He capped it with stainless and did a full sweep. The smell is finally gone and I feel safe lighting fires again. Genuinely appreciated his patience explaining everything.",
          "name": "Marguerite B.",
          "date": "2025-02-14",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Our second-floor dryer would get blazing hot and quit. Sam mapped the vent route, found a sagging section that had collected years of lint, secured it, and cleared the blockage. He measured airflow at the exterior hood when finished. Polite, efficient, and explained everything in plain terms.",
          "name": "Darnell S.",
          "date": "2025-10-27",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Right before summer I had the whole duct system cleaned and sanitized. Tony and his partner were efficient, courteous, and left the house cleaner than they found it. They bagged all the debris from the return vents and showed me before and after shots. Cool air finally reaches the bonus room above the garage.",
          "name": "Sofia G.",
          "date": "2026-05-15",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Persistent musty odor turned out to be dust caked in the supply ducts combined with some moisture. Pavel cleaned everything thoroughly and applied a sanitizing treatment. He showed me camera footage before and after. Impressed by how detailed the work was and how clean they left the place.",
          "name": "Fernando A.",
          "date": "2025-07-22",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Impressed by how methodical the inspection was. Camera went down the flue, every section photographed, and the written report graded each component. The crown needed work but the liner was solid. Made our home sale negotiation easy.",
          "name": "Harold D.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Honestly didn't expect such a difference. We moved into a house where the sellers had a houseful of pets, and the dander coating in the ductwork was the source of a constant musty pet smell. Marcus scoped the system first, then cleaned every supply and return vent, the trunk lines, and the blower. He wore shoe covers, protected the floors, and walked me through a written report at the end. Transparent on cost from the first phone call. The air smells fresh and clean now, even my husband who doubted it admits the difference.",
          "name": "Vanessa L.",
          "date": "2026-03-30",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Restricted airflow on the second floor. Tech found a packed return vent, cleaned it and the ducts, photos before and after. Solid same-day work.",
          "name": "Jamal C.",
          "date": "2023-05-03",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Certified, insured, and clearly experienced. The technician explained how the dust in the ductwork forces the blower to work harder and drives up energy use. After the cleaning the airflow at every register is stronger and our cooling bill dropped noticeably.",
          "name": "Hassan I.",
          "date": "2025-06-18",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Andre did a meticulous job on our supply ducts and returns. What stood out was how he took the time to show me a section of the trunk line that had heavy buildup and explained why our allergies had been flaring up. After cleaning he sanitized everything. Genuinely kind, never made a mess, and the air in the house feels noticeably fresher.",
          "name": "Beatrice H.",
          "date": "2024-08-30",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "This family-owned outfit has been my go-to for rental maintenance for two years now. Latest visit was a dryer-vent cleaning at a townhouse rental where the run goes straight up through three floors. Marco brushed it from both ends, checked the booster fan, and confirmed proper airflow at the roof cap. Detailed written report every time, which makes my bookkeeping easy.",
          "name": "Greg A.",
          "date": "2025-08-14",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Excellent yearly chimney service. Diego brought a camera into the flue and walked me through every foot of it on his tablet. He pointed out a light creosote layer and a bit of rust forming on the damper plate, then swept everything thoroughly. The written report had timestamps and photos. You can tell this is a company that's been doing it for two decades. Will absolutely book again next fall.",
          "name": "Cassandra W.",
          "date": "2026-03-12",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Cannot say enough about how organized the scheduling was. I booked through the website, got an immediate email confirmation, a reminder text 24 hours out, and a call when Hector was fifteen minutes away. He cleaned the dryer vent, snaked the full duct run to the exterior wall, and showed me the lint he pulled out. The office stayed in touch the entire time without ever being pushy.",
          "name": "Tobias N.",
          "date": "2025-05-19",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Pregnant with twins and wanted everything clean before nesting season hit hard. Sergei was friendly, professional, and meticulous. He showed me the camera footage inside the ducts before and after. Worth it.",
          "name": "Chloe S.",
          "date": "2025-10-04",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Same-day visit when our gas fireplace started making a faint hissing sound. Mikhail traced it to a connection at the control valve, snugged it up, and confirmed zero leaks with his sniffer. Relieved it was minor and handled fast.",
          "name": "Marcus the customer H.",
          "date": "2025-11-18",
          "service": "Fireplaces Service",
          "rating": 4.1
        },
        {
          "review": "Got the insert cleaned and inspected ahead of fall. Carlos vacuumed the firebox, cleaned the blower, and checked the door gasket seal. Runs quieter and heats better now.",
          "name": "Ravi S.",
          "date": "2025-09-21",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Family-owned and it shows in how they treat you. Got a clear quote, Raj cleaned all the supply ducts and returns, put drop cloths down, and the bill was exactly what I was told. He pointed out some mold near one vent but recommended I monitor it rather than upselling a remediation service.",
          "name": "Cody S.",
          "date": "2023-11-19",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Pet hair clogged ducts, simple fix. Devin handled it fast and the registers look brand new. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Adaeze U.",
          "date": "2025-05-09",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Long ceiling run to a rooftop cap. The technician confirmed with a camera, cleaned it, and reattached a loose joint with foil tape rather than the old plastic tape that was there.",
          "name": "Harlan F.",
          "date": "2024-12-15",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "A duct had detached behind the furnace and we never knew. Tyler sealed the leaks, reconnected the run, and pointed out a crushed section we should watch. Friendly, clean, and on time.",
          "name": "Holly N.",
          "date": "2024-12-19",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Pleasant technician cleaned our dryer vent and replaced the worn exterior flap with a new metal hood that has a pest screen. Pointed out lint had collected behind the drum housing too. Cycle times dropped noticeably. Good value.",
          "name": "Delphine O.",
          "date": "2024-06-14",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "This family-owned outfit has done our air ducts, dryer vent, and chimney over the past six years. Omar handled the duct cleaning this time, wore shoe covers, and showed me the before/after photos on his tablet. He noticed the thermostat wiring was a little loose near the return and pointed it out so I could have someone look at it. Always thorough.",
          "name": "Reginald H.",
          "date": "2024-12-12",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Our laundry was taking two cycles minimum and I was worried about a fire. Nikolai inspected the line with a camera, found a major clog about halfway through the run, and cleaned it out completely. He also reattached the exterior vent cap that had come loose. Professional, tidy with the drop cloths, and explained everything as he went.",
          "name": "Heather J.",
          "date": "2025-12-09",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Got the crown patched and a new cap installed before winter. Eli explained why the old galvanized cap rusted so fast. Stainless one should last much longer. Quick and reasonably priced.",
          "name": "Delphine A.",
          "date": "2023-05-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Sneezing the second I walked in the door every day. After the cleaning, that stopped. The tech showed me how much pollen had collected in the return vents over the spring. Such a relief to breathe normally at home again.",
          "name": "Imani G.",
          "date": "2025-08-03",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "A family business that clearly cares about your home. Two techs, both in shoe covers, drop cloths rolled out along the entire path to the air handler. The amount of debris pulled from the return vents was shocking yet our floors stayed pristine because it all went into a sealed bag. Final wipe-down of every register cover and a quick sweep of the rooms. Could not have asked for tidier service.",
          "name": "Marguerite L.",
          "date": "2026-01-19",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "We just finished a kitchen-and-dining remodel and the whole HVAC system needed a flush. Victor and Victor were a great team. They sealed off rooms we weren't working in, pulled all the registers, and used a rotary brush plus high-powered vacuum on the trunk lines. The construction dust they extracted filled most of a contractor bag. Detailed report with before-and-after photos was emailed to me that evening. Couldn't ask for more from a crew.",
          "name": "Stephanie A.",
          "date": "2026-02-21",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Dryer running hot and clothes still damp. Ramon came out same day, on the dot, and found the vent packed near the wall cap. Cleared it, tested airflow, done in 45 minutes. Efficient and friendly.",
          "name": "Imani G.",
          "date": "2025-08-15",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Booked because my sister had a close call with her dryer overheating. Luis inspected the lint trap, the transition hose, and the full duct run, then cleaned all of it. Pointed out that my vent length was right at the manufacturer's max, so he recommended a more frequent cleaning schedule. No pressure, just good advice and clean work.",
          "name": "Isadora F.",
          "date": "2025-12-07",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Draft was so weak the fire would smolder and smoke up the room. Kevin checked the flue and found heavy soot plus a closed-off air supply. After cleaning and adjusting things, it drafts perfectly. Honest, fair, no upselling.",
          "name": "Curtis N.",
          "date": "2024-04-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Booked them after the dryer kept overheating and shutting off three or four times per load. Jordan arrived same day, pulled the machine out, and discovered the vent was almost fully obstructed where it ran under the floor joists. He cleaned the entire line, vacuumed up the mess, and even reattached the clamp that had come loose. The dryer now finishes in a single cycle and stays cool. Transparent flat rate, no surprises.",
          "name": "Bianca H.",
          "date": "2024-12-15",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Great prep for the cooling season. Dmitri cleaned the registers and trunk lines and pointed out a gap in the duct insulation that was wasting cold air. Fixed it the same visit.",
          "name": "Brendan T.",
          "date": "2024-05-06",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Scheduling was easy and the office called to confirm. Felix arrived, scoped the ducts, and addressed the mildew smell with a deep clean and antimicrobial fog. Three rooms that always smelled stale are fresh now.",
          "name": "Meredith J.",
          "date": "2026-05-09",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Before buying our colonial we had the chimney inspected and it was the best decision in the whole process. Sam found that a previous owner had installed the wrong size flue liner. He documented it thoroughly, included measurements in the report, and we used that to require the sellers to fix it before closing. Knowledgeable and patient with all my questions.",
          "name": "Camille V.",
          "date": "2025-10-26",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Smoke smell from the prior owner was driving us crazy. Tony cleaned all the ducts and returns and the difference was immediate. Friendly, fast, and fair pricing.",
          "name": "Patrick S.",
          "date": "2025-01-19",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "We'd lived with weak airflow so long we thought it was normal. Pavel arrived on time, pulled the return grilles, and the amount of compacted dust restricting them was alarming. He cleaned the returns and every supply duct, sanitized, and provided a detailed written report. The change in how the air moves through the house is dramatic. Twenty-plus years in business clearly shows in how thorough and professional they are.",
          "name": "Heather D.",
          "date": "2025-12-11",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Family-owned outfit that treated my home with respect. Drop cloths down, shoe covers on, and a thorough scrub of the return and supply ducts. The furnace heats more evenly now and the airflow is much stronger.",
          "name": "Margaret S.",
          "date": "2023-05-02",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Marcus arrived early and got straight to work on the ductwork. Clean, courteous, and explained how the rotary brush dislodges debris from the supply lines. Showed me the full bag at the end. Top notch service.",
          "name": "Cody W.",
          "date": "2025-10-21",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Vent at my rental was venting into the crawlspace instead of outside, a previous handyman's mistake. Andre rerouted it to a proper exterior vent hood and cleared the existing duct. Huge moisture problem solved.",
          "name": "Bianca F.",
          "date": "2024-12-29",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Needed creosote removed before our holiday fires. Marco knocked out a stubborn glazed section near the top and bagged the debris neatly. Quick turnaround and a fair flat rate.",
          "name": "Bertram L.",
          "date": "2025-12-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Reminders are a small thing but they make a big difference. Got one the evening before and a follow up the morning of. The crew cleaned the supply ducts and replaced a torn return vent screen. Pleasant office staff.",
          "name": "Celeste V.",
          "date": "2023-06-14",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "We have a one-year-old with recurring ear infections and read that indoor air matters. Diego cleaned all the ducts, replaced a torn section of flex duct in the attic, and pointed out where the return vent was leaking unconditioned air. Detailed written report, fair price, no nonsense. The house feels noticeably less stuffy and we're hopeful it helps the little guy.",
          "name": "Jamal H.",
          "date": "2024-09-27",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Knowledgeable crew that clearly knows gas appliances. They inspected the flue liner for the gas logs, cleaned the burner ports, checked the thermopile millivolt reading, and replaced a corroded pilot hood. Walked me through the whole safety checklist before leaving. Pricing was exactly what the office quoted, no surprises.",
          "name": "Felicia O.",
          "date": "2025-03-08",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Late-season cleaning but worth it. Hector swept the flue, removed creosote, and found that our crown had a hairline crack letting moisture in. He documented it with photos in the written report and gave me options without pushing. Professional and clean.",
          "name": "Marisol V.",
          "date": "2026-03-11",
          "service": "Fireplaces Service",
          "rating": 4.1
        },
        {
          "review": "Quoted price was the final price. Sergei cleared the vent, checked the flap outside, and showed me before and after photos. No surprises on the invoice at all.",
          "name": "Tanya G.",
          "date": "2025-02-26",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Years of cat dander had really built up and we could see lint-like fuzz on the supply vent covers. Mikhail removed and cleaned each register, ran the brush through the lines, and finished with a sanitizing fog. He showed before and after photos that made the cost easy to justify. Highly recommend for any pet household.",
          "name": "Lorenzo S.",
          "date": "2025-08-21",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Our dryer duct climbs from the first floor laundry up through two floors and out the roof. Carlos explained the whole process before starting and quoted a flat price. He worked from both ends, cleared a serious clog right where the vertical run meets the rooftop elbow, and finished by installing a new stainless cap to keep critters out. Professional and respectful of the house.",
          "name": "Delphine A.",
          "date": "2026-03-22",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Sealed up a whole network of leaky supply ducts in our attic. Raj used mastic on every joint, reattached two runs that had separated at the collars, and added new strapping. He laid drop cloths in the hallway and wore shoe covers the entire visit. The difference in airflow at the far bedrooms is remarkable and our spring allergies have eased up.",
          "name": "Bernard A.",
          "date": "2025-07-08",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Devin arrived right in the window the office promised. He ran a brush and vacuum through the entire duct, then showed me the bag of lint he'd pulled, which was alarming. The exterior vent hood was a flimsy plastic one with no guard, so he installed a stainless replacement with a pest screen to keep the chipmunks out. Professional, clean, and he double-checked the airflow before leaving.",
          "name": "Ignacio R.",
          "date": "2025-08-21",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Master has cleaned our ducts every other year since 2019. Tyler came out, laid drop cloths through the den, and cleared a heavy buildup in the main supply trunk. He also re-secured a damper that had drifted closed. Same dependable crew every visit.",
          "name": "Geneva O.",
          "date": "2025-11-21",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Multiple cycles to dry a basic load of t-shirts finally pushed me to call. Omar measured the airflow, cleaned the full vent line, and swapped the crushed plastic transition for metal. He left the laundry room cleaner than he found it. One cycle does the job now and the dryer doesn't get nearly as hot.",
          "name": "Quentin L.",
          "date": "2026-02-03",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Water had been seeping in and I worried the whole chimney was failing. Nikolai reassured me it was just the crown and cap. He recast the crown, swapped the rusted cap for stainless, and applied a breathable waterproof sealer. Wore shoe covers inside and cleaned up completely. The written report with photos gave me real peace of mind.",
          "name": "Bryce H.",
          "date": "2026-04-15",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "My asthma had been acting up for months. Eli cleaned the full duct system and swapped the filter for a higher-MERV one. The wheezing eased within a week and the dust on my nightstand isn't piling up like before.",
          "name": "Curtis D.",
          "date": "2023-04-11",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Clean, careful, and quick. Victor put drop cloths under each supply vent, used the HEPA vacuum on the grilles, and bagged everything from the trunk line. Floors spotless after.",
          "name": "Felipe G.",
          "date": "2025-07-23",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Drywall and joint-compound dust from our basement finish was clogging the system. Ramon cleaned the supply and return ducts and changed the filter. Solid work, fair flat rate, easy scheduling with the office.",
          "name": "Ivan G.",
          "date": "2023-05-30",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "We had a baby due any day and wanted clean air before bringing her home. Despite the short notice, the office fit us in that same afternoon. Luis arrived punctually, cleaned all supply and return vents, sanitized the system, and provided a written report. Wore shoe covers and was respectful of the nursery. Could not have asked for better timing or care.",
          "name": "Sloane V.",
          "date": "2024-06-13",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Clothes coming out damp and the top of the dryer hot to the touch was the warning sign. Kevin cleared a vent absolutely choked with lint and even cleaned out the blower housing. Airflow at the exterior cap is strong now. Same-day, fair, done.",
          "name": "Maxwell J.",
          "date": "2023-07-25",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "The smoke smell in our upstairs hallway turned out to be coming down the flue. Jordan explained how stack effect was pulling chimney air into the house. He cleaned the creosote and recommended a top-sealing damper. Problem solved and he was great about wearing shoe covers.",
          "name": "Heather J.",
          "date": "2025-12-07",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Heat shutoff kept killing the cycle. Dmitri cleared the packed vent and the dryer runs normal again. Fast visit, fair price.",
          "name": "Trevor N.",
          "date": "2025-03-21",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "We just bought an older house and had no idea when the ducts were last serviced. Felix ran a camera through and found years of dust and pet hair from the previous owners. He cleaned every line, sanitized the system, and replaced two crushed flex ducts that were choking the airflow. Now the AC keeps the whole place comfortable instead of just the front rooms. Transparent pricing the entire way.",
          "name": "Marisol C.",
          "date": "2025-04-28",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "We have asthma in the house so the musty smell really worried us about mold. The technician was incredibly thorough, vacuuming each supply and return vent and then sanitizing the entire system with a fog treatment. He gave us a written report and recommended a filter upgrade. Breathing is genuinely easier and the odor is gone. Grateful we called.",
          "name": "Isaiah C.",
          "date": "2024-12-15",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Solid work. Pre-listing chimney inspection, written report in hand within 48 hours, and the technician was courteous and wore shoe covers. The flashing around the chimney base got flagged for resealing.",
          "name": "Wesley J.",
          "date": "2024-06-05",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Bought a townhouse and the previous tenant had a dog that clearly shed everywhere. The pet smell came roaring back every time the heat turned on. Sam came out the same day I called, inspected the supply ducts with a camera, and showed me the dander and hair buildup. He cleaned the entire system, sealed a leaky return, and the air is noticeably cleaner. The written report was a nice touch for our records.",
          "name": "Danielle G.",
          "date": "2025-10-26",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Living room never cooled right. Tony traced it to a clogged return that was starving the system. Cleared it, cleaned the supplies, balanced the flow. Upfront quote, clean work, big improvement.",
          "name": "Owen R.",
          "date": "2024-04-22",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Pavel arrived right in the window the office gave me and got straight to work. He cleaned the main trunk, all the branches, and the return drop, then showed me how much stronger the airflow registered afterward. The thermostat stops the cycle quicker now because the rooms actually reach temperature. I expect to see it on the next bill, but the comfort difference alone was worth it.",
          "name": "Elliot V.",
          "date": "2025-10-12",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Marcus was the technician sent out and honestly he set the bar. He inspected every return vent, photographed the buildup, and cleaned the system without leaving a single mark on our floors. Polite to my kids, patient with my questions, and finished right when he said he would. The written report was detailed and easy to understand.",
          "name": "Adaeze N.",
          "date": "2024-06-05",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Straightforward dryer-vent cleaning on a rental I just acquired. The tech vacuumed the lint trap area, cleared the run, and tested the exterior flap. In and out in under an hour with a written report.",
          "name": "Martin Z.",
          "date": "2023-10-12",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Scheduling was painless and the scheduler confirmed the appointment by text. On the day, Andre swept the flue, cleared a moderate creosote buildup, and inspected the crown and stainless cap. He laid drop cloths everywhere and wore shoe covers without being asked. The before and after photos made it easy to see the work was real. Honest, tidy, and a fair price for a thorough annual sweep.",
          "name": "Delphine O.",
          "date": "2024-11-05",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Booking was painless and the scheduler explained the flat rate clearly so I knew exactly what I'd pay. Text reminders came the day before and the morning of. Marco arrived in the promised window, put on shoe covers, and cleaned every return vent and supply duct in our two story house. He left a tidy written report. Office communication was top notch the whole way.",
          "name": "Darnell J.",
          "date": "2025-11-02",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Quick, clean, and considerate. Diego cleaned every supply duct and return vent while our newborn slept, didn't make a peep, and wore shoe covers the whole time. Fair pricing and a tidy job.",
          "name": "Renata C.",
          "date": "2025-12-11",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Straightforward and honest. Hector tested the igniter, cleaned the logs, and confirmed the damper was locked open as required for a gas unit. Quick safety check done right.",
          "name": "Patrick G.",
          "date": "2024-08-21",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Wanted peace of mind before lighting fires again. The crew inspected the firebox and flue, cleaned out a nest some critter had built near the damper, and installed a new stainless cap with a screen so it won't happen again. Fairly priced.",
          "name": "Tobias E.",
          "date": "2024-10-29",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Every duct in a four-bedroom house cleaned for the flat rate they quoted on the phone. I kept waiting for the catch but there wasn't one. Sergei was professional, wore shoe covers, vacuumed out the returns and all the supply vents, and even reset my thermostat after he was done. Handed me a written report and the total matched the estimate. No upsell whatsoever.",
          "name": "Harold V.",
          "date": "2024-08-05",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Our two cats and an elderly retriever meant nonstop dander in the air. Mikhail arrived same-day, covered the floors, and worked methodically through every duct run. He pointed out where hair had collected at the elbows and made sure those were fully cleared. The written report he left included photos of each vent before and after. Genuinely impressed with the care, and the house smells noticeably fresher.",
          "name": "Priscilla J.",
          "date": "2026-01-15",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Rooftop dryer vent that hadn't been touched since the house was built. Carlos pulled an alarming clump of lint from the roof termination and another wad halfway down the long run. Airflow at the exterior hood went from barely a flutter to a strong stream. Fair price, friendly guy.",
          "name": "Quentin M.",
          "date": "2025-02-08",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Detached duct run over the garage was the culprit behind a room that never cooled. Raj reconnected it, sealed the seam, and checked the rest of the supply lines. Quick, honest, fairly priced.",
          "name": "Sasha G.",
          "date": "2024-05-27",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Couldn't be happier. Devin cleaned the dryer vent thoroughly and explained that the original builder-grade exterior hood was undersized and trapping lint. He upgraded us to a wider vent hood with a pest guard. Sent a written report with before-and-after photos to my email same day.",
          "name": "Whitney G.",
          "date": "2026-02-25",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We started with duct cleaning years ago and have stuck with them for everything since. Tyler inspected the chimney, cleaned out the creosote, and checked the crown and flashing for cracks. Detailed written report with photos of the flue. Honest pricing, no scare tactics.",
          "name": "Thaddeus J.",
          "date": "2023-10-05",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Scheduled a vent cleaning because nothing dried in a single cycle anymore. Omar was punctual, friendly, and clearly experienced. He pulled the dryer out, cleared the lint trap housing and the entire duct run, and showed me how clogged the exterior hood had been. Dramatic improvement, dries first try now.",
          "name": "Imani O.",
          "date": "2024-06-28",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Snow melt was getting into the chimney and into the attic. Nikolai resealed the flashing, repaired a crack in the crown, and capped the flues with stainless. No more wet spots in the attic this spring. Very communicative throughout the job.",
          "name": "Marlene V.",
          "date": "2024-12-28",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "After years of waking up congested, I finally booked a duct cleaning and I only wish I'd done it sooner. The crew was punctual, used drop cloths, and Eli walked me through the before/after photos of each return vent. Dust everywhere had been feeding my allergies. Now I sleep through the night without a stuffy nose and my eyes aren't red in the mornings.",
          "name": "Federica V.",
          "date": "2026-05-10",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "From the moment Victor stepped inside he had shoe covers on and was unrolling drop cloths. He sealed the duct openings he wasn't working in so dust stayed put, and the negative-air machine handled the rest. When he reinstalled the return covers he wiped each one and the surrounding wall. Swept the basement, coiled his hoses neatly, and left no dust behind. Truly spotless work.",
          "name": "Helena R.",
          "date": "2024-05-30",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "After a four-month whole-house renovation, our ducts were a disaster of sawdust and drywall powder. Ramon did a complete cleaning, opening access panels on the main trunk and brushing out every branch line. He found that the framers had let debris fall into a return chase, which he cleared out by hand. Wore shoe covers, used drop cloths, and walked me through the before-and-after photos. The air in here finally feels like home again. Pricing matched the quote exactly.",
          "name": "Renata C.",
          "date": "2025-08-12",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Vent hood outside was barely puffing air and the dryer smelled scorched. Luis was dispatched same day and arrived early. He disconnected the duct, vacuumed a heavy lint clog, and reconnected everything with a proper clamp. Quick diagnosis, honest price.",
          "name": "Felipe O.",
          "date": "2026-03-04",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Honestly nervous about how much lint had collected over the years, especially with a long basement-to-roof run. Kevin showed up with the right equipment, broke up the compacted lint with a rotary brush, and vacuumed it as he worked so nothing spread into the room. He checked the lint screen seating and confirmed the exterior flap was opening freely. Gave me a written report noting the duct material and length. Couldn't ask for more.",
          "name": "Ophelia G.",
          "date": "2026-03-15",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Jordan pinpointed our poor draft to a damaged smoke shelf packed with old debris. Cleared it, swept the flue, gave us before and after photos. Fire lights clean now with zero smoke spillage. Very impressed.",
          "name": "Damian F.",
          "date": "2024-07-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Really impressed with the diagnosis. My dryer was getting dangerously hot and the technician explained the airflow restriction was forcing the element to short-cycle. He cleared the vent, cleaned out the lint trap cavity with a long brush, and pointed out that the exterior flap wasn't opening. Replaced that too. Detailed written report at the end.",
          "name": "Adaeze C.",
          "date": "2025-07-08",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Fast and tidy. Had the supply ducts cleaned out before the heat arrived and the difference in airflow at the vents is obvious.",
          "name": "Derek W.",
          "date": "2026-04-03",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Earthy, basement-y smell every time the furnace ran. Dmitri found buildup in the trunk line and a damp spot near the return. Cleaned and sanitized in about three hours. Smell gone.",
          "name": "Tabitha L.",
          "date": "2025-03-06",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "I run a small real estate practice and now I refer clients here for pre-sale chimney inspections. They consistently deliver clear written reports with photos of the flue, crown, and cap. Felix handled my last referral and the homeowner couldn't stop praising how clean and professional he was. Dependable every single time.",
          "name": "Renata S.",
          "date": "2026-03-14",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Our new home reeked of cigarettes near every vent. Sam did a full ductwork cleaning, used drop cloths, and the stale smell is nearly gone after just a couple days. Honest, professional crew.",
          "name": "Joseph N.",
          "date": "2024-09-03",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "The return vent behind our couch had quietly clogged over years and the system airflow had dropped way off. Tony moved the furniture carefully, cleaned the return and all supply ducts, and left everything exactly as he found it. He showed me the debris and the before/after photos. House feels cooler and less dusty already. Reasonable, transparent price.",
          "name": "Yusuf A.",
          "date": "2026-03-05",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Heating bill kept climbing every winter. Pavel cleaned out the ductwork and a heavily clogged return filter housing, and the airflow improved enough that the furnace stopped running nonstop. December bill was the lowest in three years.",
          "name": "Dahlia C.",
          "date": "2024-12-19",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Marcus cleaned our air ducts and the difference is huge. Less dust on the furniture already. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Marcus B.",
          "date": "2025-04-12",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Coordinating maintenance across six units is a headache, but the scheduler made it easy by grouping three appointments in one morning. Andre and the crew cleared every dryer vent, replaced two crushed transition ducts, and flagged one exterior cap that needed a new louver. Each tenant got a heads-up call. Itemized invoices per unit made expensing simple. Genuinely the easiest vendor I deal with.",
          "name": "Lorraine C.",
          "date": "2026-02-18",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Solid creosote cleaning. The technician used a rotary brush, vacuumed the firebox, and showed me the soot he collected. Damper opens easily now and the smell is gone.",
          "name": "Quentin F.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "The scheduler answered all my questions about the dryer vent process and gave me a firm two hour window. A reminder text arrived the night before. Marco cleared the lint trap duct and checked the vent hood outside, confirming airflow was back to normal. Easy, clear, no nonsense.",
          "name": "Imani F.",
          "date": "2024-12-28",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "First baby on the way and we wanted the air clean before her arrival. Diego arrived same day, laid down drop cloths, and used a powerful vacuum on every duct. He showed me how much debris had collected near the return and explained the negative-air process clearly. The written report listed each vent serviced. Couldn't be happier with the attention to detail.",
          "name": "Elena K.",
          "date": "2026-03-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our older gas-log fireplace hadn't been serviced in years. Hector gave it a complete going-over, checking the burner for blockage, testing the gas pressure, inspecting the ceramic logs for cracks, and cleaning soot off the glass. He found the oxygen depletion sensor was the original and recommended replacing it for safety, which he did same visit. Thorough and patient explaining why each step mattered.",
          "name": "Helena V.",
          "date": "2025-12-22",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Booked ahead of the holidays and so glad I did. Sergei was meticulous, sweeping the flue liner, scraping the smoke chamber, and vacuuming every bit of ash from the firebox. He laid down a drop cloth and wore shoe covers throughout. Walked me through the written inspection report and pointed out everything looked structurally sound. The fireplace burned clean and bright that evening. Truly a pleasant, professional visit from start to finish.",
          "name": "Lacey N.",
          "date": "2025-11-18",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Honest from start to finish. The price they gave me included the full vent cleaning and a quick airflow test. Mikhail found the issue was just a clogged lint trap, cleared it fast, and charged exactly what was quoted instead of inventing a bigger repair.",
          "name": "Renata L.",
          "date": "2026-02-12",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Adopted a third dog and the allergies in the house spiked. Carlos cleaned the return plenum where dander had collected and wiped down every register. Clear pricing, no upsell.",
          "name": "Camden W.",
          "date": "2024-06-02",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Could not be happier. The vent in our condo runs nearly 50 feet horizontally before turning up to the roof, and the dryer had started shutting off mid-cycle from overheating. Raj brought the right brush length for that run, cleaned it thoroughly, and showed me the lint by the bucketful. He also cleaned the lint trap housing and recommended we avoid dryer sheets on such a long run. The dryer hasn't tripped once since.",
          "name": "Naomi T.",
          "date": "2024-06-11",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Really impressed with this crew. A return duct had pulled off at the air handler and the system was sucking in dusty attic air. Devin sealed the connection, reattached the run, and mastic-sealed several leaky joints along the trunk. He explained why the dust kept coming back and gave me a written report. Same-day appointment and transparent pricing made it painless.",
          "name": "Imogen P.",
          "date": "2026-04-29",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Got the dryer vent cleaned and a new exterior hood with a pest guard installed. Tyler was matter-of-fact and efficient, in and out in under an hour. The old louvers were jammed with lint and a bird's nest. Runs great now.",
          "name": "Basil C.",
          "date": "2023-03-16",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Been a customer for ages and the office staff actually remember us. Omar cleaned all the return vents and supply lines, swapped the filter, and noted one register cover needed replacing. Quick and tidy.",
          "name": "Sylvia E.",
          "date": "2026-02-08",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Dryer running twice per load. Nikolai cleaned the vent thoroughly and checked the connection at the wall. Quick same-day appointment.",
          "name": "Gunnar H.",
          "date": "2023-11-07",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "The cap on our chimney had rusted so badly it was clogging the flue with flakes. Eli pulled it, installed a stainless steel cap with a spark arrestor screen, and noticed the crown was cracked so he sealed that too. Then waterproofed the brick. Same-day turnaround and a fair, transparent quote.",
          "name": "Foster J.",
          "date": "2025-06-03",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Same-day service when my allergies were at their worst. Victor cleaned the supply ducts and the main return, bagged all the dust, and showed me the report. Breathing easier already.",
          "name": "Hank R.",
          "date": "2024-12-17",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Protective gear for the floors everywhere, shoe covers on every entry. They contained the dust from the supply ducts and vacuumed the registers before reinstalling them. Clean job.",
          "name": "Chandler N.",
          "date": "2026-04-10",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Construction dust everywhere after our remodel. Ramon cleaned all the supply ducts and return vents, showed me the gritty filter he replaced, and left the place spotless. Same-day service was a lifesaver.",
          "name": "Aaron J.",
          "date": "2024-12-19",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Snowstorm knocked our schedule sideways and our furnace was circulating stale, dusty air. The crew still made the same-day window they promised. Luis cleaned the entire duct system, showed before-and-after photos of the main trunk, and was careful with drop cloths on our stairs. Punctual even in bad weather, which I respect.",
          "name": "Delphine R.",
          "date": "2024-12-19",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Fast, friendly, and reasonably priced. Kevin cleaned the vent, swapped my plastic transition hose for metal, and tested the airflow. Lint buildup behind the unit was no joke.",
          "name": "Cornelius H.",
          "date": "2024-04-10",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Smelled smoke constantly and worried about safety. The crew did a camera inspection and showed me cracks in the flue liner letting smoke and odor leak into the wall cavity. They gave honest transparent pricing for the reline and didn't pressure us. Trustworthy people who clearly know chimneys.",
          "name": "Adaeze O.",
          "date": "2025-08-16",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Jordan came out for a dryer that kept overheating and stopping. The vent line had so much lint the airflow at the hood was basically nothing. After he cleaned it, the exhaust was strong and warm instead of hot and trickling. He also recommended a longer interval between cleanings based on how we use it. Appreciated the honest, no-pressure advice.",
          "name": "Whitney A.",
          "date": "2024-03-30",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Very pleased with the pre-summer cleaning. Dmitri walked me through the whole process, vacuumed each return vent, and sanitized the ductwork. He even reset our thermostat schedule for better efficiency. The house cools down faster and there's far less dust settling on the furniture now.",
          "name": "Anneliese B.",
          "date": "2024-06-24",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Called about a moldy odor and they had a crew out the same day. Felix inspected with a camera, found no mold but plenty of dust and moisture residue, and was upfront that a full cleaning plus sanitizing would solve it. He was right. Honest, fair pricing, no scare tactics. The air smells clean for the first time in years.",
          "name": "Marshall E.",
          "date": "2026-02-27",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Buyer's agent insisted on a chimney specialist and I'm glad they did. The inspection turned up significant creosote glaze that needed professional removal. Everything was in the written report with clear before photos. No fluff, just the facts we needed.",
          "name": "Quentin H.",
          "date": "2025-02-23",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "First-time homebuyers here, and we quickly learned the sellers had multiple cats. The dander circulating through the supply vents had my allergies in overdrive. Sam was fantastic, he scoped each duct run, cleaned the returns and supply lines, and vacuumed out the air handler that was caked with fur. He took before and after photos and explained how often we should have it done going forward. Pricing was exactly what the office quoted, no hidden fees. Breathing so much easier now.",
          "name": "Tiffany E.",
          "date": "2026-04-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Allergies had been brutal and the airflow felt weak. Tony identified two heavily clogged return vents as the culprit. He cleaned the returns, all the supply ducts, and replaced our filter. Within a day my sneezing dropped and the air moves strongly through every register. Loved that the price was set before he started and there were zero add-ons. Polite, careful, and quick.",
          "name": "Bianca G.",
          "date": "2025-07-29",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Appreciated the straightforward pricing and no pressure. The crew vacuumed every supply duct and the airflow throughout the house is noticeably better. AC keeps up easily now.",
          "name": "Marcus-Andre J.",
          "date": "2025-02-26",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Pavel came out to clean the ducts in our new construction home and was excellent. Construction debris had clogged several supply runs and he cleared them all, then showed me the before and after photos. Polite, careful with the drop cloths, and explained everything in plain language. You can tell this is a family business that values reputation.",
          "name": "Isabella G.",
          "date": "2024-09-27",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Dryer in my basement rental apartment was overheating. Marcus cleaned out the heavily clogged vent line, confirmed the lint trap was seating properly, and checked airflow at the hood. Same-day appointment which my tenant appreciated.",
          "name": "Howard E.",
          "date": "2025-07-06",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "This was our first annual sweep with them after switching companies, and the difference was night and day. Andre spent time explaining how creosote forms, inspected the flue liner top to bottom with a camera, and found a hairline crack in the crown that the previous company never mentioned. He gave me a written report with photos and a no-pressure estimate. Drop cloths down, shoe covers on, everything spotless after. Genuinely impressed.",
          "name": "Imelda R.",
          "date": "2025-04-14",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Same day service and they meant it. Called in the morning, got a confirmation text, a reminder an hour later, and the crew arrived that afternoon. Marco cleaned all supply ducts and the main return, then walked me through before and after photos. The office kept me posted on timing the entire day.",
          "name": "Reuben C.",
          "date": "2026-04-21",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Allergies were brutal for our preschooler and the pediatrician suggested duct cleaning. Diego found years of buildup in the supply ducts and a return vent full of insulation debris. He cleaned it all, sealed the registers, and the sneezing has dropped off dramatically. Honest pricing and a friendly tech.",
          "name": "Gabriel A.",
          "date": "2024-06-18",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Wanted peace of mind before lighting the gas logs with a newborn in the house. The technician checked for any gas leaks at the fittings, tested CO near the unit, cleaned the burner, and verified the flame pattern. Patient and careful. Highly recommend.",
          "name": "Damon C.",
          "date": "2026-03-11",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Annual cleaning to get ready for winter. Hector knocked out the creosote, checked the damper, and tightened the loose cap on the chimney. In and out in under an hour and left zero mess.",
          "name": "Bennett C.",
          "date": "2024-11-08",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "No bait and switch here. The estimate covered all ten vents and the two returns, and that's what I paid. Sergei took before and after photos and explained the buildup he removed. He could have easily talked me into extra services but didn't.",
          "name": "Quentin M.",
          "date": "2024-12-28",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Long overdue cleaning after years with two shedding cats. Mikhail pulled fur out of the supply ducts and showed me the camera feed throughout. Polite, careful, and on time.",
          "name": "Renata C.",
          "date": "2025-04-18",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Two-story with the dryer venting up and out the roof. Tech got on the roof, removed the cap, and brushed the run clean. No mess left behind.",
          "name": "Rufus E.",
          "date": "2023-05-02",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Whistling and weak airflow led them to a leaky joint and a partially detached run in the crawlspace. Carlos sealed it and reconnected the section in under an hour. Clean and professional.",
          "name": "Roland E.",
          "date": "2023-11-16",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "We'd been smelling something musty near the dryer for months. Raj traced it to lint packed in the vent and a cracked exterior cap that let rain in. After cleaning the whole run he mounted a new stainless vent hood with a pest screen and sealed it properly with weatherproof caulk. Smell is gone and the dryer is far quieter. Courteous and tidy throughout.",
          "name": "Estelle P.",
          "date": "2025-12-09",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Eight years of repeat service and counting. The crew showed up on time, put down drop cloths, and ran the brush and vacuum through every duct run. Devin flagged a disconnected branch line in the crawlspace that was dumping conditioned air, reconnected it, and showed me the before/after photos. Their consistency across air ducts and the dryer vent we did last year is why I never bother getting other quotes.",
          "name": "Cornelius V.",
          "date": "2025-07-03",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "After noticing loads needed an extra cycle, I had the vent cleaned. The technician found that the previous owners had used a long flexible foil hose that was sagging and trapping lint. He replaced it with rigid pipe and cleared the rest of the run. Gave me a written report with photos. Drying time dropped noticeably.",
          "name": "Beatriz A.",
          "date": "2025-05-15",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Brick was visibly damp and a few spots were flaking. Tyler explained the crown had failed and water was wicking down. He recrowned and waterproofed the stack, replaced the rusty cap. Patient with all my questions about maintenance.",
          "name": "Camila O.",
          "date": "2023-11-21",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Three people in our house have allergies, so dusty ducts were a real problem. Omar and the crew cleaned every register and the trunk line, then sanitized the system. The improvement in air quality was immediate, less sneezing, fewer itchy eyes, and the house finally feels fresh.",
          "name": "Bianca N.",
          "date": "2025-04-26",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Nikolai laid drop cloths the entire length of the hall and put a mat under his equipment cart. He kept each return vent cover bagged while he cleaned so nothing scattered. The buildup that came out was significant but you'd never know from looking at the floor. He vacuumed and wiped everything down before leaving.",
          "name": "Solange A.",
          "date": "2025-02-26",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Our living-room expansion left a fine layer of drywall dust on every surface no matter how much I cleaned. Eli came out, explained how the HVAC had been recirculating the sanding dust, and did a full negative-air cleaning of the system. He cleared a clump of sawdust from near the blower motor and showed me before-and-after shots of each register. Respectful, certified, and the office pricing was completely transparent.",
          "name": "Beatriz O.",
          "date": "2026-05-04",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "My elderly mother's dryer stopped heating and she couldn't go without laundry. Called and the technician was there the same afternoon, right when they said. Cleaned the clogged vent and checked the lint trap path. So grateful they treated it as urgent.",
          "name": "Harold E.",
          "date": "2025-04-09",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Smelled something hot during a dry cycle and shut it off immediately. Called the next day and Victor came out, found a vent line packed with lint near a wall elbow, and cleared it completely. He also reattached the loose exterior vent hood that had let in moisture. Calm, thorough, and explained why the buildup was a fire risk. Real peace of mind now.",
          "name": "Seraphina O.",
          "date": "2025-10-21",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Ramon solved a draft issue I'd given up on. Turned out the cap mesh was clogged with soot restricting airflow. Cleaned it out and the smoke goes straight up.",
          "name": "Spencer G.",
          "date": "2026-04-11",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Dryer ran hot then shut itself off every load. Luis found the duct crushed behind the pedestal and clogged. Straightened the run, cleared the lint, tested it twice. Works great.",
          "name": "Roberto E.",
          "date": "2026-04-02",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Smooth experience. The office got me booked same day when our AC started blowing weak, and the crew traced it to badly clogged return ducts. After the cleaning the airflow was strong again. Honest folks.",
          "name": "Jamal O.",
          "date": "2025-05-21",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Crisp, fresh air after years of a faint musty smell. The crew cleaned every register and fogged the system. Very tidy work.",
          "name": "Delphine V.",
          "date": "2024-07-01",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Affordable and quick. Got our chimney inspected before listing and the report noted the cap was missing entirely. Tech was friendly and explained why that matters for the next owner.",
          "name": "Bethany L.",
          "date": "2024-08-22",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Heavy smoker lived in our house before us and the ducts held onto that smell something fierce. Kevin cleaned every register and the return system and laid drop cloths so nothing got dusty. The improvement in air quality was obvious by that evening.",
          "name": "Gerald V.",
          "date": "2025-07-12",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Furnace airflow was poor. The clogged return was the problem. Crew cleaned it and the ducts same day. Honest and tidy.",
          "name": "Theodore N.",
          "date": "2023-10-07",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "From the first call the office was upfront about cost and timing. Jordan and his teammate covered the floors, removed each register, and ran the brush-and-vacuum system through the entire ductwork. They showed me the debris bag and a written report at the end. Our drafty back rooms finally get airflow, the HVAC cycles less often, and the first month's electric bill dropped about twenty dollars. Genuinely impressed.",
          "name": "Genevieve H.",
          "date": "2026-04-15",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Dmitri did a great job on the return vents and supply ducts. He noticed our thermostat fan setting was working against the system and adjusted it. Friendly and quick.",
          "name": "Roland D.",
          "date": "2025-11-18",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Got the dryer vent cleaned at a duplex I rent out. Felix was thorough, brushing the full run and vacuuming the buildup near the wall sleeve. He explained why annual cleaning matters for fire prevention in shared laundry setups. Fair, transparent pricing and a tidy job.",
          "name": "Tamara J.",
          "date": "2024-04-03",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Matter-of-fact and efficient. Yearly sweep completed, creosote cleared, flue confirmed clean with the camera. Sam also reset a loose cap screw up top.",
          "name": "Roland H.",
          "date": "2024-07-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Friendly, well run family operation. The scheduler set my dryer vent cleaning and texted reminders so it never slipped my mind. Tony pulled out a thick lint clog near the wall elbow and tested the vent hood flap afterward. Clear pricing, clear communication.",
          "name": "Vivian L.",
          "date": "2025-01-09",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Our infant daughter has sensitive lungs so clean air was a priority. Pavel was punctual, explained the whole process, and showed before/after photos of each return vent. The dust buildup he removed was unreal. He worked quietly during nap time and the price was transparent from the first call. So glad we did this.",
          "name": "Vanessa O.",
          "date": "2025-04-25",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Friendly tech, clean work. Cleaned the dust from the logs, inspected the pilot assembly, and confirmed the venting was clear. Lights perfectly now and the glass is spotless.",
          "name": "Ingrid R.",
          "date": "2024-11-09",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Moved in over the summer and finally got the gas fireplace serviced before the deep cold. Marcus cleaned the burner, vacuumed dust off the ceramic logs, checked the pilot and thermocouple, and made sure the venting was clear. The flame is gorgeous now and there's no gas smell on startup like there used to be. He explained the safety checks he ran in a way that actually made sense. Fair, transparent pricing too.",
          "name": "Imani F.",
          "date": "2026-01-22",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Transparent pricing was the reason I chose them over a cheaper-looking ad. The office gave me the real number upfront with no vague fine print. Andre cleaned the supply ducts and returns, laid drop cloths, and the final invoice matched the quote exactly. When I asked about adding a dryer vent cleaning he gave me a fair price for it instead of pretending it was urgent.",
          "name": "Beatriz E.",
          "date": "2025-10-03",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "We could literally see pet hair drifting out of the vents. Marco sealed each register, ran negative air, and cleaned the return ducts where most of the dander had settled. He wore shoe covers the whole time and left the house spotless. Family-owned business that clearly takes pride in the work.",
          "name": "Harlan E.",
          "date": "2024-10-08",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Scheduling was easy and the office called to confirm. Our long rooftop dryer run was the issue, and Diego found the rooftop vent cap was the kind without a flap, so rain and debris had been getting in and mixing with lint into a paste near the top. He cleaned it all out, swapped in a proper hooded cap, and resealed the flashing around the penetration.",
          "name": "Camila H.",
          "date": "2025-10-27",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Fixed a detached supply duct that had dropped off the boot above our nursery. Hector reseated and sealed the collar, then went joint by joint resealing leaks along the branch with mastic. He measured airflow before and after so I could see the improvement. Considerate about keeping the area clean with drop cloths and quick to answer my questions.",
          "name": "Gwendolyn M.",
          "date": "2025-10-21",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Reliable service. Sergei cleaned the dryer duct, removed a wad of lint near the wall elbow, and replaced the broken exterior vent with a new hood and pest guard. Wore shoe covers and cleaned up. Fair, transparent pricing as quoted.",
          "name": "Hugh M.",
          "date": "2024-08-27",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Trusted them for years on the air ducts, so the dryer vent was a no-brainer. Mikhail cleaned out the lint trap housing and the full vent run, then checked the vent hood outside. Clothes dry in one cycle now instead of two.",
          "name": "Marguerite Z.",
          "date": "2024-06-20",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Two cycles every time, sometimes three for towels. Carlos showed up the same day I called, laid down a drop cloth, and brushed out the full vent line plus the lint trap area. He found the outside vent flap painted shut and freed it. Clothes finally dry on the first cycle and the bill matched the quote exactly.",
          "name": "Colin M.",
          "date": "2024-12-22",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Outstanding from the first call. Raj arrived on time, set up drop cloths, and inspected the chimney top to bottom. The crown had a major crack and the cap was rusted solid. He recast the crown with a proper overhang, fitted a stainless cap, and applied a waterproof masonry sealer. Detailed photos before and after. The price was exactly what the office quoted, no surprises.",
          "name": "Reginald P.",
          "date": "2026-03-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dust kept triggering my hay fever indoors. Devin cleaned the return vents and supply ducts and explained the buildup clearly. Noticeably fewer sneezing fits now.",
          "name": "Quentin J.",
          "date": "2023-09-02",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Spotless cleanup was the highlight. Plastic over the doorways, drop cloths under the furnace, and a sealed bag for all the debris from the supply lines. They even wiped the floor where the hose had dragged.",
          "name": "Travis E.",
          "date": "2023-10-04",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Sawdust from our hardwood flooring project had worked its way into the return ducts. Tyler cleaned every vent and ran a brush through the trunk lines. Tidy, on time, and the written report was a nice touch.",
          "name": "Wesley H.",
          "date": "2023-11-26",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Closing on the sale of our house and the buyer demanded the ducts be cleaned within 24 hours. Frantic, I called and they slotted me in that very day. Omar arrived on time, cleaned all the registers and returns, and gave me documentation the title company accepted. Saved the entire closing timeline. Professional from start to finish.",
          "name": "Genevieve L.",
          "date": "2024-10-01",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "This family-run company was upfront about pricing from the first call. Nikolai cleaned the entire dryer duct, removed a startling amount of lint, and showed me before-and-after photos. Outside vent cap now opens like it should.",
          "name": "Augustus E.",
          "date": "2025-04-18",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Our fireplace smoked badly every time we used it. Eli diagnosed it as a combination of creosote buildup and a too-small flue opening, then walked us through a smoke guard option to fix the spillage. He swept everything spotless and laid drop cloths over the whole hearth area. Knowledgeable, friendly, and the smell that had haunted our living room for two winters is finally gone.",
          "name": "Veronica C.",
          "date": "2024-10-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Scheduling was easy and the office had someone out the next morning. Victor diagnosed our overheating dryer as a fully blocked roof vent, climbed up to clear the cap, then brushed the interior duct from inside. He laid drop cloths and wore shoe covers the whole time. The dryer no longer trips off and the clothes are dry in one go. Reasonable price for the work.",
          "name": "Melissa U.",
          "date": "2025-11-19",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Ramon did a fantastic job getting our ducts ready for summer. He found a section of ductwork in the attic that had come loose and was leaking conditioned air into the insulation. After sealing it and cleaning the whole system, our upstairs is actually cool for the first time in years. He took photos of everything and explained each step. Couldn't be happier.",
          "name": "Felicity Z.",
          "date": "2026-05-25",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Luis and his partner spent the better part of a morning on our two-story home. The musty smell was coming from the return ducts where dust had absorbed humidity. They cleaned it all, sanitized with an antimicrobial fog, and even wiped down the vent covers. Showed me before and after photos that made the price absolutely worth it. Professional from start to finish.",
          "name": "Bridget M.",
          "date": "2025-10-18",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "We were under contract on a house with a beautiful old fireplace but the chimney was a question mark. Kevin ran a full inspection, found the flue liner was cracked in two spots, and laid it all out in a written report with diagrams. The detail let us renegotiate the price and budget for the relining. Truly grateful for the honesty during such a stressful purchase.",
          "name": "Tobias M.",
          "date": "2025-11-09",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Newly purchased home, previous family had big dogs, and the pet odor lingering in the air was the first thing guests noticed. Jordan inspected the ductwork, found significant hair and dander in the trunk lines, and cleaned the whole system top to bottom. He wore shoe covers and protected our new floors. Same-day service was a lifesaver before we moved the furniture in.",
          "name": "Monica D.",
          "date": "2024-12-07",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Stuffy back bedrooms and a system that ran nonstop. Dmitri pulled the main return and it was packed solid, restricting nearly all the airflow. After cleaning both returns and the supply lines, the rooms finally get proper air. He took before/after photos and explained how to keep the returns clear going forward. Fair pricing and very professional.",
          "name": "Camila V.",
          "date": "2024-12-19",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Restricted airflow in the den for years. Tech cleared the supply line and a kinked flex duct behind the wall. Room is comfortable now and the system isn't straining.",
          "name": "Owen P.",
          "date": "2024-04-08",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Felix was incredibly skilled and courteous during our duct cleaning. He found mouse droppings in one of the supply ducts left by a previous tenant, sanitized the whole system, and documented it in the written report. Never tried to upsell, just told me honestly what we needed. Shoe covers on, drop cloths down, and the place was cleaner than when he arrived.",
          "name": "Wendy K.",
          "date": "2024-03-14",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Excellent service for property owners. Sam handled a dryer-vent cleaning at my rental where lint had compacted into a solid plug at the elbow. Cleared it completely, snapped before and after photos for me, and double-checked the exterior vent flap opened freely. Tenant says drying time was cut in half. I keep their number on speed dial for all my units now.",
          "name": "Patrice W.",
          "date": "2025-11-17",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Booked the annual maintenance and it went smoothly. Tony swept the flue, removed a moderate creosote layer, and pointed out that the flashing needed resealing before the rainy season. He didn't pressure me, just documented it in the report. Firebox was vacuumed clean and the hearth looked untouched. Great value for the peace of mind.",
          "name": "Genevieve A.",
          "date": "2025-10-03",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Coordinating the appointment around my schedule was simple. The office offered three window options and sent a reminder the night before. Technician cleaned the return vents and supply ducts and noted a small gap at the damper in the written report he handed over.",
          "name": "Étienne G.",
          "date": "2024-02-17",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Bringing home a newborn made us hyper-aware of every dust bunny. Pavel cleaned all the supply ducts and returns, found a damper stuck shut that was choking airflow to the nursery, and fixed it. Wore shoe covers, used drop cloths, left no mess. Great value.",
          "name": "Patrick E.",
          "date": "2024-12-03",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Marcus handled our annual gas fireplace safety inspection and was excellent. He pulled the logs, vacuumed the firebox, cleaned the burner ports, checked the gas connections with leak detector solution, and tested the thermocouple. Reset the embers and logs to the manufacturer diagram so we get that realistic glow. Left a clear written report. Fair, transparent pricing throughout.",
          "name": "Carlotta J.",
          "date": "2025-01-26",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Quick pre-season tune-up. Andre swept the flue, removed creosote, and replaced the worn door gasket on our wood insert. Burns hotter and cleaner now. No complaints.",
          "name": "Garrett O.",
          "date": "2025-10-25",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Solid honest service. Quoted me a rate, cleaned the lint trap and full vent line, and that was the bill. Marco did the work efficiently and never once tried to upsell me.",
          "name": "Travis W.",
          "date": "2023-05-30",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Three cats, one old house, and ducts full of dander. Diego was patient, walked me through the whole process, and cleaned every supply and return run. The dust settling on shelves has dropped dramatically.",
          "name": "Genevieve M.",
          "date": "2025-11-11",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Long duct run with a rooftop exit. Hector checked airflow first, cleaned both the long horizontal section and the vertical riser, and replaced a section of flex hose behind the dryer that had been kinked for years. Clear pricing up front.",
          "name": "Lachlan B.",
          "date": "2024-09-09",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Sergei reconnected two detached runs and sealed the leaky seams on our main trunk line. Airflow to the back rooms finally feels right. Upfront pricing and same-day service.",
          "name": "Hassan K.",
          "date": "2024-09-08",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "After moving into an older home, our first call was to get the dryer vent inspected. Mikhail found the line nearly half blocked and the exterior hood missing its flap entirely, which is how a family of birds had moved in. He cleared everything, installed a new vent hood with a pest guard, and verified strong airflow with a meter. Same-day, certified, insured, and genuinely kind. Highly recommend them.",
          "name": "Carmen Z.",
          "date": "2026-05-11",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Repeat customer across multiple services and always satisfied. Carlos cleaned the supply and return ducts, sealed a leaky joint near the air handler, and walked me through the written report line by line. Fair pricing, certified tech, in and out without any fuss. We'll keep this family business on speed dial.",
          "name": "Bernard Q.",
          "date": "2025-10-16",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "What a difference. Our dryer had been taking forever, running two and three cycles, and Raj diagnosed a completely blocked vent within minutes. He cleaned the entire run from the back of the dryer to the roof termination cap and vacuumed out the lint trap slot. Sent before and after photos. Highly recommend for anyone whose laundry won't dry.",
          "name": "Delphine R.",
          "date": "2025-08-30",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Leak was showing up on the second-floor ceiling. Devin found the crown cracked and the flashing lifted. Sealed both, replaced the cap, waterproofed the brick. Ceiling stayed dry through the next big storm.",
          "name": "Tabitha E.",
          "date": "2024-08-16",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "My mother has severe asthma and the dust in her old place was making it worse. Tyler came out the same day, covered her furniture, and meticulously cleaned every supply and return duct. He showed us photos of the debris pulled from the system. Her breathing has improved and she's no longer reaching for her rescue inhaler every evening.",
          "name": "Marisol C.",
          "date": "2026-03-07",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Honestly the tidiest contractors we've had in this house. Omar and his partner covered the path with drop cloths, wore shoe covers, and taped plastic over each register they weren't actively cleaning. The negative-air machine kept the dust contained while they brushed the return ducts. At the end they vacuumed every vent, wiped the covers, and ran a dust mop across the main floor. Zero mess, fresher air.",
          "name": "Delphine I.",
          "date": "2025-10-21",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "We remodeled the upstairs and the drywall dust kept blowing out the supply vents for weeks. Nikolai did a complete duct cleaning, sealed off the registers individually, and used a powerful vacuum on each line. He found construction debris wedged near a damper that was reducing airflow. Air quality is much better and the dusting frequency has dropped way off. Honest crew, fair price.",
          "name": "Naomi E.",
          "date": "2025-02-08",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Dryer took forever and the laundry room felt like a sauna. Same-day visit, Eli right on schedule. He found the flexible transition hose kinked and the duct clogged, replaced the hose with rigid metal, and cleared the run. Dries fast now and the room stays cool.",
          "name": "Theodore J.",
          "date": "2025-11-26",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Dryer was running forever to dry a single load. Victor found the vent run nearly blocked with lint and cleared it in under an hour. Quick and effective.",
          "name": "Lucinda Z.",
          "date": "2023-12-05",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Backdraft was pushing smoke into the basement. Ramon found the issue was a competing exhaust fan creating negative pressure, plus a dirty flue. He cleaned the creosote and explained the makeup air fix clearly. No more smoke smell.",
          "name": "Mateo R.",
          "date": "2025-06-25",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Felt unsafe with the dryer running so hot it would shut down. Luis showed up, found a bird nest plus lint blocking the vent hood, removed it all, and installed a guard cap. The overheating is gone completely. Knowledgeable and reassuring.",
          "name": "Quentin J.",
          "date": "2024-08-11",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Decent value for a thorough job. The tech cleaned all the supply registers and the return, then sanitized everything. Air smells clean now that the AC is running daily.",
          "name": "Spencer L.",
          "date": "2023-05-17",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Worried sick about mold after spotting black specks near a supply vent. Kevin came out, took samples, confirmed it was mostly dust and minor mildew, and treated the whole system with a sanitizing fog. The written report eased my mind and the odor disappeared.",
          "name": "Sylvester G.",
          "date": "2026-01-03",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Professional inspection, fair price, no upsell. The written report documented minor creosote and a perfectly good damper. Made handing the house over to the new owners stress-free.",
          "name": "Imani W.",
          "date": "2024-03-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Cigarette odor through the vents was unbearable. Jordan cleaned the supply and return ducts and gave me photos of all the buildup. Smell is gone. Great value.",
          "name": "Brandon K.",
          "date": "2025-02-14",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Noticed the AC barely moved air after we adopted two dogs. Dmitri found the return vents clogged with hair and dust. He cleared them and cleaned the ducts thoroughly, laying drop cloths the whole way. Airflow is back to strong. Quote was honest and matched the bill.",
          "name": "Reginald M.",
          "date": "2025-02-09",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Felix was thorough and patient with all my questions. He explained that the dust coating the duct walls was reducing airflow and making the AC work harder than it needed to. After cleaning, the air pushing out of the vents is stronger and cooler, the compressor cycles less, and I genuinely noticed the difference on my next power bill. Highly recommend.",
          "name": "Tasha B.",
          "date": "2025-08-03",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Sam handled our air duct cleaning with real professionalism. He explained the negative-pressure setup, ran the brush through every supply line, and walked me through the debris at the end. Respectful of the house and finished on time.",
          "name": "Gregory M.",
          "date": "2025-07-30",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Fast, professional dryer-vent work at my rental. Tony cleared the line, replaced the flimsy foil duct with rigid metal, and was respectful of the tenant's space the whole time. No mess left behind.",
          "name": "Colin M.",
          "date": "2026-05-04",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Same-day appointment when I smelled smoke backing up. Pavel found a heavy creosote glaze choking the flue and cleared it with the rotary system. He ran a smoke test afterward to confirm the draft was restored. Honest, fast, fairly priced.",
          "name": "Tobias E.",
          "date": "2026-04-08",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "I run a busy household so the reminders were a lifesaver. Confirmation email when I booked, a text 24 hours before, and a call when Marcus was on his way. He cleaned the full dryer vent run, cleared the lint trap channel, and checked the exterior vent hood for blockage. Scheduling could not have been smoother and the staff were genuinely pleasant on every call.",
          "name": "Nadia Q.",
          "date": "2025-07-27",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Family-owned business that clearly cares. Andre cleaned every vent, showed me the grime pulled from the return, and answered all my new-mom questions without making me feel silly. The baby's room finally feels fresh and the price was honest.",
          "name": "Lucia B.",
          "date": "2025-08-16",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Quick and competent. Pilot kept going out so Marco cleaned the thermopile contacts and adjusted the pilot flame to fully engulf the sensor. Working perfectly now and he tested it several times before leaving.",
          "name": "Bryan E.",
          "date": "2025-10-03",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Outstanding fireplace cleaning before the season turned. Diego took his time, sweeping the flue liner, scraping creosote from the smoke shelf, and vacuuming the firebox until it was spotless. He flagged a small gap in the mortar joints inside the firebox and noted it in the written report rather than scaring me into an immediate repair. That kind of honesty is rare. The hearth and surrounding floor were protected with drop cloths the entire time. Highly recommend for anyone prepping for winter.",
          "name": "Sasha Q.",
          "date": "2024-09-30",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Exactly what was quoted, not a dollar more. They explained the per-vent cost clearly before I committed. Hector cleaned everything, supply runs and returns, showed me the debris in the collection bag, and gave me a written report. He noticed a torn flex duct and fixed it without adding it to the bill. Genuinely fair people.",
          "name": "Olga K.",
          "date": "2025-06-17",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Two German shepherds shed enough to knit a sweater, and it all ended up in our ductwork. Sergei inspected with a camera, showed me the hair packed into the supply lines, and cleaned each one thoroughly. He also vacuumed out the blower compartment where dander had collected. The before-and-after photos were dramatic. Airflow is stronger and my sinuses thank him.",
          "name": "Octavia L.",
          "date": "2026-04-29",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "We had no idea our dryer vent ran so far. From the upstairs laundry it goes the whole length of the house and exits through the roof. Mikhail spent over an hour on it, working methodically from the roof down, and pulled out lint at three separate elbows. He documented everything with photos and a written report, and pointed out where a previous installer had used too many tight bends. The drying time improvement is dramatic.",
          "name": "Esperanza R.",
          "date": "2026-04-14",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "A family-owned company that actually does what they promise. Carlos found a duct that had separated at a junction in the attic and was venting our heat into the insulation. He reconnected it, sealed every accessible joint with mastic, and strapped the runs. Left a detailed written report with before and after photos. Our gas bill dropped the very next month.",
          "name": "Adelaide R.",
          "date": "2026-05-10",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Raj handled the dryer-vent cleaning and noticed the exterior hood was held on with one screw and zero pest protection. Installed a solid metal hood with a screen guard and re-secured it to the siding. Clothes dry in a single cycle now. Appreciated the honest assessment.",
          "name": "Otto B.",
          "date": "2025-04-05",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Years of good service keep us coming back. Devin vacuumed the return vents and showed before/after photos. Clean, fast, polite.",
          "name": "Anneliese U.",
          "date": "2024-03-28",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Loads needed a second cycle constantly. Tyler cleared the vent and the exterior hood, both packed with lint. Fast and reasonably priced.",
          "name": "Anson P.",
          "date": "2024-03-19",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Omar did a fantastic job. Our crown was cracked in two places and the cap was rusting onto the masonry leaving ugly stains. He ground out and recast the crown, installed a new stainless cap, and sealed the entire chimney with a clear waterproofer. He took the time to show me each step in his photo report. Highly recommend their chimney work.",
          "name": "Lionel D.",
          "date": "2025-11-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Pollen would drift through the whole house every spring. Nikolai cleaned the ducts and pointed out a gap in a return that was sucking in attic dust. After he sealed and cleaned it, my sneezing dropped off fast.",
          "name": "Theo E.",
          "date": "2024-06-14",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Eli showed up with drop cloths and shoe covers and got to work without tracking anything in. He sealed each supply duct opening between sections so dust wouldn't drift, then vacuumed the grilles. Cleanup was meticulous, swept and wiped down.",
          "name": "Mason U.",
          "date": "2024-12-09",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Whole-home duct cleaning after a long renovation. Victor and Victor pulled out so much drywall powder and sawdust it was almost funny. Drop cloths, shoe covers, before-and-after photos. Couldn't have gone smoother.",
          "name": "Curtis B.",
          "date": "2024-06-11",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Prompt, professional, done. Our return vents were filthy and I wanted it handled before company arrived. They came the same day within the window, cleaned the whole system, and left zero mess thanks to drop cloths and shoe covers.",
          "name": "Ophelia M.",
          "date": "2024-03-15",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Got serious about this after my insurance agent mentioned dryer-vent fires. Ramon inspected the full system, found lint compacted against the rooftop termination, and cleared it with a brush from the cap down. He replaced the crushed flex hose behind the dryer with rigid ductwork and resealed every joint with foil tape. Showed me the airflow reading before and after. Professional, certified, and genuinely cared about doing it right.",
          "name": "Beatrix Q.",
          "date": "2025-06-26",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Faint smoky odor in the house all summer. Luis inspected and found the flue cap had blown off in a storm, letting moisture mix with creosote. New stainless cap installed and a full sweep done. Odor gone within a day.",
          "name": "Priscilla E.",
          "date": "2024-03-12",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "The dryer kept stopping on a heat error and I was worried it was the control board. Kevin checked the vent first and found it packed near the wall penetration. He cleared it, the airflow returned, and the error never came back. Saved me an unnecessary appliance repair bill.",
          "name": "Indira P.",
          "date": "2025-05-26",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Could not be more impressed. Jordan showed up early, covered the floors, and spent a couple hours cleaning every duct in our ranch home. The amount of dust he pulled from behind the return vent was unbelievable. He also caught a torn filter slot that was letting debris bypass straight into the system. AC runs cleaner and quieter than it has in years.",
          "name": "Theresa M.",
          "date": "2024-03-30",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Damp, sour smell in the nursery had me anxious about my newborn. Dmitri was so patient explaining the sanitizing process and used a baby-safe antimicrobial treatment after a full duct cleaning. Drop cloths down, shoe covers on, the whole nine yards. Air is fresh and clean now. Cannot thank them enough.",
          "name": "Genevieve W.",
          "date": "2025-08-25",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Scheduling was easy and the office worked around our tight closing window. Felix inspected the chimney, scoped the flue, and noted the crown had hairline cracks that should be monitored. The written report was detailed enough to satisfy our mortgage company. Genuinely appreciated the clarity.",
          "name": "Frederick A.",
          "date": "2025-07-12",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "We bought a home where the sellers smoked and had a cat, the worst combination for indoor air. Sam took his time, scoped the ducts, and showed me the residue and dander coating the supply lines. He cleaned the entire system, sanitized the returns, and replaced our clogged filter. The whole crew was respectful of our space and laid down drop cloths everywhere. Pricing was transparent from the booking call. The difference in how the house smells and feels is remarkable, no more headaches from the stale air.",
          "name": "Allison M.",
          "date": "2026-05-09",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Honestly thought we'd need a new HVAC unit because the airflow was so weak. Tony came out same day, inspected, and found both return vents almost completely blocked with years of compacted debris. He cleaned the returns, all supply ducts, and showed me the airflow meter jump significantly afterward. Saved us thousands. He was courteous, wore shoe covers, and the written report was detailed. Family-owned and it shows in the care they take.",
          "name": "Anastasia P.",
          "date": "2026-04-30",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Straightforward duct cleaning that fixed weak airflow upstairs. The blower compartment was packed with dust. Much better circulation and quieter running now.",
          "name": "Quentin R.",
          "date": "2023-11-17",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Pavel was our tech and I'd request him again in a heartbeat. He cleaned all the returns, sanitized the ducts, and even reattached a loose register cover that had been rattling for months. Kind, thorough, and the transparent pricing meant the bill matched the quote exactly. A genuinely good experience start to finish.",
          "name": "Delia R.",
          "date": "2024-05-22",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Inherited a rental with a dryer vent that clearly had never been cleaned. Marcus pulled out years of packed lint, found a section of duct that had separated inside the wall, and resealed it. He walked me through the camera footage so I understood the condition. Reasonable rate given how bad it was, and now I have a clean baseline and a written report for the property file.",
          "name": "Renata S.",
          "date": "2025-02-26",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Our yearly creosote removal was handled by a courteous crew that respected the house. Drop cloths, shoe covers, the works. They swept the entire flue, checked the smoke shelf, and inspected the stainless cap for damage. The written report confirmed everything was clean and safe for the season. Pricing was exactly what the scheduler quoted on the phone, no surprises. We'll keep coming back.",
          "name": "Soledad M.",
          "date": "2024-09-21",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Booked over the phone with a friendly scheduler who quoted me a clear price. Reminder text came the day before. Crew cleaned the supply ducts and returns and left no mess thanks to the drop cloths.",
          "name": "Grant U.",
          "date": "2023-04-03",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Two little ones constantly on the floor breathing whatever the vents push out, so we booked a deep clean. Andre was professional, laid drop cloths everywhere, and cleaned the blower compartment along with all the ducts. He flagged a small mold spot near a supply register and gave us a written note about it. No pressure to buy anything. The air smells cleaner already.",
          "name": "Megan R.",
          "date": "2024-10-22",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Top-notch from start to finish. Marco inspected the gas-log fireplace before winter, cleaned the burner and logs, checked CO levels, and confirmed the flue damper was properly clamped open. He noticed sooting on the glass and adjusted the air mixture to fix it. Explained how to spot warning signs myself between visits. Genuinely cared about doing it right.",
          "name": "Annette M.",
          "date": "2024-10-30",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "Solid work getting our fireplace cold-season ready. Diego cleaned the flue, vacuumed the ash, and verified the damper sealed tight to stop drafts. The office made scheduling painless.",
          "name": "Darnell I.",
          "date": "2025-11-27",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "Price held exactly as quoted. Hector cleared the vent run and the exterior cap, tested the airflow before leaving, and didn't push any add-ons. Clean and simple transaction.",
          "name": "Marcus the customer, written as Dario F.",
          "date": "2024-10-21",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Quick same-day cleaning after fur buildup. Sergei got the return vents spotless. Fair price. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Bertram Q.",
          "date": "2024-02-27",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Rooftop vent on a long run. Mikhail cleaned it efficiently and reinstalled the cap with new screws since the old ones had rusted out. Towels dry in one cycle now.",
          "name": "Otis K.",
          "date": "2025-01-21",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Carlos sealed a series of leaky duct joints and reattached a supply run that had slipped off near the furnace. Matter-of-fact, efficient, and he tested airflow at each register. No complaints at all.",
          "name": "Cornelius D.",
          "date": "2024-02-23",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "What a difference. Raj pulled an unbelievable amount of lint from our dryer line and showed me how the old exterior vent had no guard, letting bugs and a mouse get in. He fitted a new stainless hood with a fine pest mesh and made sure it sealed flush to the brick. Laid drop cloths, vacuumed, and walked me through the written report. The dryer no longer shuts off on overheat. Excellent crew.",
          "name": "Gwendolyn A.",
          "date": "2024-02-19",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "We've had Master out for ducts, dryer vent, and a chimney sweep over the years and they're consistently solid. Devin cleaned every supply line, reseated a damper, and pointed out the filter slot needed a better-sealing gasket. Same-day availability when our HVAC guy recommended a cleaning. Couldn't ask for more from a long-term provider.",
          "name": "Horace G.",
          "date": "2026-04-25",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Three cycles to dry bath towels was the last straw. Tyler arrived on time, used shoe covers, and ran a brush the full length of our vent. He found a section behind the wall almost completely choked with lint and a partially detached duct joint, which he resealed. Now everything dries in one go and the laundry room temperature is back to normal.",
          "name": "Margot E.",
          "date": "2026-05-11",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Cracked crown was the source of our leak. Omar repaired it and waterproofed the stack same day. Showed me the corroded cap before swapping it for stainless. Clean, polite, fair.",
          "name": "Octavia M.",
          "date": "2024-04-02",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Highly recommend for anyone with allergies. The crew removed years of dust from the supply ducts and return grilles, used shoe covers the entire time, and left a detailed written report. My constant throat tickle and morning sneezing have both gotten much better.",
          "name": "Rosalind P.",
          "date": "2025-10-19",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Cream carpets made me nervous but the crew rolled runners over every inch of the path and wore shoe covers on top. They bagged the debris from the return ducts and never set a dusty tool down without a cloth under it. Floors and vents spotless afterward.",
          "name": "Esperanza J.",
          "date": "2026-05-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Post-construction cleaning after our two-story addition. Nikolai was professional from the first knock, mapping the entire supply and return system before starting. He used a negative-air machine and rotary brush, and removed a startling amount of gypsum dust and wood shavings from the main trunk. He even cleared a piece of cut-off ductwork the installers had left rattling inside a chase. Written report with photos of every vent and the filter he replaced. The family-owned care really showed in how careful he was with our new floors.",
          "name": "Ingrid S.",
          "date": "2026-03-27",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "This family business saved me when my dryer vent clogged the night before a long trip and I had loads of laundry to finish. Morning call, and Eli arrived by early afternoon exactly as scheduled. He pulled a dense lint blockage from deep in the run, cleaned the vent hood, and tested the airflow twice to be sure. I packed on time and the dryer has worked flawlessly since. Cannot overstate how the punctuality made my day.",
          "name": "Cordelia B.",
          "date": "2025-06-20",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Moved into an older home and the dryer vent had clearly never been touched. Victor pulled out years of matted lint, cleared a partial blockage at the exterior hood, and confirmed the flap was sealing properly. Drying time is noticeably better and the burning smell is gone. Tidy, on time, fairly priced.",
          "name": "Geraldine U.",
          "date": "2024-08-02",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Same-day appointment to deal with a smoking fireplace. Ramon cleared a thick creosote layer and reset the damper, which had been stuck half-closed. Draft is excellent now and the price matched the quote exactly.",
          "name": "Gregory U.",
          "date": "2025-09-30",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Clothes hot, dryer quitting, classic. Luis cleared the lint-choked vent, cleaned the trap housing, and checked exhaust temp. Quick and clean.",
          "name": "Oscar M.",
          "date": "2026-05-12",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Booked pre-summer because of dust and allergies. Kevin cleaned the ductwork and replaced our filter with the correct size. Breathing easier and the cold air reaches every room now.",
          "name": "Ophelia R.",
          "date": "2025-04-07",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Musty odor in the den knocked out in a single visit. Jordan cleaned the supply ducts and fogged the system. Straightforward and well-priced.",
          "name": "Horace P.",
          "date": "2024-09-27",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Bought a 1960s ranch and the chimney inspection caught a partially collapsed flue liner that the seller's disclosure never mentioned. Dmitri photographed everything and the written report was thorough enough that we got the sellers to cover the repair. Cannot overstate how much this saved us.",
          "name": "Marisol E.",
          "date": "2026-04-18",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Pet dander in our new place was relentless until Felix cleaned the ductwork. He vacuumed the returns, the supply vents, and the air handler, all while wearing shoe covers. The musty animal smell is finally gone. Solid, honest work.",
          "name": "Christina R.",
          "date": "2024-06-22",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Restricted airflow had the system cycling constantly. Sam cleared the clogged return vent and cleaned the supply ducts. Clear before/after photos and an upfront price. The house breathes again.",
          "name": "Wesley T.",
          "date": "2024-07-14",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Tony took the time to show me how clogged the return ducts were before he touched anything. After the cleaning the airflow at the registers is strong enough that the furnace heats the whole house quickly and shuts off sooner. Our gas usage this winter is clearly down versus last year.",
          "name": "Adaeze M.",
          "date": "2025-12-08",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Pavel is back at it for us again, this time cleaning the upstairs ducts. Same great attention, drop cloths everywhere, photos before and after. Trustworthy.",
          "name": "Quinn J.",
          "date": "2025-01-19",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Booked them for a rental turnover and they delivered. Marcus cleared the dryer vent, checked the booster fan in the long run, and confirmed the roof termination cap was clear of debris. Clean, certified, and on time.",
          "name": "Otis G.",
          "date": "2024-08-21",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Clean, professional annual sweep. Andre vacuumed every bit of soot and emailed photos same day. Damper smooth, flue clear. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Padraig K.",
          "date": "2025-06-17",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Everything about the scheduling was modern and clear. Online booking, instant confirmation, a reminder text the night before, and a real time tracker when the tech was en route. Marco arrived right in the window, laid down drop cloths, cleaned all return vents and supply ducts, and emailed me a detailed written report with photos. The office set the tone for a great experience.",
          "name": "Soledad I.",
          "date": "2026-05-12",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Same-day service saved us right before the baby shower. Diego cleaned every duct and return vent, used shoe covers, and showed me photos of the dust he removed. Quick and courteous.",
          "name": "Adaeze U.",
          "date": "2025-05-09",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Needed our gas logs checked after a remodel kicked up a lot of dust. Hector cleaned the burner thoroughly, blew out the pilot orifice, inspected the gas line, and ran it to confirm a clean flame with no smell. Reasonable rate for the work.",
          "name": "Sophia T.",
          "date": "2025-11-27",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "Had Sergei out to clean and inspect our fireplace before the first frost. He removed a heavy creosote layer from the flue, examined the firebox refractory, and showed me on his camera how clean the liner was afterward. He also adjusted the damper, which had been sticking. Polite, careful, and he double-checked that drop cloths covered the rug before starting. Heating season started without a hitch thanks to him.",
          "name": "Esther M.",
          "date": "2024-10-17",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "The quote I got matched the invoice perfectly. No mysterious fees, no upsell on duct sanitizing. Mikhail cleaned all the supply vents and returns, wore shoe covers the whole time, and showed me before and after photos of the worst vent. Twenty-plus years in business and it feels like it.",
          "name": "Celeste B.",
          "date": "2026-04-19",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Our cats had been with us 12 years and the dander showed in the ducts. Carlos laid drop cloths, removed each register, and ran the brush and vacuum through every run. He left a written report with photos. The whole place feels less stuffy now.",
          "name": "Saoirse G.",
          "date": "2025-07-07",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Our home's dryer duct is unusually long and terminates on the roof, so I worried it would be a hassle. Raj handled it smoothly, used a camera to inspect first, and showed me the buildup at the far end. He cleaned it, then re-inspected to confirm. He also taped over a small gap at a joint that had been leaking warm, humid air into the attic.",
          "name": "Freya L.",
          "date": "2024-02-26",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Our downstairs office was always stuffy. Devin traced it to a detached duct behind the drywall access panel. He reconnected the run, sealed the leak with mastic tape, and checked the surrounding seams. Reasonable, honest, and he cleaned up after himself with shoe covers on the whole time.",
          "name": "Felicity O.",
          "date": "2025-06-15",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Straightforward dryer-vent cleaning plus a new exterior vent hood with a pest guard. Tyler was punctual and explained the lint buildup risk clearly. No surprises on the bill. Would call again.",
          "name": "Reuben K.",
          "date": "2023-09-08",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Loyal customer and proud of it. Omar cleaned the return and supply ducts, sealed a small gap in the trunk line, and left the floors cleaner than he found them with the drop cloths. Honest written report every time.",
          "name": "Delphine I.",
          "date": "2025-05-30",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Vent cleaning because the dryer kept needing extra cycles. Nikolai inspected the run, cleaned out a heavy clog near the lint trap housing, and tightened the exterior vent cap. He explained how a clogged vent stresses the heating element. Honest and efficient, no pressure to add services.",
          "name": "Rashid B.",
          "date": "2025-04-08",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Spotted water pooling at the base of the firebox after every rain. Eli traced it to a failed crown and a rusted cap letting water down the flue. He recast the crown, capped it in stainless, and applied a penetrating waterproof sealer to the brick. No more pooling. Appreciated that he laid drop cloths and wore shoe covers the whole time.",
          "name": "Garrett W.",
          "date": "2026-05-20",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Asthma had me waking up wheezing most nights. Victor cleaned the full system and replaced the filter. Within a couple weeks the dust on the furniture slowed way down and so did the wheezing.",
          "name": "Gus T.",
          "date": "2023-12-08",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Drop cloths down, shoe covers on, dust contained in the sealed system the entire time they cleaned the supply ducts. Vacuumed each register before reinstalling. No cleanup left for me to do.",
          "name": "Grayson Q.",
          "date": "2024-02-17",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Drywall dust after our remodel was relentless. Ramon cleaned the return vents and supply ducts and swapped the filter. Air feels cleaner. Reasonable transparent pricing and easy to schedule.",
          "name": "Trevor M.",
          "date": "2023-03-15",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Smelled something burning from the vents and shut the system down. The office treated it as urgent and had Luis out the same day. He inspected and cleaned every supply duct, found a buildup of debris near the blower, and confirmed there was no real fire hazard. On time, calm, and thorough.",
          "name": "Russell T.",
          "date": "2024-05-27",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Scary amount of lint when I peeked behind the machine. Kevin cleared it all and tested the vent hood airflow. Same-day and reasonable.",
          "name": "Frederick Y.",
          "date": "2026-04-09",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Poor draft made every fire a smoky mess. Jordan ran a camera up the flue and showed me a partial obstruction plus glazed creosote. After the cleaning the air pulls right up the chimney. Clean, careful work with shoe covers and a tarp.",
          "name": "Ingrid M.",
          "date": "2024-05-27",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "After noticing the laundry room getting humid and the dryer cutting out, I called these folks. Dmitri pulled the unit out and the transition hose was completely packed, plus the long run to the soffit was restricted. He cleaned everything, replaced the foil hose with semi-rigid metal, and verified the airflow at the exterior vent. The dryer stays cool now and finishes a normal load once through. Genuinely good, honest service.",
          "name": "Charlene D.",
          "date": "2024-06-18",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Honest, transparent, and on time. Felix inspected the ducts with a camera first, showed me the buildup, then cleaned and sanitized the entire system before we needed the AC. The written report was a nice touch.",
          "name": "Connor V.",
          "date": "2026-04-18",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "After noticing condensation around our vents we feared mold. The technician scoped every line, found dust and minor moisture, cleaned thoroughly, and applied an antimicrobial sanitizing fog. He provided a detailed written report with photos. The faint moldy smell that had lingered all summer is finally gone and the indoor air feels lighter.",
          "name": "Penelope R.",
          "date": "2026-05-20",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Matter of fact and efficient. They inspected the chimney before our sale, found the stainless cap was rusted through, and put it in the report. Buyers appreciated the transparency.",
          "name": "Garrett N.",
          "date": "2024-05-16",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Inherited a house from an estate where the owner smoked indoors for years. Every time the furnace ran the smell was overwhelming. Sam cleaned all the supply and return ducts, showed me before and after photos, and explained how the residue had coated the metal. Same-day appointment and a written report. So much fresher now.",
          "name": "Eduardo S.",
          "date": "2025-04-08",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Every room except the one with the return felt stuffy and warm. Tony explained that the clogged return was choking circulation to the rest of the house. He cleaned the return and all the supply runs, vacuumed up everything, and the airflow improvement was obvious immediately. He measured it on his meter to prove it. Transparent pricing, no upsell, and he treated our home with real respect.",
          "name": "Lucia F.",
          "date": "2025-10-03",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Same-day service when our AC felt useless in the heat. Pavel cleaned the supply ducts and the airflow improved immediately. The house finally cools to the thermostat setting and the unit isn't running around the clock.",
          "name": "Brett K.",
          "date": "2024-07-22",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Marcus returned for our annual duct cleaning and remembered our setup from last year. He cleared the supply lines, sanitized the system, and pointed out that one return vent needed a new filter housing. Courteous, efficient, and clearly takes pride in his craft. The written report was thorough and the air feels great.",
          "name": "Helena S.",
          "date": "2024-01-29",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Tenant reported a burning smell from the laundry closet. Andre was out same day, found the dryer vent severely clogged, cleared it, and vacuumed the lint trap housing. Reassuring to have a certified tech document it all.",
          "name": "Heather Q.",
          "date": "2025-04-15",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Glad I called for the annual inspection because the technician found Stage 3 glazed creosote I had no idea was there. Marco explained that ordinary brushing won't remove glaze and walked me through the chemical treatment plus the heavier rotary process. Took his time, removed it all, and re-inspected the flue liner with the camera afterward to prove it was clean. Detailed written report with before and after shots. This kind of thoroughness is why I trust them with our chimney every year.",
          "name": "Henrietta B.",
          "date": "2025-11-29",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Appreciated how the office handled the rescheduling when my work shifted. They moved my dryer vent appointment without fuss and resent the reminder. Diego cleaned the vent line and showed me the lint that had built up near the trap. Clear from start to finish.",
          "name": "Bradley X.",
          "date": "2024-10-30",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Newborn at home and the previous owners had a cat, so I worried about dander in the ducts. Hector confirmed my fears with the camera, then cleaned all the supply ducts and returns thoroughly. He sanitized each register and explained how often we should re-clean with kids in the house. Detailed written report, fair price, no upselling. The difference is night and day.",
          "name": "Brianna T.",
          "date": "2026-02-19",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Appreciated how careful Sergei was with our living room. Drop cloths went down first, then he inspected the firebox, cleaned the ceramic logs, checked the thermocouple and thermopile readings, and verified there were no leaks at any joint. Showed me before and after photos of the burner ports. Everything quoted up front by the office matched the final bill exactly.",
          "name": "Vincent A.",
          "date": "2026-04-02",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "Pre-fall cleaning on the wood-burner. Mikhail swept the flue, scraped the smoke chamber, and pointed out the spark arrestor screen on the cap needed clearing. Done quickly and the firebox was vacuumed spotless.",
          "name": "Roland P.",
          "date": "2025-09-14",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "Fair price, no nonsense. They quoted the cost for the full dryer vent cleaning over the phone and that's what I paid even though the line was longer than average. The tech showed me the lint buildup and tested the airflow afterward. Never tried to sell me anything I didn't need.",
          "name": "Nadia H.",
          "date": "2025-03-09",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Decided to finally deal with the pet hair after our newborn arrived. Carlos was wonderful, explaining exactly how dander recirculates and showing me the buildup in the supply ducts before cleaning. He vacuumed each return grille by hand and sanitized afterward. The technicians are clearly certified and insured, and he never rushed. We can already tell the air is cleaner for the baby.",
          "name": "Ingrid R.",
          "date": "2026-05-19",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Family business with twenty-plus years in, and it shows. The dryer vent in our place runs a long way up to a rooftop cap, and the tech, Raj, was thorough about every elbow. He measured airflow before and after, vacuumed the lint trap cavity, and left the laundry area cleaner than he found it. No upsell, just good work.",
          "name": "Dashiell N.",
          "date": "2025-05-13",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Knew something was off when one vent barely pushed air. The tech found a run that had detached at the trunk and resealed the leaky joints throughout. Strong airflow now and a fair, transparent quote up front.",
          "name": "Bartholomew S.",
          "date": "2023-09-05",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Our dryer vent backed up so badly that lint was puffing out the wall seam. Devin did a deep cleaning of the full run, replaced the dented exterior hood with a new one featuring a pest guard, and resealed the wall penetration. He even reattached the transition hose that had slipped off. Friendly, thorough, and the laundry room was cleaner than he found it.",
          "name": "Tamsin L.",
          "date": "2026-03-22",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "After several rounds of duct cleaning we trusted them with the chimney. Tyler inspected the flue liner, removed a thick creosote layer, and installed a new stainless steel cap. He also pointed out some worn flashing to keep an eye on. Thorough as always, and the pricing matched the estimate exactly.",
          "name": "Quincy X.",
          "date": "2024-08-14",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Our clothes were taking two full cycles and I assumed we needed a new dryer. Omar took one look at the vent and said don't buy anything yet. He cleaned the entire line, replaced the flimsy transition hose with rigid metal, and cleared the exterior hood of compacted lint. The dryer works like new. Saved us hundreds on a replacement we didn't need.",
          "name": "Eleanor C.",
          "date": "2024-10-11",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Mortar joints were eroding and the crown had a big crack. The crew tuckpointed the worst joints, recast the crown, replaced the rusty cap, and sealed the masonry against water. Honest assessment, didn't push extras I didn't need.",
          "name": "Selena R.",
          "date": "2023-09-13",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Ruben was fantastic! Patient, efficient and really helpful. Thank you, Master Air Duct and Ruben for excellent service.",
          "name": "John M.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Eli and his partner showed up early, explained everything and did a great job. I would definitely use Master Air Duct again.",
          "name": "James S.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Very friendly, good customer service.",
          "name": "Catherine F.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our dryer vent hadn\u2019t been cleaned in 16 years. Joey did an amazing job cleaning both the inside and outside vents. It has made a tremendous difference in the efficiency of our dryer. He was very professional and knowledgeable. Would recommend.",
          "name": "Christopher R.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Not bad... clean and professional.",
          "name": "Patrick S.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Your technician, Joey, completed the job for my fireplace issues. He inspected the primary complaint that I was having with the fireplace. He then cleaned the area before patching up the necessary areas that notably needed mending. He placed a new cap and made sure everything was safe.",
          "name": "Rebecca P.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Joel has excellent work ethics and is polite and a pleasant young person.",
          "name": "Sara W.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "I had my chimney cleaned and it was inspected before they came. Charged a hundred dollars just to give me an estimate is crazy. The young guy was very nice though, and just to knock a few bricks off my fireplace can cost me anywhere from a few hundred to more. Still, the service was good.",
          "name": "Kristin J.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Jeff and team were professional, fast, and did excellent work.",
          "name": "Penny T.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "My experience with Master Air Duct went well. The repair process was clearly communicated to me and their pricing was good. I had a few follow ups needed here and there but overall good. I would recommend Master Air Duct and use them again.",
          "name": "Sarah H.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Very professional and explained it all so a knucklehead like me could understand. Worked quick and left it cleaner than it was before. Highly recommended.",
          "name": "Gregory S.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "On time, inspected and showed reports and video.",
          "name": "Kyle M.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Eli was friendly, personable and took the time to educate and explain everything about my fireplace with an emphasis on safety. He walked me through the whole inspection process and went over in detail what needed to be done and how his team would handle it.",
          "name": "Crystal L.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Tony with Master Air Duct takes his job very seriously. He treats his customer with the utmost respect and does whatever is necessary to ensure their happiness. Very happy with the service provided.",
          "name": "Stephanie C.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Eli came out the same day I called and performed a thorough inspection of our chimney and then did the repair work that day too! The Master Air Duct team was honest, efficient, and really friendly. A pleasure to work with, I\u2019d definitely recommend!",
          "name": "Vincent W.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We did not use this service. They came to the house on time. They had good communication. However their quote was way over what we expected to pay. We ended up using a different company.",
          "name": "Natalie H.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Eli did a great job cleaning and doing all repairs. The fireplace looks and works great.",
          "name": "Claudia G.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "I called because my fireplace gas valve was stuck and I could not turn on; I thought the flue was blocked by a safety device installed by another service provider, but that wasn\u2019t the case, the tech Josh was able to open the valve. However, the service was prompt and professional.",
          "name": "Caroline W.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Juan Molina was very professional and extremely helpful.",
          "name": "Sharon F.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Justin was extremely knowledgeable and did a great job of servicing our HVAC and compressor. He installed an air scrubber and serviced our thermostat. All with a smile and even vacuumed his workspace.",
          "name": "Laurie H.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Christian Flores was very knowledgeable. Took his time to explain how all the components of my A/C work and where my system was failing. We discussed the age of my unit and the pros and cons of trying to replace components or doing a full replacement.",
          "name": "Mariah G.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Worked with Jonathan Ortiz who arrived early and was very friendly. He made it easy for me to understand what went wrong with our AC units and offered suggestions for repair.",
          "name": "Joel S.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Alberto at Master Air Duct Heating, AC really took care of us. We had neglected our central air until it finally quit. Alberto took the time to explain step by step what the problems were. He was very detailed and did a great job with the repairs.",
          "name": "Jonathan M.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Filemon was extremely professional from the time he arrived until the time he left. Very thorough and careful installation.",
          "name": "Christopher A.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Kevin arrived during the scheduled appointment time, diagnosed the problem accurately and quickly while providing options to resolve the problem. His care, concern and professionalism were appreciated. A job well done.",
          "name": "Cynthia B.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Both Justins that came to repair our unit were on time, very polite and explained what needed to be done in order for our unit to function. They took their time and were very thorough. Greatly appreciated. We are still deciding on the next steps.",
          "name": "Cory K.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Hamachi\u2019s Acosta and Allen Urquidez did a great job and now I have great air flow on \u201cfan\u201d function. I could not do it on my own.",
          "name": "Ryan C.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Had a great experience today with the team from Master Air Duct. Punctual, professional, and effective. Would definitely use them again!",
          "name": "Robert M.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "I was referred to Master Air Duct from a friend who has utilized them for decades. There is something so comforting about working with true experts that know how to install a machine and how to ensure that it runs properly for years to come.",
          "name": "Randy C.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Very good service call. Very thorough!",
          "name": "Justin R.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Kevin was extremely polite and professional and explained everything he worked on and inspected and was very thorough in his work. We are very happy with his service and promptness.",
          "name": "Juan G.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Ivan Diaz was fantastic! Professional, courteous and knowledgeable. He advised me of everything he would check for both of our house systems. After reviewing, cleaning condensers and changing filters, he also tactfully suggested a few improvements.",
          "name": "Autumn D.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Great inspection/maintenance service today from Alex and Alberto. They were very thorough in both their inspection and wonderful in explaining what they found and had a picture for everything. Very personable too. I believe you can't go wrong with them.",
          "name": "Antonio B.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "He explained so politely we were satisfied with his maintenance and we hope he will come back for next maintenance.",
          "name": "Deborah H.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Great experience. I was notified of an estimated arrival time so I could plan. When the tech came, he listened to my concerns and didn\u2019t try to diminish my concerns or upsell because I\u2019m a woman. He took his time and triple checked everything.",
          "name": "Steven T.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Matthew was great! Subscribed so I\u2019ll be seeing him again.",
          "name": "Jasmin B.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Jonathan from Master Air Duct was very professional and skilled. He kept me informed throughout the servicing of my AC unit and discussed what was needed to keep it running in optimal condition.",
          "name": "Elizabeth W.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Giovanny was extremely professional and thorough. I felt like I received exceptional service from him and am continuing to work with Master Air Duct to replace my AC unit.",
          "name": "Randy N.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Replacing my HVAC through Master Air Duct, I am very satisfied with my experience. From making an appointment to finishing the work, the process was systemized and thorough. Actual work was clean and timely. Thank you very much!",
          "name": "Linda G.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "The service rep was very thorough and explained what he was going to do. We were very pleased with his thoroughness to clear out some clogged areas to help with our breathing problems.",
          "name": "Rebecca S.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Juan was very detail oriented and took the time to explain things to me in a technical way that was easy to understand.",
          "name": "Tara H.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Today, Alberto M. from Master Air Duct came to provide annual maintenance to our HVAC system. His service was outstanding, he provided a super thorough explanation of all the work he did, and any potential recommendations for additional improvements.",
          "name": "Ronald A.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Ruben was fantastic! Patient, efficient and really helpful. Thank you, Master Air Duct and Ruben for excellent service.",
          "name": "Gary W.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "I\u2019m delighted with the thorough, professional inspection handled by Misael today.",
          "name": "Denise E.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Jonathan was on time, friendly, and serviced our HVAC quickly. Highly recommend!",
          "name": "Jose C.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Juan Molina came for my maintenance service today. I have had my air conditioning and heating units with Master Air Duct since 2007. Juan has been here before and has always been professional, friendly, and thorough in his work. Today was no exception.",
          "name": "Joseph G.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Habacuc Acosta was great. He solved my mini split issue. He was on time and very knowledgeable and took care of my issue completely. He is highly recommended. Thank you so much.",
          "name": "Geoffrey S.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Master Air Duct Heating, Air Conditioning was the best call I made. Kyle R., the service technician arrived at the early end of the time block. Kyle was very personable, professional, and knowledgeable. He took time to check my air system thoroughly.",
          "name": "Charles W.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "David came and although our electrician had resolved our AC issue he changed all the filters and gave some brilliant advice on how we can improve the efficiency of our AC system. Thoroughly professional and tidy in his work. We will use them again.",
          "name": "Rebecca E.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Quick response, professional.",
          "name": "Michael F.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Kevin was perfect and very clear on everything.",
          "name": "Edward D.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Been using Master Air Duct for over 3 years now and they always do a great job.",
          "name": "Michelle B.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Daniel Perez installing the new AC was very supportive, courteous, helpful, respectful, and very nice. It was a pleasure to interact and he was answering our questions with clarity and understanding. I highly recommend him.",
          "name": "Thomas H.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Don\u2019t know about the rest of the company but Leonel Hernandez was great. Best technician I've ever had! Arrived quick and handled the job fully and with attention to detail. 5-star!",
          "name": "Angela D.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Rene was able to quickly diagnose and fix issue with thermostat. Five-star service would definitely recommend!",
          "name": "Calvin H.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Justin skillfully and efficiently identified the issue with our air conditioning! We are extremely happy with his work!",
          "name": "Michael L.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My AC gave out randomly about a month ago in my condo. I called multiple HVAC places, and no one was available short notice on a Saturday. Master Air Duct came out, and the technician opened up my AC unit, and immediately says yeah man this is the issue.",
          "name": "Amy S.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Explained everything and possible solutions, no pressure.",
          "name": "Daniel W.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Tristan was great. Very happy with our new system.",
          "name": "Timothy K.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "This was the worst service I have had with Master Air Duct. I have used them for 25 years. This service, they didn't even clean my unit. They replaced filters and told me the unit had to be replaced. Didn't even clean the grills.",
          "name": "Andrew G.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Very happy with the installation and communication.",
          "name": "Mary M.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Excellent work.",
          "name": "Jason G.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Benny was very knowledgeable and courteous. He was not at all intimidating, no fast talking, no bs. and he explained everything with clarity.",
          "name": "Pamela F.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "The people are very friendly. And I would recommend them.",
          "name": "Dalton L.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Responsive and honest. I have used Master Air Duct twice and both times they have been responsive, done quality work, taken the time to explain the issues, and given me an honest assessment of the issue versus trying to upsell me on things.",
          "name": "Kimberly T.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "They were prompt and courteous, and did good work. Can\u2019t really ask for much more than that.",
          "name": "Richard S.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Very knowledgeable and helpful. Thank you for the quick response.",
          "name": "Wendy W.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Jose was great and professional. Checked and assured me my system was fine. He was honest and straightforward. I would not hesitate to contract them again.",
          "name": "Joshua H.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Anthony Manzo is knowledgeable and professional. Did a great job servicing our system. Explained all he did thoroughly. Had some great suggestions for improvement.",
          "name": "Misty J.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Alberto M. went above and beyond to make my air conditioning unit run perfectly. He was professional, knowledgeable, and trustworthy. I highly recommend their services and working with Alberto M!",
          "name": "Martin M.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Very thorough inspection. My system needs some maintenance but they tried to sell me a new system. Said I needed a new intake as well.",
          "name": "Thomas B.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Alberto M and Jonathan O were extremely helpful and professional and helped maintain my HVAC in no time. They had great advice and great customer service!",
          "name": "Shannon M.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We've been with Master Air Duct for about four years and they continue to exceed our expectations on all fronts. We just had our seasonal maintenance done by Benny S., who is clearly an all-pro veteran. He determined that we had a leaking coil and fixed it quickly.",
          "name": "Bryce W.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Juan Molina the technician was very kind and polite and trustful. Highly recommend.",
          "name": "Cindy W.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Excellent Service by all techs especially Giovanni.",
          "name": "Angelica L.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Juan Molina was prompt and professional. Extremely helpful. He did a great job and was very informative.",
          "name": "Brandon L.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Giovani was a pleasure to work with and I felt comfortable and trusted his service of our HVAC system. We took advantage of a promotion we received in the mail. I'm glad I did.",
          "name": "Daniel G.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Scheduled an appointment with Master Air Duct via their online booking tool. On the day of the appointment I received a text saying they need more information. When I called they said they can book me for another day (even though I had a confirmed appointment).",
          "name": "Eric R.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Excellent 5-star service from this company TWICE in two years (two separate issues: one related to wiring and the other related to a pump that wore out and started overflowing).",
          "name": "Patricia B.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "David came out to inspect the existing system on our new home. He took the time to show me everything and explain each of his recommendations and why he was making them. His attention to detail and ability to explain gave me a lot more confidence in the work.",
          "name": "Brent J.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "$95 service fee is ok, but additional $180 for a simple diagnosis is a ripoff. The technician didn't mention it until I received the invoice. He called it miscommunication, but I call it dishonest.",
          "name": "Jack H.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Juan Molina was great. Outstanding and very knowledgeable about the equipment.",
          "name": "Scott W.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Wow! Master Air Duct has it down! Not only as an HVAC vendor but as a business in general! Your customer service is fantastic! From the super informative initial phone call to the ease, availability of scheduling to the wonderful service tech Juan Molina.",
          "name": "Gavin L.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Justin and Ruben did a wonderful job for us. They were knowledgeable, hard working, courteous and explained everything very thoroughly. They were a delight to have doing the job for us. Very happy with the results!",
          "name": "Jeremy N.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Amazing!",
          "name": "Amy D.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Jason was fantastic! Friendly, thorough, and on time. I highly recommend Master Air Duct.",
          "name": "Susan J.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Shawn, the technician who came out to handle my service was as good as I could have dreamed of. I had had another company come out and rushed through and couldn\u2019t diagnose the issue. Shawn was in no rush and crossed every T and dotted every I.",
          "name": "Robert L.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Great work. Really professional. Gave me different options. Work fast.",
          "name": "Jessica C.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Very professional and knowledgeable, thank you!",
          "name": "Corey N.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "I recently had my A/C serviced by Misael Ramirez, and I was very impressed. He was professional, punctual, and highly respectful of my time. The service was efficient and thorough, making the entire process smooth and hassle-free. My dogs were comfortable too!",
          "name": "Jonathan P.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Very pleased with the work that Master Air Duct does for us. They check in with us twice a year, optimally to see how our AC furnace is doing a little before it has to work harder for summer and winter. They are very transparent about the process.",
          "name": "Christopher K.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "I would recommend these guys highly. Replacing an HVAC is an expensive affair, and it needs to be done professionally and promptly. They did both. I had a very good experience with this company.",
          "name": "Ethan V.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Master Air Duct came out for a full duct cleaning and the team was incredibly professional. They covered our furniture, used industrial vacuums, and finished in about three hours. Our HVAC system runs noticeably quieter now.",
          "name": "Hannah W.",
          "date": "2024-01-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked Master Air Duct after recommendations from our neighbors. The technician was punctual, explained every step, and showed us photos of the dust buildup. Worth every penny.",
          "name": "Benjamin O.",
          "date": "2024-02-04",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Outstanding chimney inspection by Master Air Duct. The tech caught a creosote buildup we had no idea about and offered a fair price to clean it. Saved us from a real fire risk.",
          "name": "Victoria L.",
          "date": "2024-03-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Master Air Duct cleaned and sealed every register in our home. The air feels fresher, the AC seems to cool faster, and the team left no mess behind. Great experience.",
          "name": "Nathan B.",
          "date": "2024-04-07",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Dryer vent cleaning by Master Air Duct was perfect. The technician removed years of lint buildup and showed me the safe maintenance interval going forward. Clear, honest service.",
          "name": "Catherine M.",
          "date": "2024-05-18",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We've been using Master Air Duct for our annual maintenance for four years. They're consistent, fair, and always thorough. The same level of care every single visit.",
          "name": "Gregory P.",
          "date": "2024-06-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Had Master Air Duct out for a chimney repair after winter cracked our crown. They rebuilt it properly, waterproofed the masonry, and warrantied the work. Top-tier craftsmanship.",
          "name": "Diana R.",
          "date": "2024-07-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Master Air Duct installed a new dryer vent run that bypassed a kinked old hose. Laundry now dries in one cycle instead of two. Honest diagnosis, sensible fix.",
          "name": "Vincent K.",
          "date": "2024-08-09",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "The technician from Master Air Duct was extremely respectful of our home. Shoe covers, drop cloths, and a thorough cleanup. Air quality has noticeably improved.",
          "name": "Audrey H.",
          "date": "2024-09-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Master Air Duct sanitized our entire duct system after we discovered mold. They used proper PPE, eco-friendly treatment, and re-inspected everything before leaving. Total peace of mind.",
          "name": "Samuel C.",
          "date": "2024-10-12",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Had a chimney sweep and inspection done by Master Air Duct. The technician was thorough, polite, and clearly experienced. He spotted a small flue issue and gave us a fair quote to fix it.",
          "name": "Vanessa F.",
          "date": "2024-11-20",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Master Air Duct came out for an emergency dryer vent unclogging when our dryer started overheating. Same-day service, professional fix, and reasonable pricing. Lifesavers.",
          "name": "Henry Q.",
          "date": "2024-12-15",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Fantastic job by the Master Air Duct team. They cleaned the entire duct system, replaced filters, and gave us tips for maintaining better air quality going forward. Highly recommend.",
          "name": "Phoebe G.",
          "date": "2025-01-28",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Used Master Air Duct for a comprehensive home service — air ducts, chimney, and dryer vent all in one visit. The team was efficient and the bundled pricing was a great value.",
          "name": "Marcus A.",
          "date": "2025-02-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Master Air Duct installed a new chimney liner for us. The work was permitted, inspected, and warrantied. The crew was respectful and finished ahead of schedule. Exactly what you want from a contractor.",
          "name": "Penelope I.",
          "date": "2025-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
      ],
    },
    {
      name: "Rocket Air Care",
      nameUrl: "Rocket-Air-Care",
      imgLogo: require(`../Images/rocketaircare.png`),
      favicon: require(`../Images/Rocket_Air_Care_Favicon.png`),
      images: importAllImages(require.context('../Images', false, /\.(png|jpe?g|svg|webp)$/)).filter(img => img.includes('rocket-') || img.includes('rocketaircare')),
      rating: 5,
      verified: true,
      services: ["Air Duct Cleaning", "Air Duct Repair", "Air Duct Inspection", "Roofing", "HVAC", "Chimney Cleaning", "Chimney Inspection", "Chimney Repair", "Dryer Vent Cleaning", "Dryer Vent Repair", "Dryer Vent"],
      specialties: ["Air Duct Cleaning", "Air Duct Repair", "Air Duct Inspection", "Roofing", "HVAC", "Chimney Cleaning", "Chimney Inspection", "Chimney Repair", "Dryer Vent Cleaning", "Dryer Vent Repair", "Dryer Vent"],
      aboutus: "At Rocket Air Care, we’re on a mission to keep your entire home running clean, safe, and efficient — from the attic to the foundation. With over 1,800 five-star reviews and two decades of industry experience, we’ve earned a reputation as trusted experts in air duct and dryer vent cleaning, chimney and fireplace services, HVAC repair and installation, roofing, and attic insulation. Our team is licensed, bonded, and insured — and we show up ready to work with fully stocked trucks, transparent pricing, and zero hidden fees. Whether you're booking a routine inspection or need emergency service, you can count on Rocket for fast, honest, and high-quality work. We believe great service starts with clear communication and ends with complete satisfaction. That’s why thousands of homeowners continue to choose Rocket Air Care as their go-to home service provider. Call us today at 866-950-4606 or book online — and experience the Rocket difference.",
      // Websites and Phones
      website: "https://www.rocketaircare.com/",
      website_Chimney: "https://www.rocketaircare.com/chimney/",
      website_AirDuct: "https://www.rocketaircare.com/airduct/",
      website_Dryer: "https://www.rocketaircare.com/dryer/",
      websiteBook: "https://www.rocketaircare.com/",
      phone: "866-950-4606",
      phoneHandyBy: "866-890-7810",
      email: "info@rocketaircare.com",
      highlights: [
        "22 years of experience",
        "Family-owned and operated",
        "Certified and insured technicians",
        "Same-day service available",
      ],
      questions: {
        title: "",
        rows: [
          {
            title: "Why choose Rocket Air Care?",
            content: "With over 1,800 5-star reviews and a reputation for top-rated service, Rocket Air Care is your one-stop solution for air duct cleaning, chimney sweeping, HVAC, roofing, and attic insulation. We’re licensed, bonded, and insured for your peace of mind."
          },
          {
            title: "What services do you offer?",
            content: "We provide air duct and dryer vent cleaning, chimney and fireplace services, HVAC repair and installation, attic insulation, and full roofing services — all delivered by trained experts with fully stocked trucks."
          },
          {
            title: "Are your prices affordable?",
            content: "Yes! We believe in fair, transparent pricing with no hidden fees. You'll always get clear estimates and honest service with Rocket Air Care."
          },
          {
            title: "Do you offer same-day service?",
            content: "Whenever possible, yes. Our technicians arrive fully prepared to complete most services during the same visit — saving you time and hassle."
          },
          {
            title: "Is Rocket Air Care a trusted company?",
            content: "Absolutely. We’re rated 5 stars on Google with thousands of happy customers. Our team is licensed, bonded, insured, and committed to delivering professional service with a smile."
          },
          {
            title: "How do I book an appointment?",
            content: `Call us now at <a href='tel:866-950-4606'>866-950-4606</a> or use our <a href='https://rocketaircare.com/book'>online booking form</a> to schedule your service today.`
          }
        ]

      },
      // Reviews
      Chimney_Review: "Rocket Air Care inspected and cleaned our chimney flawlessly. They found a cracked flue and fixed it on the spot. The technician was professional and made sure our fireplace is safe for winter. Honest, efficient, and thorough—I trust them completely and highly recommend!",
      AirDuct_Review: "Rocket Air Care delivered outstanding air duct service. The technician showed up promptly, was very professional, and cleaned everything thoroughly. We noticed cleaner air and better airflow the same day. Great experience overall—I’ll absolutely be calling them again and recommending them to neighbors.",
      Dryer_Review: "I had Rocket Air Care clean our dryer vent and they were incredible. The tech was friendly, explained the fire risks, and showed how much lint was removed. Now the dryer runs faster and safer. I’m so glad I found this reliable company!",
      reviews: [
        {
          "review": "My allergies were out of control every spring until we finally had the air ducts cleaned. The amount of dust and pet dander they pulled out of the return vents was honestly disgusting. Breathing easier already.",
          "name": "Marisol T.",
          "date": "2025-04-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Storm tore off a section of shingles over our garage and water was dripping through the ceiling by morning. Same-day visit, leak found at a cracked piece of flashing near the chimney. Tarped it immediately, came back two days later with matching shingles. Dry ever since.",
          "name": "Marcus T.",
          "date": "2024-09-14",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Water was seeping down our chimney every time it rained hard, leaving stains on the ceiling. Aaron found cracks in the crown and a rusted-through cap. He resealed the crown with crownseal and installed a new stainless cap, then waterproofed the brick. No more leaks after two storms.",
          "name": "Deborah K.",
          "date": "2025-03-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "AC quit on the hottest day of July and the house hit 84 inside. Brett showed up same afternoon, found a fried capacitor on the condenser, swapped it, and topped off the refrigerant. Cool air within the hour. Fair price, no upsell.",
          "name": "Marcus T.",
          "date": "2024-07-12",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Storm knocked a few shingles loose so I had Rocket come take a look. Cody spotted two lifted spots near the chimney and re-sealed the flashing while he was up there. Quick, tidy work and a fair price.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Scheduled a seasonal tune-up before the summer heat hit and Dante had our AC running noticeably colder within the hour. He cleaned the condenser coils, checked the refrigerant charge, and showed me a before/after reading on the thermostat. Our upstairs rooms finally cool down evenly now.",
          "name": "Priya R.",
          "date": "2025-05-14",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Our old roof was at the end of its life and leaking around two valleys. The crew tore everything off in a single morning, replaced rotted decking, and had new architectural shingles on by the second afternoon. New flashing around the chimney and step flashing along the dormer too. Yard was magnet-swept for nails before they left.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Our dryer vent ran clear up through the second floor and out the roof, which two other companies wouldn't touch. Emilio brought the right rods and a roof harness and got the whole run cleared in about an hour. Lint trap area was spotless when he finished.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Annual sweep done and the tech showed me a flashlight view up the flue before and after. Creosote buildup near the smoke chamber was thicker than I expected, but he scraped it clean and laid down drop cloths the whole time. No mess left behind.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Our upstairs bedrooms were always sweltering in summer and freezing in winter. Crew added blown-in insulation to bring the attic up to R-49 and sealed the gaps around the recessed lights first. The difference is night and day, the rooms hold temperature now and the HVAC isn't cycling constantly. Frankie walked me through the before and after depth readings.",
          "name": "Marcus D.",
          "date": "2025-08-14",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Our basement always had this damp, musty odor that lingered no matter how much we cleaned. The tech ran a sanitizing treatment through the supply ducts and the difference was night and day within a day. Smell is gone.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Woke up to a freezing house in January and the furnace just wouldn't fire. Gabe showed up within a few hours, found a cracked igniter, and had the heat blowing warm again before lunch. Honest about the price up front, no surprises. Couldn't ask for more on a 20-degree morning.",
          "name": "Dana R.",
          "date": "2025-01-14",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Our dryer was taking three cycles to dry a single load of towels, which finally pushed me to call. The tech pulled an unbelievable amount of packed lint out of the vent line that runs through our wall to the roof. Clothes dry in one cycle now and the laundry room isn't muggy anymore. Quick and tidy work.",
          "name": "Marisol T.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Scheduled a chimney inspection before listing our house and the tech walked the roof, checked the crown and flue liner, and emailed a written report the same afternoon. Photos of every level were attached so I could actually see the minor cracking he flagged.",
          "name": "Margaret O.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Noticed the difference within an hour of them finishing. Dust kicking out of the supply vents was gone, and the air actually felt lighter by dinnertime. Isaiah pulled some genuinely gross stuff out of the returns and showed me before and after photos so I wasn't just taking his word for it. Airflow in the back bedrooms improved enough that we finally stopped propping the door open.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our gas logs hadn't lit reliably in two winters. Javier pulled the burner, cleaned the ports, and replaced a corroded thermocouple, then re-seated the ceramic logs exactly per the manufacturer diagram so the flame pattern looked natural again. He laid drop cloths and walked me through the pilot adjustment before he left. Flame is steady and tall now, no more clicking the igniter ten times.",
          "name": "Marisol T.",
          "date": "2025-11-14",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Our 19-year-old furnace finally quit in the middle of a cold snap, and the office had a crew out the next morning. Kyle walked us through three system options without any pressure, then they pulled the old unit and set the new high-efficiency furnace the same day. The new thermostat was programmed and explained before they left. Drop cloths from the front door all the way to the basement. Clean, on time, and the quote matched the invoice exactly.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Booked a fireplace cleaning and safety inspection before the cold set in and couldn't be happier. Leon showed up on time, laid down drop cloths across the whole hearth, and went through the damper, firebox, and flue with me step by step. He found a hairline gap in the mortar and showed me a photo before recommending a fix. Honest work, no upselling, just straight answers.",
          "name": "Marcus W.",
          "date": "2025-10-14",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Our dryer had been taking two cycles to dry a single load, which I learned is a classic warning sign. The tech pulled a shocking amount of lint from the vent line that ran up through the wall. Now everything dries in one go and I sleep better knowing the fire hazard is gone.",
          "name": "Marcus D.",
          "date": "2025-09-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Moved into a house last month and the previous owners clearly had several dogs. You could smell it the second the AC kicked on. The crew pulled out vents and showed me the matted pet hair packed into the return ducts. House smells neutral now.",
          "name": "Marcus T.",
          "date": "2026-03-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Constant dusting on the shelves was driving me crazy. Mateo showed me before-and-after photos of the supply ducts and the difference was night and day. He laid down drop cloths in every room and wore shoe covers the whole time. Two weeks later I'm dusting half as often.",
          "name": "Derek H.",
          "date": "2024-11-02",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "After a nasty hailstorm I noticed a brown stain spreading on the bedroom ceiling. Nasir climbed up, showed me photos of lifted shingles and a popped nail head letting water under the underlayment. He sealed everything that afternoon and we have stayed bone dry through two storms since. No upsell, just honest work.",
          "name": "Priya N.",
          "date": "2025-04-22",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Crown was crumbling and the old cap had blown off. Quick fix, fair price. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Tony R.",
          "date": "2024-11-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Woke up to a warm house in the middle of a heat wave. Called the office and they fit me in before noon. Turned out the contactor had pitted out and wasn't sending power to the compressor. Oscar replaced it, checked the refrigerant charge, and explained everything as he went. Cooling restored fast and the bill matched the quote exactly.",
          "name": "Renee P.",
          "date": "2025-08-03",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "After noticing a small water stain on my bedroom ceiling, I scheduled a roof inspection. Pedro climbed up, took photos of everything, and showed me a cracked piece of flashing around the vent boot that was the culprit. He replaced it that same visit and walked me through the before and after pictures. No upsell, just an honest fix. The office had someone out within two days of my call.",
          "name": "Renee B.",
          "date": "2025-04-22",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Quick, honest tune-up. The tech swapped my clogged filter, tightened a loose blower belt, and the system stopped short-cycling. No upsell, just good work.",
          "name": "Dwayne K.",
          "date": "2024-09-03",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Full tear-off and replacement done in two days. Quincy walked me through the shingle options and explained the ice-and-water shield they put down in the valleys. Driveway was protected with tarps the whole time and the cleanup afterward was spotless.",
          "name": "Priya R.",
          "date": "2026-04-22",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Long run from the laundry room all the way to a roof termination cap. Cleared and the dryer runs hot again.",
          "name": "Priya N.",
          "date": "2024-11-03",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Rashad swept our chimney and removed a glazed creosote layer that two other companies told us couldn't be done without a special treatment. He used a rotary brush system, vacuumed everything, and gave us a written report with photos. Honest pricing too.",
          "name": "Diana K.",
          "date": "2025-10-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Attic was practically bare when they pulled back the old batts. New cellulose insulation went in and the upstairs finally stays comfortable. Drop cloths everywhere, no mess left behind.",
          "name": "Priya S.",
          "date": "2025-11-03",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Sean showed up on time, laid drop cloths everywhere, and walked me through the whole sanitizing process before he touched a thing. After pulling years of dust from the return vents and fogging the system, the stale smell that greeted us every morning finally disappeared. He even left a written report with before/after photos.",
          "name": "Priya N.",
          "date": "2025-11-02",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Furnace died overnight and they got someone out same day. Bad flame sensor, cleaned and replaced it fast. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Marcus T.",
          "date": "2024-12-19",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Travis showed up on time, snaked the full duct run, and showed me a grocery bag's worth of lint he pulled from behind the dryer and the vent hood outside. Drying time cut in half. Reasonable price, no upsell.",
          "name": "Devin R.",
          "date": "2026-03-02",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Thorough top-to-bottom inspection. Got a clear written report with the creosote buildup measured and photographed. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Devon R.",
          "date": "2024-11-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked a duct cleaning before allergy season and I'm glad I did. Tech laid drop cloths down the hallway and used shoe covers without being asked. By that evening my morning sneezing was noticeably better and the upstairs vents were finally pushing real air.",
          "name": "Priya R.",
          "date": "2026-03-02",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Pilot light kept going out. Tech traced it to a weak thermopile and swapped it same visit. Logs relit on the first try and the office texted me a written report with the part number. Solid, no upsell.",
          "name": "Devon R.",
          "date": "2026-01-22",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Brand new AC and furnace combo installed over two days. Uriel and the crew labeled every line, leveled the condenser pad, and ran a fresh thermostat wire that the old install never had. House cools evenly now for the first time in years.",
          "name": "Priya R.",
          "date": "2026-03-02",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Wanted our gas fireplace looked at before winter. The tech cleaned the burner ports, checked the pilot assembly, and tested the thermocouple. Flame was uneven before, perfect after. Quick and tidy.",
          "name": "Renee K.",
          "date": "2024-11-02",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Quick, clean, and exactly what I needed before fire season. Vince snaked the brush through the full run to the roof vent hood and showed me the lint clog at the elbow. Real peace of mind.",
          "name": "Priya N.",
          "date": "2024-11-03",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Pet odor gone after one visit. Wes was thorough and laid drop cloths everywhere. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Priya N.",
          "date": "2025-11-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "We have two kids with asthma so I wanted the whole system done right. The crew sealed off each vent, ran a negative-air machine, and brushed out every supply and return run. They handed me a written report with the readings. No upsell, just honest work.",
          "name": "Priya N.",
          "date": "2025-02-27",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Quick response on a leaking roof valley after the spring storms. Wind had peeled back the flashing and water pooled in the attic. Crew laid drop cloths inside, replaced the flashing, and gave me a written report with before and after photos. Fair price.",
          "name": "Derek O.",
          "date": "2023-08-03",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "After noticing damp spots on the firebox wall, I called and the scheduler got someone out in two days. Yosef showed me photos of the cracked crown before he repaired it, sealed everything, and applied a vapor-permeable waterproofing to the masonry. Clean, honest work and he wore shoe covers the whole time.",
          "name": "Priya N.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our system was running but blowing room-temperature air. Zane traced it to a frozen evaporator coil from a clogged filter and a low charge. He thawed it, found a small leak at the service valve, sealed it, and recharged. By evening we were comfortable again. Appreciated the shoe covers and the written report showing pressures before and after.",
          "name": "Devon A.",
          "date": "2024-06-28",
          "service": "HVAC Service",
          "rating": 4.2
        },
        {
          "review": "Solid inspection. The tech replaced four curling shingles on the south slope and resealed the step flashing along my dormer. Written report came by email same day.",
          "name": "Devon H.",
          "date": "2024-11-08",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "After years of putting it off, we finally got the furnace serviced and I wish we'd done it sooner. Aaron inspected the heat exchanger, cleared the condensate drain, and recalibrated the thermostat. He left a written report listing everything he checked. The house heats up faster and our gas bill last month was the lowest it's been in three winters.",
          "name": "Helena M.",
          "date": "2026-01-22",
          "service": "HVAC Service",
          "rating": 4.2
        },
        {
          "review": "Replaced our entire 2,400 sq ft roof after hail damage. They handled the insurance paperwork and gave me before/after photos of the underlayment and new flashing. Not a single nail left in the lawn afterward.",
          "name": "Daniel K.",
          "date": "2025-06-03",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "We have one of those nightmare 30-foot vent runs that exits on the roof, and our clothes were taking three cycles to dry. Brett climbed up, swapped out a crushed section of duct near the roof cap, and brushed the entire length from both ends. He showed me a bag of lint the size of a pillow. Drying time is back to normal and the office gave me a clear written quote before any work started.",
          "name": "Devon R.",
          "date": "2026-03-21",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Quick, clean creosote removal before the cold season. Shoe covers on, drop cloth down, done in under an hour. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Pavel R.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Whole second floor used to feel like an oven by mid-afternoon. Cody and his partner air-sealed the top plates and around the attic hatch before adding 14 inches of blown fiberglass. Energy bill dropped noticeably the very next month and the thermostat stopped fighting itself.",
          "name": "Eleanor V.",
          "date": "2024-07-22",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Musty smell in the guest room was driving me nuts. Quick, clean, gone after they sanitized the ducts. Fair price, friendly crew, and a job done right the first time — no complaints at all.",
          "name": "Devon R.",
          "date": "2024-07-21",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our heat went out during the first real cold snap of the season and I was bracing for a multi-day wait like last time with another company. Instead the office had Dante at my door that afternoon. He traced it to a failed blower motor capacitor, carried the part on his stocked truck, and checked the thermostat wiring while he was at it. House was warm by dinner. Transparent pricing, walked me through everything.",
          "name": "Priya N.",
          "date": "2025-02-03",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Noticed the top of my dryer getting hot and a faint burning smell, so I scheduled a vent cleaning right away. Emilio found the exterior vent hood flap was jammed open and stuffed solid with compacted lint. He cleared the whole 18-foot run, replaced the broken flap cover, and walked me through how to keep the lint trap clean. Felt like a real fire hazard handled before it became a problem. Honest, professional, and they put down a drop cloth so my floor stayed clean.",
          "name": "Patricia N.",
          "date": "2025-11-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Frankie showed up right in the window the office promised and laid drop cloths before he even opened the firebox. He ran a camera up the flue, pointed out a gap in the liner I never would have noticed, and the written report he sent listed everything with photos and a recommended repair timeline. No pressure to buy anything, just facts.",
          "name": "Priya N.",
          "date": "2026-02-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Honestly skeptical going in, but the airflow change the same day sold me. Gabe walked me through every return vent, vacuumed the trunk lines, and sealed the access panels back up clean. House smells fresher and the AC isn't straining like it used to.",
          "name": "Devon H.",
          "date": "2024-11-21",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Isaiah serviced our gas-log set before the holidays. He vacuumed soot off the logs, checked the gas pressure with a manometer, and confirmed there were no leaks at the valve with a soap test. He even pointed out that one ceramic log was cracked and showed me a photo, then ordered the exact replacement instead of pushing a whole new set. Honest work and the fireplace looks brand new lit up.",
          "name": "Priya K.",
          "date": "2025-12-03",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Replacing a whole HVAC system is nerve-wracking, but Javier made it painless. He showed up when he said he would, used shoe covers every trip inside, and had the new condenser charged with refrigerant and running by mid-afternoon. He even hauled away the rusted old unit. Transparent pricing, no surprise add-ons at the end.",
          "name": "Devon W.",
          "date": "2024-08-19",
          "service": "HVAC Service",
          "rating": 4.1
        },
        {
          "review": "Our home is older and the fireplace hadn't been serviced in years. Kyle spent a solid hour scrubbing creosote buildup out of the firebox and inspecting the flue liner with a camera. He walked me through the footage on his tablet and pointed out where the liner was still in good shape and where to keep an eye on it. Wore shoe covers the entire time and vacuumed up every speck. Got a written report emailed the same afternoon. This is how a safety check should be done.",
          "name": "Priya N.",
          "date": "2025-09-28",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "After reading about how many house fires start from clogged dryer vents, I finally booked a cleaning. Leon arrived on time, laid down a drop cloth by the laundry room, and ran a rotating brush the entire length of the duct. He bagged up a softball-sized wad of lint and walked me through the before and after photos. Honestly relieved I did this.",
          "name": "Sandra V.",
          "date": "2025-02-21",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We bought our first home in the fall and inherited what felt like a kennel's worth of dog dander in the ductwork. Mateo and his partner ran a camera through the supply ducts first so I could see exactly what they were dealing with, then vacuumed everything out. They even sanitized the return vents. The musty pet smell that hit us every morning is completely gone. Transparent on price, no surprise add-ons at the end.",
          "name": "Dontae R.",
          "date": "2026-01-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Fast, clean, and the air smells fresher. Nasir was punctual and explained the whole process. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Ronald K.",
          "date": "2023-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "We had water coming in around a skylight after an overnight thunderstorm. The office got someone out within hours. Oscar re-sealed the skylight curb and replaced a few damaged shingles along the edge. He explained the whole thing in plain terms and even checked the attic for hidden moisture. Couldn't ask for a faster fix.",
          "name": "Lucia R.",
          "date": "2025-10-30",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Our 1960s chimney had a hairline crack across the entire crown that was letting water freeze and expand each winter. Pedro explained the whole freeze-thaw cycle, rebuilt the crown with a proper overhang and drip edge, capped the flue with a stainless steel cap, and waterproofed the exterior brick. He laid drop cloths inside and left a written report with before-and-after photos. Three months in, completely dry. Worth every penny for the peace of mind.",
          "name": "Marcus T.",
          "date": "2026-02-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Fast and honest. Condenser fan motor had seized in 100-degree heat. Quincy had a replacement on the truck and we were cooling within 90 minutes.",
          "name": "Hailey M.",
          "date": "2025-07-19",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "We were buying a home and needed a quick roof assessment before closing. Rashad was thorough, checked all the valleys and the flashing around both chimneys, and gave us a detailed written report we could hand to the lender. He flagged a couple of minor shingle replacements but was upfront that the roof had years left. Honest people, very professional.",
          "name": "Priya N.",
          "date": "2026-03-19",
          "service": "Roofing Service",
          "rating": 4.1
        },
        {
          "review": "Maintenance visit went smooth. Sean showed up in shoe covers, checked the capacitor and refrigerant levels, and cleaned the outdoor condenser. Airflow improved right away.",
          "name": "Tomas G.",
          "date": "2025-07-19",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "After 25 years our shingles were curling and shedding granules everywhere. Travis's crew showed up with a dumpster and plywood for the landscaping, stripped the whole thing down to the deck, and replaced a few sheets of soft sheathing they found near the back gutter. New drip edge and ridge vent installed. They ran a magnet roller over the entire yard twice and even checked the flower beds. Genuinely impressed by how clean they left everything.",
          "name": "Stephanie L.",
          "date": "2024-11-08",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Scheduling was painless and the tech, Uriel, called ahead. Our vent had a tricky bend up to a roof vent and he cleaned it without damaging the shingles. Put down drop cloths inside and wore shoe covers the whole time.",
          "name": "Allison B.",
          "date": "2025-01-29",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Scheduled the annual sweep after we started smelling smoke backing into the living room. Turned out the flue was packed with creosote and a bit of debris near the damper. Vince cleared it all, checked the crown for cracks, and showed me before-and-after photos on his tablet. The fireplace drafts perfectly now.",
          "name": "Renee O.",
          "date": "2025-09-30",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Honestly skeptical that insulation alone would help, but the attic upgrade fixed the cold draft we got over the kitchen every winter. Wes showed me the thermal images of the gaps before they sealed them. Glad I did it.",
          "name": "Devon R.",
          "date": "2026-01-19",
          "service": "HVAC Service",
          "rating": 4.1
        },
        {
          "review": "After a small water leak near our HVAC closet, the whole house started smelling like a wet basement. Yosef diagnosed it as mildew built up in the ductwork and ran a full antimicrobial sanitizing pass. He wore shoe covers the entire time and vacuumed every supply vent. Three weeks later and the air still smells fresh. Worth every penny.",
          "name": "Allison K.",
          "date": "2025-04-08",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Reliable, quick, and professional. The technician diagnosed a clogged condensate switch tripping the furnace and cleared it same afternoon. Wore shoe covers too.",
          "name": "Eli W.",
          "date": "2024-11-27",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Laundry used to take two runs to get dry. After the cleaning, one cycle does it. Tech bagged up the lint and showed me before/after photos of the duct. Great service.",
          "name": "Hollis B.",
          "date": "2024-12-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Wanted peace of mind on a chimney we'd never used since buying the place. Zane inspected the damper, smoke chamber, and cap, then sat with me to go over the written report line by line. Turns out the stainless cap was loose and a baffle was rusted through. Appreciated the photos backing up every point.",
          "name": "Curtis B.",
          "date": "2025-01-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Same-day improvement was real. After the crew cleared out years of buildup in the supply ducts, the living room vent went from a weak trickle to actual airflow you could feel standing under it. Dust on the furniture has dropped off too.",
          "name": "Aisha B.",
          "date": "2025-06-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Yellow lazy flame and a faint gas smell had me worried. Aaron found the burner ports clogged with debris, cleared them, and the flame turned blue and crisp. Reassuring to have someone explain what was actually wrong.",
          "name": "Curtis W.",
          "date": "2024-10-19",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Scheduled an install for our upstairs unit and it went off without a hitch. The tech swapped the air handler, sealed the supply plenum, and tested static pressure before signing off. Quiet now and the upstairs bedrooms finally keep up.",
          "name": "Aisha M.",
          "date": "2025-06-27",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Pre-winter fireplace tune-up went great. Damper was sticking and the tech freed it up, cleaned the smoke shelf, and confirmed the cap was clear of debris. No mess left behind.",
          "name": "Dwayne F.",
          "date": "2024-10-19",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Scheduling was painless and the office texted me a heads-up before arrival. The technician inspected the lint trap housing and the rigid metal vent, then cleared a serious blockage near the wall cap. The burning smell I'd been noticing is completely gone now.",
          "name": "Theo R.",
          "date": "2025-06-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Honestly didn't think air ducts could hold that much hair until I saw the before and after photos. Previous owner had cats. The tech showed me clumps coming out of the supply ducts and the difference in airflow afterward was noticeable. Shoe covers on the whole time too.",
          "name": "Heather B.",
          "date": "2025-09-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "After moving into a 1990s house, the dust never stopped no matter how much I vacuumed. Brett pulled a thick mat of debris and old construction dust out of the main trunk line. He showed me each vent before reinstalling the registers. My sinuses have calmed down noticeably since then.",
          "name": "Yvette D.",
          "date": "2025-08-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Heavy rain found a weak spot in our 18-year-old roof. Leak was right above the dining room. Cody traced it to failed flashing where the roof meets the dormer, replaced the section, and resealed. Honest pricing, no hidden fees, done in a day.",
          "name": "Anthony G.",
          "date": "2024-11-08",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Honestly impressed. The tech caught a gap between the cap and crown that two other companies missed. Resealed it and waterproofed the masonry the same afternoon.",
          "name": "Lauren H.",
          "date": "2025-06-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "During last summer's heat spike the AC stopped cooling overnight. The scheduler got a tech out the next morning. Dante found the thermostat wiring had corroded and the low-voltage signal wasn't reaching the air handler. He rewired it cleanly, tested the cycle a few times, and made sure the supply registers were all pushing cold air before he left.",
          "name": "Theo R.",
          "date": "2023-08-14",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "My gutters kept overflowing and I assumed it was a bigger problem. Turned out a section of drip edge flashing had come loose. Emilio reattached it and swapped two damaged shingles nearby. In and out in under an hour, very reasonable.",
          "name": "Tom W.",
          "date": "2025-06-30",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Our central air had been struggling to keep up and the tune-up made a real difference. Frankie found the condenser coils packed with cottonwood fluff, hosed them down, topped off the refrigerant, and tested the static pressure across the system. He explained each number instead of just rattling them off. The unit cycles less and the temperature holds steady now.",
          "name": "Brianna L.",
          "date": "2025-06-08",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Tear-off and reroof completed exactly on the timeline they quoted. Crew laid down synthetic underlayment, new flashing at the wall transitions, and a continuous ridge vent. Tarps over the deck and bushes the whole time, and they swept for nails before pulling out.",
          "name": "Omar H.",
          "date": "2026-02-17",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Roof-run dryer vents are no joke and most outfits quote you sight unseen. Gabe came out, measured the run, explained why our lint kept building up at the elbow, and cleared it properly. Honest pricing, no hidden fees, and he sent before/after photos of the roof cap.",
          "name": "Tomas L.",
          "date": "2025-06-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Second year in a row using them for our yearly sweep and they remain consistent. Isaiah arrived on time, brushed the entire flue liner, removed a moderate creosote layer, and inspected the stainless cap. He even pointed out a small gap in the mortar I should watch. Trustworthy crew.",
          "name": "Hollis B.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Family-owned operation that clearly takes pride in their work. They removed contaminated old insulation, baffled the soffit vents so airflow stayed clear, then blew in fresh cellulose to R-60. The master bedroom over the garage is finally usable in July. Crew laid down plastic on every step and vacuumed the hallway after.",
          "name": "Rosalind K.",
          "date": "2025-06-30",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "We moved into a 1990s house and the previous owners clearly had pets. The musty, animal smell came right through the vents when the AC kicked on. The crew sanitized the entire duct system, replaced the filter, and showed me photos of the gunk they pulled out of the returns. Honestly shocked at the difference.",
          "name": "Tobias G.",
          "date": "2026-03-19",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "No heat on one of the coldest nights we'd had in years, two little kids in the house. Called the number around 7am and Javier was working on it by 11. Turned out the gas valve had failed; he had a replacement on the truck and tested every burner before he left. Showed me the old part and explained why it went. Family-owned and it shows in how they treat you.",
          "name": "Carolyn B.",
          "date": "2025-01-09",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Booked these folks after my second-floor dryer started leaving clothes damp. Kyle traced the vent up through the ceiling and out the gable. The line was nearly choked with years of lint from a previous owner who clearly never had it serviced. He vacuumed it, brushed it, and tested airflow at the hood before and after. Difference is night and day. Wore shoe covers in the house and cleaned up after himself completely.",
          "name": "Angela K.",
          "date": "2025-06-27",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Honest, detailed, and on time. The written report even included flue measurements. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Yolanda T.",
          "date": "2024-06-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Leon and a second tech knocked out the whole system in about three hours. They showed me the camera footage of the inside of the ductwork before and after, which I appreciated. Air quality felt better that afternoon and the persistent musty smell near the return is finally gone.",
          "name": "Grant M.",
          "date": "2023-08-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Switched our wood-burning insert thinking to a gas-log conversion and the crew handled everything. They ran the new gas line connection, installed a vented log set, and set the damper clamp so it stays partly open for safety. Mateo explained the remote thermostat and made sure the ember bed glowed right. Twenty-two years in business shows in how clean and careful they were, and the pricing was exactly what was quoted.",
          "name": "Annika L.",
          "date": "2026-02-11",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "After two other companies quoted us sky-high prices, this family-owned outfit came in fair and honest. Nasir handled the new gas furnace install, took the time to re-route a return duct that was undersized, and gave us a written report with photos of the finished work. Started exactly on the scheduled morning and wrapped up early. The crew left the utility room cleaner than they found it.",
          "name": "Gregory S.",
          "date": "2024-02-23",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Scheduling was painless, the office got me in within three days. Oscar did a thorough fireplace cleaning and safety inspection, removing soot from the firebox and checking the damper seal. He also pointed out that our gas logs needed repositioning for proper flame distribution. Fair price, fully explained, no hidden fees. Will use them again.",
          "name": "Olivia T.",
          "date": "2026-01-09",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Five stars for fire safety alone. Pedro found that our flexible foil vent was crushed behind the dryer and trapping lint, which he flagged as a real hazard. He replaced the section with smooth rigid duct and cleaned the whole run. Dries faster and I'm not lying awake worried anymore.",
          "name": "Lauren K.",
          "date": "2024-08-12",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "New homeowners here. Sneezing every morning until these folks cleaned our return vents. Quincy explained the prior pet hair situation clearly and gave me a written report at the end.",
          "name": "Vikram S.",
          "date": "2026-02-11",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked them after my doctor suggested indoor air quality might be triggering my allergies. The technician was thorough with the return vents and even cleaned the blower compartment. Transparent pricing, exactly what they quoted on the phone. Will use again.",
          "name": "Anthony R.",
          "date": "2024-06-21",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "A spring storm knocked a tree limb onto our roof and left a gash that started leaking immediately. Called the number that night and they had a crew out first thing to tarp it. Within the week they replaced the damaged decking, underlayment, and shingles. Rashad walked me through every step and the written estimate matched the final bill to the dollar. So relieved we found them.",
          "name": "Bethany K.",
          "date": "2026-03-17",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Spotted efflorescence on the interior brick and figured we had a water problem. Sean confirmed the crown was shot and the cap was undersized. He replaced both, applied a breathable waterproof sealant, and walked me through the warranty. Professional and tidy.",
          "name": "Greg P.",
          "date": "2024-08-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Compressor was short-cycling and the house never got below 80. Travis diagnosed a bad start capacitor and a dirty condenser coil packed with cottonwood fluff. He cleaned the coil, replaced the cap, and verified the refrigerant pressures. Transparent pricing, no hidden fees, and he wore boot covers the whole time. Cold air back the same day.",
          "name": "Priya S.",
          "date": "2025-06-09",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Wonderful experience from start to finish. Uriel arrived right on time, laid out where he'd be walking, and did a full inspection of our aging roof. He found three cracked shingles above the garage and a gap in the flashing where the satellite mount had been removed. Everything was repaired the same afternoon and he sent over photos of the completed work. The pricing was exactly what the office quoted, no surprises at all.",
          "name": "Angela F.",
          "date": "2024-07-15",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Booked a fall maintenance check and Vince was thorough. Cleaned the burners, replaced the filter, and tested the carbon monoxide levels at the furnace. Transparent pricing, exactly what was quoted on the phone.",
          "name": "Marcus T.",
          "date": "2024-10-27",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Couldn't be happier with the full roof replacement. Wes was the lead and kept me updated each day. They replaced the decking in one corner that had water damage, installed new step flashing, and the cleanup was honestly better than the state my yard was in before they started.",
          "name": "Rachel B.",
          "date": "2025-03-29",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Finally found someone willing to deal with a vent that goes up two stories and out the roof. The crew set up on the roof safely, removed a bird nest blocking the termination cap, and snaked the full run. Clothes dry in one cycle now instead of two. Twenty-two years in business clearly shows in how organized they were.",
          "name": "Hannah G.",
          "date": "2024-08-17",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Family-owned and it shows in how careful they are. The technician taped plastic around the firebox, swept the creosote out with zero dust escaping into the room, and bagged everything. Twenty-plus years of doing this clearly pays off.",
          "name": "Tamsin V.",
          "date": "2025-08-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quick turnaround from quote to install. Attic got topped up and the AC short-cycling problem we'd had for two years basically vanished. Yosef explained the R-value targets clearly.",
          "name": "Hank B.",
          "date": "2024-10-11",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Booked a sanitizing service because of a persistent damp odor and the office got me on the schedule within two days. Fair price, no hidden fees, fresh air.",
          "name": "Renata V.",
          "date": "2024-11-30",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Thermostat was reading right but the furnace wasn't responding. Zane found a tripped high-limit switch from a dirty filter restricting airflow, swapped the filter, reset it, and gave me a maintenance tip so it doesn't happen again. Same-day, in and out in under an hour.",
          "name": "Hassan M.",
          "date": "2024-02-16",
          "service": "HVAC Service",
          "rating": 4.1
        },
        {
          "review": "Twenty-two years in business shows. The scheduler got me in two days after I called about slow drying, and the technician pulled lint clumps the size of softballs out of my vent run. Clothes are dry in 40 minutes now instead of an hour and a half.",
          "name": "Curtis M.",
          "date": "2026-01-15",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "After a chimney fire scare last winter we finally booked a real inspection. The technician spent over an hour checking the flue liner, crown, and firebox mortar joints, then handed us a written report with before photos and a clear note that the creosote was only stage one. Reassuring to have documentation we could keep on file.",
          "name": "Hector M.",
          "date": "2025-12-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our newborn's nursery always felt stuffy. The technician focused extra time on that room's supply line and added a fresh filter. By bedtime the air felt cleaner and the room held temperature far better. Grateful for the careful work.",
          "name": "Lena K.",
          "date": "2026-01-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Annual tune-up on the gas fireplace. Aaron cleaned the glass, checked the oxygen depletion sensor, and adjusted the pilot flame so it properly engulfed the thermocouple. Quick, tidy, shoe covers on the whole time.",
          "name": "Hugo S.",
          "date": "2025-03-08",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "New heat pump system installed in a single day. Brett coordinated everything, double-checked the refrigerant charge, and walked me through the warranty paperwork. No mess, no hidden fees, and the old equipment was gone before he left.",
          "name": "Tabitha L.",
          "date": "2025-09-08",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "After moving into a new place I wanted the wood fireplace checked before lighting our first fire. Cody inspected the firebox, the flue, and the chimney crown, then cleaned out a season's worth of creosote. He explained the difference between the glazed and flaky buildup and why it matters for safety. Felt confident lighting a fire that night. Great experience with a clearly experienced crew.",
          "name": "Hannah B.",
          "date": "2025-11-21",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Wonderful experience from start to finish. As a family-owned outfit they treated my home like their own, with shoe covers and a clean workspace. The amount of lint pulled out of that vent was genuinely alarming, and the tech explained the fire risk in plain terms. Worth every penny for the peace of mind.",
          "name": "Gregory M.",
          "date": "2025-12-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Closed on a house in March that smelled faintly of dog no matter how much we cleaned the floors. Turns out the problem was in the ducts. Dante came out, pulled the registers, and showed me the fur and dust that had built up over what looked like years. He fogged a deodorizer through the system after the cleaning. Four days later the smell still hasn't returned. Family-owned outfit and it shows in how they treat your home.",
          "name": "Allison K.",
          "date": "2026-04-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Sneezing every morning had become routine. Emilio and the crew got here on time, taped off the registers, and ran their brushes through every supply duct. The before-and-after photos sealed it for me, you could see the layer of dust gone. Highly recommend for anyone with allergy issues.",
          "name": "Bianca S.",
          "date": "2025-10-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Wind-driven rain was getting in around a roof vent. Frankie popped up, found the boot had cracked and the flashing underneath had rusted. Swapped both out same visit. Tidy work and he hauled the old materials away.",
          "name": "Quentin D.",
          "date": "2025-06-29",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Recurring leak above the fireplace had us chasing the roof for months. Turned out the chimney crown was the culprit. Gabe cut out the failed mortar cap, poured a real concrete crown with a slope, and sealed the brick with a clear waterproofer. Detailed and patient explaining everything.",
          "name": "Sandra M.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Outdoor unit was humming but not spinning. Quick fix on a brutal afternoon. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Bryan K.",
          "date": "2024-08-22",
          "service": "HVAC Service",
          "rating": 4.1
        },
        {
          "review": "Reliable and honest. Minor shingle repair done quickly and the chimney flashing got resealed too. Fair price. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Carl D.",
          "date": "2023-10-03",
          "service": "Roofing Service",
          "rating": 4.1
        },
        {
          "review": "Efficiency was my main concern since our electric bills kept climbing. Isaiah ran a full tune-up, found a refrigerant charge that was off, corrected it, and cleaned the evaporator coil. He also pointed out a clogged return vent we'd ignored for years. The system reaches the set temperature far quicker and stays there.",
          "name": "Nadia F.",
          "date": "2025-08-11",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Solid work on a complete tear-off. New architectural shingles, new flashing around all three roof penetrations, and a fresh ridge vent. They tarped the deck overnight when rain threatened and protected the AC condenser with plywood. Nails were all magnet-swept.",
          "name": "Victor M.",
          "date": "2024-08-12",
          "service": "Roofing Service",
          "rating": 4.9
        },
        {
          "review": "Javier handled our long attic-to-roof vent run with zero fuss. Found the lint trap was only catching part of it and the rest packed the duct. All clear now.",
          "name": "Bryce O.",
          "date": "2026-02-11",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Kyle handled our annual chimney cleaning and I appreciated how thorough he was. He measured the creosote thickness, classified it as stage two, and explained why it needed a wire brush rather than just a poly one. Flue is spotless and the written inspection report was detailed.",
          "name": "Greg M.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "After years of uneven temperatures between floors, we finally pulled the trigger on an attic insulation upgrade. Leon's team sealed all the penetrations around the ductwork and the chimney chase, added baffles, then brought the depth up to code. They left a written report with photos of every step and the depth markers they installed. The house holds heat far better now and the furnace runs much less. Couldn't be happier with how thorough they were.",
          "name": "Yvonne T.",
          "date": "2025-02-27",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Mateo and his partner were thorough. They explained that the musty smell was coming from moisture in the supply ducts and treated everything with an EPA-approved sanitizer. They protected the floors with drop cloths and cleaned up so well you would never know they were here. The lingering smell is completely gone now.",
          "name": "Hank D.",
          "date": "2025-06-25",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Heat quit Sunday morning. They actually answered and dispatched Nasir, who replaced a cracked hot surface igniter on the spot. Warm house by noon. Fair price.",
          "name": "Lindsey K.",
          "date": "2025-12-08",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Fast, friendly, and effective. Oscar cleared a long duct run that snakes behind a finished wall, and the lint he removed was honestly alarming. Drying is normal again.",
          "name": "Yvonne S.",
          "date": "2025-04-03",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Pedro ran a full camera inspection of our masonry chimney and explained what each shot meant. The written report flagged some spalling brick near the crown and a worn damper. Pricing for the inspection was exactly what the office quoted, no surprises.",
          "name": "Allison K.",
          "date": "2026-03-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Solid job on the air ducts. Noticed stronger airflow from the vents right away. Tech was tidy and explained the written report he left behind. No upsell pressure.",
          "name": "Tobias W.",
          "date": "2024-04-27",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "After we moved in, the gas logs in the den wouldn't ignite at all. Quincy came out, found the gas valve had been shut at the floor key, but he didn't just flip it and leave. He did a full inspection, tested for leaks, cleaned the burner, and repositioned two logs that were blocking the flame ports. Detailed written report afterward. Couldn't be happier.",
          "name": "Renata M.",
          "date": "2024-12-27",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "Furnace died in January, which is the worst possible timing. The scheduler got someone out fast and Rashad installed a new 96% efficiency unit the very next day. He explained the variable-speed blower, set up the smart thermostat, and made sure the condensate drain was pitched correctly. Honest pricing and the man wore shoe covers the entire time. Couldn't ask for better.",
          "name": "Roland P.",
          "date": "2026-01-19",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Reliable, professional, and clean. Sean serviced our fireplace, swept the flue, and made sure the damper opened and closed smoothly. Showed me before and after photos. Twenty-plus years of experience really shows.",
          "name": "Caleb R.",
          "date": "2024-12-07",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Noticed the top of my dryer getting hot to the touch and called these folks. Travis diagnosed a vent packed solid with lint about ten feet from the exterior hood. He cleared it, tested airflow with a meter, and showed me the reading before and after. Genuinely a fire waiting to happen, glad it's fixed.",
          "name": "Daniela F.",
          "date": "2025-04-17",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Great experience. The previous owner's two huskies left fur in every supply duct. Crew was in and out in about three hours and the air feels fresher.",
          "name": "Devon M.",
          "date": "2025-12-17",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Wonderful experience start to finish. The scheduler fit us in within a few days. Uriel explained that our ducts hadn't been touched in over a decade, which explained all the dust. He cleaned the return vents, the supply runs, and replaced our filter. Worth every penny.",
          "name": "Curtis M.",
          "date": "2024-03-12",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "After a microburst rolled through, half our ridge cap was gone and the ceiling started dripping. The scheduler was calm and reassuring, got a crew out the same afternoon. They tarped it, then returned to install new ridge caps and reseal the flashing around the chimney. Photos before and after, clear report, and they wore shoe covers when checking the attic. Twenty-two years of experience clearly shows.",
          "name": "Selena V.",
          "date": "2024-05-19",
          "service": "Roofing Service",
          "rating": 4.9
        },
        {
          "review": "Stainless cap installed and crown sealed in under two hours. No mess, fair quote, dry chimney. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Devon A.",
          "date": "2024-05-16",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Came home from work to an 86-degree house and an AC that wouldn't kick on. Vince arrived within a couple hours, found the float switch on the drain pan had tripped because the condensate line was clogged with algae. He cleared the line, tested the switch, and got us cooling again. Friendly, efficient, and explained how to flush the line myself next time.",
          "name": "Lena W.",
          "date": "2026-05-18",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "After a windy week I wanted peace of mind, so I booked an inspection. Wes went up, secured a few loose shingles at the ridge, and pointed out that my pipe flashing was starting to dry-rot. He replaced the boot and showed me the difference in the photos. Couldn't be happier with how careful and clear he was.",
          "name": "Sofia G.",
          "date": "2025-11-26",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "Reliable maintenance crew. Tech checked the compressor amperage, flushed the drain line, and swapped the filter. Got a written report emailed before he even left the driveway.",
          "name": "Owen C.",
          "date": "2024-04-16",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "We had three estimates and went with these folks because the pricing was transparent with no surprises. The crew removed two layers of old shingles, replaced the rotted fascia board on the north side, and put down ice-and-water shield along every eave. Yosef made sure the gutters were cleared of debris when they wrapped up. The magnet sweep over the driveway and lawn was thorough, and they hauled the dumpster away the same afternoon they finished. Whole job took three days and looks fantastic.",
          "name": "Lauren C.",
          "date": "2026-05-09",
          "service": "Roofing Service",
          "rating": 5
        },
        {
          "review": "After noticing the dryer getting hot to the touch, I called about our roof-vented line. Zane inspected the whole run with a camera, found a heavy lint clog about 20 feet in near a bend, and cleared it from the roof side. He replaced a loose vent hood flap too. Professional, tidy, and explained everything as he went.",
          "name": "Renata C.",
          "date": "2025-11-22",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Got the yearly sweep booked easily through the office. The crew ran a camera up the flue, removed creosote and a surprising amount of debris, and checked the damper operation. Reasonable price, no upsell.",
          "name": "Lucia F.",
          "date": "2025-12-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Bonus room over the garage was unusable in summer. They air-sealed it and added blown-in insulation, plus insulated the knee walls. Comfortable now even on 95 degree days.",
          "name": "Carlos M.",
          "date": "2026-03-08",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Every time the furnace turned on we got a sour, musty whiff through the house. Aaron identified mold spores in the return vents, cleaned and fogged the entire system, and gave me a detailed written report. The air smells noticeably cleaner and my wife's allergies have calmed down too.",
          "name": "Sandra M.",
          "date": "2024-02-17",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "I've used a lot of HVAC outfits over the years and this was the smoothest. Furnace stopped heating during a deep freeze and Brett arrived the same day with a fully stocked van. He found the inducer motor had seized, replaced it, and then ran a full combustion check before signing off. No upsell, just fixed what was broken and left a written report. Heat has been steady since.",
          "name": "Gregory P.",
          "date": "2024-12-30",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "My energy bill kept creeping up and the dryer ran forever. Turns out the vent was almost completely blocked near the wall elbow. The crew disconnected the dryer, ran a rotary brush the full length, and vacuumed everything including the lint trap housing. They showed me the pile of lint when they finished, easily a gallon's worth. Towels now dry in a single cycle and the room stays cool. Transparent flat price quoted up front, no surprises on the invoice.",
          "name": "Reginald F.",
          "date": "2025-08-21",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Quick, professional inspection with a tidy written report. Shoe covers on, drop cloth down, gone in an hour. Fair price, friendly crew, and a job done right the first time — no complaints at all.",
          "name": "Tomas G.",
          "date": "2023-11-22",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "After a remodel left drywall dust everywhere, these guys were a lifesaver. Cody ran his vacuum through every register, cleaned the returns, and even wiped down the vent covers before reinstalling them. The same day, the gritty taste in the air was gone and the whole house felt easier to breathe in. Transparent pricing, exactly what they quoted on the phone.",
          "name": "Renata C.",
          "date": "2025-11-08",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Needed the millivolt system on our older gas-log unit diagnosed. Dante tested the thermopile output, found it reading low, and replaced it. Flame controls work off the wall switch again. Fair price.",
          "name": "Tobias F.",
          "date": "2025-09-16",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Clean and on schedule, just like they promised. Emilio pulled the ancient furnace, set the new one, and tied in the existing ductwork without a hitch. Showed me the old cracked heat exchanger so I understood why we replaced it.",
          "name": "Nadia K.",
          "date": "2024-11-05",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Decided to get the fireplace cleaned and inspected ahead of the first cold snap. Frankie arrived right on schedule, spread drop cloths, and went after the creosote in the firebox and smoke chamber. He checked the flue liner top to bottom and gave the damper a good once-over. The written report he left was detailed and easy to understand, with a couple of photos attached. Pricing matched the quote exactly. This is a family-owned outfit that clearly cares about doing it right.",
          "name": "Felicia M.",
          "date": "2025-10-30",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Prompt and professional. Pulled out years of compacted lint and cleaned the exterior vent flap so it actually closes now. No more fire worry.",
          "name": "Nathan O.",
          "date": "2024-05-29",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Our newly purchased home came with an unwelcome bonus: years of cat dander in the HVAC ducts. The smell was strongest near the return vents. Gabe walked me through the whole process, used drop cloths on our new carpet, and showed me the filter that came out nearly black. Pricing was exactly what the office quoted on the phone, no hidden fees. Very pleased.",
          "name": "Roberta C.",
          "date": "2026-05-09",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Less dust on the furniture within days. Honest crew, fair price, no hidden fees. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Lena P.",
          "date": "2023-05-30",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Roof leak over the kitchen after a heavy downpour. Isaiah found a couple of shingles that had blown loose and a nail pop letting water through. Fixed it in about two hours and showed me the spot in the attic that had gotten damp. Fair, fast, professional.",
          "name": "Omar F.",
          "date": "2023-11-27",
          "service": "Roofing Service",
          "rating": 4.9
        },
        {
          "review": "We had water dripping into the flue and could hear it on rainy nights. Javier inspected with a camera, showed me the deteriorated crown and a corroded cap that no longer covered the opening. He installed a new oversized stainless cap with mesh, recrowned, and waterproofed the stack. Tidy drop cloths and a clear invoice with no surprises.",
          "name": "Angela F.",
          "date": "2025-10-22",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "This family business saved our July weekend. The blower motor failed and warm air was just sitting in the house. Kyle had the part, installed it, and double-checked the airflow at every return vent. Honest pricing and cold air fast.",
          "name": "Carlos D.",
          "date": "2024-07-05",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Excellent service. Their tech inspected the entire roof, replaced six worn shingles on the north face, and re-flashed the valley that had been collecting debris. He even cleaned out the gutters along that section before heading down. The written report was detailed and easy to understand.",
          "name": "Brandon M.",
          "date": "2024-09-21",
          "service": "Roofing Service",
          "rating": 4.9
        },
        {
          "review": "Couldn't be happier with the spring tune-up. Leon arrived on time, laid a drop cloth by the indoor unit, and went through everything from the blower motor to the refrigerant pressure. He noticed the thermostat was reading two degrees off and recalibrated it. The AC kicks on smoother and the house feels more even room to room. Fair price too.",
          "name": "Genevieve P.",
          "date": "2025-04-30",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Whole roof replaced before the winter. Crew was punctual, laid drop cloths against the siding, and replaced the chimney flashing while they were up there. Cleanup left the yard cleaner than they found it.",
          "name": "Ahmed F.",
          "date": "2025-12-01",
          "service": "Roofing Service",
          "rating": 4.9
        },
        {
          "review": "Our townhome has the dryer vent running straight up to the roof, about 25 feet, and it had never been cleaned in the eight years we owned it. Mateo showed up with the proper rotary brush setup, got on the roof, and pulled out an unreal amount of lint. He also confirmed the cap had a proper screen. Highly recommend for any tricky vertical run.",
          "name": "Owen F.",
          "date": "2024-05-30",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Outstanding service from start to finish. We hadn't had the chimney swept in three years and the creosote had glazed over. Nasir used a chemical loosener first, then mechanically removed the hardened layer along the flue liner. He also reset the cap that had loosened in a storm. Took his time, cleaned up completely, and the report he left included photos of every section. Worth every penny for the peace of mind heading into winter.",
          "name": "Dominic A.",
          "date": "2024-10-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Oscar came out, measured the existing insulation depth, and was upfront that we only needed a top-up rather than a full tear-out. Appreciated the honesty. They blew in the extra inches, sealed the attic hatch with weatherstripping, and the upstairs temperature swing is way smaller. Transparent pricing, no surprises on the invoice.",
          "name": "Bridget A.",
          "date": "2024-04-16",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Skeptical at first that duct sanitizing would fix the basement smell, but it really did. Pedro was professional and showed me the before photos of the mildew.",
          "name": "Owen B.",
          "date": "2025-08-03",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Pipes nearly froze when our heat went out and I panicked. Within hours the tech showed up, diagnosed a faulty control board, and had the right one on the truck. Detailed and patient explaining the fix.",
          "name": "Aisha D.",
          "date": "2025-01-22",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Slow drying had been driving me crazy for months. Quincy arrived, found the vent hood flapper stuck shut behind a bush, and cleared a massive lint clog from the line. He also reattached a loose section of the transition duct that was leaking lint into the wall cavity. Clothes dry fast now. Couldn't be happier with the attention to detail.",
          "name": "Sandra W.",
          "date": "2024-10-11",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our home insurance asked for a chimney inspection report and these folks delivered exactly what was needed. Rashad documented the flue liner condition, crown, and cap with photos, and the written report was formatted clearly enough to forward straight to my agent. The whole visit was painless.",
          "name": "Renee P.",
          "date": "2025-04-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Family-owned outfit that clearly takes pride in the work. Sean showed up on time, protected the floors with drop cloths, and got every supply duct cleaned. Airflow in the master suite improved that same afternoon and the dust we'd been fighting for months settled way down.",
          "name": "Hassan O.",
          "date": "2024-07-15",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Phenomenal experience. The technician arrived in a fully stocked truck and had every part on hand. He replaced our failing igniter module, cleaned years of dust off the ceramic logs, and re-arranged them so the flames danced naturally instead of shooting straight up. He also sealed a small gap around the gas line penetration. Lit it for me before leaving and the room filled with a warm, even glow. Transparent pricing, no surprise charges.",
          "name": "Lucinda B.",
          "date": "2026-03-29",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "We had a complete system replacement, both the AC condenser and the furnace. Travis and his partner arrived first thing, laid drop cloths through the hallway, and finished both pieces in one day. They flushed the line set, pulled a proper vacuum, and showed me the gauges so I knew the charge was right. The estimate was itemized and matched the final bill to the dollar.",
          "name": "Bryce H.",
          "date": "2025-04-12",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Glad I called before winter. Tech found a cracked firebrick during the safety inspection that I had no idea about. Cleaned everything, took photos, and explained the repair options without pressure.",
          "name": "Theo G.",
          "date": "2026-02-15",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "We just bought an older home and wanted the dryer vent checked before running it much. Uriel came out, inspected the long run that goes up two stories, and found a bird's nest plus a thick lint layer blocking the cap. He cleared everything, installed a new pest-proof vent hood, and gave me a written report. Such peace of mind for a young family.",
          "name": "Olivia T.",
          "date": "2025-10-05",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Skeptical at first that duct cleaning would fix the lingering dog odor in our new place, but it did. Vince was professional and didn't push extra services.",
          "name": "Tyrell W.",
          "date": "2025-08-21",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Our newborn's nursery was the dustiest room in the house and it worried us. Wes took extra care in that room, brushing the supply duct twice and vacuuming the register. He wore shoe covers and cleaned up like he was never there. The whole family is breathing better now.",
          "name": "Tomas G.",
          "date": "2025-12-08",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Woke up to a drip in the hallway after an ice-and-rain storm. They sent Yosef out within the hour. He found the leak at a lifted piece of step flashing along the chimney and sealed it up, then checked the rest of the roof to be safe. Genuinely impressed by how quickly a family-owned shop responded on a weekend.",
          "name": "Hannah W.",
          "date": "2025-12-05",
          "service": "Roofing Service",
          "rating": 4.9
        },
        {
          "review": "Family-owned and it shows. The crew treated my house like their own, taping off the fireplace before sealing the crown leak and applying waterproofing to the chimney brick. Zane answered every question without rushing. Highly recommend.",
          "name": "Hassan B.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Thermostat read 79 and climbing even though the AC was running nonstop. Aaron discovered the system was low on refrigerant from a slow leak at the line set. He found and sealed the leak, recharged the system to spec, and showed me the pressure readings on his gauges before and after. Whole house cool within the hour. Twenty-two years of experience clearly shows.",
          "name": "Sandra V.",
          "date": "2025-07-30",
          "service": "HVAC Service",
          "rating": 4.1
        },
        {
          "review": "Punctual and professional. Found two lifted shingles by the skylight and resealed the flashing. Quick visit, no mess left behind.",
          "name": "Lena K.",
          "date": "2026-01-12",
          "service": "Roofing Service",
          "rating": 4.9
        },
        {
          "review": "Annual furnace service done right. Brett cleaned the flame sensor, which had been causing it to cut out, and checked the gas pressure. Runs quiet now.",
          "name": "Hassan B.",
          "date": "2024-11-12",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Tore off the old roof and installed new dimensional shingles over two days. Cody explained the underlayment and the new pipe boots they were using. They covered all my landscaping with tarps and ran a magnet over the entire perimeter for stray nails. Office kept me posted on the schedule the whole time.",
          "name": "Nicole W.",
          "date": "2024-04-19",
          "service": "Roofing Service",
          "rating": 4.9
        },
        {
          "review": "Tricky run, easy experience. Vent goes through the ceiling and out the roof and Dante cleared the whole thing without leaving a mess. Lint was caking the roof cap.",
          "name": "Yara S.",
          "date": "2025-03-05",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Prompt and professional. Creosote scraped, flue brushed, fireplace ready for the season. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Anita W.",
          "date": "2025-11-02",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our 1970s house leaked heat through the attic like crazy. The crew removed the old settled insulation, sealed the can lights and plumbing stacks, installed soffit baffles, and blew in cellulose to R-49. Emilio was professional and explained the airflow concerns with the bath fans venting into the attic, which they corrected. The bedrooms hold temperature overnight now instead of dropping five degrees. Whole project took a single day and they protected the floors throughout.",
          "name": "Nadia F.",
          "date": "2025-09-25",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Fantastic experience from start to finish. The musty smell in our rental had been there for years and two previous companies couldn't fix it. The crew from Rocket pulled the registers, scrubbed the supply ducts, ran a sanitizing fog, and sealed everything back up. Smell gone, tenants happy. Family-owned and it shows in how much they cared.",
          "name": "Carmen L.",
          "date": "2026-01-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Furnace blowing cold air all morning. Frankie pinpointed a failed limit switch, replaced it, and checked the gas pressure to be safe. Same day, very tidy, drop cloths down the whole time.",
          "name": "Brandon S.",
          "date": "2024-01-29",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Excellent experience start to finish. The office called the morning of to confirm, and Gabe got the whole vent line cleared in under an hour. He showed me the lint he pulled and explained the roof termination needed a new cap, which he handled. Drying time dropped dramatically.",
          "name": "Omar J.",
          "date": "2026-02-18",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Booked an inspection because we kept smelling smoke in the living room. The tech found the smoke chamber had heavy creosote glaze and the damper wasn't seating right. Everything went into a written report with annotated photos, plus he explained the difference between the inspection and the cleaning we'd need next. Genuinely educational visit.",
          "name": "Wallace D.",
          "date": "2024-02-09",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Couldn't believe how much debris came out of our returns. The tech bagged it up and showed me, then ran the system to prove the airflow had improved before he left. House felt fresher by evening.",
          "name": "Bianca F.",
          "date": "2026-04-11",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Our gas-log remote stopped pairing. Isaiah reprogrammed the receiver, replaced the battery pack in the control module, and tested the on/off and flame-height functions. Works perfectly now and he labeled the remote so my wife and I stop hitting the wrong button.",
          "name": "Omar D.",
          "date": "2024-08-04",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Twenty-two years in business shows in the work. Our new furnace install was spotless, the technician sealed every duct joint with mastic and labeled the breaker. Quiet, efficient, and done on time.",
          "name": "Lorraine F.",
          "date": "2023-10-17",
          "service": "HVAC Service",
          "rating": 4.9
        },
        {
          "review": "Excellent fireplace service from start to finish. Javier was punctual, courteous, and meticulous. He cleaned the firebox, checked the gas line connections on our insert, and verified the pilot was burning correctly. Even tested the carbon monoxide levels nearby for peace of mind. Left the hearth cleaner than he found it. Highly recommend for anyone wanting their fireplace ready for the season.",
          "name": "Sandra L.",
          "date": "2024-11-26",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Honestly didn't realize how dangerous a clogged vent could be until the technician showed me the lint buildup near the heating element area. Kyle was thorough, vacuumed the lint trap cavity, and brushed the full duct line to the roof. Clothes dry in half the time now and I feel a lot safer.",
          "name": "Reginald P.",
          "date": "2024-02-19",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "We had no idea what we were inhaling. Bought a home from owners with a German Shepherd and the ducts were caked. The tech ran a brush and vacuum through every supply and return line, then handed me before and after photos that honestly shocked me. The pet smell that greeted us each evening is finally gone and the airflow out of the vents is stronger. Booking through the office was painless and they showed up right on time.",
          "name": "Camille O.",
          "date": "2026-02-27",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Year-round allergies pushed me to finally do this. The amount of dander and dust they extracted from the return vents filled their collection bag twice. Professional, friendly, and they protected my hardwood floors with drop cloths the entire visit.",
          "name": "Sandra W.",
          "date": "2024-09-17",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Storm peeled shingles off the back slope and rain got into the attic insulation. Crew tarped the same day, then came back to replace shingles and underlayment. They even swapped out the soggy insulation. Written report, fair price, no surprises.",
          "name": "Tyrone B.",
          "date": "2024-07-11",
          "service": "Roofing Service",
          "rating": 4.8
        },
        {
          "review": "Old chimney was wicking moisture straight through the brick. Leon diagnosed both a failing crown and porous masonry, repaired the crown overhang, and applied two coats of a vapor-permeable waterproofer. Patient, knowledgeable, and the price matched the estimate exactly.",
          "name": "Christine L.",
          "date": "2024-12-18",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "AC died right as the first heat wave hit. Same-day service, condenser capacitor swapped, done in under an hour. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Trevor B.",
          "date": "2023-06-21",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Such a relief to find a roofer who isn't trying to sell you a whole new roof. Mateo came out, did a careful inspection, and told me honestly that I only needed a handful of shingles replaced and the flashing around my vent stack resealed. He had the materials on the truck and finished within a couple hours. Detailed photos came with the invoice. This family-owned outfit earned a customer for life.",
          "name": "Gerald P.",
          "date": "2025-02-17",
          "service": "Roofing Service",
          "rating": 4.8
        },
        {
          "review": "This family-owned company has handled our HVAC maintenance two years running. Nasir serviced both the heat pump and air handler, cleared a partially blocked condensate line, and cleaned the coils. He took before and after photos and walked me through the static pressure readings. Our second floor used to be miserable in July, now it actually keeps up with the thermostat. Worth every penny.",
          "name": "Annika S.",
          "date": "2025-09-02",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Full replacement on a steep roof that other companies didn't want to touch. The crew rigged proper fall protection, stripped the old shingles, replaced a few decking sheets, and installed new flashing and a ridge vent. Cleanup was meticulous, every nail accounted for.",
          "name": "Greg P.",
          "date": "2025-07-26",
          "service": "Roofing Service",
          "rating": 4.8
        },
        {
          "review": "Pleasantly surprised by how thorough this team was on a hard-to-reach roof vent. The technician didn't just blow air through it, he physically brushed the full length from the dryer connection up to the rooftop termination. Showed me the cleared cap and the pile of removed lint. Fair price, fully insured, and no upsell pressure at all.",
          "name": "Carlton D.",
          "date": "2024-12-19",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Oscar did our annual sweep and was incredibly tidy. He laid drop cloths from the front door to the hearth, wore shoe covers, and vacuumed the firebox after removing the creosote. Showed me the clean flue liner with his light afterward. Couldn't ask for more.",
          "name": "Yvonne C.",
          "date": "2026-03-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Cold floors and a furnace that never quit running. Adding attic insulation made an immediate difference, the system finally gets a break. Pedro was tidy and on time.",
          "name": "Garrett L.",
          "date": "2024-12-02",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Quincy arrived right in the window the office promised. He found standing dust and mildew in our return vents that was causing the stale odor, sanitized the whole system, and laid drop cloths so nothing got dirty. Clean, polite, and the air smells like a new house.",
          "name": "Felicia A.",
          "date": "2025-10-11",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Couldn't get the heat to kick on no matter what I did with the thermostat. Rashad came out the same day, discovered the thermostat itself had died, and installed a new one after confirming the furnace was fine. Took the time to program it for us and showed my wife how to use the schedule feature. Genuinely kind guy, fair pricing, no hidden fees on the invoice.",
          "name": "Teresa V.",
          "date": "2025-02-11",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Quick job, big difference. Vent was packed; clothes dry in one cycle now. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Lena P.",
          "date": "2025-12-05",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Sean was meticulous. Crown, flashing, cap, liner, firebox, all checked and noted in a written report I got by email before he left the driveway.",
          "name": "Indira S.",
          "date": "2026-01-16",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Three of us in the house have allergies, so clean ducts matter. Travis and his partner sealed off each register, ran a high-powered vacuum through the trunk line, and replaced our clogged filter. Within hours the air felt noticeably less stale, and my wife stopped waking up congested. They left a written summary of what they cleaned and a couple before/after photos. Worth every dollar and no surprise fees.",
          "name": "Quentin D.",
          "date": "2025-02-23",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Soot was building up on the glass front and the flame looked weak. Uriel deep-cleaned the burner pan, removed the logs to vacuum underneath, and adjusted the air shutter to fix the lazy yellow flame. He also showed me how to clean the glass with the proper conditioner. Great gas-log service and very respectful of the house with drop cloths down.",
          "name": "Yvette C.",
          "date": "2025-06-21",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Old AC was R-22 and not worth fixing, so we went with a new system. Vince walked us through the SEER ratings, didn't oversell, and installed a properly sized condenser. He set the new pad on gravel so it wouldn't sink, ran a fresh disconnect, and tested everything before leaving. Fair price and a clean job site.",
          "name": "Ethan V.",
          "date": "2025-12-03",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Quick, honest, and respectful of the house. Damper inspected, firebox swept, flue checked. The tech laid drop cloths and wore shoe covers without being asked. In and out in under an hour.",
          "name": "Brandon C.",
          "date": "2025-12-03",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Texted my landlord that the dryer was overheating and they sent Rocket Air Care out. Wes found a crushed vent behind the unit and a blockage at the wall. He cleaned it all and replaced the foil section with rigid pipe. Big relief on the fire-safety front.",
          "name": "Chelsea B.",
          "date": "2025-07-22",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Prior owners smoked and had a dog, double trouble for our ducts. Yosef tackled both odors and was upfront that smoke residue might need a second pass, which I appreciated. Smells dramatically better.",
          "name": "Stefan L.",
          "date": "2025-10-14",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Zane arrived right on schedule and got straight to work on the supply ducts. He found a buildup near the blower that was recirculating dust through the whole house. After cleaning it, the difference in air quality was immediate. My wife's allergy symptoms have dropped off a cliff. Genuinely impressed with the attention to detail and the written report he left.",
          "name": "Marcus E.",
          "date": "2025-03-25",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Found a slow leak above the closet after a windy rainstorm. Aaron located a hairline crack in the flashing around the plumbing vent. He replaced the boot and resealed the whole area. Dry through the next two storms.",
          "name": "Camille A.",
          "date": "2026-01-23",
          "service": "Roofing Service",
          "rating": 4.8
        },
        {
          "review": "Noticed rust streaks running down the chimney from a cap that had basically rotted out. Brett swapped it for a heavy-gauge stainless cap and sealed the crown cracks while he was up there. Quick turnaround and very respectful of our property.",
          "name": "Nathan W.",
          "date": "2025-04-30",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Upstairs was unbearable, easily 85 degrees, and the system just couldn't keep up. Cody checked everything methodically and found the contactor was welded shut plus the coil was filthy. He replaced the contactor, washed the condenser coil, and verified the temperature split at the supply ducts. Cooling improved immediately. Appreciated the drop cloths inside and the clear written report.",
          "name": "Nadia F.",
          "date": "2025-08-16",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Quick and painless roof checkup. A few shingles near the eave were cracked and the tech swapped them out, plus tightened up the flashing on the back slope. Done in no time.",
          "name": "Naomi R.",
          "date": "2024-04-09",
          "service": "Roofing Service",
          "rating": 4.8
        },
        {
          "review": "Solid tune-up. Replaced the capacitor that was bulging, cleaned the condenser, and topped off refrigerant. Cooling is noticeably stronger. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Derek O.",
          "date": "2024-07-08",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Replaced our entire roof after a tree branch came through during a storm. Dante's team handled the decking repair and the new shingles, and they coordinated with our insurance. They protected the garden beds with plywood and tarps, and the final nail sweep was done twice.",
          "name": "Tanya S.",
          "date": "2026-01-14",
          "service": "Roofing Service",
          "rating": 4.8
        },
        {
          "review": "Our dryer vent is a long horizontal run that turns up into the roof, and the buildup was a real fire hazard. Emilio came out, used rods plus a vacuum on both ends, and got everything spotless. He pointed out where a previous installer used screws that snag lint and recommended a fix. Great communication from the office to the field.",
          "name": "Stephanie K.",
          "date": "2026-01-08",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Reliable annual maintenance. The technician removed a light coating of creosote, inspected the crown and stainless cap, and confirmed the damper sealed properly. He noted everything in a written report and emailed a copy. Smooth experience.",
          "name": "Kelvin D.",
          "date": "2024-11-27",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Scheduling was painless and the office followed up to confirm the morning of. Frankie's team handled the attic insulation upgrade and sealed the attic access with a foam dam and cover. House feels noticeably more even floor to floor, and the AC kicks off sooner now. Good value for the comfort improvement.",
          "name": "Tamara W.",
          "date": "2025-04-09",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Damp smell after the rainy season was unbearable. They sanitized the ducts and it vanished. Truck was fully stocked so no return trip needed.",
          "name": "Grant S.",
          "date": "2024-09-05",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Quick same-day response when our furnace died in 18-degree weather. Bad pressure switch, replaced and tested. Heat restored. Fair price, friendly crew, and a job done right the first time — no complaints at all.",
          "name": "Omar F.",
          "date": "2024-12-12",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "We had no idea how clogged our dryer vent was until Gabe opened it up. The line runs almost 25 feet to the side of the house and was matted with lint the whole way. He used a brush kit and a powerful vacuum, then sealed the transition hose connections properly with the right clamps, not tape. Drying time went from over an hour to about 35 minutes. He also pointed out our lint screen had a small tear and recommended a replacement. Genuinely knowledgeable and respectful of our home.",
          "name": "Theresa G.",
          "date": "2025-03-29",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Family-owned outfit that treats your house with respect. Drop cloths everywhere, careful camera work up the flue, and a written report that broke findings into urgent versus monitor. They flagged a hairline crack in the crown and gave me honest options rather than a hard sell.",
          "name": "Greg F.",
          "date": "2025-07-25",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Scheduling was painless and the office gave me a clear window. Once the crew started, they were quick and respectful of the house, shoe covers and all. Vents push more air now and the lingering pet odor is much improved since the same day they cleaned.",
          "name": "Sofia L.",
          "date": "2023-12-04",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Pilot assembly was acting up. Tech swapped the thermocouple and cleaned the pilot orifice with a fine wire. Lights every time now. Straightforward visit.",
          "name": "Sterling H.",
          "date": "2023-11-30",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Couldn't be happier with our new furnace and AC. Isaiah showed up exactly on time, kept the work area tidy with drop cloths, and had the whole system swapped and running in a single afternoon. He programmed the thermostat and texted me a written report with before-and-after photos.",
          "name": "Sofia D.",
          "date": "2026-04-21",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "My elderly mother needed her fireplace inspected before winter and I wanted someone trustworthy. Javier was patient, explained everything to her in plain terms, and cleaned the creosote from the firebox while checking the flue liner and crown. He noticed the chimney cap was loose and secured it. No upselling, just genuine care. She felt totally comfortable with him in her home. Worth every penny.",
          "name": "Vanessa P.",
          "date": "2025-10-08",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Excellent service. The tech laid drop cloths, pulled the dryer out, disconnected it carefully, and ran a long brush through the whole vent to the exterior. Showed me a bag full of lint at the end. So much peace of mind knowing we won't have a dryer fire.",
          "name": "Vincent A.",
          "date": "2024-10-11",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Quick, clean, professional. New house, old pet hair in the return vents, all cleared out in an afternoon. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Lena F.",
          "date": "2026-03-29",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Family-owned and it shows in how they treat your home. Kyle and his partner cleaned every register, ran a negative-air machine, and showed me the debris they collected. My constant morning congestion is finally gone.",
          "name": "Heidi L.",
          "date": "2024-12-19",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Massive thunderstorm knocked loose a whole row of shingles on our front slope and water started coming through the garage ceiling that night. I called and they had a tech out by 8am to tarp it. Leon replaced the shingles and damaged flashing two days later, laid drop cloths in the garage, and left the area cleaner than he found it. Transparent pricing the entire way.",
          "name": "Jared L.",
          "date": "2025-02-14",
          "service": "Roofing Service",
          "rating": 4.8
        },
        {
          "review": "Leak detective work at its finest. Mateo used dye and a moisture meter to confirm the crown was the entry point, not the flashing. Resealed the crown, replaced the cracked cap, and waterproofed. Thorough report with photos.",
          "name": "Yvette C.",
          "date": "2025-07-11",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "No cold air during a Labor Day scorcher. Nasir arrived fast, found a tripped breaker tied to a shorted fan motor, replaced the motor, and had the condenser spinning again. Straightforward and fair.",
          "name": "Grant H.",
          "date": "2024-09-02",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Called about a possible leak near my fireplace chase. Oscar did a complete inspection and discovered the issue was the chimney flashing, not the roof itself. He resealed it, replaced two adjacent shingles that had been damaged, and documented all of it with before and after photos. The crew was respectful and the pricing transparent from the first phone call.",
          "name": "Eduardo S.",
          "date": "2025-08-05",
          "service": "Roofing Service",
          "rating": 4.8
        },
        {
          "review": "Pleasantly surprised by how detailed the maintenance visit was. Pedro checked refrigerant charge, tightened electrical connections at the disconnect, cleaned the blower wheel, and showed me the temperature split across the supply and return. Everything went into a written report. The system runs quieter and our July bill dropped compared to last year.",
          "name": "Carmen V.",
          "date": "2025-07-25",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Quoted a fair price for a complete tear-off and stuck to it, no hidden fees. New synthetic underlayment, fresh flashing at the valleys, and architectural shingles. The crew was respectful of the property and left no debris behind.",
          "name": "Brandon J.",
          "date": "2024-10-05",
          "service": "Roofing Service",
          "rating": 4.8
        },
        {
          "review": "Quincy got up on a steep roof to clear our dryer termination and never complained once. The cap was almost fully blocked with packed lint. Now the dryer actually dries.",
          "name": "Reggie A.",
          "date": "2025-07-27",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "We burn wood almost every night in winter so the creosote builds up fast. Rashad came out for the annual cleaning and you could see the difference immediately. He brushed the full flue, cleared the smoke shelf, and recommended we burn seasoned hardwood to slow the buildup. Genuinely helpful advice, not a sales pitch.",
          "name": "Brenda H.",
          "date": "2025-10-13",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Estimate was clear, work was clean. They blew loose-fill into the attic and added insulation over the garage ceiling too. Upstairs is so much more comfortable now.",
          "name": "Oliver P.",
          "date": "2026-02-14",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "We had a recurring musty odor that got worse with humidity. Sean walked the house, checked the ductwork, and explained exactly where the moisture was sitting. After a full sanitizing treatment of the supply and return lines, the smell is gone and hasn't come back in two months. Transparent pricing, no surprises on the invoice.",
          "name": "Bianca F.",
          "date": "2025-12-08",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Heating system stopped cold and the office squeezed me in for the same afternoon. Travis found a rodent had chewed through a low-voltage wire to the furnace. He repaired the wiring, sealed the entry point he found, and got everything firing again. Explained it all in plain English and sent a written summary. Heat has been rock solid through the rest of winter.",
          "name": "Bethany L.",
          "date": "2025-01-31",
          "service": "HVAC Service",
          "rating": 4.8
        },
        {
          "review": "Reached out because the dryer was running hot and slow. The technician found the outdoor vent hood completely caked over and the duct full of lint. Cleared it all, tested airflow, and gave me a written report. Clothes dry properly now and I feel safer about the fire risk.",
          "name": "Bryce H.",
          "date": "2024-07-16",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Needed an inspection fast for a real estate closing and the office squeezed me in. Report was emailed within hours, complete with flue liner photos.",
          "name": "Bianca L.",
          "date": "2024-09-05",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Uriel found a collapsed section of flex duct in the attic that was choking off airflow to the back of the house. He repaired it on the spot and cleaned everything else. Difference was immediate, the bedroom that never got cool finally does. Impressed by the thoroughness.",
          "name": "Darnell P.",
          "date": "2025-08-19",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Booked a gas-log inspection and cleaning ahead of selling the house. Vince was thorough, checking the gas pressure, testing the oxygen depletion sensor, inspecting the venting, and cleaning the logs and burner. He gave me a written report I could hand to the buyer, plus before-and-after photos. The whole thing was painless and the scheduler had me booked within two days.",
          "name": "Delphine A.",
          "date": "2026-04-17",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Solid install of a new high-efficiency furnace. Wes explained the two-stage operation, flushed and tested the condensate line, and made sure the gas pressure was dialed in. On schedule and no hidden charges at the end.",
          "name": "Hugh B.",
          "date": "2024-05-30",
          "service": "HVAC Service",
          "rating": 4.7
        },
        {
          "review": "Annual fireplace cleaning and safety check done well. Yosef swept the flue, cleared the smoke shelf, and confirmed the damper was sealing properly. Detailed written report afterward. Smooth from booking to finish.",
          "name": "Garrett H.",
          "date": "2024-10-11",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Booked an annual cleaning since the manufacturer recommends it for fire safety. Zane was punctual, friendly, and meticulous. He cleared the lint trap slot, brushed the duct run, and checked that the outside vent hood flapper opened freely. Quick and reassuring.",
          "name": "Monica E.",
          "date": "2025-11-19",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "After moving in we noticed every time the heat ran the house smelled like a wet dog. The previous family had three of them. Aaron came out, inspected the ductwork with a camera, and found heavy fur buildup deep in the supply ducts where a regular filter never catches it. He cleaned it all and sanitized. The transformation in air quality is real, my wife's allergies have calmed down too.",
          "name": "Garrett P.",
          "date": "2026-01-06",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Reasonable price and zero pressure to add services. The tech focused on the return vents where most of the dust was hiding. Clean work.",
          "name": "Owen B.",
          "date": "2023-11-08",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Big spring storm and suddenly there was water spotting on the ceiling. Brett climbed up the same morning, found a torn section of valley flashing, and patched it temporarily before doing a full repair the next day. Appreciated the honesty about what was urgent versus what could wait.",
          "name": "Noelle S.",
          "date": "2024-03-08",
          "service": "Roofing Service",
          "rating": 4.7
        },
        {
          "review": "Great experience start to finish. Cody arrived on time, found a spider crack in the concrete crown and a cap that wasn't flashed properly. He rebuilt the crown slope, fitted a new stainless cap, and sealed the brick against future water intrusion. Took photos before and after and cleaned up completely.",
          "name": "Roberto S.",
          "date": "2024-09-25",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Our AC was blowing but the air just wasn't cold. Dante diagnosed a frozen coil caused by a failing blower wheel that wasn't moving enough air. He let it thaw, replaced the wheel, and checked the refrigerant charge to be safe. Patient, thorough, and the price was exactly what he quoted up front. House finally comfortable again.",
          "name": "Olivia C.",
          "date": "2025-06-26",
          "service": "HVAC Service",
          "rating": 4.1
        },
        {
          "review": "Great team. Inspection was thorough, shingle repair was clean, and the flashing around the plumbing vents got resealed. Very fair pricing.",
          "name": "Holly V.",
          "date": "2023-06-28",
          "service": "Roofing Service",
          "rating": 4.7
        },
        {
          "review": "Heat pump tune-up before winter. The tech cleaned the outdoor coil, checked the defrost cycle, and recalibrated the thermostat. Heats faster than before.",
          "name": "Felix W.",
          "date": "2025-11-18",
          "service": "HVAC Service",
          "rating": 4.7
        },
        {
          "review": "After 22 years our roof finally needed full replacement. From the first estimate to the final magnet sweep, everything was handled professionally. Emilio walked me through photos of the rotted decking they replaced and the new drip edge along the eaves. The crew showed up at 7 sharp each morning, tarped the entire deck whenever they stopped for the day, and protected my hostas with plywood sheets. When they finished, the yard was immaculate, no scraps of shingle, no nails, nothing. Worth every penny.",
          "name": "Yvonne D.",
          "date": "2025-10-21",
          "service": "Roofing Service",
          "rating": 4.7
        },
        {
          "review": "We'd been told our roof-run vent was impossible to clean without tearing into the ceiling. Frankie proved otherwise. He accessed it from both the laundry connection and the rooftop cap, brushed the whole length, and even resecured a section of flex duct that had come loose in the attic. Honest, skilled, and respectful of our home with drop cloths everywhere.",
          "name": "Melinda W.",
          "date": "2024-09-11",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Booked the yearly sweep last minute before a cold snap and they squeezed me in. Creosote removed, flue inspected, cap checked. Fast and fair.",
          "name": "Omar S.",
          "date": "2026-01-21",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Gabe and the crew did a fantastic job upgrading our attic insulation. They started by air-sealing every gap with foam, including around the recessed lighting and the duct boots, then added baffles before blowing in fiberglass to R-60. What impressed me most was the before-and-after photos and the depth-ruler card they posted by the hatch. Our second floor used to be ten degrees warmer than downstairs in summer, now it's within two. The HVAC system runs far less and our energy bills reflect it.",
          "name": "Simone H.",
          "date": "2025-07-18",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Old house, old smell. The technician sanitized everything and now it actually smells clean. Couldn't be happier. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Desmond P.",
          "date": "2023-11-19",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Solid work. Furnace wasn't heating, Isaiah diagnosed a faulty flame sensor within minutes, cleaned and reseated it, and we had warm air same day. Appreciated the upfront quote.",
          "name": "Derek A.",
          "date": "2024-11-19",
          "service": "HVAC Service",
          "rating": 4.7
        },
        {
          "review": "Javier did a thorough job on a vent that hadn't been cleaned in over a decade. The amount of lint he removed filled a whole bag. Drying time is back to normal and the burning smell is gone.",
          "name": "Carla D.",
          "date": "2025-10-22",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Kyle arrived on time, set up drop cloths, and ran a thorough level-two inspection since we'd just bought the house. He found a cracked clay tile in the liner and corrosion on the cap, all documented in a written report with clear photos and a plain-English summary. I never felt rushed and he answered every question I had about creosote and draft.",
          "name": "Stephanie A.",
          "date": "2025-11-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Quick, clean, effective. Airflow from the supply registers picked up the same day and the dust haze in the sunlight finally disappeared.",
          "name": "Mira S.",
          "date": "2024-09-30",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Gas fireplace was throwing a faint odor when running. Leon checked every connection with a soap test, found a slightly loose flare fitting at the valve, tightened it, and confirmed zero bubbles. Peace of mind restored. He didn't try to sell me anything extra.",
          "name": "Marcus V.",
          "date": "2025-01-09",
          "service": "Fireplaces Service",
          "rating": 4.1
        },
        {
          "review": "From the quote to the finished install everything was straightforward. The crew replaced our aging heat pump, mounted a new air handler in the closet, and re-sealed the supply plenum that was leaking. Mateo checked the static pressure and airflow at each register before he called it done. Tidy, punctual, and exactly the price we agreed on. The house has never been this comfortable.",
          "name": "Camille O.",
          "date": "2025-07-15",
          "service": "HVAC Service",
          "rating": 4.7
        },
        {
          "review": "Our gas fireplace wouldn't stay lit, so I scheduled a cleaning and safety inspection before relying on it all winter. Nasir cleaned the burner and pilot assembly, replaced a worn thermocouple, and tested the flame multiple times. He walked me through how to safely operate the unit and what warning signs to watch for. Transparent pricing right on the invoice. The whole visit was efficient and professional.",
          "name": "Maya D.",
          "date": "2026-01-22",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "After a small lint fire scare at a neighbor's place, I wanted ours inspected immediately. Oscar came the next morning, ran a camera through the duct, and found a heavy lint clog about midway. He cleaned the entire line, tested airflow, and confirmed the vent cap on the roof was clear too. Cannot put a price on knowing my kids are safe.",
          "name": "Harold W.",
          "date": "2025-03-08",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Booked these guys two weeks after closing on our place. Cat odor was baked into the system. The crew was respectful, wore shoe covers, and left the return vents spotless. Worth every penny.",
          "name": "Yumi A.",
          "date": "2025-07-19",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Three cats means a lot of dander floating around, and our air ducts proved it. Pedro pulled out clumps of fur and dust from the supply runs that explained why we were always sniffling. He documented everything with before-and-after photos. The house feels noticeably less stuffy now and I'm not reaching for allergy meds every morning.",
          "name": "Renata F.",
          "date": "2025-06-14",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Hail damage led to a leak over the living room. The tech showed me cracked shingles and a dented vent cap, replaced both, and resealed. Done in an afternoon with a clear written estimate.",
          "name": "Victor H.",
          "date": "2023-04-26",
          "service": "Roofing Service",
          "rating": 4.7
        },
        {
          "review": "Water stains kept reappearing on our bedroom ceiling near the chimney chase. Quincy traced it to a cracked crown and missing cap. Fixed both, applied waterproofing, and it has stayed dry through spring rains.",
          "name": "Melissa D.",
          "date": "2026-03-14",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Hottest week of the year and the compressor wouldn't start. Rashad found a bad run capacitor and a loose wire at the contactor, fixed both, and we were cooling within the hour.",
          "name": "Damien O.",
          "date": "2024-07-27",
          "service": "HVAC Service",
          "rating": 4.7
        },
        {
          "review": "Sean handled my roof inspection and I was impressed by how methodical he was. He checked every valley, the ridge cap, and all the flashing points, then showed me on his phone exactly where two shingles had gone missing after the last storm. He replaced them and resealed the flashing around the bathroom vent. The whole thing took maybe ninety minutes and the written report was emailed before he even left my driveway.",
          "name": "Cassandra L.",
          "date": "2026-04-30",
          "service": "Roofing Service",
          "rating": 4.7
        },
        {
          "review": "We'd been running our AC ragged all summer and it finally got the attention it needed. Travis did the full maintenance, cleaned both coils, replaced a worn contactor, and adjusted the refrigerant. He explained why the system was working harder than it should and what the new pressure readings meant. Cools the whole house evenly now and the compressor isn't straining anymore.",
          "name": "Lorena D.",
          "date": "2025-08-29",
          "service": "HVAC Service",
          "rating": 4.7
        },
        {
          "review": "Excellent full roof replacement. They removed the old layers, installed new ice-and-water shield in the valleys, and added a ridge vent for better attic airflow. Driveway and shrubs stayed protected throughout, and cleanup was thorough.",
          "name": "Carlos V.",
          "date": "2026-03-08",
          "service": "Roofing Service",
          "rating": 4.7
        },
        {
          "review": "Quick and effective on a tough vertical vent. Uriel cleared the roof termination and the upstairs laundry finally vents right.",
          "name": "Hugo P.",
          "date": "2025-10-02",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Vince was fantastic during our annual chimney sweep. He found stage three creosote glaze that needed special treatment, explained the process clearly, and didn't rush it. After two passes the flue liner was clean and he documented it all with before-and-after photos. Honest about what the chimney needed and what could wait until next year.",
          "name": "Priya N.",
          "date": "2024-09-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wes explained why our old batts weren't cutting it and recommended blown-in on top after sealing the leaks. The temperature difference upstairs is dramatic. Clean, fast, professional.",
          "name": "Reggie C.",
          "date": "2024-03-21",
          "service": "HVAC Service",
          "rating": 4.7
        },
        {
          "review": "Yosef was incredibly knowledgeable. He explained that the musty smell coming through our vents was from organic buildup deep in the ducts, not just the filter. He ran a sanitizing treatment, vacuumed all the registers, and provided before-and-after photos. The whole house smells fresh now and I appreciated that he wore shoe covers without me even asking.",
          "name": "Yvette C.",
          "date": "2026-04-27",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Came home from work to a cold house in the middle of a January storm. I called expecting a wait but the scheduler had Zane out before 6pm. He found the condensate pump had failed and backed up, tripping the safety. Swapped the pump, cleared the line, and confirmed the burners were clean. Professional, respectful of our floors with shoe covers, and the heat hasn't skipped since.",
          "name": "Nicole H.",
          "date": "2025-02-19",
          "service": "HVAC Service",
          "rating": 4.1
        },
        {
          "review": "Months of damp clothes and rising electric bills finally got me to act. Aaron pulled the dryer out, found the flex hose crushed behind it, and cleared a solid plug of lint from the wall duct. He replaced the kinked flexible transition with a rigid section so it won't collapse again. Airflow at the exterior vent is strong now and a load dries in one go. Friendly, on time, and explained everything in plain terms without pushing extras.",
          "name": "Gregory V.",
          "date": "2026-04-09",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Solid inspection, clear written report, fair price. The technician showed me the camera footage of the flue in real time.",
          "name": "Marcus W.",
          "date": "2023-08-30",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Brett was professional from start to finish. He laid down drop cloths, vacuumed every return and supply vent, and showed me the gunk he pulled out. Our HVAC stopped that whistling strain and the air felt crisp by the afternoon. Booked them again for the dryer vent next month.",
          "name": "Caleb V.",
          "date": "2026-02-14",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Our older gas logs looked tired and the flame was uneven. The crew cleaned the entire firebox, vacuumed the burner ports, and reset the log placement to factory spec. They also replaced the glowing embers material that had burned out over the years. Looks like a brand-new fire now, warm and full. Family-owned outfit and you can tell they take pride in the details.",
          "name": "Phoebe N.",
          "date": "2024-02-14",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "New furnace went in clean and on time. Tech laid down drop cloths and vacuumed up after himself. Walked me through the new filter size and how often to swap it.",
          "name": "Theodore N.",
          "date": "2023-03-09",
          "service": "HVAC Service",
          "rating": 4.7
        },
        {
          "review": "First time using Rocket Air Care and I'm impressed. Cody did a full fireplace cleaning, brushed the flue, and inspected the firebox for cracks. Found minor creosote glazing and explained why it builds up. Clean, courteous, and on time.",
          "name": "Derek S.",
          "date": "2025-11-12",
          "service": "Fireplaces Service",
          "rating": 4.1
        },
        {
          "review": "Fast and tidy. Dante cleared the lint from a long basement run and sealed a loose duct joint that was leaking warm air. Dries great now and the fire risk is handled.",
          "name": "Bianca S.",
          "date": "2024-07-04",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Twenty-plus years in business and you can tell. Emilio knew immediately the smell in our new home was coming from pet dander trapped in the ductwork, not the carpet like we assumed. He showed me the supply ducts before and after and the difference was night and day. No upselling, transparent price, friendly the whole time.",
          "name": "Bridget H.",
          "date": "2026-04-18",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Skeptical at first about whether duct cleaning would help my allergies, but the proof was in the collection bin. Frankie was meticulous with each return vent and explained why the buildup was triggering my symptoms. Honest, no hidden fees, and they showed up exactly when promised.",
          "name": "Glenn A.",
          "date": "2024-07-29",
          "service": "Air Duct Service",
          "rating": 4.1
        },
        {
          "review": "Severe storm flipped up shingles near the gable and rain found its way in fast. Within hours of calling, Gabe arrived, tarped the section, and scheduled the repair. He came back to replace the shingles, install new drip edge, and reseal the flashing. He sent before and after photos and a detailed report. Could not have handled an emergency more professionally.",
          "name": "Renata C.",
          "date": "2025-08-17",
          "service": "Roofing Service",
          "rating": 4.7
        },
        {
          "review": "Quick and honest. Crown sealed, new cap, done. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Omar J.",
          "date": "2024-06-22",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Early heat wave caught us off guard and the AC wouldn't cool past 80. The office got Isaiah out the next morning. He found the TXV valve was sticking and the system was undercharged. He corrected the charge, verified superheat and subcooling, and made sure every room was getting cold air. Took the time to walk me through the readings. Very professional.",
          "name": "Bethany L.",
          "date": "2026-04-29",
          "service": "HVAC Service",
          "rating": 4.7
        },
        {
          "review": "Needed a roof inspection for my insurance renewal. Javier was on time, polite, and walked the whole roof. Found minor flashing separation near the dormer and fixed it on the spot. Report ready same day.",
          "name": "Derrick A.",
          "date": "2024-12-14",
          "service": "Roofing Service",
          "rating": 4.1
        },
        {
          "review": "Prompt and professional. Kyle serviced the furnace, cleaned the burners, and replaced the filter. No hidden fees, exactly the quoted price.",
          "name": "Ahmed J.",
          "date": "2024-12-04",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Needed the whole roof redone after years of patchwork. Crew tore it down to the deck, found and replaced two soft sheathing panels, and installed new flashing around the skylights. They laid drop cloths everywhere and the post-job nail sweep was impressively thorough.",
          "name": "Heather N.",
          "date": "2024-06-27",
          "service": "Roofing Service",
          "rating": 4.6
        },
        {
          "review": "My laundry room is on the first floor but the vent snakes all the way up and out the roof, so the lint had nowhere easy to go. Leon mapped the run, cleaned it in sections, and showed me a video of the now-clear duct. He also wiped down behind the dryer. The before/after photos of the rooftop cap were eye-opening.",
          "name": "Gwendolyn M.",
          "date": "2026-04-16",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Solid annual sweep. Drop cloths everywhere, creosote bagged and hauled out, no dust in the house. The tech even wiped down the glass doors.",
          "name": "Roy G.",
          "date": "2025-12-28",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "We'd been running our AC nonstop with little relief. The attic upgrade changed everything. Mateo's team sealed the top plates, addressed a couple of gaps where the attic met the garage, and blew in cellulose to bring it up to current standards. They were respectful of the house, wore shoe covers inside, and cleaned up completely. The upstairs is finally comfortable and the system isn't straining anymore.",
          "name": "Lucinda B.",
          "date": "2025-10-29",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Persistent earthy smell whenever the AC ran. Nasir treated the supply ducts with an antimicrobial sanitizer and it cleared up beautifully. Quick and no mess.",
          "name": "Roland H.",
          "date": "2024-05-13",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Furnace went out overnight and Oscar had it running again by early afternoon. Replaced a worn igniter and tested the cycle twice. Honest and efficient.",
          "name": "Patrick O.",
          "date": "2024-12-23",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Such a relief. The tech cleared the vent, replaced the crushed exterior flap, and showed me before and after photos. Towels dry in 30 minutes now.",
          "name": "Priya L.",
          "date": "2025-05-17",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Pleasantly surprised by how detailed the written report was. Pedro checked the chimney crown, flashing seal, and damper, then included a moisture note about the crown cracking and how it could let water in. Photos were labeled by location so I could match each finding to the right spot. Worth every penny for the documentation alone.",
          "name": "Felicia J.",
          "date": "2026-04-28",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Reasonable price and honest work. The tech cleaned the ductwork and pointed out our filter was the wrong size, which was restricting airflow. Swapped it and the difference standing under the vent was obvious that same day.",
          "name": "Yolanda E.",
          "date": "2025-05-07",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Quincy diagnosed why our gas logs kept shutting off after a few minutes. Turned out the thermopile was failing and the safety valve was cutting fuel. He replaced it and ran the unit for twenty minutes to confirm. No more shutdowns. Honest and efficient.",
          "name": "Ignacio P.",
          "date": "2025-10-05",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Whole-home system replacement handled professionally start to finish. Rashad and the crew arrived on the dot, removed the 20-year-old unit, and installed a new variable-speed furnace and matching condenser. They pulled a deep vacuum on the line set, verified the refrigerant charge, and left a typed report. The thermostat is now app-controlled and they made sure I knew how to use it. No mess left behind anywhere.",
          "name": "Imani C.",
          "date": "2025-02-26",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Wonderful service ahead of the holidays. The crew came out, laid drop cloths everywhere, and cleaned our fireplace and flue thoroughly. They checked the damper, the cap, and the crown, then handed me a written report with photos showing the before and after. Nothing was rushed and every question got a real answer. You can tell this is a family business that takes pride in the work. Booking the safety check before winter gave us total peace of mind.",
          "name": "Lorraine A.",
          "date": "2024-12-18",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Such a relief to finally get this done. The technician explained how lint is extremely flammable and how a blocked vent traps heat, which is the real danger. He brushed the full run, vacuumed the trap cavity, and replaced a kinked flex hose with smooth metal. Transparent pricing, no surprises, and I feel so much safer running the dryer overnight now.",
          "name": "Quentin H.",
          "date": "2025-08-26",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "The home we bought had a faint kennel smell. One duct cleaning later and it's gone. Sean was efficient and explained the airflow improvement.",
          "name": "Omar J.",
          "date": "2025-11-25",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Excellent service. The crew laid drop cloths, wore shoe covers, and cleaned all supply and return ducts in about three hours. Dust on the mantel is way down.",
          "name": "Carla J.",
          "date": "2025-01-22",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Leak appeared over the stairwell after an overnight storm. Travis tracked it to failed flashing around the skylight, resealed it, and replaced two cracked shingles nearby. Fast scheduling and fair pricing, no hidden fees added on at the end.",
          "name": "Desmond P.",
          "date": "2024-12-19",
          "service": "Roofing Service",
          "rating": 4.6
        },
        {
          "review": "Outstanding service on a tricky leak. Our chimney sits on a steep roof and water was finding its way through the crown joints. Uriel secured everything safely, ground out the bad mortar, recapped the crown with a flexible sealant rated for movement, installed a multi-flue stainless cap, and waterproofed the entire stack. He explained why the previous patch job failed and gave me a written warranty. Two heavy storms later, bone dry inside.",
          "name": "Bethany O.",
          "date": "2025-11-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Condensate overflow shut the unit down on a 99-degree day. Cleared, cleaned, and cooling in no time. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Ramon E.",
          "date": "2025-07-11",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Spotted some granules in my downspouts and got nervous about the roof. The technician inspected everything and reassured me it was normal wear, but he did replace three brittle shingles and reseal the flashing near the ridge vent while he was up there. Honest assessment and no pressure to do more than needed. Appreciated the clear photos he texted me afterward.",
          "name": "Bianca O.",
          "date": "2025-05-18",
          "service": "Roofing Service",
          "rating": 4.1
        },
        {
          "review": "Maintenance plan customer here. Vince comes out twice a year and this spring he caught a low refrigerant charge before it became a real problem. He topped it off, cleaned the condenser coils, and flushed the condensate drain. The AC is back to cooling like new and I appreciate that he always shows me the readings instead of just telling me everything's fine.",
          "name": "Sandra E.",
          "date": "2025-03-21",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Professional from start to finish on a complete reroof. Wes and the crew replaced the rotted fascia, installed new step flashing along the chimney, and put on a clean run of architectural shingles. They magnet-swept the lawn and driveway and even blew off the patio before leaving.",
          "name": "Tyler G.",
          "date": "2025-05-16",
          "service": "Roofing Service",
          "rating": 4.6
        },
        {
          "review": "Long run, roof exit, and a dryer that was overheating. Yosef diagnosed a near-total clog about 15 feet up, cleared it, and tested airflow at the cap before leaving. Same-day appointment and transparent pricing.",
          "name": "Felix J.",
          "date": "2025-02-23",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Zane arrived right in the scheduled window and got to work on our yearly cleaning. The creosote layer was moderate but he was meticulous, brushing the full length of the flue and clearing the damper area. He showed me a cracked crown on the camera and quoted a repair, but never pressured me. Appreciated the transparency.",
          "name": "Felicia U.",
          "date": "2025-07-24",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Top-notch attic insulation job. Sealed the bypasses, added baffles, blew in to R-49. Bedrooms hold heat overnight now and the furnace cycles less. Worth every dollar.",
          "name": "Felix N.",
          "date": "2024-09-05",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "My elderly mother kept complaining about a moldy smell in her apartment and I worried about her breathing it in. The crew came out, found mildew in the return vents, and sanitized the entire duct system the same day. They were patient explaining everything to her and left a written report. The smell is completely gone and she feels better. Grateful for this company.",
          "name": "Tessa W.",
          "date": "2025-02-28",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Heat completely dead during a cold front. The technician traced it to a blown transformer feeding the control board, had the part on hand, and got us warm the same day. Tidy and clear about the cost.",
          "name": "Samantha G.",
          "date": "2025-11-15",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Aaron was professional and quick. He found a bird had built a nest in our exterior vent hood on top of years of lint buildup, which explained why nothing was drying. Cleared it all out, installed a guard cap, and now the dryer runs like new. Great value for the work.",
          "name": "Felicia A.",
          "date": "2024-09-02",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Reached out for a chimney safety check before our first fire of the season. Brett inspected the flue, measured the creosote, and confirmed the stainless cap and screen were intact. The written report gave us a green light with one minor note about repointing some exterior mortar down the road. Friendly and knowledgeable.",
          "name": "Owen H.",
          "date": "2025-10-02",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "After we moved into an older home, the air always smelled musty. Cody ran a full duct cleaning, treated the returns, and sealed the panels tight. By that evening the must was gone and the airflow upstairs improved dramatically. He left a written report detailing each line he serviced. Twenty-plus years of experience clearly shows in how methodical the crew was.",
          "name": "Theo G.",
          "date": "2024-02-19",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "What a relief to find a company that actually knows gas-log systems. Dante arrived on time, laid a drop cloth, and methodically went through the burner, pilot, thermocouple, and gas pressure. He found a partially clogged orifice causing the weak flame, cleared it, and the difference was night and day. He also adjusted the logs so the flames lick around them naturally. Clear pricing up front and a written summary emailed before he even left the driveway.",
          "name": "Brigitte O.",
          "date": "2026-05-12",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Replaced both the furnace and AC in one visit. Emilio was meticulous, leveled the condenser, ran new whip and disconnect, and sealed the duct transitions. Pricing was transparent and the work finished right on schedule.",
          "name": "Vincent A.",
          "date": "2024-09-22",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Solid pre-season fireplace inspection. Frankie swept the firebox, checked the flue liner with a camera, and made sure the damper moved freely. Honest assessment, no scare tactics. Fair price.",
          "name": "Ian Q.",
          "date": "2025-09-19",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Gabe did a fantastic job on our dryer vent cleaning. He found the exterior hood completely matted with lint and a blockage at the elbow joint. After clearing it, he ran an airflow test and the difference was huge. Highly recommend for anyone worried about dryer fires.",
          "name": "Felicia C.",
          "date": "2024-12-15",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Couldn't figure out why our brand new home felt stuffy and smelled faintly of animal until a neighbor suggested the ducts. So glad we called. Isaiah pulled every register, ran the vacuum line through both supply and return ducts, and showed me handfuls of matted pet hair the previous owners left behind. He fogged a deodorizer afterward and the air smells clean for the first time since we moved in. Will use them again for the dryer vent.",
          "name": "Natasha V.",
          "date": "2026-02-04",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Persistent dust and a musty smell from the vents had us worried about air quality. Javier ran a camera through the ducts first, showed me the buildup on a screen, then brushed and vacuumed every run. He also pointed out a loose return that was pulling in attic dust. The transparency was refreshing and the air smells clean now.",
          "name": "Devon U.",
          "date": "2025-09-11",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Wind storm ripped open a corner of the roof and water poured into the upstairs bedroom. The office moved us to the front of the line and Kyle was out within the hour to tarp it. He returned to replace the decking, underlayment, and shingles, and walked me through photos of the whole repair. Worth every dollar and then some.",
          "name": "Aisha M.",
          "date": "2026-04-09",
          "service": "Roofing Service",
          "rating": 4.6
        },
        {
          "review": "Dampness and a musty smell from the firebox tipped us off. Leon found the crown had eroded and the cap rusted open. He replaced the cap with stainless, recrowned with overhang, and sealed the masonry. Friendly and didn't upsell anything we didn't need.",
          "name": "Diane V.",
          "date": "2024-10-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "System froze up solid and the house climbed to 83. Mateo explained it was a dirty filter plus low charge, thawed the coil, replaced the filter, found a tiny leak, sealed it, and recharged. He also vacuumed up the water from the drain pan and wiped down the air handler. Cool, dry air restored by dinner. Honest crew.",
          "name": "Whitney G.",
          "date": "2024-08-09",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Fast, friendly, and fair. Swapped a couple cracked shingles and resealed flashing around the vent pipe. Recommend them. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Stan C.",
          "date": "2023-03-11",
          "service": "Roofing Service",
          "rating": 4.6
        },
        {
          "review": "Got the system tuned up and the difference is obvious. Cleaned coils, new filter, checked the blower motor amperage. Runs cooler and quieter.",
          "name": "Victor N.",
          "date": "2024-06-19",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Our 1970s roof was overdue for replacement. The team tore everything off, replaced several decking boards, and installed new underlayment, drip edge, and dimensional shingles over two and a half days. The cleanup crew came through afterward with a rolling magnet and got every last nail out of the gravel driveway. Couldn't ask for a smoother experience.",
          "name": "Angela M.",
          "date": "2026-04-30",
          "service": "Roofing Service",
          "rating": 4.6
        },
        {
          "review": "Booking through the office was simple and they understood right away that we had a complicated roof-vented setup. The two-person crew worked the run from inside and on the roof at the same time, which made it fast. They removed a serious lint blockage near the termination and showed me everything they pulled out. No mess left behind, shoe covers on, very professional family-run operation.",
          "name": "Adaeze U.",
          "date": "2024-07-04",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Highly recommend for annual chimney maintenance. Nasir removed years of creosote we inherited from the previous owners, inspected the flue liner with a camera, and replaced a rusted-out cap with a new stainless one. The written report walked through every issue with photos. He spent nearly two hours making sure it was done right and left the room cleaner than he found it.",
          "name": "Nathaniel P.",
          "date": "2024-08-06",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Booked them after a friend raved about her attic upgrade. Glad I listened. They removed old rodent-damaged insulation, sanitized the space, sealed the penetrations, and blew in fresh cellulose. Oscar walked me through the whole plan beforehand and the crew finished in a day. The difference in how evenly the house heats is remarkable, and the thermostat reads steady all evening now instead of climbing.",
          "name": "Antoinette G.",
          "date": "2025-12-16",
          "service": "HVAC Service",
          "rating": 4.6
        },
        {
          "review": "Reached out about a musty odor we couldn't track down. Pedro figured out it was the ducts within minutes, ran a sanitizing fog, and cleaned the supply vents. Honest pricing and a thorough job.",
          "name": "Curtis E.",
          "date": "2024-12-16",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "What a relief. No heat, newborn at home, freezing outside. Quincy answered the call himself and arrived within a couple hours. Found the gas furnace was locking out on a faulty flame rollout switch, replaced it, inspected the heat exchanger for cracks to be safe, and walked me through the whole diagnosis. He didn't leave until warm air was steady at every register. This is how a family business should run.",
          "name": "Vanessa C.",
          "date": "2025-01-06",
          "service": "HVAC Service",
          "rating": 4.5
        },
        {
          "review": "Highly recommend for anyone dealing with slow drying. Rashad traced our long vent run from the basement laundry up two floors and out the roof. It was nearly solid with lint. He brushed and vacuumed the full length, then checked the dryer's lint trap cavity which had its own buildup. Drying time was cut by more than half and the basement doesn't get humid during laundry anymore. Fair price and very clean work, drop cloths down the whole time.",
          "name": "Stuart B.",
          "date": "2025-07-30",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "No fuss inspection. Got photos and a written summary the same day. Fair price, friendly crew, and a job done right the first time — no complaints at all.",
          "name": "Dana V.",
          "date": "2024-03-26",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "My asthma flares with dust, so I was overdue for this. The technician was careful with shoe covers and drop cloths and walked me through before and after photos of the supply ducts. Breathing was easier the same night and the vents finally push strong air into the den.",
          "name": "Ingrid N.",
          "date": "2025-10-12",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Switch on the wall did nothing. Sean found a broken wire at the millivolt connection, repaired it, and tested the valve. Fireplace fires up instantly now. In and out in under an hour.",
          "name": "Roland E.",
          "date": "2024-05-23",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Our furnace was on its last legs and the new install couldn't have gone smoother. Travis arrived first thing, protected the floors, and had the new 95% efficiency unit set and venting properly by lunch. He showed me the new PVC intake and exhaust runs and explained the condensate trap. Honest, clean, and right on the dollar amount quoted.",
          "name": "Delphine G.",
          "date": "2026-05-11",
          "service": "HVAC Service",
          "rating": 4.5
        },
        {
          "review": "Set up a fireplace cleaning and safety check after smelling smoke in the living room last winter. Uriel investigated, found creosote buildup restricting the flue, and cleaned it out completely. He also discovered the damper wasn't opening fully and adjusted it. Showed me everything on camera so I understood the problem. No more smoke issues. Genuinely appreciate the thoroughness and the clear written report.",
          "name": "Tasha E.",
          "date": "2026-02-04",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Reached out because our dryer was leaving clothes damp and smelling musty. Vince traced it to a lint-packed vent that wasn't exhausting properly. He cleaned the entire duct, scrubbed the lint trap, and showed me how to maintain it between visits. Now it dries in one cycle and the fire hazard is gone.",
          "name": "Damon L.",
          "date": "2025-05-13",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Dog smell in the vents was the dealbreaker for my wife. Wes and the crew cleaned the whole system and the odor disappeared. Drop cloths down, shoe covers on.",
          "name": "Phillip D.",
          "date": "2025-06-12",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Allergy season used to wreck me. After Yosef cleaned the supply ducts and replaced our filter, my symptoms eased within a week. He was tidy, professional, and explained everything in plain terms.",
          "name": "Fiona C.",
          "date": "2024-04-05",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Roof started leaking at the chimney after heavy rain. Zane found the cricket flashing had failed and rebuilt it. Sealed everything tight and gave me a written report. Solid, no-nonsense repair.",
          "name": "Gordon E.",
          "date": "2023-06-15",
          "service": "Roofing Service",
          "rating": 4.5
        },
        {
          "review": "Reasonably priced crown repair and waterproofing. The technician showed me the cracks on his phone before starting and the office had texted a confirmation the day before. No more drips down the flue when it rains.",
          "name": "Curtis E.",
          "date": "2025-02-04",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Outdoor fan stopped during a heat advisory. Aaron replaced the motor and capacitor same day, tested the cycle, and the house was cooling within an hour. Fair price.",
          "name": "Felix N.",
          "date": "2023-07-18",
          "service": "HVAC Service",
          "rating": 4.5
        },
        {
          "review": "Brett performed a detailed inspection after I noticed a damp spot in the attic. He traced it to a tiny gap in the step flashing along the chimney and resealed it, then replaced two shingles that had been compromised. What stood out was how carefully he explained everything and showed me the before and after photos so I understood the repair. The price matched the estimate exactly, no hidden fees whatsoever.",
          "name": "Yvonne T.",
          "date": "2024-10-27",
          "service": "Roofing Service",
          "rating": 4.5
        },
        {
          "review": "Cody handled our seasonal HVAC check and I was impressed with the thoroughness. He cleaned the evaporator coil, tested the capacitor, checked refrigerant pressures, and cleared the drain line. Laid down a drop cloth and wore shoe covers the entire time. The written report broke down every reading. House cools faster and the energy bill reflects it.",
          "name": "Meredith A.",
          "date": "2025-05-27",
          "service": "HVAC Service",
          "rating": 4.5
        },
        {
          "review": "Full tear-off and new roof installed efficiently. Crew protected the deck and landscaping with tarps, replaced the flashing at the wall-to-roof transition, and hauled the old shingles off the same day. Yard was spotless when they wrapped up.",
          "name": "Jordan E.",
          "date": "2024-02-23",
          "service": "Roofing Service",
          "rating": 4.5
        },
        {
          "review": "Dante tackled our 28-foot vent that exits through the roof and had clearly never been serviced. He found lint compacted at two elbows, cleared both, and replaced the dented exterior vent hood with a proper cap. Drying time dropped noticeably. Appreciated the written report he left with airflow readings before and after.",
          "name": "Lindsey H.",
          "date": "2025-12-01",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Yearly sweep handled efficiently. Creosote out, flue brushed, cap secure. The scheduler called ahead with an ETA. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Sasha L.",
          "date": "2026-04-02",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Master suite over the porch was always the coldest room. After they air-sealed and added insulation it's finally comfortable. Emilio was knowledgeable and friendly.",
          "name": "Trent O.",
          "date": "2026-04-22",
          "service": "HVAC Service",
          "rating": 4.5
        },
        {
          "review": "Impressed by how methodical the team was. After remodeling, our house smelled like damp drywall through every vent. They sanitized the entire duct network, replaced the filter, and showed me photos of the dust and debris they removed from the returns. The musty smell is gone and the air feels lighter. Will use them again for sure.",
          "name": "Lorena J.",
          "date": "2025-07-09",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Furnace stopped firing on a frigid Saturday. Same-day visit, replaced a cracked hot surface igniter, and back to warm in under an hour. Great value.",
          "name": "Trevor M.",
          "date": "2024-02-09",
          "service": "HVAC Service",
          "rating": 4.5
        },
        {
          "review": "Came home to a dryer that wouldn't dry and a hot laundry room. The crew arrived next day, cleared an enormous lint clog from the vent elbow, and tested the airflow before leaving. One cycle dries everything now.",
          "name": "Renata C.",
          "date": "2026-05-11",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "We've used a few chimney companies over the years and this was by far the most transparent. Frankie explained that the inspection comes with a written report regardless of whether we hired them for repairs. He documented a deteriorating flue liner and a loose crown, attached before photos, and didn't pad the findings. Trust matters with this kind of work and they earned ours.",
          "name": "Theresa M.",
          "date": "2025-03-13",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Good experience overall. Two techs cleaned all the returns and supplies in about two and a half hours. Airflow improved noticeably and the dusty smell when the AC kicked on is gone.",
          "name": "Roman A.",
          "date": "2023-05-16",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Our gas-log fireplace hadn't been serviced since we bought the home. Gabe did a complete tune-up: cleaned the logs and burner, tested the oxygen depletion sensor, verified the gas pressure with a manometer, and cleaned the glass. He flagged that the pilot flame was riding low and adjusted it so it fully covered the thermocouple. Patient, knowledgeable, and the price matched the estimate exactly.",
          "name": "Camila J.",
          "date": "2025-12-19",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Needed a new system before winter and they delivered. Isaiah swapped the furnace, tied in the existing returns, and balanced the airflow room by room. Trucks were fully stocked so there were no delays waiting on parts.",
          "name": "Garrett U.",
          "date": "2025-10-04",
          "service": "HVAC Service",
          "rating": 4.5
        },
        {
          "review": "Friendly and knowledgeable from the first phone call. The office scheduled me fast, and the tech arrived ready to work. He cleaned the firebox, inspected the flue, and verified the cap and crown were in good shape. Left no mess and gave honest feedback. Great value for a thorough job.",
          "name": "Roberto V.",
          "date": "2024-11-15",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Couldn't believe how much lint came out of a vent we thought was fine. Javier pulled it from a run that snaked through the ceiling, cleared the wall cap, and bagged it all for me to see. Sobering how big a fire risk that was. Great work.",
          "name": "Yvette G.",
          "date": "2024-04-22",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Excellent service from start to finish. We inherited a house with serious cat dander in the return vents. The tech showed me a camera feed of the ducts before he started, which built a lot of trust. After cleaning, he ran the camera again so I could see the difference. The lingering odor is gone and the office quoted me an honest, flat price with no hidden fees. Highly recommend for any new homeowner dealing with the same thing.",
          "name": "Daniela E.",
          "date": "2026-05-20",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Pleasantly surprised by how thorough this was. Kyle didn't rush, cleaned every return vent and supply run, and left a written report of the work. The dust on our blinds has noticeably decreased and I'm sleeping better with less congestion.",
          "name": "Hugo V.",
          "date": "2025-05-16",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Storm left a leak right over the nursery, which had me panicked. Called and they understood the urgency, sending Leon out the same afternoon. He found lifted shingles and a gap in the flashing, tarped it, then did a permanent repair the following morning. Tidy, kind, and the price matched the estimate exactly.",
          "name": "Tabitha J.",
          "date": "2025-05-21",
          "service": "Roofing Service",
          "rating": 4.5
        },
        {
          "review": "Couldn't be happier. Mateo rebuilt our cracked crown, added a proper drip edge, installed a custom stainless cap, and sealed the brick with a breathable waterproofer. He laid drop cloths through the living room and vacuumed after. The detailed report even noted minor flashing wear to watch. Trustworthy crew.",
          "name": "Felicia G.",
          "date": "2026-04-02",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Late-summer heat and our AC just stopped putting out cold air. Nasir arrived promptly, hooked up his gauges, and found the refrigerant nearly empty due to a leak at a corroded fitting. He repaired the fitting, pulled a vacuum, recharged to factory spec, and checked the temperature drop at the registers. Detailed, tidy, and the cost matched the estimate to the dollar.",
          "name": "Angela R.",
          "date": "2025-09-01",
          "service": "HVAC Service",
          "rating": 4.5
        },
        {
          "review": "Booked an inspection because shingles were scattered in the yard after a storm. The crew replaced the missing ones, resealed the flashing around the skylight, and left the property spotless. Professional all around.",
          "name": "Hassan E.",
          "date": "2026-02-08",
          "service": "Roofing Service",
          "rating": 4.5
        },
        {
          "review": "Furnace tune-up before the cold set in. Tech inspected the heat exchanger, cleaned the flame sensor, and tested CO levels. Peace of mind for the season.",
          "name": "Roberto Q.",
          "date": "2025-10-14",
          "service": "HVAC Service",
          "rating": 4.4
        },
        {
          "review": "Whole roof replaced and I'm thrilled. Oscar's crew was courteous, explained the new pipe boots and ridge vent, and kept the work area tidy each day. The final magnet sweep caught nails I never would have found.",
          "name": "Felicia A.",
          "date": "2025-08-09",
          "service": "Roofing Service",
          "rating": 4.4
        },
        {
          "review": "Top-notch work on a hard roof run. Pedro cleared it completely and the lint trap stays clean now. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Mateus V.",
          "date": "2026-05-10",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "After a chimney fire scare last winter we get the annual sweep without fail now. Quincy was thorough, removing heavy creosote and checking the flue liner for any cracks or damage from the heat. He confirmed everything was structurally sound and gave us a detailed report. Reassuring to have a pro who knows what to look for.",
          "name": "Gwen E.",
          "date": "2025-02-18",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Twenty-two years in business clearly shows. Rashad's crew did a meticulous attic insulation upgrade, starting with sealing the ductwork joints and the chimney chase gap before topping the whole attic to R-60. They left a detailed written report with photos. Our energy use is down and the upstairs bedrooms no longer overheat in the afternoon sun. Highly recommend for anyone with comfort issues.",
          "name": "Marlene Z.",
          "date": "2024-06-13",
          "service": "HVAC Service",
          "rating": 4.4
        },
        {
          "review": "Stale, musty air bugged us for months. One sanitizing visit and it's fresh again. Sean was friendly and tidy. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Aaron-Michael Q.",
          "date": "2026-02-11",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Our older furnace quit heating and I assumed it was finally dead. Travis came out the same afternoon, found it was just a stuck gas valve and a dirty burner assembly, cleaned everything thoroughly, and got it running like new. Could have easily told me to buy a whole new system but he was straight with me. Saved us thousands. Written report included photos of the burners before and after.",
          "name": "Donald R.",
          "date": "2025-12-02",
          "service": "HVAC Service",
          "rating": 4.1
        },
        {
          "review": "Solid work. Vent was choked with lint, tech cleared it fast, drying is back to normal. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Aaron T.",
          "date": "2024-11-27",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Uriel handled our inspection with real care. He noticed the damper was warped and the firebox had a couple of cracked bricks, both captured in the written report with close-up photos. Appreciated that he wore shoe covers and cleaned up the small amount of soot that came down during the camera scan.",
          "name": "Karl B.",
          "date": "2024-12-18",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Outstanding from the first call. The scheduler fit me in quickly and Vince arrived on time with a fully stocked truck. He cleaned every register, vacuumed the trunk lines, and replaced our filter. The same afternoon, the air felt noticeably cleaner and our weak back-room vent finally delivered real airflow. No hidden fees, exactly the quote they gave me. Couldn't ask for more.",
          "name": "Camille J.",
          "date": "2026-05-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Logs were sitting wrong and the flame pattern looked off. Tech repositioned every log per the manufacturer's chart and the fire instantly looked more realistic. Small fix, big difference.",
          "name": "Edmund G.",
          "date": "2023-12-11",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Outstanding from the first phone call. The office scheduled us quickly, gave a clear written estimate, and the install team showed up exactly on time. Wes replaced our condenser and air handler, ran a fresh line set, and pulled a proper vacuum before charging the refrigerant. He tested every supply vent for airflow and left a tidy mechanical room. The price matched the quote with zero surprise fees, and the new system is whisper quiet.",
          "name": "Renata Q.",
          "date": "2024-06-14",
          "service": "HVAC Service",
          "rating": 5
        },
        {
          "review": "Couldn't ask for better. Yosef cleaned years of soot out of our masonry fireplace, swept the flue, and inspected the smoke chamber and damper carefully. He found a small gap in the mortar joints and recommended monitoring it rather than pushing an expensive repair. Honest people. Drop cloths and shoe covers the whole visit, and a detailed report afterward.",
          "name": "Gwendolyn F.",
          "date": "2025-10-25",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Outstanding. As a family business they clearly take pride in the work. The tech wore shoe covers, protected the floor, and spent real time clearing the lint from the full duct and the rooftop vent hood. He left a written report noting the airflow improved dramatically. I sleep easier knowing there's no fire hazard lurking behind the dryer.",
          "name": "Curtis J.",
          "date": "2025-01-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Moved in, smelled dog, called Rocket. Problem solved in one visit. Zane was great. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Khalil R.",
          "date": "2025-09-03",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Quick, courteous, and effective. Less dust everywhere within days of the cleaning. Fair price, friendly crew, and a job done right the first time — no complaints at all.",
          "name": "Theresa O.",
          "date": "2023-07-19",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Downpour exposed a leak near the roof eave. Aaron pulled back the gutter, found rotted fascia and a gap in the drip edge letting water in, and fixed both. Showed me the damp spot in the attic and confirmed it had dried out on his follow-up. Professional and quick.",
          "name": "Roland U.",
          "date": "2024-08-28",
          "service": "Roofing Service",
          "rating": 4.4
        },
        {
          "review": "Persistent moisture problem solved. Brett explained that our porous old brick was acting like a sponge and the cap gap was making it worse. He fitted a new cap, repaired the crown, and applied a siloxane-based waterproofer that lets the masonry breathe. Clean, professional, and fairly priced.",
          "name": "Walter K.",
          "date": "2025-05-27",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Compressor wouldn't engage in 95-degree heat. Hard-start kit installed, cold air back fast. Great service. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Spencer J.",
          "date": "2024-06-14",
          "service": "HVAC Service",
          "rating": 4.4
        },
        {
          "review": "Pleased with the whole process. Cody inspected the roof, identified loose flashing near the gable, and resealed it along with replacing four worn shingles. He kept me updated the entire time and the written report had photos of every repair. Pricing was transparent and the office was easy to coordinate with.",
          "name": "Melissa J.",
          "date": "2025-07-22",
          "service": "Roofing Service",
          "rating": 4.4
        },
        {
          "review": "Phoned the office for a maintenance appointment and they fit me in two days later. Dante checked the refrigerant charge, cleaned the condenser, and recalibrated a thermostat that had been running the AC nonstop. He found a loose wire at the contactor and tightened it up. The unit cycles properly now and the upstairs finally cools down at night.",
          "name": "Yvonne H.",
          "date": "2025-06-23",
          "service": "HVAC Service",
          "rating": 4.4
        },
        {
          "review": "Old three-tab roof came off and beautiful new architectural shingles went on. The crew replaced rotted decking near the back valley and installed new ice-and-water shield. They covered my AC condenser and garden with plywood and tarps, and the nail cleanup was done with a proper rolling magnet, not just a rake.",
          "name": "Derek O.",
          "date": "2024-12-15",
          "service": "Roofing Service",
          "rating": 4.4
        },
        {
          "review": "After a home inspection flagged our roof-terminated dryer vent as a fire risk, I called Rocket. Emilio arrived on time, harnessed up, and cleaned the entire long run from the rooftop down. He found the cap screen was clogged solid and replaced it with a stainless one. Patient, thorough, and explained why roof runs need cleaning more often than typical vents.",
          "name": "Bianca E.",
          "date": "2024-10-25",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Frankie did a careful job on our annual cleaning. He vacuumed the firebox, brushed the creosote from the flue, and pointed out that our damper wasn't closing fully. Quick fix and now we're not losing heat up the chimney. Professional and clean.",
          "name": "Bianca J.",
          "date": "2024-12-10",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Got several quotes and theirs was transparent with no hidden fees. The team blew in loose-fill insulation, sealed the attic hatch, and baffled the eaves. Living room stays warm without the furnace running all night now.",
          "name": "Desmond E.",
          "date": "2025-03-12",
          "service": "HVAC Service",
          "rating": 4.4
        },
        {
          "review": "Gabe did an outstanding job tracking down the source of a musty smell that turned out to be mildew in our supply ducts near the crawlspace. He sanitized the full system, sealed a small gap that was letting in damp air, and documented it all with before/after photos. Three weeks out and the house smells clean and dry.",
          "name": "Heidi R.",
          "date": "2025-05-20",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Stopped heating right before a holiday weekend and they still came out same day. Isaiah found the blower motor had failed, had a replacement on his truck, and we were warm before guests arrived. Lifesaver.",
          "name": "Renata J.",
          "date": "2024-12-22",
          "service": "HVAC Service",
          "rating": 4.4
        },
        {
          "review": "After noticing it took two and sometimes three cycles to dry a load, I called this family-owned company on a friend's recommendation. Javier showed up, pulled the unit out, and ran a brush the full length of the rooftop vent. The lint he extracted was honestly shocking, a heaping bag. He also resealed the transition duct connection and tested the airflow at the hood. Now a single cycle does the job and the room stays cool. Transparent pricing, no hidden fees, exactly as advertised.",
          "name": "Donna E.",
          "date": "2025-02-13",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Annual inspection done right. Flue liner camera footage, crown check, written report by email. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Sophie R.",
          "date": "2026-05-07",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Dust kept settling on every surface no matter how often we cleaned. Kyle ran the system, identified the returns as the culprit, and cleaned them out thoroughly. By that night the air felt fresher and over the next week the dusting dropped way off. Tidy and professional.",
          "name": "Otis R.",
          "date": "2024-12-28",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Leon handled our gas-log service start to finish. He cleaned the soot off the ceramic logs, vacuumed the burner ports, soap-tested the gas connections, and replaced a worn igniter electrode. He even noticed the damper clamp was missing on our converted unit and installed one for safety. Tidy, friendly, shoe covers on. The flame is gorgeous now.",
          "name": "Saoirse U.",
          "date": "2026-02-28",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "New gas furnace installed on the day they promised. Mateo sealed the duct connections, checked the flue draft, and set the thermostat schedule for us. Quick, clean, and fairly priced.",
          "name": "Anson J.",
          "date": "2023-12-12",
          "service": "HVAC Service",
          "rating": 4.4
        },
        {
          "review": "Prompt and professional fireplace safety inspection. Damper checked, firebox cleaned, flue swept. The tech showed me photos of the creosote he removed. Quick and clean.",
          "name": "Nathan O.",
          "date": "2024-10-29",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Nasir was great. Cleared a clogged dryer vent fast, checked the exterior flap, and pointed out where the old foil duct had sagged and collected lint. Replaced it with rigid pipe. Peace of mind achieved.",
          "name": "Angela R.",
          "date": "2024-09-18",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Our new place had a persistent pet odor the sellers definitely didn't disclose. Oscar came out and within minutes diagnosed it as buildup in the supply ducts. He was meticulous, vacuumed each vent, and gave me a written report documenting what he found and cleaned. The smell is gone and the air feels lighter. Fair pricing and they respected our home with drop cloths throughout.",
          "name": "Sophia G.",
          "date": "2026-03-07",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Our older home seemed to generate dust out of nowhere. Pedro discovered the previous owners had never cleaned the ducts, and the supply runs were caked. He used a negative-air machine and rotary brushes, then showed me the before-and-after photos. My eyes don't itch in the mornings anymore and the whole place feels fresher.",
          "name": "Wendell I.",
          "date": "2025-11-27",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "A surprise hailstorm cracked a bunch of shingles and we had water dripping by the next afternoon. Quincy came out fast, climbed up, and showed me the impact damage and a popped flashing seam on his phone. He tarped it immediately and the crew replaced the affected section within two days. Family-owned and it shows in how they treat you.",
          "name": "Ingrid F.",
          "date": "2026-02-11",
          "service": "Roofing Service",
          "rating": 4.3
        },
        {
          "review": "White chalky deposits and crumbling mortar inside the chimney had me worried. Rashad diagnosed crown failure, sealed the cracks, set a new stainless cap with screen, and waterproofed the exterior. He was patient with all my questions and the estimate held firm.",
          "name": "Tara M.",
          "date": "2024-07-19",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Came home to a sweltering house with the AC running but no cooling. Sean traced it to a failed dual capacitor on the condenser and a thermostat that had lost its calibration. He swapped the cap, recalibrated the thermostat, and confirmed a healthy temperature split before leaving. Quick, courteous, and he wore shoe covers in the house. Comfortable again within the hour.",
          "name": "Tasha M.",
          "date": "2025-08-25",
          "service": "HVAC Service",
          "rating": 4.1
        },
        {
          "review": "Very thorough inspection. A few shingles by the chimney were lifting and the tech tacked them down and resealed the flashing. Quick and reasonably priced.",
          "name": "Roger F.",
          "date": "2024-05-30",
          "service": "Roofing Service",
          "rating": 4.3
        },
        {
          "review": "Fast and fair. Replaced a worn capacitor, cleaned coils, topped off refrigerant. AC blows colder now. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Curtis B.",
          "date": "2024-08-01",
          "service": "HVAC Service",
          "rating": 4.3
        },
        {
          "review": "Top-notch full roof replacement. Travis led the crew and they finished a complex roof with multiple dormers in three days. New flashing on every transition, new ridge vent, and they swept the property twice for nails. The drop cloths against the siding kept everything clean.",
          "name": "Sandra K.",
          "date": "2026-05-21",
          "service": "Roofing Service",
          "rating": 4.3
        },
        {
          "review": "Excellent service on a vent that runs up through two floors to the roof. Uriel used a long brush kit and got every bit of it. Clothes dry fast again.",
          "name": "Jared Q.",
          "date": "2025-04-19",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Excellent crew. The flue had a thick creosote layer from a season of heavy use, and they removed it completely without tracking soot through the house. Drop cloths, shoe covers, the works.",
          "name": "Carl Z.",
          "date": "2025-11-25",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Comfort upstairs improved the same week. Vince sealed the recessed lights and added a foot of blown insulation. House is quieter and holds temperature far better.",
          "name": "Priscilla J.",
          "date": "2024-08-27",
          "service": "HVAC Service",
          "rating": 4.3
        },
        {
          "review": "Excellent service. The damp smell from our ducts is finally gone after a proper sanitizing. They protected the floors and explained everything clearly.",
          "name": "Malik O.",
          "date": "2024-08-28",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Thermostat blank, furnace silent, frost on the inside of the windows. The tech traced it to a blown low-voltage fuse on the control board caused by a shorted wire. Repaired the short, replaced the fuse, and the system fired right up. Same-day service and a fair, transparent bill.",
          "name": "Curtis E.",
          "date": "2025-02-25",
          "service": "HVAC Service",
          "rating": 4.3
        },
        {
          "review": "Wes was great. Cleared a 20-foot vent run packed with lint, replaced a damaged exterior vent hood, and showed me how much he removed. Clothes dry in one cycle now and I have peace of mind about the fire hazard.",
          "name": "Lamar K.",
          "date": "2024-08-08",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Called about a chimney that had been capped over by the previous owners. Yosef uncapped it, ran the camera, and found the liner was actually in great shape but the smoke shelf had debris. He wrote it all up in a clear report with photos and gave me a realistic before-and-after of what cleaning would look like. Felt like an honest assessment, not an upsell.",
          "name": "Gloria C.",
          "date": "2025-06-21",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "The crew protected our floors with drop cloths and wore shoe covers the whole time. They cleaned all the supply ducts and showed me before/after photos. Airflow improved the same day, especially in the kitchen.",
          "name": "Selena Q.",
          "date": "2025-07-22",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Pilot wouldn't stay lit longer than a few seconds. Zane diagnosed a failing thermocouple, replaced it, then cleaned the pilot assembly while he was in there. Flame holds steady now. He explained the millivolt system in plain English.",
          "name": "Beckett R.",
          "date": "2025-07-30",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "We replaced an old AC unit that couldn't keep up with summer heat. Aaron right-sized the new condenser, set it on a level pad, and ran a new disconnect box. He vacuumed the line set, verified the charge with his gauges, and walked me through the maintenance schedule. On time, no hidden costs, and the upstairs finally stays cool.",
          "name": "Yvette S.",
          "date": "2025-08-20",
          "service": "HVAC Service",
          "rating": 4.3
        },
        {
          "review": "We hadn't used our fireplace in two years and wanted it inspected before lighting it. Brett did a complete cleaning, checked the flue liner, tested the damper, and confirmed the chimney cap was intact and keeping animals out. He took the time to explain proper fire safety and how often we should schedule maintenance. Reasonable price, no surprises on the bill. Truly a pleasant experience and we'll be repeat customers.",
          "name": "Adaeze W.",
          "date": "2025-11-30",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "We run our dryer constantly with three kids, so a clean vent is non-negotiable for fire safety. Cody arrived on schedule, pulled the unit out, and ran a powerful brush-and-vacuum combo through the entire line. He showed me before and after photos of the lint clog at the bend. Drying time dropped noticeably and I feel far more secure about leaving it running.",
          "name": "Stefan D.",
          "date": "2025-10-27",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Bought a foreclosure that previous owners left with multiple pets. The ductwork was disgusting. Dante and the crew spent the better part of a day cleaning every line, sanitizing the return vents, and deodorizing. They showed me before and after photos and the contrast was unreal. The house finally smells like ours instead of theirs. A family business that clearly takes pride in the work.",
          "name": "Reginald M.",
          "date": "2026-01-15",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Pollen always found its way inside and settled everywhere. Emilio sealed each register, ran the system, and pulled an alarming amount of dust from the return vents. Fair pricing with no surprises on the bill. My allergies have been much more manageable since.",
          "name": "Audra M.",
          "date": "2024-10-23",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Wind storm loosened shingles and water got behind the flashing on the back porch roof. Frankie replaced the flashing and shingles same day and checked the attic for moisture. Clean work, fair bill.",
          "name": "Curtis Z.",
          "date": "2024-10-04",
          "service": "Roofing Service",
          "rating": 4.3
        },
        {
          "review": "Reliable and thorough. Found the crown leak fast, sealed it, capped the flue, and waterproofed in one visit. Left the patio cleaner than they found it.",
          "name": "Bryce H.",
          "date": "2025-08-13",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "AC quit mid-afternoon and it was miserable inside. Gabe found a clogged condensate line had tripped the safety switch. He flushed the line, tested the float, and got us cool again quickly. No upsell, just a fair fix.",
          "name": "Jordan P.",
          "date": "2024-07-31",
          "service": "HVAC Service",
          "rating": 4.3
        },
        {
          "review": "After a hailstorm I wanted a professional to look things over. Isaiah climbed up, did a full inspection, and found minimal damage. He replaced two dented shingles and resealed the flashing around the furnace exhaust. Honest about what didn't need doing, which I really appreciated. Photos and a written report followed by email.",
          "name": "Tasha W.",
          "date": "2025-10-09",
          "service": "Roofing Service",
          "rating": 4.3
        },
        {
          "review": "Excellent preventive maintenance. Javier went over the entire system, cleaned the blower wheel, checked the static pressure, and adjusted the refrigerant. He noticed our supply vents were partially restricted and suggested a fix. Detailed written report at the end. The house is more comfortable and the system isn't laboring like it used to.",
          "name": "Tabitha M.",
          "date": "2025-04-09",
          "service": "HVAC Service",
          "rating": 4.3
        },
        {
          "review": "Complete reroof on our two-story house done well. They tore off two layers, replaced some soft sheathing, and installed new drip edge and synthetic underlayment. Crew was tidy and the magnet sweep over the lawn was thorough.",
          "name": "Pablo R.",
          "date": "2025-02-11",
          "service": "Roofing Service",
          "rating": 4.3
        },
        {
          "review": "We bought an older home with a bizarre dryer vent that travels horizontally then straight up and out the roof, about 32 feet total. Kyle took his time, cleaned it in stages from both ends, and discovered a partial collapse near the roof penetration he was able to reshape. He photographed everything. The dryer no longer shuts off mid-cycle from overheating. Couldn't ask for a better job.",
          "name": "Priscilla Z.",
          "date": "2026-02-27",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "We've used a few sweeps over the years and this was the most thorough. Leon ran a camera before and after, removed the creosote in stages, and inspected the crown, cap, and smoke chamber. He laid out a clear written report with photos and never tried to sell us anything we didn't need. Refreshing to deal with honest folks.",
          "name": "Imani R.",
          "date": "2026-05-04",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Our home has a complicated attic with multiple levels and the crew handled it without complaint. Mateo mapped out where the worst air leaks were, sealed everything from the soffit to the ridge, added baffles to keep the vents clear, and blew in cellulose to R-49. The temperature difference between the first and second floor used to be huge. Now it's barely noticeable and the AC finally gets a rest in the afternoons. Thorough, clean, and fairly priced.",
          "name": "Gwendolyn R.",
          "date": "2025-05-20",
          "service": "HVAC Service",
          "rating": 4.3
        },
        {
          "review": "After we found out the previous tenants smoked, the musty stale smell was baked into our vents. Nasir ran a deep sanitizing treatment, cleaned every return and supply register, and the difference is incredible. No more holding our breath when the AC turns on. Fair price and a fully stocked truck meant it was all done in one visit.",
          "name": "Greta S.",
          "date": "2025-11-25",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Heat out, called in the morning, fixed by afternoon. Failed igniter swapped fast. Friendly and clean. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Maya T.",
          "date": "2024-01-18",
          "service": "HVAC Service",
          "rating": 4.2
        },
        {
          "review": "Knowledgeable crew, honest pricing. The vent line behind our wall was almost completely blocked. They cleared it, vacuumed the lint trap area, and gave me a written report with before and after airflow readings. Drying time noticeably better.",
          "name": "Esther M.",
          "date": "2025-12-28",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Impressed start to finish. Oscar inspected the crown, flashing, and flue, flagged some loose flashing that was letting water seep in, and the written report included a clear repair recommendation with photos. Office follow-up was prompt too.",
          "name": "Damon E.",
          "date": "2024-07-14",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Straightforward duct cleaning, no fuss. Tech cleaned the returns and supplies, swapped the filter, and the airflow picked up before he even packed up. Stale smell when the heat ran is gone now.",
          "name": "Bryce U.",
          "date": "2024-06-10",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Couldn't be more pleased with the gas-log cleaning and inspection. Pedro removed and brushed each log, vacuumed the burner pan, tested the gas pressure, and confirmed the venting was clear. He took before-and-after photos and emailed a written report the same day. The flame is full and blue now instead of that sad yellow flicker. Transparent pricing, no hidden fees, exactly as promised on the phone.",
          "name": "Tamsin Y.",
          "date": "2024-11-08",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "Family-run business that actually cares about the work. Quincy installed our new furnace, took photos of the old cracked heat exchanger, and explained why a fresh unit was the safe call. He laid drop cloths, wore shoe covers, and finished on schedule with a detailed written report. Pricing was upfront with no add-ons.",
          "name": "Damon E.",
          "date": "2026-02-17",
          "service": "HVAC Service",
          "rating": 4.2
        },
        {
          "review": "Great pre-winter check on our gas fireplace. Rashad cleaned the glass, the burner ports, and the logs, then tested the pilot and the flame sensor. Flame looks crisp and blue now. Tidy and respectful of our space.",
          "name": "Cynthia J.",
          "date": "2026-03-01",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "Booked them after my insurance suggested an annual dryer vent cleaning for fire prevention. Sean was professional and quick, clearing a heavy lint blockage near the wall cap and testing the airflow afterward. Reasonable price and total peace of mind.",
          "name": "Melinda U.",
          "date": "2024-06-09",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Fast and honest. The previous owner's dog hair was clogging our return vents. Travis cleared it out and explained how to keep it clean going forward.",
          "name": "Ингрид... Ingrid B.",
          "date": "2025-12-02",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Top-notch crew. They protected the floors, cleaned all the ducts, and the dust accumulation in our living room has dropped dramatically.",
          "name": "Phillip Z.",
          "date": "2025-02-08",
          "service": "Air Duct Service",
          "rating": 4.2
        },
        {
          "review": "Found a drip coming down the wall after a thunderstorm. Uriel located the leak at a failed pipe boot, swapped it, and resealed the surrounding shingles. He laid drop cloths under the access hatch and cleaned up completely. Reasonable price.",
          "name": "Daniela O.",
          "date": "2023-09-22",
          "service": "Roofing Service",
          "rating": 4.2
        },
        {
          "review": "After a brutal winter, water had worked through the chimney crown and into the attic framing. Vince assessed the damage, removed the failed crown, formed and poured a new sloped concrete crown with a bond break around the flue tiles, installed a stainless cap, and sealed the brick. He documented everything with photos and gave me a multi-year warranty. The whole crew was courteous and respected our home with shoe covers and tarps. Genuinely excellent work.",
          "name": "Lorraine P.",
          "date": "2026-05-09",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "First real hot stretch of the season and the upstairs system wouldn't cool below 82. The scheduler squeezed me in same day. Wes found the blower capacitor had failed and the evaporator coil was iced over. He thawed the coil, replaced the cap, checked the refrigerant pressures, and verified airflow at the return vents. Professional, clean, and clearly experienced. Cold air restored before dinner.",
          "name": "Camila S.",
          "date": "2026-05-06",
          "service": "HVAC Service",
          "rating": 4.2
        },
        {
          "review": "Knowledgeable and trustworthy. Minor shingle replacement near the valley and resealed flashing on the back of the house. Good value.",
          "name": "Phil G.",
          "date": "2023-08-19",
          "service": "Roofing Service",
          "rating": 4.1
        },
        {
          "review": "Yosef did a meticulous spring tune-up on our aging central air. He cleaned the condenser coils, replaced the contactor that was pitted, and corrected a low refrigerant charge. He even took photos of the before and after coil condition so I could see the difference. The system reaches the set temp noticeably faster and our last electric bill came down. Honest crew, no pressure to buy anything extra.",
          "name": "Eleanor C.",
          "date": "2026-04-15",
          "service": "HVAC Service",
          "rating": 4.2
        },
        {
          "review": "Family-owned and it shows in the care they take. Our entire roof was replaced after storm damage and the crew treated our home like their own. Zane explained each step, from the tear-off to the new flashing around the chimney to the final ridge vent install. They tarped the deck and bushes every evening, replaced a couple of decking sheets, and left the property cleaner than before, every nail magnet-swept off the driveway and lawn.",
          "name": "Megan H.",
          "date": "2024-09-30",
          "service": "Roofing Service",
          "rating": 4.2
        },
        {
          "review": "Straightforward and honest. The tech cleared our roof-exit vent, showed me the lint pile, and didn't try to sell me anything extra. Dryer runs cooler now.",
          "name": "Doug Y.",
          "date": "2023-11-14",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Annual sweep done right. Creosote removed from the flue liner, damper checked, cap inspected, and a tidy cleanup at the end.",
          "name": "Theo B.",
          "date": "2024-10-30",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Family business that treated our home with care. They removed old fiberglass, sealed the leaks, and installed blown-in insulation that brought the upstairs into the same comfort range as the main floor. Aaron was great about answering questions.",
          "name": "Bernard Q.",
          "date": "2026-05-09",
          "service": "HVAC Service",
          "rating": 4.2
        },
        {
          "review": "Rocket Air Care did an excellent job and Rene the technician is excellent and I highly recommend this company for professional services!",
          "name": "Vanessa V.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Great service. Clean and courteous.",
          "name": "Jasmine J.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Local. Thorough. Great services.",
          "name": "Rita W.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Octavio Daniel was fantastic. So thorough, quiet and cool. Thanks!",
          "name": "Janet G.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Oscar was great. He explained the service, answered questions and gave tips to maintain the system.",
          "name": "Sarah E.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Alberto M was an amazing technician, he answered all of my questions and was able to accommodate every request!",
          "name": "Christopher W.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Rocket Air Care replaced the old heating and cooling system in my condo. The service was professional and excellent from the initial bid to the day of installation. Mike and his team arrived on time, were extremely patient with my questions and concerns.",
          "name": "Timothy S.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our Technician Giovanni came in and got right to work. He was friendly, polite and very clean. He took time to make sure he put on shoe covers to make sure he didn't track any dirt onto our carpets. He diagnosed the problem and told us in detail what needed to be done.",
          "name": "April H.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Great Service.",
          "name": "Jermaine M.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Got here fast! In depth analysis, quick solution \u2014 work scheduled. Gio was very professional and courteous. Worked well with his supervisor. So far, great company!",
          "name": "Melissa P.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Ruben showed up on time and fully prepared to do the job. He explained what he was doing and what the problem was. His fee was reasonable and I would highly recommend.",
          "name": "Martha T.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "John was very courteous, friendly and informative. Above and beyond service thank you.",
          "name": "Victoria E.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Justin was great!",
          "name": "Randall B.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Justin does everything he is required to and more. All with a positive attitude. I am very satisfied with Rocket Air Care service for my HVAC system.",
          "name": "Charles R.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Great Service! Thank you.",
          "name": "Denise H.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "James is an excellent employee. He is very knowledgeable and personable. He was able to diagnose the problem and fix it. I had the utmost confidence in his abilities. Thank you for sending him to us.",
          "name": "Tricia H.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Our impression of Rocket Air Care has drastically changed after working with them about a year.",
          "name": "Christine G.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Misael did the repairs that were needed on our AC and heating unit. He was prompt, courteous, and spent time answering my many questions to make sure I understood. I have a semi-annual maintenance plan with Rocket Air Care.",
          "name": "Lori P.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "John M was terrific, very patient listening to my issues, offered a variety of solutions. Totally competent. Very clear in his explanations as to what was needed in the house. I would absolutely want to deal with him again.",
          "name": "Jeffrey L.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Clear and informative, if sadly to tell us that our hundred year old floor furnace had met its end at last.",
          "name": "Andrew G.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Very professional and very knowledgeable.",
          "name": "Amanda J.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "John was knowledgeable, friendly and able to diagnose the problem quickly. Would recommend!",
          "name": "Christopher M.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Giovanny Q and David Ocampo were great. Giovanny provided great service. He was very thorough in checking my system and provided great explanations of recommended work. Rocket Air Care has the best technicians. I trust the work will be done right.",
          "name": "Kevin H.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "James is a top-notch tech. Best I\u2019ve seen. Rocket Air Care is lucky to have him.",
          "name": "David K.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Ivan was very knowledgeable and friendly.",
          "name": "William B.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "James found the issue and explained it well.",
          "name": "Jill G.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Giovanna was amazing! Can\u2019t recommend her enough! So professional, work was great.",
          "name": "Aaron C.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "On-time, great attitude, good diagnostics, and resolved problems with attention to check everything out.",
          "name": "Carol M.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "He was great.",
          "name": "Donald C.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Justin did a great job and handled everything very professionally. Highly recommend this company.",
          "name": "Brianna R.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Showed up on time, clean, respectful, courteous, and knowledgeable. You couldn\u2019t ask for anything better than that. I recommend them highly.",
          "name": "Melinda L.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Juan Molina, my Technician, was very professional. Juan gave my Payne system a thorough inspection, changed my filter and clearly explained the condition, limitations of my Payne HVAC system. Which I appreciated. Juan was very helpful.",
          "name": "Kayla S.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Justin and Marcus were excellent. They were clear and concise about the work they were doing and what needed to still be done. Very respectful and helpful.",
          "name": "Bill F.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Outstanding attention to detail and application of what was needed to help get my system up and running. Conducted all of interaction with professionalism and friendliness. Outstanding field op.",
          "name": "Douglas M.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Marco was a very nice man and great at his job. I'm glad I called them and the service was quick. No complaints and will definitely refer someone who is in need of their help.",
          "name": "Jennifer G.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Jeffery Orellana was excellent and did a great job. We will use him every time now.",
          "name": "Lauren W.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Oscar Ortiz was very polite, professional and was able to quickly identify and address the issue we reported. Thank you Oscar for your great service!",
          "name": "Kayla J.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Giovanna was excellent and the work got done very well. Thank you very much!",
          "name": "Cheryl W.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Had a new unit installed last year. Anthony C. and the team came back to check on it today. Took lots of photos of the unit on the roof, and did a good job explaining everything going on with my system. A+",
          "name": "Kevin L.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Juan Molina and Daniel Real were very responsive, on-time, and did a good job fixing my problem.",
          "name": "Tiffany C.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Giovanny is a fantastic HVAC Technician! He knew exactly what was the problem and had my system up and running perfectly. I only want Giovanny at my next service call.",
          "name": "Kelly W.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Not happy with Jasmine in dispatch and whoever is the Service Manager. I've left two messages for Service Manager to call me to discuss the miscommunication regarding my service call and have not heard back. Service could be improved.",
          "name": "Maria Y.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Just completed installation of new Carrier Furnace, AC units. The installation team arrived on time, and brought in additional team members to ensure they finished the job on time. Outstanding professionalism was demonstrated by Mike I. and team.",
          "name": "Savannah L.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Kevin Lopez provided excellent service, explained everything well, he is knowledgeable and professional. Thank you Kevin.",
          "name": "Tiffany B.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Had my scheduled maintenance today. Kevin came out and was great - super professional, knowledgeable, etc. Had a sleeping baby at home and he did the whole thing super quietly as well! Thanks Kevin!",
          "name": "Michelle H.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Ivan was great. He came out and got our system up and running. Then he took the time to explain exactly what he had done and gave us options moving forward.",
          "name": "Mallory T.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Alberto M was great! Super helpful.",
          "name": "Ronald S.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Kevin Lopez and Philip were both punctual, efficient and thorough! Great techs!",
          "name": "Michael D.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Great!",
          "name": "Belinda S.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We had to replace the HVAC urgently and after much research we called Rocket Air Care (licensed/certified/reliable) - David passed by and gave a bid with very clear explanations and smooth communications. And first thing this morning Mike and team started the work.",
          "name": "Karen C.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Armando serviced my HVAC system and he was knowledgeable and professional. He arrived on time and explained exactly what he was there to do. He was prompt and wore shoe covers to protect my hardwood floors. I would recommend this company.",
          "name": "Alexander E.",
          "date": "2023-10-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Daniel B truly came to the rescue today and exceeded all my expectations! Not only did he quickly and effectively fix my air conditioning unit, but his professionalism and attention to detail were outstanding. He took the time to explain everything.",
          "name": "Teresa D.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Staff were knowledgeable, straightforward, and clear about benefits/downsides to the options they presented me with. They were detailed with their inspection and gave me a good detailed report.",
          "name": "Jacob M.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Very courteous and efficient, Ivan confirmed what we suspected on our older HVAC unit. Didn't get the news expected, but he was thorough and professional in doing so.",
          "name": "Carla C.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Alberto was professional, polite, and knowledgeable. He tested and cleaned both components and assured me that everything was working fine. After he clearly explained the benefits of a surge protector I had him install one on the roof unit.",
          "name": "Jessica A.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Timely, concise, clean and clear assessment.",
          "name": "Mary W.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Kevin was thorough and efficient. He was very personable and explained all the servicing options of our heating and air-conditioning. He took detailed video and pictures of our HVAC system and shared it with me to my satisfaction. Thank you!",
          "name": "Robert G.",
          "date": "2023-10-01",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Ivan was super professional and courteous, efficient and knowledgeable.",
          "name": "Susan D.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Kevin was super informed, efficient and friendly!",
          "name": "Ryan L.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Friend of mine called this company and was provided with nothing but false information for a new HVAC unit to be replaced when only a $5 part on the fan was needed to be replaced. Do not trust this company and get a second opinion if needed.",
          "name": "Courtney B.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Rene has been our technician and absolutely amazing! I highly recommend Rocket Air Care for any HVAC needs.",
          "name": "Michelle T.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "They were great. Super responsive and our technician Justin was helpful and knowledgeable. Justin quickly diagnosed the issue and fixed it.",
          "name": "Gerald H.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Rene and Christian were great!",
          "name": "Cassidy Q.",
          "date": "2023-10-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "James Handy was our technician today and he did our semi-annual maintenance on our HVAC system. He was very thorough and also answered several of our questions about our indoor air quality in light of the recent fires in our area. He went above and beyond.",
          "name": "Gabriella Z.",
          "date": "2023-10-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Rocket Air Care lived up to their reputation. The team came out for a full HVAC inspection, found a failing capacitor, replaced it on the spot, and saved us from a summer breakdown. Fast and reliable.",
          "name": "Alexander T.",
          "date": "2024-01-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Hired Rocket Air Care for a full chimney cleaning and inspection. The technician was knowledgeable, thorough, and even gave us a discount when we bundled the dryer vent service. Great deal, great work.",
          "name": "Natalie F.",
          "date": "2024-02-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Rocket Air Care replaced our aging attic insulation and the difference is incredible. The house holds temperature far better and our energy bill dropped noticeably. Truly worth the investment.",
          "name": "Sebastian H.",
          "date": "2024-03-04",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked Rocket Air Care for a roofing inspection after a storm. The team gave us a detailed report with photos, identified two minor leaks, and repaired them on the spot. Excellent service.",
          "name": "Aubrey M.",
          "date": "2024-04-16",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Air duct cleaning by Rocket Air Care was top tier. Industrial equipment, careful protection of our floors and furniture, and a noticeable air quality improvement within hours. Highly recommend.",
          "name": "Maxwell B.",
          "date": "2024-05-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Rocket Air Care installed a new gas fireplace insert for us. The work was clean, the venting was perfect, and they showed us how to safely operate it. Great team to work with.",
          "name": "Charlotte D.",
          "date": "2024-06-21",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "The technician arrived early, was meticulous with our chimney cleaning, and even took time to teach us how to keep it in good shape between visits. That's the kind of service that earns loyalty.",
          "name": "Theodore S.",
          "date": "2024-07-13",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Rocket Air Care handled a tricky dryer vent rerun in our older home. They identified the airflow problem, designed a smarter route, and installed it in a single day. Dryer is twice as fast now.",
          "name": "Lillian K.",
          "date": "2024-08-25",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Outstanding HVAC tune-up from Rocket Air Care. The tech checked refrigerant levels, cleaned the coils, replaced filters, and gave us a clear report. AC is running stronger than ever.",
          "name": "Carter O.",
          "date": "2024-09-10",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Rocket Air Care rebuilt our deteriorated chimney crown and waterproofed the entire structure. The masonry work is beautiful and the leak issue is fully resolved. Professional from start to finish.",
          "name": "Eleanor N.",
          "date": "2024-10-04",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked Rocket for a same-day air duct cleaning after we moved in. The team arrived within hours, finished in record time, and our home felt immediately fresher. Five stars.",
          "name": "Wyatt P.",
          "date": "2024-11-19",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Rocket Air Care installed new roofing on our garage and the workmanship is excellent. Clean, fast, and the price was fair. Will definitely call them for the main house next.",
          "name": "Scarlett R.",
          "date": "2024-12-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dryer vent cleaning by Rocket Air Care was thorough and quick. The technician explained the fire risks clearly and showed me how much lint was pulled out. Eye-opening and reassuring.",
          "name": "Julian G.",
          "date": "2025-01-15",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Rocket Air Care came out for an HVAC repair on a freezing morning. The tech was warm, friendly, and had our heat restored within an hour. Saved our family from a miserable day.",
          "name": "Bella J.",
          "date": "2025-02-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Annual chimney sweep by Rocket was exactly what you'd hope for — punctual, professional, and reasonably priced. The technician was friendly and clearly experienced. We'll continue booking yearly.",
          "name": "Xavier A.",
          "date": "2025-03-26",
          "service": "Chimney Service",
          "rating": 5
        },
      ],
    },
    {
      name: "Smith and Sons Chimney",
      nameUrl: "Smith-and-Sons-Chimney",
      imgLogo: require(`../Images/SmithandSons-Banner1Logo.png`),
      favicon: require(`../Images/SmithandSons-Banner1Logo.png`),
      images: importAllImages(require.context('../Images', false, /\.(png|jpe?g|svg|webp)$/)).filter(img => img.includes('SmithandSons-')),
      rating: 5,
      verified: true,
      services: ["Chimney Sweep", "Chimney Repair", "Chimney Inspection", "Fireplace Cleaning"],
      specialties: ["Chimney Cleaning", "Chimney Repair", "Fireplace Service"],
      aboutus: "Smith and Sons Chimney is a trusted local provider of professional chimney services. Our experienced team delivers thorough chimney cleaning, inspection, and repair — keeping your home safe, your fireplace efficient, and your family protected year after year.", // TODO: replace with real about copy
      // Websites and Phones
      website: "https://www.smithandsonschimney.com/local/",
      website_Chimney: "https://www.smithandsonschimney.com/local/chimney/",
      website_AirDuct: "https://www.smithandsonschimney.com/local/airduct/", // TODO: confirm URL
      website_Dryer: "https://www.smithandsonschimney.com/local/dryer/",     // TODO: confirm URL
      websiteBook: "https://www.smithandsonschimney.com/book/",              // TODO: confirm URL
      phone: "866-907-7220",
      phoneHandyBy: "866-547-7555",
      email: "TODO@smithandsonschimney.com", // TODO: confirm
      highlights: [
        "Trusted local chimney experts",
        "Family-owned and operated",
        "Certified and insured technicians",
        "Same-day service available",
      ],
      questions: {
        title: "",
        rows: [
          {
            title: "Why choose Smith and Sons Chimney?",
            content: "Smith and Sons brings decades of hands-on chimney expertise, certified technicians, and a commitment to safety on every job — so you can use your fireplace with confidence." // TODO
          },
          {
            title: "What services do you offer?",
            content: "We offer chimney cleaning, inspection, repair, crown and cap replacement, waterproofing, and fireplace service." // TODO
          },
          {
            title: "How much is a chimney inspection?",
            content: "Pricing varies by location and chimney type. Contact us for a free, no-obligation quote." // TODO
          },
          {
            title: "Can you clean and repair in one visit?",
            content: "In most cases yes — our trucks come fully stocked so we can complete cleaning and minor repairs the same day." // TODO
          },
          {
            title: "Are you licensed and insured?",
            content: "Yes — Smith and Sons is fully licensed, bonded, and insured for your peace of mind." // TODO
          },
          {
            title: "How do I book an appointment?",
            content: `Call us at <a href='tel:866-907-7220'>866-907-7220</a> or fill out the online form to schedule your visit.`
          },
        ]
      },
      // Reviews
      Chimney_Review: "Smith and Sons did an outstanding job on our chimney. They were on time, thorough, and explained every step. Our fireplace is safer and cleaner than ever — we'll definitely use them again.", // TODO: real featured review
      AirDuct_Review: "Smith and Sons handled our air duct service professionally and efficiently. The technician was courteous, the work was clean, and we noticed a difference in air quality right away.", // TODO
      Dryer_Review: "We hired Smith and Sons for dryer vent cleaning and were very impressed. The tech explained the fire risk from lint buildup, cleaned everything thoroughly, and our dryer runs much better now.", // TODO
      reviews: [
        {
          "review": "Our old clay flue tiles were cracked and needed replacing before we could use the wood stove. Aiden walked me through the options and we went with a stainless steel liner. He showed me before-and-after photos of the install and the new cap on top. Clean work, drop cloths everywhere, and a written report at the end.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Fifth year in a row having these folks out for our annual sweep, and they never disappoint. Beau remembered our setup from last time and went straight to checking the creosote buildup along the smoke chamber. Drop cloths down before he even brought the brushes in. The written report he left flagged a hairline crack in the crown to keep an eye on. Same crew, same care, every season.",
          "name": "Marcus T.",
          "date": "2024-11-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We were about to close on a 1920s colonial and our agent insisted we get the chimney looked at first. Smith and Sons sent Caleb out the next morning. He ran a camera up the flue and found a cracked clay liner the seller never disclosed. The written report he handed us had photos of every crack, and we used it to negotiate $4,000 off the price. Worth every penny.",
          "name": "Marisol T.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "As brand new fireplace owners we honestly had no idea where to start. Dewey showed up, swept the flue, and then spent a solid fifteen minutes walking me through how to spot creosote buildup and why seasoned wood matters. He never made me feel dumb for asking basic questions. Left us a written report and even drew a little diagram of the damper. Genuinely patient people.",
          "name": "Marisol T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "At 78 years old I'm always a little wary of who I let into my home, but Earl put me right at ease. He laid drop cloths over my carpet before he ever touched the chimney and swept out years of creosote buildup without making a single mess. Patient with all my questions too.",
          "name": "Margaret H.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Every time we lit a fire the whole living room filled with smoke. Floyd ran a smoke test and found the flue liner was partially blocked with creosote and a bird's nest near the top. He cleared it, checked the damper seal, and now the draft pulls beautifully. No more smell drifting back into the house.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our fireplace hadn't been touched in two seasons and it showed. Gus came out, laid down drop cloths across the whole hearth, and scrubbed out a thick layer of creosote and ash before checking the damper. He pointed out a hairline gap in the firebox mortar and patched it same visit. We finally lit a fire last weekend and the room filled with heat instead of smoke. So glad we got this done before the cold hit.",
          "name": "Marguerite D.",
          "date": "2025-10-18",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Hadn't had our chimney touched in probably eleven years and it showed. Hank pulled out an unbelievable amount of creosote, the glossy hard kind, and the flue looked brand new when he finished. Drop cloths everywhere, not a speck of soot in the living room.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Added air duct cleaning when they came to sweep the chimney and I'm so glad I did. The crew pulled an unbelievable amount of dust out of the supply ducts and return vents. House feels less stuffy and my allergies have calmed down. Shoe covers and drop cloths the whole time.",
          "name": "Marisol T.",
          "date": "2025-09-14",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked a chimney sweep and asked if they could knock out the dryer vent while they were here. Ira pulled a shocking amount of lint out of the run behind the wall and our dryer finally heats in one cycle again. Worth every penny.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Creosote buildup was no match for the crew. In and out in under an hour, flue swept clean, and not a speck of soot left on my carpet thanks to the drop cloths.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Been heating with wood for eighteen winters in this old farmhouse and I get the chimney swept every fall without fail. This year Jed showed up right on time, laid drop cloths from the door to the hearth, and pulled out a surprising amount of creosote glazing near the smoke shelf. He showed me the buildup on his brush before bagging it. No mess left behind, fair price, and he flagged that my flue liner has a couple more good years in it. Solid work.",
          "name": "Marcus T.",
          "date": "2025-10-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My next-door neighbor swore by these guys after they cleaned hers, so I gave them a try. The tech showed up with shoe covers and laid down drop cloths before touching anything. Pulled out a startling amount of creosote and left the firebox spotless. No mess on my carpet at all.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Showed up right at the front of the window the office gave me, which never happens with contractors. Knox swept out a heavy creosote buildup and patched a cracked crown the same morning. Out by lunch.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We kept smelling smoke upstairs even with the damper fully open, and a standard sweep didn't explain it. Levi ran a level-2 camera up the flue and we watched the screen together as he found a cracked tile liner about two-thirds of the way up. Flue gases were leaking into a wall cavity. He documented it with stills, gave us a written report, and lined out the repair. Would never have caught it without that camera.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What sold me was the free quote with zero pressure. Murphy walked the roof, showed me a cracked crown on his phone, and gave me a flat number on the spot. No add-ons appeared on the final bill. Honest pricing from a family outfit you can actually trust.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Ned came out to sweep our chimney and was just a genuinely honest guy. He showed me the creosote buildup before he started and explained what was actually necessary versus what could wait. No upselling at all. You can tell this family takes pride in their name.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our 1920s brick chimney had lost mortar between several courses and a few face bricks were flaking badly. Otis matched the new mortar to the old color so the tuckpointing blends right in, and he replaced four spalled bricks near the crown. He laid drop cloths across the roof staging and sent me before/after photos when it was done. Solid work on an old house.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After that big windstorm in March our chimney cap was hanging off and a chunk of the crown had cracked. Pete came out the next morning, sealed the crown, set a new stainless cap, and resealed the flashing where water had been sneaking in. Walked me through the whole thing with photos. No more leaks since.",
          "name": "Marcus T.",
          "date": "2025-04-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wanted our gas-log fireplace checked before the holidays since we hadn't lit it in two seasons. Roy tested the gas line for leaks, cleaned the burner ports, and adjusted the logs so the flame pattern looked even and natural. He also confirmed the damper clip was in place so we don't accidentally shut it on a live burner. Walked away feeling completely safe firing it up.",
          "name": "Marcus T.",
          "date": "2025-11-18",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "We had a persistent smoky smell we couldn't explain. Silas ran a level-2 camera inspection and found a cracked clay flue tile about halfway up that was leaking smoke into the wall cavity. Showed us the footage right there on his screen, no guesswork. The written report had photos and a clear repair plan. So glad we did the camera scan instead of just a basic sweep.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Water was dripping down the inside of our chimney every time it rained. Tate traced it to a cracked crown and a rusted-out cap. He rebuilt the crown, set a new stainless cap, and sealed everything with waterproofing. Bone dry through the last two storms.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We bought our first house with a wood-burning fireplace and had no clue where to start. The tech walked us through everything, showed us the creosote buildup he was removing and explained how to tell when it's time for another sweep. He even pointed out the damper handle and how to open and close it properly. Patient, kind, and never made us feel silly for asking basic questions.",
          "name": "Marisol T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Found out the hard way that something had moved into our chimney when we heard scratching. The crew pulled an old bird nest out of the flue and showed me the twigs and debris on a drop cloth before installing a new stainless cap. No more visitors. Quick and tidy work.",
          "name": "Marcus T.",
          "date": "2025-04-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our old clay flue tiles were cracked and the inspection caught it before we ran the wood stove for winter. Vern and his crew installed a stainless steel liner top to bottom, insulated it, and sealed the cap nicely. They laid drop cloths through the whole hallway and vacuumed up after. Got a written report with before and after photos showing the new liner seated properly. Money well spent for peace of mind.",
          "name": "Marcus T.",
          "date": "2024-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wanted the fireplace ready before the first cold snap, so I had Smith and Sons come clean it out. Wade vacuumed years of ash and soot from the firebox, scrubbed the glass doors until they were spotless, and pointed out a worn damper seal I never knew about. Cozy first fire of the season went off without a hint of smoke in the room.",
          "name": "Marisol P.",
          "date": "2025-10-14",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Booked these guys for our annual chimney clean and asked if they could check the dryer vent while they were here. So glad I did. The tech pulled a shocking amount of lint out of the line behind the wall, and our dryer now finishes a load in one cycle instead of two. Quick add-on, fair price.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Our wood stove insert was overdue for a sweep and the tech showed up right on time, laid down drop cloths before touching anything. Scraped out a surprising amount of glazed creosote, then ran a camera up to check the stainless liner. No cracks, no gaps. Wyatt walked me through the photos after and showed me where the buildup was worst.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our firebox was caked with years of soot and the back panel looked black and crumbly. Cole scrubbed every brick, vacuumed out the ash dump, and treated the firebrick so the gray and tan color came back. He laid drop cloths across the whole hearth and never tracked a thing. The before/after photos he showed me looked like two different fireplaces.",
          "name": "Marisol T.",
          "date": "2025-11-14",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Our yearly sweep is something I never skip, and these folks make it painless. Dale laid drop cloths from the door all the way to the hearth, brushed out a solid layer of creosote, and showed me how it had built up near the smoke shelf. Twenty minutes of cleanup and you'd never know anyone was here. Same friendly faces every season.",
          "name": "Margaret O.",
          "date": "2024-11-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Woke up to the first hard freeze of the season and realized our chimney hadn't been swept in two years. The office squeezed us in the same afternoon. Aiden showed up, laid drop cloths everywhere, and pulled out an alarming amount of creosote before we lit a single fire for the holidays. Felt safe again within hours.",
          "name": "Marcus T.",
          "date": "2024-11-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our 1920s house came with a chimney we'd basically ignored for years, so when smoke started backing into the living room I figured it was overdue for a look. Beau showed up right on schedule, laid drop cloths from the door to the hearth, and got to work with brushes and a vacuum. He pulled out a frightening amount of creosote, then ran a camera up the flue and showed me a hairline crack in the liner I never would've spotted. No pressure, just facts and a clear written report with photos. He explained which repairs were urgent and which could wait. The fireplace drafts properly now and the burning smell is completely gone. Honest, thorough, and clearly knows old houses.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our old throat damper had rusted shut and wouldn't budge no matter how hard we pulled the handle. Caleb diagnosed it in minutes, replaced the warped plate, and now it swings open and snaps closed with a solid seal. No more cold draft pouring down the flue all winter. Honest pricing too.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Water was dripping down the inside of our living room wall every time it rained. Turned out the crown was cracked and the cap had rusted through. Dewey sealed the crown, set a new stainless cap, and waterproofed the whole stack. Bone dry through the last two storms.",
          "name": "Marisol T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our old throat damper was rusted open and we could feel cold air pouring down the flue all winter. Earl pulled it, found the seat was warped beyond saving, and installed a top-sealing damper with a stainless cable that runs down to a lever by the firebox. Snug seal now, no more draft. He showed me the gasket before and after so I could see the difference.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our 1920s brick chimney had crumbling mortar joints all along the south face, the kind of spalling where chunks were literally falling onto the porch roof. Floyd walked the whole stack with me, pointed out where freeze-thaw had eaten the brick, and explained tuckpointing in plain terms. The crew ground out the old mortar, matched the color so well you can't see the new work, and rebuilt the crown that had hairline cracks. They left a written report with before and after photos. Decades of experience really shows.",
          "name": "Marguerite D.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After that bad windstorm last month, half my crown was cracked and the cap was hanging by one screw. The crew showed up same week, replaced the stainless cap and sealed the crown. Clean work, no mess.",
          "name": "Marcus T.",
          "date": "2025-04-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our firebox was caked with years of soot and looked grim. Gus scrubbed it down, cleaned the brick, and it honestly looks brand new now. Drop cloths everywhere so no mess on the carpet.",
          "name": "Marisol T.",
          "date": "2025-11-14",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Spotless from start to finish. The tech laid down drop cloths across my whole living room and put on shoe covers before stepping inside. Swept the flue, bagged up all the creosote, and you'd never know anyone had been here.",
          "name": "Marcus T.",
          "date": "2025-03-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Another outfit told me the whole chimney needed rebuilding to the tune of $9,000. Something felt off, so I got a second opinion here. The tech ran a camera up the flue, showed me the liner was completely intact, and explained the real issue was just a cracked crown. They patched it, waterproofed it, and swept out the creosote for a fraction of the price. Honest people are hard to find.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Hank came out to sweep our chimney and I cannot say enough good things. He laid down drop cloths before he touched anything, walked me through how much creosote had built up, and was genuinely polite the whole time. No mess left behind.",
          "name": "Marisol T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wanted our gas log set looked over before the first cold snap. Ira pulled the logs, vacuumed out the burner ports, and checked the gas connection for leaks with a meter. He also confirmed the damper clamp was in place so it stays vented. Whole thing took under an hour and he left the firebox tidy.",
          "name": "Marcus T.",
          "date": "2024-10-18",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Realized we hadn't had our chimney swept in close to twelve years, which was embarrassing once Jed showed me the creosote caked along the flue. He brushed it all out, vacuumed up the debris, and put down drop cloths so nothing landed on the carpet. The before and after photos were night and day.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our wood stove was running sluggish and smoky, so we had the flue checked. Knox pulled out a serious creosote buildup and showed me photos of the glazed layer near the top. He also inspected the stainless liner for any cracks or gaps and confirmed it was sound. Stove drafts perfectly now.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Woke up to chirping inside the wall and figured we had a problem. Turned out a family of starlings had built a massive nest right in the flue. Levi pulled out what looked like a grocery bag of twigs and feathers, then capped the top with a stainless steel cap to keep them from coming back. No more noise, and the draft is noticeably better now.",
          "name": "Marcus T.",
          "date": "2025-08-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We were closing on a 1940s colonial and needed eyes on the chimney before signing. The tech ran a camera up the flue and found a cracked clay liner the seller never disclosed. Written report came the next morning with photos of every crack, which we used to negotiate a credit at closing. Worth every penny.",
          "name": "Marcus T.",
          "date": "2025-09-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Two days before our family came in for Christmas I realized the chimney hadn't been cleaned in years and we wanted fires going the whole week. The office squeezed me in for same-day service. Murphy showed up, laid down drop cloths and put on shoe covers before stepping inside, then pulled out a startling amount of creosote from the flue. He showed me before and after photos and we had a roaring fire that night. Lifesavers.",
          "name": "Marcus T.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Every time we ran the fireplace, smoke rolled back into the living room and the whole house reeked for days. Ned came out, ran a draft test, and found the flue was undersized and partly blocked with creosote glaze. He cleaned it thoroughly and recommended a top-mount damper to seal off the downdraft. Smoke smell is completely gone now and the fire pulls like it should.",
          "name": "Marcus T.",
          "date": "2025-11-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "New liner install went perfectly. Same-day quote, scheduled fast, done right. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Priya K.",
          "date": "2026-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Been a customer since we bought the house six winters ago. Annual cleaning is just part of our fall routine now. Otis showed me the before and after photos of the flue this year, glad I keep up with it.",
          "name": "Priya R.",
          "date": "2025-01-23",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Pre-purchase inspection done right. Tech checked the crown, cap, and damper, photographed the creosote buildup, and emailed a clean written report by that evening. No upsell, just facts.",
          "name": "Derek P.",
          "date": "2026-03-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "First winter in a house with a real fireplace and I was nervous about using it. The tech cleaned everything out, checked the flue liner, and explained the difference between the open and closed damper position. No rush, no upsell. I feel like I can actually light a fire now without burning the place down.",
          "name": "Darnell P.",
          "date": "2026-03-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Very gentle and respectful young man named Pete came to clean our chimney. He explained the flue liner condition slowly so my husband could follow along. No rushing, no pressure.",
          "name": "Doris P.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Persistent smoky odor in the summer turned out to be heavy creosote buildup soaking up humidity. Roy explained it clearly, swept the flue, and recommended a stainless cap to keep rain out. Smell is gone.",
          "name": "Priya K.",
          "date": "2026-02-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quick, clean, no fuss. Silas swept the fireplace, vacuumed the ash bin, and was out in under an hour with the hearth spotless. Cozy and ready for winter now.",
          "name": "Trevor B.",
          "date": "2024-11-02",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Bought a house where the previous owners clearly never swept the chimney. Tate showed me before and after photos and the difference was night and day. Thick layer of buildup gone, damper now moves freely.",
          "name": "Priya R.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Vern handled our air duct cleaning and showed me before/after photos of the return vents. The difference was shocking, years of grime gone. No more musty smell when the AC kicks on.",
          "name": "Damon R.",
          "date": "2024-11-03",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Came for the annual chimney inspection, mentioned my clothes were taking two cycles to dry, and the tech offered to clean the dryer vent on the spot. Glad I let him. He showed me a felted lint clog near the vent hood and cleared the whole run.",
          "name": "Priya R.",
          "date": "2026-02-21",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Wade swept the chimney fast and showed me a photo of the clean flue afterward. Shoe covers on the whole time. Same-day appointment too. Couldn't ask for more.",
          "name": "Priya R.",
          "date": "2026-03-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Annual sweep done quick and clean. Tech wore shoe covers, swept the flue, and vacuumed up the soot at the firebox. Handed me a short written report noting light creosote and a healthy damper. In and out in under an hour.",
          "name": "Priya R.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Heard about them at a block party when a neighbor mentioned how thorough their sweep was. Booked the same week. Wyatt ran the brush all the way up the flue and showed me a photo of the cap before and after. Honest, tidy work.",
          "name": "Priya R.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What sold me was that the cleaning and the repair happened in one trip. Cole brushed out the flue, then noticed the stainless cap had come loose and resecured it before he left. No second appointment, no upcharge for coming back. Truck was fully stocked so he had the part on hand.",
          "name": "Priya R.",
          "date": "2024-09-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Bought the house last fall and wanted a thorough look before lighting a fire. Dale did a full camera inspection and spotted a hairline crack in the crown plus a gap behind the smoke chamber I'd never have known about. He showed me the footage right there on his tablet and explained what was urgent versus what could wait.",
          "name": "Priya R.",
          "date": "2026-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quoted, cleaned, done. The price they gave over the phone for the sweep was the price I paid, no surprise flue liner upsell like the last company tried. Creosote came out heavy and they showed me before and after photos. Fair and refreshingly straightforward.",
          "name": "Priya K.",
          "date": "2026-03-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Honest folks. Aiden swept the flue, showed me the before and after photos, and didn't try to sell me anything I didn't need.",
          "name": "Renee K.",
          "date": "2024-09-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Spalling brick on the upper section of our chimney was getting worse every winter. Beau explained how water was getting behind the failing mortar joints, then ground out the bad joints and repointed the whole upper third. He also recoated the crown. No more crumbling chips on the patio.",
          "name": "Priya R.",
          "date": "2026-03-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Storm knocked half our shingles loose and we noticed water staining around the chimney. The tech checked the flashing, found it had pulled away, and resealed it same day. Quick and clean.",
          "name": "Priya N.",
          "date": "2024-09-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Caleb came out to prep our gas logs for winter. He vacuumed years of dust off the burner, repositioned the ceramic logs to the diagram, and checked the thermocouple and pilot assembly. Flame is blue and steady now instead of that lazy yellow it used to have.",
          "name": "Priya K.",
          "date": "2026-01-09",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Camera inspection found a gap in the flue liner that the previous company completely missed. Worth every penny. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Priya R.",
          "date": "2026-02-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Brown stains kept showing up on the ceiling near the fireplace, and turns out it was the chimney crown letting moisture in. Dewey showed me the hairline cracks up top, patched the crown, and applied a vapor-permeable waterproofing on the brick. He explained the whole process so I actually understood why the stains were happening. No more leaks since.",
          "name": "Priya S.",
          "date": "2025-04-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "First fireplace, zero experience. Earl took the time to show me the flue liner with his little camera and explained what good airflow looks like. Genuinely appreciated how he didn't rush.",
          "name": "Derek P.",
          "date": "2026-01-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Squirrels had packed leaves and acorns into our flue. Floyd cleared it all out, swept up the creosote while he was at it, and capped the top with a stainless mesh cap so nothing gets back in. Showed me before and after photos on his phone.",
          "name": "Priya N.",
          "date": "2025-08-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Stainless liner install went smoothly. Gus explained why the masonry chimney needed relining after the camera showed gaps in the old tiles. Clean work, fair price.",
          "name": "Priya R.",
          "date": "2025-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quick and tidy fireplace cleaning before winter. Hank put down drop cloths, swept the firebox, and was gone in under an hour with no mess left behind. House felt ready for the cold.",
          "name": "Derek H.",
          "date": "2024-11-02",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Dryer was taking forever to dry towels. Ira cleaned the vent while up on the roof for the sweep and showed me the clump of lint from the termination cap. Runs great now.",
          "name": "Priya R.",
          "date": "2024-09-22",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Quick, clean sweep of the wood-burning insert. Liner checked out fine and Jed even tightened a loose connector at the appliance collar. Out in under an hour.",
          "name": "Priya R.",
          "date": "2024-09-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Firebox came out looking brand new. The tech reset two cracked firebricks and cleaned the damper while he was in there. Quick and tidy.",
          "name": "Devon R.",
          "date": "2026-03-02",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Tenth year in a row using them for the annual cleaning. Creosote was heavier than usual this time and the tech explained why before he even started brushing.",
          "name": "Theodore R.",
          "date": "2025-01-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Cold snap hit two days before Christmas and our flue was clearly clogged. Called in a panic and Knox came out within hours, cleared the blockage, and showed me a bird's nest he removed from up top. Lifesaver.",
          "name": "Priya R.",
          "date": "2024-12-23",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After buying a foreclosure I had no idea what shape the chimney was in, so I scheduled a full sweep and inspection. Levi arrived with a fully stocked truck and clearly wasn't going to leave until things were right. He spent close to two hours brushing the flue, clearing a partial blockage of leaves and a dead squirrel nest, and checking the damper, which was rusted shut. He freed it up, cleaned everything, and walked me through before-and-after photos on his tablet. What impressed me most was that he didn't try to upsell a crown replacement I clearly didn't need yet. Shoe covers, tidy cleanup, fair price. I'll be calling this family business every year from now on.",
          "name": "Priya N.",
          "date": "2026-02-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Damper replaced same day. Sealed tight now, no more draft. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Gwen R.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Cracked crown was letting water seep into the brick. Murphy showed me before and after photos so I could actually see the patched crown and the new cap. No more leak. Worth every penny.",
          "name": "Desmond R.",
          "date": "2026-03-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Damper handle snapped off in my hand. Ned came out same week, replaced the whole assembly, and tested the seal with a smoke pencil. No leaks. Quick and tidy.",
          "name": "Priya S.",
          "date": "2026-02-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Tuckpointing on the upper third of our chimney where the mortar had washed out completely. Otis matched the existing joint profile and the new work blends right in. Drop cloths everywhere, very tidy.",
          "name": "Desmond R.",
          "date": "2026-03-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We lost a few shingles around the chimney base in a hailstorm and were worried about leaks. Pete climbed up, found the flashing had pulled loose, and resealed everything plus checked the crown for hairline cracks. He sent before and after photos to my phone and a written report the same day. Honest pricing, no upselling. Will call them again.",
          "name": "Priya N.",
          "date": "2025-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wonderful work on our fireplace. The smoke staining on the firebox brick was so heavy we thought it was permanent, but the crew brought it back to life. They even cleaned the glass doors and showed me before and after photos. Worth every penny and the office was easy to schedule with.",
          "name": "Devon R.",
          "date": "2025-02-19",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "Roy showed up with a vacuum that caught every speck of soot. He taped plastic around the firebox opening so nothing escaped into the room. After the sweep he wiped down the hearth tiles and even the brass surround. Cleaner when he left than when he arrived, honestly.",
          "name": "Priya R.",
          "date": "2024-11-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Skeptical doesn't begin to cover it. A previous company swore my brick stack was structurally failing and quoted a full teardown. Silas came out, did a thorough inspection, and handed me a written report showing the masonry was sound. He pointed out the actual culprit was failing flashing at the roofline. Fixed it same day. Saved me thousands.",
          "name": "Priya R.",
          "date": "2026-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Tate handled our annual cleaning and was a true professional. Showed me before and after photos of the flue and explained the slight glazing he found.",
          "name": "Devon R.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Gas-log prep done right. Tech tested the pilot, cleaned the soot off the ceramic logs, and made sure the oxygen depletion sensor was working before lighting it for me.",
          "name": "Priya N.",
          "date": "2025-09-30",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Booked these folks after moving into a house where the previous owners clearly never cleaned the chimney. Glazed creosote everywhere. Vern explained the buildup honestly and got it scraped down to bare liner.",
          "name": "Priya N.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Stove insert hadn't been swept in three winters. The tech ran a brush through the liner, vacuumed out the firebox, and left zero mess thanks to the drop cloths. Honest crew, fair price.",
          "name": "Priya N.",
          "date": "2026-02-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Squirrels had stuffed our flue with leaves and acorns over the winter. Wade cleared it all out, showed me before and after photos, and installed a new stainless cap with mesh sides. Quick and tidy work.",
          "name": "Priya R.",
          "date": "2026-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Pre-purchase inspection done quickly and thoroughly. Wyatt checked the crown, cap, and flashing, then emailed a detailed written report the same day. Helped us go into negotiations with real information instead of guesses.",
          "name": "Priya R.",
          "date": "2026-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Cold snap hit and our heat struggled, so we wanted the fireplace ready fast. Cole arrived within hours, swept the flue and cleared a small bird's nest near the cap. Quick, clean, and reasonable.",
          "name": "Priya R.",
          "date": "2023-12-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Sooty smell hung in the den for weeks. Dale diagnosed a negative pressure issue from our new range hood pulling air down the flue. Cracked a window per his advice and the draft corrected instantly. Honest, clear explanation.",
          "name": "Priya R.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a level two inspection turned up a gap in the flue, the crew recommended relining rather than a patch job. They explained why insurance wouldn't cover a damaged liner and laid out the full cost up front. Aiden and another tech ran a new insulated stainless liner top to bottom, sealed the crown, and hauled away every scrap. Truck was fully stocked so there was no waiting on parts.",
          "name": "Donovan R.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Year after year I call these guys and year after year they earn it. This time Beau swept the flue, checked the damper which was sticking a bit, and gave it a quick adjustment so it seals right again. He laid shoe covers at the door without me asking. Booked next October's appointment before he left. That kind of consistency is rare.",
          "name": "Donald K.",
          "date": "2023-09-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Buying a foreclosure is stressful enough without surprises in the chimney. Caleb showed up on time, laid down drop cloths even though it was just an inspection, and spent a solid hour going over the masonry and flue with a camera. The report flagged spalling brick and a missing stainless cap. He explained which items were urgent and which could wait. Genuinely helpful for a first-time buyer like me.",
          "name": "Yolanda R.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "We bought our first home in the fall and the fireplace came with it. Dewey came out for the cleaning and gave me a whole patient tutorial on the chimney cap, the smoke shelf, and how often to schedule a sweep. He laid down drop cloths so my floors stayed spotless. I took notes the whole time because he was so clear about it all.",
          "name": "Priya K.",
          "date": "2025-02-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My late husband always handled the chimney, so this was my first time arranging a sweep on my own. The office walked me through everything kindly. The technician showed me before and after photos of the creosote he removed and never once made me feel foolish for not knowing the terms. A trustworthy outfit.",
          "name": "Eleanor B.",
          "date": "2026-02-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our fireplace had a nasty downdraft pushing cold air and soot smell into the den whenever the wind kicked up. The technician diagnosed a chimney that was too short relative to the roofline and installed a draft-correcting cap. Laid down drop cloths the whole time and walked me through before and after photos. The difference is night and day, fires light easily and the room stays clear now.",
          "name": "Desmond R.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Scheduling was painless and the office called the morning of to confirm a window. Earl showed up in shoe covers and treated our living room like his own. He cleaned out the firebox, brushed the smoke shelf, and showed me before and after photos of just how much soot had built up. The glass doors sparkle now and the whole thing smells fresh. We light it almost every night since.",
          "name": "Priscilla N.",
          "date": "2025-09-29",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Decades, honestly. Never once cleaned it. The crew arrived on time, laid down protection, and Floyd got to work scraping years of creosote off the flue liner. He warned me about a stage-three glaze buildup near the top and explained why it mattered. Got a written report with everything documented. Felt good to finally have it done right.",
          "name": "Eleanor W.",
          "date": "2024-09-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a kitchen remodel left fine drywall dust everywhere, we booked the air duct add-on. Gus and the crew cleaned every supply duct and return, vacuumed the main trunk lines, and laid drop cloths near each vent. Took about three hours and the air quality improvement was immediate. Professional from the first phone call to the final walkthrough.",
          "name": "Priya N.",
          "date": "2025-03-22",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "While the crew was up doing the cap and crown work, Hank went ahead and brushed out our dryer vent too. He snaked it from the lint trap all the way to the exterior hood and bagged up two handfuls of buildup. One less thing to worry about as a fire hazard.",
          "name": "Deshawn K.",
          "date": "2025-08-03",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Years of soot gone in one visit. The tech checked the damper, swept the flue, and left the hearth spotless. Quick, clean, professional work.",
          "name": "Devon K.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We've used these folks for our yearly cleaning three seasons running now. Ira remembered our setup from last time, which I appreciated. He brushed the full flue, scraped some stubborn creosote off the upper section, and checked the cap while he was on the roof. He even pointed out a hairline gap in the crown to keep an eye on but didn't try to upsell me a repair I didn't need yet. Honest crew.",
          "name": "Donovan K.",
          "date": "2024-11-03",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "A guy two houses down recommended Smith and Sons after they sorted out his smoky fireplace. Figured a word-of-mouth tip beats a random search. The crew swept the chimney, checked the damper operation, and pointed out a bit of creosote buildup higher in the flue that they cleared. Reasonable price and they were done in under an hour.",
          "name": "Daniel K.",
          "date": "2025-09-03",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Punctual to the minute. Jed called fifteen minutes ahead like the scheduler promised, laid down drop cloths, and had the chimney swept and a new damper seal installed before noon. Same visit, done right.",
          "name": "Eleanor M.",
          "date": "2026-03-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Hidden creosote glaze deep in the flue offset was the culprit behind our poor draft. The level-2 scan caught it.",
          "name": "Devon K.",
          "date": "2024-11-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After two other companies tried to scare me into a thousand-dollar repair, these folks sent Knox out for a free inspection and told me my chimney just needed a basic cleaning. He could have easily upsold me on a new cap. He didn't. That kind of honesty earns repeat business, and they got mine.",
          "name": "Daniel R.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What struck me most about Smith and Sons was how down-to-earth they are. The father answered the phone himself and one of the sons, Levi, did the actual cleaning. He laid drop cloths everywhere, swept the creosote out cleanly, and we chatted the whole time. Felt like having a neighbor over rather than a contractor. Will use them every season from here on out.",
          "name": "Devon A.",
          "date": "2026-02-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Older farmhouse, original chimney, lots of deteriorated mortar. The crew did careful tuckpointing and pointed out two bricks that had spalled all the way through. Fair price and they cleaned up every speck.",
          "name": "Gerald V.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Hail did a number on our chimney crown last spring. Murphy inspected it top to bottom, showed me the spider cracks, and patched the crown with a proper sealant instead of just slapping caulk on it like the last guy. He also swapped out the bent cap. Handed me a written report for the insurance claim, which my adjuster actually thanked me for. Solid work from people who clearly know chimneys.",
          "name": "Eleanor V.",
          "date": "2025-05-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our gas fireplace had a faint odor when running, which made us nervous. The tech ran a combustion check, cleaned the burner and pilot, and found the logs had shifted enough to cause incomplete burning. After he realigned everything and tested the gas connections with a leak solution, the smell was gone. Put down drop cloths and wore shoe covers the whole time too. Very thorough safety check.",
          "name": "Devon R.",
          "date": "2025-10-27",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "After buying an older home, we wanted a thorough look before lighting the first fire. Ned brought the camera and threaded it down the entire flue. Turned out there was heavy glazed creosote buildup near a bend plus a small separation between two liner sections. He explained the fire risk plainly and scheduled the repair. Trucks were stocked so the cleaning happened same day.",
          "name": "Devon K.",
          "date": "2025-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Rusted cap, finally replaced. Looks sharp now. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Doug R.",
          "date": "2024-11-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Just moved into a 1940s home and the fireplace intimidated me. Otis did a full sweep and inspection, then sat down at my kitchen table afterward to go over the written report line by line. He explained seasoned versus green wood, why the creosote was darker in spots, and how often a first-time owner like me should book a cleaning. Drop cloths everywhere, shoe covers on, not a speck of soot left behind. Couldn't have asked for a better introduction to fireplace ownership.",
          "name": "Aisha N.",
          "date": "2025-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "A pair of birds had built a nest right at the top of our chimney and the smell was awful. Pete removed the whole thing, cleaned the flue, and fitted a new stainless cap. He wore shoe covers and left no mess behind. Very professional.",
          "name": "Donovan K.",
          "date": "2024-11-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a chimney fire scare, we needed the flue relined fast. The office got a crew out within two days, which I appreciated. Roy ran a camera up first so we could actually see the damaged tiles on his screen, then quoted a stainless insert. Installation took most of an afternoon. He showed me the new liner and how the top plate and cap were sealed against water. No mess left behind.",
          "name": "Donovan K.",
          "date": "2023-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our gas fireplace hadn't been touched in three seasons and the logs were caked with dust. Silas pulled the logs, cleaned the burner ports, and tested the pilot before reassembling everything exactly as it was. He even showed me on his phone the before and after photos. Flames are blue and steady now and we are all set for the chilly months.",
          "name": "Priya N.",
          "date": "2025-09-27",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "While the crew was out doing our flue, I mentioned the laundry room always felt hot and humid. They added a dryer vent cleaning on the spot since the truck was fully stocked. Brushed the whole run from the lint trap to the exterior hood, vacuumed everything, and laid down a drop cloth so there was zero mess. The difference in airflow at the outside vent is night and day. Appreciated that they didn't try to upsell anything I didn't need.",
          "name": "Eleanor B.",
          "date": "2026-03-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "After a few seasons of heavy burning I was worried about creosote in my insert flue. Tate brushed the liner top to bottom, vacuumed the firebox, and gave me a written report noting a thin Stage 2 layer that he cleared completely. He recommended drier wood going forward and explained why my damper area was collecting soot. Honest and thorough, no upsell.",
          "name": "Deshawn K.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After fifteen years of winter fires our fireplace had turned into a dingy gray box. Vern spent a good two hours hand-cleaning the firebox, replacing missing mortar between the firebricks, and polishing the cast iron grate until it looked sharp again. He wore shoe covers, taped plastic over the mantel, and walked me through everything he found. Honestly it looks better than the day we bought the house.",
          "name": "Priya K.",
          "date": "2025-08-19",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Annual sweep done right. Wade swept the flue, vacuumed the firebox, and pointed out a little glazing on the liner that I should keep an eye on. Honest and quick.",
          "name": "Priya N.",
          "date": "2023-09-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Hosting the whole family for the holidays and our fireplace was smoking up the living room. Wyatt arrived same day, found heavy creosote glazing in the flue, and gave it a thorough cleaning. He wore shoe covers the entire time and left zero mess. We had a proper fire that night.",
          "name": "Daniel K.",
          "date": "2025-12-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Honestly didn't expect a chimney cleaning to be this painless. Cole called ahead, showed up within the window, and got right to work without tracking soot through the house. He found heavy creosote buildup near the smoke shelf and explained how it had become a real fire hazard given how much we burn each winter. The flue liner checked out fine, thankfully. He capped off the visit by installing a new stainless cap to keep birds and rain out, since our old one had rusted through. Clear pricing, no surprises on the invoice, and he answered every dumb question I threw at him. The whole crew clearly takes pride in doing it the right way.",
          "name": "Eleanor V.",
          "date": "2025-09-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We could feel cold air leaking into the living room even with the fireplace closed, and our heating bill kept climbing. Dale found the damper plate was bent and no longer sitting flush. He installed a new top-mount damper with a cable control and showed me the gasket seal before and after. House feels noticeably warmer now.",
          "name": "Priya K.",
          "date": "2026-02-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We had brown stains spreading on the ceiling near the chimney chase. The tech traced it to a missing cap and a hairline crack in the crown. They rebuilt the crown with a proper overhang, installed a stainless steel cap, and applied a vapor-permeable waterproofing on the masonry. Drop cloths everywhere, shoe covers on, and a written report with photos handed over at the end. Genuinely impressed by how thorough the crew was.",
          "name": "Priya V.",
          "date": "2024-08-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We had a constant whistling draft and a heating bill that kept climbing. Aiden diagnosed a damper that wouldn't fully close because of creosote buildup wedged in the hinge. He cleaned it out, freed the plate, then recommended a top-mount damper since the original cast iron was cracked. Installation took about an hour and he laid drop cloths over the whole hearth. The seal is airtight now and the lever action is smooth. Fair price, no upsell pressure.",
          "name": "Donovan R.",
          "date": "2025-09-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We bought a 1940s house and the inspection flagged spalling brick on the chimney. Smith and Sons came out, and Beau took time to show me exactly which courses had face-shedding from water intrusion. They replaced the worst bricks, repointed the rest, and sealed it with a breathable waterproofing. The crown was also re-poured because the old one had cracked clean through. Fair price for the amount of work, and the written estimate matched the final bill to the dollar. Genuinely impressed with this family business.",
          "name": "Priya N.",
          "date": "2024-11-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Storm knocked our chimney cap clean off into the backyard. Called the office, got squeezed in for a same-day visit. Tech installed a new stainless cap and pointed out where the flashing needed resealing too. Fair price.",
          "name": "Diego R.",
          "date": "2024-11-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Sparkling results. Caleb cleaned out the firebox, vacuumed the ash dump, and the whole hearth looks like a showroom piece again.",
          "name": "Priya K.",
          "date": "2024-09-30",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "What stood out was how careful they were about my cream carpet. Two layers of drop cloths and runners all the way from the front door. The crew worked the flue brush from the roof and a HEPA vac at the bottom so no creosote dust drifted out. Zero mess.",
          "name": "Devon K.",
          "date": "2026-01-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Got a scary quote from a door-knocker about rebuilding my chimney from the firebox up. I called these folks for a sanity check. Dewey showed up, laid down drop cloths, swept the flue, and walked me through before-and-after photos. Turns out there was nothing wrong except heavy creosote buildup. No upsell, no drama. I'm a believer now.",
          "name": "Donovan K.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Earl swept the chimney and inspected the liner in under two hours. Courteous, wore shoe covers without being asked, and gave me a written report on the spot. Appreciated his straight talk about what could wait and what needed attention.",
          "name": "Priya K.",
          "date": "2026-03-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We bought a house with an existing gas fireplace and had no idea if it was safe to use. Floyd came out, inspected the flue, tested for carbon monoxide while it ran, and walked me through how the millivolt valve works. He repositioned the logs exactly per the manufacturer diagram because they'd been set wrong, which can cause sooting. Honest, careful work from a family-run outfit. We feel comfortable using it now.",
          "name": "Dwayne R.",
          "date": "2024-02-11",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Our chimney had probably gone fifteen years without attention. The tech who came out, Gus, was patient about showing me just how much soot and creosote had accumulated. He wore shoe covers, ran a HEPA vacuum, and left the hearth cleaner than he found it. Honestly relieved we caught it before a fire risk became real. The written report was thorough and easy to understand.",
          "name": "Eleanor B.",
          "date": "2025-09-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked a cleaning and liner inspection for our wood-burning insert before the season. Hank arrived right on time, laid down a tarp, and swept out a thick band of creosote. He scoped the liner with a camera and walked me through every section on his screen. Came away with a written report and a clear conscience heading into winter. Very thorough work.",
          "name": "Garrett W.",
          "date": "2025-09-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We could smell something awful coming from the fireplace and dreaded what it might be. The tech found a dead bird and an old nest jammed against the smoke shelf. He removed everything, vacuumed out the debris, and put a proper stainless cap on top so critters can't get in again. Honest, careful, and he laid down drop cloths the whole time. Couldn't ask for more.",
          "name": "Donovan K.",
          "date": "2024-11-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "As a first-time buyer I had no idea what to look for in a chimney. Ira walked the roof, scoped the flue with a camera, and showed me the creosote buildup and a leaning chimney cap on the spot. The written report broke everything into urgent versus cosmetic, which made it easy to decide what to ask the seller to fix. Genuinely educational and not pushy at all.",
          "name": "Devon K.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Thanksgiving morning and we smelled smoke backing into the living room with eight guests on the way. Phoned in a panic and they had Jed out by noon. Turned out the damper was stuck partway and creosote buildup was restricting the draft. He freed the damper, swept the flue, and checked the stainless cap for blockage. We had a clean-burning fire by dinner. Honest pricing for a holiday emergency call too, which I half expected to get gouged on.",
          "name": "Donovan F.",
          "date": "2025-11-26",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We had a persistent campfire odor even when nothing was burning, worst on humid days. Knox explained it was creosote buildup soaking up moisture and breathing back through a leaky damper. He swept the flue, scraped the third-stage creosote off the liner, and installed a proper stainless cap to keep rain out. The smell dropped within a day and hasn't come back. Trucks were fully stocked so it was all done in one visit.",
          "name": "Donovan K.",
          "date": "2026-03-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Bought an older home and the chimney inspector flagged the liner. These folks came out, confirmed the clay tiles had spalled, and installed a new flexible stainless liner for the furnace. Levi was professional, wore shoe covers, and left the basement spotless. Appreciated the honest assessment instead of an upsell.",
          "name": "Saoirse M.",
          "date": "2025-01-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Loyal for going on seven years. The annual inspection caught a worn stainless cap last fall and they swapped it during the same visit. This time the flue was nice and clean, minimal creosote, which the tech said is because we keep up the yearly schedule. Couldn't be happier.",
          "name": "Yolanda B.",
          "date": "2025-10-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Needed a fast inspection before our offer deadline. The office squeezed us in same day. Murphy documented a deteriorating crown and water staining in the firebox, all in a tidy written report with before-and-after style photos. Sellers fixed it before closing.",
          "name": "Trevor M.",
          "date": "2025-01-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Total beginner here. The crew swept the chimney and walked me through what the creosote glaze looked like before they removed it. Appreciated that they slowed down and answered every newbie question I had.",
          "name": "Conor M.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Ned took his time with us. We're both in our eighties and a little hard of hearing, and he spoke clearly and waited while we asked the same thing twice. Cleaned the damper and showed us the soot he pulled. Lovely man.",
          "name": "Harold W.",
          "date": "2025-03-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Smoke kept rolling back into the room. Otis checked the damper and found it warped so it never fully opened. Replaced it same day and showed me how to test the draft with a match. Solid work.",
          "name": "Lena M.",
          "date": "2025-03-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wanted the fireplace ready before the first cold snap and these folks delivered. Pete cleared a season of ash, wiped down the glass, and tested the damper to make sure it sealed tight. Honest about what we did and didn't need, which I appreciated.",
          "name": "Desmond R.",
          "date": "2025-11-12",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "First sweep in nine years and the technician didn't sugarcoat how much buildup there was. Pulled bag after bag of soot and creosote. Shoe covers on, careful the whole time.",
          "name": "Devon K.",
          "date": "2025-03-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Two cats and a dog meant our ducts were packed with pet hair and dander. The technician ran a brush and vacuum system through every vent and showed me the filter bag at the end. Genuinely impressed.",
          "name": "Curtis B.",
          "date": "2024-06-18",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Honestly didn't even know dryer vents needed cleaning until Roy brought it up during our sweep. He measured the airflow before and after, and the difference at the vent hood flap was night and day. Quick add-on, no upsell pressure.",
          "name": "Eleanor W.",
          "date": "2025-04-09",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Stainless cap was loose and Silas spotted it during the sweep. Tightened it up and cleaned the creosote in the same trip. No mess, fair price.",
          "name": "Lorena M.",
          "date": "2025-06-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Same-day appointment for our routine sweep before the cold set in. Tate was friendly and thorough, laid down drop cloths and used a HEPA vacuum so there was zero dust in my living room. Creosote removal was the main job and he showed me before and after photos from up top. Will book again next autumn.",
          "name": "Eleanor B.",
          "date": "2025-09-28",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Trusted my neighbor's recommendation and so glad I did. Vern was friendly, explained what he was doing, and wore booties the whole time.",
          "name": "Yvonne A.",
          "date": "2024-12-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked a sweep and figured the small mortar repair on the crown would be a separate job. Nope. Wade knocked out both in one stop, showed me before and after photos of the flue, and explained why the creosote was building up so fast. Appreciated that he respected my time and the house with shoe covers the whole visit.",
          "name": "Darnell W.",
          "date": "2025-01-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a minor chimney fire, our insurance required a level-2 inspection. Wyatt brought the camera, fed it the full length of the flue, and identified two spots where the liner had warped from the heat. He walked me through every frame of the recording, marked the locations on a diagram, and the written report was detailed enough that my adjuster approved everything without a single follow-up question. Genuinely thorough work and no upselling.",
          "name": "Eleanor M.",
          "date": "2025-01-27",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Transparent from the first call. The scheduler explained exactly what the sweep would cost and why, with no vague ranges. Cole ran the brush down the flue, vacuumed up the creosote, and the final invoice matched the quote to the dollar. No hidden fees, no nonsense.",
          "name": "Lena M.",
          "date": "2025-01-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dale was personable from the second he arrived. He put on shoe covers without being asked, swept the chimney, and pointed out a small gap in the flue liner that he said wasn't urgent. Refreshing to deal with someone who tells you straight.",
          "name": "Sandra W.",
          "date": "2025-03-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What impressed me most was the honesty. After inspecting the brickwork on our 80-year-old home, Aiden said only the south face actually needed repointing rather than the whole stack like another company quoted. He replaced the spalled bricks, repaired the crown, and sealed it with a breathable waterproofing. Written report with photos showed exactly what was done and why.",
          "name": "Nadia K.",
          "date": "2025-06-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Wind tore the cap clean off during a storm and rain was getting into the flue. Called the office, they squeezed me in same week. Beau capped it with a new stainless one and checked the flashing for good measure. Reasonable price.",
          "name": "Darnell K.",
          "date": "2024-11-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Caleb did a full safety inspection on our gas-log set before we started using it again. He cleaned the glowing embers material, checked the venting, and showed me how the flame should look when it's burning correctly. Honest, patient, and never tried to upsell us. Appreciated the written report he left.",
          "name": "Annette W.",
          "date": "2024-12-03",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Honestly impressed by the technology. The level-2 scope camera revealed a hidden blockage where a squirrel had stuffed nesting material above the damper. Couldn't see it from below at all. Dewey cleared it and showed me the before and after video. Cheery, professional, laid down drop cloths the whole time.",
          "name": "Allison M.",
          "date": "2025-12-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our cap had blown off in a windstorm and water poured straight into the flue. Earl came out same day with a new stainless steel cap on the truck and had it installed within the hour. He also pointed out a couple spots on the crown that were starting to crack and sealed them as a preventive measure. Fair price, no upselling.",
          "name": "Yolanda B.",
          "date": "2025-12-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Never owned a fireplace before this winter. The crew swept the flue and showed me before and after photos so I could actually see the difference. They explained the stainless cap they recommended to keep critters and rain out. No pressure, just good advice for a newbie.",
          "name": "Trevor M.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Raccoon nest in the flue, of all things. Cleared and capped same day. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Theresa W.",
          "date": "2025-03-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Switched from an oil furnace to gas and the flue was way too big for the new appliance. Floyd sized and dropped in a properly sized aluminum liner so the venting would draft correctly. He walked me through every step and pointed out the old creosote buildup he cleaned out first. Honest, no upselling.",
          "name": "Eleanor M.",
          "date": "2025-03-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Cozy season is officially open at our place. The technician scraped a surprising amount of creosote off the firebox walls and cleaned out the ash dump so the airflow is much better. Pleasant, on time, and respectful of the house with shoe covers on.",
          "name": "Curtis B.",
          "date": "2024-10-19",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Gus handled the dryer vent add-on after the chimney inspection and was honest that ours had probably never been cleaned. The lint behind the dryer was packed solid. Worth every penny for the fire safety alone.",
          "name": "Devon K.",
          "date": "2025-06-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Scheduling was painless and the office called the morning of with a heads-up. The crew pulled my pellet-style insert partway out, swept the connector pipe, and inspected the full liner length. Found a slightly loose cap screw up top and fixed it on the spot. Shoe covers, tidy work, fair price.",
          "name": "Eleanor W.",
          "date": "2025-02-18",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Wanted the firebox cleaned up before the holidays. Hank showed up same morning, knocked out the creosote glaze on the back wall, and tightened the loose damper plate. Left the hearth spotless with the drop cloth he brought.",
          "name": "Brennan M.",
          "date": "2024-12-07",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Been heating with wood for almost thirty years and a clean chimney every fall is just part of the routine now. What I appreciate about this outfit is they don't try to upsell. Ira brushed the whole flue, measured the creosote, said it was a normal year, and that was that. Shoe covers on, written report in hand, out the door.",
          "name": "Desmond K.",
          "date": "2025-10-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Temperatures dropped overnight and I needed the chimney cleared fast before relatives arrived. The scheduler found me a same-day slot. Jed did a quick but thorough sweep, checked the damper, and pointed out the cap needed a minor fix which he handled on the spot from his stocked truck.",
          "name": "Eleanor S.",
          "date": "2026-01-08",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "We'd been smelling something musty whenever it rained and assumed it was the basement, but it turned out water was getting into the chimney. Knox came out, inspected the crown, and found it badly cracked and letting moisture seep down into the masonry. He explained the whole waterproofing process in plain language, sealed the crown, and cleaned out the flue while he was up there. He even pointed out where the flashing was lifting at the roofline and recommended I keep an eye on it. Detailed written report landed in my inbox that afternoon with photos of everything he described. The dampness smell is gone after the next few storms. Couldn't ask for a more thorough, honest visit.",
          "name": "Damian K.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Booked an appointment because our chimney whistled on windy nights. Turned out the damper wasn't seating at all. The tech swapped it for a new one and added a proper gasket so it closes airtight. Quiet evenings again and a written report left on the counter.",
          "name": "Donovan F.",
          "date": "2025-03-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Rusted cap was funneling rain straight into the flue. Levi swapped it for a new stainless cap and sealed the crown the same afternoon. Quick, clean, no leak since.",
          "name": "Garrett M.",
          "date": "2025-06-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Replacement of a frozen damper that hadn't moved in years. Murphy got it loose, but the frame was too corroded to reseal, so he fitted a new one. Explained every option. Cold air no longer sneaks in.",
          "name": "Yolanda B.",
          "date": "2024-07-22",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Older home, lots of deteriorated mortar. The tech ground out the failing joints and repointed cleanly. Honest about what needed doing now versus what could wait a season.",
          "name": "Travis K.",
          "date": "2023-08-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Following a nasty spring storm, I wanted the chimney looked at before using the fireplace again. Ned did a thorough inspection, found a cracked crown and water staining inside the flue, and walked me through the repair options with photos. The crew patched the crown, waterproofed it, and replaced the cap two days later. Tidy, professional, and they laid drop cloths inside the whole time.",
          "name": "Eleanor W.",
          "date": "2025-05-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After fifteen years of use our fireplace looked like a cave. Otis spent the better part of a morning detailing the firebox, scrubbing the refractory panels, and degreasing the brick. He laid down shoe covers and drop cloths and you'd never know anyone had been there except the fireplace now gleams. Genuinely impressed with the attention to detail.",
          "name": "Hassan M.",
          "date": "2026-03-08",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Pete was meticulous. Booties on, drop cloth down, and a special seal over the fireplace opening before he ran the brush. I expected to be vacuuming black dust for days but there was nothing. He showed me a handful of the creosote he pulled out and then bagged it.",
          "name": "Annette F.",
          "date": "2025-08-27",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Quoted a small fortune elsewhere for a rebuild I didn't need. Roy inspected the crown and cap, found a hairline crack, sealed it, and was done in under two hours. Genuinely refreshing honesty.",
          "name": "Yolanda B.",
          "date": "2025-01-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My thanks go to Silas, who scraped years of creosote out of our flue and never once made me feel silly for letting it go so long. He pointed out a hairline crack in the crown and photographed it so I could see exactly what he meant. Friendly, fast, tidy.",
          "name": "Gregory M.",
          "date": "2025-02-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Annual safety check on our gas logs. The technician cleaned the burner, replaced a worn thermocouple, and verified the flame height. Quick, professional, and he put down a drop cloth so no soot got on the carpet.",
          "name": "Helena K.",
          "date": "2026-01-22",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "First sweep in over a decade and wow, the amount of buildup that came out of that flue was alarming. Tate took his time, didn't rush, and answered every question I threw at him. Now the draft is so much better when we light a fire.",
          "name": "Desmond K.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "These folks cleaned the liner on our old wood stove and checked the cap while they were up there. Found a bit of rust on the stainless cap and gave me options rather than pressuring me. Appreciated the straight talk.",
          "name": "Linda K.",
          "date": "2024-12-09",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Raccoon had taken up residence and left quite a mess. Vern handled the removal humanely and cleaned the flue completely. New stainless cap installed same afternoon. Professional and patient with all my questions.",
          "name": "Yolanda B.",
          "date": "2025-05-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Hired them for an inspection before we made an offer. The report flagged spalling brick on the crown and missing mortar joints. Photos were clear and the explanation was plain English. Saved us from a surprise.",
          "name": "Sandra L.",
          "date": "2025-01-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Arctic blast was forecast and I hadn't used my fireplace in a season. Called that morning, they fit me in by mid-afternoon. The tech swept the flue, vacuumed the firebox, and pointed out a hairline crack in the crown to keep an eye on. No upsell pressure at all.",
          "name": "Lena K.",
          "date": "2024-01-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Downdraft was so bad it would snuff the fire out and fill the room with smoke. Wade checked the cap and found it crushed and clogged with debris. Replaced it the same day and the draft is night and day better now.",
          "name": "Tamara W.",
          "date": "2025-02-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Heavy creosote buildup had practically glazed the old liner. Wyatt cleaned what he could but was straight with me that the liner itself was shot and a relining was the safe move. Glad I listened. The new stainless setup drafts so much better and I sleep easier knowing it's up to code.",
          "name": "Bradley O.",
          "date": "2023-08-17",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Same-day slot when our usual fall appointment got bumped by weather. Cole was thorough, brushed out the liner and pointed out some glazed creosote forming near the top. Appreciate that he tells me the truth instead of upselling. Third winter with them and I'll keep calling.",
          "name": "Trevor M.",
          "date": "2024-02-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "As a real estate agent I've used several chimney companies for buyer inspections and Smith and Sons is now my go-to. They turn around the written report quickly, the photos of the flue liner and damper are crystal clear, and they never invent problems to scare my clients. Dale handled my last three transactions and each homeowner felt informed, not pressured. That kind of honesty is rare in this trade.",
          "name": "Priya N.",
          "date": "2024-06-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Never owned a fireplace before this place and was intimidated by the whole thing. Aiden was incredibly patient, swept the flue, inspected the crown, and then sat with me at the kitchen table going over a maintenance schedule for the year. He explained why I should burn hardwood and how to tell when it's properly seasoned. Shoe covers on the whole time. Honestly turned my anxiety into excitement about cozy winter nights.",
          "name": "Yolanda R.",
          "date": "2026-01-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Trustworthy from start to finish. Beau wore shoe covers without being asked and treated my old farmhouse with real care. He found a small crack near the crown and explained exactly why it mattered, then gave me a written report I could share with my son. No hard sell.",
          "name": "Ruth A.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We had been living with a faint smoke smell for two winters and just assumed it was normal. Caleb came out, ran a thorough inspection with a camera, and found a cracked flue liner letting odors leak into the wall cavity. He gave us a detailed written report with photos and explained our repair options without any pressure. The crew was respectful, wore shoe covers, and cleaned every speck of soot. Couldn't be happier with how thorough they were.",
          "name": "Anthony V.",
          "date": "2025-12-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Fantastic experience from start to finish. Dewey arrived right on time, spread drop cloths over the carpet, and got to work on a fireplace that was frankly neglected. He cleaned the firebox, brushed away the creosote near the throat, and made sure the damper opened and closed smoothly. He even walked me through how to lay a proper fire so it burns cleaner. Cozy nights ahead, thanks to him.",
          "name": "Annalise K.",
          "date": "2026-01-07",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "We moved in seven years ago and never thought about the chimney once. Earl came out, ran a camera up the flue, and showed me a creosote layer that was honestly alarming. He cleaned it thoroughly, checked the cap, and pointed out a small crack in the crown we should watch. No pressure to fix it that day. The fireplace draws so much better now and there's no more smoky smell when it rains.",
          "name": "Camille B.",
          "date": "2024-12-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Scheduling was painless and the office called the morning of to confirm. Floyd did a thorough job on the air ducts, sealing each register after cleaning so dust wouldn't resettle. He even pointed out a loose connection in one supply duct and reattached it at no charge. Honest folks who clearly take pride in the work.",
          "name": "Yolanda F.",
          "date": "2025-12-09",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Solid work. Dryer vent was packed with lint and the tech cleared it fast. Fair price, friendly crew, and a job done right the first time — no complaints at all.",
          "name": "Tomas B.",
          "date": "2024-09-18",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Sweeping was thorough and the written report was easy to read. Gus pointed out a small crown crack but no pressure to fix today. Honest folks.",
          "name": "Travis B.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Reliable annual cleaning. The scheduler got me in within the week and the tech swept the flue and cleared a moderate creosote layer. Quick, courteous, reasonable.",
          "name": "Rashad M.",
          "date": "2024-02-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My neighbor across the street has used them for years and finally convinced me to call. From the first ring the office was organized and got me on the schedule fast. Hank did the sweep, inspected the flue liner with a camera, and walked me through a written report afterward. He flagged some minor cracking in the crown but wasn't pushy about repairs. Genuinely appreciated the no-pressure honesty. The whole experience felt like dealing with people who actually care about doing it right.",
          "name": "Theodore M.",
          "date": "2026-03-17",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Same-day service that actually meant same day. Called in the morning about a sooty smell, Ira arrived that afternoon, cleaned the flue and replaced a rusted cap on the spot. Quick, clean, fair price.",
          "name": "Sofia B.",
          "date": "2025-10-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Persistent musty odor near the firebox had me stumped. The tech snaked a camera up and found a collapsed section of the clay liner trapping moisture. Photos made it obvious. Repair scheduled, problem explained clearly.",
          "name": "Tomas V.",
          "date": "2024-06-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Free estimate, fair price, no upsell. Jed laid drop cloths, swept the flue, and pointed out a little creosote glazing without trying to sell me a chemical treatment I didn't need. Said it could wait. Appreciated the honesty more than he probably knows.",
          "name": "Tobias W.",
          "date": "2026-05-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Really appreciated how candid the crew was. They could have told me I needed a whole new cap but instead just cleaned out the creosote and tightened the existing stainless cap. Honest people doing honest work.",
          "name": "Trevor M.",
          "date": "2024-12-11",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Mortar was washing out and you could see daylight in a couple of joints. Knox repointed the affected courses and swapped out three crumbling bricks. Clean, tidy, no fuss.",
          "name": "Trevor M.",
          "date": "2023-08-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We had a nasty thunderstorm roll through and afterward I could hear water dripping somewhere near the firebox. Levi traced it back to flashing that had lifted in the wind and a hairline crack in the crown. He resealed both, laid drop cloths everywhere so my hardwood stayed spotless, and showed me before and after photos on his phone. Honest, tidy, and didn't try to upsell me. Will use them again without hesitation.",
          "name": "Sofia R.",
          "date": "2026-03-20",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Scheduled a gas-log tune-up after moving into a home where the fireplace clearly hadn't been touched in years. Murphy dismantled the log set, cleaned spider webs out of the burner orifice (apparently that's a real fire hazard), and verified the pilot light and oxygen depletion sensor were working. He tested every fitting for leaks before declaring it safe. Genuinely educational visit.",
          "name": "Hector M.",
          "date": "2026-02-14",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Our insurance required a camera inspection after a chimney fire. Ned documented everything with the scope, found two cracked tiles from the heat, and gave us a detailed written report we could hand straight to the adjuster. Saved us a huge headache.",
          "name": "Reginald B.",
          "date": "2024-10-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a rough winter the chimney crown had spalled pretty badly and water was getting behind the brick. Otis ground out the bad mortar joints, recapped the crown, and applied two coats of waterproofing. He laid drop cloths inside and wore shoe covers the whole time. Tidy work and a written report with before and after photos. Glad I called.",
          "name": "Greg M.",
          "date": "2024-07-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "As a brand-new homeowner I had a hundred questions and Pete answered every single one. He showed me how to check the damper, what creosote actually is, and why I shouldn't burn that scrap lumber I'd been saving. Truly patient guidance for someone learning from scratch.",
          "name": "Bianca R.",
          "date": "2025-02-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We hadn't used the fireplace in years and assumed it was fine. Turns out a thick bird nest was blocking the flue almost entirely. The technician removed it, vacuumed out the debris, and put on a stainless steel cap to keep the critters away. Honest pricing and they explained everything as they worked.",
          "name": "Garrett M.",
          "date": "2024-06-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Needed a new liner for the wood-burning fireplace. Roy did the install and insulated the stainless pipe with a wrap so it would hold heat and draft better. Tidy, professional, on time.",
          "name": "Grant W.",
          "date": "2024-06-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We just moved into an older home and had no idea when the fireplace was last serviced. Silas gave it a thorough cleaning, checked the flue liner, and walked us through how to build a safe fire. He spent extra time answering my wife's questions about screens and tools. Honest folks who clearly take pride in the work, and our first winter fire was warm and worry-free.",
          "name": "Annette F.",
          "date": "2026-01-09",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Asked the office if the crew could tackle the dryer vent during our chimney appointment and they said no problem. Tate ran a rotary brush through the line, cleared the vent hood flap that was stuck shut with lint, and tested the airflow before and after. He even put shoe covers on coming through the house. Clothes dry in half the time now. Tidy, professional, and reasonably priced for a same-visit add-on.",
          "name": "Sofia M.",
          "date": "2026-01-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Honest assessment of my old wood stove setup. The technician ran the camera and showed me the liner was fine but the insulation around it had settled. No pressure, just facts and photos.",
          "name": "Travis B.",
          "date": "2024-12-09",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Stunning difference. Years of smoke had stained the firebrick almost solid black, and Vern brought it back to a clean buff color with a careful scrub and a firebox-safe cleaner. He also repointed a few crumbling mortar joints inside. Took pictures before he started and after he finished so I could see the change.",
          "name": "Aisha N.",
          "date": "2025-02-23",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Scheduled our usual pre-winter cleaning and the office had me in within the week. Tech removed a surprising amount of creosote and swept the damper area clean. Tidy work.",
          "name": "Lorraine B.",
          "date": "2024-02-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Last minute scramble before our Thanksgiving fire and these folks delivered. Wade cleaned out years of buildup and handed me a written report on the flue liner condition.",
          "name": "Greg M.",
          "date": "2023-11-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Scheduling was easy and the office actually called to confirm the day before, which I appreciate. Wyatt handled our annual sweep and was meticulous about it. Drop cloths everywhere, shoe covers on, and a HEPA vacuum running the whole time so the room stayed clean. He cleared a solid quarter inch of creosote out of the flue and showed me exactly how much came down. While inspecting, he noticed the damper wasn't sealing fully and adjusted it so we stop losing heat up the chimney. Everything documented in a tidy report. It's rare to find a company this organized and this respectful of your home. We're already booked for next fall.",
          "name": "Yolanda B.",
          "date": "2025-10-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quick and clean damper swap. Cole wore shoe covers, laid a drop cloth, and was done in under an hour. Seals great.",
          "name": "Helen M.",
          "date": "2024-08-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a winter of freeze-thaw, our chimney crown had a big crack running across it and water was getting behind the flashing. Dale and Dale patched the crown, re-flashed where the chimney meets the shingles, capped it with stainless, and waterproofed the brick. They explained each step and left the roof spotless. The leak in the upstairs closet is gone for good.",
          "name": "Yolanda K.",
          "date": "2024-02-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Smith and Sons came out after another company told me I needed a full flue replacement. Turns out the real issue was just a damper that wasn't sealing, letting heated air escape up the chimney. Aiden installed a top-sealing damper with a rubber gasket that closes tight when not in use. Showed me before and after photos from up top. Honest crew, saved me a small fortune.",
          "name": "Theodore K.",
          "date": "2026-04-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Spalling was getting bad on our 80-year-old chimney, brick faces popping off after the winter freeze. Beau explained that trapped moisture behind a previous owner's sealant was the culprit. They removed the damaged brick, tuckpointed the surrounding joints, rebuilt a section near the crown, and applied a vapor-permeable waterproofer instead of the wrong kind. Took two days, very respectful of the landscaping, and they swept up every bit of mortar dust. The before and after photos made the cost easy to understand.",
          "name": "Yolanda M.",
          "date": "2025-12-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Big oak branch came down in the storm and clipped the chimney. Caleb came out, checked the cap and flashing, and confirmed no structural damage to the crown. Quick, reassuring, and reasonably priced.",
          "name": "Trevor B.",
          "date": "2024-08-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Brought our old fireplace back from the dead. The tech cleaned the firebox down to the original brick color and replaced a cracked refractory panel. Looks brand new and the price was fair.",
          "name": "Caroline B.",
          "date": "2025-06-21",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Clean, quick, courteous. Shoe covers the whole time and a tarp over the rug. Flue came out spotless and so did my floors.",
          "name": "Brett L.",
          "date": "2023-09-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "When a competitor told me my entire chimney had to come down and go back up, I nearly fainted at the estimate. A friend pointed me to Smith and Sons. Dewey ran a video scope through the flue liner and showed me on the screen that it was perfectly fine. The only real problem was a missing stainless cap letting rain in. He installed one that afternoon. Cannot thank them enough for the honesty and the photos that backed up every word.",
          "name": "Theo M.",
          "date": "2026-05-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Earl was our technician and he was fantastic. Explained the difference between the cap and the crown, showed me a bit of rust on the old stainless cap, and cleaned up so well you would never know he was here.",
          "name": "Yolanda B.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Scheduling was painless and Floyd showed up in the window the office gave me. Before lighting anything he checked the gas line fittings with leak solution, brushed debris out of the burner pan, and tested the ignitor. He noticed the glowing embers material was clumped on the burner ports and spread it correctly so the flames look natural again. Left a written report noting everything passed. Reasonable price for the peace of mind heading into winter.",
          "name": "Tobias W.",
          "date": "2025-11-14",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Inherited my grandmother's house and nobody had touched the chimney in ages. Gus came out same day, found heavy third-degree creosote, and walked me through the whole cleaning. He showed me the damper was stuck too and freed it up. Very thankful.",
          "name": "Aisha R.",
          "date": "2025-03-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After we bought the house we had no idea when the wood stove flue was last serviced. Hank came out, swept a heavy creosote load, and ran a camera up the liner to verify there were no breaches. He pointed out where the previous owner had installed an undersized liner and explained why the stove was smoking back into the room. Genuinely educational visit and the firebox is spotless now.",
          "name": "Devon R.",
          "date": "2026-04-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a windstorm we had branches and a bird nest blocking the chimney, and smoke kept backing up into the living room. Ira diagnosed it fast, pulled the debris out, and ran a brush down to make sure the liner was clear. He recommended a stainless cap with a spark arrestor, which I had him install on the spot. Whole thing took about ninety minutes and the price was fair.",
          "name": "Theo M.",
          "date": "2023-10-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our realtor recommended a chimney inspection before purchase and I'm so glad we did it. Jed arrived in shoe covers, laid drop cloths, and spent over an hour examining the firebox, damper, and flue liner. He found a gap in the liner that would have been a carbon monoxide risk. The written report had before photos and a clear repair estimate. Professional from start to finish.",
          "name": "Tobias M.",
          "date": "2025-06-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Snowstorm coming, in-laws arriving, and our flue was filthy. Knox got here same day and worked fast without cutting corners, brushing out heavy creosote and showing me the readings on his moisture meter near the firebox. Tidy as can be.",
          "name": "Roberto S.",
          "date": "2025-12-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What impressed me was the methodical approach. Levi didn't just guess at the smoke problem. He did a smoke pencil test at the throat, checked the flue height against the roofline, and discovered a nearby tree had grown taller than the chimney, causing wind-driven downdrafts. Recommended a vacuum-style cap and trimming the branch. Followed his advice and the backpuffing stopped entirely. Written report with photos was thorough and easy to understand.",
          "name": "Reggie D.",
          "date": "2024-12-05",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Relined our chimney for a new gas insert. Murphy measured everything twice, sized the aluminum liner correctly, and tied it into the appliance flawlessly. He even adjusted the damper and double-checked the draft before leaving. Fair price and zero mess.",
          "name": "Yolanda F.",
          "date": "2026-05-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My family has used Smith and Sons for our annual chimney cleaning since we moved to the area. The drop cloths, the shoe covers, the written report every single time. This year Ned noted the crown was holding up well after the waterproofing they did a couple seasons back. Reliable people you can build a relationship with.",
          "name": "Helena S.",
          "date": "2025-11-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Scheduled a pre-sale inspection so we'd have no surprises listing our house. The technician found minor creosote and a loose cap, gave us a written report we could show prospective buyers. Smooth and professional.",
          "name": "Gordon W.",
          "date": "2023-08-22",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "My partner and I are first-time fireplace owners and clueless. Otis came out, did a thorough cleaning, and patiently explained the stainless cap, the flue, and why we shouldn't burn wrapping paper come Christmas. Gave us before and after photos so we could see the difference. Wonderful, no-pressure visit.",
          "name": "Theo W.",
          "date": "2025-10-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Kind, careful, and honest. That's all an old widow could ask for. Pete swept the flue, checked the cap, and helped me back to my chair afterward. Fair price too.",
          "name": "Gladys M.",
          "date": "2025-06-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Downdraft problem solved. Roy figured out negative pressure from our new bathroom exhaust fan was pulling air down the flue. Cracking a window now does the trick, and he cleaned the creosote while he was up there.",
          "name": "Renata S.",
          "date": "2024-06-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Reliable and tidy. The tech cleaned our fireplace, vacuumed up all the ash, and left no mess behind on the hearth tiles. Ready for winter and reasonably priced.",
          "name": "Bartholomew F.",
          "date": "2024-10-21",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Our chimney went untouched for over a decade after my dad stopped using the fireplace. Silas was patient explaining what the heavy buildup meant and worked methodically until the flue was spotless. Drop cloths protected the hearth and he hauled away every bit of debris. Honest crew, no upselling.",
          "name": "Gregory N.",
          "date": "2025-06-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our new baby has sensitive lungs so cleaner home air was a priority. Tate explained the whole process, cleaned all return vents and supply ducts, then sanitized them. Left the place spotless with shoe covers on the entire visit.",
          "name": "Heath M.",
          "date": "2026-01-27",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Scheduled the chimney cleaning and the office let me tack on a dryer vent cleaning for a fair price. Vern laid drop cloths by the laundry, disconnected the duct, and ran a rotary brush the full length. He even reattached the lint trap cover tighter than I had it. Dries in 40 minutes now instead of an hour and a half.",
          "name": "Yvonne G.",
          "date": "2026-01-12",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Booked online and a tech showed up same day to sweep a flue packed with creosote. Drop cloths down, vacuum running, gone in 45 minutes. Spotless.",
          "name": "Aisha N.",
          "date": "2026-01-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Twenty-two years in this house and Smith and Sons has handled our sweep for the last six. Wade came out, ran his brush down the full length of the flue, and removed a thick band of creosote that had built up over the busy winter. He kept everything covered with drop cloths and wiped down the hearth tile afterward. He also confirmed the stainless cap was still seated tight. Couldn't ask for a tidier job.",
          "name": "Yolanda C.",
          "date": "2026-03-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Word got around our street that Smith and Sons does solid chimney work, and a neighbor passed me the number. The tech swept the flue, checked the stainless cap, and cleared a wasp nest he found up top. Quick and courteous.",
          "name": "Gabriela S.",
          "date": "2025-02-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Rarely do I leave reviews, but the punctuality here deserves one. The crew arrived exactly when the office said they would, swept out a season's worth of creosote, and then sealed two hairline cracks in the crown while they were up on the roof. One visit, one bill, no waiting around for a callback.",
          "name": "Gregory H.",
          "date": "2024-04-27",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Wyatt showed up with shoe covers and drop cloths, then ran a camera inspection because our fireplace had been smoking back into the room. Turns out a previous owner's repair left a chunk of mortar half-blocking the flue near the smoke shelf. He pulled it, re-scanned to confirm a clear path, and gave us before and after photos. The room hasn't filled with smoke since. Fair price and very tidy.",
          "name": "Hannah B.",
          "date": "2025-11-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Got three quotes for a chimney cleaning and theirs was the most detailed and the only one that was genuinely free with no obligation. Cole showed up, did the work, and the written report listed everything he checked. Best of all, the price never moved. A family business that actually treats you fairly.",
          "name": "Camille B.",
          "date": "2024-06-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dale and his brother showed up right on time and were two of the friendliest tradesmen I've ever met. They swept the chimney, inspected the damper, and gave me a written report explaining everything in plain language. When I asked about a crown repair I'd been quoted elsewhere, Dale looked at it and said mine was fine for now. That kind of honesty earns lifetime customers.",
          "name": "Priya N.",
          "date": "2025-08-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "This father-and-sons crew clearly knows historic masonry. Our Victorian's chimney had heavy spalling and a cracked crown. They tuckpointed with a lime-based mortar appropriate for the soft old brick, rebuilt the crown, and added a stainless cap. The color match on the new mortar is so good you cannot tell where the repair starts. Decades of experience really shows here.",
          "name": "Eleanor B.",
          "date": "2026-01-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Crown cracked after a freeze-thaw storm cycle. Tech sealed it and replaced the rusted cap. In and out in under two hours and explained everything plainly.",
          "name": "Greg M.",
          "date": "2023-12-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Gas logs hadn't been serviced since we bought the house. Aiden cleaned the burner ports, reset the logs to the proper layout, and checked the flue and damper since it's a vented unit. Flame looks great now.",
          "name": "Renata B.",
          "date": "2025-09-15",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Smoke was backing up into the living room every time we lit a fire. The tech ran a camera up and spotted a partial obstruction from a collapsed section of the smoke chamber. Never would have found that without the scope. Fixed and re-inspected the same week.",
          "name": "Yolanda S.",
          "date": "2025-03-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Leak above the firebox had me worried about the whole structure. The technician inspected the flashing and the crown, found the crown was the culprit with several deep cracks, and rebuilt it. Waterproofed the masonry afterward. Honest assessment and they didn't try to sell me a full rebuild like another company had.",
          "name": "Tasha K.",
          "date": "2026-03-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our very first fire was a smoky disaster, so we called these folks. Turns out we'd never opened the damper fully and there was old creosote choking the flue. Beau cleaned it all out, explained the draft, and gave us a little crash course on building a proper fire. He was so easygoing about our total lack of knowledge. Now we light fires with confidence and the room actually stays smoke-free.",
          "name": "Oscar L.",
          "date": "2026-03-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Caleb showed up on time, found a massive accumulation of sticks and feathers from an old nest jammed in the smoke chamber. He cleared it, inspected the liner, and installed a new stainless cap with animal guard. Gave me a written report and even pointed out the crown could use sealing down the road. No pressure though.",
          "name": "Lucinda R.",
          "date": "2025-09-11",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Phenomenal job relining our 1920s brick chimney. The original terra cotta liner had basically crumbled. Dewey measured carefully, ordered the right diameter stainless liner, and came back to install with a full crew. They protected the floors with drop cloths, wore shoe covers inside, and resealed the crown while they were up top. He even pointed out a hairline crack in the cap and fixed it. Detailed written report afterward. Couldn't be happier with the workmanship.",
          "name": "Sofia L.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Scheduled a fireplace cleaning in late fall and the scheduler got me in within two days. Earl removed the ash, brushed the firebox, and wiped down the soot-stained glass doors so they look brand new. No upsell, just solid work. We are cozy and ready for the season.",
          "name": "Terrence O.",
          "date": "2025-11-12",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Our dryer kept overheating and shutting off. The technician was already here for the masonry crown repair and offered to clean the vent line too. Found the duct half-blocked with compacted lint near the exterior wall. No more shutdowns since.",
          "name": "Reginald A.",
          "date": "2024-04-11",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Decades of experience really shows. Floyd cleaned the creosote out of our insert flue, checked the stainless liner for corrosion, and pointed out a small gap at the top plate that needed sealing. He had the right sealant on the truck and handled it same day. Left the hearth cleaner than he found it.",
          "name": "Yolanda M.",
          "date": "2025-10-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Old masonry firebox looked tired and sooty. The crew swept it out, repaired two spalling firebricks, and cleaned the smoke chamber above. Genuinely looks like a fresh build now.",
          "name": "Garrett W.",
          "date": "2026-01-18",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Loyal customer going on eight years. Gus arrived on time, set down drop cloths, and ran the brush from the cap down to the smoke chamber. He showed me before-and-after photos of the flue so I could see the creosote that came out. The crew treats my old house with real care, and the price has stayed fair year after year. Wouldn't trust the annual sweep to anyone else.",
          "name": "Hassan T.",
          "date": "2026-03-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "An arctic blast was forecast and our wood stove flue hadn't been touched all year. Reached out late afternoon and Hank was at our door the next morning with everything he needed. He swept the chimney, brushed out the creosote, and showed me before and after photos of the flue. Honest, fast, and reasonably priced when most companies were booked solid.",
          "name": "Wendy A.",
          "date": "2025-11-26",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Smoke kept rolling back into the room every time we lit a fire, and two other companies just shrugged. Ira actually diagnosed it. He ran a camera up the flue, found a significant creosote glaze plus a partial nest blockage, and explained how both were choking the draft. He did a full sweep, cleared the blockage, and the difference the very next night was night and day. He also flagged a cracked chimney crown for future repair but was clear it wasn't an emergency. No scare tactics, just an honest read on the situation backed up with photos. The kind of straight answers you hope for and rarely get.",
          "name": "Conrad M.",
          "date": "2024-12-11",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "After years of fighting a damper that only opened halfway, we finally called these folks. Jed explained that the original cast plate had corroded and recommended a top-sealing damper instead of another throat unit. He installed it, tested the draw with a small fire, and walked me through operating the cable. Smoke pulls right up now and the seal keeps the cold out. Real professionals.",
          "name": "Theo B.",
          "date": "2026-01-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Noticed efflorescence and damp brick on the chimney exterior. The crew diagnosed water intrusion through a cracked crown and an old cap that had rusted out. Crown got resurfaced, a new cap went on, and the masonry was waterproofed. Honest pricing and a clear explanation of why the brick was crumbling.",
          "name": "Trevor B.",
          "date": "2025-09-05",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Drafty fireplace finally fixed. The tech found the damper plate had rusted and no longer met the seat. New unit installed with a fresh gasket, and he checked the operation a few times before leaving. Hearth was spotless when he packed up.",
          "name": "Renata M.",
          "date": "2025-12-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Mortar joints on the exterior stack were soft enough to scrape with a key. Knox repointed the whole visible section and replaced four spalled bricks. Solid, careful masonry work and a fair quote.",
          "name": "Clarence W.",
          "date": "2024-06-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Heavy rains had water coming down the firebox and I assumed the worst. The technician traced it to failed flashing and a hairline crown crack, both storm-related. They resealed the flashing, repaired and waterproofed the crown, and added a new cap to keep critters and rain out. Wore shoe covers, cleaned up every speck. Three generations in this business and it shows in the care they take.",
          "name": "Yolanda F.",
          "date": "2026-03-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Such a difference. Our firebox was black with creosote buildup and the damper barely moved. Levi cleaned everything, freed up the damper, and the makeover made the whole living room feel cleaner. Same-day service too, which I did not expect.",
          "name": "Tobias W.",
          "date": "2024-12-05",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Having had a sweep years ago who left soot footprints everywhere, I was bracing for a cleanup. Completely the opposite here. Murphy set up plastic sheeting around the hearth, used shoe covers, and vacuumed the area twice before packing up. The damper area was the only place he touched and it was wiped clean.",
          "name": "Carmen O.",
          "date": "2024-06-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Suspicious of every chimney company after one tried to sell me a $7k rebuild. Ned came out, measured everything, checked the damper and liner, and bluntly said the structure was solid. Just needed a sweep and minor crown patch. Trustworthy crew.",
          "name": "Renata G.",
          "date": "2024-06-19",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Otis did a thorough job sweeping the firebox and flue. Quick and respectful. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Ahmed S.",
          "date": "2023-11-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Pilot kept going out so I called for a tune-up. Pete cleaned the pilot orifice, adjusted the flame, and confirmed the thermopile voltage was strong enough to hold the valve open. Works perfectly now.",
          "name": "Renata S.",
          "date": "2023-12-05",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Sixteen years. That's how long it had been since our chimney saw a brush, according to the technician. The creosote layer was thick enough that he said we were lucky nothing had happened. Roy scraped, swept, and vacuumed everything, then showed me photos of the clean flue liner afterward. Reasonable price for how much work it clearly was.",
          "name": "Gregory P.",
          "date": "2024-08-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quick, clean, and professional. Swept the insert liner, vacuumed the ash, and double-checked the damper operation. Shoe covers on, no soot anywhere. Will call again next fall.",
          "name": "Heather B.",
          "date": "2025-01-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Found out the hard way that birds love an uncapped flue. Silas cleared the nest, swept the creosote buildup while he was up there, and fitted a new stainless cap. He even showed me the old rusty cap that had basically disintegrated. Great service from a true family business.",
          "name": "Renata S.",
          "date": "2026-01-28",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Quick, honest pre-sale inspection. They confirmed the flue was sound and the stainless cap was in good shape, so we could list with confidence. Report in hand the next day.",
          "name": "Yolanda B.",
          "date": "2024-07-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "With the holidays bearing down I needed an emergency sweep and inspection because we'd just bought the house and had no idea when it was last serviced. The scheduler bumped me up and Tate came out the next morning. He found a partial blockage from leaves and a deteriorating cap, swept everything thoroughly, and gave me a written report with photos. Drop cloths everywhere, not a speck of soot left behind. Truly grateful they could move so quick.",
          "name": "Ashley M.",
          "date": "2024-12-23",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Smoke kept spilling out the front of the firebox. Vern found the damper was warped and not opening fully. Adjusted it and gave the flue a good cleaning. Fire breathes properly now and no more smoky room.",
          "name": "Selena M.",
          "date": "2025-07-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Decades of experience really shows. The father and one of his sons handled our liner replacement together and you could tell this was a true family business. They pulled the cracked tiles, dropped in a new insulated stainless liner, poured a fresh crown, and capped it with a stainless cap. Took most of a day but the workmanship was outstanding and they cleaned the firebox before they left.",
          "name": "Hector V.",
          "date": "2024-06-25",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Annual sweep done right. Wade cleared the creosote, checked the cap, left no mess. Been four years running now. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Quentin D.",
          "date": "2023-12-04",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our home inspector flagged the chimney as 'beyond scope' so we called a specialist. Wyatt ran a full camera scan, checked the flashing where the chimney meets the roof, and noted some lifted shingles too. The written report was thorough, with each finding numbered and photographed. He walked us through it over the phone afterward. We felt confident moving forward with the purchase.",
          "name": "Annika L.",
          "date": "2025-11-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Just moved into our first home with a wood-burning fireplace. The technician swept it, pointed out a little creosote near the smoke chamber, and gave me a crash course on the damper. So patient with all my rookie questions.",
          "name": "Aisha N.",
          "date": "2024-08-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Having someone gentle in the house means everything when you're my age. The crew arrived right on time, put down drop cloths, and worked quietly. The tech, Cole, sat with me at the kitchen table afterward and went over the inspection photos one by one. He never rushed me and answered every little worry I had about the flue liner. I felt looked after, not sold to.",
          "name": "Vivian C.",
          "date": "2026-01-25",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "The smoke smell in our basement was driving us crazy. Turns out the chimney crown was cracked and rain was getting into the flue, mixing with creosote to create that musty burnt odor. Dale sealed the crown, waterproofed the masonry, and installed a new cap. Honest pricing and they showed up exactly when the office said they would.",
          "name": "Hollis B.",
          "date": "2025-08-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We just bought an older home and had no idea what shape the fireplace was in. Aiden came out, gave it a thorough cleaning, and pulled out an alarming amount of creosote. He explained everything in plain terms and showed me where the firebrick was worn but still safe. Felt great getting that first fire going knowing it had been properly looked at. Will have them back annually.",
          "name": "Yolanda C.",
          "date": "2025-12-03",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "Twelve years of neglect cleaned out in one visit. Beau was thorough. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Tasha L.",
          "date": "2025-08-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Decided to bundle air duct cleaning with our annual chimney sweep and it was the best add-on we've done. The amount of debris and old insulation fragments they vacuumed out of the trunk line was eye-opening. Caleb was meticulous, covered the floors, and gave me a written report noting which vents had the heaviest buildup. The furnace runs quieter now too.",
          "name": "Adaeze O.",
          "date": "2025-07-05",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Decades of experience really showed. Dewey noticed scorch smell when the dryer ran and traced it to a crushed section of vent in the crawlspace. Cleared the lint, reseated the duct, and showed me before and after photos. Professional from start to finish.",
          "name": "Rashid A.",
          "date": "2025-06-27",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Earl was friendly and quick. Swept the chimney, brushed the smoke shelf, and snapped before and after photos so I could see the difference. Great value.",
          "name": "Grant W.",
          "date": "2025-08-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Father-and-sons outfit and you can tell they take pride in the work. Floyd did our annual creosote removal, scraped the glazed buildup near the top of the flue, and left the firebox cleaner than he found it. Written report was clear and the cap got a quick inspection too.",
          "name": "Gregory P.",
          "date": "2025-11-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our neighbor couldn't stop talking about how clean their crew left her place, so we booked. Gus showed up on time, swept the chimney, and brushed out the smoke chamber where creosote had collected. Laid drop cloths from the door to the hearth. No soot anywhere when he left.",
          "name": "Hassan B.",
          "date": "2024-08-25",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Hank was early, which I never mind. Brushed the liner, vacuumed the firebox, and reset the flashing where it had pulled away from the masonry. All in a single morning. Trucks come fully loaded so nobody had to run to a store.",
          "name": "Annika L.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Camera went where eyes couldn't. Found a bird nest wedged above the damper that was choking our draft. Cleared and verified on screen.",
          "name": "Reginald A.",
          "date": "2023-04-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Straight shooters. The free quote covered the sweep and a damper check, and that's exactly what got done. No mystery line items at the end.",
          "name": "Reginald O.",
          "date": "2025-07-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Ira was a pleasure. Cleaned the flue, swept up every speck of soot, and never once pressured me. Genuinely nice family.",
          "name": "Holden R.",
          "date": "2023-10-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Brick faces on our chimney were popping off after a hard freeze. The technician replaced the spalled units and repointed around them. He walked me through why salts and trapped moisture cause spalling. Good info, good fix.",
          "name": "Damon L.",
          "date": "2024-04-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Following a brutal hailstorm I wanted everything on the roof checked. Jed went up, inspected the crown, cap, and flashing, and found the flashing had been loosened by the wind. Resealed it on the spot and confirmed the crown was still solid. Appreciated that he didn't invent repairs I didn't need. Photos and a written report came by email that afternoon.",
          "name": "Yvonne C.",
          "date": "2025-08-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Outstanding work prepping our gas fireplace for the season. Knox checked the gas pressure, cleaned the soot off the logs, and made sure the carbon monoxide risk was zero by testing the combustion and venting. He even pointed out that our glass front had a worn gasket and replaced it on the spot from his stocked truck. No more drafts and the unit runs clean.",
          "name": "Terrence O.",
          "date": "2024-10-21",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Booked a level-2 inspection because we smelled something off near the fireplace. Levi snaked the camera down and discovered moisture damage and a hairline crack in the flue that was letting water seep behind the brick. Pointed out the failing crown too. Appreciated that he showed me the footage frame by frame and didn't try to upsell anything we didn't need. Crown and waterproofing scheduled for the following week.",
          "name": "Greg N.",
          "date": "2024-06-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Missing chimney cap let critters and rain both get in. Murphy installed a sturdy new cap with a screen and checked the crown while he was up there. Quick and clean.",
          "name": "Frank D.",
          "date": "2024-02-27",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Recently inherited a house with a fireplace I'd never use without a professional checking it first. Ned swept it, inspected the crown, and patiently explained what flashing does and why mine looked fine. Reassuring for a first-timer.",
          "name": "Priya S.",
          "date": "2025-10-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Birds in the chimney every spring until these folks came out. Otis removed the nest, cleaned the flue of debris, and installed a stainless cap that finally solved it. Worth every penny.",
          "name": "Felipe A.",
          "date": "2024-09-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Camera inspection showed the flue tiles had shifted and were leaking smoke into the wall cavity. Pete recommended a full stainless reline and got it done in one visit. Solid work, clear explanation of the danger we were in.",
          "name": "Hugh B.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Prepping for winter, I booked a cleaning for our wood-burning fireplace. Roy showed up with a fully stocked truck and got to work right away, vacuuming the firebox and removing a buildup of creosote near the throat of the chimney. He laid drop cloths everywhere and you would never know anyone had been in the house except the fireplace was sparkling. The whole family is looking forward to fires now.",
          "name": "Lena K.",
          "date": "2024-12-03",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Smart move getting the dryer vent done while they were on site for the sweep. Saved a separate trip charge. Silas pulled the dryer out, disconnected the flex hose, and cleaned the rigid duct all the way to the roof cap. Showed me the before and after photos on his phone.",
          "name": "Yasmin H.",
          "date": "2025-08-03",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Reliable family business that's been doing this for years. They swept the wood stove liner, vacuumed out the firebox, and gave me before-and-after photos of the creosote. Reassuring to see it all documented.",
          "name": "Connor F.",
          "date": "2024-03-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We had basically given up on our fireplace because the inside was so grimy and discolored we were embarrassed to light it. Tate changed all that. He vacuumed out the firebox, hand-scrubbed each firebrick, cleared the soot off the damper, and even cleaned the glass doors so they sparkle. He showed me before and after photos and the transformation was wild. Friendly, careful with our floors, and clearly knows his trade. The whole hearth feels like a centerpiece again.",
          "name": "Lucia F.",
          "date": "2024-06-11",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Same dependable service every autumn. Vern swept out a thick coat of creosote, checked the cap was still seated tight, and left the hearth spotless.",
          "name": "Wilma E.",
          "date": "2025-11-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Christmas Eve emergency. Smoke started backing into the house right as guests arrived. Wade came out on a holiday, found a partial blockage near the smoke chamber, and cleared it within the hour. Cannot thank this crew enough for saving our evening.",
          "name": "Tomas L.",
          "date": "2024-12-24",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Brought these folks out for a pre-winter inspection and sweep after a neighbor recommended them. Wyatt was the tech and he was fantastic from start to finish. He laid down drop cloths, kept everything spotless, and was clearly experienced. The camera inspection showed the flue liner was in good shape but the masonry crown had some spider cracking starting. He gave me an honest timeline rather than pushing immediate repair, which I respected. Cleaned out a real winter's worth of creosote and double-checked the damper operation. Written report with clear photos arrived by email. You can tell this is a family operation that cares about its reputation. Fair, professional, and genuinely knowledgeable.",
          "name": "Tabitha R.",
          "date": "2026-03-03",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Reliable, family-run outfit. Our damper handle had snapped off and the plate dropped into the smoke chamber. Cole retrieved it, reseated everything, and replaced the broken linkage so it locks open and closed properly. Fair quote, no upsell, and he cleaned a little creosote buildup he spotted while he was in there.",
          "name": "Naomi C.",
          "date": "2025-09-17",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Leak was showing up as a damp spot on the bedroom ceiling. Dale found the cap completely rusted and the crown cracked in two places. New stainless cap, crown rebuilt, full waterproofing application. He even pointed out a loose mortar joint and fixed it while up there.",
          "name": "Imani S.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Cold draft was making the living room miserable. Aiden showed up in shoe covers, inspected the firebox, and pointed out the damper had warped from years of high heat. He replaced it with a cast iron unit that seats flush, then ran a quick smoke test to confirm the seal. Written report emailed the same afternoon. Couldn't ask for more.",
          "name": "Garrett W.",
          "date": "2024-03-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Restoration on a century-old brick chimney that the home inspector said was the worst he'd seen. Beau and the crew didn't oversell it. They tuckpointed the entire above-roof portion, rebuilt the top six courses where the brick had badly spalled, poured a new sloped crown with an overhang drip edge, and capped it with a stainless cap. They sent a detailed written report with photos of each stage. The masonry color match is so good my neighbor thought we hadn't touched it. Worth every penny.",
          "name": "Annika S.",
          "date": "2026-01-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Wind ripped our old cap loose and bent it sideways. Caleb swapped it for a sturdy stainless one and gave the crown a quick patch where it had started to spall. In and out in under two hours.",
          "name": "Brandon K.",
          "date": "2025-01-26",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Dewey did a fantastic job. He cleaned the firebox, polished the surround, and pointed out a small gap in the mortar joints he sealed up. The before and after photos were night and day. Highly recommend for anyone whose fireplace has seen better days.",
          "name": "Adaeze O.",
          "date": "2025-08-17",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Drop cloths went down before anything else. The tech sealed the firebox, ran the brush down the flue liner, and the vacuum hummed the entire time catching dust. Not a single black smudge on my hardwood. Very impressed with how tidy the whole job was.",
          "name": "Russell P.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "After being told by another contractor that my chimney was a hazard needing total reconstruction, I braced for the worst. Earl arrived right on time, slipped on shoe covers, and spent a solid hour inspecting. He showed me the brick and mortar were in great shape and the so-called damage was just surface soot. Swept it clean and gave me a written report. Total relief, and a fair bill.",
          "name": "Quincy A.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Floyd arrived right on time and got straight to work on a chimney that had not been touched in years. The amount of creosote he pulled out was alarming, but he stayed calm and explained why an annual sweep matters. He even adjusted the damper so it seals properly now. Genuinely kind person and clearly knows the trade inside and out.",
          "name": "Constance W.",
          "date": "2026-01-16",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Gus did a thorough gas-log inspection ahead of the season. He vacuumed the firebox, checked the venting for blockages, tested CO levels with the unit running, and showed me where the shutoff valve is. Appreciated that he explained the difference between vented and vent-free logs and what mine needed. No upsell, just solid safety work.",
          "name": "Bennett G.",
          "date": "2025-03-19",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Could not believe how much soot Hank pulled out of a chimney we'd neglected for years. He laid drop cloths everywhere and there wasn't a speck of mess when he left.",
          "name": "Tamara W.",
          "date": "2026-02-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Family-owned outfit and it shows in how careful they were. Ira cleaned the wood stove liner, found a small gap at a section joint, and showed me exactly where on the camera feed. He explained the creosote stages and how to burn drier wood to slow buildup. No upsell, just good advice and tidy work. The drop cloths stayed clean.",
          "name": "Roberto M.",
          "date": "2024-08-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Scratching sounds at 3 a.m. led me to call these guys. Jed arrived the next morning, confirmed a nest packed into the flue, and removed it along with a surprising amount of twigs and insulation a bird had dragged in. Stainless cap went on after a thorough sweep. He wore shoe covers and left zero mess inside.",
          "name": "Curtis A.",
          "date": "2025-09-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Selling our house and wanted everything documented up front. Knox scoped both flues, photographed the crown and flashing, and noted minor creosote that he cleaned the same day. The written report became part of our disclosure packet and buyers appreciated the transparency. Smooth experience and fair price.",
          "name": "Reginald P.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Sudden freeze and a chimney that hadn't been touched. Same-day appointment, swept and inspected in under an hour. Tech noted the flue liner was in good shape. Fair price, no fuss.",
          "name": "Tobias E.",
          "date": "2023-11-29",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Moved into an older home and the basement always smelled like an old ashtray. Levi traced it to a cold, oversized flue that wouldn't establish draft, letting odor settle downstairs. He cleaned out years of creosote, sealed the cleanout door, and showed me how to prime the flue with a rolled newspaper torch before lighting. The musty smoke smell is finally gone after months of frustration.",
          "name": "Garrett P.",
          "date": "2023-04-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Solid liner install. Murphy showed up on time, explained the stainless versus aluminum difference, and got it done in an afternoon. No surprises on the bill.",
          "name": "Annika L.",
          "date": "2025-12-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Coming up on a decade as their customer. What keeps me loyal is how they treat the yearly maintenance seriously instead of just running a brush through and leaving. Ned spent extra time inspecting the flue liner with a camera and showed me the footage. No issues this year, but he flagged some flashing to monitor near the roofline. Same trustworthy crew every season.",
          "name": "Anita J.",
          "date": "2026-01-15",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Pre-purchase chimney inspection on a house with a wood stove insert. Otis pulled the insert, inspected the liner, and found heavy creosote glazing the previous owner clearly ignored. Detailed written report with photos saved us from a fire hazard and a costly relining surprise after move-in.",
          "name": "Roberto C.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We had no clue how to take care of the fireplace that came with our new place. Pete arrived right on time, swept the chimney, checked the flue liner, and then gave the two of us a genuinely patient walkthrough of everything. He showed us how to open the damper, explained creosote stages, and recommended a yearly inspection. He even tested a small fire with us so we'd feel confident. Family-owned outfit and it shows in how much they actually care.",
          "name": "Brennan S.",
          "date": "2026-04-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Roy was patient as could be with my husband, who has trouble getting around. He cleaned the chimney, swept out the creosote, and even moved a chair back where it belonged. Decent folks.",
          "name": "Lorraine D.",
          "date": "2024-07-16",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Poor draft meant we could never enjoy our wood stove without smoke leaking out the door. Silas measured the flue and found it was oversized for the stove, so the exhaust cooled and stalled. He recommended a properly sized stainless liner. After install the stove drafts perfectly and the smoke smell is history.",
          "name": "Tomasz W.",
          "date": "2026-01-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Tate did a great job getting our fireplace winter-ready. Swept it out, cleaned the glass doors until they were clear, and checked that the damper wasn't sticking. Friendly and efficient.",
          "name": "Quentin M.",
          "date": "2024-12-14",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Finally booked a cleaning after putting it off for years. The amount of creosote that came out of that flue was eye-opening. Vern took his time, used a brush and rods system, and then ran a quick inspection to make sure nothing was cracked. Laid drop cloths down the whole path from the door to the fireplace. Same-day service too, which I didn't expect.",
          "name": "Henry O.",
          "date": "2024-07-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Quick and tidy. Wade cleaned every register and return, bagged the debris, and was gone in two hours. The dusty smell from the vents is finally gone.",
          "name": "Lorenzo P.",
          "date": "2024-09-30",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Asked them to look at the dryer exhaust while up on the roof for the chimney cap. Wyatt found the vent hood flap was stuck shut with lint and bird debris. He cleared it, freed the flap, and my dryer stopped overheating. Couldn't be happier with the add-on.",
          "name": "Brenda M.",
          "date": "2024-12-05",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Smooth from start to finish. The office got me in within two days, the crew swept the flue and checked the cap, and they left no soot behind. Will use again.",
          "name": "Bianca F.",
          "date": "2024-04-16",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Routine fall sweep. Cole showed up with a fully stocked truck, swept the flue, cleared the creosote, and checked the damper operation. Polite, fast, no upsell. Been a customer five years and they never disappoint.",
          "name": "Tamara W.",
          "date": "2024-12-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "A recommendation from the lady next door brought me here. Dale was thorough with the sweep and showed me the damper was rusted partly shut. Fixed it on the spot since the truck was fully stocked.",
          "name": "Lorraine P.",
          "date": "2025-06-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Reliable and fast. They cleaned the chimney and fixed a wobbly stainless cap in the same appointment instead of dragging it into two trips. Aiden walked me through the written report before he packed up. No mess left behind.",
          "name": "Terrence O.",
          "date": "2025-06-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "What impressed me was how methodical Beau was with the level-2 camera. He suspected a blockage but the footage revealed something different, a separated flue joint behind the chimney chase that was venting into the attic space. He printed the report, included timestamped images, and explained the fire risk in plain terms. We scheduled the masonry repair on the spot.",
          "name": "Sofia L.",
          "date": "2026-01-15",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Caleb gave me a no-obligation quote and walked me through every number before lifting a brush. The creosote buildup was worse than expected but he honored the original price anyway, said that was fair since they'd quoted it. Try finding that kind of integrity elsewhere.",
          "name": "Sofia D.",
          "date": "2026-02-19",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "You don't meet many contractors anymore who shoot it to you straight, but the Smith sons do. Dewey came out, swept the chimney, and showed me the creosote he'd pulled. He explained that the damper was a little stiff but functional and said there was no reason to replace it yet. Polite, tidy, and honest to a fault. I trust these guys completely.",
          "name": "Yolanda P.",
          "date": "2026-01-30",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked an inspection because mortar dust kept appearing on the roof. Earl found roughly six feet of failed joints and two badly spalled bricks below the crown. He repointed it all, replaced the bricks, and applied a vapor-permeable sealer so the chimney can still breathe. Tidy worker, shoe covers indoors, photos before and after. Couldn't be happier with how the old stack looks now.",
          "name": "Sofia G.",
          "date": "2025-11-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Big storm last fall bent our chimney cap and I was worried about the masonry. Floyd came out, replaced the cap, sealed two crown cracks, and pointed out a spot of flashing that needed attention. Fair pricing and a thorough explanation.",
          "name": "Tobias W.",
          "date": "2024-10-22",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Booked a safety check because our gas logs were burning unevenly. Gus found a partially clogged burner and a pilot that needed adjusting. He cleaned both, repositioned the front log that had slipped, and tested the whole gas connection. Quick, tidy, and reassuring.",
          "name": "Yolanda S.",
          "date": "2026-03-02",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Thorough, honest, and patient. Hank explained that a basic sweep wouldn't catch interior cracks, so he ran the camera. Found a gap at a liner joint near the top. Got photos and a quote on the spot.",
          "name": "Tamara V.",
          "date": "2025-07-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Noticed efflorescence on the brick and a musty smell, so I called these folks. Ira explained that the cracked crown was wicking water into the masonry. He sealed the crown, replaced the corroded cap, and waterproofed the entire stack. The white staining hasn't come back and the smell is gone. Decades of experience really shows in how thorough he was.",
          "name": "Nadia P.",
          "date": "2025-06-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Bought our first home last summer and the fireplace was a complete mystery to us. Jed came out, did a thorough sweep, and then spent a good twenty minutes teaching my wife and me the basics. He explained how creosote forms, why we needed a stainless cap installed, and how to read the smoke to know if the chimney is drawing properly. He left us a written report and his honest recommendation to clean annually. Family-owned outfit that clearly takes pride in educating customers, not just upselling them. We feel so much more prepared heading into our first real winter.",
          "name": "Connor B.",
          "date": "2024-10-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Heard chirping coming from the firebox and panicked. The scheduler got someone out fast and Knox removed a bird nest along with a surprising amount of leaves and twigs. He capped it with stainless mesh and double checked the flue was clear. Calm, friendly, and respectful of the house.",
          "name": "Aisha D.",
          "date": "2025-05-20",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "The crew relined two separate flues in our old farmhouse, one for the furnace and one for the fireplace. Levi coordinated the whole thing and explained why each needed a different liner size. They insulated the fireplace liner, sealed both with new top plates and caps, and hauled away all the broken tile pieces. Took them a full day but the quality shows. Got photos documenting everything for our records.",
          "name": "Tamara V.",
          "date": "2025-08-07",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Spotless work on our fireplace. Murphy cleaned out the ash, brushed the firebox, and checked the damper opened and closed smoothly. Warm and ready for the first frost.",
          "name": "Devin S.",
          "date": "2025-10-30",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Family-run outfit that does what they say. They were here for the annual chimney cleaning and I tacked on the dryer vent. Ned found a bird's nest jammed in the exterior vent hood, which explained the long dry times. Cleared it out, replaced the damaged flap, and the dryer is back to normal. Honest folks who explained everything as they went.",
          "name": "Gregory P.",
          "date": "2025-10-27",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "My insert was smoking back into the room and I assumed I needed a whole new unit. Otis came out, ran a camera up the liner, and found a heavy creosote plug near the top. He brushed it clear, checked the cap and crown for leaks, and the stove drafts perfectly now. Saved me a fortune and explained the whole thing patiently. Genuinely grateful.",
          "name": "Nadia S.",
          "date": "2025-12-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Solid work on a neglected firebox. Pete pulled out a season of ash, cleaned the back panel, and freed up a damper that hadn't moved in years. Looks great now.",
          "name": "Tobias E.",
          "date": "2025-05-30",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Routine yearly cleaning and inspection. The technician brushed the flue thoroughly, vacuumed everything up, and noted the liner looked good for another season. No mess left behind, which matters when you've got cream carpets near the fireplace.",
          "name": "Augustin P.",
          "date": "2023-12-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Realized the day before a big cold front that our chimney was overdue. The office understood the urgency and got Roy out same day. He laid drop cloths, swept thoroughly, and noted the crown had a small crack he could patch before winter set in. Professional from start to finish.",
          "name": "Carla D.",
          "date": "2025-01-14",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our older fireplace hadn't been swept in who knows how long, and I was nervous about what they'd find. Silas put me at ease right away. He inspected before touching anything, showed me the creosote layer on his camera feed, and explained the risk in terms I could actually understand. The sweep itself was fast and shockingly clean given how much soot came out. He replaced our missing stainless cap on the same visit since his truck was stocked, which saved me a second appointment. Reasonable price, no upsell games, and he treated the house like it was his own. Genuinely impressed and will absolutely use them again.",
          "name": "Frederick A.",
          "date": "2025-08-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Squirrels had bent our old damper so it never closed right. Tate installed a new stainless top-mount damper and cap combo that keeps critters out and seals the flue when we're not burning. Drafts gone, and he sent before/after photos by email same evening.",
          "name": "Rashid A.",
          "date": "2025-06-28",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Cap was missing entirely and rain had been pouring into the flue for who knows how long. Vern installed a new stainless cap and sealed the crown. Fast and reasonably priced.",
          "name": "Roland P.",
          "date": "2023-04-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Top-mount damper installed to stop the downdraft we'd fought for two winters. Wade mounted it at the crown with a stainless cap built in, ran the control cable down, and showed me how to operate the lever. The fireplace seals tight now and we're not heating the neighborhood anymore.",
          "name": "Sasha L.",
          "date": "2026-01-17",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Freeze-thaw had flaked off the brick faces near the top of our 1930s chimney. Wyatt assessed it, recommended replacing the spalled units and repointing rather than a full rebuild, which saved us a lot. Clean, honest work.",
          "name": "Reginald F.",
          "date": "2025-04-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our neighborhood took a beating from a derecho and I had three companies out. Smith and Sons was the only one that actually got on the roof, inspected the flashing seam by seam, and showed me the cracked crown on video. No scare tactics, just facts. They replaced the cap and resealed the flashing the next morning. Genuinely grateful for the honesty.",
          "name": "Anita G.",
          "date": "2025-10-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Years of soot gone in one visit. The firebox brick is back to its natural red and the glass doors are crystal clear. Tidy crew, careful with our floors.",
          "name": "Reuben S.",
          "date": "2024-04-11",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Cole and the crew treated my home like it was their own mother's. Booties at the door, runners across the entry, and a containment sheet over the fireplace. They swept the chimney, collected every bit of creosote in a bag, and left the hearth gleaming. Professional and clean.",
          "name": "Yolanda M.",
          "date": "2024-02-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "A flashy salesman quoted a rebuild that would have emptied my savings. These guys did an honest inspection instead, found the flue liner intact, and traced the draft issue to a stuck damper. Fixed in one visit. Decades of experience clearly shows.",
          "name": "Esther W.",
          "date": "2023-10-27",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Shout-out to Dale for a great cleaning. He brushed out the flue, checked the liner with a camera, and laid drop cloths everywhere. No soot in the house at all.",
          "name": "Reginald D.",
          "date": "2025-08-09",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our gas fireplace smelled odd when we ran it. Aiden came the same day, found dust burning off the logs plus a slightly loose gas connection. He tightened and leak-tested the fitting, cleaned the burner ports, and the smell was gone. Reassuring service.",
          "name": "Yolanda M.",
          "date": "2024-11-27",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "After buying our first home with a wood stove, we had no idea when the chimney was last cleaned. Turns out, never, by the look of it. The crew dug out years of creosote and debris, checked the cap, and gave us a clear written report. Now it drafts beautifully and we feel safe lighting a fire.",
          "name": "Nathaniel C.",
          "date": "2025-12-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Scheduling was painless and the office called the morning of to confirm. Beau swept the insert, inspected the full length of the liner, and noted the cap screen needed clearing of debris. Detailed before-and-after photos came with the report.",
          "name": "Allison F.",
          "date": "2025-10-22",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Pigeons had been nesting on top of our chimney for years. Caleb cleared the flue of all the accumulated debris and droppings, then capped it with stainless steel mesh. The smell is gone and the draft is much stronger.",
          "name": "Ingrid F.",
          "date": "2024-06-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Needed a chimney inspection on a property we were buying out of state, and the office coordinated with our agent to get it scheduled before the contingency deadline. The tech sent a thorough written report with camera footage of the flue liner. Found a cracked crown we negotiated into the sale price. Communication was excellent throughout.",
          "name": "Imani W.",
          "date": "2025-10-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Polar vortex week and our wood stove flue was caked. I called four places and only Smith and Sons could come same day. Dewey showed up with a fully stocked truck, swept out the creosote glaze, and replaced a missing screen on the cap right then because he had the part on board. We stayed warm through the whole cold stretch. Couldn't ask for more on short notice.",
          "name": "Gabriela N.",
          "date": "2026-01-08",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Couldn't figure out why smoke poured back in whenever the furnace kicked on. Earl identified competing draft between the water heater and the fireplace flue. Cleaned the chimney, cleared a bird's nest near the cap, and explained the make-up air problem in plain terms. Put down drop cloths and wore shoe covers the whole time. Very professional family crew.",
          "name": "Yolanda B.",
          "date": "2026-01-27",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We had carbon monoxide concerns with our furnace venting through a deteriorating chimney. The technician ran a camera up first, showed me the cracked liner on a tablet, and then installed a properly sized stainless liner with insulation. Detailed written report afterward with photos. Genuinely felt like they cared more about safety than the sale.",
          "name": "Reginald B.",
          "date": "2024-02-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Every autumn like clockwork. Floyd handled this year's cleaning, swept the flue and emptied the firebox, then walked me through the report. The creosote was lighter than past years which he credited to seasoned wood. Glad I stuck with the same company all this time.",
          "name": "Bradford L.",
          "date": "2024-10-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Cannot say enough good things. We were under contract and needed the chimney evaluated quickly. Gus arrived with a fully stocked truck, ran the inspection, and had the written report to us within hours. He found a cracked crown and corroded damper, explained the repair costs honestly, and even noted what the seller might reasonably be expected to fix. Used the report at the closing table and it paid for itself many times over.",
          "name": "Felicia D.",
          "date": "2024-02-14",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "First-time homeowner, first-time fireplace, very nervous. Hank swept everything, replaced nothing he didn't need to, and spent extra time explaining the cap and how rain was getting in. Patient and kind the whole way through.",
          "name": "Lucia F.",
          "date": "2025-03-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Recommended by my neighbor and I see why. The young man Ira was so respectful, slipped covers over his boots the second he stepped in. He inspected the whole flue, found no damage, and didn't try to invent some repair to pad the bill. Honest people are hard to find these days, especially when you're 81 and easy to take advantage of.",
          "name": "Frances K.",
          "date": "2025-09-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Wonderful experience from start to finish. A heavy smoke odor would fill the upstairs hallway every time we used the fireplace. Jed traced it to a leaky damper and a flue that hadn't been swept in years, packed with creosote. He cleaned everything, adjusted the damper, and the smell vanished completely. Genuinely kind, knowledgeable people who clearly take pride in the work.",
          "name": "Gabriela P.",
          "date": "2025-05-04",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Could not be happier. This is a true family-owned outfit and you can tell they take pride in the work. Knox cleaned our fireplace top to bottom, scraping out the firebox and brushing down the smoke shelf where soot loves to collect. He laid drop cloths everywhere and even swept the floor before he left. The room is warm and cozy now and there's no more lingering smoky smell. Booking the rest of my street to use them.",
          "name": "Rosalind T.",
          "date": "2025-10-30",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "After about fifteen years we decided it was time. Levi found a serious creosote glaze and a bird's nest jammed near the damper. Cleared it all out, double-checked the stainless cap, and left the area cleaner than he found it. Reassuring to deal with people who clearly know chimneys.",
          "name": "Rosalind F.",
          "date": "2025-10-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Moved into a 1970s house and the previous owners clearly never cleaned the ductwork. Murphy showed up with a fully stocked truck, ran his cleaning equipment through every supply duct and return vent, and pulled out construction debris that had been sitting there for decades. He documented everything with before/after photos. Worth every penny for the peace of mind.",
          "name": "Tamsin G.",
          "date": "2025-04-11",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "Great value bundling the dryer vent with the sweep. Ned brushed the run, vacuumed the lint trap housing, and pointed out my hose was the old foil kind that traps lint. Swapped me to rigid metal. Appreciated the honest advice.",
          "name": "Quentin S.",
          "date": "2025-09-22",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Otis arrived on time, laid out drop cloths, and cleaned a chimney that hadn't been swept in years. Showed me the creosote he pulled. Fast and tidy.",
          "name": "Reginald P.",
          "date": "2025-10-29",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Got our yearly cleaning knocked out. The tech found heavier creosote than usual since we burned a lot last winter, brushed it all out, and bagged the debris. He recommended seasoning our wood longer to cut down on buildup. Helpful tip and a clean job overall.",
          "name": "Nathaniel O.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "My neighbor handed me their card over the fence and said I wouldn't regret it. He was right. Pete arrived in a fully stocked truck, swept the flue, and inspected the masonry around the crown. He noticed the chimney cap had come loose in a storm and secured it before leaving. Detailed written report came by email the next morning with photos. Couldn't ask for more.",
          "name": "Vincent O.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Impressed from start to finish. The scheduler gave me a tight window and Roy hit it. He swept a flue that hadn't been touched in years, then waterproofed the crown after spotting some spalling. Both done in one visit, with drop cloths everywhere and a clear explanation of what he found. This family-owned outfit clearly takes pride in the work.",
          "name": "Hannah D.",
          "date": "2024-12-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Booked a sweep, ended up needing the camera. Silas noticed the creosote pattern looked off and recommended a level-2 scan. Glad he did, the liner had a vertical crack hidden behind a soot buildup. He didn't pressure me, just laid out the images and let me decide. Honest crew.",
          "name": "Jamal W.",
          "date": "2025-07-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Called for an estimate expecting the usual runaround. Instead I got a clear flat rate for the cleaning, free and with no strings. Tate swept the flue, checked the cap, and handed me an itemized invoice that matched the quote exactly. No upsell on waterproofing or anything else. Solid, honest work.",
          "name": "Grant H.",
          "date": "2024-09-12",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Vern swept our chimney and the whole experience was easy. He was warm, explained the soot buildup, laid down drop cloths, and left the hearth spotless. Honest pricing too.",
          "name": "Brett C.",
          "date": "2024-06-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Repointed the eroded mortar joints on our 1940s chimney and patched a chunk of spalled brick. Quick, professional, reasonable. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Roland P.",
          "date": "2023-12-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "This family-owned outfit saved us a real headache. A spring storm peeled back the flashing and water was tracking down into the attic. Wade arrived in shoe covers, diagnosed the flashing and a worn crown, and waterproofed the whole top after resealing. He even climbed back up to double-check before he left. Detailed report, photos of every step, and a price that didn't make my eyes water. These folks earned a customer for life.",
          "name": "Annika P.",
          "date": "2026-01-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "This father-and-sons crew clearly knows gas appliances. Wyatt serviced our log set, cleaned the burner tray, and verified the thermocouple was generating proper voltage so the safety valve stays open. He explained why the pilot kept going out and fixed it. Detailed and trustworthy outfit.",
          "name": "Bryce L.",
          "date": "2025-12-19",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Could not figure out why one room always smelled like soot. Cole brought out the inspection camera and found a hidden crack in the flue liner that was venting fumes into the adjacent chimney chase. Genuinely could have been a carbon monoxide issue. He walked me through the entire video, marked the exact location, and the written report was incredibly detailed with timestamps and measurements. This is a family-run outfit that clearly cares about doing it right.",
          "name": "Nathaniel O.",
          "date": "2025-01-26",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Honest crew. Dale found the leak was coming from a gap around the cap rather than the crown, saved me a lot of money by not overdoing the repair. New cap, fresh sealant, done.",
          "name": "Hector V.",
          "date": "2025-01-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "First-time fireplace owner here and I was nervous about even using it. The technician was wonderfully patient, showing me the clean flue liner after the sweep and explaining what to look and smell for between cleanings. Felt like a teaching session, not just a service call.",
          "name": "Yvonne K.",
          "date": "2025-12-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Decades of debris and an abandoned nest came out of our flue thanks to this family business. Aiden laid down drop cloths, removed everything, swept the creosote, and topped it with a stainless cap. The whole place looked cleaner than before he arrived. Genuinely impressed with the care.",
          "name": "Roland B.",
          "date": "2024-02-16",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Good honest crew. Replaced the deteriorated liner with stainless steel and added a new cap. Beau kept me updated the whole time.",
          "name": "Reggie D.",
          "date": "2023-04-17",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "After years of neglect our fireplace looked grim, with soot streaking up the surround and the glass nearly black. Caleb tackled the whole thing, scrubbing the doors, vacuuming the firebox, and clearing the ash dump door that had rusted shut. He was patient explaining what causes the buildup and how often we should clean. Now it actually looks inviting and we cannot wait for cozy nights this winter. Truly a family business that treats your home with care.",
          "name": "Rosalind T.",
          "date": "2026-02-18",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Vent cleaning got added while they did our fireplace. Lint everywhere in the duct. Dewey vacuumed it all out and the burning smell from the laundry room is finally gone.",
          "name": "Aisha N.",
          "date": "2024-12-05",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Prompt, professional sweep of the wood-burning insert. Liner inspection came back clean and the tech showed me the camera footage so I wasn't just taking his word for it.",
          "name": "Bryce H.",
          "date": "2024-06-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Booked a firebox cleaning and got way more than expected. Earl scraped the creosote buildup off the firebox walls, replaced a chipped firebrick, and re-mortared a couple of joints that had opened up. He covered the carpet with drop cloths and used a HEPA vacuum so there was zero dust. The inside of the fireplace looks crisp and new, and he gave me a tidy written report. This father-and-sons outfit really takes pride in the details.",
          "name": "Renata B.",
          "date": "2025-09-27",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Annual creosote removal, and Floyd did a fantastic job. He explained the difference between the flaky stage-one buildup and the harder stuff, then brushed it all out. Drop cloths everywhere, shoe covers on. Twelve years a customer and still happy.",
          "name": "Yolanda C.",
          "date": "2024-10-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Needed a fast sweep before the holiday weekend and a sudden freeze. Gus showed up promptly, cleared the creosote, and checked the stainless cap for damage. Quick and clean.",
          "name": "Nathan B.",
          "date": "2024-12-20",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We had a real scare when a small chimney fire flared up one night, so I called first thing the next morning and they fit us in same day. Hank arrived, did a careful inspection, and confirmed that thick creosote buildup was the culprit. He swept the entire flue, removed all the hardened deposits, and inspected the liner closely for heat damage, walking me through every photo. Thankfully the liner held, but he was upfront that we'd been overdue for cleaning. He gave practical advice on burning seasoned wood and how often to schedule sweeps. Calm, knowledgeable, reassuring during a stressful time. I can't recommend their responsiveness enough.",
          "name": "Greta P.",
          "date": "2024-10-29",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Excellent work on a tricky damper repair. The frame was rusted into the masonry and the plate wouldn't seal. Ira took his time, ground out the corrosion, fitted a new damper, and made sure it closed flush before packing up. He even showed me the gap with a flashlight afterward to prove the seal. Couldn't ask for more.",
          "name": "Bianca S.",
          "date": "2026-04-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "This father-and-sons crew really knows chimneys. Our crown was cracked and the cap had rusted to the point of falling apart, letting water rot the wood near the flashing. Jed and his son resurfaced the crown, installed a new cap, re-sealed the flashing, and waterproofed the entire stack. They walked me through a written report with photos of every repair. No leaks through a very wet spring.",
          "name": "Celeste D.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our damper wouldn't latch shut, so squirrels and cold air both had a way in. Knox replaced the throat damper and added a top-sealing unit for good measure since the old flue had a wide opening. He walked me through the gasket and the cable mechanism. Solid work, no mess left behind, and the draft is completely gone.",
          "name": "Emmanuel D.",
          "date": "2025-06-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Hairline cracks in the crown and washed-out mortar joints on a home built in 1928. Levi took photos from his ladder and showed me every problem area on his phone so I understood what I was paying for. The repointing crew matched the joint width and the new mortar color blends seamlessly. They also waterproofed once everything cured. Tidy, professional, and they actually returned calls.",
          "name": "Beatrix L.",
          "date": "2024-09-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Post-storm checkup turned up a loose cap and some lifted flashing I never would have noticed from the ground. Murphy handled both and sealed the crown joint while he was up there. Solid work.",
          "name": "Reginald M.",
          "date": "2024-06-14",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Honestly thought we'd have to rebuild the fireplace, but Ned talked us out of it. He deep-cleaned the firebox, scraped out the old creosote, and treated the smoke-stained brick. The transformation was incredible and it saved us thousands. This father-and-sons outfit clearly takes pride in their work.",
          "name": "Yolanda F.",
          "date": "2026-01-22",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "No soot, no fuss. They covered the floor, wore covers on their boots, and vacuumed up after the sweep. Flue is clear and my house is spotless.",
          "name": "Trent H.",
          "date": "2023-04-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Doubted them at first because the last company had me convinced I needed a brand new chimney. Otis took one look with his camera and showed me the masonry was solid as a rock. The actual fix was repointing a few joints and a new crown seal. Same-day work, fair price, and he cleaned up every speck of debris. Skeptic converted.",
          "name": "Bilal H.",
          "date": "2026-02-14",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Pete swept our chimney and was so patient with all my questions about creosote and how often we should book. Wore shoe covers, kept everything clean, and handed me a written report before he left. The kind of tech you actually want back next year.",
          "name": "Tamika J.",
          "date": "2024-04-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Routine prep on the gas logs before guests arrived for the holidays. The crew cleaned the soot off the glass doors, checked the damper, and tested the remote ignition. Logs look brand new and light on the first click now.",
          "name": "Curtis A.",
          "date": "2025-10-08",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Long overdue cleaning here. Probably ten plus years of buildup in that flue. Roy was professional, explained the creosote stages, and made sure I understood why annual sweeps matter going forward.",
          "name": "Olivia M.",
          "date": "2024-04-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Wood stove had a stubborn draft problem all last winter. Silas diagnosed it during the liner check, found creosote nearly choking the flue, and cleared it completely. Stove lights and draws like new now. Couldn't be happier with the turnaround.",
          "name": "Tyrese J.",
          "date": "2026-05-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Outstanding from start to finish. We had a chimney swift nest that was completely blocking airflow, and the room would fill with smoke every time we lit a fire. Tate explained that the birds are protected, made sure the nest was inactive before removing it, then swept the flue and installed a new stainless cap. He gave me a written report documenting everything for our records. Very thorough crew.",
          "name": "Rashad O.",
          "date": "2025-12-04",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Pre-purchase inspection on an older brick chimney. Found loose mortar and a rusted damper. Written report was detailed and the photos didn't lie. Helped my decision.",
          "name": "Curtis D.",
          "date": "2024-03-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Last-minute before Christmas Eve fires, the office worked us in. Vern swept the flue, cleared soot from the smoke shelf, and tightened the damper so it sealed right. Quick and professional.",
          "name": "Harold V.",
          "date": "2024-12-20",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Faint smoke odor lingered even with the damper shut. Turned out creosote on the liner was the culprit. The tech swept it clean and the smell vanished. Quick and fairly priced.",
          "name": "Bryce H.",
          "date": "2024-06-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Couldn't be happier with the relining job. Wade and the crew were courteous, protected my floors with drop cloths, and finished ahead of schedule. The new liner and cap look great from the street too.",
          "name": "Tamsin W.",
          "date": "2025-07-03",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked our yearly inspection and sweep. Wyatt arrived on time, put down drop cloths, and got to work on the smoke shelf and flue. He found the damper plate had warped slightly and recommended replacing it next visit rather than rushing. Honest, dependable, and the reason we never shop around.",
          "name": "Soo-Jin P.",
          "date": "2025-03-09",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Quick, professional pre-sale inspection. Cole checked the cap, crown, and flue, found the masonry in good shape, and gave me a written report I handed straight to my realtor. Easy.",
          "name": "Marcus H.",
          "date": "2025-04-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Inherited a fireplace I had no idea how to use when we bought this house. Dale did a complete sweep and then walked me through the entire system, the flue, the damper, the smoke shelf, like he was teaching a friend. He never rushed me. Wrote up a clear report with photos so I could remember everything. I called the office a week later with a follow-up question and they were just as patient on the phone.",
          "name": "Gregory H.",
          "date": "2024-11-18",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Wonderful experience. Aiden cleaned out the soot and creosote, checked the stainless cap on the roof, and walked me through each step at a pace I could keep up with. No condescension, just kindness.",
          "name": "Stanley R.",
          "date": "2024-04-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Smelled smoke even when no fire was burning. Beau explained it was creosote absorbing moisture and ran a deep cleaning of the flue. Added a cap to keep critters and rain out. Quick and tidy.",
          "name": "Devin O.",
          "date": "2024-11-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Same-day appointment, which saved us right before a snowstorm. Caleb cleared the ash, cleaned the firebox, and confirmed the damper sealed. Cozy fire that very night.",
          "name": "Ignatius P.",
          "date": "2026-02-11",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Couldn't remember the last time we had it swept. Years for sure. Dewey showed up, threw down drop cloths, and went after the buildup. Flue liner is clean and the smoky odor is gone.",
          "name": "Damian P.",
          "date": "2026-02-08",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Family-owned outfit that treats your house like their own. The crew put down drop cloths, slipped on shoe covers, and cleaned all our ducts without leaving a speck of dust behind. Highly recommend the air duct add-on if you've got allergies.",
          "name": "Ronan E.",
          "date": "2024-02-19",
          "service": "Air Duct Service",
          "rating": 4.9
        },
        {
          "review": "My laundry room was always humid and the tech explained the dryer vent was clogged and venting back inside. Cleared the whole line, sealed a loose joint, and the humidity problem vanished. Same-day add-on while they did the fireplace cleaning.",
          "name": "Aaliyah N.",
          "date": "2026-03-30",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Quick sweep, honest assessment. Earl checked the flue liner and damper, vacuumed up every bit of soot, and was done before lunch. Reasonable price too.",
          "name": "Camila S.",
          "date": "2023-11-09",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Wonderful experience start to finish. Floyd arrived with shoe covers and drop cloths, swept the entire flue, and removed a season's worth of creosote without leaving a speck of soot anywhere. He walked me through before and after photos of the smoke chamber and explained why annual cleaning matters for a wood-burner like ours. Detailed, professional, and genuinely kind. We've found our chimney people for good.",
          "name": "Camila S.",
          "date": "2026-04-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Found them through a neighbor who'd used them for her annual sweep. The crew was punctual, professional, and respectful of the house. They cleaned the firebox, brushed the flue, and explained how to spot creosote buildup myself between visits. Felt like good honest advice.",
          "name": "Anita C.",
          "date": "2024-04-12",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "On time, courteous, efficient. Gus cleaned out the creosote and repointed a few loose bricks near the crown the same morning. Didn't try to upsell me on anything I didn't need.",
          "name": "Brian K.",
          "date": "2025-08-17",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our chimney passed a visual just fine, but the smell of gas-like fumes worried me. Hank insisted on running the camera all the way up, and deep in an offset he found a breach where flue gases were escaping into the framing. That hidden defect could have caused a serious problem. He documented it carefully, recommended a stainless liner, and was upfront that it wasn't an emergency but shouldn't be ignored. Decades of experience clearly showed.",
          "name": "Beatrice N.",
          "date": "2024-09-05",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Honesty is rare these days. The tech inspected the crown and flue for free, told me everything looked sound, and only charged for the sweep. He didn't invent problems. Creosote was light, he said, so no extra treatment needed. I'll call them every year now.",
          "name": "Yvonne P.",
          "date": "2025-11-26",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Such personable guys. Ira did our annual sweep and took time to actually teach me how to spot creosote myself. He didn't rush, didn't upsell, and treated our home with respect. The kind of family business you root for.",
          "name": "Ингрид L.",
          "date": "2025-05-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Tuckpointing on a hundred-year-old brick chimney is not easy and these folks nailed it. Jed raked out the deteriorated joints by hand to avoid damaging the surrounding brick, then repointed and tooled the joints to match the original profile. He also resurfaced the crown where it had cracked. Detailed written estimate up front and a tarp protecting the landscaping the whole time.",
          "name": "Ingrid S.",
          "date": "2026-05-09",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Storm damage follow-up went smoothly. The crew checked the crown, replaced the storm-damaged stainless cap, and sealed the flashing. Quick turnaround and they cleaned up after themselves.",
          "name": "Devin H.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Such a relief to have our gas fireplace properly inspected before lighting it. Knox cleaned the logs and burner, checked for gas leaks at every joint, and confirmed the venting was clear. He also tested our carbon monoxide detector nearby just to be safe. Left the hearth cleaner than he found it with drop cloths down the entire time.",
          "name": "Fatima D.",
          "date": "2024-11-08",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Quick same-day appointment. The camera scan caught a loose section of liner I'd have never spotted otherwise. Shoe covers, drop cloths, clean work.",
          "name": "Bridget A.",
          "date": "2026-04-12",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We had water staining the drywall on the second floor right where the chimney runs through. Levi came out, did a full inspection, and showed me photos of the cracked crown and a cap that had rusted through completely. He rebuilt the crown with a proper overhang, fitted a new stainless cap, and applied a breathable waterproofing product so the brick can still release moisture. Three months and several heavy rains later, completely dry. Couldn't ask for more.",
          "name": "Olivia C.",
          "date": "2024-10-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Moved from an apartment to a house with a fireplace and had no idea about upkeep. Murphy did the sweep and walked me through everything from the damper to the chimney cap. He even drew a quick diagram so I'd remember how the airflow works. Great patient guidance for someone starting at zero.",
          "name": "Rashid A.",
          "date": "2024-08-07",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Nest removed, flue swept, stainless cap installed. Done by lunch. Couldn't ask for more. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Nadia P.",
          "date": "2025-11-08",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We bought a house and the inspection flagged a damaged chimney liner. Smith and Sons came out, ran their own camera to confirm, and gave us an honest assessment. Ned relined the flue with insulated stainless and made sure the connection at the appliance was airtight. He also resealed the crown that had a few cracks. The before and after photos made it easy to understand what we were paying for. Truly appreciated how thorough and patient they were with all my questions.",
          "name": "Naomi P.",
          "date": "2025-11-02",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Reliable and friendly. Otis arrived on time, cleaned the firebox and glass, and tested the pilot light on our gas insert. Done in good time and ready for winter.",
          "name": "Marcus W.",
          "date": "2024-10-08",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Mentioned to the scheduler that my dryer was running hot and they had the crew bring the dryer vent equipment along with the chimney gear. Pete did a thorough job, brushed the entire run, cleared the lint trap housing, and pointed out that our flex hose was kinked behind the unit. Straightened it and the airflow improved immediately. Great value getting two jobs done in one visit.",
          "name": "Tobias W.",
          "date": "2026-02-21",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Roy arrived with a fully stocked truck and got right to work on our wood stove. He removed the baffle, swept the connector and the liner, and vacuumed every bit of soot. The camera check showed the stainless liner in great shape after eight years. He also noted the gasket on the stove door was starting to flatten and suggested replacing it before next winter. Detailed and courteous.",
          "name": "Ingrid L.",
          "date": "2025-09-08",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Firebox makeover turned out beautifully. Silas cleaned the soot off the firebrick and reset the grate. Same-day appointment too, which was a nice surprise.",
          "name": "Quentin J.",
          "date": "2024-03-15",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "My father used these folks and now so do I. Tate handled the yearly sweep, cleared a good deal of creosote, and gave the firebox a once-over. Quick, polite, and reasonable.",
          "name": "Bartholomew S.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our first real cold spell of the year and the fireplace wouldn't draw properly. I called expecting a week-long wait but they had Vern out the same afternoon. He found heavy creosote and a damper that was stuck partly closed. Freed it up, did a full cleaning, and we were toasty by dinner. This family business clearly takes pride in their work.",
          "name": "Sophia G.",
          "date": "2025-11-18",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Moved into a new place and wanted the chimney checked before lighting anything. Wade came out and was both friendly and thorough. He started with a camera inspection, found moderate creosote and a slightly deteriorated flue liner joint, and patiently explained what each finding meant for safety. The sweep was clean and quick, and he protected the hearth and floor the entire time with cloths and covers. He gave me a clear written estimate for the liner work down the road but stressed it wasn't urgent for light use. No pressure whatsoever. The office was easy to deal with too. This is how a service visit should go.",
          "name": "Naomi L.",
          "date": "2026-04-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Same-day service to fix a damper stuck open. Wyatt had it sealing properly within the hour. Fair price, friendly crew, and a job done right the first time — no complaints at all.",
          "name": "Owen L.",
          "date": "2024-05-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Rainwater had been leaking down the firebox and rusting the damper. Cole figured out the crown was cracked and the cap was shot. He patched the crown, dropped in a new stainless cap, and waterproofed the brick. Damper still needs replacing but the source of the water is finally fixed.",
          "name": "Nikolai F.",
          "date": "2024-10-19",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Quick damper fix. The plate was stuck halfway and creosote had glued the pivot. Tech cleaned it, freed it, and confirmed it seals. In and out in under an hour.",
          "name": "Briana O.",
          "date": "2024-10-28",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Tuckpointing and spalled brick replacement on an old farmhouse chimney. The crew laid drop cloths over the roof shingles and worked carefully. New mortar matches beautifully.",
          "name": "Omar H.",
          "date": "2026-05-08",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Snowmelt and ice from the winter storms had worked into a crack in the crown, and water was getting behind the flashing. Dale explained the freeze-thaw damage clearly, rebuilt the crown, resealed the flashing, and capped it with stainless steel. He texted me a written report with photos before and after. The office kept me updated on timing the whole way through. Couldn't ask for more.",
          "name": "Sofia D.",
          "date": "2026-02-08",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Quick and thorough firebox cleaning. Aiden had the soot and ash out in no time and the brick looks fresh. Friendly and on time.",
          "name": "Garrett P.",
          "date": "2023-11-09",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "Beau was great about keeping things clean. He explained he'd seal the opening with a vacuum-fed cover so the creosote wouldn't blow back into the room, and that's exactly what happened. Drop cloths protected the floor and rug. Afterward he wiped down the mantel and glass doors. You could not tell a sweep had even taken place.",
          "name": "Sandra W.",
          "date": "2025-05-16",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Second opinion saved me $8,500. Caleb inspected the flue, crown, and cap, found only normal creosote and a loose cap, and explained why a rebuild was unnecessary. Photos to prove it. Outstanding.",
          "name": "Carmen L.",
          "date": "2025-04-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dewey is the reason I'm leaving this review. He found a gap in the flashing during the sweep and took photos so I understood the issue. Honest and skilled.",
          "name": "Hector V.",
          "date": "2025-10-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Earl arrived with shoe covers and got right to work on our gas insert. He inspected the flue liner, cleaned the burner assembly, and used a meter to confirm no carbon monoxide was leaking into the room. Patient answering all my questions about how often to service it. Honest and tidy.",
          "name": "Imogen B.",
          "date": "2026-02-14",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "We avoided lighting fires for years because we knew the chimney needed attention but kept putting it off. Glad we finally called. Floyd showed up on time, found a startling amount of creosote and even a bird's nest near the top, and cleaned it all out. He swept, vacuumed, and double-checked the liner for cracks. Such a relief to finally use our fireplace again.",
          "name": "Bartholomew S.",
          "date": "2025-10-07",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Reliable and reasonably priced. The technician swept our wood-burning insert, checked the liner for any soft spots, and confirmed the crown above was still in good shape. He laid down drop cloths and wore shoe covers the whole time. We've used them twice now and they're consistent.",
          "name": "Sandra O.",
          "date": "2024-03-30",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Debris and a small nest were clogging the top of our flue. The technician cleared it, brushed down the liner, and put on a stainless cap with animal guard. Easy scheduling through the office and reasonable cost.",
          "name": "Camille D.",
          "date": "2026-04-15",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "This father-and-sons crew clearly knows chimneys. Before buying our farmhouse, Gus inspected the masonry, ran a camera up the flue, and checked the cap and waterproofing. He explained the difference between cosmetic spalling and structural issues so I wasn't scared off unnecessarily. The written report was thorough, photo-rich, and delivered fast. We bought the house with confidence.",
          "name": "Beatrice N.",
          "date": "2025-12-07",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Right after Christmas a deep freeze rolled in and we wanted nightly fires, but the chimney smelled off. Got a same-day slot. Hank explained the odor was creosote and moisture combining, then swept the entire flue and inspected the crown for cracks. He laid drop cloths from the door to the hearth and wore shoe covers the whole time. Left the report and before/after photos on my phone. Warm and reliable through the worst of the cold.",
          "name": "Selena P.",
          "date": "2025-12-29",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Backdrafting was driving us crazy. Cold air would pour down the chimney and bring a smoky smell into the kitchen. Ira installed a top-sealing damper at the top of the flue and that fixed both the cold draft and the odor. He also pointed out some loose mortar on the crown that he sealed. Same-day service and a fair quote up front.",
          "name": "Ingrid L.",
          "date": "2025-10-03",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Old terracotta liner had shifted and was leaking smoke into the attic space. Jed diagnosed it quickly, recommended a full reline, and scheduled us within the week. The new stainless liner solved the smoke problem completely and the draft on our fireplace is night and day. Worth every penny.",
          "name": "Desmond P.",
          "date": "2023-11-22",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Sixth annual visit. The tech cleared the creosote, checked the stainless cap for rust, and confirmed the crown sealant from a prior repair is still solid. Quick, clean, and friendly as always.",
          "name": "Reginald F.",
          "date": "2024-12-28",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "We almost skipped the chimney inspection on the house we were buying. So glad we didn't. Knox spent extra time with the camera and discovered the flue liner had separated near the top. The written report included high-resolution photos and a clear summary of what needed addressing before we lit a single fire. Honest, patient, and never pushy about repairs.",
          "name": "Sunita K.",
          "date": "2024-09-29",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Brand new to fireplace ownership. The crew cleaned out a surprising amount of creosote and then took the time to teach me how to build a proper fire that burns clean. Drop cloths down, very tidy, very patient. Felt like a free lesson on top of the service.",
          "name": "Nadia B.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "As an 84-year-old living alone I appreciate being treated with dignity. The technician knocked gently, showed his ID, and explained he was from a family business. He swept the chimney, photographed the damper and flue, and left everything spotless. I never once felt hurried or pressured.",
          "name": "Mildred T.",
          "date": "2026-03-19",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our drafty old fireplace would back-puff smoke into the family room on windy days. Levi did a smoke test, found gaps in the flue liner mortar joints, and showed me on his camera exactly where the leaks were. He resealed the liner and the back-puffing stopped entirely. Appreciated the written report and the photos he left us.",
          "name": "Sloane F.",
          "date": "2025-10-16",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Professional and thorough. I'd let the fireplace go for years and was embarrassed by the buildup. Murphy didn't judge, just got to work brushing out the creosote and vacuuming the firebox spotless. He gave me a quick written note on what to watch for and recommended a yearly clean. Honestly the most pleasant home service visit I've had. We're enjoying cozy evenings already.",
          "name": "Felicity W.",
          "date": "2025-11-25",
          "service": "Fireplaces Service",
          "rating": 4.9
        },
        {
          "review": "This family-owned outfit did a fantastic job on our long-neglected chimney. Ned explained that the thick creosote layer we'd ignored for eight winters was a real fire hazard. He scrubbed the flue clean, vacuumed everything up, and showed me photos of the before and after. Worth every penny for the peace of mind heading into the cold season.",
          "name": "Yvonne S.",
          "date": "2024-11-26",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Otis was fantastic. He walked me through each return vent before starting, explained how the dust accumulates, and then methodically cleaned the entire system. He noticed our furnace filter was the wrong size and recommended the correct one. Air feels noticeably fresher and the constant sneezing in the morning has stopped.",
          "name": "Bianca W.",
          "date": "2025-11-16",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Pete handled the chimney sweep then spent twenty minutes clearing the dryer vent from both ends. Showed me a softball-sized lint wad he pulled near the exterior hood. Fast, tidy, wore shoe covers inside. Easy recommendation.",
          "name": "Gregory P.",
          "date": "2024-07-16",
          "service": "Dryer Service",
          "rating": 4.9
        },
        {
          "review": "Impressed by how clean they kept things. Shoe covers, drop cloths, and a vacuum the whole time. Flue is spotless and the damper finally moves freely.",
          "name": "Donovan H.",
          "date": "2025-02-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Long-time homeowner here, and I never skip the annual sweep. Roy did a meticulous job brushing the flue and clearing creosote, then handed me a written report noting the liner and cap were both in good shape. Fair pricing and zero mess.",
          "name": "Desmond H.",
          "date": "2024-09-12",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Neighbor down the lane raved about this family business, so I called. Silas swept the chimney top to bottom and replaced a cracked cap he spotted during the inspection. Tidy, fast, and friendly.",
          "name": "Desmond W.",
          "date": "2025-10-05",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Our chimney needed a sweep and the cap had blown off in a storm. Rather than send a sweep one day and a repair crew the next, they sent Tate who did both in a single stop. He had a replacement stainless cap right on the truck, mounted it, then cleaned the flue and showed me photos. Punctual, prepared, and easy to deal with.",
          "name": "Lucia F.",
          "date": "2026-01-23",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Slow draft for years. The camera inspection found a brick that had shifted into the flue path. Simple fix once they could actually see it.",
          "name": "Quentin D.",
          "date": "2025-04-21",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "What a difference from the high-pressure outfits. Vern gave me a free written quote for the chimney cleaning, explained the creosote rating, and never once pushed a repair. The price held firm. Family-owned and it shows in how fairly they treat customers.",
          "name": "Damon F.",
          "date": "2023-11-04",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Wade arrived with a fully stocked truck and got right to sweeping. What I valued most was his honesty when I asked about waterproofing the masonry. He said my brick was in good shape and didn't need it this year. He could've easily sold me the service. Genuinely good people, and the work was clean and thorough.",
          "name": "Camille B.",
          "date": "2024-03-08",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Several bricks near the top were spalling and the mortar was sandy and loose. Wyatt rebuilt the top three courses, repointed below, and recrowned. He showed me the original brick was failing from old water damage. Honest assessment and clean work on a tricky old chimney.",
          "name": "Quentin A.",
          "date": "2024-07-22",
          "service": "Chimney Service",
          "rating": 4.9
        },
        {
          "review": "Heavy rain and wind cracked the crown and rusted out the old cap. Cole walked the roof with me afterward, showed me exactly where the flashing had separated, and resealed everything before installing a fresh cap. He was patient with all my questions and never rushed. The drip in our chimney chase finally stopped. Genuinely good people doing honest work.",
          "name": "Rosalind F.",
          "date": "2025-11-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Dale came by to prep the gas logs. Cleaned the burner, adjusted the air shutter so the flame stopped sooting up the glass, and checked the damper. Solid, no-nonsense visit.",
          "name": "Quincy A.",
          "date": "2026-04-11",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Decades of experience really showed. Aiden ran the level-2 camera through our 1920s chimney and found that the original terracotta liner had deteriorated badly near the firebox. Explained the spalling and the safest fix. Showed every bit of evidence on the monitor and emailed the report with photos that afternoon.",
          "name": "Constance W.",
          "date": "2024-12-03",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Cracked crown sealed and chimney waterproofed in an afternoon. Beau was professional and explained everything clearly. Reasonable price for the peace of mind.",
          "name": "Ramon J.",
          "date": "2025-08-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We'd never had a fireplace before and were honestly scared to light it. Caleb came out, swept the chimney, and took the time to show us the creosote he'd cleared and explain how dangerous it can get if you let it build. He demonstrated how to crack a window for draft and how to bank the fire safely at night. Shoe covers on the whole time, drop cloth down, immaculate cleanup. He never once made us feel dumb for not knowing. We finally lit our first fire that night and it was perfect.",
          "name": "Heather V.",
          "date": "2025-04-26",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a storm knocked our old cap off, birds wasted no time nesting inside. Dewey came out, pulled the nest, cleared out the debris that had fallen down the flue, and fitted a sturdy new stainless steel cap. Explained why the mesh guard matters for keeping animals out. Reliable and knowledgeable.",
          "name": "Trevor J.",
          "date": "2025-01-29",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Old liner was shot and letting moisture in. Earl installed a new stainless liner and waterproofed the masonry around the crown. Clean, fast, no surprises on the bill.",
          "name": "Walter F.",
          "date": "2024-02-28",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Getting the house cozy before the holidays, I had Smith and Sons clean our fireplace. Floyd vacuumed out an enormous amount of ash, scraped creosote off the firebox brick, and pointed out a small crack in the refractory panel I should keep an eye on. He gave me a written note about it rather than pressuring me into a repair. Appreciated the honesty and the careful cleanup with drop cloths.",
          "name": "Yvonne D.",
          "date": "2025-12-07",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Gus cleaned out our dryer vent right after the chimney inspection. Years of lint came out of the line. He laid drop cloths and left the laundry room cleaner than he found it.",
          "name": "Margaret D.",
          "date": "2023-07-18",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Same-day cleaning when another company canceled on me. The crew swept the insert flue, checked the liner top to bottom, and laid drop cloths so there was zero mess. Couldn't ask for more.",
          "name": "Omar J.",
          "date": "2024-11-02",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Decades of fires had left our firebox black and flaking. Hank came out, vacuumed everything, scrubbed each firebrick by hand, and repaired the cracked refractory panel in the back. He also cleaned and lubricated the damper so it swings smoothly now. The before/after photos he texted me were night and day. Truly looks brand new.",
          "name": "Imani D.",
          "date": "2026-04-09",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Twenty-two years in this farmhouse and every single fall the chimney gets swept by this same family business. Ira is usually the one who comes out. This year he brushed the flue, vacuumed creosote out of the smoke shelf, checked the damper swung freely, and handed me a written report noting everything was in good shape. They never rush, never leave a speck of soot, and treat us like neighbors. Truly grateful for service this consistent.",
          "name": "Estelle M.",
          "date": "2025-02-28",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Polar vortex moved in and I panicked about lighting a fire on a chimney I'd never had inspected. Same-day service got Jed out fast. He swept it, examined the flue liner with a camera, and confirmed it was safe. Thorough and reassuring.",
          "name": "Vincent H.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Birds had taken up residence at the top of our chimney and the noise was driving us crazy. Knox came out, removed the nesting material, and did a full sweep since debris had built up alongside the creosote. He installed a stainless cap with mesh to keep critters out for good, and the difference is immediate. He showed me the before and after on camera so I could see the flue was actually clean. Tidy work, friendly attitude, and he didn't leave a speck of soot behind. The price matched the quote exactly. Solid, dependable local outfit that clearly knows what they're doing.",
          "name": "Rashid H.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We noticed a constant cold downdraft and could hear the wind. The scheduler got someone out the next morning. Levi found the damper was missing its gasket entirely and the plate had a warp. He replaced the whole assembly with a tight-sealing unit and the room temperature evened out almost immediately. Tidy, polite, and explained everything plainly.",
          "name": "Delphine V.",
          "date": "2025-12-30",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Water stains on the chimney breast had me worried. The tech inspected, photographed the cracked crown and rusty cap, and gave me a straight quote. Crown sealed, new cap fitted, masonry waterproofed. Clean work.",
          "name": "Tabitha W.",
          "date": "2026-04-28",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Decades of experience really showed here. The father and one of his sons came out together, diagnosed a cracked cast iron damper, and recommended a top-sealing replacement that closes airtight from the roof. They explained how the energy loss from a leaky damper adds up, installed the new one cleanly, and left a written report with photos of the crown and cap. Genuinely impressed by how thorough they were.",
          "name": "Nikolai V.",
          "date": "2026-03-22",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "When the brick on our chimney started shedding its faces I assumed a teardown was coming. Murphy took one look and reassured me it was salvageable. His team replaced the spalled brick, ground out and repointed the failing mortar joints, rebuilt a cracked crown, and sealed everything with a breathable waterproofing. The whole stack looks structurally sound again and they explained how the previous owner's hard sealant trapped moisture and caused it. Three generations of masonry knowledge, and it shows in the finish.",
          "name": "Felicity G.",
          "date": "2023-11-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Lightning storm spooked us into getting an inspection. Turns out the cap was fine but the crown had a real crack letting water in. Ned patched and waterproofed it the same visit. Fast and fair.",
          "name": "Curtis P.",
          "date": "2023-07-19",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "We hadn't used our fireplace in years because it looked so filthy. Otis came out, cleaned the entire firebox, scrubbed the soot off the brick, and reconditioned the cast iron grate. The drop cloths and shoe covers kept everything spotless. Now it looks like a brand new fireplace and we're actually excited to use it this winter.",
          "name": "Nadia C.",
          "date": "2025-12-18",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Appreciated the attention to detail. Shoe covers came on before the tech crossed the threshold, and he rolled out a long runner to the fireplace. The brush work knocked loose a surprising amount of creosote but the HEPA vac caught it all. Hearth and surrounding tile were spotless when he finished.",
          "name": "Ibrahim N.",
          "date": "2024-09-25",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "The previous company had me half-convinced my chimney was crumbling and needed to come down entirely. Pete showed up, ran a proper inspection, and demonstrated with his scope that the liner and brick were fine. The only issue was creosote glaze, which he removed. Handed me a detailed written report I could keep. Honest, thorough, and no pressure to spend a dime more than needed.",
          "name": "Niko P.",
          "date": "2024-08-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Roy cleaned our chimney and replaced a loose stainless cap the same day since the truck was fully stocked. Polite, careful, and quick. He showed me before and after photos and explained the creosote rating. Couldn't ask for more.",
          "name": "Fern O.",
          "date": "2026-04-11",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Top to bottom gas-log safety check. Silas disassembled the burner, cleared spider webs and debris from the ports (apparently a common ignition issue), tested the gas pressure, and verified the pilot and main flame. He also checked the venting cap on the roof was clear. Detailed written report at the end. Couldn't ask for more.",
          "name": "Fernando D.",
          "date": "2024-09-12",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "This family business sent Tate out to tackle a chimney that hadn't been swept since we moved in eight years ago. He was matter-of-fact, efficient, and showed me the creosote chunks he removed. No upselling, just honest work.",
          "name": "Frances D.",
          "date": "2025-06-30",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Stove insert cleaning went smoothly. Vern brushed out the liner, vacuumed the creosote flakes, and gave the damper a quick test. In and out in under an hour with no mess left behind.",
          "name": "Quincy D.",
          "date": "2025-06-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Mice and birds had been competing for our chimney apparently. Wade found nesting material from both, hauled it all out, and vacuumed the firebox clean. The new stainless cap he installed has a tight mesh that should keep everything out for good. Decades of experience really shows in how efficiently he worked.",
          "name": "Bjorn H.",
          "date": "2024-02-20",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Booked a pre-sale inspection to get ahead of buyer questions. Wyatt documented the crown, flue, and flashing with photos and gave us a clean written report. Made the listing process smoother.",
          "name": "Hassan J.",
          "date": "2024-09-21",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Cold front hit hard and I scrambled to get the chimney cleaned. They had a tech out within a few hours. Brushed the flue, vacuumed everything, and showed me the creosote he removed. No mess left behind, decades of experience clearly showed.",
          "name": "Dwayne L.",
          "date": "2024-02-03",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Smoke would back up every time the wind blew from the north. Cole explained it was a draft pressure issue and fitted a wind-directional cap. Problem solved on the first windy night after. Knowledgeable and no upselling.",
          "name": "Travis O.",
          "date": "2023-11-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Needed a liner for a new pellet stove install. Dale sized it right, ran the stainless liner with a tee connection at the bottom, and made sure the cap was secured. Tidy, knowledgeable, and patient with all my questions about maintenance going forward.",
          "name": "Felicity N.",
          "date": "2026-01-18",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Loyal customer here and proud of it. We've had our chimney swept by them every year since 2019. This time Aiden did the honors, brushing out a moderate creosote layer and checking the flue liner top to bottom. He even noticed a loose mortar joint on the crown and added it to the written report so we can plan ahead. Truly appreciate the continuity.",
          "name": "Camille O.",
          "date": "2026-02-26",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Pre-purchase inspection on a rental property I was considering. Tech was matter-of-fact, photographed the firebox cracks and worn damper, and delivered a written report by email the same evening. Helped me decide the price was fair.",
          "name": "Bryce A.",
          "date": "2023-11-05",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "First fireplace I've ever had and I was honestly afraid to even light it. Beau swept the chimney, inspected the flue liner, and patiently explained why the previous owners' habits had caused buildup. He showed me on the report exactly what to watch for. By the end I felt like I actually understood my own chimney.",
          "name": "Emmanuel D.",
          "date": "2023-12-07",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Patient and tidy. Caleb laid cloths everywhere and vacuumed up the last bit of creosote dust before he left. Took the time to show my wife how the damper works.",
          "name": "Walter S.",
          "date": "2025-05-02",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Downdraft was constant. The technician installed a wind-directional cap after explaining how nearby trees were disrupting airflow. Smoke no longer rolls back in. Fair price and clean work.",
          "name": "Quentin H.",
          "date": "2024-03-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Dewey handled our fireplace cleaning and was a pro. He removed a thick crust of soot from the firebox, cleaned behind the glass doors, and tested the damper movement. Left the hearth cleaner than he found it.",
          "name": "Octavia L.",
          "date": "2024-10-09",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Realized we'd never cleaned the chimney in the whole time we owned the place, going on ten years. Earl arrived with a fully stocked truck and tackled the heavy soot buildup right away. He pointed out the damper was rusted partially shut and freed it up too. Careful with shoe covers and a tidy worker. The draft is dramatically better now.",
          "name": "Connor M.",
          "date": "2025-04-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Reasonable price for a serious deep clean of the ductwork. Floyd vacuumed every supply duct, brushed the registers, and even wiped down the vent covers. Tidy and on time.",
          "name": "Garrett L.",
          "date": "2023-10-08",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Quick and painless. Lint trap and full vent run cleaned out, dryer runs cooler now. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Nadia F.",
          "date": "2025-02-08",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Gus swept years of creosote out of our flue and left zero mess. Same-day service after a cancellation. Friendly guy, fair price, clean work.",
          "name": "Yolanda C.",
          "date": "2026-04-02",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Scheduled our routine cleaning before the holidays. Hank was prompt, laid drop cloths the whole path to the fireplace, and swept out a moderate creosote buildup. He checked the damper and confirmed everything was drafting properly. Quick and clean, exactly what I wanted.",
          "name": "Isabella F.",
          "date": "2025-12-01",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "On a tip from the folks next door, I scheduled a cleaning. Ira came out, laid down drop cloths, and swept years of creosote out of the flue. He showed me before and after photos so I knew exactly what he'd done. Same-day service too.",
          "name": "Felicity N.",
          "date": "2023-11-28",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Jed arrived on the dot and worked fast. Swept the chimney, found a cracked clay tile in the liner, and sealed the crown all before lunch. Same day, one visit. Couldn't ask for more.",
          "name": "Nathaniel P.",
          "date": "2024-07-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Knox ran a level-2 camera after we noticed staining on the ceiling near the chimney. Footage showed a cracked crown letting water seep down and a deteriorating section of liner below it. He explained how the water and creosote combo was eating the masonry from inside, gave me a written report with photos, and waterproofing plus a new cap fixed it. The clarity of the video made the decision easy.",
          "name": "Naomi F.",
          "date": "2026-02-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Free quote turned into same-day service and the bill was exactly what they said. Levi swept the flue and cleaned up every speck with drop cloths down the whole hearth. No surprise charges, no upsell. Fair pricing, plain and simple.",
          "name": "Aisha N.",
          "date": "2026-04-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Straightforward and kind. Murphy cleaned the flue, checked the cap, and gave me an honest assessment with no scare tactics. Hard to find these days.",
          "name": "Oskar D.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Our older home's chimney looked rough, with crumbling joints and flaking brick. Ned did beautiful tuckpointing and replaced the worst spalled bricks. He also sealed the masonry with a waterproofing product after curing. The before and after photos were night and day.",
          "name": "Bianca F.",
          "date": "2025-02-28",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "After the derecho came through I had no idea what shape the chimney was in. Otis inspected the crown, cap, and flashing, found wind damage to the cap and a small crown crack, and fixed both same day. Straight shooter.",
          "name": "Hassan B.",
          "date": "2024-07-30",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We hadn't used the gas fireplace in over a year and wanted it checked before relying on it. Pete inspected the gas line, cleaned the dust and debris off the burner and logs, and tested the pilot ignition several times. He noticed the oxygen depletion sensor was sluggish and explained our options without pressuring us. Very honest and the flame is gorgeous now.",
          "name": "Imani G.",
          "date": "2025-02-26",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "We thought we just needed a cleaning, but the technician recommended a camera inspection first. Good thing too. Found a serious creosote glaze near a bend plus a small breach in the flue that needed attention before any more fires. No pressure, just facts and footage.",
          "name": "Hassan E.",
          "date": "2025-08-30",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Every heavy storm we'd get a damp smell from the fireplace. Turned out the chimney cap was missing entirely and rain was pooling on the smoke shelf. Roy installed a new cap, cleared the standing water, and waterproofed the crown which had a few cracks forming. Fast scheduling through the office and the tech was respectful of the house, wore shoe covers and laid drop cloths.",
          "name": "Bridget H.",
          "date": "2026-01-27",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "First winter with a fireplace and we were clueless. The crew swept the flue, inspected the crown for cracks, and gave us a simple rundown on maintenance. Patient and friendly with all our rookie questions.",
          "name": "Mateo G.",
          "date": "2023-11-30",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Something had clearly been living in our chimney based on the mess. Silas removed an old nest and a pile of debris, then ran a camera up the flue to make sure it was all clear before capping it with stainless. Showed me the footage. Thorough work and a fair price.",
          "name": "Belinda S.",
          "date": "2024-10-12",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Outstanding from start to finish. The flue serving our gas water heater was unlined properly and the tech, Tate, explained the safety risk clearly without scaring us into anything. He sized and installed an aluminum liner, sealed the top plate, and tested the draft before leaving. Drop cloths down the whole way, shoe covers on. The written report was detailed enough to satisfy our insurance company.",
          "name": "Imani S.",
          "date": "2025-05-16",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our first winter in this house and the fireplace needed serious attention. Vern cleaned the firebox top to bottom, brushed out the smoke chamber, and made the soot-blackened glass clear again. He even repositioned our gas logs back to the manufacturer pattern. Cozy fires all season thanks to him, and the price was exactly what the office quoted.",
          "name": "Bradley G.",
          "date": "2026-03-21",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "We called for a chimney sweep but the real win was the dryer vent cleaning add-on. The exterior vent hood was completely clogged and the dryer had been taking three cycles to dry a single load. Wade cleared the full duct run, checked the termination cap, and gave us a written report noting the vent was a fire hazard before he cleaned it. Wish we'd done it years ago. Fast, friendly, and the price for adding it on was very reasonable.",
          "name": "Hassan F.",
          "date": "2025-04-02",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Booked a routine sweep for our wood stove and the tech found more creosote than expected from burning some unseasoned oak last year. Wyatt brushed it all out, inspected the liner with a camera, and gave practical advice on wood storage. Friendly and didn't rush.",
          "name": "Stephanie V.",
          "date": "2025-03-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Great firebox cleaning before our first winter fire. The technician laid down a drop cloth, cleared the ash and creosote, and pointed out a hairline crack in the firebrick that he sealed. Tidy and quick.",
          "name": "Holden P.",
          "date": "2025-12-21",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Booked the annual cleaning a bit late this year but the office squeezed me in same week. Creosote buildup was moderate and the tech cleared it all, then swept the firebox. Easy.",
          "name": "Gianni F.",
          "date": "2024-12-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Two days before Christmas dinner and our flue was packed with creosote. Phoned the office and Cole arrived within hours, drop cloths down, vacuum running. He cleared everything, checked the cap, and left the hearth spotless. We had our holiday fire after all.",
          "name": "Rebecca F.",
          "date": "2023-12-23",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "After years of putting it off, I finally booked a sweep and inspection, mostly out of guilt. Turned out to be a great decision. Dale arrived on time, laid protective covers down, and got to work clearing what he called a dangerous amount of creosote from years of neglect. The camera footage was eye-opening, honestly. He also caught a cracked clay flue tile and explained my options without any pressure to decide on the spot. Everything was documented in a detailed written report with photos I could share with my insurance. Professional, patient, and refreshingly honest. The whole experience made me wish I'd called them years ago.",
          "name": "Imelda S.",
          "date": "2024-09-16",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Our 1960s throat damper finally gave up and rusted shut. Rather than force the brittle plate, Aiden recommended a cable-operated top damper. He measured the flue, installed it, and now we can seal the chimney completely between fires. The difference in draft is night and day, and the install came with a long warranty.",
          "name": "Sergio P.",
          "date": "2025-02-11",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Our chimney was acting like a funnel, dumping water into the flue and onto the smoke shelf. Beau and Beau identified a crown that had crumbled at the edges and a cap eaten up by rust. They formed a fresh crown with a drip edge, set a heavy stainless cap, and applied a breathable waterproofing sealer to the whole exterior. Detailed, patient, and the leak is completely gone.",
          "name": "Ezekiel H.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Replaced a damper that had rusted solid in the open position. Caleb cut it free, fitted a new unit, and added a fresh gasket so it now seals completely. He laid drop cloths and vacuumed up every flake of rust. The bedroom above the chimney is noticeably warmer.",
          "name": "Felicia A.",
          "date": "2025-08-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Mortar was failing on the weather-side of an 1890s brick chimney. Dewey repointed it and swapped out a dozen spalled bricks. Color match is spot on and the joint tooling looks original.",
          "name": "Gunnar P.",
          "date": "2025-07-22",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "A microburst tore through and left our chimney cap dangling. These folks answered the phone right away and had a crew out by afternoon. They installed a new cap, resealed the flashing where the wind had lifted it, and checked the crown for cracks. Drop cloths down, careful and quick. Honest family business that clearly knows chimneys.",
          "name": "Felicia H.",
          "date": "2025-11-29",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Top to bottom firebox makeover. Earl removed decades of soot, cleaned the damper, and the brick looks like the day it was laid. Professional and respectful of our home.",
          "name": "Sterling J.",
          "date": "2024-07-26",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Floyd arrived, slipped booties over his boots, and laid drop cloths from the door to the firebox. He worked the flue from the roof while keeping a vacuum sealed at the bottom opening. When he was done the only evidence was a bag of soot he carried out. Immaculate work.",
          "name": "Lorraine B.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Walked in skeptical after a rebuild quote that felt like highway robbery. The tech proved with before-and-after photos that my chimney just needed a sweep and a crown patch. No rebuild required. Gus was patient and clear. Highly recommend.",
          "name": "Imani D.",
          "date": "2026-01-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Hank handled the inspection and sweep and was wonderful with our dog underfoot the whole time. Tidy and kind. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Lamar P.",
          "date": "2024-07-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Needed our gas fireplace certified safe for a rental inspection. The tech checked the gas connections, tested for leaks, cleaned the logs, and provided documentation that everything passed. Fast turnaround helped me hit my deadline.",
          "name": "Sloane P.",
          "date": "2025-12-03",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Decades of neglect, that's what Ira found when he opened our flue. The buildup was so heavy he had to make several passes with the brush. He laid down protective coverings, vacuumed thoroughly, and showed before and after pictures. The whole hearth looked spotless.",
          "name": "Reginald A.",
          "date": "2024-10-22",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We heat almost entirely with our wood stove so the liner takes a beating each season. Jed came out, swept a heavy creosote layer, and ran the camera the full height of the chimney. He flagged a hairline issue near the top section and gave me a realistic timeline for when it would need attention rather than scaring me into a same-day fix. That kind of honesty is rare. Written report was clear and the photos were sharp.",
          "name": "Bethany L.",
          "date": "2026-01-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Couldn't use our fireplace because something was blocking the flue. Knox pulled out a huge bird nest, swept the chimney, and capped it. Same-day service and he was done in an hour.",
          "name": "Selena V.",
          "date": "2025-07-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Our home inspector flagged the chimney, so we called these folks for a specialist look before closing. Levi scoped the flue liner and found a crack the general inspector couldn't see, plus deteriorating mortar at the crown. His written report with photos gave us leverage to get the seller to fund repairs. Couldn't have asked for a better outcome.",
          "name": "Geraldine F.",
          "date": "2026-04-18",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Hosting twelve for Thanksgiving and the fireplace draft was terrible. Emergency call answered fast, Murphy came out the same afternoon. Found a heavy creosote layer choking the flue and a bit of debris near the stainless cap. Swept it clean and the draft was perfect by the time guests arrived.",
          "name": "Imani C.",
          "date": "2025-11-22",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "After a kitchen remodel our tight, energy-efficient house started pulling smoke back down the chimney whenever we lit a fire. Ned did a thorough draft evaluation, found the home was depressurized, and recommended cracking a nearby window plus cleaning the heavy creosote off the smoke shelf. He also swept the flue and reset the damper. Such a relief to have a real fire again without the living room filling with haze. Genuinely appreciated his patience explaining the physics of it.",
          "name": "Camille F.",
          "date": "2026-04-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Crown was cracked and the flue liner was crumbling. They tackled both in one visit, rebuilt the crown and dropped in a fresh stainless liner. Otis ran the job and kept me posted at each step. Reasonable quote and the area was left clean.",
          "name": "Obadiah C.",
          "date": "2024-09-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Annual cleaning again and they remain my go-to. Pete swept the flue, examined the damper, and tidied up better than I would have. Years of solid service speak for themselves.",
          "name": "Nathaniel W.",
          "date": "2023-11-07",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Selling our family home of 30 years, we wanted everything documented so buyers wouldn't haggle later. Roy came out, was respectful putting on shoe covers, and inspected the entire system top to bottom. His written report noted the chimney was in excellent condition with only minor cap rust. Buyers were impressed and we closed without a single chimney-related concern. Smith and Sons made the whole process easier.",
          "name": "Camille B.",
          "date": "2026-05-18",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "We are total beginners and this was our first ever chimney service. Silas was so patient explaining the difference between the cap and the crown, and why both matter for keeping water out. He swept everything, gave us a written report, and answered probably a dozen questions without ever sighing once. Highly recommend for anyone new to all this.",
          "name": "Shauna L.",
          "date": "2025-09-25",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "My arthritis makes it hard to do much, so I worried about having work done. Needn't have. Tate was gentle and patient, swept the flue thoroughly, and pointed out a bit of buildup near the smoke shelf using clear photos. He carried my firewood in too, bless him. Honest, careful, and kind to an old man.",
          "name": "Clarence J.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "After we added insulation the whole house got tighter and suddenly the fireplace smoked us out. Vern came and immediately recognized it as a make-up air issue causing the flue to draft backward. He swept the heavy creosote too, since it had been a while, and recommended a fresh air intake. Patient, professional, and explained everything in plain language. The room finally stays smoke free.",
          "name": "Ingrid L.",
          "date": "2026-04-12",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Wonderful service. Wade spread drop cloths over our nice rug without being asked, then got the fireplace cleaned out and the glass crystal clear. He noticed our damper was a little stiff and worked some lubricant into it so it opens easily now. We've been having fires every chilly night since and the house feels so much cozier. Highly recommend for getting ready before winter.",
          "name": "Cornelius H.",
          "date": "2025-12-19",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Long overdue cleaning, easily a dozen years. Wyatt pulled out so much creosote I couldn't believe we'd been burning safely. Quick, clean, professional.",
          "name": "Aaliyah D.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We'd been dealing with dust resettling on furniture within a day of cleaning. The technician traced it to filthy supply ducts and a clogged return. After the air duct service the dust problem is dramatically better. He gave us a written report with photos showing the before and after condition of each vent. Couldn't be happier with the result.",
          "name": "Sunita K.",
          "date": "2025-08-23",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "This family business does it right. While Cole and his son finished waterproofing the crown, they cleaned my dryer vent as an add-on. Cole explained how lint buildup is a leading cause of house fires and showed me the airflow reading at the hood after. No pressure, just good information and clean work.",
          "name": "Lucia D.",
          "date": "2025-12-18",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Sweep was fast and thorough. Tech showed me before and after photos of the flue and pointed out the cap was in good shape. No upsell, just clean work.",
          "name": "Sebastian O.",
          "date": "2024-07-30",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Annual maintenance sweep. Tech cleared the creosote and dusted out the firebox. In and out without fuss, and the price matched the quote.",
          "name": "Quentin D.",
          "date": "2023-03-22",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "A coworker who lives in my neighborhood recommended them after they cleaned his chimney. The scheduler fit me in within two days. Dale did a careful sweep, ran a camera up the flue liner, and pointed out the crown could use waterproofing down the road. No hard sell, just facts and a clear written report. Refreshing.",
          "name": "Omar L.",
          "date": "2026-04-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Texted me ahead, showed up when they said, and finished both the cleaning and a minor flashing repair in the same trip. I'd budgeted a whole afternoon and they were gone in under two hours. Floors stayed spotless thanks to the drop cloths.",
          "name": "Yusuf A.",
          "date": "2025-03-09",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Solid, no-nonsense inspection. Aiden fed the camera up, found a tile that had spalled and dropped debris onto the smoke shelf, and showed me exactly where. Cleaned it out and re-checked. Appreciated the straight talk and the printed report he left behind.",
          "name": "Theodore G.",
          "date": "2024-02-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Reasonable, transparent, no games. Got a clear cleaning quote up front, Beau did the sweep, and the damper got checked at no extra cost. Paid what I was told.",
          "name": "Bennett L.",
          "date": "2024-03-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Caleb and his dad came by for our chimney sweep and I can't say enough about how genuine they were. We got to talking and you really feel the pride this family puts into the work. Caleb pointed out where some creosote glazing was forming and explained exactly how to burn drier wood to prevent it. No pressure, no nonsense, just helpful honest advice.",
          "name": "Tasha G.",
          "date": "2026-04-12",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Mortar joints on the weather side had eroded badly. They ground them out and repointed. Two spalled bricks got swapped. Straightforward job, done in a day.",
          "name": "Theo C.",
          "date": "2023-05-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Our chimney took a beating in a summer storm. Dewey replaced the dented cap, sealed the crown where it had chipped, and reattached the flashing that had blown loose. He laid down drop cloths inside and wore shoe covers the whole time. Tidy, professional, and reasonably priced. Got a written report for our records too.",
          "name": "Camille D.",
          "date": "2025-06-17",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Great experience prepping our gas-log set for fall. The tech cleaned the burner ports, repositioned the ceramic logs exactly per the manufacturer layout, and ran a leak test on the connections. He showed me before and after photos of the burner. Worth every penny.",
          "name": "Oscar V.",
          "date": "2024-09-30",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Earl arrived on time and got right to work with the inspection camera. The hidden problem turned out to be a misaligned liner section that had shifted, creating a gap where heat could escape. He showed me on the screen, explained the danger, and scheduled the repair without any drama. Friendly and knowledgeable, and he cleaned up everything before leaving.",
          "name": "Renee D.",
          "date": "2025-05-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Rust streaks running down my white chimney from a corroded old cap drove me nuts. Floyd swapped it for a stainless one and treated the crown with waterproofing while he was up there. The streaking is gone and it looks brand new.",
          "name": "Anthony L.",
          "date": "2024-05-16",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Such a relief working with people who don't talk down to beginners. Gus swept our chimney, showed me the before and after photos of the flue, and explained why the previous owners' lack of cleaning had left so much creosote. He recommended a stainless cap and taught me how to spot a healthy fire versus a smoldering one. As someone using a fireplace for the very first time, I felt completely taken care of.",
          "name": "Delia W.",
          "date": "2026-02-04",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Quick honest service. Hank cleared the nest, swept the flue, and capped it in under two hours. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Hector V.",
          "date": "2025-06-25",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Relined our chimney after years of neglect left the clay tiles cracked. Ira and the crew were courteous and explained the stainless liner options. Reasonable quote, quality install.",
          "name": "Bradley O.",
          "date": "2024-10-25",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Fast, clean, professional fireplace service. Jed swept the firebox and checked the damper. Ready for cold weather now. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Camille R.",
          "date": "2024-11-20",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Quick and painless. Dryer vent add-on while they swept the flue. Lint trap area and the whole line got cleaned. Dryer runs cooler now.",
          "name": "Lena V.",
          "date": "2024-08-14",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Very pleased. Knox cleaned the creosote from the insert, checked the flue liner for any cracks or separation at the joints, and confirmed everything was sealed properly. He pointed out a hairline issue at the crown and offered to waterproof it, which I scheduled for spring. No high-pressure tactics, just clear options and photos to back it up.",
          "name": "Gerald D.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Cannot believe the difference in our fireplace. The firebox had a thick layer of soot and a sticky creosote glaze that I figured was permanent. Levi proved me wrong. He scrubbed the firebrick clean, repointed the mortar joints, and polished up the cast iron back panel. Wore shoe covers the whole time and left no mess. The fireplace looks brand new and we finally feel good lighting it again.",
          "name": "Soledad V.",
          "date": "2024-09-04",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Every spring after we stop burning, I have them come clear out the season's creosote so it doesn't sit all summer. Murphy swept the full flue length, vacuumed the soot, and confirmed the cap and crown were still solid. Professional and thorough as always, and the drop cloths kept my floors clean.",
          "name": "Nadia V.",
          "date": "2023-03-16",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Cold front bearing down and no time to spare. Ned got us scheduled same day, swept the chimney, and showed me how thick the buildup had gotten. Genuinely fast work.",
          "name": "Hugo P.",
          "date": "2025-02-09",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Wanted a second opinion after another company quoted me thousands for a full chimney rebuild. Otis came out, did a careful inspection top to bottom, and showed me on camera that the flue and liner were actually in solid shape. The real issue was just heavy creosote and a minor crown crack, both of which he addressed for a fraction of the other quote. He swept everything, sealed the crown, and gave me a written report I could trust. His honesty literally saved me a fortune. It's rare to find a tradesperson who tells you that you need less work, not more. This crew earned a customer for life.",
          "name": "Bartholomew O.",
          "date": "2025-06-25",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Damper plate had corroded through. Replaced quickly, seals airtight, no more cold draft down the flue. Very satisfied. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Maeve O.",
          "date": "2024-10-15",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Came home to water pooling at the base of the firebox. Pete traced it up to a cracked crown and a cap that had rusted clean through. Crown repaired, new cap installed, brick waterproofed. The office got me scheduled the next morning and the whole thing was done by lunch.",
          "name": "Lucinda A.",
          "date": "2024-05-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Damper lever was jammed and the plate wouldn't budge. Roy diagnosed a bent frame, swapped in a new throat damper, and tested it opened and closed smoothly. Reasonable rate, same-day visit. No more cold air rolling into the den.",
          "name": "Owen H.",
          "date": "2024-05-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Significant spalling and a crumbling crown on our older home. Silas walked me through the whole scope, explained why waterproofing has to wait until the new mortar cures, and gave me a written report with photos. The repointing is meticulous and they hauled away all the broken brick and mortar debris. Couldn't be happier with the masonry work.",
          "name": "Rosalind T.",
          "date": "2024-02-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Storm season did a number on the flashing and I had a small drip near the ceiling. Tate found the gap, resealed it, and noticed the cap was loose from the same storm. Both fixed in one trip. Very thorough.",
          "name": "Devon S.",
          "date": "2024-03-22",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "The fireplace in the house we just bought was disgusting, black firebox and a smoke-stained surround. Vern treated it like a project, scrubbing the brick, vacuuming the ash, and cleaning the glass doors until everything sparkled. He walked me through a written report on what he found. Couldn't be happier with how new it looks now.",
          "name": "Bianca L.",
          "date": "2025-10-03",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Genuinely the cleanest service call I've had. Plastic sheeting around the fireplace, runners on the floor, and shoe covers. Not one fleck of creosote escaped.",
          "name": "Damon V.",
          "date": "2023-11-18",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Two contractors told me my chimney was beyond repair and needed full reconstruction. I wanted a third opinion before signing anything. Wade came out, did a meticulous inspection of the flue liner and firebox, and calmly explained the structure was completely sound. The real problem? A cracked crown and heavy soot. He fixed both same day at a tenth of the rebuild cost.",
          "name": "Gunnar S.",
          "date": "2025-07-26",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Wyatt did our annual chimney service and I was impressed by how methodical he was. He vacuumed the firebox, brushed the flue from the roof, and showed me a photo of a small crack forming in the crown. He never pressured me on the repair, just laid out the options and the cost. Drop cloths everywhere, shoe covers on, and a written report emailed before he even left the driveway. Top-notch.",
          "name": "Delphine A.",
          "date": "2025-05-27",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Cole was great. He cleaned the burner, swapped a corroded thermocouple, and made sure the flame sensor held the valve open reliably. The pilot used to drop out constantly and now it's rock solid.",
          "name": "Octavia L.",
          "date": "2024-03-28",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Honestly didn't expect the chimney to be that dirty, but after twelve years it makes sense. Dale pulled out bags of soot and creosote. Quick, clean, friendly.",
          "name": "Yolanda F.",
          "date": "2026-03-04",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Same-day cleaning saved us when we smelled a strong creosote odor. Aiden showed up that afternoon, swept the insert flue, and verified the stainless liner was intact. Fast and reassuring.",
          "name": "Omar S.",
          "date": "2024-10-11",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Heard flapping in the chimney and called these folks in a bit of a panic. Beau came out, found a trapped bird and an old nest, and carefully removed both. He then ran a full inspection, swept the creosote, and installed a stainless cap to prevent it happening again. What impressed me most was how he protected my hearth with drop cloths and cleaned every speck before leaving. Genuinely kind people.",
          "name": "Quentin L.",
          "date": "2025-02-13",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Straightforward pre-purchase chimney inspection. Tech checked the firebox, liner, and cap, then sent a written report by email within a day. No upselling, just facts. Appreciated the honesty about what needed attention and what could wait.",
          "name": "Trevor S.",
          "date": "2023-11-12",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Needed a rush clean before the in-laws visited for the holidays. Scheduler found a same-day opening. Swept the flue and checked the damper operation. Straightforward and honest.",
          "name": "Frederick A.",
          "date": "2023-12-18",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Persistent smoky smell in an unused fireplace. Caleb found the previous owner had never had it swept, so the flue was caked with creosote that absorbed moisture and smelled. A deep cleaning and a new chimney cap to stop rain intrusion completely fixed it.",
          "name": "Nasir J.",
          "date": "2024-03-26",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "After three other companies tried to scare us into a full rebuild, these guys came out, did a proper inspection, and said all we really needed was a relining. Saved us thousands. Dewey was honest, thorough, and clearly took pride in the work. The insulated stainless liner he installed has our wood stove drafting beautifully. This is what an honest family-owned outfit looks like.",
          "name": "Mireille D.",
          "date": "2025-04-27",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We schedule our chimney maintenance every September without fail, and Smith and Sons has handled it for the past five years. Earl came out this time, laid drop cloths across the hearth, and removed a fair bit of creosote since we burn often. The before and after photos make it easy to see the difference. Wouldn't trust anyone else with it.",
          "name": "Beatrice H.",
          "date": "2025-09-16",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Bank required a chimney inspection before our mortgage would clear. Floyd handled it efficiently, scanned the flue with a camera, checked for creosote and structural cracks, and produced a written report formatted exactly how the lender wanted. Saved us a real headache.",
          "name": "Nathaniel F.",
          "date": "2025-07-26",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "New fireplace owner, knew nothing. The tech swept it, checked the damper, and taught me how to do the dollar-bill test for the seal. Patient and friendly. Easy first experience.",
          "name": "Vikram J.",
          "date": "2024-06-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Trust matters most to me at 79. Gus earned it. He removed creosote, checked the cap and crown, and gave me a plain written report instead of a sales pitch.",
          "name": "Beatrice F.",
          "date": "2025-08-23",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Smoke smell lingered for weeks after our last fire. Hank inspected and found the damper wasn't sealing, letting odors and downdrafts in. New damper installed, flue swept, and he even vacuumed up around the hearth. Great attention to detail.",
          "name": "Rashad C.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Fast and friendly. Ash bin emptied, firebox brushed, glass doors wiped down. Our living room fireplace is ready for the season and looks brand new.",
          "name": "Delphine G.",
          "date": "2024-11-27",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Our first ever chimney sweep on a house we've had since 2009. Ira was upfront that there was a heavy buildup of creosote and a bit of debris in the flue. He cleaned the whole liner, inspected the crown and cap, and gave us a written report with recommendations. Never felt rushed and he answered all my questions. The fireplace finally smells normal and we can use it without worrying.",
          "name": "Frederick A.",
          "date": "2024-05-14",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Jed arrived right on schedule and got straight to work on the air ducts. He sealed off each vent, ran the negative-air machine, and agitated the buildup loose from the trunk lines. The collection bag was full of gray dust by the end. House smells cleaner already.",
          "name": "Desmond A.",
          "date": "2024-12-12",
          "service": "Air Duct Service",
          "rating": 4.8
        },
        {
          "review": "Phoned the office for a chimney inspection and they suggested adding the dryer vent since they'd already be out. Knox disconnected the duct, ran a brush kit the full distance to the wall hood, and reconnected everything snug. My dryer cycle time dropped noticeably. Smart bundle.",
          "name": "Felix O.",
          "date": "2024-10-29",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Glad I called. Levi cleaned a heavily sooted chimney in under an hour, checked the damper, and rolled up his drop cloths without leaving a trace.",
          "name": "Fatima J.",
          "date": "2025-05-13",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "We've leaned on this family business for our yearly chimney cleaning since we bought the place. Murphy is the tech we usually get and he's fantastic. This time he removed a stubborn layer of glazed creosote from the upper flue, vacuumed the hearth spotless, and inspected the crown from the roof. He showed me photos of the clean flue when he finished and answered all my questions about how often we should burn before the next sweep. Trustworthy and thorough every single year.",
          "name": "Adaeze N.",
          "date": "2025-08-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "My neighbor's enthusiastic recommendation sealed it for me. The technician was prompt and wore shoe covers. Swept the flue, checked the damper, and answered all my questions patiently.",
          "name": "Bridget H.",
          "date": "2025-03-22",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Cannot overstate how nice it is to have a sweep AND a repair handled in one go. Ned brushed out the creosote, then patched the crown and resealed the cap where water had been getting in. He carried everything he needed on the truck, so there was no rescheduling. On time and tidy from start to finish.",
          "name": "Megan S.",
          "date": "2024-10-29",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Smoke was backing into the bedroom above the fireplace and three other companies just shrugged. Otis brought a proper level-2 camera and traced the issue to a small gap where the flue tiles had separated, allowing smoke into an interior wall. Watching the live feed, I could see it plainly. He recommended a relining, walked me through the cost, and never once pushed. The thoroughness was a relief after months of guessing.",
          "name": "Carmen O.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Impressed by how upfront everyone was. The office quoted a fair flat fee for the sweep with no obligation to book. When Pete found a bit of extra creosote glazing, he explained my options without pushing the priciest one. The invoice matched the quote. No upsell whatsoever, and that builds trust.",
          "name": "Mariana S.",
          "date": "2025-05-22",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Roy was great. Swept the chimney, showed me before and after photos, and was honest that the flue liner had a few more good years left. Friendly and trustworthy.",
          "name": "Roland F.",
          "date": "2024-08-27",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "After a brutal winter the brick on our 1930s chimney started spalling and shedding chips. The scheduler got someone out within two days. Silas diagnosed water intrusion through failed mortar, repointed the upper section, replaced four bricks, and rebuilt a crumbling crown. He waterproofed once it cured. Everything documented in a written report with photos. Genuinely careful craftsmanship.",
          "name": "Yasmin D.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Wind ripped the cap off and the crown was crumbling at the edges. Tate sealed the crown, set a heavy-duty stainless cap, and waterproofed the masonry to keep the storm water out next time. No leaks since.",
          "name": "Quentin S.",
          "date": "2023-05-19",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Vern did a thorough gas fireplace safety check for us. He cleaned the soot buildup, tested the gas pressure, verified the thermocouple and pilot were healthy, and confirmed the flue was drawing properly on our vented unit. Patient with all my questions about carbon monoxide and gave me a written summary. Felt completely confident lighting it that evening.",
          "name": "Larissa P.",
          "date": "2026-05-07",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "After years of skipping inspections we finally booked one. Wade ran the scope and found a cracked flue tile right at the throat that was a genuine fire hazard. The before and after photos in the report were eye opening. Grateful he caught it.",
          "name": "Walter P.",
          "date": "2024-03-21",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "First-rate work on a leaky chimney. Wyatt diagnosed the cracked crown right away, did a proper repair with a poured cap and overhang, then waterproofed the whole stack. He walked me through the written report and answered every question. This is a family business that clearly takes pride in what they do.",
          "name": "Felicia W.",
          "date": "2025-11-12",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "New homeowner, first fireplace, lots of questions. Cole answered all of them while sweeping and inspecting. Loved that he showed me the damper operation and explained the written report instead of just handing it over.",
          "name": "Garrett F.",
          "date": "2025-01-21",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "A family of birds had turned our flue into an apartment complex. Dale carefully removed the nest, cleaned the creosote buildup that had accumulated, and installed a new stainless cap with a spark arrestor. He took before and after photos and walked me through each one. Couldn't be happier with how it turned out.",
          "name": "Genevieve O.",
          "date": "2025-07-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "What a difference a proper liner makes. Our wood stove never drafted right and we kept getting smoke in the room. Aiden inspected with a camera, found the original liner was the wrong size and partially collapsed, and recommended an insulated stainless reline. After the install the stove drafts beautifully and burns cleaner. He cleaned out heavy creosote first and showed me how much came out. Family-run outfit that clearly takes pride in the work. Photos and a written report included.",
          "name": "Celeste G.",
          "date": "2026-04-08",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Months of dust and old ash had built up in our seldom-used fireplace, and with winter coming we wanted it usable again. The tech vacuumed everything out, cleaned the burner assembly on our gas unit, and tested it for a steady flame. He covered the carpet with drop cloths and wore shoe covers the entire time. We finally enjoyed a cozy fire that evening with no smoky smell at all.",
          "name": "Harold V.",
          "date": "2025-11-25",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Decades of experience really shows. Beau was here for the chimney cap install and I asked about the dryer vent on a whim. He pulled the dryer out, disconnected everything, and ran a brush through a duct that hadn't been touched in fifteen years. The amount of lint was alarming. Reconnected it all neatly and tested the airflow at the exterior hood. Honest pricing for the add-on and zero pressure.",
          "name": "Camille O.",
          "date": "2025-12-09",
          "service": "Dryer Service",
          "rating": 4.8
        },
        {
          "review": "Tidy and quick. Drop cloths down, insert swept, liner inspected, soot vacuumed, gone in 50 minutes. Caleb was polite and wore shoe covers the whole time.",
          "name": "Renata C.",
          "date": "2024-08-14",
          "service": "Chimney Service",
          "rating": 4.8
        },
        {
          "review": "Firebox went from grimy to gorgeous. Dewey cleaned out years of ash, scrubbed the back wall, and adjusted the damper. He explained each step and showed me photos when he finished.",
          "name": "Theo G.",
          "date": "2025-04-12",
          "service": "Fireplaces Service",
          "rating": 4.8
        },
        {
          "review": "Long-time customer here. Earl ran the brush down the flue, pulled out the usual creosote, and double-checked the liner. Fast and friendly, written report as always.",
          "name": "Reginald A.",
          "date": "2025-09-25",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "With a hard freeze coming and guests arriving for the holidays, I needed the chimney cleaned immediately. The scheduler bumped me up and Floyd came out within a few hours. He did a meticulous sweep, brushed the smoke shelf, inspected the damper, and handed me a written report. Booties on, drop cloths everywhere, and not a speck of soot left behind. Decades of experience really show.",
          "name": "Angela W.",
          "date": "2024-11-27",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Booked a routine sweep before the holidays since we host a lot of fires in December. Gus showed up promptly, was courteous, and clearly meticulous about keeping the house clean with drop cloths and a vacuum at the ready. He cleared the creosote, checked the damper and smoke shelf, and verified the cap was still seated properly after a windy autumn. Took the time to point out that we were burning well-seasoned wood, which keeps buildup down. The written report was clear and arrived quickly. No drama, no upsell, just a job done right by someone who knows chimneys. We'll keep this on the calendar every year.",
          "name": "Delphine W.",
          "date": "2024-11-21",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Impressed start to finish. Our damper rattled and let rain into the firebox. Hank climbed up, checked the cap, and determined the damper needed full replacement. He fit a top-mount damper with a rubber seal that keeps both weather and drafts out. Drop cloths down the whole time and the firebox was spotless when he left. Honest crew with decades of know-how.",
          "name": "Clarissa H.",
          "date": "2026-03-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Decades of experience clearly showed. Ira spotted that our crown had a structural crack, not just a surface one, and that the rusted cap had been letting water freeze inside the masonry. He rebuilt the crown properly, sealed it, capped it with stainless, and waterproofed everything. He left a written report and answered all my questions without rushing.",
          "name": "Barrett N.",
          "date": "2025-07-17",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "After a sweep, the tech noticed our damper wasn't seating right and warm air was escaping nonstop. Jed explained that the seal had degraded and the metal was pitted. He installed a top-mount damper with a built-in cap to keep rain and critters out too. Lever operation is effortless. The whole house holds heat better now and the draft is gone. Very pleased with the attention to detail.",
          "name": "Tamara J.",
          "date": "2026-05-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Brick faces flaking off and open mortar joints near the cap. Knox repointed, replaced the worst units, and resealed the crown. Same-day for the minor portion, scheduled the rest fast.",
          "name": "Dominic A.",
          "date": "2026-02-27",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "After a tornado warning night with brutal winds, I wanted peace of mind. The tech did a full top-to-bottom look, found the crown chipped and the cap mount loosened, and repaired everything that afternoon. He even showed me how to spot future flashing trouble myself. Appreciated the time he took to explain.",
          "name": "Harriet L.",
          "date": "2025-06-05",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Impressive transformation. The firebox was solid black and now you can see the brick pattern again. Levi also pointed out worn firebrick that needed attention.",
          "name": "Octavia D.",
          "date": "2024-02-27",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Murphy was thorough and tidy. Before touching anything he put down two drop cloths and covered the hearth in plastic. The dual vacuum setup meant no dust drifted into the room while he brushed the flue. He left the firebox swept clean and even tidied the ash from the grate. No soot anywhere.",
          "name": "Felicia G.",
          "date": "2025-07-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Got talked into thinking I needed a costly rebuild elsewhere. Ned inspected mine top to bottom, found the masonry healthy, and showed me the damper was the actual issue. Cleaned the flue and was gone in an afternoon. Fair and honest.",
          "name": "Lacey F.",
          "date": "2023-05-12",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Otis swept the chimney for us and was courteous from start to finish. Pointed out the worn damper and explained how it was leaking heat. No upsell, just facts.",
          "name": "Bertram L.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Booked a pre-season tune-up for the gas logs. Pete vacuumed years of dust from the firebox, cleaned the ceramic logs, and reset them to the manufacturer's layout to prevent sooting. He tested CO output with the burner running for ten minutes and it stayed at zero. Walked me through operating the wall switch and the manual override. Felt like an honest, knowledgeable visit and the price matched the quote.",
          "name": "Graham V.",
          "date": "2025-08-21",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "My husband and I finally got around to having our chimney swept after far too long. The tech found the flue liner coated in glazed creosote and explained why that's the dangerous kind. He worked carefully, kept the room clean with drop cloths, and handed us a detailed report afterward. We appreciated the education as much as the cleaning itself.",
          "name": "Henrietta L.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Decades of experience really come through with this crew. Roy cleaned our wood stove liner, explained the difference between stage one and stage three creosote, and showed me the glaze forming higher up. He recommended a hotter burn routine to manage it. The firebox and glass were spotless when he left and not a speck of soot on the hearth tile.",
          "name": "Carmen V.",
          "date": "2025-03-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Wasp and bird debris had built up at the top of our flue. Silas cleared everything out, double-checked the liner for damage, and fitted a new stainless steel cap. Honest pricing and he walked me through the before and after photos on his phone.",
          "name": "Adaeze N.",
          "date": "2024-09-26",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "We were nervous about the chimney on a 1920s bungalow we wanted to buy. Tate spent time photographing the crown cracks and showing us creosote in the flue on his camera screen. The written report was easy to follow and even ranked items by urgency. That document made our negotiation simple and gave us peace of mind.",
          "name": "Lakshmi V.",
          "date": "2025-04-29",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Bitter cold and our only heat source was the wood stove, so a clogged flue was a real emergency. Phoned at 8am and Vern was here by 11. He worked through a stubborn creosote glaze, checked the liner for cracks, and confirmed the cap was secure against the wind. Patient, thorough, and kind enough to explain everything to my elderly mother who was nervous about the whole thing. We made it through the freeze warm and safe.",
          "name": "Yolanda B.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Smoke rolled into the room on startup every single time. The technician raised the issue of a too-short flue not building enough draft, but first he cleaned out a substantial creosote blockage near the top. That alone made a huge difference. He measured everything and gave honest options.",
          "name": "Delphine C.",
          "date": "2025-05-09",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Relined the chimney for our oil furnace. Quick scheduling through the office, fair pricing, and the tech walked the whole thing with me when he was done. Stainless liner, new connector, sealed up properly. No complaints at all.",
          "name": "Garrett H.",
          "date": "2024-04-14",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Reliable year after year. Wade swept ours and checked the cap and crown. Quick same-day fix on a loose flashing piece too. Four years and counting.",
          "name": "Octavio G.",
          "date": "2024-04-03",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Thorough pre-purchase evaluation. The crew checked the crown, the stainless cap, the flashing, and ran a camera the full height of the flue. They found water intrusion that the listing never mentioned and documented it all in a detailed written report. Wyatt took time to explain everything in plain language so two non-handy people could understand it. We renegotiated thanks to that report.",
          "name": "Oksana V.",
          "date": "2024-04-11",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Our first home came with a fireplace none of us knew how to maintain. Cole spent ages with us, swept the flue, pointed out early creosote, and gently explained the whole maintenance routine. He even showed my teenage son how to safely open and close the damper. Laid drop cloths everywhere and cleaned up perfectly. Such a patient teacher, we all learned a ton.",
          "name": "Colette A.",
          "date": "2026-05-02",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "What a relief to deal with folks who don't talk down to seniors. The scheduler was patient on the phone and the technician, Dale, was the same in person. He swept the chimney, cleaned the firebox, and showed me the before and after photos of the creosote so I could see the difference. He even waited while I found my glasses to read the report. Truly gentle service.",
          "name": "Agnes L.",
          "date": "2026-04-11",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "We could never figure out why the upstairs smelled like a campfire. Aiden ran the diagnosis and found the chimney cap was missing entirely, so wind was forcing smoke and odor back down. He installed a stainless cap and cleaned the flue. Problem solved in one visit, very reasonable.",
          "name": "Yvette D.",
          "date": "2024-08-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "After a chimney smell kept creeping into the den, I finally booked a fireplace cleaning. Beau traced it to creosote built up on the smoke shelf and gave the whole firebox a deep clean. The odor is gone and the first fire of the season was glorious. He wore shoe covers and left zero mess. Couldn't ask for better.",
          "name": "Sebastian O.",
          "date": "2025-11-04",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Put this off way too long. The tech found years of accumulated soot and a creosote layer thick enough to flake off in chunks. Cleaned it all, checked the cap, no mess left behind.",
          "name": "Margarita V.",
          "date": "2025-07-22",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Honestly didn't expect such a difference. After Caleb cleaned the return vents and supply ducts, the air in the bedrooms feels lighter and my husband's snoring from congestion has improved. Drop cloths everywhere, very clean work.",
          "name": "Felicia D.",
          "date": "2025-05-29",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Dewey did our annual sweep and offered the dryer vent cleaning as an extra. He found the exterior vent cover almost completely blocked, cleared it, and tested the flap movement. The burning smell when we ran the dryer is gone. Reasonable price for the peace of mind.",
          "name": "Margaret H.",
          "date": "2026-04-15",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Family business that does honest work. Swept the flue, brushed the smoke shelf, and handed me a written report. No mess, no hassle, same-day appointment.",
          "name": "Brody V.",
          "date": "2024-02-18",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Punctual and professional. Earl swept the flue, removed a good amount of creosote, and pointed out that our stainless cap had some leaf debris he cleared while up top. Clean work, honest report, no surprises on the bill.",
          "name": "Lawrence V.",
          "date": "2024-10-29",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Got the number from a neighbor who'd been using them for ages. Floyd showed up, swept the chimney, and found heavy creosote glaze near the top of the flue. He explained the fire risk clearly and cleaned it without trying to upsell me on anything. Honest crew. The drop cloths and vacuum meant zero mess afterward, which my wife especially appreciated.",
          "name": "Rashid F.",
          "date": "2024-10-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Prompt and professional. Gus showed up first thing, swept the flue, and tightened the loose damper in the same appointment. Quick written report handed to me afterward.",
          "name": "Oliver R.",
          "date": "2026-04-02",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Camera caught a hairline flue crack our last sweep missed entirely. Worth every penny for the peace of mind and the photo documentation.",
          "name": "Vincent H.",
          "date": "2023-10-26",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Hank came out, gave me a free no-obligation estimate, and broke down exactly what the cleaning included. He noticed the stainless cap was loose and tightened it without charging extra. Fair pricing the whole way through, and not a single add-on slipped onto the bill. Genuinely refreshing.",
          "name": "Cornelius J.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Calling Smith and Sons was the best decision. Ira did the sweep, was personable the entire visit, and pointed out a minor crown crack without making it sound like an emergency. He gave me a fair price to fix it whenever I was ready. Honest from start to finish.",
          "name": "Bianca H.",
          "date": "2025-07-04",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Repointed and replaced spalled brick on our old chimney. Jed matched the mortar color and tooled the joints to match. Looks like it was always there. Very satisfied.",
          "name": "Conrad H.",
          "date": "2024-09-03",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Excellent follow-up after storm season. We'd noticed efflorescence and water marks on the chimney brick, so I had them out to check things. Knox inspected and found the flashing had lifted and the crown had a few cracks letting moisture in. He resealed the flashing, patched the crown, and applied a waterproofing treatment to the brick. Took before and after photos and emailed a clear report. The whole crew was respectful of our property and explained the why behind every step. Couldn't ask for more.",
          "name": "Beatrice L.",
          "date": "2026-04-08",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Pilot light wouldn't stay lit on our gas logs. Levi diagnosed a failing thermocouple, cleaned the pilot assembly, and replaced the part from his truck the same day. Also realigned the logs and tested for leaks. Fast and fair.",
          "name": "Nathaniel C.",
          "date": "2025-01-22",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "A draft problem turned out to be more than a draft problem. The camera inspection revealed debris lodged above the smoke shelf and a small gap in the liner. Murphy cleared the blockage, documented the crack, and laid out a clear plan. The written report with the video stills made it easy to understand exactly what we were dealing with.",
          "name": "Felicia G.",
          "date": "2025-10-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Water in the firebox after rain. Ned found the flue had no cap and the crown was crumbling. New cap and crown repair, plus waterproofing. Solid.",
          "name": "Curtis A.",
          "date": "2023-12-04",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Patient is the word that keeps coming to mind. We had never owned a fireplace and Otis treated our questions like they mattered. He swept the chimney, showed us the creosote on his brush, and explained the importance of seasoned firewood and proper draft. He went over the inspection findings about our crown and cap and even texted me a couple of the before and after photos afterward. The kind of family business that earns lifelong customers by actually teaching you.",
          "name": "Lucia D.",
          "date": "2024-02-13",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "We had debris and an old nest blocking the flue and smoke was backing into the room. Pete figured it out quickly, cleared the obstruction, swept everything, and topped the chimney with a stainless steel cap. Friendly and didn't track a speck of soot through the house thanks to the shoe covers and drop cloths.",
          "name": "Quentin H.",
          "date": "2024-04-08",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Quick turnaround on a flue reline. Roy had the truck fully stocked so he did the whole stainless install same week. Cap and top plate look great.",
          "name": "Desmond A.",
          "date": "2023-07-21",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Pleasantly surprised by how thorough the cleaning was. Silas removed ash, scrubbed creosote from the firebox, and wiped the glass doors until they gleamed. Took his time and made sure the damper sealed properly before leaving. Our living room is set for cozy winter evenings and the whole experience was painless from booking to finish.",
          "name": "Gwendolyn M.",
          "date": "2025-09-15",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Tate took care of the dryer vent cleaning during our scheduled fireplace service. Found a flattened section of flex hose restricting airflow and replaced it. Clothes actually come out dry now.",
          "name": "Bradley S.",
          "date": "2024-02-27",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "After buying a house with an existing wood stove, I had no idea when it was last serviced. The technician ran a full camera inspection of the liner, found moderate creosote and a slightly rusted cap, and walked me through everything. Cleaned it thoroughly and replaced the cap with a stainless one from the truck. Now I have peace of mind heading into colder months. Excellent communication start to finish.",
          "name": "Tobias N.",
          "date": "2025-11-29",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "What a transformation. Our masonry firebox was dark and dingy, with crumbling mortar and a sooty grate. Vern spent the afternoon hand-cleaning the firebrick, re-mortaring the joints, and clearing the smoke shelf above the damper. He brought a fully stocked truck so he had every brick and tool right there. Covered our hardwood with drop cloths and vacuumed up after himself. The firebox honestly looks like it was just built. So pleased.",
          "name": "Naomi C.",
          "date": "2023-11-29",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "After fifteen winters of wood fires I know what a good sweep looks like, and Wade delivered. He covered the whole path with drop cloths, brushed the flue from the top down, vacuumed every bit of creosote out of the smoke chamber, and showed me photos before and after. The chimney draws beautifully now. Friendly father-and-sons operation that has earned my repeat business.",
          "name": "Clementine H.",
          "date": "2026-05-14",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Snowstorm in the forecast and our chimney hadn't been swept since we bought the house. Wyatt squeezed us in same day, cleared a serious creosote layer, and pointed out the stainless cap was loose. Tightened it right then from his truck. Couldn't ask for faster service.",
          "name": "Brandon J.",
          "date": "2025-12-11",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "We noticed staining on the wall near the chimney breast and feared the worst. Cole investigated thoroughly and traced it to water intrusion from a failing crown and lifted flashing at the roofline. He explained exactly how moisture was getting in and recommended sealing the crown plus waterproofing the masonry. While he was up there he also swept the flue, which had a fair amount of creosote. The whole job was done carefully, with a written report and photos of the damaged crown so I understood what I was paying for. Months later there's been no new staining through the rainy season. Genuinely competent work and fair pricing.",
          "name": "Quentin F.",
          "date": "2025-04-14",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Phoned about a fireplace that wouldn't stop drawing cold air. The tech traced it to a damper that wasn't latching shut. New gasket and adjusted the plate so it now seals flush against the frame. Simple fix, fair price, no pressure to do anything extra.",
          "name": "Patrick N.",
          "date": "2024-07-02",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Rusted cap replaced with stainless and the cracked crown sealed up. Dale was tidy and quick, used drop cloths, and the rain leak in the attic stopped right away.",
          "name": "Faye O.",
          "date": "2023-09-29",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Stainless top-sealing damper installed to replace a useless throat damper. Aiden handled it efficiently, showed me the rubber gasket seal up close, and ran the cable down neatly along the firebox. Airtight now.",
          "name": "Devin P.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Our 1935 chimney had spalling brick on two faces and mortar you could crumble with a fingernail. Beau was patient explaining freeze-thaw damage and why patching wouldn't cut it. The crew tuckpointed the entire visible stack, replaced about eighteen spalled bricks with a careful color match, rebuilt the top courses, and poured a new crown with a proper drip edge. They protected the roof with tarps and cleaned every speck of dust. The written report had before and after photos that made me confident it was done right.",
          "name": "Imani O.",
          "date": "2025-10-05",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Wind storm peeled back the flashing on one side. Caleb resealed it, replaced two screws on the cap, and sealed a small crown crack. Quick same-day fix, very reasonable.",
          "name": "Omar V.",
          "date": "2024-12-11",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Booked a firebox cleaning after our annual sweep and it was worth it. Dewey scraped off the heavy creosote, cleaned the refractory panels, and the whole thing looks refreshed. Took care to lay drop cloths and clean up after. Will use them again next season.",
          "name": "Lamar G.",
          "date": "2025-03-14",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Booties, drop cloths, and a sealed cover over the opening, just like they promised on the phone. The tech swept decades of creosote out of the flue and somehow my white tile hearth stayed white. Vacuumed everything before leaving. Couldn't ask for cleaner.",
          "name": "Oscar D.",
          "date": "2024-04-03",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Cannot recommend an inspection here enough. A larger company quoted me $11,000 to tear down and rebuild my chimney, claiming it was unsafe. Earl arrived, put down drop cloths, ran a camera up the flue, and walked me through photo after photo of perfectly intact brick and liner. The only thing wrong was a missing stainless cap and a little creosote. He capped it, swept it, and saved me a fortune. Genuinely good people.",
          "name": "Omar V.",
          "date": "2026-04-30",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Floyd came out for the cleaning and was a delight. Stainless cap was rusted through and he had a replacement on the truck. Photos before and after.",
          "name": "Suki N.",
          "date": "2026-02-03",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Quick and competent. Tech cleaned the burner ports, tested the gas line for leaks, and confirmed the damper was vented before lighting. In and out in 45 minutes.",
          "name": "Delphine C.",
          "date": "2023-10-16",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Gus came out to clean a chimney we'd ignored since buying the place over a decade ago. The amount of buildup was honestly a little scary, but he handled it like a pro and left zero mess thanks to the shoe covers and tarps.",
          "name": "Vincent H.",
          "date": "2024-06-13",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Solid liner inspection on our insert. The tech scoped the full run, confirmed no cracks, swept out the buildup, and tested the damper. Tidy and professional, no complaints.",
          "name": "Nathaniel P.",
          "date": "2024-05-26",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Smoke smell and a blocked draft turned out to be a squirrel's nest wedged in the flue. Hank removed it, swept the chimney, and capped the top with stainless. Quick, friendly, and fairly priced.",
          "name": "Garrett W.",
          "date": "2023-05-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Inspection before purchase went well. Found a missing chimney cap and some water staining inside. Report had clear photos and an estimate. Fair and professional.",
          "name": "Quentin A.",
          "date": "2024-05-08",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Day before our big holiday party, smoke kept rolling back into the room. Same-day emergency visit. Ira diagnosed a creosote-restricted flue and a half-closed damper, cleaned it all out, and we had a flawless fire for the guests. Saved the night.",
          "name": "Nathaniel D.",
          "date": "2024-12-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Downdraft brought a strong smoke odor into our bedroom directly above the fireplace. Jed spotted that the flue extended only a few inches above the roof peak, breaking the 3-2-10 rule. He extended it and capped it, and the downdraft disappeared. Fair price for solving something two other companies couldn't even diagnose.",
          "name": "Quentin A.",
          "date": "2024-08-02",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Smoke was backing up and the inspection showed a partially collapsed flue. Knox explained that a reline was the right fix and got it scheduled fast. The new stainless liner made a huge difference. He also pointed out some loose flashing and gave me a referral, no pressure.",
          "name": "Lucinda E.",
          "date": "2023-05-06",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "What started as a one-time cleaning turned into a yearly tradition. The crew shows up, lays down their drop cloths, swaps in fresh shoe covers, and works through the flue and firebox methodically. This year Levi measured the creosote thickness and showed me it was well within safe range. They leave a detailed written report each visit so I can track everything over the years. Genuinely the most dependable contractor I've dealt with.",
          "name": "Fatima A.",
          "date": "2026-03-12",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Got a written chimney report before listing my house. Murphy was professional, found a small crown crack and recommended waterproofing, photographed it all. Quick turnaround and fair pricing for the inspection.",
          "name": "Travis G.",
          "date": "2023-05-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Never had a fireplace until this winter. Ned came out, did the sweep, and walked me through the stainless cap and why mine needed a screen to keep critters out. Took his time, no jargon, just clear patient explanations. Booked my next inspection on the spot.",
          "name": "Reuben G.",
          "date": "2025-01-16",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Otis came out and treated my mother's home like his own. He used drop cloths, swept the flue, and explained the damper situation slowly so she'd understand. Patient with an 88-year-old's questions.",
          "name": "Dorothy V.",
          "date": "2024-06-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Reached out about a downdraft that made the house reek of soot. Pete showed up the same afternoon, ran a smoke pencil test, and pinpointed that our two-story chimney had a clearance problem with the roof peak next door. Recommended an extension and cap. Meanwhile he swept out all the creosote. Honest, no upselling, just real solutions and a clear written estimate.",
          "name": "Bjorn A.",
          "date": "2025-07-08",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Roy came out and did exactly what we needed. Cleared the ash, scrubbed the firebox, and cleaned the glass doors. Punctual and polite. We're cozy and set for the cold months now.",
          "name": "Mirabel A.",
          "date": "2024-12-30",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Inherited my grandmother's house and the chimney clearly hadn't been serviced in twenty-plus years. Silas was incredible, methodical and respectful of the old masonry. He removed a frightening amount of buildup, ran a camera to check the flue liner condition, and documented a couple of areas to keep an eye on. No hard sell, just honest advice. The whole crew wore shoe covers and kept the antique rugs covered.",
          "name": "Theodore J.",
          "date": "2024-10-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked the air duct cleaning after a long winter of running the furnace nonstop. Tate and the crew were efficient, courteous, and thorough, hitting every register and the main return. They showed me how much soot and dust had collected near the air handler. Great communication from the office about arrival time too.",
          "name": "Anatoly S.",
          "date": "2024-08-07",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Vern was efficient and friendly. Cleaned the flue then snaked the dryer vent, pulling lint from a long run that went up through the attic. He capped it off by testing exhaust at the roof hood. Dryer is performing like new again.",
          "name": "Ivan Z.",
          "date": "2025-05-21",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Wade was professional and fast. Creosote was thick and he cleared it all, then vacuumed the hearth twice. Spotless when he left. Highly recommend.",
          "name": "Naomi G.",
          "date": "2025-09-04",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Routine spring sweep after a long burning season. Wyatt brushed the entire flue, scraped out the creosote near the smoke shelf, and laid drop cloths so my carpet stayed clean. He gave me a written summary and noted the liner looked great. Friendly and efficient.",
          "name": "Sofia G.",
          "date": "2026-05-02",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Two of my neighbors independently told me to call Smith and Sons, so I figured they had to be good. They were. Cole swept the flue and inspected the masonry joints around the crown. Clean, professional, on time.",
          "name": "Carmen D.",
          "date": "2025-12-15",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Decades of experience really shows. The tech arrived right on schedule, cleaned a badly clogged flue, then repaired the crumbling crown with fresh mortar before he left. Two jobs, one visit, fair price. He laid drop cloths over my hearth rug and vacuumed up every bit of soot.",
          "name": "Carmen V.",
          "date": "2025-05-22",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Dale did a camera inspection before we sold the house. Hidden in the flue was a buildup of glazed creosote in a section that's nearly impossible to reach with a brush. He flagged it, showed me the before footage, did a specialized cleaning, and re-scanned to prove it was clear. The buyer's inspector had zero complaints. Professional from the first phone call with the office.",
          "name": "Lydia P.",
          "date": "2025-05-17",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Quoted fair, charged fair. Aiden swept the flue, vacuumed the firebox, and showed me the creosote he pulled out. No attempt to sell me a liner or crown repair I didn't need. The free estimate was honest and the final number didn't budge.",
          "name": "Imani G.",
          "date": "2024-08-21",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Beau cleaned our chimney and was just a likable, honest guy. He explained the creosote levels, swept everything into the vacuum, and didn't leave a mess. Told me my cap was fine when I half expected an upsell.",
          "name": "Garrett V.",
          "date": "2024-02-19",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Where do I start. Our 1915 house has an enormous brick chimney that was spalling and shedding mortar onto the porch roof. Caleb and the crew set up staging, raked out yards of failed joints, repointed with the correct soft mortar, replaced more than a dozen spalled bricks, and resurfaced the crown. They covered the roof and shrubs with drop cloths and hauled away every bit of debris. The written report explained each step.",
          "name": "Lucia N.",
          "date": "2025-07-30",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Storm bent our cap sideways. Dewey came out, straightened the situation with a brand-new cap, and confirmed the flashing was still sound. Fast, friendly, fairly priced.",
          "name": "Omar J.",
          "date": "2024-03-11",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Phenomenal service from this family business. Earl prepped our gas fireplace top to bottom, cleaning the burner, checking the venting, and adjusting the logs so the flame looked realistic again. He tested every gas fitting with leak detector solution and walked me through what to watch for. The whole hearth was protected with drop cloths and he left no mess behind. Trustworthy and skilled.",
          "name": "Sasha H.",
          "date": "2024-12-29",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Very professional outfit. Floyd used the level-2 camera and found water staining and a deteriorating liner joint about ten feet up. Pointed out the failing flashing too. Detailed photos in the report.",
          "name": "Omar J.",
          "date": "2026-01-18",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Impressed from the first phone call. The scheduler got someone out the next morning to look at the water coming through our chimney chase. Gus inspected the crown, cap, and flashing thoroughly, then walked me through photos showing the crown had separated from the flue tile. He sealed the gap, rebuilt the crown, fitted a new cap, and waterproofed the brick. Detailed invoice with everything itemized. No more leaks.",
          "name": "Sandra E.",
          "date": "2024-09-21",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Our first fireplace and we wanted to do it right from day one. Booked a sweep and the tech turned it into a friendly lesson on creosote, dampers, and how to build a fire that draws clean. No condescension, just helpful. Highly recommend for nervous beginners.",
          "name": "Nolan H.",
          "date": "2025-07-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Stainless cap was missing so naturally birds nested. Hank removed it all and installed a proper capped guard. Great job.",
          "name": "Tamara L.",
          "date": "2025-10-02",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Excellent experience having our chimney relined. The terra cotta was spalling badly and chunks were falling into the firebox. Ira brought a camera up to show me, then walked me through the stainless steel insulated liner he recommended. Install was neat, floors protected, and he resealed the crown and installed a new stainless cap to keep rain out. The new liner draws so much better now.",
          "name": "Yvonne C.",
          "date": "2025-02-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Winter prep done right. Jed cleaned our fireplace firebox, cleared the ash, and inspected the damper, all while keeping the area covered with drop cloths. Cozy and ready now.",
          "name": "Trevor A.",
          "date": "2024-12-14",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Outstanding service. The crew came out for our masonry waterproofing and I added the dryer vent cleaning. Knox worked the line from the lint trap all the way to the roof termination, vacuumed the cavity behind the dryer, and showed me a fistful of lint that could have caught fire. He wore shoe covers the whole time and cleaned up every speck. Same-day add-on with no upcharge for the trip since they were already here. Couldn't be happier.",
          "name": "Delphine C.",
          "date": "2026-04-16",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Levi did a great job on our wood-burning insert. Heavy creosote near the throat got brushed out, the liner checked clean on camera, and he even cleaned the glass and reset the air controls. Worth every penny.",
          "name": "Maribel A.",
          "date": "2024-04-27",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Decent firebox cleanup. The tech cleared the creosote and ash, cleaned the glass doors, and tested the damper. Fireplace looks much fresher now.",
          "name": "Ravi S.",
          "date": "2026-02-17",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Yearly maintenance sweep. Tech cleared the creosote, checked the stainless cap, and was done in under an hour. No fuss, no upsell.",
          "name": "Osvaldo J.",
          "date": "2024-04-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Emergency call right before the holidays paid off. Murphy arrived quickly, found a blockage, and cleared the flue so we could safely use the fireplace for Christmas morning. Friendly and efficient.",
          "name": "Lena O.",
          "date": "2024-12-22",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "First-time homeowner here, totally clueless about chimney maintenance. Ned was incredibly patient walking me through the whole thing. He inspected with a camera, showed me a moderate creosote layer, and explained how often I should schedule sweeps based on how much we burn. The cleaning itself was quick and tidy, shoe covers on, drop cloths down, not a mess anywhere. He checked the damper and found it sticking, then freed it up at no extra charge. I felt educated rather than sold to, which made a huge difference. Detailed report by email afterward. For someone new to all this, the experience couldn't have gone better.",
          "name": "Saoirse D.",
          "date": "2026-05-12",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Our damper handle was so rusty it crumbled in my hand. Otis replaced the entire mechanism, including a new poker control and a fresh gasket seal. He tested it open and closed several times to be sure it latched tight. Warm house, no more whistling drafts, and he vacuumed up every speck of rust before leaving. Genuinely good people.",
          "name": "Yolanda E.",
          "date": "2025-08-24",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Spalling brick and a leaking chimney sent me searching for a specialist. Pete explained that a cracked crown and missing cap had let water saturate the masonry for years. They repaired the crown, installed a new cap, and waterproofed the stack to stop further freeze-thaw damage. Thorough inspection with photos and a fair, itemized estimate.",
          "name": "Octavia J.",
          "date": "2026-05-12",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Honestly didn't know a leaky damper could waste so much heat until Smith and Sons explained it. Our old one wouldn't fully close, so the furnace ran constantly. Roy replaced it with a new cast iron damper that meets the seat perfectly and added a gasket strip. He even checked the smoke shelf for creosote while he was in there. Tidy, knowledgeable, and the room feels totally different now.",
          "name": "Lourdes G.",
          "date": "2024-12-04",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Repointing on a deteriorated brick chimney from the 1940s. Silas did the grinding and tuckpointing himself and was clearly experienced. Joints look crisp and tight now.",
          "name": "Barnaby C.",
          "date": "2023-05-30",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "We had water spots showing up on the ceiling after weeks of storms, and I was convinced the roof was failing. Turns out it was the chimney crown and a section of flashing that had separated. Tate rebuilt the crown, applied waterproofing, resealed the flashing, and fitted a new stainless cap. He documented all of it with photos and a written report. Professional, courteous, and didn't try to sell me anything I didn't need.",
          "name": "Gwendolyn A.",
          "date": "2026-01-17",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Couldn't believe the before and after. Our firebox brick went from sooty gray to clean red, and the glass doors are spotless again.",
          "name": "Freya N.",
          "date": "2026-04-09",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Vern took real care with my floors. Long runner from the entry, shoe covers, and a tarp under the entire work area. He ran the brush down the liner and the vacuum picked up all the loosened soot. Wiped the glass doors clean afterward too. Spotless result.",
          "name": "Tamara J.",
          "date": "2025-10-22",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Skeptical after a rebuild quote, I asked these folks to double-check. Wade found the crown cracked but the structure solid. Sealed the crown, swept the flue, done. No rebuild needed and a written report to back it up.",
          "name": "Tabitha N.",
          "date": "2024-09-22",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Wyatt earned my trust immediately. He spent extra time on a stubborn creosote buildup near the smoke chamber and refused to call it done until the flue was spotless. Walked me through the inspection report line by line. The kind of careful, courteous work that makes you want to recommend a company to neighbors.",
          "name": "Octavia F.",
          "date": "2025-03-18",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "After moving in we weren't sure the gas fireplace had ever been serviced. Cole inspected the venting, cleaned the burner and logs, leak-tested every fitting, and checked carbon monoxide levels with the unit on. He found the glowing ember material was packed into the ports and cleared it so the flames burn blue-free now. Thorough, friendly, and explained everything in plain language.",
          "name": "Roland H.",
          "date": "2026-04-09",
          "service": "Fireplaces Service",
          "rating": 4.7
        },
        {
          "review": "Twenty years without a sweep. I'm not proud of it. Dale arrived, assessed the heavy creosote and soot, and got to work without judgment. He scraped the flue down, vacuumed everything, checked the damper, and snapped photos so I could see the difference. Peace of mind at last.",
          "name": "Genevieve O.",
          "date": "2025-08-09",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "What stood out was how careful they were with our floors. Aiden spread drop cloths from the door to the stove, slipped on shoe covers, and swept the liner without a trace of mess. He inspected the cap and crown from the roof and sent over photos of everything. The creosote he pulled out was alarming but he handled it cleanly. Great experience start to finish.",
          "name": "Yolanda G.",
          "date": "2026-03-07",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Months of bird activity left a nest and a layer of debris in our chimney. Beau arrived on time, removed all the material, and showed me how the old cap had rusted through and let everything in. He installed a heavy-duty stainless cap and explained the warranty. Clean, courteous, and clearly knows the trade inside and out.",
          "name": "Lucia P.",
          "date": "2026-05-10",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Phenomenal pre-sale inspection. Caleb arrived on time, put down drop cloths, and methodically went through the damper, smoke chamber, and flue liner with a camera. He found that a previous owner had patched the crown improperly. The written report documented everything with timestamped photos, which our buyers' agent accepted without question. The whole transaction moved faster because of it.",
          "name": "Octavia H.",
          "date": "2025-08-16",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "With a snowstorm forecast and relatives coming, I needed the chimney swept immediately. The office got me on the schedule that very day. Dewey arrived, put down drop cloths, swept out a thick creosote buildup, and pointed out some loose crown mortar I should address in spring. He wasn't pushy about the repair, just informative. Fireplace burned clean all weekend.",
          "name": "Camille O.",
          "date": "2025-12-11",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Smelled like a bonfire in the family room for weeks. Earl came out, ran a pressure test, and found a cracked flue liner letting smoke seep into the masonry and back into the room. He documented it with before and after photos, swept the creosote, and walked me through a liner repair plan. No pressure to decide on the spot. Honest, tidy, and clearly experienced. The decades of know-how really showed.",
          "name": "Harriet S.",
          "date": "2026-05-18",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Top notch liner installation. Floyd and his partner pulled the old broken tiles, vacuumed out all the debris and creosote, then ran a new insulated stainless liner and finished with a proper cap. Written report and photos emailed the same evening. Trucks were stocked so everything happened in one trip. Highly recommend for anyone dealing with an aging chimney.",
          "name": "Ezekiel A.",
          "date": "2025-10-29",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Annual sweep, seventh winter with them. Gus brushed out the liner, checked the damper seal, and confirmed the cap was in good shape. In and out in under an hour with zero mess.",
          "name": "Lionel C.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "What a relief to work with people who actually know chimneys. We were buying a century-old house and the seller's disclosure was vague. Hank did a meticulous inspection, found a deteriorated liner and missing cap, and the written report was the most professional document I received during the entire transaction. Numbered findings, clear photos, repair priorities. We used it to get the seller to install a new liner before closing.",
          "name": "Delphine S.",
          "date": "2025-10-07",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "As a first-time fireplace owner I had a million questions and Ira answered every single one. He swept the chimney, inspected the crown and flue, and then sat down to explain a year-round maintenance plan. He warned me about burning pine and the creosote it leaves behind. Genuinely the most patient service tech I've ever dealt with. We left the visit feeling confident instead of confused.",
          "name": "Imani O.",
          "date": "2024-10-28",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Gentle as can be. After my stroke I'm slow getting around, and Jed never once made me feel rushed. He cleaned out the creosote, inspected the liner, and walked me through the photos at my own pace.",
          "name": "Raymond G.",
          "date": "2025-02-14",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Smoke rolling back into the room every time we lit up. Knox found the flue completely choked with creosote and debris. After a thorough sweep the draft was strong again. He laid drop cloths everywhere and left no mess.",
          "name": "Camila N.",
          "date": "2023-11-27",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Top-notch from the first phone call. The scheduler was kind and got me in quickly. Levi arrived, draped drop cloths over the hearth and floor, and methodically cleaned the firebox, brushed the throat, and removed years of soot. He showed me before and after photos and pointed out a small spot of worn mortar to keep an eye on. The fireplace looks and smells fresh, and our first winter fire was perfect. These folks know their craft.",
          "name": "Genevieve S.",
          "date": "2026-01-22",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Eight years, no cleaning, lesson learned. Murphy showed up same day and got that creosote out fast. Fair price, friendly crew, and a job done right the first time — no complaints at all.",
          "name": "Lucia H.",
          "date": "2026-03-15",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Clean, fast, professional. Ned cleaned all the supply ducts and returns, bagged the debris, and left no mess. The stale smell is gone and the airflow seems stronger.",
          "name": "Marguerite H.",
          "date": "2023-06-14",
          "service": "Air Duct Service",
          "rating": 4.7
        },
        {
          "review": "Appreciated that they could do the dryer vent the same day as the chimney work. The tech put down drop cloths, vacuumed the lint trap cavity, and ran a rotary brush the full length of the duct. Showed me a clear before and after photo on his phone. Dryer dries in one cycle now.",
          "name": "Sofia C.",
          "date": "2024-06-11",
          "service": "Dryer Service",
          "rating": 4.7
        },
        {
          "review": "Easy scheduling and a clean sweep. The crew protected my floors, swept the flue, and checked the stainless cap. Out in 40 minutes with no soot anywhere.",
          "name": "Xavier L.",
          "date": "2026-02-10",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Thirty years burning wood and these are the most careful sweeps I've had. Otis covered the floor, swept the flue top to bottom, and pulled out a heavy creosote accumulation. He bagged every bit of it and left the firebox immaculate. Damper checked, cap checked, written report in hand. Decades of experience really shows in how methodical he is.",
          "name": "Theodore A.",
          "date": "2025-01-15",
          "service": "Chimney Service",
          "rating": 4.7
        },
        {
          "review": "Recommended by a neighbor who'd had a great experience. Pete did the sweep and showed me the stainless cap had bird debris packed in it. Cleared it out and the draft improved immediately.",
          "name": "Julius E.",
          "date": "2024-06-07",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Same-day appointment honored exactly as promised. Roy cleaned out heavy creosote and replaced a corroded cap in one visit. Friendly, fast, and no surprises on the invoice.",
          "name": "Derek J.",
          "date": "2024-02-18",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Heard scratching in the chimney and assumed animals. Silas's camera revealed an old steel insert had partially detached and was rattling, plus a cracked liner tile behind it. He sorted both, gave us a clear report with images, and explained the safety angle without dramatics. Trustworthy people.",
          "name": "Ezra C.",
          "date": "2024-12-11",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "You can tell a company by what they don't try to sell you. Tate inspected the chimney for free, said the masonry was in great shape, and only billed for the sweep. No invented crown problems, no scare tactics. The price was fair and the work was thorough. This is how it should be done.",
          "name": "Ravi C.",
          "date": "2025-10-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Three generations of this family clearly know chimneys. Vern did our sweep and his honesty stood out immediately. When I mentioned a competitor told me I needed a full liner replacement, Vern inspected it carefully and showed me with the camera that the liner was perfectly sound. Saved me thousands. Personable, patient, and the kind of tradesman you wish all of them were.",
          "name": "Delphine A.",
          "date": "2025-10-16",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Old chimney had open mortar joints letting water in. Wade repointed the bad areas and replaced a spalled brick at the corner. Fast and fairly priced.",
          "name": "Felix O.",
          "date": "2023-03-19",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "We had water coming in around the firebox after a string of storms. Wyatt traced it to failed flashing and a cracked crown. He resealed the flashing, repaired the crown, and double-checked the cap was secure. Professional from start to finish and the written report made our insurance claim painless.",
          "name": "Genevieve A.",
          "date": "2025-09-04",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Had the gas logs serviced before our first cold snap. Cole cleaned the burner tray, vacuumed the firebox, and checked the damper clamp so the vent stays open during operation. Flame ignites instantly now. Clean, professional work.",
          "name": "Damon E.",
          "date": "2026-02-03",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Our home inspector flagged the chimney during a sale, so we called for a level-2 camera inspection. Dale threaded the scope the full height and discovered a hidden crack in the liner plus moisture intrusion near the crown that the basic visual missed entirely. He gave us an unbiased written report with photos that we used in negotiations. The whole crew was courteous, wore shoe covers, and left zero mess. Could not have asked for more.",
          "name": "Veronica L.",
          "date": "2024-08-27",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "The old galvanized cap had rusted into a mess and water was running down the flue liner. Aiden replaced it with a heavy stainless cap and sealed the cracked crown. He even cleaned up the rust stains on the brick face. Great attention to detail.",
          "name": "Vincent O.",
          "date": "2025-03-29",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Just learning how to maintain our new fireplace and these folks made it painless. Beau swept the flue, checked the liner with his camera, and patiently explained what I should watch for between annual cleanings. He showed me where creosote tends to collect and how to tell if my wood is dry enough. Felt like learning from a trusted relative rather than a salesman.",
          "name": "Samira E.",
          "date": "2024-04-18",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Impressed start to finish. Discovered a nest blocking nearly the entire flue during a routine cleaning, and Caleb handled it without missing a beat. He removed the nest, vacuumed the debris, swept the creosote, and installed a stainless cap so it won't happen again. Licensed, insured, and left a detailed written report on the table.",
          "name": "Desmond F.",
          "date": "2024-12-05",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Honest assessment and great work. Dewey relined the flue, insulated it, and replaced a rusted cap with a stainless one. No mess, fair price, on schedule.",
          "name": "Theo J.",
          "date": "2024-08-13",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Decided it was finally time to use the fireplace this winter instead of letting it sit. Earl came out, vacuumed the firebox, scraped off layers of creosote, and cleaned the glass that had gone completely cloudy. He explained how to season firewood properly so we get less buildup next time. The crew is clearly experienced and they left the room cleaner than they found it. First fire was warm and smoke-free.",
          "name": "Estelle C.",
          "date": "2026-01-27",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Glad the truck was stocked for dryer vents too. Floyd cleared ours during the chimney clean and the laundry room is no longer a sauna. Fair, fast, family business.",
          "name": "Quentin L.",
          "date": "2025-02-11",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Solid sweep and liner check on the wood stove. Tech showed me a thin layer of creosote on the camera and cleared it. Quick, fair, no nonsense.",
          "name": "Damon P.",
          "date": "2023-11-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Phoned the office and got a same-day slot, which was a relief with company coming. Gus arrived, taped plastic over the surround, and got to work on the firebox. He scrubbed off the black soot, replaced two damaged firebricks, and cleaned the damper assembly. The inside of the fireplace now looks like a showroom. Friendly guy, careful with our home, and the price was exactly what the scheduler quoted.",
          "name": "Beatrix O.",
          "date": "2024-10-22",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Counting on this crew for the annual cleaning has become a fall tradition. Hank arrived right on schedule, brushed out a heavy season of creosote, vacuumed the firebox, and pointed out where a little water staining was starting near the crown so I'd know to watch it. Honest advice, neat work, fair price. Same great folks every year.",
          "name": "Bridget L.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Temperature plummeted and we hadn't planned ahead. I expected to be told no, but the office had Ira out the same day. He swept the chimney, removed a hefty amount of creosote, examined the crown, and noted some minor waterproofing he recommended for spring. No pressure, just honest advice. We stayed warm all weekend thanks to him.",
          "name": "Patrick C.",
          "date": "2026-02-04",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Reached out after our home inspector flagged the chimney during a refinance. Jed came out the same week, did a comprehensive inspection, and produced a written report detailed enough to satisfy the lender. He found creosote buildup and a minor liner gap, swept the whole flue, and documented everything with photos. He was upfront that the liner gap was minor and gave me a clear, no-pressure estimate for sealing it later. Everything was handled professionally and the paperwork was exactly what I needed. The office coordinated the timing perfectly around my closing. Reliable, prompt, and clearly experienced with the documentation side of things too.",
          "name": "Lucinda G.",
          "date": "2024-08-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Top-sealing damper installed to replace a failed throat unit. Seals beautifully and the cable operation is easy. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Brennan W.",
          "date": "2024-03-18",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Big crack in the crown, cap rusted to nothing, and water running down the flue liner. Knox and Knox rebuilt the crown, fitted a stainless cap, re-sealed the flashing against the shingles, and waterproofed the brick. Two heavy rainstorms later and not a drop inside. Couldn't be happier with the crew.",
          "name": "Reginald C.",
          "date": "2024-12-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Damper replacement done right. Old plate was warped and rattling in the wind. New one seats flush and seals tight. Tech was on time and cleaned up the firebox after.",
          "name": "Chad E.",
          "date": "2025-10-11",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Spalling brick on the chimney of a home pushing 100 years old. Levi inspected it thoroughly, showed me where water had gotten behind the brick, and laid out a repair plan that didn't involve tearing the whole thing down. They replaced damaged bricks, repointed, rebuilt the crown, and applied a breathable waterproofer. Communication from the office was excellent and the masons were polite and tidy. The new work matches so well I had to point it out to my husband.",
          "name": "Saoirse V.",
          "date": "2024-12-09",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Storm blew debris into the flue and knocked the cap askew. Murphy cleared it out, reseated the cap, and inspected the crown and flashing for storm damage. Clean, friendly, fast.",
          "name": "Pablo C.",
          "date": "2025-02-28",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Ned arrived right on time and got straight to work on our neglected fireplace. He cleaned the firebox, scrubbed the smoke stains off the brick, and serviced the damper that had been stuck for ages. The makeover made the whole hearth look like new again, and he was friendly the entire visit. A genuinely good local company.",
          "name": "Imani B.",
          "date": "2025-05-30",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Quick sweep and not a speck left behind. Drop cloth down, booties on, vacuum running. Flue is clean and so is my carpet.",
          "name": "Gerald S.",
          "date": "2023-06-27",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Family-owned and it shows in how they treat you. After another company tried to scare me into a full chimney rebuild, Otis came out, inspected the liner and crown, and honestly told me nothing structural was wrong. Heavy creosote and a loose cap were the only issues. He cleaned everything, secured the cap, and charged a reasonable rate. Refreshing to deal with people who won't sell you what you don't need.",
          "name": "Reuben C.",
          "date": "2025-11-17",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Pete swept our flue and was incredibly neat about it. Drop cloths, shoe covers, the works. He spotted minor spalling on the brick and gave me an honest timeline for when it would need masonry attention. Friendly the entire visit.",
          "name": "Marcus E.",
          "date": "2024-06-25",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Our gas logs were producing black soot on the back wall. Roy figured out the logs had shifted out of position and were impinging the flame. He repositioned them correctly, cleaned the firebox, and the sooting stopped completely. Sharp diagnostic work.",
          "name": "Maxine F.",
          "date": "2024-12-19",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Quick and thorough. Hadn't cleaned the chimney in ages and Silas cleared out years of creosote in about an hour. Loved the before and after photos.",
          "name": "Solomon J.",
          "date": "2026-04-21",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Wood-burning insert needed a sweep and the liner checked after years of use. Tate was punctual, methodical, and clearly knew his stuff. Found moderate creosote and a slightly loose cap, both addressed on the spot. Fair pricing too.",
          "name": "Frederick A.",
          "date": "2025-08-30",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Birds nesting in the flue had us worried about a fire hazard. Vern cleared the obstruction, swept out the creosote, and put on a new stainless cap with a built-in spark arrestor. Efficient and respectful of the house.",
          "name": "Devin C.",
          "date": "2024-12-15",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Got a chimney inspection before buying a rental property. Wade checked the masonry, flashing, and waterproofing and noted a few hairline crown cracks. The written report helped me budget for repairs after closing. Solid, no-nonsense service.",
          "name": "Bashir O.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Freezing temps and a chimney that hadn't been cleaned since we moved in. They came same day. The crew swept the flue, vacuumed the firebox, and checked the stainless cap. Tidy work, fair price, fast turnaround.",
          "name": "Reginald H.",
          "date": "2024-01-19",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Bad draft meant smoke in the house every burn. Wyatt cleaned the flue and adjusted the damper opening. Better airflow immediately. Simple fix, fair cost.",
          "name": "Lionel V.",
          "date": "2023-07-14",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Bought a fixer-upper with a sketchy chimney. The crew relined it for our new high-efficiency furnace and made sure the liner was the correct diameter for the appliance output. Cole was meticulous and explained everything in plain language. Floors stayed clean thanks to the drop cloths.",
          "name": "Bronwyn S.",
          "date": "2026-02-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Loyal since they first came out to repair our crown years ago. Now they do our yearly cleaning and inspection. Dale handled this visit, removing creosote and double-checking the waterproofing held up through the rainy season. Consistent quality keeps us coming back every fall.",
          "name": "Wilhelmina E.",
          "date": "2023-10-15",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Same-day pre-sale inspection because our buyer added a contingency last minute. The scheduler was accommodating and Aiden arrived within a few hours. Checked the damper, flue, and crown, and emailed the written report that night. Smooth save.",
          "name": "Quincy E.",
          "date": "2026-02-23",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "First fireplace, no clue what I was doing. The crew swept it out, showed me the creosote they removed, and patiently explained how the flue draws smoke up. Tidy work with drop cloths. Made a nervous newbie feel at ease.",
          "name": "Hugo V.",
          "date": "2023-03-21",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Being widowed and in my late seventies, I'm cautious about strangers. This company put me at ease completely. Beau showed his credentials, explained he was part of a father-and-sons operation, and worked carefully. He swept the chimney, checked the stainless cap, and left a tidy written report on my counter. Patient, kind, and trustworthy.",
          "name": "Helen O.",
          "date": "2026-05-06",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "First class service. Our fireplace had a stubborn smoke smell and weak draft that two other companies couldn't figure out. Caleb took his time, ran a full camera inspection, and discovered a collapsed section of clay flue tile that was restricting airflow. He documented it all in a written report with before and after photos, then walked us through the relining process. The crew was meticulous, wore shoe covers, and cleaned up beautifully. Worth every penny.",
          "name": "Eamon G.",
          "date": "2025-09-13",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Solid work at a fair price. The crew swept the firebox, cleaned the glass, and checked the damper before declaring us winter-ready. Tidy and quick.",
          "name": "Augustus E.",
          "date": "2024-10-15",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "After avoiding it for nearly a decade, we got the chimney swept and I wish we'd done it sooner. Dewey explained the difference between the soft soot and the hardened creosote glaze near the top of the flue. He worked carefully, laid drop cloths the entire route, and bagged everything for disposal. The written inspection report was detailed and easy to understand.",
          "name": "Brennan C.",
          "date": "2025-01-29",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Renovating an older home meant a lot of dust got into the ductwork. Earl came out, sealed each vent, and ran his system through the whole house. He found a section of duct that had partially collapsed and flagged it for repair, showing me photos so I understood the issue. Appreciated his honesty rather than just quietly cleaning around the problem. The cleaning itself was top-notch and the air quality is much improved.",
          "name": "Octavia M.",
          "date": "2025-10-21",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Floyd noticed our dryer was running hot during the fireplace cleaning visit and recommended a vent cleaning. Glad he caught it. Pulled out years of compacted lint and reseated a duct joint that had pulled loose. Thorough and honest crew.",
          "name": "Theodore L.",
          "date": "2025-10-07",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Gus did a great job sweeping our chimney and explained the creosote rating clearly. Shoe covers on, drop cloths down, spotless finish. Fair price for solid work.",
          "name": "Heidi A.",
          "date": "2024-10-25",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Quick annual cleaning. Tech removed the creosote and tidied up after. No complaints, will use again. The technician was courteous, explained what he found, and left everything spotless.",
          "name": "Bianca L.",
          "date": "2024-04-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "After my neighbor mentioned how reliable they were, I booked a fall cleaning. The whole thing went smoothly from the friendly office staff to the tech who arrived right on schedule. Hank swept the chimney, brushed the smoke shelf, and checked the flue liner thoroughly. He laid drop cloths over my hardwood and vacuumed every speck of soot before packing up. Sent a written report with photos the same evening. This is how service should be done, and I'll be calling them every year now.",
          "name": "Naomi G.",
          "date": "2026-05-02",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "I called the office a little frantic because we were hosting that weekend, and they squeezed us in the same day. Ira swept the chimney, fixed a gap in the flashing, and resealed the crown in one efficient visit. He even pointed out a few photos of before and after so I could see the difference. Punctual, prepared, and genuinely kind.",
          "name": "Rebecca N.",
          "date": "2025-12-12",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Jed arrived right in the scheduled window, laid drop cloths, and ran a level-2 camera because our older home had never had a real inspection. The footage uncovered a section of unlined flue from a 1950s addition, completely hidden until you sent a camera up. He explained the carbon monoxide risk calmly, gave us a detailed written report, and outlined a lining plan. No scare tactics, just facts and great photos. So glad we called.",
          "name": "Giselle M.",
          "date": "2026-04-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Got a no-obligation quote in writing and the cleaning came in at exactly that. Knox was tidy with the drop cloths and explained the creosote level honestly. No upselling, just fair work at a fair price.",
          "name": "Delphine A.",
          "date": "2023-04-18",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Personable and prompt. Levi swept the flue, cleared the creosote, and walked me through the written report line by line. No upselling whatsoever.",
          "name": "Quincy M.",
          "date": "2023-12-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Noticed brick flakes on the ground and a few hollow-sounding bricks up top. Murphy inspected, found spalling from years of water sitting in cracked mortar, and recommended targeted tuckpointing rather than a full rebuild. He repointed, replaced the spalled brick, and sealed it. Appreciated that he didn't oversell. The repair blends in perfectly.",
          "name": "Greta W.",
          "date": "2026-04-17",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "A wicked nor'easter loosened our chimney cap and cracked the crown. Ned arrived on time, sealed the crown, replaced the cap with stainless, and resealed the flashing along the roofline. He explained that the freeze-thaw cycle would only widen those cracks if we waited, which made sense. Honest decades-of-experience advice. The leak we'd been chasing for weeks is finally gone.",
          "name": "Lorenzo M.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Our gas fireplace was making a soft popping sound that worried us. Otis traced it to debris in the burner ports and a slightly misaligned log blocking gas flow. He cleaned everything out, repositioned the logs, and tested the gas line for leaks. No more noise and the flame is even across the burner. Reassuring to have an expert confirm it was safe.",
          "name": "Belinda F.",
          "date": "2025-03-17",
          "service": "Fireplaces Service",
          "rating": 4.1
        },
        {
          "review": "Smelled gas-like fumes occasionally and got worried. Camera inspection found the flue liner had a breach where exhaust was leaking. The tech treated it seriously and got us scheduled fast. Real peace of mind.",
          "name": "Dale F.",
          "date": "2025-04-07",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Highly recommend these guys for chimney leaks. Pete caught a crown crack that two other companies missed, sealed it, replaced the missing cap, and waterproofed the masonry. The leak that had bugged us for two years is finally gone.",
          "name": "Della F.",
          "date": "2024-12-15",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "First-time fireplace owner and totally green about all of it. The technician swept the chimney, pointed out the damper, and walked me through the inspection report on the crown and cap. Patient and thorough with a complete beginner.",
          "name": "Brock T.",
          "date": "2025-11-02",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Birds had been a problem for two seasons. Roy pulled the nest, cleaned out the twigs and droppings, and put on a stainless mesh cap that finally keeps them out. Reasonable and respectful.",
          "name": "Yolanda C.",
          "date": "2025-02-21",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Top notch chimney relining job. We had converted to a high efficiency furnace and the old masonry flue was oversized and getting condensation damage. Silas explained the whole problem clearly, then sized and installed a proper liner so the venting would work safely with the new equipment. He sealed the top plate, added a rain cap, and gave me a thorough written report with photos. Crew was polite, wore shoe covers, and cleaned up every speck of debris. Genuinely impressed.",
          "name": "Larissa H.",
          "date": "2025-09-28",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Solid job cleaning our gas fireplace before the cold set in. Tate cleaned the logs, cleared the burner ports, and tested the pilot until the flame was steady. Friendly and efficient.",
          "name": "Omar J.",
          "date": "2025-10-22",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "They were out for the annual sweep and I had them clean the dryer vent as well. Vern brushed the entire rigid duct and found the exterior flap painted shut, which was trapping all the moisture inside. Freed it up, cleaned the hood, and now you can feel strong airflow outside when the dryer runs. Knowledgeable and tidy.",
          "name": "Brenda J.",
          "date": "2024-06-19",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Impressed by the thoroughness. Wade pulled our insert out, swept the connector pipe and the full liner, vacuumed the firebox, and inspected the welds on the stainless liner. He found everything in good condition but recommended a yearly check given how much we burn. Left a written report and photos by email that afternoon. Professional and respectful of the house.",
          "name": "Lucinda E.",
          "date": "2025-06-16",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Firebox restoration was worth every penny. Wyatt cleaned the firebrick, repointed a few joints, and cleared a thick creosote ridge near the throat. The hearth looks brand new and he left it spotless.",
          "name": "Cormac L.",
          "date": "2025-06-08",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Routine creosote removal before the cold set in. Cole was prompt, laid down cloths, and swept the flue clean. He showed me the damper was opening fully too. Reliable as ever.",
          "name": "Khalil D.",
          "date": "2023-11-28",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Last-minute before a deep freeze, and Dale came through. Quick sweep, checked the flue liner, and confirmed it was safe to burn. In and out, no mess, fair price.",
          "name": "Yvonne M.",
          "date": "2025-01-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Smelled a strong campfire odor in the house even when no fire was lit, which turned out to be old creosote absorbing humidity. Aiden explained the whole phenomenon, then did a deep sweep that pulled out a startling amount of buildup. He went further and applied a treatment to break down the glazed creosote near the smoke shelf that a standard brush wouldn't touch. The odor faded within days. He also inspected the cap and crown, finding both in good shape, and shared photos of the clean flue afterward. Knowledgeable, friendly, and clearly not the type to invent problems. Exactly the kind of service that keeps a family business thriving.",
          "name": "Octavia B.",
          "date": "2025-07-18",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Reached out after noticing soot stains and a draft around our closed fireplace. Beau inspected the throat and found the damper plate cracked. He installed a replacement with a tight gasket and verified the seal with a smoke test. Now the firebox holds heat and the cold drafts are gone. Clear written report explaining the issue and the fix.",
          "name": "Inez G.",
          "date": "2025-10-07",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Damp musty smell from the fireplace turned out to be a leak from a cracked crown. Caleb patched the crown, replaced the rusted cap with stainless, and waterproofed the exterior. He laid down drop cloths and vacuumed up before leaving. No more moisture smell.",
          "name": "Saoirse L.",
          "date": "2025-03-21",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Winter draft was unbearable. Dewey came out, found the damper gasket had rotted away and the plate no longer sealed, and fitted a top-sealing damper from the roof. He showed me before and after photos so I could see the new seal at the crown. Cold air is shut out completely and the fireplace finally feels efficient.",
          "name": "Anaya F.",
          "date": "2026-01-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Crown was cracked and the mortar joints were shot on our older brick stack. The crew rebuilt the crown, repointed the upper section, and replaced a few spalled bricks. Clean, square, professional masonry.",
          "name": "Thaddeus B.",
          "date": "2026-04-19",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Following last summer's hailstorm, the crown looked pitted and I worried about leaks. Earl came out, confirmed minor surface damage, sealed it preventively, and checked the flashing and cap. He laid drop cloths and wore shoe covers without being asked. Reasonable cost for the thoroughness.",
          "name": "Renata J.",
          "date": "2024-09-18",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Great firebox cleaning. Floyd got the creosote and soot off the brick and the fireplace looks like it belongs in a magazine now. Fast and clean.",
          "name": "Quentin H.",
          "date": "2024-10-19",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Family-run outfit and it shows in the care they take. Gus covered the hearth, the floor, and even draped a cloth over the nearby armchair before he started. The creosote and soot all went straight into the vacuum and a sealed bag. My living room was cleaner after than before. Truly no mess.",
          "name": "Wanda C.",
          "date": "2024-12-15",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Distrusted every chimney company after one quoted a $6,500 rebuild. Hank proved with his camera that my flue liner and masonry were both in good shape. The fix was a crown repair and a sweep. Done same day, spotless cleanup.",
          "name": "Anaya J.",
          "date": "2026-05-20",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Ira was our tech and he was terrific. Cleaned the firebox, brushed the flue, and reseated the damper that had been sticking for years. Left zero mess.",
          "name": "Imani C.",
          "date": "2025-12-12",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Annual gas fireplace prep. Jed checked the pilot assembly, cleaned the burner, tested the thermopile, and verified the venting was clear all the way up. Also wiped down the glass front and reseated the gasket. Came with a fully stocked truck so he had the parts on hand. Smooth visit start to finish.",
          "name": "Theo Q.",
          "date": "2025-01-30",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "After at least fifteen years of no maintenance, our chimney was in rough shape. Knox inspected first, showed us the thick creosote layer and a deteriorating section near the crown, then cleaned the entire flue. He was honest that we'd want to keep an eye on the crown but didn't pressure us. The fireplace draws so much better now.",
          "name": "Marguerite V.",
          "date": "2024-11-30",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Prompt and courteous service on our stove flue. Levi ran the camera up the liner and pointed out where moisture had been getting in near the top. He swept the creosote, cleaned the firebox, and gave us a written report with a clear photo of the damaged section. We knew exactly what we were dealing with.",
          "name": "Tabitha E.",
          "date": "2024-02-14",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "What a relief to have this handled properly. We'd had birds for two seasons and the previous company just shoved a screen on top that fell off. Murphy actually removed the entire compacted nest, ran a camera up to confirm the flue was clear, swept the liner, and bolted on a proper stainless steel cap. He documented it all in a written report. This is how it should be done.",
          "name": "Maribel Z.",
          "date": "2025-10-21",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Selling a home we'd owned for thirty years and wanted the chimney documented before listing. Ned scoped both flues, examined the stainless cap, and confirmed the liner was intact. He cleaned out the light creosote the same visit. The written report and before/after photos went straight into our disclosure file. Buyers loved seeing it up front.",
          "name": "Marguerite C.",
          "date": "2026-01-26",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Cold snap dropped us to single digits overnight and I desperately needed the fireplace usable. Called first thing and they prioritized me as an emergency. Otis came out, removed heavy creosote, cleared a small obstruction at the cap, and tested the draft before leaving. Professional from start to finish, and he never tracked a bit of soot through my house thanks to the shoe covers and drop cloths.",
          "name": "Sofia W.",
          "date": "2026-01-15",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "We dreaded lighting fires because of the smoke that always backed up. Pete did a complete workup, found the smoke chamber was rough and unparged which was choking the draft, and cleaned out years of creosote on top of that. He explained how a smoother smoke chamber improves draw. After the cleaning the fire lit and drafted perfectly on the first try. The office got us scheduled within two days.",
          "name": "Estelle G.",
          "date": "2025-12-19",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Liner had rusted through where the old water heater vented. They installed a new stainless liner and re-capped the top. Roy was friendly and efficient, in and out the same day with minimal fuss. Good value.",
          "name": "Thaddeus G.",
          "date": "2024-12-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Eight years a customer and still impressed. The technician swept the flue, inspected the smoke chamber, and noted the stainless liner is aging well. Written report in hand before he left. Family-run outfit that actually values long-term clients.",
          "name": "Hassan M.",
          "date": "2024-09-25",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "We hired Smith and Sons for a pre-purchase chimney inspection and were thoroughly impressed. Silas ran a camera up the entire flue, showed us the footage of creosote and a hairline liner crack, and answered every question we had. The written report arrived the next day with annotated photos. Decades of experience clearly show in how carefully they work. We felt fully informed before signing anything.",
          "name": "Brigitte M.",
          "date": "2024-12-15",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "We just became fireplace owners and were honestly overwhelmed. Tate was wonderfully patient, sweeping the chimney and then teaching me what a proper draft feels like and how to crack a window for airflow. He inspected the damper and flue liner and gave me a written report I could understand. No condescension, just kind guidance for two beginners.",
          "name": "Tabitha E.",
          "date": "2025-12-19",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Vern was a gentleman. Cleaned the flue, removed a surprising amount of creosote, and showed me each photo. Never pushy. At 82 I value that.",
          "name": "Arthur N.",
          "date": "2024-10-27",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Faint burnt smell whenever it rained. Wade explained moisture was getting through the cracked crown into the creosote. Sealed the crown, waterproofed the brick, and added a cap. Smell gone, very professional.",
          "name": "Noor J.",
          "date": "2024-02-14",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "We host the holidays and wanted the fireplace looking and working its best. Wyatt cleaned out a season of ash and creosote, polished the glass doors, and made sure the damper opened freely. He even showed my kids how the smoke shelf works, which they loved. The fire on Thanksgiving was warm and smoke-free. Genuinely friendly people who clearly care about doing things right.",
          "name": "Theodora V.",
          "date": "2025-11-18",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Honestly embarrassed how long it had been, well over ten years. Cole was reassuring and didn't make me feel bad about it. Heavy creosote buildup all cleaned out and the damper works again.",
          "name": "Selena G.",
          "date": "2025-09-11",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Dale did our air ducts and was an absolute professional. Every return vent and supply line got a proper cleaning, and he laid down drop cloths in each room. The written report he left documented the condition of each vent before and after.",
          "name": "Reginald V.",
          "date": "2024-03-26",
          "service": "Air Duct Service",
          "rating": 4.6
        },
        {
          "review": "Wonderful experience. Came for the cap install, left with a clean dryer vent too. Aiden was meticulous, even cleaning behind the dryer where lint had collected on the floor. Airflow at the exterior hood is strong again.",
          "name": "Carmen V.",
          "date": "2026-05-02",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Punctual and tidy. Tech swept the flue, inspected the damper, and showed me photos before he packed up. Quick same-day visit, no mess left behind.",
          "name": "Quinton D.",
          "date": "2025-12-16",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Booked our regular fall sweep and Beau handled it beautifully. He swept the flue, cleared a moderate creosote band, and checked the damper and cap. Drop cloths down the whole time and a clear written report at the end. Reasonable rate for the quality.",
          "name": "Malik J.",
          "date": "2025-11-26",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Neighbor's recommendation led me to these folks and I'm grateful. Quick sweep, clean firebox, no upsell. The tech even pointed out my damper was working fine and didn't need replacing despite what another company had told me.",
          "name": "Errol J.",
          "date": "2023-09-14",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Caleb got here exactly when scheduled. Brushed the liner, vacuumed the firebox, and tuned up a sticking damper all in the same stop. No second trip needed.",
          "name": "Tobias E.",
          "date": "2024-06-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Draft problems gone after the scan found mortar debris lodged in an offset. Quick, clean, and the tech showed me everything on the screen.",
          "name": "Roland S.",
          "date": "2023-07-08",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Three other companies wanted to upsell waterproofing before they'd even look at the flue. Smith and Sons sent Dewey for a free quote, did the straightforward sweep I asked for, and that was that. Creosote handled, cap checked, no pressure. Transparent pricing from start to finish made this an easy decision.",
          "name": "Fletcher M.",
          "date": "2026-05-11",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Warmest crew I've dealt with in years. Earl came out for the sweep, and while he worked we talked about how his dad started the business. He was honest that my damper needed a small adjustment but assured me it was a quick fix and didn't charge extra. Real people who care about their reputation.",
          "name": "Lorraine K.",
          "date": "2024-11-29",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Mortar on our 70-year-old chimney was practically dust in spots. Floyd repointed the entire exposed section, replaced two spalled bricks, and capped a small crack in the crown. Neat, respectful, and he texted photos of the finished work.",
          "name": "Omar J.",
          "date": "2024-12-28",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Storm-damage inspection turned up a loose cap and lifted flashing. Gus reseated the cap, sealed the flashing, and verified the crown was intact. Quick visit, clear pricing.",
          "name": "Imani O.",
          "date": "2024-05-28",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Excellent gas-log prep and safety inspection. Hank checked the pilot, cleaned the burner, and verified the oxygen depletion sensor functioned. Quick, courteous, and reasonably priced.",
          "name": "Ravi N.",
          "date": "2024-10-05",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Ira was fantastic. The scope camera picked up a section of crumbling mortar between liner tiles that was creating a gap. He explained why it mattered, showed me the footage, and the written report had clear photos and measurements. No upsell, just an honest assessment of a hidden issue we never knew existed.",
          "name": "Janelle H.",
          "date": "2025-06-23",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Storm knocked the cap loose and the next rain we had water inside. They came out quickly, secured a new cap, and inspected the crown which had a couple of cracks. Sealed those and applied waterproofing. The whole job was done same day and the price was exactly what was quoted on the phone.",
          "name": "Trevor N.",
          "date": "2026-02-18",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "We closed on our first house in March and the fireplace was the part I knew nothing about. Jed came out, did a careful sweep, and gave my husband and me a genuine education. He explained how creosote builds, why the flue liner matters, and how to use the damper to control airflow. He laid drop cloths and wore shoe covers without being asked. Before he left he handed us a written report and walked through every line, recommending we clean once a year going forward. For two people learning from scratch, this was exactly the patient guidance we hoped for.",
          "name": "Carmen O.",
          "date": "2026-04-15",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Called about scratching noises and they had Knox out the next morning. He found an old nest and a lot of fallen debris in the flue, cleared it completely, then capped the chimney with stainless steel. Patient with all my questions and showed me exactly what he removed.",
          "name": "Bradley E.",
          "date": "2025-08-30",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Solid reline on our 80 year old chimney. Levi showed me the cracked clay tiles on the camera, installed a stainless liner, and waterproofed the masonry. Good crew, clear pricing.",
          "name": "Omar N.",
          "date": "2024-04-05",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "We host a lot during the holidays so a clean, cozy fireplace matters to us. Murphy vacuumed years of ash, brushed the firebox and smoke shelf, and made the sooty glass doors crystal clear again. He was punctual, polite, and laid drop cloths from the door to the hearth. The room smells fresh and looks great for our winter gatherings. Couldn't be happier with the result.",
          "name": "Felicia B.",
          "date": "2024-11-29",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Asked about the dryer vent when they finished the flue liner work. Ned crawled behind the unit, disconnected the transition hose, and vacuumed out a startling amount of lint. Dry times cut nearly in half.",
          "name": "Ravi G.",
          "date": "2025-09-08",
          "service": "Dryer Service",
          "rating": 4.6
        },
        {
          "review": "Father-and-sons operation and you can tell they take pride in it. They swept our wood stove liner, checked for creosote glazing, and made sure the cap was secure. Honest folks who clearly know chimneys.",
          "name": "Reggie O.",
          "date": "2024-10-19",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Years of use had dulled and blackened the firebrick in our fireplace. Otis came out and gave it a proper makeover. He vacuumed the ash, hand-scrubbed every brick, sealed a small crack in the back panel, and cleaned the damper so it seals tight again. Photos before and after told the whole story. Looks brand new and smells fresh.",
          "name": "Fiona A.",
          "date": "2025-01-25",
          "service": "Fireplaces Service",
          "rating": 4.6
        },
        {
          "review": "Summer sweep so we're ready come fall. Pete cleared the creosote, vacuumed thoroughly, and noted the liner was in great shape for our older home. Eight years and still the only company I call.",
          "name": "Sigrid W.",
          "date": "2024-08-21",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Smelled smoke backing up the night a cold snap hit, and I knew we had a problem before the holidays. Roy was dispatched same afternoon. He discovered creosote glazing and a partially blocked flue, cleared it all, and walked me through before and after photos. Calm, professional, and clearly experienced. Highly recommend for anyone in a pinch.",
          "name": "Derek S.",
          "date": "2024-12-18",
          "service": "Chimney Service",
          "rating": 4.6
        },
        {
          "review": "Our rental property needed a chimney sweep between tenants and the office made coordinating access simple. Silas handled it and was professional throughout. He swept the flue, removed a good bit of creosote, and inspected the damper and liner, documenting everything for my records since I'm not local. The written report with photos was perfect for keeping the property compliant and giving new tenants peace of mind. He even noted the cap was slightly loose and re-secured it without an upcharge. Communication was clear from start to finish. As a landlord, having a dependable, honest crew I can send out sight-unseen is worth its weight in gold.",
          "name": "Thaddeus E.",
          "date": "2026-03-27",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Honestly thought we'd need a whole new chimney, but the problem was just a damper that no longer sealed. Tate reset the frame, fitted a new plate with a proper gasket, and showed me how snug it closed. Saved us a fortune and the room stays warm now. Quick, courteous, and clean.",
          "name": "Garrett D.",
          "date": "2026-05-12",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Rain had been sneaking in through a rusted cap and a hairline-cracked crown for at least a couple seasons, rotting the framing near the chase. Vern and Vern handled it start to finish: crown resurfaced with an overhang, new stainless cap, flashing re-sealed, and a full waterproofing coat on the masonry. They documented everything with before and after photos. Professional, friendly, and clearly experienced. The leak that haunted us for years is finally gone.",
          "name": "Hamza G.",
          "date": "2024-06-04",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "The damper in our 1950s chimney was seized shut. Wade freed it, but the cast iron was cracked, so he replaced the whole throat damper assembly. Walked me through pricing before any work started. Seals well and opens easily now. Appreciated the straightforward approach.",
          "name": "Roberto C.",
          "date": "2024-08-30",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "After a bad winter the brick on our 1922 chimney was actively spalling, with flakes landing in the gutters. Wyatt came out, identified that a previous waterproofing job had sealed moisture in, and walked me through the fix. His team stripped the bad sealant, replaced the spalled brick, tuckpointed the failed joints with a matched mortar, rebuilt two courses near the crown, and finished with a vapor-permeable sealer. Two full days of careful work, all debris removed, and a thorough written report with photos. This family-owned outfit clearly knows old masonry.",
          "name": "Lucinda E.",
          "date": "2025-03-16",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "High winds bent our cap and loosened the flashing. The crew straightened things out, resealed the flashing seam, and gave the crown a waterproof coat for good measure. They explained everything in plain language and emailed photos afterward. No mess left behind.",
          "name": "Stanley E.",
          "date": "2025-07-24",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "What a difference one visit made. The firebox was so coated in soot we couldn't tell what color the brick was. Cole cleaned it all out, polished the cast iron, and reconditioned the surround. Photos before and after were dramatic. He explained everything and answered all my questions patiently. The fireplace looks brand new and the living room feels brighter.",
          "name": "Sasha V.",
          "date": "2025-09-08",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Dale was a pro about cleanliness. He laid drop cloths, donned shoe covers, and sealed the firebox with a vacuum cover so soot stayed contained. Brushed the flue liner top to bottom, then vacuumed the hearth and wiped down the surround. The only sign he'd been there was the bag of creosote he hauled away.",
          "name": "Nathaniel A.",
          "date": "2025-09-08",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "One company swore my chimney was failing and pushed a full rebuild. Aiden from Smith and Sons came out, ran a thorough inspection, and showed me on his scope that the brick and flue were perfectly fine. Just needed creosote removed and the cap reseated. Honest assessment, photos to prove it, and a bill that didn't make me wince.",
          "name": "Bryce E.",
          "date": "2024-02-28",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Beau handled the sweep and inspection with real care. He photographed the inside of the flue liner so I could see the creosote glazing, explained why it forms, and gave practical advice on burning seasoned wood. Same-day appointment, fully stocked truck, and a written report. He even swept up a bit of old soot from a previous company's sloppy work. Genuinely good guy and a skilled technician.",
          "name": "Rosalind H.",
          "date": "2024-02-09",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Service tech tested the gas connection for leaks, cleaned the soot off the logs, and confirmed the oxygen depletion sensor functioned. Reassuring to know it's safe before we start using it again.",
          "name": "Bianca E.",
          "date": "2024-08-07",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Our scheduler got us in fast after I admitted it had been over a decade since our last sweep. Caleb found heavy buildup and a clogged cap. Cleaned it all out and the difference in airflow is remarkable.",
          "name": "Theodore G.",
          "date": "2025-05-17",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Best chimney crew we've used. Swept the wood stove liner, vacuumed every flake of creosote, and confirmed the stainless liner had no gaps. The technician even wiped down the stove glass before leaving.",
          "name": "Desmond C.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Dead branches and a bird nest were stopping the chimney from drawing. Dewey climbed up, cleared the lot, and capped it with stainless. Took about an hour and the fireplace works perfectly now.",
          "name": "Forrest E.",
          "date": "2024-04-07",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Pre-purchase inspection on a property with a tall brick chimney. The crew used a camera on the flue and flagged a deteriorating liner. Written report arrived promptly with photos. Helped me walk into closing informed.",
          "name": "Felix G.",
          "date": "2023-06-22",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Between Christmas and New Year's a hard freeze came and our flue was overdue. Got a same-day appointment, which surprised me for that week. Swept clean, damper checked, all good. Reasonable rate for the timing.",
          "name": "Quentin J.",
          "date": "2023-12-27",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Stale smoke odor every time it rained hard. The crew determined rain was hitting creosote in an uncapped flue and releasing the smell. Installed a stainless cap and swept the chimney. Odor problem solved and now rain stays out too.",
          "name": "Omar Z.",
          "date": "2024-11-21",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "What a relief to find a company that does relining right. Our 1920s chimney had original clay tiles that were basically powder. Earl and the team carefully removed them, poured insulation around a new stainless liner, rebuilt the crown, and topped it with a sturdy stainless cap. They protected every surface with drop cloths and shoe covers, gave me before-and-after photos, and a written report for our records. Outstanding from start to finish.",
          "name": "Imogen R.",
          "date": "2025-06-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our annual chimney service has been in the hands of Smith and Sons for as long as I can remember. Floyd arrived, covered the floors, and got into the flue to clear out the creosote that builds up over a season of regular fires. He flagged a small gap in the crown mortar and scheduled a follow-up to seal it. Trustworthy people who remember their repeat customers by name.",
          "name": "Genevieve T.",
          "date": "2026-04-18",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Inspection before buying a duplex. Gus looked at both chimneys, noted one had a sound crown and the other needed a new cap and crown repair. Written report broke it down unit by unit with photos. Made budgeting for repairs straightforward.",
          "name": "Hassan J.",
          "date": "2025-03-08",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "My wife and I are new to having a fireplace and Hank treated us with so much patience. He swept the flue, checked the cap, and explained step by step how to start and maintain a safe fire. Felt more like a friendly lesson than a service call.",
          "name": "Octavio M.",
          "date": "2024-04-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "My hands shake now and I can't manage much, so I rely on honest workers. Ira was exactly that. He swept the chimney gently, checked the crown for cracks, and didn't find any reason to upsell me. He explained everything twice without a trace of impatience and helped me sign the report. A genuinely kind young man from a fine family business.",
          "name": "Pearl E.",
          "date": "2025-10-30",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Downdraft issues every winter, the room would fill with smoke within minutes. Jed diagnosed it as a flue that was too cold to establish draft and showed me how to prime it, plus he installed an insulated liner. Also cleared a surprising amount of creosote. Genuinely impressed with his knowledge and patience answering all my questions.",
          "name": "Gerald U.",
          "date": "2026-03-07",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Knox was prompt and respectful of our home. He cleaned the fireplace firebox, vacuumed all the ash, and wiped down the doors. No upsell, just good honest work. Cozy nights guaranteed now.",
          "name": "Lysander J.",
          "date": "2025-02-09",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "We'd never had our flue cleaned in the fourteen years here. Levi ran the brush through and pulled out years of buildup along with a surprising amount of debris that had collected above the smoke shelf. He checked the stainless cap and confirmed it was intact. Friendly, fast, and left zero mess. Highly recommend for anyone overdue.",
          "name": "Olivier R.",
          "date": "2024-06-20",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Same-day availability saved us before a big family gathering. The tech cleaned all the registers and the main return in just over two hours. Shoe covers on, no dust left behind. Impressive.",
          "name": "Ingrid C.",
          "date": "2025-02-13",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Matter of fact and no nonsense. The tech cleared the dryer vent run after the sweep, found a partially crushed section behind the wall and flagged it for me to fix. Cleaned what he could reach and gave me a written note. Dryer heats better already.",
          "name": "Bryce W.",
          "date": "2024-11-23",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Years of buildup cleared in one short visit. Murphy brushed the flue, checked the cap, and vacuumed everything. Clean, courteous, and reasonably priced.",
          "name": "Marisol E.",
          "date": "2023-08-27",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Our annual creosote removal was handled with real care. Ned arrived on time, slipped on shoe covers, and ran his brush through the full flue length. He found more buildup than last year and showed me the difference in his before and after photos. The hearth was spotless when he left and the written report flagged nothing urgent. We've trusted this crew for years and they keep earning it.",
          "name": "Genevieve U.",
          "date": "2026-02-13",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "A friendly neighbor passed along the number after they did her chimney. Glad she did. Otis arrived with a stocked truck, swept the flue, and cleared out creosote that had built up over two seasons. He took before and after photos and walked me through the whole inspection. Polite, efficient, and tidy.",
          "name": "Sienna V.",
          "date": "2025-07-21",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Booked online and the scheduler confirmed a same-day slot. Pete swept out the creosote, replaced the chimney cap, and sealed a couple of small cracks in the crown without making me book a follow-up. Everything done in one efficient morning. Trucks are clearly stocked because he never had to leave for parts.",
          "name": "Whitney C.",
          "date": "2026-05-05",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "This family-owned outfit takes the camera inspection seriously. Roy spent a good while feeding the scope through every section, paused to highlight a corroded damper plate and a small flue breach, and recorded it all. The written report he emailed later had labeled images for each finding. We fixed the breach and the damper, and the difference in how the fireplace draws is night and day.",
          "name": "Anika J.",
          "date": "2025-08-23",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Fair and honest, two words I rarely use for contractors. The free estimate for the chimney sweep had no fine print, and Silas stuck to it even after spending extra time clearing stubborn creosote near the smoke shelf. Handed me a written report and no surprise fees. I've already recommended them to my sister.",
          "name": "Ophelia R.",
          "date": "2024-12-13",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Tate was fantastic. He swept the chimney, laid down drop cloths to protect the floors, and was upfront that I only needed a basic cleaning, not the full package the office mentioned. Honest and friendly.",
          "name": "Hassan T.",
          "date": "2025-06-23",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Tuckpointing job on an old brick chimney that had seen better days. Vern ground out the failing joints carefully, repointed, and replaced the spalled face brick near the top. He also pointed out the crown would need attention within a year and gave me a quote, no pressure. Drop cloths down, area swept clean. Trustworthy outfit.",
          "name": "Harriet E.",
          "date": "2025-04-05",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Hailstorm cracked our crown and dented the cap pretty badly. Wade came out the same day I called, sealed the crown, fitted a new cap, and checked the flashing for storm damage too. He showed me photos of the damage before and the repair after. No mess left behind and a fair bill. These guys clearly take pride in their work.",
          "name": "Frederick T.",
          "date": "2025-07-13",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "After a remodel we wanted our gas fireplace certified safe before using it. Wyatt inspected the gas connection behind the unit, cleaned the burner and logs, and confirmed the venting and damper were correct. He tested combustion and gave us a detailed written report. Knowledgeable, thorough, and respectful of our new floors with shoe covers and drop cloths the whole visit.",
          "name": "Colette J.",
          "date": "2026-01-28",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Excellent diagnostic work. The level-2 inspection found a blockage from fallen brick debris wedged in the flue. Cleared and re-scanned same day. Detailed photos provided.",
          "name": "Curtis M.",
          "date": "2026-03-02",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Wonderful experience start to finish. Cole arrived on time, showed me the spalling brick and the deteriorated crown that was letting water in, and explained my options without any pressure. He rebuilt the crown with a proper drip edge, fitted a new stainless cap with a spark screen, and applied two coats of waterproofing sealant. He left the work area cleaner than he found it. The detailed report with before-and-after photos was a nice touch.",
          "name": "Renata G.",
          "date": "2025-05-07",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Never used a fireplace until this house. Dale swept it, showed me the creosote he removed, and explained the stainless cap he installed to keep rain out of the flue. Took his time with a beginner and didn't rush off.",
          "name": "Felix J.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Nest and leaves were clogging our flue something terrible. The crew cleared the lot, swept down to the damper, and fitted a new stainless cap. Same-day service and very tidy.",
          "name": "Imani G.",
          "date": "2024-07-14",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Reached out after smelling smoke upstairs when we ran the fireplace. The crew found a breach in the flue liner during inspection. Aiden relined it with insulated stainless, resealed the crown, and fitted a new cap. He laid drop cloths and was meticulous about cleanup. The detailed report and photos gave us total confidence the chimney is safe to use again.",
          "name": "Bianca E.",
          "date": "2026-01-19",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Booked a fireplace cleaning to get ready for the season. Beau arrived right on schedule, removed all the ash, and scrubbed the firebox brick clean. Quick, neat, and no surprises on the bill.",
          "name": "Nathaniel P.",
          "date": "2025-10-05",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Tremendous experience from start to finish. Originally booked just the chimney inspection, but when the tech noticed our dryer exhaust looked neglected he offered to clean it while he was here. Caleb ran his brush through the full line, cleared the termination cap of lint and a small nest, and documented it all in a written report with before and after photos. The dryer no longer overheats and the burning smell is gone. Professional crew that clearly takes fire safety seriously.",
          "name": "Naomi E.",
          "date": "2026-05-01",
          "service": "Dryer Service",
          "rating": 4.1
        },
        {
          "review": "Dewey came out to clean our insert and inspect the liner before the season. He found a small amount of Stage 3 glazing that worried me, treated it, and brushed it out completely. The camera footage afterward showed a clean liner. He also checked the damper and confirmed it sealed properly. Took the time to answer all my questions about safe burning. Genuinely good experience.",
          "name": "Annika F.",
          "date": "2025-12-04",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Honestly thought we'd need a full rebuild. Instead the technician scrubbed the firebox, reset a couple of loose firebricks, and re-mortared the joints. Came out looking new and saved us a fortune.",
          "name": "Desmond H.",
          "date": "2024-07-19",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Decades in this house and these are the only people who've ever touched our chimney. The technician swept the full flue, pulled out the annual creosote, and checked the cap and crown from the roof. Written report every time. Shoe covers, drop cloths, the works. Couldn't be happier with such steady, careful service.",
          "name": "Marcellus G.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Right as winter slammed in, our fireplace stopped drawing well. Called and the team got Earl out within hours. He swept the chimney, freed up a sticky damper, and checked the cap for nesting. Saved us before the family arrived for the holidays.",
          "name": "Maria V.",
          "date": "2025-11-29",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Floyd came out for our annual maintenance and once again did an excellent job. This is our third year using them and the consistency is what keeps me loyal. He swept the flue, cleared the seasonal creosote, and ran the camera up to confirm the liner remained sound. He flagged that our stainless cap was starting to show some corrosion and gave me a heads-up to budget for a replacement next year, no pressure. Floors stayed clean thanks to the drop cloths and vacuum. Friendly, efficient, and never trying to manufacture work. A genuinely trustworthy local company that treats repeat customers right. Already on the books for next season.",
          "name": "Magdalena C.",
          "date": "2025-10-23",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Stuck damper fixed in one visit. Closes tight now and the draft is gone. Polite tech, fair price. Easy to schedule, no upselling, and the results speak for themselves — I'd book them again.",
          "name": "Sofia J.",
          "date": "2023-11-29",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Cap was rusted and the crown had a visible crack. Gus replaced the cap with stainless and sealed the crown same day. Simple, honest, leak fixed.",
          "name": "Delphine M.",
          "date": "2023-11-07",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Squirrels kept getting in past a damper that wouldn't close. Hank installed a top-mount damper with an integrated stainless cap, sealing the flue and blocking critters at the same time. The control cable works smoothly from inside. No more drafts, no more uninvited guests.",
          "name": "Whitney S.",
          "date": "2025-04-17",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Mortar erosion and a couple of spalled bricks on a 1950s chimney. Ira repointed and swapped the bad units same week. Straightforward, fair, no upselling.",
          "name": "Ravi J.",
          "date": "2024-08-14",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Rainstorm after rainstorm finally exposed a crack in the crown. Jed diagnosed it quick, repaired and sealed the crown, and reseated a wobbly cap. Honest and efficient.",
          "name": "Tamara O.",
          "date": "2024-05-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Decades of grime cleared off the firebox in an afternoon. Knox was meticulous, even cleaning the soot from the smoke shelf and the corners. Spotless cleanup.",
          "name": "Donovan E.",
          "date": "2024-06-13",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Impressed by how clean they kept everything. Runners across the floor, booties on, and plastic taped around the opening. Tech vacuumed up every bit of dust before leaving.",
          "name": "Bianca E.",
          "date": "2026-03-26",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "What a relief. Came in convinced I needed the rebuild a competitor quoted, left knowing my chimney was structurally sound. Levi inspected the crown, cap, and liner, found only a cracked crown, sealed it, and swept the flue. Written report included. Fair, fast, and honest.",
          "name": "Sofia Q.",
          "date": "2025-02-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Murphy did a quick, clean sweep and was polite throughout. Showed me the creosote he removed and checked the cap on the roof.",
          "name": "Demetrius Q.",
          "date": "2025-07-02",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Ned did a full safety inspection on the gas log set. He cleaned the burner ports, checked the gas pressure with a manometer, tested for carbon monoxide while running, and inspected the flue venting. He flagged a slightly cracked log and ordered a replacement instead of pushing me to redo the whole set. Honest family business, will use again.",
          "name": "Nikolai J.",
          "date": "2025-11-22",
          "service": "Fireplaces Service",
          "rating": 4.1
        },
        {
          "review": "Embarrassed to say the chimney went unswept for the entire eleven years we've owned the house. Otis didn't bat an eye. He brushed and vacuumed out an incredible amount of creosote, inspected the liner, and made sure the smoke was drafting properly before he left. Truly great results and a fair price for the labor involved.",
          "name": "Cordelia E.",
          "date": "2024-02-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked a routine sweep and liner check for the insert. Pete was friendly and quick, cleared the creosote, checked the cap screen, and made sure the damper sealed. Honest assessment with no pushy add-ons. Appreciated the straightforward visit.",
          "name": "Ingrid H.",
          "date": "2024-07-19",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Nesting debris had completely choked our flue. Roy removed it all, swept the creosote that had built up, and installed a stainless cap with fine mesh to block birds and squirrels. He covered the floor with drop cloths and vacuumed afterward. Polite, knowledgeable, and the rate was reasonable for the work involved.",
          "name": "Anneliese G.",
          "date": "2026-02-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "After our offer was accepted we wanted a chimney specialist, not just the general inspector, to weigh in. Silas examined the crown, cap, and flashing and ran a camera the full length of the flue. He found water damage behind the firebox the seller hadn't disclosed. His written report with photos let us renegotiate. Honest, thorough, and genuinely helpful people.",
          "name": "Dominique E.",
          "date": "2025-11-03",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Three days before Christmas and the fireplace wouldn't draw. The scheduler treated it as the emergency it was. Tate showed up that afternoon, found the flue packed with creosote and a clogged cap from years of neglect by the previous owner. He swept the whole system, cleared the cap, and walked me through before-and-after photos. We had stockings hung and a warm fire on Christmas morning. This father-and-sons outfit really came through for us.",
          "name": "Daniela F.",
          "date": "2025-12-22",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Constant downdraft and a smoke smell that wouldn't quit. Vern figured out our chimney was lower than the adjacent two-story addition, so wind washed smoke back down. He recommended raising the flue and adding a directional cap. Did the work cleanly with drop cloths everywhere. Draft is excellent now and the house finally smells fresh.",
          "name": "Fatima N.",
          "date": "2025-08-27",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Straightforward reline for the furnace flue. Wade showed up when they said, sized the liner, and finished without drama. Cleaned up the creosote and old tile fragments completely. Appreciated the matter-of-fact, no-nonsense approach.",
          "name": "Cornelius J.",
          "date": "2023-03-28",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Yearly cleaning handled fast and clean. Wyatt swept the flue and checked the cap. No surprises, just good steady work. Third year running.",
          "name": "Desmond R.",
          "date": "2023-02-22",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Pre-sale chimney check went smoothly. The technician documented light creosote and a slightly rusted cap in a clear written report. Showed up on time and left no mess. Reasonable for the peace of mind.",
          "name": "Lorelei P.",
          "date": "2023-09-30",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "This was our very first chimney cleaning as new homeowners and we were clueless. Cole arrived, laid down drop cloths, swept everything, and removed a thick layer of creosote we never knew was there. Then he patiently explained the whole anatomy of the chimney to us, the smoke shelf, the damper, the flue, with before and after photos. He recommended an annual sweep and didn't push anything extra. Left feeling educated and safe.",
          "name": "Delphine R.",
          "date": "2026-04-27",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Dale arrived promptly, covered the floor, and cleaned the chimney from top to bottom. He took special care to explain the flue liner condition to my hard-of-hearing father. Patient and respectful throughout.",
          "name": "Ethel Q.",
          "date": "2024-08-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Smoke was leaking out around the firebox and into the room. The tech found the smoke chamber was rough and unparged, slowing the draft. He smoothed and sealed it, then swept the flue. Fires draw cleanly now and the smell is gone.",
          "name": "Talia E.",
          "date": "2024-12-22",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Impressed by the attention to detail. Aiden cleaned our fireplace thoroughly, brushing out the firebox and removing creosote from the smoke shelf, then tested the damper for a proper seal. He laid drop cloths down so the carpet stayed pristine. The whole job took about an hour and he left it spotless. First fire of the winter was warm and inviting. Will absolutely call them again next fall.",
          "name": "Henrietta B.",
          "date": "2025-10-07",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Took us moving in to realize the chimney had probably never been cleaned. Beau found stage two creosote throughout the flue and a partial blockage. Cleared everything, inspected the crown, and walked me through photos. Same-day appointment, great communication.",
          "name": "Naomi B.",
          "date": "2025-05-08",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Caleb handled our air duct cleaning and clearly knew his trade. He explained how dust and allergens circulate through the supply ducts, then cleaned every vent and return in the house. He pointed out that one of our cold-air returns wasn't sealed properly and fixed it on the spot. The morning sniffles my daughter had are gone now. Genuinely grateful for the careful work.",
          "name": "Calloway B.",
          "date": "2025-06-30",
          "service": "Air Duct Service",
          "rating": 4.5
        },
        {
          "review": "Dewey did a fantastic job. After the chimney inspection he tackled the dryer vent, removing a thick lint mat near the lint trap housing and another clog at the wall hood. Tested the airflow before leaving and walked me through how often to have it cleaned. Genuinely cared.",
          "name": "Harriet J.",
          "date": "2025-07-30",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Earl swept our chimney quickly and pointed out the flue liner looked great. Drop cloths kept the room clean and he was gone in under an hour. Solid service.",
          "name": "Clayton U.",
          "date": "2025-03-30",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Same-day cleaning came through when I called late in the week. The tech swept the flue, cleared the creosote, and checked that the cap was secure. Tidy, fast, and fairly priced. Glad I called.",
          "name": "Hassan E.",
          "date": "2024-08-21",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Heard good things from the neighbors so I gave Smith and Sons a shot. The crew swept the chimney and noticed the crown had a hairline crack. They explained my options without pressure and got the cleaning done same day.",
          "name": "Mateo Q.",
          "date": "2024-02-26",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Quick, on time, and thorough. Floyd cleaned the flue and patched some loose masonry on the crown the same day. Left the hearth cleaner than he found it.",
          "name": "Ramon G.",
          "date": "2025-02-26",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Wet spots inside the firebox led to a level-2 camera scan. Gus found the flashing had failed and water was tracking down behind the liner, rotting things out of sight. The photos made the hidden damage undeniable. Repair done right.",
          "name": "Fernando B.",
          "date": "2024-04-14",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "No-obligation quote was easy to get and the price was reasonable. Hank swept the flue, checked the damper, and didn't try to sell me anything I didn't ask for. The invoice matched the estimate exactly. Straightforward and fair.",
          "name": "Tariq B.",
          "date": "2025-03-07",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "From the first phone call to the finished job, this family was honest and easy to deal with. Ira handled the sweep, showed me the creosote in the flue, and pointed out that my stainless cap was loose. He tightened it on the spot and didn't add it to the bill. That kind of integrity is rare.",
          "name": "Felicity R.",
          "date": "2026-03-05",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Spalling brick and crumbling mortar on our older home. The crew repointed and replaced the worst bricks in one visit. Reasonable and clean.",
          "name": "Devon S.",
          "date": "2023-10-26",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Wind-driven rain had been getting past our flashing for who knows how long. Jed found it during a storm follow-up inspection, resealed the flashing, and patched a crown crack while he was up there. Thorough and honest.",
          "name": "Naomi E.",
          "date": "2023-09-06",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Knox serviced our gas logs ahead of winter. Cleaned the burner, adjusted the flame so it stopped leaving black streaks on the glass, and checked the connections for leaks. Straightforward and effective.",
          "name": "Gerald U.",
          "date": "2025-11-30",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "We had no idea our chimney had a hidden problem until Levi ran the camera. The footage revealed a vertical crack running through several flue tiles, likely from an old chimney fire before we owned the place. He was thorough, explained the risk of leaving it, and provided a comprehensive written report with timestamped images. Decades of experience really came through in how calmly he walked us through everything. Repair was scheduled within days.",
          "name": "Lorraine C.",
          "date": "2024-11-19",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Leaky chimney fixed right. Cracked crown patched, rusted cap replaced with stainless, masonry waterproofed. Done in one visit. Murphy knew his stuff.",
          "name": "Patrick S.",
          "date": "2024-04-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "As first-time fireplace owners we appreciated how Ned turned a routine sweep into a mini-lesson. He showed us the before and after of the flue, explained why our crown looked solid, and taught us how to read the chimney's draft. Patient, friendly, and genuinely invested in us learning to care for it ourselves.",
          "name": "Tabitha C.",
          "date": "2025-03-27",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Outstanding work from a true family operation. Otis arrived, removed a substantial bird nest from the top of the flue, cleaned out years of debris that had collected, and inspected the crown while he was up there. Installed a stainless cap with an animal guard and gave me before and after photos. Honest, careful, and great value.",
          "name": "Reginald A.",
          "date": "2025-12-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Needed the flue relined before selling the house. Pete got it done quickly with a stainless liner and provided documentation the buyers needed. Smooth process.",
          "name": "Franklin U.",
          "date": "2023-09-12",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Our fireplace had a stubborn smoky smell that lingered in the living room. Roy diagnosed it as creosote buildup in the firebox and smoke chamber, gave both a deep cleaning, and the odor disappeared completely. He took before and after photos so I could see the difference. Now we can actually enjoy a cozy fire on cold nights without the whole house reeking. Worth every penny and a pleasure to deal with.",
          "name": "Sandra L.",
          "date": "2026-02-04",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Dryer vent add-on during the chimney sweep. Silas was thorough, vacuumed the lint trap housing, and tested airflow at the hood. In and out, no fuss.",
          "name": "Calvin U.",
          "date": "2023-11-30",
          "service": "Dryer Service",
          "rating": 4.5
        },
        {
          "review": "Straightforward and fast. Insert swept, liner camera-checked, no issues found. The tech vacuumed up afterward and didn't leave a speck of soot behind.",
          "name": "Hugo R.",
          "date": "2024-02-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Our firebox was an embarrassment, all soot-blackened brick and a rusty grate. Tate transformed it. He cleaned the firebrick down to its natural color, wire-brushed and treated the grate, and cleared the creosote from the smoke chamber. Drop cloths went down first and he vacuumed every speck before leaving. The before and after photos were jaw-dropping. The fireplace is now the nicest feature in our living room.",
          "name": "Yara M.",
          "date": "2026-05-14",
          "service": "Fireplaces Service",
          "rating": 4.5
        },
        {
          "review": "Yearly cleaning was painless. Vern swept out the creosote, vacuumed the firebox, and left no trace. In and out, friendly the whole time.",
          "name": "Fern Q.",
          "date": "2025-03-19",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Frigid weekend approaching and our chimney was filthy. Wade answered the emergency call, came same day, and removed a thick creosote layer plus some debris near the cap. Reassuring and fast.",
          "name": "Oscar T.",
          "date": "2024-02-15",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Wood stove insert vented through our chimney was drafting poorly, so I called for an inspection. Wyatt traced the problem to creosote accumulation in the liner combined with a partially blocked cap. He swept the connector pipe and liner thoroughly, cleared the cap mesh, and the stove drafts beautifully now. He took the time to explain how insert chimneys differ and why they need more frequent cleaning given how we burn. Camera footage before and after made the improvement obvious. Tidy, respectful of the house, and clearly experienced with stove setups specifically. The detailed report rounded out a great visit. I'll definitely have him back for the next cleaning.",
          "name": "Bridget Z.",
          "date": "2024-07-02",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Wind kept howling down our flue every cold front because the old damper had warped open. Cole assessed it, recommended a top-mount damper for a better long-term seal, and installed it the same afternoon. He demonstrated the cable lock and left the hearth cleaner than he found it. The house is quieter and noticeably warmer in the evenings now.",
          "name": "Quentin F.",
          "date": "2025-01-26",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Water was leaking down behind the mantel during storms. The technician found the crown cracked and the cap missing, with water pouring into the flue. They formed a new crown, capped it in stainless, and waterproofed the brick. Clean, courteous, and the written report made it easy to file with my insurance.",
          "name": "Quentin R.",
          "date": "2025-10-09",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Thorough from start to finish. Dale inspected the firebox, identified that the damper plate had warped and was leaking conditioned air year-round, and laid out two options without pressure. We went with a top-sealing damper that closes airtight at the top of the flue. He waterproofed around the cap base too while he was up there. Emailed a written report with photos. The fireplace seals like new and our energy bills should thank us.",
          "name": "Idris N.",
          "date": "2026-02-19",
          "service": "Chimney Service",
          "rating": 4.5
        },
        {
          "review": "Tuckpointing and spalling repair on a charming but neglected old home. Aiden matched the historic mortar color and the original joint profile, which mattered a lot to us. The crew also rebuilt a crumbling crown and sealed the masonry once it cured. Roof shingles were protected with cloths the whole time. The before and after photos in the written report were a nice touch and the price was reasonable for the scope.",
          "name": "Genevieve U.",
          "date": "2026-05-21",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "A bad ice storm cracked the crown and the cap had blown loose. Beau came out, rebuilt the crown, waterproofed it, replaced the stainless cap, and resealed the flashing all in one visit. He took before and after photos and gave me a clear written report. The office had originally quoted next week but called back to fit me in two days early. Top-notch crew, would trust them with anything chimney-related.",
          "name": "Nathaniel Q.",
          "date": "2026-04-21",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Scheduled a firebox makeover and they did not disappoint. Caleb cleaned the brick, vacuumed the ash dump, and replaced a chipped firebrick. The before and after photos he sent over were impressive. Office was responsive and the price was reasonable. Fireplace truly looks brand new now.",
          "name": "Magnolia R.",
          "date": "2025-07-22",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Dewey and his partner were spotless workers. Two drop cloths overlapped under the fireplace, shoe covers on, and a containment seal over the opening. They swept the flue, collected the creosote in a bag, and ran the HEPA vac across the whole hearth area twice. Not a smudge anywhere. Exactly what you hope for.",
          "name": "Theodore K.",
          "date": "2024-07-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Burned once by a rebuild quote that didn't sit right, I called for a second look. Earl spent an hour going through the flue liner and firebox with a camera, then explained plainly that no rebuild was warranted. The real issue was a stuck damper and soot buildup. Cleaned and repaired same visit. Trust earned.",
          "name": "Hollis B.",
          "date": "2023-12-15",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Floyd went above and beyond on our chimney cleaning. He noticed the crown was cracking and waterproofing had failed, then explained exactly how water was getting in. No pressure, just clear photos and an honest estimate. Courteous, knowledgeable, and respectful of our home with drop cloths and shoe covers. A father-and-sons outfit that clearly takes pride in the work.",
          "name": "Annika W.",
          "date": "2026-05-04",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Pilot wouldn't stay lit so I called. Gus cleaned the pilot orifice, replaced the thermocouple, and adjusted the flame. Tested it several times to be sure it held. Quick same-day fix and the firebox was spotless when he finished.",
          "name": "Cassandra U.",
          "date": "2024-05-15",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Hank tackled a chimney that hadn't been cleaned since the Obama administration, as he joked. Tons of creosote came out. Professional, tidy, and quick.",
          "name": "Lamar U.",
          "date": "2026-05-02",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Our insert was overdue and I was worried about a chimney fire risk. Ira came out, swept a thick creosote build, and ran a thorough camera inspection of the full liner. He confirmed it was structurally sound and showed me each section on the monitor. Walked me through proper seasoning of firewood so I don't end up in the same spot. Reassuring and professional throughout.",
          "name": "Lamar W.",
          "date": "2026-05-21",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "A bird had built a nest right on top of the damper. Jed pulled it out, cleaned the smoke shelf, and capped the chimney with stainless. Same-day appointment and good communication from the office.",
          "name": "Omar J.",
          "date": "2023-08-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Needed a fast turnaround for a pre-sale inspection. The office squeezed us in and the tech delivered a written report the same evening covering the liner, damper, and crown. Impressive efficiency without cutting corners.",
          "name": "Anjali T.",
          "date": "2024-08-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Thanksgiving week cold snap and our chimney smelled like a campfire when it wasn't lit. Same-day call answered. Knox swept out heavy creosote, the source of the smell, and inspected the flue liner. Clean and quick.",
          "name": "Theo G.",
          "date": "2024-11-27",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Smoke kept curling out of the firebox into the room. The tech identified an undersized fireplace opening relative to the flue and suggested a smoke guard, but first cleared a heavy creosote ridge. Drafts much better now. Appreciated the straight talk.",
          "name": "Cordell E.",
          "date": "2024-02-09",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Our chimney was sharing a flue between two appliances, which is a no-go. Levi separated them and installed a dedicated stainless liner for each, then verified the draft on both. He explained the code reasons clearly and emailed a detailed report. Professional and reassuring throughout.",
          "name": "Delphine Q.",
          "date": "2026-04-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Faithful customer for six years now. The crew came out for our spring cleaning this time instead of fall, and Murphy didn't miss a thing. Brushed the entire flue, emptied the firebox, and checked the damper operation. He left before and after photos on my phone showing the creosote removal. The annual visit always gives me peace of mind heading into next season.",
          "name": "Imani L.",
          "date": "2025-05-14",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "During our home purchase the chimney was the one thing nobody could speak to confidently, so we brought in the specialists. Ned climbed up, inspected the flashing and shingles around the chimney, ran the camera down the flue, and found a cracked clay tile midway. His written report was detailed enough that the seller's contractor couldn't argue with it. They repaired it before we closed. Professional from the first phone call to the final report.",
          "name": "Desmond R.",
          "date": "2025-12-02",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "First time owning a place with a fireplace and I had no idea it needed regular cleaning. The technician swept it, found early creosote, and patiently walked me through why seasoned wood burns cleaner. Honest and educational, exactly what a beginner needs.",
          "name": "Bashir K.",
          "date": "2025-05-23",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Reassuring service for an old fellow living alone. Otis was calm, careful, and never once rushed me. Swept the creosote out, checked the damper, and tidied up completely. I'd trust him in my home anytime.",
          "name": "Leonard Z.",
          "date": "2025-12-17",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Persistent downdraft pushing odor into the living room. Pete installed a top-mount damper that seals the flue when not in use, which also stopped the cold air and smell. Swept the creosote while up there. Clean, friendly, on time.",
          "name": "Oscar Z.",
          "date": "2025-01-09",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Booked online and got a fast confirmation from the office. Roy cleaned the firebox, scrubbed the glass doors clear, and freed up a sticky damper. Ready to be cozy all winter.",
          "name": "Montgomery D.",
          "date": "2024-11-19",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "My wife finally convinced me to get the chimney done after, oh, eleven winters of use. The crew was professional from the first knock. Silas discovered the creosote was so thick in spots it was nearly closing off the flue, which honestly scared me a little. He cleaned every inch, vacuumed the firebox, and showed me before and after shots so I could see the difference. Tidy, knowledgeable, and clearly experienced. We feel a lot safer now.",
          "name": "Reginald T.",
          "date": "2024-08-28",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Smoke smell from a previous tenant lingered in our vents for months. After the air duct service it finally cleared. Tate was thorough with every register and even sanitized the ducts. Worth it.",
          "name": "Naima Z.",
          "date": "2024-05-02",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Same-day dryer vent cleaning added on with no hassle. Vern ran a brush the full length, cleared the exterior flap, and vacuumed up the loose lint. Clothes dry way faster now.",
          "name": "Omar S.",
          "date": "2024-08-27",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Fast, friendly, and clean. The tech cleared a sooty flue, tightened the cap, and left no trace on my hardwood floors. Same-day booking made it easy.",
          "name": "Imani B.",
          "date": "2024-06-08",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Routine sweep done right. Wade brushed the flue, removed the creosote, and dusted the firebox clean. He mentioned the crown could use waterproofing down the line but wasn't pushy about it. Appreciated the honest heads-up.",
          "name": "Rosalind Q.",
          "date": "2025-03-30",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "My neighbor wouldn't let me hire anyone else after the job they did at her place. Wyatt came out, swept the flue, inspected the cap and crown, and left a detailed written report. Wore booties indoors and cleaned up beautifully. The kind of careful work you don't see much anymore.",
          "name": "Delia U.",
          "date": "2025-08-09",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Every step ran on schedule. The crew arrived within the promised window, swept years of buildup out of the flue, and then waterproofed the crown and reset the cap before they left. I expected to need a separate masonry appointment, but they handled it all in one visit with the parts already on the truck. Clean, courteous, and clearly experienced. The family-run feel comes through in how they treat your home.",
          "name": "Felicity B.",
          "date": "2024-08-21",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Our fireplace had a faint sour smell that came and went. Cole ran the camera and discovered a dead bird and accumulated debris caught on a ledge in the smoke chamber, plus a small crack the moisture had started. He removed everything, scanned again to confirm, and gave us before and after photos along with a tidy written report. Patient, knowledgeable, and didn't leave a speck of soot on the carpet.",
          "name": "Wilhelmina K.",
          "date": "2025-10-19",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "From the first phone call the pricing was crystal clear. The scheduler gave me a flat rate for the cleaning, no obligation, and explained what was and wasn't included. Dale arrived, swept the flue, inspected the crown for free, and the bill was exactly the quote. No upsell, no hidden charges. A family business that earns loyalty the right way.",
          "name": "Cassandra V.",
          "date": "2024-02-26",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Aiden did a thorough sweep and was honest as the day is long. Said the chimney was in great shape and I wouldn't need anything beyond an annual cleaning. Lovely family.",
          "name": "Damon W.",
          "date": "2024-05-14",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Couldn't ask for better. Our 1925 chimney had deep mortar erosion and several spalled bricks threatening to fall. Beau assessed it, explained how freeze-thaw cycles had broken down the joints, and laid out a clear plan. He repointed the whole upper stack, swapped the damaged brick, resurfaced the crown, and applied a breathable waterproofer. Photos before and after, written report, spotless cleanup. The masonry looks decades younger.",
          "name": "Annika P.",
          "date": "2026-05-22",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "After the big April storm I scheduled a chimney check and was glad I did. Caleb discovered the cap had blown partly off and the crown had a deep crack channeling water down the flue. He installed a new stainless cap, sealed the crown, and reattached the flashing where the wind had pried it up. Wore shoe covers, laid drop cloths, and left the place cleaner than he found it. The written report with photos was a nice touch for our home records.",
          "name": "Sebastian W.",
          "date": "2026-04-29",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "So glad we had our gas-log fireplace checked before the season. Dewey cleaned the burner ports, repositioned the logs to spec, and tested the thermocouple and pilot. He found a tiny gas leak at a fitting that we never would have caught and tightened it on the spot, then re-tested. Genuinely could have been dangerous. Cannot thank this crew enough.",
          "name": "Mireille Z.",
          "date": "2024-11-19",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Camera inspection found a gap behind the damper letting cold air pour in. Earl sealed it and showed me the before video. Quick, clean, professional.",
          "name": "Trevor B.",
          "date": "2025-02-14",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Water had been seeping in around the chimney for months and damaging the ceiling. Floyd did a careful inspection and found both a cracked crown and a cap that was completely rusted through. He took care of both, then waterproofed the entire exterior of the chimney. Explained that the breathable sealant won't trap moisture inside the brick. Very knowledgeable and patient with all my questions.",
          "name": "Camille R.",
          "date": "2025-10-23",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Bought a fixer-upper with an old fireplace and had no experience. Gus swept the chimney, inspected the liner, and patiently explained the maintenance schedule for a newcomer like me. Appreciated the honesty about what could wait and what couldn't.",
          "name": "Dominic Q.",
          "date": "2023-09-12",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Debris and an old nest removed, flue inspected, stainless cap on. Fast and friendly. Honest, efficient, and thorough from start to finish; exactly the kind of company you hope to find.",
          "name": "Sofia M.",
          "date": "2024-03-27",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Really pleased with the liner installation. Our chimney inspection revealed the old liner had separated joints leaking heat into the framing, a real fire hazard. Hank installed a continuous stainless liner with insulation wrap, sealed the top with a new plate and cap, and tested the draft. He explained everything in plain terms and the written report documented it all with before and after photos. Clean, respectful, professional crew.",
          "name": "Adaeze W.",
          "date": "2025-06-24",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Cozy nights are back. Ira cleaned the firebox, removed ash, and polished the glass doors. Easy scheduling through the office and quality work.",
          "name": "Ignacio R.",
          "date": "2024-10-26",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "The scheduler made it easy to add dryer vent cleaning onto our fireplace appointment. Jed cleared a duct that was nearly choked with lint, replaced a crushed section of flex hose, and showed me the airflow improvement at the exterior vent. Worth doing while they were already on site.",
          "name": "Imani P.",
          "date": "2024-10-23",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Called about a draft problem with our wood stove and Knox diagnosed it as creosote restriction in the liner. He swept it clean, ran the camera to confirm, and checked the cap screen for blockage. Stove burns hot and clean now. Appreciated that he showed up exactly when the office said he would.",
          "name": "Camille B.",
          "date": "2025-01-31",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Good firebox cleaning. Levi cleared the ash, scrubbed the back wall, and freed up the damper. Looks much better and he was in and out quickly.",
          "name": "Elliott B.",
          "date": "2023-04-18",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "We've burned hardwood in this fireplace for over twenty years and the annual sweep is non-negotiable. Murphy showed up on time, masked off the area, and ran the brush from cap to firebox. Creosote was on the lighter side this year, which he said was thanks to keeping the fires hot. Vacuumed everything, handed me a written report, and was gone within the hour. Dependable family business.",
          "name": "Domenico U.",
          "date": "2024-01-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Hosting Christmas and our flue was overdue for a sweep. The office made room for us that same day. Ned laid out drop cloths, swept thoroughly, inspected the liner, and showed me the soot he pulled out. We lit our first fire that evening without a worry. Impressed by the speed and the care taken with our home.",
          "name": "Felicia R.",
          "date": "2025-12-15",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Had a chunk of masonry fall into the firebox and panicked a bit, but the office calmed me down and got someone out same day. Otis inspected the chimney inside and out, found deteriorating mortar joints and a cracked crown letting water in, which had accelerated the spalling. He explained the repair clearly, swept the flue while he was there, and gave me a written estimate with photos for the masonry work. No scare tactics, just a straightforward assessment of what needed doing and what could wait. The same-day responsiveness genuinely impressed me during a stressful moment. Honest, capable, and reassuring. Exactly who you want showing up when something goes wrong.",
          "name": "Hollis T.",
          "date": "2025-05-08",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Family-owned and it shows in how careful they are. Our damper had rusted so badly it dropped pieces into the firebox. Pete cleared the debris, installed a new sealing damper, and adjusted it until the plate sat perfectly flush. Before and after photos texted to me, and a fair invoice with no surprises. Will call them again for the annual sweep.",
          "name": "Adaeze M.",
          "date": "2025-07-19",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Noticed rust streaks on the brick and a damp ceiling. Roy diagnosed a rusted-out cap and a crown that had cracked along the flue. New stainless cap, crown repaired, and the whole chimney waterproofed. He showed me the corroded old cap so I understood the problem.",
          "name": "Anneliese T.",
          "date": "2026-02-11",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Fast damper repair. The plate had slipped off its hinge. Tech reseated it, added a new gasket, and confirmed a tight seal. Drafty no more.",
          "name": "Carmen Z.",
          "date": "2024-02-14",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Spalled brick faces on the weather side of an old chimney. Silas replaced the damaged units and repointed around them. Quick, clean, and the color match is excellent.",
          "name": "Horace Q.",
          "date": "2023-09-25",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Storm tore a couple shingles loose near the chimney and water found the flashing gap. Tate resealed it and double-checked the crown and cap. Quick, no drama, fair bill.",
          "name": "Imani W.",
          "date": "2023-11-02",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Brilliant job. Our firebox looked hopeless after years of fires, but the tech brought it right back. Brick is clean, damper works, glass is clear.",
          "name": "Anders K.",
          "date": "2023-04-18",
          "service": "Fireplaces Service",
          "rating": 4.1
        },
        {
          "review": "Vern made cleanliness the priority. He explained the dust containment before starting, put covers on his boots, and laid drop cloths from the door. The sweep pulled out plenty of creosote but the sealed vacuum caught it all. He left my hearth tile and glass doors gleaming. No soot, no dust, no trace.",
          "name": "Marisol P.",
          "date": "2025-01-28",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "A contractor told me my chimney needed demolition and rebuilding. Skeptical, I booked an inspection here. Wade found the masonry intact and the crown just needed resealing. Quick, honest, and far cheaper. Glad I asked.",
          "name": "Delphine R.",
          "date": "2026-03-22",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Wyatt swept the flue and was just a pleasant person to have in the house. Detailed about the creosote levels and gentle with my questions.",
          "name": "Tobias G.",
          "date": "2024-10-17",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Excellent gas-log prep. Cole vacuumed the firebox, cleaned the ceramic logs, leak-tested the gas line, and ran a carbon monoxide check with the unit on. He also showed me how to relight the pilot myself if it ever goes out. Professional and patient.",
          "name": "Dominic Y.",
          "date": "2026-05-11",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "We knew it had been too long, but seeing the bucket of soot Dale pulled from our flue really drove it home. He covered the floor, used a powerful vacuum, and explained the creosote stages so we understood the urgency. Now we'll be scheduling yearly. The whole experience was reassuring from start to finish.",
          "name": "Josephine Q.",
          "date": "2025-07-25",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Wood stove liner cleaning done right. Aiden laid down drop cloths, swept the flue, and verified there were no cracks in the stainless liner. Quick, clean, and the report had nice before-and-after photos.",
          "name": "Sofia R.",
          "date": "2025-04-25",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "We bought an older home and discovered the chimney was full of nesting material and leaves from years of being uncapped. Beau spent the better part of a morning removing it all, sweeping the flue, and inspecting the liner for any damage from moisture. He then installed a sturdy stainless steel cap and gave us a written report with photos. Trustworthy crew that takes pride in the work.",
          "name": "Tabitha U.",
          "date": "2025-04-02",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Outstanding pre-purchase inspection. Caleb scoped the flue and immediately spotted a cracked clay liner and significant creosote glaze. He explained why the glaze was a fire hazard and what relining would cost. The written report was meticulous, with labeled photos and a priority list. We used it to negotiate a five-figure credit. This crew earned our trust completely.",
          "name": "Gerald W.",
          "date": "2026-05-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Subzero forecast and I needed the wood stove ready, no time to spare. They fit me in same day. Dewey arrived with a stocked truck, swept the flue, scraped a glazed creosote section, and replaced a rusted cap screen on the spot. He explained why the glaze was a fire hazard and how to burn drier wood. Warm, knowledgeable, and fast when it mattered most.",
          "name": "Magdalena R.",
          "date": "2025-01-09",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Our two-story foyer always smelled faintly of smoke. Earl explained the stack effect was pulling air down the cold fireplace flue and dragging odor through. He cleaned the creosote, sealed the damper better, and recommended a top-sealing damper to stop the air movement. The lingering smell is gone and our heating bill even dropped a bit from the air seal.",
          "name": "Wendy U.",
          "date": "2026-02-23",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Excellent relining work on our masonry fireplace. The old liner was cracked from a chimney fire years ago. Floyd installed a heavy-duty insulated stainless liner rated for wood burning, sealed the crown, and fitted a new cap. He showed me camera footage before and after so I could see the difference. The whole crew was respectful of our home.",
          "name": "Augustus M.",
          "date": "2024-08-02",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Same crew, same excellent service, every single year. Gus swept ours and gave the crown and flashing a careful look from the roof. Decades of experience really shows. Won't go anywhere else.",
          "name": "Bartholomew N.",
          "date": "2024-08-07",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Outstanding pre-purchase inspection. Hank was punctual, courteous, and clearly knowledgeable. He examined the crown, cap, and firebox, ran a flue camera, and flagged early creosote buildup plus a loose damper. The written report came with timestamped photos and a clean summary. Never once pressured us into buying repairs. Just gave us the facts to make a smart decision.",
          "name": "Inga T.",
          "date": "2024-07-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Brand new fireplace owners, totally lost. Ira came out for the sweep and gave us such a patient education on the flue liner and why a stainless cap keeps moisture out. He showed us the small bit of creosote near the top and explained how it forms. Wrote up a clear report. We felt completely looked after by this family business.",
          "name": "Wendy C.",
          "date": "2024-02-15",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "At my age you learn to spot the ones who'll cheat you and the ones who won't. Jed is the kind you can trust. He spent extra time explaining the soot and creosote he removed, showed me the cap on his phone, and gave me a clear written report. Patient with every question. I felt respected, not hurried.",
          "name": "Mabel I.",
          "date": "2026-02-28",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "We assumed the smoke smell was just an old house thing until Knox inspected and found heavy creosote glazing in the flue. A proper sweep and a new stainless cap made an enormous difference. He explained everything and left a written report. The whole house smells fresh again, even when the fireplace isn't in use.",
          "name": "Fatima R.",
          "date": "2023-04-18",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Honestly the best money I've spent on the house this year. Levi came out and treated our long-neglected fireplace with care. He removed a heavy layer of creosote, vacuumed the firebox until it gleamed, and checked the damper operation. He even gave me a written summary of what he did and a tip on burning seasoned wood to cut down on soot. The living room feels so cozy now with a clean, safe fire going.",
          "name": "Wilhelmina F.",
          "date": "2026-03-01",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Overdue by at least nine years. Murphy scraped out the buildup, checked the liner, and was done quick. Clean work.",
          "name": "Bianca M.",
          "date": "2026-04-02",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "These folks are the real deal, a true family business that has been doing this for decades. Ned led the air duct crew and they cleaned every supply duct, return vent, and the main trunk line. He showed me before-and-after photos and explained what causes the buildup. The dust on our shelves has noticeably decreased since. Punctual, respectful of the home with drop cloths and shoe covers, and fairly priced.",
          "name": "Thaddeus Q.",
          "date": "2025-01-08",
          "service": "Air Duct Service",
          "rating": 4.4
        },
        {
          "review": "Otis swept the chimney then offered to clean the dryer vent since he had the gear in the truck. He found the vent hood screen was clogged solid, removed it, and explained those screens trap lint and cause fires. Cleared the whole run and the dryer stopped shutting off mid-cycle. Excellent service.",
          "name": "Renata B.",
          "date": "2026-01-28",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Pete arrived right on time and swept the chimney in no time. Showed me before and after photos of the flue and the smoke shelf. No mess, great price.",
          "name": "Reuben K.",
          "date": "2026-05-01",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Yearly maintenance for our wood-burning fireplace. Roy was thorough, swept the entire flue, scraped off some glazed creosote near the top, and gave the damper a once-over. Drop cloths kept everything clean and the written report was easy to follow. Been with them several seasons now and they're consistently good.",
          "name": "Frederick Y.",
          "date": "2023-11-09",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Picked up the recommendation from a neighbor at the mailbox and called the next day. Silas swept the chimney and ran a camera up to check the flue liner for cracks. Found a small gap and explained it plainly. No pressure, just honest guidance and a clean job.",
          "name": "Roland I.",
          "date": "2026-01-05",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Tate showed up right on time and got to work. Swept the chimney and fixed a loose stainless cap in the same trip. Done in about ninety minutes with no mess.",
          "name": "Damon W.",
          "date": "2025-09-15",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Level-2 scope found a separated joint we'd never have spotted. Clear report, fair quote, no pressure. Decent folks. Communication was great the whole way through and the work held up beautifully afterward.",
          "name": "Damian R.",
          "date": "2023-12-05",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Honest quote, honest work. They told me the sweep cost up front and never wavered. Vern showed me the creosote on the brush and said the flue was otherwise fine. No invented repairs.",
          "name": "Nathaniel D.",
          "date": "2025-08-19",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Wade showed up and immediately put me at ease. He's the kind of guy who explains everything, like why the creosote was glazing near the top of the flue, and what burning seasoned wood would do to prevent it. Never pushy, never rushed. He even helped me move a heavy log rack that had nothing to do with the job. Genuinely good, honest people running this outfit.",
          "name": "Sabrina J.",
          "date": "2025-09-18",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Repointed eroded joints and replaced a couple of spalled bricks on our old place. Wyatt was on time and the color match on the mortar is excellent.",
          "name": "Bryce R.",
          "date": "2024-06-11",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Storm tore shingles off near the chimney and the flashing came with them. Cole resealed everything, checked the crown, and made sure the cap was storm-secure. Quick and no fuss.",
          "name": "Tanya G.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Gas fireplace prep done right. Dale cleaned the dust off the logs and burner, checked the gas pressure, and made sure the pilot ignition was reliable. Walked me through proper operation. Friendly and efficient.",
          "name": "Trevor B.",
          "date": "2026-03-25",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Scheduling was easy and the office kept me posted. Aiden ran the level-2 scope and found a partial liner collapse near the top that was restricting draft and causing smoke spillage. He documented it all, explained the relining options without pressure, and the report photos made the decision simple. Appreciated the honesty.",
          "name": "Sandra K.",
          "date": "2025-12-29",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Quick turnaround on a missing cap. Mud was getting into the flue from a nest and rain too. Beau installed a screened stainless cap and checked the crown for cracks, sealing one small one. Friendly and efficient.",
          "name": "Darnell T.",
          "date": "2023-08-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "I was so intimidated by the fireplace in our new place that I avoided it all last winter. This year I finally called and I'm thrilled I did. Caleb swept the chimney, showed me how thick the creosote had gotten, and gently explained why using it without a cleaning would have been risky. He demonstrated the damper, taught me to crack a window for draft, and recommended a cap to stop the downdraft I'd been feeling. He never made me feel foolish for waiting. Now I actually look forward to lighting a fire.",
          "name": "Imani B.",
          "date": "2025-05-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "We assumed the smoke problem was the damper but Dewey found a packed bird nest jammed in the flue. He removed it, cleaned out the surrounding debris and creosote, and capped the chimney with a stainless steel cap. Explained the whole thing patiently and didn't try to upsell. Solid, trustworthy service.",
          "name": "Clarence T.",
          "date": "2025-05-09",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Family business that does right by customers. Earl relined our fireplace flue with stainless after the clay tiles cracked from a past chimney fire. He insulated it, sealed the cap, and cleaned out all the old creosote. Tidy and thorough.",
          "name": "Spencer K.",
          "date": "2024-11-30",
          "service": "Chimney Service",
          "rating": 4.4
        },
        {
          "review": "Getting set for winter, we had our wood-burning fireplace cleaned and inspected. Floyd vacuumed the firebox, scraped creosote from the walls, and checked that the damper moved freely. He noticed the gasket on our glass doors was worn and recommended a replacement without any pushy sales talk. The whole job was done with shoe covers and tarps protecting the floor. Looking forward to many cozy evenings this season.",
          "name": "Beatrice H.",
          "date": "2025-12-19",
          "service": "Fireplaces Service",
          "rating": 4.4
        },
        {
          "review": "Gus took care of the dryer vent while the crew worked on the crown. Lint packed solid in the line. He brushed it clean, vacuumed behind the dryer, and the unit runs noticeably cooler now.",
          "name": "Stefan K.",
          "date": "2025-07-14",
          "service": "Dryer Service",
          "rating": 4.4
        },
        {
          "review": "Great value for a thorough job. Hank swept the wood-burning insert, inspected the liner for any gaps or corrosion, and pointed out where the insulation wrap had compressed over the years. He documented it all with photos and a written report. No pressure to do extra work, just an honest rundown of what he saw. Hearth was spotless when he left.",
          "name": "Devon S.",
          "date": "2025-08-22",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Such a careful, thorough job. The firebox in our 1920s home had decades of buildup and several cracked firebricks. Ira hand-cleaned the brick, replaced the damaged ones, and repointed the crumbling mortar joints so everything looks uniform. He also cleaned the cast iron damper and showed me how to operate it. Laid down drop cloths and wore shoe covers throughout. The fireplace genuinely looks brand new. This family business clearly cares about doing things right.",
          "name": "Anika R.",
          "date": "2025-10-03",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "Spring chimney cleaning after a busy burning season. Tech brushed the flue, removed a fair amount of creosote, and confirmed the stainless cap was secure. Quick and clean.",
          "name": "Imelda Z.",
          "date": "2025-05-06",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "A sudden cold snap had me scrambling. Jed arrived within the hour, cleared the creosote, and checked the damper and cap. Honest crew, very quick.",
          "name": "Trevor N.",
          "date": "2026-01-19",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Scheduled a sweep after moving into a home where the previous owners clearly never maintained the chimney. Knox arrived prepared and got right into it. The amount of creosote and debris he pulled out was honestly alarming, and the camera inspection revealed an animal nest lodged near the top. He cleared it all, swept the entire flue, and recommended a stainless cap with mesh to prevent future intrusions, installing it the same day. Floors and hearth stayed pristine thanks to careful prep. He documented everything in a clear report. Patient with my questions and never condescending. A huge relief to know the chimney is finally safe to use.",
          "name": "Persephone J.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Damper wouldn't seal and our energy bills proved it. Levi swapped the worn gasket and realigned the plate so it shuts airtight. Cold draft gone same day.",
          "name": "Logan B.",
          "date": "2024-09-05",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Leak in the fireplace traced to a cracked crown letting water seep down to the smoke chamber. Murphy and Murphy resurfaced the crown, fitted a new cap, and applied waterproofing across the masonry. They protected the floors with drop cloths and wore shoe covers throughout. Bone dry since.",
          "name": "Bartholomew K.",
          "date": "2024-03-30",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Replaced a corroded damper that let cold air pour in every winter. Ned measured the throat carefully, fitted a new cast iron unit, and tested the seal with a smoke pencil to make sure nothing leaked. Laid drop cloths over the hearth and vacuumed the rust flakes. The den finally holds its warmth. Clean, professional job.",
          "name": "Jonas Q.",
          "date": "2025-07-08",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "We have a sprawling brick chimney on a 1908 home and the mortar had eroded badly with several spalled bricks near the top. Otis spent a good while inspecting and photographing before quoting anything. The crew tuckpointed the entire above-roof section, replaced the spalled brick with a meticulous color match, rebuilt the crown that had separated from the flue, and applied a breathable waterproofer. They tarped the roof, swept up all debris, and left a written report with staged photos. Honest, skilled, and respectful of an old house.",
          "name": "Mireille Z.",
          "date": "2025-11-03",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Wind storm left our cap rattling and I could hear it from inside. Pete secured a new stainless cap, resealed the flashing where it had lifted, and sealed a small crown crack. He was patient with all my questions and showed me photos of each step. Reasonable price and great communication from the office.",
          "name": "Lorenzo B.",
          "date": "2025-08-16",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "We inherited a 1970s fireplace that looked every bit its age. Roy deep-cleaned the firebox, scrubbed the heavily stained brick, and reconditioned the metal surround. He laid drop cloths over the hardwood and wore shoe covers the whole time. The transformation was so good our neighbors thought we'd had the entire fireplace rebuilt. Couldn't recommend this family business more for a real makeover.",
          "name": "Theodora M.",
          "date": "2026-02-11",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "Tidy and professional. Drop cloths, shoe covers, and a vacuum the whole time. Swept the flue and left zero soot behind.",
          "name": "Clifford R.",
          "date": "2023-08-05",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "After a sketchy rebuild estimate from another company, I wasn't sure who to trust. Silas changed that. He arrived on time, laid drop cloths, scoped the flue, and showed me the liner and brick were completely solid. The only legitimate issue was creosote and a worn cap. He swept it, replaced the stainless cap, and handed me before-and-after photos. No pressure, no nonsense, just straight answers and quality work.",
          "name": "Xavier U.",
          "date": "2024-12-11",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Tate impressed me with how thorough he was on the inspection. Camera down the flue, checked the liner, photographed a small gap in the mortar joints. Patient and kind.",
          "name": "Penelope U.",
          "date": "2025-09-29",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Got the gas fireplace looked over before winter. The technician inspected the venting, cleaned the burner, and tested the ignition. He laid down a drop cloth and wore shoe covers, which I appreciated. Everything checked out.",
          "name": "Wilhelmina O.",
          "date": "2023-11-09",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "First cleaning in roughly thirteen years. Vern was great, found significant buildup along the smoke shelf and flue, scraped it clean, and showed me the written report. Highly recommend for anyone who's been putting it off.",
          "name": "Maximilian Z.",
          "date": "2024-09-14",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Called about a smoky wood stove and they fit us in fast. The tech found the liner packed with creosote near a bend, brushed it clear, and the stove drafted perfectly afterward. He also checked the cap and damper for good measure. Respectful of our home and left it clean.",
          "name": "Gregory M.",
          "date": "2024-11-08",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Persistent scratching noises meant something had moved into the chimney. Wade located a nest and a stash of acorns, cleared it all, and put on a new stainless cap. He was honest that no major repairs were needed, which I appreciated.",
          "name": "Nikolai R.",
          "date": "2024-08-11",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Booked an inspection before buying our first house. Found minor mortar erosion and a slightly rusted damper. The written report was clear and the photos helped. Reasonable price for the peace of mind.",
          "name": "Naomi K.",
          "date": "2023-09-05",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Holidays approaching and the fireplace hadn't been swept in too long. Quick same-day visit. Tech laid drop cloths, brushed out the flue, vacuumed the firebox, and checked the damper. No upsell, just honest work.",
          "name": "Bryce N.",
          "date": "2024-12-16",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Backpuffing on every fire. Wyatt ran a draft test and found the cap screen was completely clogged with soot and creosote, choking the exhaust. He cleaned it out and swept the flue. The fire drafts cleanly now with zero smoke spillage into the living room.",
          "name": "Hugo R.",
          "date": "2023-09-30",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Quick and clean liner replacement for the boiler. The tech sized it, ran the stainless liner, and tied it in neatly. Office was easy to deal with on scheduling. Left no mess behind, even swept the basement floor.",
          "name": "Vivienne T.",
          "date": "2025-02-25",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Annual maintenance done. Cole cleared a light creosote layer, inspected the liner, and confirmed the cap screen was intact. Drop cloths down, shoe covers on. Five dependable years and counting with this family business.",
          "name": "Surya K.",
          "date": "2026-05-06",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Needed a chimney inspection for the sale of my late mother's house. Dale was compassionate and efficient, found the masonry solid with just a worn cap, and provided a written report the buyers accepted without quibble. Appreciated the professionalism during a tough time.",
          "name": "Patrick O.",
          "date": "2026-04-27",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "New to fireplaces entirely. Aiden swept the chimney and patiently explained the damper to me twice because I kept mixing it up. No attitude at all. Good clean work and a friendly first lesson.",
          "name": "Tomas I.",
          "date": "2025-07-08",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Beau was so patient with me. I move slowly with my walker and he held the door and waited without complaint. Swept the flue, removed the creosote, and explained the damper. Gentle soul.",
          "name": "Bernard U.",
          "date": "2024-05-21",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Couldn't use our fireplace without smoking out the room. Caleb ran a thorough draft test and discovered the flue was undersized after a previous botched repair. He laid out the relining options clearly, swept the existing creosote, and the downdraft is completely fixed now. Respectful, tidy, and genuinely cared about getting it right.",
          "name": "Hugo M.",
          "date": "2025-06-29",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Great little family business. Dewey was friendly, cleaned the firebox and glass, and made sure the damper sealed before he left. Hearth was spotless. We're set for a cozy winter.",
          "name": "Percival N.",
          "date": "2025-12-08",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "Couldn't recall ever having it swept since we built the house in 2010. The technician was thorough, removing layers of creosote and a bit of nesting material from near the cap. He documented everything in a written report and recommended a waterproofing treatment for down the road without pushing it. Respectful of our home, drop cloths and shoe covers throughout.",
          "name": "Pascal W.",
          "date": "2025-02-17",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Earl was courteous and efficient. He cleaned all the return vents and supply ducts and explained how often we should have it done. Air feels noticeably cleaner and fresher now.",
          "name": "Delphine R.",
          "date": "2023-04-17",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Polite and professional. Floyd cleaned out the dryer duct after our annual sweep, pulled a good amount of lint from the bend behind the wall, and reattached the duct clamp properly. Dries quicker and the laundry room isn't muggy anymore.",
          "name": "Damon E.",
          "date": "2025-03-17",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Decades of experience really shows. Crew swept the flue, checked the damper, and laid drop cloths everywhere. Spotless work and an honest written report.",
          "name": "Selena T.",
          "date": "2025-07-22",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Couldn't be happier with our annual sweep. Gus was professional, careful with shoe covers and drop cloths, and removed a thick season's worth of creosote from the flue. He took photos from the roof showing the clean liner and intact cap. The whole visit was smooth and the firebox looked brand new afterward. This is why we keep coming back every fall.",
          "name": "Anjali P.",
          "date": "2025-10-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "A neighbor recommended them and the experience lived up to the hype. The technician swept the flue, brushed out heavy creosote, and checked the stainless cap. Drop cloths everywhere, shoe covers on. Spotless cleanup and a fair price. Booking through the office was painless too.",
          "name": "Tabitha Z.",
          "date": "2024-11-03",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "After two no-show contractors, it was a relief to have a company actually arrive when promised. Hank called ahead, came on time, and cleaned the flue while also repairing a cracked crown the same morning. He had mortar and a new cap on the truck so nothing got pushed to another day. Walked me through the written report at the end.",
          "name": "Josephine T.",
          "date": "2024-11-19",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "After a windstorm knocked our cap loose, Ira came out and ran a camera while he was up there. Beyond the obvious cap damage, the footage showed water had already worked into a cracked tile near the top of the flue. He fitted a new stainless cap, documented the interior damage, and recommended waterproofing before it spread. Appreciated that he caught the hidden problem instead of just slapping on a cap and leaving.",
          "name": "Yolanda T.",
          "date": "2026-05-10",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "After being burned by an upsell-happy company last year, the free no-obligation quote here was a breath of fresh air. Jed walked me through the cleaning cost line by line, did the sweep, vacuumed the firebox, and the final number didn't change. Fair, transparent, and no pressure to buy a cap I didn't need.",
          "name": "Gwendolyn T.",
          "date": "2026-03-21",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Knox was personable and refreshingly honest. Swept the flue, checked the damper, and told me the small soot stain on the ceiling was old, not active. No upsell.",
          "name": "Vincent L.",
          "date": "2023-08-30",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Our chimney's brick was spalling so badly that pieces were landing in the gutters. Levi did meticulous tuckpointing, replaced the failed bricks, and explained the soft historic brick needed a softer mortar than modern stuff or it would crack again. That kind of knowledge is why I trusted this family business. Crown got resurfaced too and everything was sealed afterward.",
          "name": "Camille T.",
          "date": "2025-10-03",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Reached out after a hailstorm worried me about the chimney crown. Murphy inspected it carefully, found two cracks and a cap that the wind had knocked askew. He sealed the crown, reset the cap, and waterproofed the top to handle future storms. Reasonable rates and a clear explanation of what he did and why. Photos came by text before he even left the driveway.",
          "name": "Bjorn H.",
          "date": "2025-03-07",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "We smelled a faint gas odor near the fireplace and called right away. Ned came out and ran a full leak test, cleaned the burner, and discovered a loose connection at the control valve. He repaired it, verified zero leaks, and confirmed the venting was clear before lighting it. Took the time to explain everything and never rushed. Huge peace of mind for our family.",
          "name": "Selena R.",
          "date": "2025-08-12",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "Best chimney service we've used. The technician insisted on a camera inspection before cleaning and found heavy third-degree creosote glaze plus a hairline flue crack hiding behind it. Showed me everything on the monitor. The written report was professional and detailed.",
          "name": "Ibrahim Q.",
          "date": "2024-05-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After noticing damp patches on the chimney breast wall inside, I had Otis come take a look. He identified the cracked crown and a corroded cap as the entry points for water. He repaired the crown, replaced the cap with stainless steel, and applied a quality waterproofing treatment to the brick. The damp patches have completely dried out. Worth every penny and the technician was a genuinely nice guy.",
          "name": "Lucia M.",
          "date": "2024-06-12",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Total fireplace novice here. Pete came out for a sweep and inspection and spent real time teaching me about creosote and proper firewood. He pointed out a hairline crack in the crown and explained my options without pressure. Patient guidance from start to finish.",
          "name": "Roland S.",
          "date": "2024-06-21",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Roy was fantastic. Pulled a huge nest and a pile of twigs out of our flue, swept the creosote, and installed a stainless cap with mesh sides. Walked me through the written report and the photos he took up top. No more critters and no more worry.",
          "name": "Wendy K.",
          "date": "2024-08-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Could not ask for a better experience. The flue liner in our 1940s home was badly deteriorated and unsafe for the gas furnace. Silas sized a new aluminum liner correctly, dropped it in, sealed the top plate, and made sure the appliance connection was solid. He took the time to show me the damaged sections on camera first so I understood the why. Drop cloths everywhere, immaculate cleanup, and a written report with photos. Pricing was fair and transparent.",
          "name": "Renata B.",
          "date": "2025-12-03",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Thorough and honest. Tate cleaned our gas fireplace, dusted the logs, cleared the burner, and confirmed the pilot was working safely. Warm and ready for the cold months ahead.",
          "name": "Donovan E.",
          "date": "2024-09-30",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "What a difference. The team arrived for our chimney cleaning and I asked them to look at the dryer vent since our towels never came out dry. Vern disconnected the unit, ran a rotary brush through the whole run to the exterior hood, and pulled out years of compacted lint. He laid drop cloths across the laundry room floor and left it spotless. Tested everything before packing up. Genuinely the best service call we've had in years.",
          "name": "Henrietta B.",
          "date": "2026-02-04",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Friendly tech, clean work. Cleared the creosote from our insert flue and confirmed the stainless liner had no cracks. In and out without any fuss.",
          "name": "Larissa M.",
          "date": "2024-07-30",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Firebox came out looking sharp. Wade scrubbed off the soot, cleaned the glass doors, and checked the damper seal. Tidy work, fair price.",
          "name": "Malik T.",
          "date": "2024-02-09",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "Annual sweep handled by Wyatt, who's been out a few times now. He cleared the creosote, vacuumed the smoke shelf, and pointed out the flue liner was holding up nicely. Drop cloths down the whole time. Appreciate the consistency.",
          "name": "Roosevelt N.",
          "date": "2023-10-13",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "With the holidays days away and a freeze rolling in, I needed someone immediately. Cole showed up the same afternoon I called. He found heavy buildup and a cracked crown, swept the chimney spotless, and patched the crown from his fully stocked truck. Wore shoe covers, used a tarp, and handed me a written report before he left. This is how every service company should operate.",
          "name": "Bianca K.",
          "date": "2024-11-30",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Phoned 866-907-7220 after realizing it had been five years since our last cleaning. The scheduler was pleasant and got me in quickly. Dale did the sweep and was thorough, clearing heavy creosote and checking the flue liner with a camera, which thankfully looked sound. He noticed the damper plate was warped and not closing fully, costing us heat all winter, and adjusted it on the spot. Everything explained plainly, no jargon, no upsell. The written report with photos arrived the same evening. Clean, professional, and clearly experienced. After putting it off for so long I feel silly for waiting. This crew made the whole thing easy and stress-free.",
          "name": "Ignatius R.",
          "date": "2024-06-19",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Came home to find our damper jammed wide open after a storm. The office squeezed us in next day. Aiden found a bent hinge pin and a torn gasket, replaced both, and made sure the plate latched tight against the frame. No more rain or cold air coming down. Professional and reasonably priced.",
          "name": "Camille R.",
          "date": "2026-02-19",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Outstanding work on a stubborn chimney leak. Years of water through a rusted cap and cracked crown had eaten into the mortar joints. Beau repointed the worst joints, rebuilt the crown with a proper drip edge, installed a heavy-gauge stainless cap, and waterproofed the entire stack with a breathable sealer. Detailed inspection, clear photos, and a written report. The most thorough chimney company I've dealt with.",
          "name": "Vivienne S.",
          "date": "2025-05-23",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our damper had rusted open and we were losing heat constantly. Caleb came out, explained that a top-sealing damper would seal far better than the old throat type, and installed one with a rubber gasket at the crown. The lever inside is smooth and the flue is now airtight when closed. He showed me before and after photos and left everything spotless.",
          "name": "Delphine R.",
          "date": "2026-05-21",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Older chimney with open mortar joints letting water in. Dewey ground them out and repointed with a matched mix, then replaced three spalled bricks. The new tooling looks original and the crew cleaned up well.",
          "name": "Augustin Y.",
          "date": "2024-04-08",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Big storm rolled through and I scheduled a follow-up inspection just to be safe. The tech found the flashing had pulled away on the north side and the crown had a fresh crack. Both got sealed that day. Glad I called before the next downpour.",
          "name": "Cassandra T.",
          "date": "2024-10-25",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Same-day firebox cleaning that exceeded expectations. Earl scraped the creosote, cleaned the brick, and got the damper moving freely. Looks brand new.",
          "name": "Rashida P.",
          "date": "2024-11-27",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "Was worried about my new light wood floors but the crew laid runners all the way to the fireplace and wore booties. They sealed the firebox opening with plastic and a vacuum line, so when they brushed the creosote loose none of it reached the room. Wiped everything down at the end. Floors stayed perfect.",
          "name": "Justine F.",
          "date": "2024-10-11",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Wary after being quoted a rebuild, I had these folks verify. Floyd inspected everything, found the structure sound, and traced my draft trouble to a cracked crown. Sealed it and swept the flue same day. Honest work.",
          "name": "Greta M.",
          "date": "2025-06-04",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Big thanks to Gus, who arrived same-day to sweep a chimney we'd neglected far too long. He pulled out heavy creosote, scrubbed the smoke shelf, and reset the damper, all while keeping the room cleaner than I expected. He showed me before and after photos and never made me feel judged. Skilled hands and a courteous manner, exactly what you hope for.",
          "name": "Sebastián R.",
          "date": "2024-03-21",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Hank came out for our annual gas log safety check and was incredibly thorough. He disassembled and cleaned the burner, cleared debris from the ports, tested the gas connections for leaks, verified the thermopile voltage, and measured CO output while it ran. Reset the logs to factory position to keep the flames clean. He handed me a written report listing every test and the result. Worth every penny for the peace of mind.",
          "name": "Jamal R.",
          "date": "2025-02-26",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "Put off this cleaning for far too long out of fear it would be a hassle. It wasn't. Ira arrived promptly, laid drop cloths, and removed years of caked creosote and debris from the flue. He even cleared a small obstruction near the cap. Spotless when he finished, and the report was clear about everything he did.",
          "name": "Beatrice Y.",
          "date": "2025-01-28",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Outstanding job on our insert. Jed swept the liner, vacuumed out the creosote, and scoped the full length with a camera to rule out any breaches. He explained everything in plain language and never once tried to sell me something I didn't need. The written report was thorough and the firebox looked brand new when he finished. Trustworthy and skilled.",
          "name": "Naomi T.",
          "date": "2025-07-13",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Birds nested in our flue every spring until we finally called. Knox removed the existing nest, swept the chimney thoroughly, and installed a stainless cap that should end the cycle. He explained why the previous owner's mesh kept failing. Friendly and very tidy work, all drop cloths and shoe covers.",
          "name": "Brenna I.",
          "date": "2025-11-18",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Our lender wanted documentation on the chimney before closing. Levi came out, inspected the masonry and flashing, ran the flue camera, and produced a written report within twenty-four hours. He even called to walk me through the findings. The crown needed minor waterproofing, which they handled the following week. Smooth, professional, and easy to work with.",
          "name": "Esteban R.",
          "date": "2025-03-08",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "A surprise ice storm knocked out power and our fireplace was the only heat, but the flue was filthy and dangerous to use. I called in a near panic and they treated it as an emergency. Murphy got out within a couple hours, swept out years of creosote, confirmed the liner was intact, and checked the cap for ice blockage. We stayed warm until the lights came back. Cannot thank this crew enough for moving so fast in awful weather.",
          "name": "Octavia M.",
          "date": "2026-02-19",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "After years of giving up on our fireplace because of the smoke, we finally called. Ned did a detailed inspection, found a partially collapsed clay tile in the flue creating turbulence and poor draft, plus a thick creosote layer. He cleaned what he could reach, photographed the damaged tile, and laid out a relining plan honestly without pressure. We can actually enjoy fires again. Truly grateful for the careful diagnosis instead of a quick guess.",
          "name": "Bianca M.",
          "date": "2025-03-12",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Had water leaking down the flue and the liner was corroded. Otis assessed it, recommended a reline plus waterproofing, and got both done. New stainless liner, fresh crown, and a cap to keep the rain out. Honest pricing and solid craftsmanship.",
          "name": "Leopold K.",
          "date": "2023-10-13",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Every winter for the past seven years these folks have cleaned our chimney, and the routine never gets old. This time the tech found heavier creosote than usual and explained it was likely the wood we'd been burning. He cleared it thoroughly, checked the smoke shelf, and left a written report noting everything. Loyal because they earn it season after season.",
          "name": "Esperanza V.",
          "date": "2025-02-11",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Pre-purchase evaluation on a house with two fireplaces. Pete inspected each flue with a camera, documented creosote levels and a cracked crown on the larger chimney, and laid drop cloths so nothing got dirty. The written report was clear and well organized. We knew exactly what we were buying into before we signed.",
          "name": "Esperanza M.",
          "date": "2024-03-26",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "We bought our first house in the fall and the fireplace terrified me. Roy was endlessly patient, sweeping the flue and then sitting with me to explain creosote buildup, the crown, and how to safely store firewood away from the house. He drew the damper positions on the report so I'd remember. Truly never made me feel like my beginner questions were silly. Lovely, decades-of-experience kind of service.",
          "name": "Renata Q.",
          "date": "2026-01-09",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Such a comfort to have careful, honest people in the house. The technician laid drop cloths over my good rug, swept the chimney, and showed me before and after photos of all the creosote. He spoke slowly and clearly for my benefit and never tried to sell me anything I didn't need. At 80, that kind of patience means the world.",
          "name": "Geraldine X.",
          "date": "2025-04-18",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Smoke smell in the den finally explained. Silas found a gap in the flashing letting water seep into the chimney and dampen the creosote. Repaired the flashing and swept the flue same day. No more odor.",
          "name": "Selina B.",
          "date": "2024-10-05",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Very pleased. Tate arrived on time, put on shoe covers, and spread drop cloths before cleaning out our fireplace. He brushed away the creosote, vacuumed the ash, and cleaned the glass doors until they were clear. Pointed out our damper was a touch loose and tightened it on the spot. The room is finally warm and welcoming again for winter.",
          "name": "Clementine R.",
          "date": "2025-09-21",
          "service": "Fireplaces Service",
          "rating": 4.3
        },
        {
          "review": "This father-and-sons crew cleaned a chimney we'd ignored for over fifteen years. The buildup was extreme. They worked as a team, one up top and one at the firebox, and pulled out an astonishing volume of creosote. Checked the damper and crown too. The fireplace draws like a dream now and the lingering smoke smell is finally gone.",
          "name": "Delphine K.",
          "date": "2024-12-21",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Wonderful experience with the air duct cleaning add-on. Vern took his time, sealed each register, ran the vacuum system through every line, and gave me a clear written report at the end. He even reattached a supply duct that had come loose in the crawlspace. The musty smell from the basement vents is completely gone and the whole house just feels healthier to breathe in.",
          "name": "Esperanza J.",
          "date": "2025-09-02",
          "service": "Air Duct Service",
          "rating": 4.3
        },
        {
          "review": "Had no idea how much lint was hiding in the run. Wade disconnected the duct, ran the brush kit the full distance to the exterior hood, and showed me the pile he removed. Dryer cycle time cut nearly in half. Tidy, fast, and friendly.",
          "name": "Annika P.",
          "date": "2024-05-19",
          "service": "Dryer Service",
          "rating": 4.3
        },
        {
          "review": "Wyatt cleaned a creosote-caked flue and left the hearth cleaner than he found it. Quick same-day visit, polite, and the price was more than fair.",
          "name": "Damon R.",
          "date": "2024-03-14",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Off-season cleaning to get ahead of next winter. Tech cleared the creosote and checked the flue. Simple, clean, done. Fair price, friendly crew, and a job done right the first time — no complaints at all.",
          "name": "Cornelius B.",
          "date": "2024-06-18",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "On my neighbor's advice I scheduled a sweep before winter. Cole was right on time, laid drop cloths, and cleared the flue of creosote. He showed me photos of the crown and flagged a bit of spalling brick to keep an eye on. Solid, honest work.",
          "name": "Ferdinand X.",
          "date": "2025-04-18",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Fast and dependable. Dale swept out the creosote and resealed the crown in one visit. Shoe covers on, drop cloths down, gone by noon. Great value.",
          "name": "Antonio L.",
          "date": "2026-03-21",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Booked an inspection because our fires never burned well. The level-2 camera revealed the flue was undersized and partly obstructed by a sagging old liner, something no visual check would catch. Aiden explained the physics of it on the spot, showed me the footage, and laid out options without rushing. Honest and clearly experienced.",
          "name": "Oscar V.",
          "date": "2024-08-27",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "Pricing was upfront and reasonable from the start. The tech gave a free estimate, came back to do the sweep, and laid drop cloths over my new carpet without being asked. Creosote was moderate, he said, and no extra treatment was pushed. Bill matched the quote. Couldn't ask for more.",
          "name": "Hassan K.",
          "date": "2024-10-05",
          "service": "Chimney Service",
          "rating": 4.3
        },
        {
          "review": "The honesty here is what keeps me coming back. Beau did our sweep this year and, just like last year, he gave me a straight answer about everything. He noted the crown had a hairline crack but said it could wait another season and wasn't worth rushing. Personable, never condescending, and clearly proud of the family name on the truck.",
          "name": "Geraldine M.",
          "date": "2026-05-08",
          "service": "Chimney Service",
          "rating": 4.1
        },
        {
          "review": "Old brick chimney, loose mortar, a few spalled faces. Caleb repointed and replaced them. Done same day. No complaints. Showed up on time, cleaned up after themselves, and the price was exactly what they quoted.",
          "name": "Sven L.",
          "date": "2023-07-08",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "A family-run business that actually shows up when they say they will. Storm follow-up: Dewey checked the crown, cap, and flashing, found the flashing had lifted in the wind, and resealed it. Fast and friendly.",
          "name": "Carmen R.",
          "date": "2024-06-04",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Pilot kept clicking but not igniting. The tech cleaned the pilot orifice, replaced the igniter, and tested the gas logs thoroughly. Lights on the first try every time now. Quick same-day fix.",
          "name": "Donovan K.",
          "date": "2024-12-11",
          "service": "Fireplaces Service",
          "rating": 4.1
        },
        {
          "review": "A musty smell after every rain led us to book an inspection. Earl's camera revealed water had been seeping through a cracked liner section, and the crown above was failing. He connected the dots between the two issues and laid out a fix for both. Honest family business that took the time to show me the actual footage rather than just telling me to trust them.",
          "name": "Megan S.",
          "date": "2025-09-04",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Cap had rusted and water was reaching the damper, leaving it stiff and stained. Floyd replaced the cap, freed up the damper, sealed the crown cracks, and waterproofed the stack. Thorough and reasonably priced.",
          "name": "Warren B.",
          "date": "2025-07-25",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "First home, first fireplace, and a long list of nervous questions. Gus answered each one while sweeping the flue and showing me the camera footage of the liner. He explained how to tell seasoned wood from green, how the damper controls the burn, and why an annual cleaning keeps creosote in check. He left a tidy written report and his cell number in case I had follow-up questions. Genuinely kind teaching for a beginner.",
          "name": "Vanessa P.",
          "date": "2026-05-10",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Animal had nested deep in the flue and the debris was extensive. Hank cleared every bit, swept the chimney clean, and topped it with a sturdy stainless cap. Quick, courteous, and the price was fair for the amount of work.",
          "name": "Omar B.",
          "date": "2025-03-30",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Relined the chimney for our wood insert. Ira insulated the stainless liner and connected it tight to the insert flue collar. Drafts perfectly now. No complaints at all.",
          "name": "Quentin M.",
          "date": "2024-03-19",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Years of buildup left our firebox black with creosote and the glass impossible to see through. Jed put in real effort, scrubbing the brick, vacuuming the ash dump, and cleaning the doors until they sparkled. He explained what to watch for and how often to schedule a cleaning. The living room finally feels cozy and inviting again, just in time for the first cold front of the season.",
          "name": "Lorraine K.",
          "date": "2026-04-11",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "Knox added the dryer vent cleaning to our chimney appointment without any hassle. The exterior flap was clogged and the line was full of lint. Cleared it all and airflow is strong again.",
          "name": "Desmond R.",
          "date": "2024-05-09",
          "service": "Dryer Service",
          "rating": 4.2
        },
        {
          "review": "Levi serviced our wood stove and went above and beyond. He swept the connector and liner, vacuumed the firebox, and noticed the liner cap had come loose in a windstorm. Refastened it and sealed the top plate. The camera inspection gave us confidence the liner itself was sound. Tidy, knowledgeable, and patient with all my questions about creosote stages.",
          "name": "Felix W.",
          "date": "2025-04-13",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We were ready to write off our fireplace until Murphy showed up. The firebox was solid black with creosote and the firebrick was flaking. He scrubbed each brick clean, replaced two that were beyond saving, re-mortared the joints, and cleared the smoke shelf. Covered the floors with drop cloths and used a quiet vacuum so there was no dust anywhere. The makeover is incredible and the before/after photos prove it. Couldn't be happier.",
          "name": "Genevieve W.",
          "date": "2025-07-21",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Faithful customer for over a decade. Ned did the yearly cleaning, brushing a thick layer of creosote out of the flue and vacuuming the firebox until it sparkled. He even photographed the smoke chamber so I could see how clean it was. The scheduler is always easy to deal with, and the crew never leaves a mess. Worth every penny for the peace of mind heading into winter.",
          "name": "Lucinda T.",
          "date": "2026-04-27",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Cold front coming and our wood-burning fireplace hadn't been cleaned in ages. Same-day appointment with Otis, who removed a startling amount of creosote and confirmed the flue liner was intact. Felt safe lighting a fire that night.",
          "name": "George L.",
          "date": "2025-02-22",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "We bought an old farmhouse with two chimneys and needed both inspected. The tech worked methodically through each one, running cameras up both flues and documenting everything. One had significant creosote and a cracked tile, the other was surprisingly clean but had a failing crown. He swept both, gave honest priorities on the repairs, and put together a detailed written report with photos for each chimney separately. Took his time, answered every question, and never made me feel rushed despite the bigger job. The drop cloths and cleanup were impeccable. For a property with this much chimney work, having someone this thorough and honest was exactly what we needed.",
          "name": "Cordelia M.",
          "date": "2025-09-04",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Pleased with the whole experience. Our cast iron damper had seized from corrosion and wouldn't close to seal the flue. Pete removed the old assembly, fit a new stainless damper with a fresh gasket, and tested the draw before and after. He laid drop cloths across the carpet and wore shoe covers the entire time. Drafts eliminated and the firebox stays clean. Great value for skilled work.",
          "name": "Tobias K.",
          "date": "2025-04-30",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Missing cap and a crown that had cracked were the culprits behind our leak. Roy installed a stainless cap and sealed the crown. Quick turnaround and the rain stays out now.",
          "name": "Ignatius P.",
          "date": "2023-07-19",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Damper plate was bent and wouldn't seal, so the upstairs room stayed cold. Silas replaced it with a properly fitted unit and a fresh gasket strip. Quick visit, fair price, and he confirmed the seal before leaving.",
          "name": "Hassan B.",
          "date": "2024-11-19",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Spalling and failing mortar on a beautiful old brick chimney we didn't want to lose. Tate reassured us a full rebuild wasn't needed. His team replaced the worst brick, tuckpointed the deteriorated joints, repaired the crown, and waterproofed it. The mortar color match is remarkable and the joints look like they belong. Office kept us updated on scheduling and the masons were courteous throughout. Very pleased with the result.",
          "name": "Delphine X.",
          "date": "2026-01-12",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "After the spring storms, water was seeping in around the chimney. Vern inspected top to bottom, found failed flashing and a worn crown, resealed and waterproofed everything, and added a new cap. Clean work, drop cloths down, thorough written report. Very pleased.",
          "name": "Vivian R.",
          "date": "2025-03-30",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Outstanding work on a very dirty fireplace. The firebox was packed with old ash and the brick was black with soot. Wade cleaned every surface, polished the glass doors, and walked me through a written report. The whole makeover took a few hours and the result looks like a completely new fireplace. Very pleased.",
          "name": "Emerson T.",
          "date": "2025-04-26",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Wyatt showed up prepared. Booties, drop cloths, and a sealed cover over the opening before he ran the brush down the flue. The vacuum captured all the soot and creosote dust. He bagged it, vacuumed the hearth, and left without a trace. Cleanest sweep I've ever had done.",
          "name": "Aurora L.",
          "date": "2025-11-19",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Decades of experience clearly separate the honest from the hucksters. Another firm quoted me $10k to rebuild a chimney they claimed was dangerous. Cole ran a meticulous camera inspection of the flue liner, showed me the masonry was perfectly intact, and pointed out the actual problem was a missing cap and heavy soot. He capped and swept it for a fraction of the rebuild cost, with a written report. Skeptic fully converted.",
          "name": "Vincent A.",
          "date": "2026-01-19",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Caught a great experience with the tech named Dale again this year. Swept the flue, checked the stainless cap, and gave me a written report. Reliable.",
          "name": "Gwendolyn I.",
          "date": "2026-01-29",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Friendly tech cleaned the burner, tested for gas leaks, and confirmed the damper clamp was installed for safe venting. Logs look clean and the pilot lights right up now.",
          "name": "Estelle B.",
          "date": "2024-07-23",
          "service": "Fireplaces Service",
          "rating": 4.2
        },
        {
          "review": "Old farmhouse chimney, never cleaned in our memory. Aiden dug out an unbelievable amount of creosote and soot. Friendly and fast.",
          "name": "Dominic X.",
          "date": "2026-01-22",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Efficient liner inspection and sweep on our wood-burning stove. Beau cleared the creosote, tested the damper, and confirmed the cap was secure. No fuss, fair price, clean work.",
          "name": "Bradley K.",
          "date": "2024-09-21",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Discovered a nest blocking the flue when smoke poured back into the room. Caleb cleared it, brushed the liner clean, and capped the top with stainless. Fast same-day fix and a fair price.",
          "name": "Hugo M.",
          "date": "2026-05-22",
          "service": "Chimney Service",
          "rating": 4.2
        },
        {
          "review": "Smith and Sons did a phenomenal job on our chimney. The technician arrived on time, laid down drop cloths to protect our floors, and walked us through every step. The before-and-after photos were eye-opening. Highly recommend!",
          "name": "Sarah M.",
          "date": "2024-01-15",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked an inspection after we noticed smoke backing up into the room. The tech from Smith and Sons identified a blocked flue and a damaged cap, gave us a fair quote, and had it fixed the next day. Fireplace works perfectly now.",
          "name": "Michael R.",
          "date": "2024-02-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Excellent experience from start to finish. The scheduler was friendly, the technician was thorough, and the price matched the estimate exactly. No upsells, no surprises. This is how service should be done.",
          "name": "Jennifer K.",
          "date": "2024-02-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Had Smith and Sons out for an annual chimney cleaning. Quick, clean, and respectful of our home. They even noticed a small crack in the crown and offered a sensible repair option without pressure.",
          "name": "David T.",
          "date": "2024-03-04",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We had a dryer vent fire scare last winter and called Smith and Sons for a deep cleaning. They removed an alarming amount of lint and showed us exactly where the buildup was. Peace of mind restored.",
          "name": "Emily H.",
          "date": "2024-03-19",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "The team replaced our chimney cap and crown after storm damage. Communication was clear, the work was tidy, and they cleaned up before they left. Could not have asked for a better experience.",
          "name": "Robert N.",
          "date": "2024-04-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Jessica from Smith and Sons answered our questions over the phone before we even booked. When the tech arrived, he was just as professional. Reliable, transparent, and clearly knows chimneys inside and out.",
          "name": "Jessica P.",
          "date": "2024-04-18",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Used Smith and Sons for an air duct cleaning. The technician took photos of the ducts before and after — the difference was night and day. My allergies have noticeably improved since.",
          "name": "Daniel L.",
          "date": "2024-05-01",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "I have a tricky two-story chimney and have had bad experiences with other companies. Smith and Sons handled it with no drama, used proper roof harnesses, and finished in under two hours. Top notch.",
          "name": "Ashley W.",
          "date": "2024-05-17",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Our fireplace had not been used in years. The technician inspected it head-to-toe, identified what was safe and what needed work, and gave us an honest assessment with no scare tactics. We're using it again this winter.",
          "name": "Matthew B.",
          "date": "2024-06-03",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "Smith and Sons sent a technician within 24 hours of our call. He found a bird's nest blocking the flue, removed it carefully, and installed a new spark arrestor cap. Professional and reasonably priced.",
          "name": "Amanda S.",
          "date": "2024-06-20",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Booked online and got a confirmation right away. The tech showed up in a marked truck, in uniform, and clearly knew his stuff. He even gave me tips for safer fires this season. Five stars all around.",
          "name": "Christopher Y.",
          "date": "2024-07-08",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Had a dryer vent cleaning that the previous company clearly skipped. Smith and Sons cleaned it properly, sealed loose joints, and rerouted a kinked hose. Dryer cycles are now half as long.",
          "name": "Lauren D.",
          "date": "2024-07-25",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "We had a chimney leak during heavy rain. Smith and Sons identified that the crown had failed, replaced it, and waterproofed the entire structure. No leaks since, even through the wet season.",
          "name": "Joshua F.",
          "date": "2024-08-11",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "The technician was punctual, polite, and remarkably patient with all our questions. He never made us feel rushed and gave us realistic options at different price points. Old-school service.",
          "name": "Stephanie O.",
          "date": "2024-08-29",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Smith and Sons inspected our chimney before we moved into the home. The report was detailed and saved us from a major safety issue the previous owners had ignored. Worth every penny.",
          "name": "Andrew Q.",
          "date": "2024-09-12",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Air ducts had never been cleaned in our 30-year-old house. The Smith and Sons team came prepared with industrial equipment and worked through the entire system. The dust difference is unbelievable.",
          "name": "Nicole G.",
          "date": "2024-09-28",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Quick scheduling, fair pricing, and the work spoke for itself. Smith and Sons swept and inspected our chimney in under an hour. Very satisfied — will book again next year.",
          "name": "Brandon E.",
          "date": "2024-10-14",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We had glass doors installed on our fireplace by Smith and Sons. The fit is perfect, the seal is tight, and they look fantastic. The installer was a true craftsman.",
          "name": "Megan I.",
          "date": "2024-10-30",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "I have used Smith and Sons for three years running for our annual maintenance. Consistent quality every time. They remember our home, our preferences, and treat us like family.",
          "name": "Tyler U.",
          "date": "2024-11-09",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "After a bird flew down our chimney, Smith and Sons came out the same afternoon, safely removed it, and installed a proper cap. Fast, humane, and reasonably priced. Lifesaver.",
          "name": "Rachel C.",
          "date": "2024-11-24",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Got a full chimney rebuild after our old one was deteriorating. Smith and Sons handled the demo, the masonry, and the cleanup over four days. The new chimney looks like it belongs there. Beautiful work.",
          "name": "Ryan V.",
          "date": "2024-12-07",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Samantha in their office was wonderful to deal with — patient, kind, and accommodating with scheduling around our work week. The technician was equally pleasant. Great company culture shows.",
          "name": "Samantha J.",
          "date": "2024-12-19",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Smith and Sons cleaned our dryer vent and replaced an outdated outdoor flap. The dryer no longer overheats and laundry takes one cycle instead of two. Should have called them years ago.",
          "name": "Kevin A.",
          "date": "2025-01-08",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Honest, skilled, and friendly. The technician noticed our damper wasn't fully closing and fixed it on the spot at no extra charge. That kind of integrity is rare. Customer for life.",
          "name": "Heather X.",
          "date": "2025-01-22",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Had Smith and Sons out for an emergency inspection after we heard noises in the chimney. Turned out to be a loose brick. The tech secured it, cleaned the soot buildup, and gave us a clean bill of health.",
          "name": "Justin Z.",
          "date": "2025-02-06",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Air duct service was top-notch. Smith and Sons protected our furniture with covers, used HEPA filtration on their vacuum, and left no mess behind. Worth booking every couple of years.",
          "name": "Brittany M.",
          "date": "2025-02-20",
          "service": "Air Duct Service",
          "rating": 5
        },
        {
          "review": "Booked a chimney sweep right before the holidays. Smith and Sons squeezed us in, did a thorough job, and even helped us light the first fire. Made our family Christmas perfect.",
          "name": "Jason H.",
          "date": "2025-03-05",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Reasonable price, no hidden fees, no high-pressure sales. The technician explained which repairs were urgent and which could wait. That kind of transparency builds trust.",
          "name": "Melissa P.",
          "date": "2025-03-21",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "We had Smith and Sons reline our chimney after the original liner cracked. The work was permitted, inspected, and warrantied. Felt like dealing with real professionals throughout.",
          "name": "Eric D.",
          "date": "2025-04-04",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Smith and Sons came recommended by a neighbor and now I see why. The fireplace had stopped drawing properly — turns out the chimney needed cleaning and the cap was clogged. Fixed in one visit.",
          "name": "Kimberly L.",
          "date": "2025-04-19",
          "service": "Fireplaces Service",
          "rating": 5
        },
        {
          "review": "The tech walked us through the inspection report with photos and a clear list of recommendations. No fluff, no upsells. We chose to do everything and the work was finished in one day.",
          "name": "Brian W.",
          "date": "2025-05-02",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Smith and Sons did a fantastic dryer vent cleaning. Removed clogged lint that was a real fire hazard. The technician was professional, courteous, and clearly experienced. Highly recommend!",
          "name": "Lisa F.",
          "date": "2025-05-16",
          "service": "Dryer Service",
          "rating": 5
        },
        {
          "review": "Patrick was our technician and he was outstanding. Took the time to explain everything, answered every question, and left the work area cleaner than he found it. A true professional.",
          "name": "Patrick T.",
          "date": "2025-06-01",
          "service": "Chimney Service",
          "rating": 5
        },
        {
          "review": "Smith and Sons handled a tricky chimney rebuild on our 1920s home. They respected the original masonry style and the result is stunning. Other companies wouldn't even quote the job.",
          "name": "Amy N.",
          "date": "2025-06-18",
          "service": "Chimney Service",
          "rating": 5
        },
      ],
    },
];

export default Companies;
